// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"5DEId":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _app = require("./App");
let container = document.getElementById("app");
let root = (0, _client.createRoot)(container);
root.render(// <StrictMode>
/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _app.App), {}));

},{"react/jsx-runtime":"gonF6","react-dom/client":"5eZdG","./App":"ceurZ"}],"gonF6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"euPNa"}],"euPNa":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"5eZdG":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9e932721f217f9f6");

},{"9e932721f217f9f6":"atjdB"}],"atjdB":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var Scheduler = require("934b50a50c275743"), React = require("56d30b16d84cc622"), ReactDOM = require("d42dbe4aacaa6df4");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
}
function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate) throw Error(formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return assertIsMounted(parentA), fiber;
                if (parentB === b) return assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error(formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error(formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_FRAGMENT_TYPE:
            return "Fragment";
        case REACT_PROFILER_TYPE:
            return "Profiler";
        case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_PORTAL_TYPE:
            return "Portal";
        case REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, valueStack = [], index = -1;
function createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function pop(cursor) {
    0 > index || (cursor.current = valueStack[index], valueStack[index] = null, index--);
}
function push(cursor, value) {
    index++;
    valueStack[index] = cursor.current;
    cursor.current = value;
}
var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    pop(contextStackCursor);
    push(contextStackCursor, fiber);
}
function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
}
function pushHostContext(fiber) {
    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
}
function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
}
var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
    } catch (err) {}
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
}
var nextTransitionLane = 256, nextRetryLane = 4194304;
function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function claimNextTransitionLane() {
    var lane = nextTransitionLane;
    nextTransitionLane <<= 1;
    0 === (nextTransitionLane & 4194048) && (nextTransitionLane = 256);
    return lane;
}
function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
}
function createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
}
function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        return ReactDOMSharedInternals.p = priority, fn();
    } finally{
        ReactDOMSharedInternals.p = previousPriority;
    }
}
var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
}
function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                targetNode = getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
}
function getResourcesFromRoot(root) {
    var resources = root[internalRootNodeResourcesKey];
    resources || (resources = root[internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = !0;
}
var allNativeEvents = new Set(), registrationNameDependencies = {};
function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
}
var VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
    illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function setValueForAttribute(node, name, value) {
    if (isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var prefix, suffix;
function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + prefix + name + suffix;
}
var reentry = !1;
function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return describeBuiltInComponentFrame(fiber.type);
        case 16:
            return describeBuiltInComponentFrame("Lazy");
        case 13:
            return describeBuiltInComponentFrame("Suspense");
        case 19:
            return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function trackValueOnNode(node) {
    var valueField = isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function track(node) {
    node._valueTracker || (node._valueTracker = trackValueOnNode(node));
}
function updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
        } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
}
function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
}
function initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error(formatProdErrorMessage(92));
            if (isArrayImpl(children)) {
                if (1 < children.length) throw Error(formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error(formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var currentReplayingEvent = null;
function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var restoreTarget = null, restoreQueue = null;
function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[internalPropsKey] || null;
                            if (!otherProps) throw Error(formatProdErrorMessage(90));
                            updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var isInsideEventHandler = !1;
function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
            if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
        }
    }
}
function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error(formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
if (canUseDOM) try {
    var options = {};
    Object.defineProperty(options, "passive", {
        get: function() {
            passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
} catch (e) {
    passiveBrowserEventsSupported = !1;
}
var root = null, startText = null, fallbackText = null;
function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function functionThatReturnsTrue() {
    return !0;
}
function functionThatReturnsFalse() {
    return !1;
}
function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
    view: 0,
    detail: 0
}), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
    }
}), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
    dataTransfer: 0
}), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
    relatedTarget: 0
}), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
    data: 0
}), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function getEventModifierState() {
    return modifierStateGetter;
}
var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
}), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0
}), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
    9,
    13,
    27,
    32
], canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = !1;
function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var isComposing = !1;
function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            hasSpaceKeypress = !0;
            return SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
        target
    ] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var activeElement$1 = null, activeElementInst$1 = null;
function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
}
function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
}
function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var isInputEventSupported = !1;
if (canUseDOM) {
    var JSCompiler_inline_result$jscomp$282;
    if (canUseDOM) {
        var isSupported$jscomp$inline_417 = "oninput" in document;
        if (!isSupported$jscomp$inline_417) {
            var element$jscomp$inline_418 = document.createElement("div");
            element$jscomp$inline_418.setAttribute("oninput", "return;");
            isSupported$jscomp$inline_417 = "function" === typeof element$jscomp$inline_418.oninput;
        }
        JSCompiler_inline_result$jscomp$282 = isSupported$jscomp$inline_417;
    } else JSCompiler_inline_result$jscomp$282 = !1;
    isInputEventSupported = JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
}
function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
}
function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
}
function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
}
function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
}
function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
}
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is;
function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function getNodeForCharacterOffset(root, offset) {
    var node = getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = getLeafNode(node);
    }
}
function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = getActiveElement(containerInfo.document);
    }
    return element;
}
function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1;
function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = activeElement)));
}
function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
}, prefixedEventNames = {}, style = {};
canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
simpleEventPluginEvents.push("scrollEnd");
function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var CapturedStacks = new WeakMap();
function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: getStackByFiberInDevAndProd(source)
    };
}
var concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
function finishQueueingConcurrentUpdates() {
    for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var queue = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var update = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var lane = concurrentQueues[i];
        concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
}
function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var emptyContextObject = {};
function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
}
function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case REACT_ACTIVITY_TYPE:
            return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case REACT_PROFILER_TYPE:
            return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
            return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
            return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case REACT_PROVIDER_TYPE:
                case REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function createFiberFromText(content, mode, lanes) {
    content = createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
function pushTreeFork(workInProgress, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress;
    treeForkCount = totalChildren;
}
function pushTreeId(workInProgress, totalChildren, index) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress;
    } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
}
function pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
}
function popTreeContext(workInProgress) {
    for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
}
var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519));
function throwOnHydrationMismatch(fiber) {
    var error = Error(formatProdErrorMessage(418, ""));
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
}
function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch(type){
        case "dialog":
            listenToNonDelegatedEvent("cancel", instance);
            listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], instance);
            break;
        case "source":
            listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            listenToNonDelegatedEvent("error", instance);
            listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            listenToNonDelegatedEvent("invalid", instance);
            initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            track(instance);
            break;
        case "select":
            listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children), track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$1), instance = !0) : instance = !1;
    instance || throwOnHydrationMismatch(fiber);
}
function popToNextHostParent(fiber) {
    for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
        case 5:
        case 13:
            rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            rootOrSingletonContext = !0;
            return;
        default:
            hydrationParentFiber = hydrationParentFiber.return;
    }
}
function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return !1;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            nextHydratableInstance = getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = !1;
}
function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
    return queuedErrors;
}
function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [
        error
    ] : hydrationErrors.push(error);
}
var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
function pushProvider(providerFiber, context, nextValue) {
    push(valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
}
function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error(formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function prepareToReadContext(workInProgress) {
    currentlyRenderingFiber$1 = workInProgress;
    lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
}
function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
}
function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === lastContextDependency) {
        if (null === consumer) throw Error(formatProdErrorMessage(308));
        lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
}
var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function createCache() {
    return {
        controller: new AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
    });
}
var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
}
function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var prevOnStartTransitionFinish = ReactSharedInternals.S;
ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
};
var resumedCache = createCursor(null);
function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
}
function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
}
function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = {
    then: function() {}
};
function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function noop$3() {}
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$3, noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then(noop$3, noop$3);
            else {
                thenableState = workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error(formatProdErrorMessage(483));
}
var hasForceUpdate = !1;
function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = getRootForUpdatedFiber(fiber);
        markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root, lane);
    }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var didReadFromEntangledAsyncAction = !1;
function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = assign({}, newState, updateLane);
                            break a;
                        case 2:
                            hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
    callback.call(context);
}
function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
}
var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
}
function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
}
function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
}
var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter$1 = 0, thenableState$1 = null, globalClientIdCounter = 0;
function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
}
function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
    finishRenderingHooks(current);
    return nextRenderLanes;
}
function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = !1;
    thenableIndexCounter$1 = 0;
    thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
}
function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState$1 = null);
        thenableIndexCounter$1 = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
        numberOfReRenders += 1;
        workInProgressHook = currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        ReactSharedInternals.H = HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
}
function bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function resetHooksOnUnwind(workInProgress) {
    if (didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        didScheduleRenderPhaseUpdate = !1;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = !1;
    thenableIndexCounter$1 = localIdCounter = 0;
    thenableState$1 = null;
}
function mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
}
function updateWorkInProgressHook() {
    if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === currentlyRenderingFiber.alternate) throw Error(formatProdErrorMessage(467));
            throw Error(formatProdErrorMessage(310));
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
}
function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function useThenable(thenable) {
    var index = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    thenable = trackUsedThenable(thenableState$1, thenable, index);
    index = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
}
function use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
}
function useMemoCache(size) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
}
function updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if ((renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
    hook = hook.queue;
    var create = subscribeToStore.bind(null, fiber, hook, subscribe);
    updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        pushSimpleEffect(9, createEffectInstance(), updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== (renderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
}
function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function forceStoreRerender(fiber) {
    var root = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && scheduleUpdateOnFiber(root, fiber, 2);
}
function mountStateImpl(initialState) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
}
function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            onActionError(actionQueue, node, error);
        } finally{
            ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        onActionError(actionQueue, node, error$38);
    }
}
function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return onActionError(actionQueue, node, error);
    }) : onActionSuccess(actionQueue, node, returnValue);
}
function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
}
function onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function actionStateReducer(oldState, newState) {
    return newState;
}
function mountActionState(action, initialStateProp) {
    if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = currentlyRenderingFiber;
                if (isHydrating) {
                    if (nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                            for(var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            nextHydratableInstance = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(!1);
    inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
}
function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = useThenable(currentStateHook);
    } catch (x) {
        if (x === SuspenseException) throw SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(9, createEffectInstance(), actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function updateRef() {
    return updateWorkInProgressHook().memoizedState;
}
function mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(1 | hookFlags, createEffectInstance(), create, createDeps);
}
function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function mountEffect(create, createDeps) {
    mountEffectImpl(8390656, 8, create, createDeps);
}
function updateEffect(create, createDeps) {
    updateEffectImpl(2048, 8, create, createDeps);
}
function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
}
function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
}
function imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
}
function mountDebugValue() {}
function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
    if (0 === (renderLanes & 42)) return didReceiveUpdate = !0, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
            dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
        } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
    } catch (error) {
        dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, requestUpdateLane());
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function noop$2() {}
function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(formFiber, queue, pendingState, sharedNotPendingObject, null === action ? noop$2 : function() {
        requestFormReset$1(formFiber);
        return action(formData);
    });
}
function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: sharedNotPendingObject,
        baseState: sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function requestFormReset$1(formFiber) {
    var resetStateQueue = ensureFormComponentIsStateful(formFiber).next.queue;
    dispatchSetStateInternal(formFiber, resetStateQueue, {}, requestUpdateLane());
}
function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
}
function updateId() {
    return updateWorkInProgressHook().memoizedState;
}
function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
}
function refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = requestUpdateLane();
                fiber = createUpdate(lane);
                var root$41 = enqueueUpdate(provider, fiber, lane);
                null !== root$41 && (scheduleUpdateOnFiber(root$41, provider, lane), entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
}
function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
}
function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
}
function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root, lane);
    }
}
var ContextOnlyDispatcher = {
    readContext: readContext,
    use: use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
}, HooksDispatcherOnMount = {
    readContext: readContext,
    use: use,
    useCallback: function(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            0 !== (workInProgressRootRenderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(9, createEffectInstance(), updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var JSCompiler_inline_result = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: function() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    }
}, HooksDispatcherOnUpdate = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
        return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
}, HooksDispatcherOnRerender = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
        return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
}, thenableState = null, thenableIndexCounter = 0;
function unwrapThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    return trackUsedThenable(thenableState, thenable, index);
}
function coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
        current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case REACT_PORTAL_TYPE:
                    return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error(formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) {
                key = getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === SuspenseException || x === SuspenseActionException) throw x;
            var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
}
function pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && (shellBoundary = fiber);
        }
    } else reuseSuspenseHandlerOnStack(fiber);
}
function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
}
function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
}
var suspenseStackCursor = createCursor(0);
function findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
};
function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
}
function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function defaultOnUncaughtError(error) {
    reportGlobalError(error);
}
function defaultOnCaughtError(error) {
    console.error(error);
}
function defaultOnRecoverableError(error) {
    reportGlobalError(error);
}
function logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function createRootErrorUpdate(root, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        logUncaughtError(root, errorInfo);
    };
    return lane;
}
function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error(formatProdErrorMessage(435, sourceFiber.tag));
        }
        attachPingListener(root, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return !1;
    }
    if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error(formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
        wrapperError
    ] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1;
function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress);
    nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && key && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack(workInProgress));
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress);
    null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    finishRenderingHooks(current);
    Component = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && Component && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    resetHydrationState();
    workInProgress.flags |= 256;
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: getSuspendedCache()
    };
}
function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
}
function updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if (isHydrating) {
            showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
            if (isHydrating) {
                var nextInstance = nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== treeContextProvider ? {
                            id: treeContextId,
                            overflow: treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, hydrationParentFiber = workInProgress, nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
        pushPrimaryTreeSuspenseHandler(workInProgress);
        return mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = showFallback);
        else if (pushPrimaryTreeSuspenseHandler(workInProgress), isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error(formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
            "$?" === nextInstance.data || renderDidSuspendDelayIfPossible();
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, nextHydratableInstance = getNextHydratable(nextInstance.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && (idStack[idStackIndex++] = treeContextId, idStack[idStackIndex++] = treeContextOverflow, idStack[idStackIndex++] = treeContextProvider, treeContextId = current.id, treeContextOverflow = current.overflow, treeContextProvider = workInProgress), workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = createWorkInProgress(digest, showFallback) : (showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
    pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    push(suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? !0 : !1;
}
function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
            resetHydrationState();
            break;
        case 27:
        case 5:
            pushHostContext(workInProgress);
            break;
        case 4:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                pushPrimaryTreeSuspenseHandler(workInProgress);
                current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            push(suspenseStackCursor, suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
        else {
            if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) shouldConstruct(lazyComponent) ? (current = resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error(formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error(formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                cloneUpdateQueue(current, workInProgress);
                processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                pushProvider(workInProgress, CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0);
                suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                        queueHydrationError(init);
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        nextHydratableInstance = getNextHydratable(current.firstChild);
                        hydrationParentFiber = workInProgress;
                        isHydrating = !0;
                        hydrationErrors = null;
                        rootOrSingletonContext = !0;
                        renderLanes = mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[internalInstanceKey] = workInProgress, lazyComponent[internalPropsKey] = current, setInitialProperties(lazyComponent, renderLanes, current), markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return pushHostContext(workInProgress), null === current && isHydrating && (lazyComponent = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, init = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = init, nextHydratableInstance = getNextHydratable(lazyComponent.firstChild)) : nextHydratableInstance = init), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && isHydrating) {
                if (init = lazyComponent = nextHydratableInstance) lazyComponent = canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(lazyComponent.firstChild), rootOrSingletonContext = !1, init = !0) : init = !1;
                init || throwOnHydrationMismatch(workInProgress);
            }
            pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = init);
            markRef(current, workInProgress);
            reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && isHydrating) {
                if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                current || throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, pushProvider(workInProgress, workInProgress.type, lazyComponent.value), reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), init = readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return prepareToReadContext(workInProgress), lazyComponent = readContext(CacheContext), null === current ? (init = peekCacheFromPool(), null === init && (init = workInProgressRoot, prevState = createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, init)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), pushProvider(workInProgress, CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, pushProvider(workInProgress, CacheContext, lazyComponent), lazyComponent !== init.cache && propagateContextChanges(workInProgress, [
                CacheContext
            ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
        resource = suspenseHandlerStackCursor.current;
        if (null !== resource && ((workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null !== shellBoundary : (workInProgressRootRenderLanes & 62914560) !== workInProgressRootRenderLanes && 0 === (workInProgressRootRenderLanes & 536870912) || resource !== shellBoundary)) throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
}
function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return bubbleProperties(workInProgress), null;
        case 1:
            return bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            popProvider(CacheContext);
            popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
            bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? (markUpdate(workInProgress), null !== renderLanes ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            popHostContext(workInProgress);
            renderLanes = rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, markUpdate(workInProgress));
            }
            bubbleProperties(workInProgress);
            return null;
        case 5:
            popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[internalInstanceKey] = workInProgress;
                    current[internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch(setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && markUpdate(workInProgress);
                }
            }
            bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                current = rootInstanceStackCursor.current;
                if (popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || throwOnHydrationMismatch(workInProgress);
                } else current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error(formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error(formatProdErrorMessage(317));
                        type[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    type = !1;
                } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            bubbleProperties(workInProgress);
            return null;
        case 4:
            return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
        case 10:
            return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
        case 19:
            pop(suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            push(suspenseStackCursor, suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                    } else 2 * now() - type.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = now(), workInProgress.sibling = null, current = suspenseStackCursor.current, push(suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function unwindWork(current, workInProgress) {
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return popHostContext(workInProgress), null;
        case 13:
            popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return pop(suspenseStackCursor), null;
        case 4:
            return popHostContainer(), null;
        case 10:
            return popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return popProvider(CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            popProvider(CacheContext);
            popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            popHostContext(interruptedWork);
            break;
        case 4:
            popHostContainer();
            break;
        case 13:
            popSuspenseHandler(interruptedWork);
            break;
        case 19:
            pop(suspenseStackCursor);
            break;
        case 10:
            popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            popSuspenseHandler(interruptedWork);
            popHiddenContext();
            null !== current && pop(resumedCache);
            break;
        case 24:
            popProvider(CacheContext);
    }
}
function commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            commitCallbacks(updateQueue, instance);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        setInitialProperties(singleton, type, props);
        singleton[internalInstanceKey] = finishedWork;
        singleton[internalPropsKey] = props;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
function commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    eventsEnabled = _enabled;
    root = getActiveElementDeep(root);
    if (hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    _enabled = !1;
    for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, nextEffect = root;
    else for(; null !== nextEffect;){
        firstChild = nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error(formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            nextEffect = root;
            break;
        }
        nextEffect = firstChild.return;
    }
}
function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && commitClassCallbacks(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    commitCallbacks(finishedRoot, current);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && commitHostMount(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                prevProps = offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = flags;
                (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                offscreenSubtreeIsHidden = prevProps;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var hostParent = null, hostParentIsContainer = !1;
function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
            isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            releaseSingletonInstance(deletedFiber.stateNode);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = null;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            if (null !== hostParent) {
                if (hostParentIsContainer) try {
                    (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = deletedFiber.stateNode.containerInfo;
            hostParentIsContainer = !0;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        retryIfBlockedOn(finishedRoot);
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
            throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
}
function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if (isSingletonScope(parent.type)) {
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var currentHoistableRoot = null;
function commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = currentHoistableRoot;
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        setInitialProperties(currentResource, flags, current);
                                        currentResource[internalInstanceKey] = finishedWork;
                                        markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error(formatProdErrorMessage(468, flags));
                                }
                                currentResource[internalInstanceKey] = finishedWork;
                                markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    setTextContent(hoistableRoot, "");
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && (needsFormReset = !0);
            break;
        case 6:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            tagCaches = null;
            hoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(root.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            currentHoistableRoot = hoistableRoot;
            commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            currentHoistableRoot = flags;
            break;
        case 12:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            break;
        case 13:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            recursivelyTraverseMutationEffects(root, finishedWork);
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
    }
}
function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if (isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && (setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error(formatProdErrorMessage(161));
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
}
function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
}
function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var suspenseyCommitFlag = 8192;
function recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
            recursivelyAccumulateSuspenseyCommit(fiber);
            currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, deletions, deletions.return);
                recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== nextEffect;){
        var fiber = nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
            cache = nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            detachFiberAfterEffects(cache);
            if (cache === fiber) {
                nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                break a;
            }
            nextEffect = returnFiber;
        }
    }
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
function requestUpdateLane() {
    if (0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes) return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
    if (null !== ReactSharedInternals.T) {
        var actionScopeLane = currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : requestTransitionLane();
    }
    return resolveUpdatePriority();
}
function requestDeferredLane() {
    0 === workInProgressDeferredLane && (workInProgressDeferredLane = 0 === (workInProgressRootRenderLanes & 536870912) || isHydrating ? claimNextTransitionLane() : 536870912);
    var suspenseHandler = suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return workInProgressDeferredLane;
}
function scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    markRootUpdated$1(root, lane);
    if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
}
function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = workInProgressRootRecoverableErrors;
                            workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                prepareFreshStack(root$jscomp$0, 0);
                markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error(formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error(formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
                    markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                commitRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    ensureRootIsScheduled(root$jscomp$0);
}
function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if (suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: noop
        }, accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function resetWorkInProgressStack() {
    if (null !== workInProgress) {
        if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
        else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState = null, thenableIndexCounter = 0, interruptedWork = workInProgress;
        for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
    }
}
function prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    resetWorkInProgressStack();
    workInProgressRoot = root;
    workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = !1;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    workInProgressRootDidAttachPingListener = !1;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function handleThrow(root, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
}
function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
}
function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
}
function renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = workInProgressRootExitStatus;
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch(workInProgressSuspendedReason){
                case 8:
                    resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = workInProgressSuspendedReason;
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
}
function workLoopSync() {
    for(; null !== workInProgress;)performUnitOfWork(workInProgress);
}
function renderRootConcurrent(root, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            lanes = workInProgress;
            var thrownValue = workInProgressThrownValue;
            b: switch(workInProgressSuspendedReason){
                case 1:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if (isThenableResolved(thrownValue)) {
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root || (workInProgressSuspendedReason = 7);
                        ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : 1) {
                                workInProgressSuspendedReason = 0;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                    }
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error(formatProdErrorMessage(462));
            }
        }
        workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        handleThrow(root, thrownValue$169);
    }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
}
function workLoopConcurrentByScheduler() {
    for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
}
function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
            break;
        case 11:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
            break;
        case 5:
            resetHooksOnUnwind(next);
        default:
            unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState = null;
    thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = 1;
        logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
        workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if (isHydrating || 1 === suspendedReason) root = !0;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
        else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root);
    } else completeUnitOfWork(unitOfWork);
}
function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
        if (null !== next) {
            workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            workInProgress = completedWork;
            return;
        }
        workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
}
function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            workInProgress = unitOfWork;
            return;
        }
        workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
}
function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
        markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root;
        pendingEffectsLanes = lanes;
        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
            flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            transitions = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            spawnedLane = executionContext;
            executionContext |= 4;
            try {
                commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
            }
        }
        pendingEffectsStatus = 1;
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
    }
}
function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                _enabled = !!eventsEnabled;
                selectionInformation = eventsEnabled = null;
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        pendingEffectsStatus = 2;
    }
}
function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        pendingEffectsStatus = 3;
    }
}
function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        requestPaint();
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
            injectedHook.onCommitFiberRoot(rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = ReactSharedInternals.T;
            remainingLanes = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : nestedUpdateCount = 0;
        flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
}
function flushPendingEffects(wasDelayedCommit) {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects(wasDelayedCommit);
}
function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return !1;
    var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        ReactSharedInternals.T = null;
        renderPriority = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
        pendingEffectsStatus = 0;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        commitPassiveUnmountOnFiber(root$jscomp$0.current);
        commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        executionContext = prevExecutionContext;
        flushSyncWorkAcrossRoots_impl(0, !1);
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
            injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root, remainingLanes);
    }
}
function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
}
function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                error = createClassErrorUpdate(2);
                instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root);
}
function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
}
function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
}
var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0;
function ensureRootIsScheduled(root) {
    root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
    mightHavePendingSyncWork = !0;
    didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
}
function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root$174, root$174 === workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        isFlushingWork = !1;
    }
}
function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
}
function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && (shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane), currentEventTransitionLane = 0);
    for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
        root = next;
    }
    flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && cancelCallback$1(pingedLanes);
        switch(lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = IdlePriority;
                break;
            default:
                suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if (flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root, now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function performSyncWorkOnRoot(root, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root, lanes, !0);
}
function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
        0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
    });
}
function requestTransitionLane() {
    0 === currentEventTransitionLane && (currentEventTransitionLane = claimNextTransitionLane());
    return currentEventTransitionLane;
}
function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
}
function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== currentEventTransitionLane) {
                                var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var i$jscomp$inline_1528 = 0; i$jscomp$inline_1528 < simpleEventPluginEvents.length; i$jscomp$inline_1528++){
    var eventName$jscomp$inline_1529 = simpleEventPluginEvents[i$jscomp$inline_1528], domEventName$jscomp$inline_1530 = eventName$jscomp$inline_1529.toLowerCase(), capitalizedEvent$jscomp$inline_1531 = eventName$jscomp$inline_1529[0].toUpperCase() + eventName$jscomp$inline_1529.slice(1);
    registerSimpleEvent(domEventName$jscomp$inline_1530, "on" + capitalizedEvent$jscomp$inline_1531);
}
registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
registerSimpleEvent(ANIMATION_START, "onAnimationStart");
registerSimpleEvent("dblclick", "onDoubleClick");
registerSimpleEvent("focusin", "onFocus");
registerSimpleEvent("focusout", "onBlur");
registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
registerSimpleEvent(TRANSITION_START, "onTransitionStart");
registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes));
function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = !0;
        allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch(getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = SyntheticTouchEvent;
                        break;
                    case ANIMATION_END:
                    case ANIMATION_ITERATION:
                    case ANIMATION_START:
                        SyntheticEventCtor = SyntheticAnimationEvent;
                        break;
                    case TRANSITION_END:
                        SyntheticEventCtor = SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = getParent(inCapturePhase);
                                reactEventName = getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                else if (isTextInputElement(reactName)) {
                    if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = getTargetInstForInputEventPolyfill;
                        var handleEventFunc = handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                    break;
                case "focusout":
                    lastSelection = activeElementInst = activeElement = null;
                    break;
                case "mousedown":
                    mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    mouseDown = !1;
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if (skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if (canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function noop$1() {}
function setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && setTextContent(domElement, "" + value);
            break;
        case "className":
            setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
}
function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
    }
}
function setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(formatProdErrorMessage(137, tag));
                    default:
                        setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            track(domElement);
            return;
        case "select":
            listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            listenToNonDelegatedEvent("cancel", domElement);
            listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(formatProdErrorMessage(137, tag));
                default:
                    setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, !0) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && setProp(domElement, tag, value, name, nextProps, type);
            }
            updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error(formatProdErrorMessage(137, tag));
                    break;
                default:
                    setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var eventsEnabled = null, selectionInformation = null;
function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var currentPopstateTransitionEvent = null;
function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return !1;
        currentPopstateTransitionEvent = event;
        return !0;
    }
    currentPopstateTransitionEvent = null;
    return !1;
}
var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
} : scheduleTimeout;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function isSingletonScope(type) {
    return "head" === type;
}
function clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    retryIfBlockedOn(suspenseInstance);
}
function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                clearContainerSparingly(node);
                detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var previousHydratableOnEnteringScopedSingleton = null;
function getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function resolveSingletonInstance(type, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error(formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error(formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error(formatProdErrorMessage(454));
            return type;
        default:
            throw Error(formatProdErrorMessage(451));
    }
}
function releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
}
var preloadPropsMap = new Map(), preconnectsSet = new Set();
function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
}
var globalDocument = "undefined" === typeof document ? null : document;
function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
}
function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
}
function preload(href, as, options) {
    previousDispatcher.L(href, as, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = getStyleKey(href);
                break;
            case "script":
                key = getScriptKey(href);
        }
        preloadPropsMap.has(key) || (href = assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function preloadModule(href, options) {
    previousDispatcher.m(href, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = getScriptKey(href);
        }
        if (!preloadPropsMap.has(key) && (href = assign({
            rel: "modulepreload",
            href: href
        }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function preinitStyle(href, precedence, options) {
    previousDispatcher.S(href, precedence, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                markNodeAsHoistable(link);
                setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function preinitScript(src, options) {
    previousDispatcher.X(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function preinitModuleScript(src, options) {
    previousDispatcher.M(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = getStyleKey(pendingProps.href);
                var styles$244 = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector(getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, preloadPropsMap.set(type, pendingProps), styles$244 || preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error(formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error(formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error(formatProdErrorMessage(444, type));
    }
}
function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function stylesheetPropsFromRawProps(rawProps) {
    return assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, markNodeAsHoistable(instance$250), instance$250;
            instance = stylesheetPropsFromRawProps(props);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = preloadPropsMap.get(instance$250)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error(formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var tagCaches = null;
function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
        var cache = new Map();
        var caches = tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var suspendedState = null;
function noop() {}
function suspendResource(hoistableRoot, resource, props) {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = stylesheetPropsFromRawProps(props);
            (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function waitForCommitToBeReady() {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var precedencesByRoot = null;
function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
}
function insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
};
function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
}
function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
}
function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
}
function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var _enabled = !0;
function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                ensureRootIsScheduled(fiber);
                                0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = findInstanceBlockingEvent(nativeEvent);
                null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
}
var return_targetInst = null;
function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    return_targetInst = targetNode;
    return null;
}
function getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch(getCurrentPriorityLevel()){
                case ImmediatePriority:
                    return 2;
                case UserBlockingPriority:
                    return 8;
                case NormalPriority$1:
                case LowPriority:
                    return 32;
                case IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = requestUpdateLane();
                            lane = getBumpedLaneForHydrationByLane(lane);
                            var root = enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && scheduleUpdateOnFiber(root, nearestMounted, lane);
                            markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            currentReplayingEvent = null;
        } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function replayUnblockedEvents() {
    hasScheduledReplayAttempt = !1;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}
function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
}
var lastScheduledReplayQueue = null;
function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i);
        }
    }
}
function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error(formatProdErrorMessage(409));
    var current = root.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root, null, null);
};
ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        updateContainerImpl(root.current, 2, null, root, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
    }
};
function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
        queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && attemptExplicitHydrationTarget(target);
    }
};
var isomorphicReactPackageVersion$jscomp$inline_1785 = React.version;
if ("19.1.0" !== isomorphicReactPackageVersion$jscomp$inline_1785) throw Error(formatProdErrorMessage(527, isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error(formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2257.isDisabled && hook$jscomp$inline_2257.supportsFiber) try {
        rendererID = hook$jscomp$inline_2257.inject(internals$jscomp$inline_2256), injectedHook = hook$jscomp$inline_2257;
    } catch (err) {}
}
exports.createRoot = function(container, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[internalContainerInstanceKey] = options.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options);
};
exports.hydrateRoot = function(container, initialChildren, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    markRootUpdated$1(initialChildren, options);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
};
exports.version = "19.1.0";

},{"934b50a50c275743":"dHubo","56d30b16d84cc622":"bmhQu","d42dbe4aacaa6df4":"82aNB"}],"dHubo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c2333c22ee790411");

},{"c2333c22ee790411":"d4zlD"}],"d4zlD":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
exports.unstable_now = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var localPerformance = performance;
    exports.unstable_now = function() {
        return localPerformance.now();
    };
} else {
    var localDate = Date, initialTime = localDate.now();
    exports.unstable_now = function() {
        return localDate.now() - initialTime;
    };
}
var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function advanceTimers(currentTime) {
    for(var timer = peek(timerQueue); null !== timer;){
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
    }
}
function handleTimeout(currentTime) {
    isHostTimeoutScheduled = !1;
    advanceTimers(currentTime);
    if (!isHostCallbackScheduled) {
        if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = peek(timerQueue);
            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
function shouldYieldToHost() {
    return needsPaint ? !0 : exports.unstable_now() - startTime < frameInterval ? !1 : !0;
}
function performWorkUntilDeadline() {
    needsPaint = !1;
    if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                isHostCallbackScheduled = !1;
                isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                isPerformingWork = !0;
                var previousPriorityLevel = currentPriorityLevel;
                try {
                    b: {
                        advanceTimers(currentTime);
                        for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                            var callback = currentTask.callback;
                            if ("function" === typeof callback) {
                                currentTask.callback = null;
                                currentPriorityLevel = currentTask.priorityLevel;
                                var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                currentTime = exports.unstable_now();
                                if ("function" === typeof continuationCallback) {
                                    currentTask.callback = continuationCallback;
                                    advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                currentTask === peek(taskQueue) && pop(taskQueue);
                                advanceTimers(currentTime);
                            } else pop(taskQueue);
                            currentTask = peek(taskQueue);
                        }
                        if (null !== currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = peek(timerQueue);
                            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
        }
    }
}
var schedulePerformWorkUntilDeadline;
if ("function" === typeof localSetImmediate) schedulePerformWorkUntilDeadline = function() {
    localSetImmediate(performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var channel = new MessageChannel(), port = channel.port2;
    channel.port1.onmessage = performWorkUntilDeadline;
    schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
    };
} else schedulePerformWorkUntilDeadline = function() {
    localSetTimeout(performWorkUntilDeadline, 0);
};
function requestHostTimeout(callback, ms) {
    taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
    }, ms);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(task) {
    task.callback = null;
};
exports.unstable_forceFrameRate = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return currentPriorityLevel;
};
exports.unstable_next = function(eventHandler) {
    switch(currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = currentPriorityLevel;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_requestPaint = function() {
    needsPaint = !0;
};
exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
    var currentTime = exports.unstable_now();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
exports.unstable_shouldYield = shouldYieldToHost;
exports.unstable_wrapCallback = function(callback) {
    var parentPriorityLevel = currentPriorityLevel;
    return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
};

},{}],"bmhQu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"ez6FA"}],"ez6FA":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.1.0";

},{}],"82aNB":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"5lC7J"}],"5lC7J":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.1.0";

},{"6a05e75e64e4f862":"bmhQu"}],"ceurZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "App", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _appCss = require("./App.css");
var _body = require("./components/Body");
var _bodyDefault = parcelHelpers.interopDefault(_body);
var _myStore = require("./store/myStore");
var _myStoreDefault = parcelHelpers.interopDefault(_myStore);
function App() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRedux.Provider), {
        store: (0, _myStoreDefault.default),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: " overflow-x-hidden",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bodyDefault.default), {})
        })
    });
}

},{"react/jsx-runtime":"gonF6","react-redux":"aRDHF","./App.css":"ffZW6","./components/Body":"fdMCo","./store/myStore":"fQlbO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aRDHF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>Provider_default);
parcelHelpers.export(exports, "ReactReduxContext", ()=>ReactReduxContext);
parcelHelpers.export(exports, "batch", ()=>batch);
parcelHelpers.export(exports, "connect", ()=>connect_default);
parcelHelpers.export(exports, "createDispatchHook", ()=>createDispatchHook);
parcelHelpers.export(exports, "createSelectorHook", ()=>createSelectorHook);
parcelHelpers.export(exports, "createStoreHook", ()=>createStoreHook);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
parcelHelpers.export(exports, "useDispatch", ()=>useDispatch);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
parcelHelpers.export(exports, "useStore", ()=>useStore);
// src/utils/react.ts
var _react = require("react");
// src/hooks/useSelector.ts
var _withSelectorJs = require("use-sync-external-store/with-selector.js");
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var IS_REACT_19 = /* @__PURE__ */ _react.version.startsWith("19");
var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for(IS_REACT_19 ? "react.transitional.element" : "react.element");
var REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Memo = REACT_MEMO_TYPE;
function isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof } = object;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function isContextConsumer(object) {
    return IS_REACT_19 ? typeOf(object) === REACT_CONSUMER_TYPE : typeOf(object) === REACT_CONTEXT_TYPE;
}
function isMemo(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    verify(mapStateToProps, "mapStateToProps");
    verify(mapDispatchToProps, "mapDispatchToProps");
    verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual, areOwnPropsEqual, areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps, initMapDispatchToProps, initMergeProps } = _b, options = __objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function verifyPlainObject(value, displayName, methodName) {
    if (!isPlainObject(value)) warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? wrapMapToPropsConstant((dispatch)=>({
            dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return __spreadValues(__spreadValues(__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName, areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>defaultMergeProps : typeof mergeProps === "function" ? wrapMergePropsFunc(mergeProps) : createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify () {},
    get: ()=>[]
};
function createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub,
        notifyNestedSubs,
        handleChangeWrapper,
        isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var isDOM = /* @__PURE__ */ canUseDOM();
var isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var isReactNative = /* @__PURE__ */ isRunningInReactNative();
var getUseIsomorphicLayoutEffect = ()=>isDOM || isReactNative ? _react.useLayoutEffect : _react.useEffect;
var useIsomorphicLayoutEffect = /* @__PURE__ */ getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {
    [ForwardRef]: FORWARD_REF_STATICS,
    [Memo]: MEMO_STATICS
};
function getStatics(component) {
    if (isMemo(component)) return MEMO_STATICS;
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if (objectPrototype) {
            const inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        const targetStatics = getStatics(targetComponent);
        const sourceStatics = getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function getContext() {
    var _a;
    if (!_react.createContext) return {};
    const contextMap = (_a = gT[ContextKey]) != null ? _a : gT[ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get(_react.createContext);
    if (!realContext) {
        realContext = _react.createContext(null);
        contextMap.set(_react.createContext, realContext);
    }
    return realContext;
}
var ReactReduxContext = /* @__PURE__ */ getContext();
// src/components/connect.tsx
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function strictEqual(a, b) {
    return a === b;
}
var hasWarnedAboutDeprecatedPureOption = false;
function connect(mapStateToProps, mapDispatchToProps, mergeProps, { // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual = strictEqual, areOwnPropsEqual = shallowEqual, areStatePropsEqual = shallowEqual, areMergedPropsEqual = shallowEqual, // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, // the context consumer to use
context = ReactReduxContext } = {}) {
    const Context = context;
    const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges,
            displayName,
            wrappedComponentName,
            WrappedComponent,
            // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps,
            initMergeProps,
            areStatesEqual,
            areStatePropsEqual,
            areOwnPropsEqual,
            areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = _react.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = __objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = _react.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = _react.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = _react.useMemo(()=>{
                return finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = _react.useMemo(()=>{
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY;
                const subscription2 = createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = _react.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return __spreadProps(__spreadValues({}, contextValue), {
                    subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = _react.useRef(void 0);
            const lastWrapperProps = _react.useRef(wrapperProps);
            const childPropsFromStoreUpdate = _react.useRef(void 0);
            const renderIsScheduled = _react.useRef(false);
            const isMounted = _react.useRef(false);
            const latestSubscriptionCallbackError = _react.useRef(void 0);
            useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = _react.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = _react.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = _react.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = _react.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ _react.createElement(WrappedComponent, __spreadProps(__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = _react.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ _react.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = _react.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = _react.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ _react.createElement(Connect, __spreadProps(__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var connect_default = connect;
// src/components/Provider.tsx
function Provider(providerProps) {
    const { children, context, serverState, store } = providerProps;
    const contextValue = _react.useMemo(()=>{
        const subscription = createSubscription(store);
        const baseContextValue = {
            store,
            subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = _react.useMemo(()=>store.getState(), [
        store
    ]);
    useIsomorphicLayoutEffect(()=>{
        const { subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || ReactReduxContext;
    return /* @__PURE__ */ _react.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var Provider_default = Provider;
// src/hooks/useReduxContext.ts
function createReduxContextHook(context = ReactReduxContext) {
    return function useReduxContext2() {
        const contextValue = _react.useContext(context);
        return contextValue;
    };
}
var useReduxContext = /* @__PURE__ */ createReduxContextHook();
// src/hooks/useStore.ts
function createStoreHook(context = ReactReduxContext) {
    const useReduxContext2 = context === ReactReduxContext ? useReduxContext : // @ts-ignore
    createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var useStore = /* @__PURE__ */ createStoreHook();
// src/hooks/useDispatch.ts
function createDispatchHook(context = ReactReduxContext) {
    const useStore2 = context === ReactReduxContext ? useStore : createStoreHook(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var useDispatch = /* @__PURE__ */ createDispatchHook();
var refEquality = (a, b)=>a === b;
function createSelectorHook(context = ReactReduxContext) {
    const useReduxContext2 = context === ReactReduxContext ? useReduxContext : createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn = refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store, subscription, getServerState } = reduxContext;
        const firstRun = _react.useRef(true);
        const wrappedSelector = _react.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, _withSelectorJs.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        _react.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var useSelector = /* @__PURE__ */ createSelectorHook();
// src/exports.ts
var batch = defaultNoopBatch;

},{"react":"bmhQu","use-sync-external-store/with-selector.js":"aRxn3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aRxn3":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("626c9c74fab84747");

},{"626c9c74fab84747":"5ft1K"}],"5ft1K":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("309335e472185eb6");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = React.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"309335e472185eb6":"bmhQu"}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"ffZW6":[function() {},{}],"fdMCo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _login = require("./Login");
var _loginDefault = parcelHelpers.interopDefault(_login);
var _browse = require("./Browse");
var _browseDefault = parcelHelpers.interopDefault(_browse);
var _reactRouter = require("react-router");
var _signup = require("./Signup");
var _signupDefault = parcelHelpers.interopDefault(_signup);
const Body = ()=>{
    const appRouter = (0, _reactRouter.createBrowserRouter)([
        {
            path: "/browse",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _browseDefault.default), {})
        },
        {
            path: "/",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginDefault.default), {})
        },
        {
            path: "/signup",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signupDefault.default), {})
        }
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.RouterProvider), {
            router: appRouter
        })
    });
};
exports.default = Body;

},{"react/jsx-runtime":"gonF6","./Login":"39FX7","./Browse":"1HNKH","react-router":"6qXj4","./Signup":"53bH1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"39FX7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Login);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _header = require("./Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _validate = require("../utils/validate");
var _react = require("react");
var _signin = require("../utils/signin");
var _spinner = require("./helper/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _reactRedux = require("react-redux");
var _user = require("../store/slice/user");
function Login() {
    const email = (0, _react.useRef)(null);
    const password = (0, _react.useRef)(null);
    const navigate = (0, _reactRouter.useNavigate)();
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [loading, setLoading] = (0, _react.useState)(false);
    const dispatchAction = (0, _reactRedux.useDispatch)();
    // const userStore = useSelector((store)=>store?.user)
    const handleSigninOps = async ()=>{
        let validateRes = (0, _validate.signInValidate)(email?.current?.["value"]);
        if (validateRes) setErrorMessage(validateRes);
        else {
            setLoading(true);
            setErrorMessage("");
            let signInRes = await (0, _signin.signInUser)(email?.current?.["value"], password?.current?.["value"]);
            setLoading(false);
            if (signInRes.status === "Error") setErrorMessage("Invalid Credentials");
            else {
                dispatchAction((0, _user.addUser)(signInRes));
                navigate("/browse");
            }
        }
        return;
    };
    return(// userStore.accessToken
    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bg-[url(https://assets.nflxext.com/ffe/siteui/vlv3/6863f6e8-d419-414d-b5b9-7ef657e67ce4/web/IN-en-20250602-TRIFECTA-perspective_27a3fdfa-126f-4148-b153-55d60b51be6a_small.jpg)]",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex h-screen justify-center items-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "lg:w-3/12  mt-20  absolute opacity-80 bg-black p-10 space-y-10 rounded-md text-lg mb-10",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-white text-4xl font-bold ",
                                children: "Sign In"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                className: "  space-y-4",
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        ref: email,
                                        type: "email",
                                        placeholder: "Email or mobile number",
                                        required: true,
                                        className: " py-3 px-4 w-full bg-transparent text-slate-200 placeholder-slate-200 border border-slate-200 rounded-sm  focus:border-2 focus:border-white"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-red-500 -mt-4 text-sm",
                                        children: errorMessage.search("Email") != -1 ? errorMessage : null
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        ref: password,
                                        type: "password",
                                        placeholder: "Password",
                                        required: true,
                                        className: "  py-3 px-4  w-full bg-transparent text-slate-200 placeholder-slate-200 border border-slate-200 rounded-sm focus:border-2 focus:border-white"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-red-500 -mt-4 text-sm",
                                        children: errorMessage.search("Cred") != -1 ? errorMessage : null
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "bg-red-600 px-4 py-2 w-full text-white font-bold rounded-sm hover:cursor-pointer",
                                        onClick: ()=>handleSigninOps(),
                                        children: !loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "hover:cursor-pointer",
                                            children: "Sign In"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-white text-center",
                                        children: "OR"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "w-full bg-neutral-500 text-white  py-3 px-4 rounded-sm  hover:cursor-pointer",
                                        onSubmit: (e)=>e.preventDefault(),
                                        children: "Use a sign-in code"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-white underline text-center hover:cursor-pointer",
                                        children: "Forgot Password?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "text-white space-x-3 align-middle",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "checkbox",
                                                name: "Remember me",
                                                id: "",
                                                className: "w-4 h-4 accent-amber-50 hover:cursor-pointer "
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                htmlFor: "checkbox",
                                                children: "Remember Me"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "text-white text-base",
                                        children: [
                                            "New to Netflix?",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                to: "/signup",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "hover:underline font-bold hover:cursor-pointer",
                                                    children: "Sign up now."
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-gray-300",
                                        children: "This page is protected by Google reCAPTCHA to ensure you're not a bot."
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-blue-500 underline hover:cursor-pointer",
                                        children: "Learn more."
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    }));
}

},{"react/jsx-runtime":"gonF6","react-router":"6qXj4","./Header":"5keeC","../utils/validate":"36F7x","react":"bmhQu","../utils/signin":"7HPJs","./helper/Spinner":"fDGWh","react-redux":"aRDHF","../store/slice/user":"4kGyY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6qXj4":[function(require,module,exports,__globalThis) {
/**
 * react-router v7.6.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Await", ()=>(0, _chunkNL6KNZEEMjs.Await));
parcelHelpers.export(exports, "BrowserRouter", ()=>(0, _chunkNL6KNZEEMjs.BrowserRouter));
parcelHelpers.export(exports, "Form", ()=>(0, _chunkNL6KNZEEMjs.Form));
parcelHelpers.export(exports, "HashRouter", ()=>(0, _chunkNL6KNZEEMjs.HashRouter));
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>(0, _chunkNL6KNZEEMjs.IDLE_BLOCKER));
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>(0, _chunkNL6KNZEEMjs.IDLE_FETCHER));
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>(0, _chunkNL6KNZEEMjs.IDLE_NAVIGATION));
parcelHelpers.export(exports, "Link", ()=>(0, _chunkNL6KNZEEMjs.Link));
parcelHelpers.export(exports, "Links", ()=>(0, _chunkNL6KNZEEMjs.Links));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _chunkNL6KNZEEMjs.MemoryRouter));
parcelHelpers.export(exports, "Meta", ()=>(0, _chunkNL6KNZEEMjs.Meta));
parcelHelpers.export(exports, "NavLink", ()=>(0, _chunkNL6KNZEEMjs.NavLink));
parcelHelpers.export(exports, "Navigate", ()=>(0, _chunkNL6KNZEEMjs.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _chunkNL6KNZEEMjs.Action));
parcelHelpers.export(exports, "Outlet", ()=>(0, _chunkNL6KNZEEMjs.Outlet));
parcelHelpers.export(exports, "PrefetchPageLinks", ()=>(0, _chunkNL6KNZEEMjs.PrefetchPageLinks));
parcelHelpers.export(exports, "Route", ()=>(0, _chunkNL6KNZEEMjs.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _chunkNL6KNZEEMjs.Router));
parcelHelpers.export(exports, "RouterProvider", ()=>(0, _chunkNL6KNZEEMjs.RouterProvider));
parcelHelpers.export(exports, "Routes", ()=>(0, _chunkNL6KNZEEMjs.Routes));
parcelHelpers.export(exports, "Scripts", ()=>(0, _chunkNL6KNZEEMjs.Scripts));
parcelHelpers.export(exports, "ScrollRestoration", ()=>(0, _chunkNL6KNZEEMjs.ScrollRestoration));
parcelHelpers.export(exports, "ServerRouter", ()=>(0, _chunkNL6KNZEEMjs.ServerRouter));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _chunkNL6KNZEEMjs.StaticRouter));
parcelHelpers.export(exports, "StaticRouterProvider", ()=>(0, _chunkNL6KNZEEMjs.StaticRouterProvider));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _chunkNL6KNZEEMjs.DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _chunkNL6KNZEEMjs.DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _chunkNL6KNZEEMjs.ErrorResponseImpl));
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>(0, _chunkNL6KNZEEMjs.FetchersContext));
parcelHelpers.export(exports, "UNSAFE_FrameworkContext", ()=>(0, _chunkNL6KNZEEMjs.FrameworkContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _chunkNL6KNZEEMjs.LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _chunkNL6KNZEEMjs.NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RemixErrorBoundary", ()=>(0, _chunkNL6KNZEEMjs.RemixErrorBoundary));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _chunkNL6KNZEEMjs.RouteContext));
parcelHelpers.export(exports, "UNSAFE_ServerMode", ()=>(0, _chunkNL6KNZEEMjs.ServerMode));
parcelHelpers.export(exports, "UNSAFE_SingleFetchRedirectSymbol", ()=>(0, _chunkNL6KNZEEMjs.SingleFetchRedirectSymbol));
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>(0, _chunkNL6KNZEEMjs.ViewTransitionContext));
parcelHelpers.export(exports, "UNSAFE_createBrowserHistory", ()=>(0, _chunkNL6KNZEEMjs.createBrowserHistory));
parcelHelpers.export(exports, "UNSAFE_createClientRoutes", ()=>(0, _chunkNL6KNZEEMjs.createClientRoutes));
parcelHelpers.export(exports, "UNSAFE_createClientRoutesWithHMRRevalidationOptOut", ()=>(0, _chunkNL6KNZEEMjs.createClientRoutesWithHMRRevalidationOptOut));
parcelHelpers.export(exports, "UNSAFE_createRouter", ()=>(0, _chunkNL6KNZEEMjs.createRouter));
parcelHelpers.export(exports, "UNSAFE_decodeViaTurboStream", ()=>(0, _chunkNL6KNZEEMjs.decodeViaTurboStream));
parcelHelpers.export(exports, "UNSAFE_deserializeErrors", ()=>(0, _chunkNL6KNZEEMjs.deserializeErrors));
parcelHelpers.export(exports, "UNSAFE_getHydrationData", ()=>(0, _chunkNL6KNZEEMjs.getHydrationData));
parcelHelpers.export(exports, "UNSAFE_getPatchRoutesOnNavigationFunction", ()=>(0, _chunkNL6KNZEEMjs.getPatchRoutesOnNavigationFunction));
parcelHelpers.export(exports, "UNSAFE_getTurboStreamSingleFetchDataStrategy", ()=>(0, _chunkNL6KNZEEMjs.getTurboStreamSingleFetchDataStrategy));
parcelHelpers.export(exports, "UNSAFE_hydrationRouteProperties", ()=>(0, _chunkNL6KNZEEMjs.hydrationRouteProperties));
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>(0, _chunkNL6KNZEEMjs.invariant));
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>(0, _chunkNL6KNZEEMjs.mapRouteProperties));
parcelHelpers.export(exports, "UNSAFE_shouldHydrateRouteLoader", ()=>(0, _chunkNL6KNZEEMjs.shouldHydrateRouteLoader));
parcelHelpers.export(exports, "UNSAFE_useFogOFWarDiscovery", ()=>(0, _chunkNL6KNZEEMjs.useFogOFWarDiscovery));
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>(0, _chunkNL6KNZEEMjs.useScrollRestoration));
parcelHelpers.export(exports, "UNSAFE_withComponentProps", ()=>(0, _chunkNL6KNZEEMjs.withComponentProps));
parcelHelpers.export(exports, "UNSAFE_withErrorBoundaryProps", ()=>(0, _chunkNL6KNZEEMjs.withErrorBoundaryProps));
parcelHelpers.export(exports, "UNSAFE_withHydrateFallbackProps", ()=>(0, _chunkNL6KNZEEMjs.withHydrateFallbackProps));
parcelHelpers.export(exports, "createBrowserRouter", ()=>(0, _chunkNL6KNZEEMjs.createBrowserRouter));
parcelHelpers.export(exports, "createCookie", ()=>(0, _chunkNL6KNZEEMjs.createCookie));
parcelHelpers.export(exports, "createCookieSessionStorage", ()=>(0, _chunkNL6KNZEEMjs.createCookieSessionStorage));
parcelHelpers.export(exports, "createHashRouter", ()=>(0, _chunkNL6KNZEEMjs.createHashRouter));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _chunkNL6KNZEEMjs.createMemoryRouter));
parcelHelpers.export(exports, "createMemorySessionStorage", ()=>(0, _chunkNL6KNZEEMjs.createMemorySessionStorage));
parcelHelpers.export(exports, "createPath", ()=>(0, _chunkNL6KNZEEMjs.createPath));
parcelHelpers.export(exports, "createRequestHandler", ()=>(0, _chunkNL6KNZEEMjs.createRequestHandler));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _chunkNL6KNZEEMjs.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _chunkNL6KNZEEMjs.createRoutesFromElements));
parcelHelpers.export(exports, "createRoutesStub", ()=>(0, _chunkNL6KNZEEMjs.createRoutesStub));
parcelHelpers.export(exports, "createSearchParams", ()=>(0, _chunkNL6KNZEEMjs.createSearchParams));
parcelHelpers.export(exports, "createSession", ()=>(0, _chunkNL6KNZEEMjs.createSession));
parcelHelpers.export(exports, "createSessionStorage", ()=>(0, _chunkNL6KNZEEMjs.createSessionStorage));
parcelHelpers.export(exports, "createStaticHandler", ()=>(0, _chunkNL6KNZEEMjs.createStaticHandler));
parcelHelpers.export(exports, "createStaticRouter", ()=>(0, _chunkNL6KNZEEMjs.createStaticRouter));
parcelHelpers.export(exports, "data", ()=>(0, _chunkNL6KNZEEMjs.data));
parcelHelpers.export(exports, "generatePath", ()=>(0, _chunkNL6KNZEEMjs.generatePath));
parcelHelpers.export(exports, "href", ()=>(0, _chunkNL6KNZEEMjs.href));
parcelHelpers.export(exports, "isCookie", ()=>(0, _chunkNL6KNZEEMjs.isCookie));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _chunkNL6KNZEEMjs.isRouteErrorResponse));
parcelHelpers.export(exports, "isSession", ()=>(0, _chunkNL6KNZEEMjs.isSession));
parcelHelpers.export(exports, "matchPath", ()=>(0, _chunkNL6KNZEEMjs.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _chunkNL6KNZEEMjs.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _chunkNL6KNZEEMjs.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _chunkNL6KNZEEMjs.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _chunkNL6KNZEEMjs.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _chunkNL6KNZEEMjs.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _chunkNL6KNZEEMjs.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _chunkNL6KNZEEMjs.resolvePath));
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>(0, _chunkNL6KNZEEMjs.HistoryRouter));
parcelHelpers.export(exports, "unstable_RouterContextProvider", ()=>(0, _chunkNL6KNZEEMjs.unstable_RouterContextProvider));
parcelHelpers.export(exports, "unstable_createContext", ()=>(0, _chunkNL6KNZEEMjs.unstable_createContext));
parcelHelpers.export(exports, "unstable_setDevServerHooks", ()=>(0, _chunkNL6KNZEEMjs.setDevServerHooks));
parcelHelpers.export(exports, "unstable_usePrompt", ()=>(0, _chunkNL6KNZEEMjs.usePrompt));
parcelHelpers.export(exports, "useActionData", ()=>(0, _chunkNL6KNZEEMjs.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _chunkNL6KNZEEMjs.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _chunkNL6KNZEEMjs.useAsyncValue));
parcelHelpers.export(exports, "useBeforeUnload", ()=>(0, _chunkNL6KNZEEMjs.useBeforeUnload));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _chunkNL6KNZEEMjs.useBlocker));
parcelHelpers.export(exports, "useFetcher", ()=>(0, _chunkNL6KNZEEMjs.useFetcher));
parcelHelpers.export(exports, "useFetchers", ()=>(0, _chunkNL6KNZEEMjs.useFetchers));
parcelHelpers.export(exports, "useFormAction", ()=>(0, _chunkNL6KNZEEMjs.useFormAction));
parcelHelpers.export(exports, "useHref", ()=>(0, _chunkNL6KNZEEMjs.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _chunkNL6KNZEEMjs.useInRouterContext));
parcelHelpers.export(exports, "useLinkClickHandler", ()=>(0, _chunkNL6KNZEEMjs.useLinkClickHandler));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _chunkNL6KNZEEMjs.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _chunkNL6KNZEEMjs.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _chunkNL6KNZEEMjs.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _chunkNL6KNZEEMjs.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _chunkNL6KNZEEMjs.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _chunkNL6KNZEEMjs.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _chunkNL6KNZEEMjs.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _chunkNL6KNZEEMjs.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _chunkNL6KNZEEMjs.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _chunkNL6KNZEEMjs.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _chunkNL6KNZEEMjs.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _chunkNL6KNZEEMjs.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _chunkNL6KNZEEMjs.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _chunkNL6KNZEEMjs.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _chunkNL6KNZEEMjs.useRoutes));
parcelHelpers.export(exports, "useSearchParams", ()=>(0, _chunkNL6KNZEEMjs.useSearchParams));
parcelHelpers.export(exports, "useSubmit", ()=>(0, _chunkNL6KNZEEMjs.useSubmit));
parcelHelpers.export(exports, "useViewTransitionState", ()=>(0, _chunkNL6KNZEEMjs.useViewTransitionState));
var _chunkNL6KNZEEMjs = require("./chunk-NL6KNZEE.mjs");

},{"./chunk-NL6KNZEE.mjs":"3ZkaE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ZkaE":[function(require,module,exports,__globalThis) {
/**
 * react-router v7.6.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "unstable_createContext", ()=>unstable_createContext);
parcelHelpers.export(exports, "unstable_RouterContextProvider", ()=>unstable_RouterContextProvider);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "hydrationRouteProperties", ()=>hydrationRouteProperties);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromElements);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "withComponentProps", ()=>withComponentProps);
parcelHelpers.export(exports, "withHydrateFallbackProps", ()=>withHydrateFallbackProps);
parcelHelpers.export(exports, "withErrorBoundaryProps", ()=>withErrorBoundaryProps);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "SingleFetchRedirectSymbol", ()=>SingleFetchRedirectSymbol);
parcelHelpers.export(exports, "getTurboStreamSingleFetchDataStrategy", ()=>getTurboStreamSingleFetchDataStrategy);
parcelHelpers.export(exports, "decodeViaTurboStream", ()=>decodeViaTurboStream);
parcelHelpers.export(exports, "RemixErrorBoundary", ()=>RemixErrorBoundary);
parcelHelpers.export(exports, "createClientRoutesWithHMRRevalidationOptOut", ()=>createClientRoutesWithHMRRevalidationOptOut);
parcelHelpers.export(exports, "createClientRoutes", ()=>createClientRoutes);
parcelHelpers.export(exports, "shouldHydrateRouteLoader", ()=>shouldHydrateRouteLoader);
parcelHelpers.export(exports, "getPatchRoutesOnNavigationFunction", ()=>getPatchRoutesOnNavigationFunction);
parcelHelpers.export(exports, "useFogOFWarDiscovery", ()=>useFogOFWarDiscovery);
parcelHelpers.export(exports, "FrameworkContext", ()=>FrameworkContext);
parcelHelpers.export(exports, "Links", ()=>Links);
parcelHelpers.export(exports, "PrefetchPageLinks", ()=>PrefetchPageLinks);
parcelHelpers.export(exports, "Meta", ()=>Meta);
parcelHelpers.export(exports, "Scripts", ()=>Scripts);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "useViewTransitionState", ()=>useViewTransitionState);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "StaticRouterProvider", ()=>StaticRouterProvider);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler2);
parcelHelpers.export(exports, "createStaticRouter", ()=>createStaticRouter);
parcelHelpers.export(exports, "ServerRouter", ()=>ServerRouter);
parcelHelpers.export(exports, "createRoutesStub", ()=>createRoutesStub);
parcelHelpers.export(exports, "createCookie", ()=>createCookie);
parcelHelpers.export(exports, "isCookie", ()=>isCookie);
parcelHelpers.export(exports, "ServerMode", ()=>ServerMode);
parcelHelpers.export(exports, "setDevServerHooks", ()=>setDevServerHooks);
parcelHelpers.export(exports, "createRequestHandler", ()=>createRequestHandler);
parcelHelpers.export(exports, "createSession", ()=>createSession);
parcelHelpers.export(exports, "isSession", ()=>isSession);
parcelHelpers.export(exports, "createSessionStorage", ()=>createSessionStorage);
parcelHelpers.export(exports, "createCookieSessionStorage", ()=>createCookieSessionStorage);
parcelHelpers.export(exports, "createMemorySessionStorage", ()=>createMemorySessionStorage);
parcelHelpers.export(exports, "href", ()=>href);
parcelHelpers.export(exports, "deserializeErrors", ()=>deserializeErrors2);
parcelHelpers.export(exports, "getHydrationData", ()=>getHydrationData);
// lib/components.tsx
var _react = require("react");
// lib/server-runtime/cookies.ts
var _cookie = require("cookie");
// lib/server-runtime/headers.ts
var _setCookieParser = require("set-cookie-parser");
var $16225997b5bec248$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-NL6KNZEE.mjs"
});
var global = arguments[3];
var __typeError = (msg)=>{
    throw TypeError(msg);
};
var __accessCheck = (obj, member, msg)=>member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter)=>(__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value)=>member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var Action = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})(Action || {});
var PopStateEventType = "popstate";
function createMemoryHistory(options = {}) {
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function createBrowserHistory(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname, search, hash } = window2.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href2 = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href2 = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href2 + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? parsePath(to) : to,
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    };
    return location;
}
function createPath({ pathname = "/", search = "", hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    invariant(base, "No window.location.(origin|href) available to create URL");
    let href2 = typeof to === "string" ? to : createPath(to);
    href2 = href2.replace(/ $/, "%20");
    if (!isAbsolute && href2.startsWith("//")) href2 = base + href2;
    return new URL(href2, base);
}
// lib/router/utils.ts
function unstable_createContext(defaultValue) {
    return {
        defaultValue
    };
}
var _map;
var unstable_RouterContextProvider = class {
    constructor(init){
        __privateAdd(this, _map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    get(context) {
        if (__privateGet(this, _map).has(context)) return __privateGet(this, _map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    set(context, value) {
        __privateGet(this, _map).set(context, value);
    }
};
_map = new WeakMap();
var unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isUnsupportedLazyRouteObjectKey(key) {
    return unsupportedLazyRouteObjectKeys.has(key);
}
var unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "unstable_middleware",
    "children"
]);
function isUnsupportedLazyRouteFunctionKey(key) {
    return unsupportedLazyRouteFunctionKeys.has(key);
}
function isIndexRoute(route) {
    return route.index === true;
}
function convertRoutesToDataRoutes(routes, mapRouteProperties2, parentPath = [], manifest = {}) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, `Cannot specify children on an index route`);
        invariant(!manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if (isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function matchRoutes(routes, locationArg, basename = "/") {
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function generatePath(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify2(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName, isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive = false, end = true) {
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function resolvePath(to, fromPathname = "/") {
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function getResolveToMatches(matches) {
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = {
            ...toArg
        };
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function data(data2, init) {
    return new DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var redirect = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers
    });
};
var redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var ErrorResponseImpl = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "GET",
    ...validMutationMethodsArr
];
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_FETCHER = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let mapRouteProperties2 = init.mapRouteProperties || defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || defaultDataStrategyWithMiddleware;
    let future = {
        unstable_middleware: false,
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location, delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            // matches, errors, fetchers go through as-is
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }, {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path, submission, error } = normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = new unstable_RouterContextProvider(init.unstable_getContext ? await init.unstable_getContext() : void 0);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...getActionDataForCommit(pendingActionResult),
            loaderData,
            errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData
                    } : {}
                }, {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches, revalidatingFetchers } = getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches,
            loaderData,
            errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href2, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, href2, routeId, opts?.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        let scopedContext = new unstable_RouterContextProvider(init.unstable_getContext ? await init.unstable_getContext() : void 0);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, match, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        await handleFetcherLoader(key, routeId, path, match, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, match, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(void 0));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset
                    });
                }
            }
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches, revalidatingFetchers } = getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset
        });
        redirect2 = findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset
            });
        }
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, match, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, getDoneFetcher(void 0));
            return;
        }
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset
                });
                return;
            }
        }
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission, fetcherSubmission, preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation({ currentLocation, nextLocation, historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch: fetch2,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || defaultMapRouteProperties;
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext, filterMatchesToLoad, skipLoaderErrorBubbling, skipRevalidation, dataStrategy, unstable_respond: respond } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new unstable_RouterContextProvider();
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return respond ? respond(staticContext) : staticContext;
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return respond ? respond(staticContext) : staticContext;
        }
        if (respond && matches.some((m)=>m.route.unstable_middleware || typeof m.route.lazy === "object" && m.route.lazy.unstable_middleware)) {
            invariant(requestContext instanceof unstable_RouterContextProvider, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `unstable_RouterContextProvider`");
            try {
                await loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await runMiddlewarePipeline({
                    request,
                    matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, true, async ()=>{
                    let result2 = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
                    if (isResponse(result2)) return result2;
                    renderedStaticContext = {
                        location,
                        basename,
                        ...result2
                    };
                    let res = await respond(renderedStaticContext);
                    return res;
                }, async (error, routeId)=>{
                    if (isResponse(error)) return error;
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        return respond(getStaticContextFromError(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, routeId).route.id));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        return respond({
                            matches,
                            location,
                            basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: isRouteErrorResponse(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        });
                    }
                });
                invariant(isResponse(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if (isResponse(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if (isResponse(result)) return result;
        return {
            location,
            basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId, requestContext, dataStrategy, unstable_respond: respond } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new unstable_RouterContextProvider();
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (respond && matches.some((m)=>m.route.unstable_middleware || typeof m.route.lazy === "object" && m.route.lazy.unstable_middleware)) {
            invariant(requestContext instanceof unstable_RouterContextProvider, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `unstable_RouterContextProvider`");
            await loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await runMiddlewarePipeline({
                request,
                matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, true, async ()=>{
                let result2 = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                if (isResponse(result2)) return respond(result2);
                let error2 = result2.errors ? Object.values(result2.errors)[0] : void 0;
                if (error2 !== void 0) throw error2;
                let value = result2.actionData ? Object.values(result2.actionData)[0] : Object.values(result2.loaderData)[0];
                return typeof value === "string" ? new Response(value) : Response.json(value);
            }, (error2)=>{
                if (isResponse(error2)) return respond(error2);
                return new Response(String(error2), {
                    status: 500,
                    statusText: "Unexpected Server Error"
                });
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method)) {
                let result2 = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return isResponse(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error
            };
        } else {
            let dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if (isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if (isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, false);
                return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches,
            loaderData: {},
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await callDataStrategyImpl(dataStrategy || defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isResponse(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
function getStaticContextFromError(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: void 0,
        text: void 0
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    let parsedPath = parsePath(path);
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: createPath(parsedPath),
        submission
    };
}
function getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult,
        actionStatus
    };
    let dsMatches = matches.map((match, index)=>{
        let { route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (route.loader == null) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if (isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate
        };
        let shouldLoad = shouldRevalidateLoader(match, shouldRevalidateArgs);
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if (shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches,
        revalidatingFetchers
    };
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        invariant(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>isSameRoute(newRoute, existingRoute)));
    let newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String(childrenToPatch?.length || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>isSameRoute(aChild, bChild)));
}
var lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var loadLazyRouteProperty = ({ key, route, manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            invariant(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = loadLazyRouteProperty({
            key,
            route,
            manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise,
        lazyHandlerPromise
    };
}
function isNonNullable(value) {
    return value !== void 0;
}
function loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.unstable_middleware) return void 0;
        return loadLazyRouteProperty({
            key: "unstable_middleware",
            route,
            manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter(isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.unstable_middleware)) return defaultDataStrategy(args);
    return runMiddlewarePipeline(args, false, ()=>defaultDataStrategy(args), (error, routeId)=>({
            [routeId]: {
                type: "error",
                result: error
            }
        }));
}
async function runMiddlewarePipeline(args, propagateResult, handler, errorHandler) {
    let { matches, request, params, context } = args;
    let middlewareState = {
        handlerResult: void 0
    };
    try {
        let tuples = matches.flatMap((m)=>m.route.unstable_middleware ? m.route.unstable_middleware.map((fn)=>[
                    m.route.id,
                    fn
                ]) : []);
        let result = await callRouteMiddleware({
            request,
            params,
            context
        }, tuples, propagateResult, middlewareState, handler);
        return propagateResult ? result : middlewareState.handlerResult;
    } catch (e) {
        if (!middlewareState.middlewareError) throw e;
        let result = await errorHandler(middlewareState.middlewareError.error, middlewareState.middlewareError.routeId);
        if (propagateResult || !middlewareState.handlerResult) return result;
        return Object.assign(middlewareState.handlerResult, result);
    }
}
async function callRouteMiddleware(args, middlewares, propagateResult, middlewareState, handler, idx = 0) {
    let { request } = args;
    if (request.signal.aborted) {
        if (request.signal.reason) throw request.signal.reason;
        throw new Error(`Request aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
    }
    let tuple = middlewares[idx];
    if (!tuple) {
        middlewareState.handlerResult = await handler();
        return middlewareState.handlerResult;
    }
    let [routeId, middleware] = tuple;
    let nextCalled = false;
    let nextResult = void 0;
    let next = async ()=>{
        if (nextCalled) throw new Error("You may only call `next()` once per middleware");
        nextCalled = true;
        let result = await callRouteMiddleware(args, middlewares, propagateResult, middlewareState, handler, idx + 1);
        if (propagateResult) {
            nextResult = result;
            return nextResult;
        }
    };
    try {
        let result = await middleware({
            request: args.request,
            params: args.params,
            context: args.context
        }, next);
        if (nextCalled) {
            if (result === void 0) return nextResult;
            else return result;
        } else return next();
    } catch (error) {
        if (!middlewareState.middlewareError) middlewareState.middlewareError = {
            routeId,
            error
        };
        else if (middlewareState.middlewareError.error !== error) middlewareState.middlewareError = {
            routeId,
            error
        };
        throw error;
    }
}
function getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = loadLazyRouteProperty({
        key: "unstable_middleware",
        route: match.route,
        manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = loadLazyRoute(match.route, isMutationMethod(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, unstable_shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises,
        shouldLoad,
        unstable_shouldRevalidateArgs,
        unstable_shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!unstable_shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return shouldRevalidateLoader(match, {
                ...unstable_shouldRevalidateArgs,
                defaultShouldRevalidate
            });
            return shouldRevalidateLoader(match, unstable_shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            if (isUsingNewApi || shouldLoad || handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) return callLoaderOrAction({
                request,
                match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride,
                scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            unstable_shouldRevalidateArgs: shouldRevalidateArgs,
            unstable_shouldCallHandler: ()=>false,
            _lazyPromises: getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request,
        params: matches[0].params,
        context: scopedContext,
        matches
    };
    let unstable_runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `unstable_runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return runMiddlewarePipeline(typedDataStrategyArgs, false, ()=>cb({
                ...typedDataStrategyArgs,
                fetcherKey,
                unstable_runClientMiddleware: ()=>{
                    throw new Error("Cannot call `unstable_runClientMiddleware()` from within an `unstable_runClientMiddleware` handler");
                }
            }), (error, routeId)=>({
                [routeId]: {
                    type: "error",
                    result: error
                }
            }));
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey,
        unstable_runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function callLoaderOrAction({ request, match, lazyHandlerPromise, lazyRoutePromise, handlerOverride, scopedContext }) {
    let result;
    let onReject;
    let isAction = isMutationMethod(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new ErrorResponseImpl(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if (isDataWithResponseInit(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: new ErrorResponseImpl(result.init?.status || 500, void 0, result.data),
                statusCode: isRouteErrorResponse(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : void 0
        };
    }
    if (isDataWithResponseInit(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) invariant(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, { pathname, routeId, method, type, message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath({
        ...parsedPath,
        hash: ""
    });
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function isRedirectDataStrategyResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectStatusCode(statusCode) {
    return redirectStatusCodes.has(statusCode);
}
function isRedirectResponse(result) {
    return isResponse(result) && isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toUpperCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toUpperCase());
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: void 0,
        json: void 0,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod,
        formAction,
        formEncType,
        formData: void 0,
        json,
        text: void 0
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise,
        //@ts-ignore
        resolve,
        //@ts-ignore
        reject
    };
}
var DataRouterContext = _react.createContext(null);
DataRouterContext.displayName = "DataRouter";
var DataRouterStateContext = _react.createContext(null);
DataRouterStateContext.displayName = "DataRouterState";
var ViewTransitionContext = _react.createContext({
    isTransitioning: false
});
ViewTransitionContext.displayName = "ViewTransition";
var FetchersContext = _react.createContext(/* @__PURE__ */ new Map());
FetchersContext.displayName = "Fetchers";
var AwaitContext = _react.createContext(null);
AwaitContext.displayName = "Await";
var NavigationContext = _react.createContext(null);
NavigationContext.displayName = "Navigation";
var LocationContext = _react.createContext(null);
LocationContext.displayName = "Location";
var RouteContext = _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
RouteContext.displayName = "Route";
var RouteErrorContext = _react.createContext(null);
RouteErrorContext.displayName = "RouteError";
var ENABLE_DEV_WARNINGS = true;
function useHref(to, { relative } = {}) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
function useLocation() {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return _react.useContext(LocationContext).location;
}
function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
function useMatch(pattern) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname } = useLocation();
    return _react.useMemo(()=>matchPath(pattern, decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) _react.useLayoutEffect(cb);
}
function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback((to, options = {})=>{
        warning(activeRef.current, navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var OutletContext = _react.createContext(null);
function useOutletContext() {
    return _react.useContext(OutletContext);
}
function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /* @__PURE__ */ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function useResolvedPath(to, { relative } = {}) {
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    return _react.useMemo(()=>resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if (ENABLE_DEV_WARNINGS) {
        let parentPath = parentRoute && parentRoute.path || "";
        warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
        invariant(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = matchRoutes(routes, {
        pathname: remainingPathname
    });
    if (ENABLE_DEV_WARNINGS) {
        warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ _react.createElement(LocationContext.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if (ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ _react.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ _react.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ _react.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var defaultErrorElement = /* @__PURE__ */ _react.createElement(DefaultErrorComponent, null);
var RenderErrorBoundary = class extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function RenderedRoute({ routeContext, match, children }) {
    let dataRouterContext = _react.useContext(DataRouterContext);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        invariant(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ _react.createElement(RenderedRoute, {
                match,
                routeContext: {
                    outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError(hookName));
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError(hookName));
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    invariant(route, getDataRouterConsoleError(hookName));
    return route;
}
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    invariant(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function useRouteId() {
    return useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function useNavigation() {
    let state = useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function useRevalidator() {
    let dataRouterContext = useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = _react.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return _react.useMemo(()=>({
            revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function useMatches() {
    let { matches, loaderData } = useDataRouterState("useMatches" /* UseMatches */ );
    return _react.useMemo(()=>matches.map((m)=>convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function useLoaderData() {
    let state = useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function useRouteLoaderData(routeId) {
    let state = useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function useActionData() {
    let state = useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function useRouteError() {
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value?._data;
}
function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value?._error;
}
var blockerId = 0;
function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : IDLE_BLOCKER;
}
function useNavigateStable() {
    let { router } = useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(async (to, options = {})=>{
        warning(activeRef.current, navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) {
        alreadyWarned[key] = true;
        warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var alreadyWarned2 = {};
function warnOnce(condition, message) {
    if (!condition && !alreadyWarned2[message]) {
        alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.element) warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: _react.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.hydrateFallbackElement) warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: _react.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.errorElement) warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: _react.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var hydrationRouteProperties = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function createMemoryRouter(routes, opts) {
    return createRouter({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes,
        hydrationRouteProperties,
        mapRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function RouterProvider({ router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(/* @__PURE__ */ new Map());
    let setState = _react.useCallback((newState, { deletedFetchers, flushSync, viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else _react.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                _react.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /* @__PURE__ */ _react.createElement(Router, {
        basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator
    }, /* @__PURE__ */ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state
    })))))), null);
}
var MemoizedDataRoutes = _react.memo(DataRoutes);
function DataRoutes({ routes, future, state }) {
    return useRoutesImpl(routes, void 0, state, future);
}
function MemoryRouter({ basename, children, initialEntries, initialIndex }) {
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = createMemoryHistory({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function Navigate({ to, replace: replace2, state, relative }) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = _react.useContext(NavigationContext);
    warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    let path = resolveTo(to, getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state,
            relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function Outlet(props) {
    return useOutlet(props.context);
}
function Route(_props) {
    invariant(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function Router({ basename: basenameProp = "/", children = null, location: locationProp, navigationType = "POP" /* Pop */ , navigator, static: staticProp = false }) {
    invariant(!useInRouterContext(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ _react.createElement(LocationContext.Provider, {
        children,
        value: locationContext
    }));
}
function Routes({ children, location }) {
    return useRoutes(createRoutesFromChildren(children), location);
}
function Await({ children, errorElement, resolve }) {
    return /* @__PURE__ */ _react.createElement(AwaitErrorBoundary, {
        resolve,
        errorElement
    }, /* @__PURE__ */ _react.createElement(ResolveAwait, null, children));
}
var AwaitErrorBoundary = class extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children
        });
        throw promise;
    }
};
function ResolveAwait({ children }) {
    let data2 = useAsyncValue();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, toRender);
}
function createRoutesFromChildren(children, parentPath = []) {
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!_react.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        invariant(element.type === Route, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        invariant(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var createRoutesFromElements = createRoutesFromChildren;
function renderMatches(matches) {
    return _renderMatches(matches);
}
function withComponentProps(Component4) {
    return function WithComponentProps() {
        const props = {
            params: useParams(),
            loaderData: useLoaderData(),
            actionData: useActionData(),
            matches: useMatches()
        };
        return _react.createElement(Component4, props);
    };
}
function withHydrateFallbackProps(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        const props = {
            params: useParams(),
            loaderData: useLoaderData(),
            actionData: useActionData()
        };
        return _react.createElement(HydrateFallback, props);
    };
}
function withErrorBoundaryProps(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        const props = {
            params: useParams(),
            loaderData: useLoaderData(),
            actionData: useActionData(),
            error: useRouteError()
        };
        return _react.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event);
}
function createSearchParams(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
var supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) {
        warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${defaultEncType}"`);
        return null;
    }
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? stripBasename(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(form, target);
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
// lib/dom/ssr/invariant.ts
function invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/routeModules.ts
async function loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $16225997b5bec248$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href2)=>({
                    rel: "stylesheet",
                    href: href2
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = getModuleLinkHrefs(matches, manifest);
    return dedupeLinkDescriptors(descriptors, preloads);
}
function getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href2)=>({
            rel: "stylesheet",
            href: href2
        }));
}
async function prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = getRouteCssDescriptors(route);
    await Promise.all(descriptors.map(prefetchStyleLink));
}
async function prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map(prefetchStyleLink));
}
async function prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return dedupeLinkDescriptors(links.flat(1).filter(isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function getModuleLinkHrefs(matches, manifest, { includeHydrateFallback } = {}) {
    return dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify(sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var _isPreloadSupported;
function isPreloadSupported() {
    if (_isPreloadSupported !== void 0) return _isPreloadSupported;
    let el = document.createElement("link");
    _isPreloadSupported = el.relList.supports("preload");
    el = null;
    return _isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function escapeHtml(html) {
    return html.replace(ESCAPE_REGEX, (match)=>ESCAPE_LOOKUP[match]);
}
function createHtml(html) {
    return {
        __html: html
    };
}
// vendor/turbo-stream-v2/utils.ts
var HOLE = -1;
var NAN = -2;
var NEGATIVE_INFINITY = -3;
var NEGATIVE_ZERO = -4;
var NULL = -5;
var POSITIVE_INFINITY = -6;
var UNDEFINED = -7;
var TYPE_BIGINT = "B";
var TYPE_DATE = "D";
var TYPE_ERROR = "E";
var TYPE_MAP = "M";
var TYPE_NULL_OBJECT = "N";
var TYPE_PROMISE = "P";
var TYPE_REGEXP = "R";
var TYPE_SET = "S";
var TYPE_SYMBOL = "Y";
var TYPE_URL = "U";
var TYPE_PREVIOUS_RESOLVED = "Z";
var Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function flatten(input) {
    const { indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return UNDEFINED;
    if (input === null) return NULL;
    if (Number.isNaN(input)) return NAN;
    if (input === Number.POSITIVE_INFINITY) return POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    stringify.call(this, input, index);
    return index;
}
function stringify(input, index) {
    const { deferred, plugins, postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flatten.call(this, k)}":${flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? flatten.call(this, input2[i]) : HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) str[index2] = `["${TYPE_DATE}",${input2.getTime()}]`;
                        else if (input2 instanceof URL) str[index2] = `["${TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${TYPE_SET}",${[
                                ...input2
                            ].map((val)=>flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    flatten.call(this, k),
                                    flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if (isPlainObject(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === objectProtoNames;
}
// vendor/turbo-stream-v2/unflatten.ts
var globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function unflatten(parsed) {
    const { hydrated, values } = this;
    if (typeof parsed === "number") return hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return hydrate.call(this, startIndex);
}
function hydrate(index) {
    const { hydrated, values, deferred, plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case UNDEFINED:
                set(void 0);
                continue;
            case NULL:
                set(null);
                continue;
            case NAN:
                set(NaN);
                continue;
            case POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && globalObj && globalObj[errorType] ? new globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function decode(readable, options) {
    const { plugins } = options ?? {};
    const done = new Deferred2();
    const reader = readable.pipeThrough(createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins
    };
    const decoded = await decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: unflatten.call(this, line)
    };
}
async function decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function encode(input, options) {
    const { plugins, postPlugins, signal } = options ?? {};
    const encoder2 = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins,
        postPlugins,
        signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = flatten.call(encoder2, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder2.stringified.join(",")}]
`));
                lastSentIndex = encoder2.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder2.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder2.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder2.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder2.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = flatten.call(encoder2, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${TYPE_PROMISE}${deferredId}:[["${TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder2.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder2.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder2.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = flatten.call(encoder2, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${TYPE_ERROR}${deferredId}:[["${TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder2.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder2.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder2.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder2.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder2.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder2.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function createRequestInit(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/single-fetch.tsx
var SingleFetchRedirectSymbol = Symbol("SingleFetchRedirect");
var SingleFetchNoResultError = class extends Error {
};
var SINGLE_FETCH_REDIRECT_STATUS = 202;
var NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function StreamTransfer({ context, identifier, reader, textDecoder, nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done, value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ _react.createElement("script", {
        nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ _react.createElement(_react.Fragment, null, scriptTag, /* @__PURE__ */ _react.createElement("script", {
        nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ _react.createElement(_react.Fragment, null, scriptTag, /* @__PURE__ */ _react.createElement(_react.Suspense, null, /* @__PURE__ */ _react.createElement(StreamTransfer, {
        context,
        identifier: identifier + 1,
        reader,
        textDecoder,
        nonce
    })));
}
function getTurboStreamSingleFetchDataStrategy(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = getSingleFetchDataStrategyImpl(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.unstable_runClientMiddleware(dataStrategy);
}
function getSingleFetchDataStrategyImpl(getRouter, getRouteInfo, fetchAndDecode, ssr, basename) {
    return async (args)=>{
        let { request, matches, fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader, hasClientLoader } = getRouteInfo(m);
            return m.unstable_shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename);
    };
}
async function singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if (isResponse(result.result) || isRouteErrorResponse(result.result) || isDataWithResponseInit(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: data(result.result, actionStatus)
        }
    };
}
async function nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.unstable_shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>createDeferred2());
    let singleFetchDfd = createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader, hasClientLoader, hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.unstable_shouldRevalidateArgs || m.unstable_shouldRevalidateArgs.actionStatus == null || m.unstable_shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.unstable_shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.unstable_shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function stripIndexParam(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function singleFetchUrl(reqUrl, basename) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else if (basename && stripBasename(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.data`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.data`;
    return url;
}
async function fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request } = args;
    let url = singleFetchUrl(request.url, basename);
    if (request.method === "GET") {
        url = stripIndexParam(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await createRequestInit(request));
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new ErrorResponseImpl(404, "Not Found", true);
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: SINGLE_FETCH_REDIRECT_STATUS,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if (NO_BODY_STATUS_CODES.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes
            }
        };
    }
    invariant2(res.body, "No response body to decode");
    try {
        let decoded = await decodeViaTurboStream(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if (SingleFetchRedirectSymbol in typed) data2 = {
                redirect: typed[SingleFetchRedirectSymbol]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function decodeViaTurboStream(body, global2) {
    return decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new ErrorResponseImpl(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [SingleFetchRedirectSymbol]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate, reload, replace: replace2, status } = result.redirect;
        throw redirect(location, {
            status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise,
        //@ts-ignore
        resolve,
        //@ts-ignore
        reject
    };
}
var RemixErrorBoundary = class extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ _react.createElement(RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function RemixRootDefaultErrorBoundary({ error, isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ _react.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if (isRouteErrorResponse(error)) return /* @__PURE__ */ _react.createElement(BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ _react.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), ENABLE_DEV_WARNINGS ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ _react.createElement(BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp
    }, /* @__PURE__ */ _react.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ _react.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function BoundaryShell({ title, renderScripts, isOutsideRemixApp, children }) {
    let { routeModules } = useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ _react.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ _react.createElement("head", null, /* @__PURE__ */ _react.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ _react.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ _react.createElement("title", null, title)), /* @__PURE__ */ _react.createElement("body", null, /* @__PURE__ */ _react.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ _react.createElement(Scripts, null) : null)));
}
function RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ _react.createElement(BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, ENABLE_DEV_WARNINGS ? /* @__PURE__ */ _react.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ _react.createElement(RemixRootDefaultErrorBoundary, {
            error: useRouteError()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ _react.createElement(routeModule.Layout, null, /* @__PURE__ */ _react.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ _react.createElement(routeModule.Layout, null, /* @__PURE__ */ _react.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ _react.createElement(routeModule.Layout, null, /* @__PURE__ */ _react.createElement(HydrateFallback, null))
        } : {
            HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary,
        HydrateFallback
    };
}
function createServerRoutes(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function createClientRoutesWithHMRRevalidationOptOut(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", groupRoutesByParentId(manifest), needsRevalidation);
}
function preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new ErrorResponseImpl(400, "Bad Request", new Error(msg), true);
    }
}
function noActionDefinedError(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new ErrorResponseImpl(405, "Method Not Allowed", new Error(msg), true);
}
function createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...getRouteComponents(route, routeModule, isSpaMode),
                unstable_middleware: routeModule.unstable_clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request, params, context }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request,
                            params,
                            context,
                            async serverLoader () {
                                preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = shouldHydrateRouteLoader(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request, params, context }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request,
                        params,
                        context,
                        async serverAction () {
                            preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction } = await clientActionPromise;
                    invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                unstable_middleware: route.hasClientMiddleware ? async ()=>{
                    let { unstable_clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    invariant2(unstable_clientMiddleware, "No `unstable_clientMiddleware` export found");
                    return unstable_clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    if (ssr && route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        unstable_clientMiddleware: routeModule.unstable_clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function shouldHydrateRouteLoader(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var nextPaths = /* @__PURE__ */ new Set();
var discoveredPathsMaxSize = 1e3;
var discoveredPaths = /* @__PURE__ */ new Set();
var URL_LIMIT = 7680;
function isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function getPartialManifest({ sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = matchRoutes(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function getPatchRoutesOnNavigationFunction(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path, patch, signal, fetcherKey })=>{
        if (discoveredPaths.has(path)) return;
        await fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function useFogOFWarDiscovery(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    _react.useEffect(()=>{
        if (!isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!discoveredPaths.has(pathname)) nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from(nextPaths.keys()).filter((path)=>{
                if (discoveredPaths.has(path)) {
                    nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function getManifestPath(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    let url = new URL(getManifestPath(manifestPath, basename), window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > URL_LIMIT) {
        nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            if (sessionStorage.getItem(MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                console.error("Unable to discover routes due to manifest version mismatch.");
                return;
            }
            sessionStorage.setItem(MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        sessionStorage.removeItem(MANIFEST_VERSION_STORAGE_KEY);
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>addToFifoQueue(p, discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, createClientRoutes(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function addToFifoQueue(path, queue) {
    if (queue.size >= discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function useDataRouterContext2() {
    let context = _react.useContext(DataRouterContext);
    invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function useDataRouterStateContext() {
    let context = _react.useContext(DataRouterStateContext);
    invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var FrameworkContext = _react.createContext(void 0);
FrameworkContext.displayName = "FrameworkContext";
function useFrameworkContext() {
    let context = _react.useContext(FrameworkContext);
    invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = _react.useContext(FrameworkContext);
    let [maybePrefetch, setMaybePrefetch] = _react.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = _react.useState(false);
    let { onFocus, onBlur, onMouseEnter, onMouseLeave, onTouchStart } = theirElementProps;
    let ref = _react.useRef(null);
    _react.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    _react.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: composeEventHandlers(onFocus, setIntent),
            onBlur: composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function Links() {
    let { isSpaMode, manifest, routeModules, criticalCss } = useFrameworkContext();
    let { errors, matches: routerMatches } = useDataRouterStateContext();
    let matches = getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = _react.useMemo(()=>getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ _react.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ _react.createElement("link", {
        rel: "stylesheet",
        href: criticalCss.href
    }) : null, keyedLinks.map(({ key, link })=>isPageLinkDescriptor(link) ? /* @__PURE__ */ _react.createElement(PrefetchPageLinks, {
            key,
            ...link
        }) : /* @__PURE__ */ _react.createElement("link", {
            key,
            ...link
        })));
}
function PrefetchPageLinks({ page, ...dataLinkProps }) {
    let { router } = useDataRouterContext2();
    let matches = _react.useMemo(()=>matchRoutes(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ _react.createElement(PrefetchPageLinksImpl, {
        page,
        matches,
        ...dataLinkProps
    });
}
function useKeyedPrefetchLinks(matches) {
    let { manifest, routeModules } = useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = _react.useState([]);
    _react.useEffect(()=>{
        let interrupted = false;
        getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function PrefetchPageLinksImpl({ page, matches: nextMatches, ...linkProps }) {
    let location = useLocation();
    let { manifest, routeModules } = useFrameworkContext();
    let { basename } = useDataRouterContext2();
    let { loaderData, matches } = useDataRouterStateContext();
    let newMatchesForData = _react.useMemo(()=>getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = _react.useMemo(()=>getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = _react.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = singleFetchUrl(page, basename);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = _react.useMemo(()=>getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, dataHrefs.map((href2)=>/* @__PURE__ */ _react.createElement("link", {
            key: href2,
            rel: "prefetch",
            as: "fetch",
            href: href2,
            ...linkProps
        })), moduleHrefs.map((href2)=>/* @__PURE__ */ _react.createElement("link", {
            key: href2,
            rel: "modulepreload",
            href: href2,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key, link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ _react.createElement("link", {
            key,
            ...link
        })));
}
function Meta() {
    let { isSpaMode, routeModules } = useFrameworkContext();
    let { errors, matches: routerMatches, loaderData } = useDataRouterStateContext();
    let location = useLocation();
    let _matches = getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params,
            location,
            matches,
            error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName, ...rest } = metaProps;
            if (!isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ _react.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ _react.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ _react.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ _react.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ _react.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var isHydrated = false;
function Scripts(props) {
    let { manifest, serverHandoffString, isSpaMode, renderMeta, routeDiscovery, ssr } = useFrameworkContext();
    let { router, static: isStatic, staticContext } = useDataRouterContext2();
    let { matches: routerMatches } = useDataRouterStateContext();
    let enableFogOfWar = isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = getActiveMatches(routerMatches, null, isSpaMode);
    _react.useEffect(()=>{
        isHydrated = true;
    }, []);
    let initialScripts = _react.useMemo(()=>{
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule, clientLoaderModule, clientMiddlewareModule, hydrateFallbackModule, module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify(getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ _react.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let preloads = isHydrated ? [] : dedupe(manifest.entry.imports.concat(getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    return isHydrated ? null : /* @__PURE__ */ _react.createElement(_react.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ _react.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ _react.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ _react.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ _react.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if (isBrowser) window.__reactRouterVersion = "7.6.2";
} catch (e) {}
function createBrowserRouter(routes, opts) {
    return createRouter({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: createBrowserHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || parseHydrationData(),
        routes,
        mapRouteProperties,
        hydrationRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return createRouter({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || parseHydrationData(),
        routes,
        mapRouteProperties,
        hydrationRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: deserializeErrors(state.errors)
    };
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function BrowserRouter({ basename, children, window: window2 }) {
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = createBrowserHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function HashRouter({ basename, children, window: window2 }) {
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function HistoryRouter({ basename, children, history }) {
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
HistoryRouter.displayName = "unstable_HistoryRouter";
var ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var Link = _react.forwardRef(function LinkWithRef({ onClick, discover = "render", prefetch = "none", relative, reloadDocument, replace: replace2, state, target, to, preventScrollReset, viewTransition, ...rest }, forwardedRef) {
    let { basename } = _react.useContext(NavigationContext);
    let isAbsolute = typeof to === "string" && ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href2 = useHref(to, {
        relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = usePrefetchBehavior(prefetch, rest);
    let internalOnClick = useLinkClickHandler(to, {
        replace: replace2,
        state,
        target,
        preventScrollReset,
        relative,
        viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ _react.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href2,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: mergeRefs(forwardedRef, prefetchRef),
        target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ _react.createElement(_react.Fragment, null, link, /* @__PURE__ */ _react.createElement(PrefetchPageLinks, {
        page: href2
    })) : link;
});
Link.displayName = "Link";
var NavLink = _react.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, viewTransition, children, ...rest }, ref) {
    let path = useResolvedPath(to, {
        relative: rest.relative
    });
    let location = useLocation();
    let routerState = _react.useContext(DataRouterStateContext);
    let { navigator, basename } = _react.useContext(NavigationContext);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ _react.createElement(Link, {
        ...rest,
        "aria-current": ariaCurrent,
        className,
        ref,
        style,
        to,
        viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
NavLink.displayName = "NavLink";
var Form = _react.forwardRef(({ discover = "render", fetcherKey, navigate, reloadDocument, replace: replace2, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, viewTransition, ...props }, forwardedRef)=>{
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace: replace2,
            state,
            relative,
            preventScrollReset,
            viewTransition
        });
    };
    return /* @__PURE__ */ _react.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
Form.displayName = "Form";
function ScrollRestoration({ getKey, storageKey, ...props }) {
    let remixContext = _react.useContext(FrameworkContext);
    let { basename } = _react.useContext(NavigationContext);
    let location = useLocation();
    let matches = useMatches();
    useScrollRestoration({
        getKey,
        storageKey
    });
    let ssrKey = _react.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ _react.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
ScrollRestoration.displayName = "ScrollRestoration";
function getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function useDataRouterContext3(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError2(hookName));
    return ctx;
}
function useDataRouterState2(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError2(hookName));
    return state;
}
function useLinkClickHandler(to, { target, replace: replaceProp, state, preventScrollReset, relative, viewTransition } = {}) {
    let navigate = useNavigate();
    let location = useLocation();
    let path = useResolvedPath(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : createPath(location) === createPath(path);
            navigate(to, {
                replace: replace2,
                state,
                preventScrollReset,
                relative,
                viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function useSearchParams(defaultInit) {
    warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = useLocation();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = useNavigate();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var fetcherId = 0;
var getUniqueFetcherId = ()=>`__${String(++fetcherId)}__`;
function useSubmit() {
    let { router } = useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename } = _react.useContext(NavigationContext);
    let currentRouteId = useRouteId();
    return _react.useCallback(async (target, options = {})=>{
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function useFormAction(action, { relative } = {}) {
    let { basename } = _react.useContext(NavigationContext);
    let routeContext = _react.useContext(RouteContext);
    invariant(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...useResolvedPath(action ? action : ".", {
            relative
        })
    };
    let location = useLocation();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function useFetcher({ key } = {}) {
    let { router } = useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext(RouteContext);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    invariant(fetcherData, `useFetcher must be used inside a FetchersContext`);
    invariant(route, `useFetcher must be used inside a RouteContext`);
    invariant(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = _react.useId();
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = _react.useCallback(async (href2, opts)=>{
        invariant(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href2, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm2 = _react.forwardRef((props, ref)=>{
            return /* @__PURE__ */ _react.createElement(Form, {
                ...props,
                navigate: false,
                fetcherKey,
                ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || IDLE_FETCHER;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>({
            Form: FetcherForm,
            submit,
            load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function useFetchers() {
    let state = useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key
        }));
}
var SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var savedScrollPositions = {};
function getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: stripBasename(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function useScrollRestoration({ getKey, storageKey } = {}) {
    let { router } = useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename } = _react.useContext(NavigationContext);
    let location = useLocation();
    let matches = useMatches();
    let navigation = useNavigation();
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = getScrollRestorationKey(location, matches, basename, getKey);
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {
            warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        _react.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        _react.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePrompt({ when, message }) {
    let blocker = useBlocker(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function useViewTransitionState(to, opts = {}) {
    let vtContext = _react.useContext(ViewTransitionContext);
    invariant(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename } = useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = useResolvedPath(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return matchPath(path.pathname, nextPath) != null || matchPath(path.pathname, currentPath) != null;
}
function StaticRouter({ basename, children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = getStatelessNavigator();
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function StaticRouterProvider({ context, router, hydrate: hydrate2 = true, nonce }) {
    invariant(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router,
        navigator: getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: serializeErrors(context.errors)
        };
        let json = htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state } = dataRouterContext.router;
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ _react.createElement(FetchersContext.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ _react.createElement(ViewTransitionContext.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ _react.createElement(Router, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ _react.createElement(DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state
    })))))), hydrateScript ? /* @__PURE__ */ _react.createElement("script", {
        suppressHydrationWarning: true,
        nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function DataRoutes2({ routes, future, state }) {
    return useRoutesImpl(routes, void 0, state, future);
}
function serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (isRouteErrorResponse(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function getStatelessNavigator() {
    return {
        createHref,
        encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function createStaticHandler2(routes, opts) {
    return createStaticHandler(routes, {
        ...opts,
        mapRouteProperties
    });
}
function createStaticRouter(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                unstable_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: IDLE_NAVIGATION,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref,
        encodeLocation,
        getFetcher () {
            return IDLE_FETCHER;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return IDLE_BLOCKER;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function createHref(to) {
    return typeof to === "string" ? to : createPath(to);
}
function encodeLocation(to) {
    let href2 = typeof to === "string" ? to : createPath(to);
    href2 = href2.replace(/ $/, "%20");
    let encoded = ABSOLUTE_URL_REGEX3.test(href2) ? new URL(href2) : new URL(href2, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function htmlEscape(str) {
    return str.replace(ESCAPE_REGEX2, (match)=>ESCAPE_LOOKUP2[match]);
}
function ServerRouter({ context, url, nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest, routeModules, criticalCss, serverHandoffString } = context;
    let routes = createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && shouldHydrateRouteLoader(routeId, route.clientLoader, manifestRoute.hasLoader, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = createStaticRouter(routes, context.staticHandlerContext);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement(FrameworkContext.Provider, {
        value: {
            manifest,
            routeModules,
            criticalCss,
            serverHandoffString,
            future: context.future,
            ssr: context.ssr,
            isSpaMode: context.isSpaMode,
            routeDiscovery: context.routeDiscovery,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ _react.createElement(RemixErrorBoundary, {
        location: router.state.location
    }, /* @__PURE__ */ _react.createElement(StaticRouterProvider, {
        router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ _react.createElement(_react.Suspense, null, /* @__PURE__ */ _react.createElement(StreamTransfer, {
        context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce
    })) : null);
}
function createRoutesStub(routes, unstable_getContext) {
    return function RoutesTestStub({ initialEntries, initialIndex, hydrationData, future }) {
        let routerRef = _react.useRef();
        let remixContextRef = _react.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {
                    unstable_subResourceIntegrity: future?.unstable_subResourceIntegrity === true,
                    unstable_middleware: future?.unstable_middleware === true
                },
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                ssr: false,
                isSpaMode: false,
                routeDiscovery: {
                    mode: "lazy",
                    manifestPath: "/__manifest"
                }
            };
            let patched = processRoutes(// @ts-expect-error `StubRouteObject` is stricter about `loader`/`action`
            // types compared to `AgnosticRouteObject`
            convertRoutesToDataRoutes(routes, (r)=>r), remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = createMemoryRouter(patched, {
                unstable_getContext,
                initialEntries,
                initialIndex,
                hydrationData
            });
        }
        return /* @__PURE__ */ _react.createElement(FrameworkContext.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ _react.createElement(RouterProvider, {
            router: routerRef.current
        }));
    };
}
function processRoutes(routes, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component ? withComponentProps(route.Component) : void 0,
            HydrateFallback: route.HydrateFallback ? withHydrateFallbackProps(route.HydrateFallback) : void 0,
            ErrorBoundary: route.ErrorBoundary ? withErrorBoundaryProps(route.ErrorBoundary) : void 0,
            action: route.action,
            loader: route.loader,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should be stubbing loader/action/middleware,
            // not trying to re-implement the full loader/clientLoader/SSR/hydration
            // flow. That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasClientMiddleware: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            // any need for these?
            module: "build/stub-path-to-module.js",
            clientActionModule: void 0,
            clientLoaderModule: void 0,
            clientMiddlewareModule: void 0,
            hydrateFallbackModule: void 0
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: newRoute.Component || Outlet,
            ErrorBoundary: newRoute.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = processRoutes(route.children, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var encoder = /* @__PURE__ */ new TextEncoder();
var sign = async (value, secret)=>{
    let data2 = encoder.encode(value);
    let key = await createKey2(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = encoder.encode(value);
    let key = await createKey2(secret, [
        "verify"
    ]);
    let signature = byteStringToUint8Array(atob(hash));
    let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
    return valid ? value : false;
};
var createKey2 = async (secret, usages)=>crypto.subtle.importKey("raw", encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var createCookie = (name, cookieOptions = {})=>{
    let { secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, _cookie.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, _cookie.serialize)(name, value === "" ? "" : await encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var isCookie = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function encodeCookieValue(value, secrets) {
    let encoded = encodeData(value);
    if (secrets.length > 0) encoded = await sign(encoded, secrets[0]);
    return encoded;
}
async function decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await unsign(value, secret);
            if (unsignedValue !== false) return decodeData(unsignedValue);
        }
        return null;
    }
    return decodeData(value);
}
function encodeData(value) {
    return btoa(myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent(myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + hex(code, 2);
            else result += "%u" + hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function warnOnceAboutExpiresCookie(name, expires) {
    warnOnce(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo2, routeId)=>{
        let route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var ServerMode = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})(ServerMode || {});
function isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: sanitizeError(error, serverMode)
        });
    }, {});
}
function serializeError(error, serverMode) {
    let sanitized = sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (isRouteErrorResponse(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function matchServerRoutes(routes, pathname, basename) {
    let matches = matchRoutes(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function callRouteHandler(handler, args) {
    let result = await handler({
        request: stripRoutesParam(stripIndexParam2(args.request)),
        params: args.params,
        context: args.context
    });
    if (isDataWithResponseInit(result) && result.init && result.init.status && isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
    return result;
}
function stripIndexParam2(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/dev.ts
var globalDevServerHooksKey = "__reactRouterDevServerHooks";
function setDevServerHooks(devServerHooks) {
    globalThis[globalDevServerHooksKey] = devServerHooks;
}
function getDevServerHooks() {
    return globalThis[globalDevServerHooksKey];
}
function getBuildTimeHeader(request, headerName) {
    var e;
    return null;
}
// lib/server-runtime/routes.ts
function groupRoutesByParentId2(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function createRoutes(manifest, parentId = "", routesByParentId = groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: createRoutes(manifest, route.id, routesByParentId)
        }));
}
function createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            unstable_middleware: route.module.unstable_middleware,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                let preRenderedData = getBuildTimeHeader(args.request, "X-React-Router-Prerender-Data");
                if (preRenderedData != null) {
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    invariant3(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await decodeViaTurboStream(stream, global);
                    let data2 = decoded.value;
                    if (data2 && SingleFetchRedirectSymbol in data2) {
                        let result = data2[SingleFetchRedirectSymbol];
                        let init = {
                            status: result.status
                        };
                        if (result.reload) throw redirectDocument(result.redirect, init);
                        else if (result.replace) throw replace(result.redirect, init);
                        else throw redirect(result.redirect, init);
                    } else {
                        invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                        let result = data2[route.id];
                        invariant3("data" in result, "Unable to process prerendered data");
                        return result.data;
                    }
                }
                let val = await callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/markup.ts
var ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function escapeHtml2(html) {
    return html.replace(ESCAPE_REGEX3, (match)=>ESCAPE_LOOKUP3[match]);
}
// lib/server-runtime/serverHandoff.ts
function createServerHandoffString(serverHandoff) {
    return escapeHtml2(JSON.stringify(serverHandoff));
}
function getDocumentHeaders(build, context) {
    return getDocumentHeadersImpl(context, (m)=>{
        let route = build.routes[m.route.id];
        invariant3(route, `Route with id "${m.route.id}" not found in build`);
        return route.module.headers;
    });
}
function getDocumentHeadersImpl(context, getRouteHeadersFn) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders, actionData, loaderHeaders, loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id } = match.route;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        let headersFn = getRouteHeadersFn(match);
        if (headersFn == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) prependCookies(errorHeaders, headers2);
            prependCookies(actionHeaders, headers2);
            prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(typeof headersFn === "function" ? headersFn({
            loaderHeaders,
            parentHeaders,
            actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : headersFn);
        if (includeErrorCookies) prependCookies(errorHeaders, headers);
        prependCookies(actionHeaders, headers);
        prependCookies(loaderHeaders, headers);
        prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, _setCookieParser.splitCookiesString)(parentSetCookieString);
        let childCookies = new Set(childHeaders.getSetCookie());
        cookies.forEach((cookie)=>{
            if (!childCookies.has(cookie)) childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var SERVER_NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    ...NO_BODY_STATUS_CODES,
    304
]);
async function singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let respond2 = function(context) {
            let headers = getDocumentHeaders(build, context);
            if (isRedirectStatusCode(context.statusCode) && headers.has("Location")) return generateSingleFetchResponse(request, build, serverMode, {
                result: getSingleFetchRedirect(context.statusCode, headers, build.basename),
                headers,
                status: SINGLE_FETCH_REDIRECT_STATUS
            });
            if (context.errors) {
                Object.values(context.errors).forEach((err)=>{
                    if (!isRouteErrorResponse(err) || err.error) handleError(err);
                });
                context.errors = sanitizeErrors(context.errors, serverMode);
            }
            let singleFetchResult;
            if (context.errors) singleFetchResult = {
                error: Object.values(context.errors)[0]
            };
            else singleFetchResult = {
                data: Object.values(context.actionData || {})[0]
            };
            return generateSingleFetchResponse(request, build, serverMode, {
                result: singleFetchResult,
                headers,
                status: context.statusCode
            });
        };
        var respond = respond2;
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            skipRevalidation: true,
            unstable_respond: respond2
        });
        if (!isResponse(result)) result = respond2(result);
        if (isRedirectResponse(result)) return generateSingleFetchResponse(request, build, serverMode, {
            result: getSingleFetchRedirect(result.status, result.headers, build.basename),
            headers: result.headers,
            status: SINGLE_FETCH_REDIRECT_STATUS
        });
        return result;
    } catch (error) {
        handleError(error);
        return generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error
            },
            headers: new Headers(),
            status: 500
        });
    }
}
async function singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let respond2 = function(context) {
            let headers = getDocumentHeaders(build, context);
            if (isRedirectStatusCode(context.statusCode) && headers.has("Location")) return generateSingleFetchResponse(request, build, serverMode, {
                result: {
                    [SingleFetchRedirectSymbol]: getSingleFetchRedirect(context.statusCode, headers, build.basename)
                },
                headers,
                status: SINGLE_FETCH_REDIRECT_STATUS
            });
            if (context.errors) {
                Object.values(context.errors).forEach((err)=>{
                    if (!isRouteErrorResponse(err) || err.error) handleError(err);
                });
                context.errors = sanitizeErrors(context.errors, serverMode);
            }
            let results = {};
            let loadedMatches = new Set(context.matches.filter((m)=>loadRouteIds ? loadRouteIds.has(m.route.id) : m.route.loader != null).map((m)=>m.route.id));
            if (context.errors) for (let [id, error] of Object.entries(context.errors))results[id] = {
                error
            };
            for (let [id, data2] of Object.entries(context.loaderData))if (!(id in results) && loadedMatches.has(id)) results[id] = {
                data: data2
            };
            return generateSingleFetchResponse(request, build, serverMode, {
                result: results,
                headers,
                status: context.statusCode
            });
        };
        var respond = respond2;
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let routesParam = new URL(request.url).searchParams.get("_routes");
        let loadRouteIds = routesParam ? new Set(routesParam.split(",")) : null;
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            filterMatchesToLoad: (m)=>!loadRouteIds || loadRouteIds.has(m.route.id),
            skipLoaderErrorBubbling: true,
            unstable_respond: respond2
        });
        if (!isResponse(result)) result = respond2(result);
        if (isRedirectResponse(result)) return generateSingleFetchResponse(request, build, serverMode, {
            result: {
                [SingleFetchRedirectSymbol]: getSingleFetchRedirect(result.status, result.headers, build.basename)
            },
            headers: result.headers,
            status: SINGLE_FETCH_REDIRECT_STATUS
        });
        return result;
    } catch (error) {
        handleError(error);
        return generateSingleFetchResponse(request, build, serverMode, {
            result: {
                root: {
                    error
                }
            },
            headers: new Headers(),
            status: 500
        });
    }
}
function generateSingleFetchResponse(request, build, serverMode, { result, headers, status }) {
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if (SERVER_NO_BODY_STATUS_CODES.has(status)) return new Response(null, {
        status,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    return new Response(encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
function getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return encode(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name, message, stack } = serverMode === "production" /* Production */  ? sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof ErrorResponseImpl) {
                    let { data: data3, status, statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && SingleFetchRedirectSymbol in value) return [
                    "SingleFetchRedirect",
                    value[SingleFetchRedirectSymbol]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function derive(build, mode) {
    let routes = createRoutes(build.routes);
    let dataRoutes = createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    let errorHandler = build.entry.module.handleError || ((error, { request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        isRouteErrorResponse(error) && error.error ? error.error : error);
    });
    return {
        routes,
        dataRoutes,
        serverMode,
        staticHandler,
        errorHandler
    };
}
var createRequestHandler = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    return async function requestHandler(request, initialContext) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
            let derived = derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        }
        let params = {};
        let loadContext;
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params,
                request
            });
        };
        if (_build.future.unstable_middleware) {
            if (initialContext == null) loadContext = new unstable_RouterContextProvider();
            else try {
                loadContext = new unstable_RouterContextProvider(initialContext);
            } catch (e) {
                let error = new Error(`Unable to create initial \`unstable_RouterContextProvider\` instance. Please confirm you are returning an instance of \`Map<unstable_routerContext, unknown>\` from your \`getLoadContext\` function.

Error: ${e instanceof Error ? e.toString() : e}`);
                handleError(error);
                return returnLastResortErrorResponse(error, serverMode);
            }
        } else loadContext = initialContext || {};
        let url = new URL(request.url);
        let normalizedBasename = _build.basename || "/";
        let normalizedPath = url.pathname;
        if (stripBasename(normalizedPath, normalizedBasename) === "/_root.data") normalizedPath = normalizedBasename;
        else if (normalizedPath.endsWith(".data")) normalizedPath = normalizedPath.replace(/\.data$/, "");
        if (stripBasename(normalizedPath, normalizedBasename) !== "/" && normalizedPath.endsWith("/")) normalizedPath = normalizedPath.slice(0, -1);
        let isSpaMode = getBuildTimeHeader(request, "X-React-Router-SPA-Mode") === "yes";
        if (!_build.ssr) {
            if (_build.prerender.length === 0) isSpaMode = true;
            else if (!_build.prerender.includes(normalizedPath) && !_build.prerender.includes(normalizedPath + "/")) {
                if (url.pathname.endsWith(".data")) {
                    errorHandler(new ErrorResponseImpl(404, "Not Found", `Refusing to SSR the path \`${normalizedPath}\` because \`ssr:false\` is set and the path is not included in the \`prerender\` config, so in production the path will be a 404.`), {
                        context: loadContext,
                        params,
                        request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                } else isSpaMode = true;
            }
        }
        let manifestUrl = getManifestPath(_build.routeDiscovery.manifestPath, normalizedBasename);
        if (url.pathname === manifestUrl) try {
            let res = await handleManifestRequest(_build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = matchServerRoutes(routes, normalizedPath, _build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = normalizedPath;
            let singleFetchMatches = matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
            response = await handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError);
            if (_build.entry.module.handleDataRequest) {
                response = await _build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request
                });
                if (isRedirectResponse(response)) {
                    let result = getSingleFetchRedirect(response.status, response.headers, _build.basename);
                    if (request.method === "GET") result = {
                        [SingleFetchRedirectSymbol]: result
                    };
                    let headers = new Headers(response.headers);
                    headers.set("Content-Type", "text/x-script");
                    return new Response(encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                        status: SINGLE_FETCH_REDIRECT_STATUS,
                        headers
                    });
                }
            }
        } else if (!isSpaMode && matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await handleResourceRequest(serverMode, _build, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let { pathname } = url;
            let criticalCss = void 0;
            if (_build.unstable_getCriticalCss) criticalCss = await _build.unstable_getCriticalCss({
                pathname
            });
            else if (mode === "development" /* Development */  && getDevServerHooks()?.getCriticalCss) criticalCss = await getDevServerHooks()?.getCriticalCss?.(pathname);
            response = await handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
};
async function handleManifestRequest(build, routes, url) {
    if (build.assets.version !== url.searchParams.get("version")) return new Response(null, {
        status: 204,
        headers: {
            "X-Remix-Reload-Document": "true"
        }
    });
    let patches = {};
    if (url.searchParams.has("p")) {
        let paths = /* @__PURE__ */ new Set();
        url.searchParams.getAll("p").forEach((path)=>{
            if (!path.startsWith("/")) path = `/${path}`;
            let segments = path.split("/").slice(1);
            segments.forEach((_, i)=>{
                let partialPath = segments.slice(0, i + 1).join("/");
                paths.add(`/${partialPath}`);
            });
        });
        for (let path of paths){
            let matches = matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let response = request.method !== "GET" ? await singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    return response;
}
async function handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss) {
    try {
        let response = await staticHandler.query(request, {
            requestContext: loadContext,
            unstable_respond: build.future.unstable_middleware ? (ctx)=>renderHtml(ctx, isSpaMode) : void 0
        });
        return isResponse(response) ? response : renderHtml(response, isSpaMode);
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    async function renderHtml(context, isSpaMode2) {
        if (isResponse(context)) return context;
        let headers = getDocumentHeaders(build, context);
        if (SERVER_NO_BODY_STATUS_CODES.has(context.statusCode)) return new Response(null, {
            status: context.statusCode,
            headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!isRouteErrorResponse(err) || err.error) handleError(err);
            });
            context.errors = sanitizeErrors(context.errors, serverMode);
        }
        let state = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: serializeErrors2(context.errors, serverMode)
        };
        let baseServerHandoff = {
            basename: build.basename,
            future: build.future,
            routeDiscovery: build.routeDiscovery,
            ssr: build.ssr,
            isSpaMode: isSpaMode2
        };
        let entryContext = {
            manifest: build.assets,
            routeModules: createEntryRouteModules(build.routes),
            staticHandlerContext: context,
            criticalCss,
            serverHandoffString: createServerHandoffString({
                ...baseServerHandoff,
                criticalCss
            }),
            serverHandoffStream: encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {},
            future: build.future,
            ssr: build.ssr,
            routeDiscovery: build.routeDiscovery,
            isSpaMode: isSpaMode2,
            serializeError: (err)=>serializeError(err, serverMode)
        };
        let handleDocumentRequestFunction = build.entry.module.default;
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error) {
            handleError(error);
            let errorForSecondRender = error;
            if (isResponse(error)) try {
                let data2 = await unwrapResponse(error);
                errorForSecondRender = new ErrorResponseImpl(error.status, error.statusText, data2);
            } catch (e) {}
            context = getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
            if (context.errors) context.errors = sanitizeErrors(context.errors, serverMode);
            let state2 = {
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: serializeErrors2(context.errors, serverMode)
            };
            entryContext = {
                ...entryContext,
                staticHandlerContext: context,
                serverHandoffString: createServerHandoffString(baseServerHandoff),
                serverHandoffStream: encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
                renderMeta: {}
            };
            try {
                return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
            } catch (error2) {
                handleError(error2);
                return returnLastResortErrorResponse(error2, serverMode);
            }
        }
    }
}
async function handleResourceRequest(serverMode, build, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let response = await staticHandler.queryRoute(request, {
            routeId,
            requestContext: loadContext,
            unstable_respond: build.future.unstable_middleware ? (ctx)=>ctx : void 0
        });
        if (isResponse(response)) return response;
        if (typeof response === "string") return new Response(response);
        return Response.json(response);
    } catch (error) {
        if (isResponse(error)) {
            error.headers.set("X-Remix-Catch", "yes");
            return error;
        }
        if (isRouteErrorResponse(error)) {
            if (error) handleError(error);
            return errorResponseToJson(error, serverMode);
        }
        if (error instanceof Error && error.message === "Expected a response from queryRoute") {
            let newError = new Error("Expected a Response to be returned from resource route handler");
            handleError(newError);
            return returnLastResortErrorResponse(newError, serverMode);
        }
        handleError(error);
        return returnLastResortErrorResponse(error, serverMode);
    }
}
function errorResponseToJson(errorResponse, serverMode) {
    return Response.json(serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function flash(name) {
    return `__flash_${name}__`;
}
var createSession = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has(flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set(flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var isSession = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function createSessionStorage({ cookie: cookieArg, createData, readData, updateData, deleteData }) {
    let cookie = isCookie(cookieArg) ? cookieArg : createCookie(cookieArg?.name || "__session", cookieArg);
    warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return createSession(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function warnOnceAboutSigningSessionCookie(cookie) {
    warnOnce(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://reactrouter.com/explanation/sessions-and-cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function createCookieSessionStorage({ cookie: cookieArg } = {}) {
    let cookie = isCookie(cookieArg) ? cookieArg : createCookie(cookieArg?.name || "__session", cookieArg);
    warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return createSession(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function createMemorySessionStorage({ cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return createSessionStorage({
        cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/href.ts
function href(path, ...args) {
    let params = args[0];
    return path.split("/").map((segment)=>{
        if (segment === "*") return params ? params["*"] : void 0;
        const match = segment.match(/^:([\w-]+)(\?)?/);
        if (!match) return segment;
        const param = match[1];
        const value = params ? params[param] : void 0;
        const isRequired = match[2] === void 0;
        if (isRequired && value === void 0) throw Error(`Path '${path}' requires param '${param}' but it was not provided`);
        return value;
    }).filter((segment)=>segment !== void 0).join("/");
}
// lib/dom/ssr/errors.ts
function deserializeErrors2(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/dom/ssr/hydration.tsx
function getHydrationData(state, routes, getRouteInfo, location, basename, isSpaMode) {
    let hydrationData = {
        ...state,
        loaderData: {
            ...state.loaderData
        }
    };
    let initialMatches = matchRoutes(routes, location, basename);
    if (initialMatches) for (let match of initialMatches){
        let routeId = match.route.id;
        let routeInfo = getRouteInfo(routeId);
        if (shouldHydrateRouteLoader(routeId, routeInfo.clientLoader, routeInfo.hasLoader, isSpaMode) && (routeInfo.hasHydrateFallback || !routeInfo.hasLoader)) delete hydrationData.loaderData[routeId];
        else if (!routeInfo.hasLoader) hydrationData.loaderData[routeId] = null;
    }
    return hydrationData;
}

},{"react":"bmhQu","cookie":"dFs6L","set-cookie-parser":"ggtek","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dFs6L":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parse = parse;
exports.serialize = serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const __toString = Object.prototype.toString;
const NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function parse(str, options) {
    const obj = new NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = startIndex(str, index, eqIdx);
        const keyEndIdx = endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function isDate(val) {
    return __toString.call(val) === "[object Date]";
}

},{}],"ggtek":[function(require,module,exports,__globalThis) {
"use strict";
var defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter(isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, defaultParseOptions, options) : defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else cookie[key] = value;
    });
    return cookie;
}
function parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function parse(input, options) {
    options = options ? Object.assign({}, defaultParseOptions, options) : defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter(isNonEmptyString).map(function(str) {
        return parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter(isNonEmptyString).reduce(function(cookies, str) {
            var cookie = parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;

},{}],"5keeC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _user = require("../store/slice/user");
var _signin = require("../utils/signin");
var _auth = require("firebase/auth");
var _firebase = require("../config/firebase");
var _feature = require("../store/slice/feature");
var _constants = require("../utils/constants");
var _mobileHeader = require("./MobileHeader");
var _mobileHeaderDefault = parcelHelpers.interopDefault(_mobileHeader);
const Header = ()=>{
    const [showMenu, setShowMenu] = (0, _react.useState)(false);
    const dispatchAction = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouter.useNavigate)();
    const user = (0, _reactRedux.useSelector)((store)=>store.user);
    const feature = (0, _reactRedux.useSelector)((store)=>store.feature);
    const handleGptClick = ()=>{
        dispatchAction((0, _feature.toggleGpt)());
    };
    (0, _react.useEffect)(()=>{
        const unSubscribe = (0, _auth.onAuthStateChanged)((0, _firebase.auth), (user)=>{
            if (user) {
                dispatchAction((0, _user.addUser)({
                    accessToken: user?.stsTokenManager?.accessToken,
                    refreshToken: user?.stsTokenManager?.refreshToken,
                    displayName: user?.displayName,
                    email: user?.email,
                    uid: user?.uid
                }));
                navigate("/browse");
            } else {
                dispatchAction((0, _user.removeUser)());
                window.location.pathname == "/signup" ? navigate("/signup") : navigate("/");
            }
        });
        return ()=>unSubscribe();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex md:hidden",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileHeaderDefault.default), {
                    feature: feature,
                    dispatchAction: dispatchAction,
                    setLanguage: (0, _feature.setLanguage),
                    language: (0, _constants.language),
                    handleGptClick: handleGptClick,
                    setShowMenu: setShowMenu,
                    showMenu: showMenu,
                    signOutUser: (0, _signin.signOutUser),
                    user: user
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " hidden md:flex  absolute w-full sm:px-8  py-5 bg-gradient-to-b from-10%  from-black z-20 justify-between   ",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex md:w-fit w-screen justify-center md:justify-normal",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: "https://help.nflxext.com/helpcenter/OneTrust/oneTrust_production/consent/87b6a5c0-0104-4e96-a291-092c11350111/01938dc4-59b3-7bbc-b635-c4131030e85f/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png",
                            alt: "",
                            className: "md:w-36 sm:w-28 w-28 "
                        })
                    }),
                    user.accesstoken && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex space-x-6 align-middle items-center",
                        children: [
                            feature.gptSearch && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                                    name: "",
                                    id: "",
                                    className: "text-white py-2 rounded-md bg-transparent",
                                    defaultValue: feature?.language,
                                    onChange: (e)=>dispatchAction((0, _feature.setLanguage)(e.target.value)),
                                    children: Object.keys((0, _constants.language)).map((i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                            className: "text-black bg-transparent",
                                            value: i,
                                            children: i
                                        }, i))
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "cursor-pointer py-2 px-4 rounded-lg bg-gradient-to-bl from-blue-900 to-red-500 text-white hover:scale-105 duration-300  shadow-md shadow-red-500/50 ",
                                    onClick: ()=>handleGptClick(),
                                    children: feature.gptSearch ? "Homepage" : "AI Search"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "relative flex items-center",
                                onMouseEnter: ()=>setShowMenu(true),
                                onMouseLeave: ()=>setShowMenu(false),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: "https://occ-0-2483-3647.1.nflxso.net/dnm/api/v6/vN7bi_My87NPKvsBoib006Llxzg/AAAABTfUlmnFRKf_OEUhru2aqso39FKxONTd5Dt_sWnNj5wAg4bbMBZ8sgZupTfnB9IQ8tmWcrzRiyZsCp1bLKb_n7VrnTw3_Ovw7Q.png?r=bd7",
                                        alt: "User",
                                        className: "md:w-12 md:h-12 sm:w-8 sm:h-8 w-6 h-6  cursor-pointer duration-300 hover:scale-105"
                                    }),
                                    showMenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "absolute top-[6%] right-0 bg-gray-800 text-white rounded-md opacity-90 z-50 w-36 ",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: (0, _signin.signOutUser),
                                            className: "hover:cursor-pointer block w-full text-left px-4 py-2 hover:bg-gray-800",
                                            children: "Sign Out"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = Header;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-redux":"aRDHF","react-router":"6qXj4","../store/slice/user":"4kGyY","../utils/signin":"7HPJs","firebase/auth":"dZ6yw","../config/firebase":"cmjIE","../store/slice/feature":"Io6av","../utils/constants":"fZCF6","./MobileHeader":"eTDOq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4kGyY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUser", ()=>addUser);
parcelHelpers.export(exports, "removeUser", ()=>removeUser);
var _toolkit = require("@reduxjs/toolkit");
const userSlice = (0, _toolkit.createSlice)({
    name: "user",
    initialState: {
        accesstoken: "",
        refreshtoken: "",
        displayName: "",
        email: "",
        uid: ""
    },
    reducers: {
        addUser: (state, action)=>{
            const { accessToken, refreshToken, displayName, email, uid } = action.payload;
            state.accesstoken = accessToken;
            state.refreshtoken = refreshToken;
            state.displayName = displayName;
            state.email = email;
            state.uid = uid;
        },
        removeUser: (state)=>{
            state.accesstoken = "";
            state.refreshtoken = "";
            state.displayName = "";
            state.uid = "";
            state.email = "";
        }
    }
});
const { addUser, removeUser } = userSlice.actions;
exports.default = userSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7hE98":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReducerType", ()=>ReducerType);
parcelHelpers.export(exports, "SHOULD_AUTOBATCH", ()=>SHOULD_AUTOBATCH);
parcelHelpers.export(exports, "TaskAbortError", ()=>TaskAbortError);
parcelHelpers.export(exports, "Tuple", ()=>Tuple);
parcelHelpers.export(exports, "addListener", ()=>addListener);
parcelHelpers.export(exports, "asyncThunkCreator", ()=>asyncThunkCreator);
parcelHelpers.export(exports, "autoBatchEnhancer", ()=>autoBatchEnhancer);
parcelHelpers.export(exports, "buildCreateSlice", ()=>buildCreateSlice);
parcelHelpers.export(exports, "clearAllListeners", ()=>clearAllListeners);
parcelHelpers.export(exports, "combineSlices", ()=>combineSlices);
parcelHelpers.export(exports, "configureStore", ()=>configureStore);
parcelHelpers.export(exports, "createAction", ()=>createAction);
parcelHelpers.export(exports, "createActionCreatorInvariantMiddleware", ()=>createActionCreatorInvariantMiddleware);
parcelHelpers.export(exports, "createAsyncThunk", ()=>createAsyncThunk);
parcelHelpers.export(exports, "createDraftSafeSelector", ()=>createDraftSafeSelector);
parcelHelpers.export(exports, "createDraftSafeSelectorCreator", ()=>createDraftSafeSelectorCreator);
parcelHelpers.export(exports, "createDynamicMiddleware", ()=>createDynamicMiddleware);
parcelHelpers.export(exports, "createEntityAdapter", ()=>createEntityAdapter);
parcelHelpers.export(exports, "createImmutableStateInvariantMiddleware", ()=>createImmutableStateInvariantMiddleware);
parcelHelpers.export(exports, "createListenerMiddleware", ()=>createListenerMiddleware);
parcelHelpers.export(exports, "createNextState", ()=>(0, _immer.produce));
parcelHelpers.export(exports, "createReducer", ()=>createReducer);
parcelHelpers.export(exports, "createSelector", ()=>(0, _reselect.createSelector));
parcelHelpers.export(exports, "createSelectorCreator", ()=>(0, _reselect.createSelectorCreator));
parcelHelpers.export(exports, "createSerializableStateInvariantMiddleware", ()=>createSerializableStateInvariantMiddleware);
parcelHelpers.export(exports, "createSlice", ()=>createSlice);
parcelHelpers.export(exports, "current", ()=>(0, _immer.current));
parcelHelpers.export(exports, "findNonSerializableValue", ()=>findNonSerializableValue);
parcelHelpers.export(exports, "formatProdErrorMessage", ()=>formatProdErrorMessage);
parcelHelpers.export(exports, "freeze", ()=>(0, _immer.freeze));
parcelHelpers.export(exports, "isActionCreator", ()=>isActionCreator);
parcelHelpers.export(exports, "isAllOf", ()=>isAllOf);
parcelHelpers.export(exports, "isAnyOf", ()=>isAnyOf);
parcelHelpers.export(exports, "isAsyncThunkAction", ()=>isAsyncThunkAction);
parcelHelpers.export(exports, "isDraft", ()=>(0, _immer.isDraft));
parcelHelpers.export(exports, "isFluxStandardAction", ()=>isFSA);
parcelHelpers.export(exports, "isFulfilled", ()=>isFulfilled);
parcelHelpers.export(exports, "isImmutableDefault", ()=>isImmutableDefault);
parcelHelpers.export(exports, "isPending", ()=>isPending);
parcelHelpers.export(exports, "isPlain", ()=>isPlain);
parcelHelpers.export(exports, "isRejected", ()=>isRejected);
parcelHelpers.export(exports, "isRejectedWithValue", ()=>isRejectedWithValue);
parcelHelpers.export(exports, "lruMemoize", ()=>(0, _reselect.lruMemoize));
parcelHelpers.export(exports, "miniSerializeError", ()=>miniSerializeError);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "original", ()=>(0, _immer.original));
parcelHelpers.export(exports, "prepareAutoBatched", ()=>prepareAutoBatched);
parcelHelpers.export(exports, "removeListener", ()=>removeListener);
parcelHelpers.export(exports, "unwrapResult", ()=>unwrapResult);
parcelHelpers.export(exports, "weakMapMemoize", ()=>(0, _reselect.weakMapMemoize));
// src/index.ts
var _redux = require("redux");
parcelHelpers.exportAll(_redux, exports);
var _immer = require("immer");
var _reselect = require("reselect");
// src/getDefaultMiddleware.ts
var _reduxThunk = require("redux-thunk");
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var __publicField = (obj, key, value)=>__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var createDraftSafeSelectorCreator = (...args)=>{
    const createSelector2 = (0, _reselect.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var createDraftSafeSelector = /* @__PURE__ */ createDraftSafeSelectorCreator((0, _reselect.weakMapMemoize));
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, _redux.compose;
    return (0, _redux.compose).apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error(formatProdErrorMessage(0));
            return __spreadValues(__spreadValues({
                type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, _redux.isAction)(action) && action.type === type;
    return actionCreator;
}
function isActionCreator(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    hasMatchFunction(action);
}
function isFSA(action) {
    return (0, _redux.isAction)(action) && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function createActionCreatorInvariantMiddleware(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var Tuple = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function freezeDraftable(val) {
    return (0, _immer.isDraftable)(val) ? (0, _immer.produce)(val, ()=>{}) : val;
}
function getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function createImmutableStateInvariantMiddleware(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function isPlain(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, _redux.isPlainObject)(val);
}
function findNonSerializableValue(value, path = "", isSerializable = isPlain, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && isNestedFrozen(value)) cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
var buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk = true, immutableCheck = true, serializableCheck = true, actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new Tuple();
        if (thunk) {
            if (isBoolean(thunk)) middlewareArray.push((0, _reduxThunk.thunk));
            else middlewareArray.push((0, _reduxThunk.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = ()=>(payload)=>({
            payload,
            meta: {
                [SHOULD_AUTOBATCH]: true
            }
        });
var createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var autoBatchEnhancer = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch = true } = options != null ? options : {};
        let enhancerArray = new Tuple(middlewareEnhancer);
        if (autoBatch) enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function configureStore(options) {
    const getDefaultMiddleware = buildGetDefaultMiddleware();
    const { reducer, middleware, devTools = true, duplicateMiddlewareCheck = true, preloadedState, enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, _redux.isPlainObject)(reducer)) rootReducer = (0, _redux.combineReducers)(reducer);
    else throw new Error(formatProdErrorMessage(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, _redux.compose);
    if (devTools) finalCompose = composeWithDevTools(__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, _redux.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, _redux.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error(formatProdErrorMessage(28));
            if (type in actionsMap) throw new Error(formatProdErrorMessage(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher,
                reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if (isStateFunction(initialState)) getInitialState = ()=>freezeDraftable(initialState());
    else {
        const frozenInitialState = freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, _immer.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, _immer.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, _immer.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var matches = (matcher, action)=>{
    if (hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function isAnyOf(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>matches(matcher, action));
    };
}
function isAllOf(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>matches(matcher, action));
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isPending()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function isRejected(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isRejected()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function isRejectedWithValue(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return isAllOf(isRejected(...asyncThunks), hasFlag);
    if (!isAsyncThunkArray(asyncThunks)) return isRejectedWithValue()(asyncThunks[0]);
    return isAllOf(isRejected(...asyncThunks), hasFlag);
}
function isFulfilled(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isFulfilled()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function isAsyncThunkAction(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isAsyncThunkAction()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ __publicField(this, "_type");
    }
};
var FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ __publicField(this, "_type");
    }
};
var miniSerializeError = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var externalAbortMessage = "External signal was aborted";
var createAsyncThunk = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = createAction(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload,
                error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort(externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort(externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState,
                            extra
                        });
                        if (isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId,
                            arg
                        }, {
                            getState,
                            extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch,
                                getState,
                                extra,
                                requestId,
                                signal: abortController.signal,
                                abort,
                                rejectWithValue: (value, meta)=>{
                                    return new RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof RejectWithValue) throw result;
                                if (result instanceof FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort,
                    requestId,
                    arg,
                    unwrap () {
                        return promise.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending,
            rejected,
            fulfilled,
            settled: isAnyOf(rejected, fulfilled),
            typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var asyncThunkCreator = {
    [asyncThunkSymbol]: createAsyncThunk
};
var ReducerType = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})(ReducerType || {});
function getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function buildCreateSlice({ creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[asyncThunkSymbol];
    return function createSlice2(options) {
        const { name, reducerPath = name } = options;
        if (!name) throw new Error(formatProdErrorMessage(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error(formatProdErrorMessage(12));
                if (type in context.sliceCaseReducersByType) throw new Error(formatProdErrorMessage(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName,
                type: getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return createReducer(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = wrapSelector(selector, selectState, ()=>getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice
            };
        }
        const slice = __spreadProps(__spreadValues({
            name,
            reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = __objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer
                }, config);
                return __spreadValues(__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return __spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare,
                reducer
            };
        },
        asyncThunk
    };
}
function handleNormalReducerDefinition({ type, reducerName, createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error(formatProdErrorMessage(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function handleThunkCaseReducerDefinition({ type, reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error(formatProdErrorMessage(18));
    const { payloadCreator, fulfilled, pending, rejected, settled, options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || noop,
        pending: pending || noop,
        rejected: rejected || noop,
        settled: settled || noop
    });
}
function noop() {}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign(getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState
    };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = createDraftSafeSelector } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds,
            selectEntities,
            selectAll,
            selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors
    };
}
var isDraftTyped = (0, _immer.isDraft);
function createSingleArgumentStateOperator(mutator) {
    const operator = createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if (isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, _immer.produce)(state, runMutator);
    };
}
function selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function getCurrent(value) {
    return (0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    const existingIdsArray = getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: __spreadValues(__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function createSortedStateAdapter(selectId, comparer) {
    const { removeOne, removeMany, removeAll } = createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has(selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = getCurrent(state.entities);
        const currentIds = getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne,
        removeMany,
        removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options = {}) {
    const { selectId, sortComparer } = __spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    const stateFactory = createInitialStateFactory(stateAdapter);
    const selectorsFactory = createSelectorsFactory();
    return __spreadValues(__spreadValues(__spreadValues({
        selectId,
        sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = `task-${cancelled}`;
var taskCompleted = `task-${completed}`;
var listenerCancelled = `${listener}-${cancelled}`;
var listenerCompleted = `${listener}-${completed}`;
var TaskAbortError = class {
    constructor(code){
        this.code = code;
        __publicField(this, "name", "TaskAbortError");
        __publicField(this, "message");
        this.message = `${task} ${cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError(formatProdErrorMessage(32));
};
var noop2 = ()=>{};
var catchRejection = (promise, onError = noop2)=>{
    promise.catch(onError);
    return promise;
};
var addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason } = signal;
        throw new TaskAbortError(reason);
    }
};
function raceWithSignal(signal, promise) {
    let cleanup = noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new TaskAbortError(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = noop2;
    });
}
var runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value
        };
    } catch (error) {
        return {
            status: error instanceof TaskAbortError ? "cancelled" : "rejected",
            error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var createPause = (signal)=>{
    return (promise)=>{
        return catchRejection(raceWithSignal(signal, promise).then((output)=>{
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = (signal)=>{
    const pause = createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign } = Object;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>addAbortSignalListener(parentAbortSignal, ()=>abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = runTask(async ()=>{
            validateActive(parentAbortSignal);
            validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: createPause(childAbortController.signal),
                delay: createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            validateActive(childAbortController.signal);
            return result2;
        }, ()=>abortControllerWithReason(childAbortController, taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch(noop2));
        return {
            result: createPause(parentAbortSignal)(result),
            cancel () {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await raceWithSignal(signal, Promise.race(promises));
            validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>catchRejection(take(predicate, timeout));
};
var getListenerEntryPropsFrom = (options)=>{
    let { type, actionCreator, matcher, predicate, effect } = options;
    if (type) predicate = createAction(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error(formatProdErrorMessage(21));
    assertFunction(effect, "options.listener");
    return {
        predicate,
        type,
        effect
    };
};
var createListenerEntry = /* @__PURE__ */ assign((options)=>{
    const { type, predicate, effect } = getListenerEntryPropsFrom(options);
    const entry = {
        id: nanoid(),
        effect,
        type,
        predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error(formatProdErrorMessage(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>createListenerEntry
});
var findListenerEntry = (listenerMap, options)=>{
    const { type, effect, predicate } = getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        abortControllerWithReason(controller, listenerCancelled);
    });
};
var createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/add`), {
    withTypes: ()=>addListener
});
var clearAllListeners = /* @__PURE__ */ createAction(`${alm}/removeAll`);
var removeListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/remove`), {
    withTypes: ()=>removeListener
});
var defaultErrorHandler = (...args)=>{
    console.error(`${alm}/error`, ...args);
};
var createListenerMiddleware = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra, onError = defaultErrorHandler } = middlewareOptions;
    assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = findListenerEntry(listenerMap, options)) != null ? _a : createListenerEntry(options);
        return insertEntry(entry);
    };
    assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) cancelActiveListeners(entry);
        }
        return !!entry;
    };
    assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            assign({}, api, {
                getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take,
                delay: createDelay(internalTaskController.signal),
                pause: createPause(internalTaskController.signal),
                extra,
                signal: internalTaskController.signal,
                fork: createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            abortControllerWithReason(controller, listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    abortControllerWithReason(internalTaskController, listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof TaskAbortError)) safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            abortControllerWithReason(internalTaskController, listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, _redux.isAction)(action)) return next(action);
                if (addListener.match(action)) return startListening(action.payload);
                if (clearAllListeners.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if (removeListener.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === INTERNAL_NIL_TOKEN) throw new Error(formatProdErrorMessage(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware,
        startListening,
        stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var createMiddlewareEntry = (middleware)=>({
        middleware,
        applied: /* @__PURE__ */ new Map()
    });
var matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var createDynamicMiddleware = ()=>{
    const instanceId = nanoid();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign(createAction("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            getOrInsertComputed(middlewareMap, middleware2, createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, _redux.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = isAllOf(withMiddleware, matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware,
        addMiddleware,
        withMiddleware,
        instanceId
    };
};
var isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var getReducers = (slices)=>slices.flatMap((sliceOrMap)=>isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var isStateProxy = (value)=>!!value && !!value[ORIGINAL_STATE];
var stateProxyMap = /* @__PURE__ */ new WeakMap();
var createStateProxy = (state, reducerMap, initialStateCache)=>getOrInsertComputed(stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: nanoid()
                        });
                        if (typeof reducerResult === "undefined") throw new Error(formatProdErrorMessage(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var original = (state)=>{
    if (!isStateProxy(state)) throw new Error(formatProdErrorMessage(25));
    return state[ORIGINAL_STATE];
};
var emptyObject = {};
var noopReducer = (state = emptyObject)=>state;
function combineSlices(...slices) {
    const reducerMap = Object.fromEntries(getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, _redux.combineReducers)(reducerMap) : noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn(createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original
    });
    return Object.assign(combinedReducer, {
        inject,
        selector
    });
}
// src/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

},{"redux":"fptxw","immer":"ggZ4C","reselect":"ds2su","redux-thunk":"cC21f","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fptxw":[function(require,module,exports,__globalThis) {
// src/utils/formatProdErrorMessage.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>actionTypes_default);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "isAction", ()=>isAction);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
function formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;
// src/utils/actionTypes.ts
var randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
    INIT: `@@redux/INIT${randomString()}`,
    REPLACE: `@@redux/REPLACE${randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;
// src/utils/isPlainObject.ts
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    const constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error(formatProdErrorMessage(17));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: actionTypes_default.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe
                };
            },
            [symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: actionTypes_default.INIT
    });
    const store = {
        dispatch,
        subscribe,
        getState,
        replaceReducer,
        [symbol_observable_default]: observable
    };
    return store;
}
function legacy_createStore(reducer, preloadedState, enhancer) {
    return createStore(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === actionTypes_default.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: actionTypes_default.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: actionTypes_default.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
function combineReducers(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function compose(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error(formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = compose(...chain)(store.dispatch);
            return {
                ...store,
                dispatch
            };
        };
}
// src/utils/isAction.ts
function isAction(action) {
    return isPlainObject(action) && "type" in action && typeof action.type === "string";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ggZ4C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>Immer2);
parcelHelpers.export(exports, "applyPatches", ()=>applyPatches);
parcelHelpers.export(exports, "castDraft", ()=>castDraft);
parcelHelpers.export(exports, "castImmutable", ()=>castImmutable);
parcelHelpers.export(exports, "createDraft", ()=>createDraft);
parcelHelpers.export(exports, "current", ()=>current);
parcelHelpers.export(exports, "enableMapSet", ()=>enableMapSet);
parcelHelpers.export(exports, "enablePatches", ()=>enablePatches);
parcelHelpers.export(exports, "finishDraft", ()=>finishDraft);
parcelHelpers.export(exports, "freeze", ()=>freeze);
parcelHelpers.export(exports, "immerable", ()=>DRAFTABLE);
parcelHelpers.export(exports, "isDraft", ()=>isDraft);
parcelHelpers.export(exports, "isDraftable", ()=>isDraftable);
parcelHelpers.export(exports, "nothing", ()=>NOTHING);
parcelHelpers.export(exports, "original", ()=>original);
parcelHelpers.export(exports, "produce", ()=>produce);
parcelHelpers.export(exports, "produceWithPatches", ()=>produceWithPatches);
parcelHelpers.export(exports, "setAutoFreeze", ()=>setAutoFreeze);
parcelHelpers.export(exports, "setUseStrictShallowCopy", ()=>setUseStrictShallowCopy);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function getArchtype(thing) {
    const state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    const t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        const proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj, deep = false) {
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>freeze(value, true));
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    const plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_,
        immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    const state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    if (!state) {
        each(value, (key, childValue)=>finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, (key, childValue)=>finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    const { revoke, proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get (state, prop) {
        if (prop === DRAFT_STATE) return state;
        const source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys(latest(state));
    },
    set (state, prop, value) {
        const desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = peek(latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        die(11);
    },
    getPrototypeOf (state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, (key, fn)=>{
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    const state = draft[DRAFT_STATE];
    const source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    const desc = getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            let result;
            if (isDraftable(base)) {
                const scope = enterScope(this);
                const proxy = createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!isDraftable(base)) die(8);
        if (isDraft(base)) base = current(base);
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        proxy[DRAFT_STATE].isManual_ = true;
        leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[DRAFT_STATE];
        if (!state || !state.isManual_) die(9);
        const { scope_: scope } = state;
        usePatchesInScope(scope, patchListener);
        return processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = getPlugin("Patches").applyPatches_;
        if (isDraft(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function createProxy(value, parent) {
    const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, (key, childValue)=>{
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_, assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_, copy_ } = state;
        each(state.assigned_, (key, assignedValue)=>{
            const origValue = get(base_, key);
            const value = get(copy_, key);
            const op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op,
                path
            } : {
                op,
                path,
                value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path
            } : op === REMOVE ? {
                op: ADD,
                path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_, copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: ADD,
                    path,
                    value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path,
                    value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path, op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if (typeof base !== "object") die(errorOffset + 2, path.join("/"));
            }
            const type = getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create(getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_,
        generatePatches_,
        generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(key) {
            return latest(this[DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!latest(state).has(key) || latest(state).get(key) !== value) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[DRAFT_STATE];
            latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            const value = latest(state).get(key);
            if (state.finalized_ || !isDraftable(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return latest(this[DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if (isDraftable(value)) {
                    const draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_,
        proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ds2su":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
parcelHelpers.export(exports, "lruMemoize", ()=>lruMemoize);
parcelHelpers.export(exports, "referenceEqualityCheck", ()=>referenceEqualityCheck);
parcelHelpers.export(exports, "setGlobalDevModeChecks", ()=>setGlobalDevModeChecks);
parcelHelpers.export(exports, "unstable_autotrackMemoize", ()=>autotrackMemoize);
parcelHelpers.export(exports, "weakMapMemoize", ()=>weakMapMemoize);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __publicField = (obj, key, value)=>{
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize, memoizeOptions } = options;
    const { inputSelectorResults, inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var setGlobalDevModeChecks = (devModeChecks)=>{
    Object.assign(globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck, inputStabilityCheck } = __spreadValues(__spreadValues({}, globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $REVISION = 0;
var CURRENT_TRACKER = null;
var Cell = class {
    constructor(initialValue, isEqual = tripleEq){
        __publicField(this, "revision", $REVISION);
        __publicField(this, "_value");
        __publicField(this, "_lastValue");
        __publicField(this, "_isEqual", tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        CURRENT_TRACKER == null || CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$REVISION;
    }
};
function tripleEq(a, b) {
    return a === b;
}
var TrackingCache = class {
    constructor(fn){
        __publicField(this, "_cachedValue");
        __publicField(this, "_cachedRevision", -1);
        __publicField(this, "_deps", []);
        __publicField(this, "hits", 0);
        __publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = CURRENT_TRACKER;
            CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        CURRENT_TRACKER == null || CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function getValue(cell) {
    if (!(cell instanceof Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function setValue(storage, value) {
    if (!(storage instanceof Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function createCell(initialValue, isEqual = tripleEq) {
    return new Cell(initialValue, isEqual);
}
function createCache(fn) {
    assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var neverEq = (a, b)=>false;
function createTag() {
    return createCell(null, neverEq);
}
function dirtyTag(tag, value) {
    setValue(tag, value);
}
var consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = createTag();
    getValue(tag);
};
var dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var REDUX_PROXY_LABEL = Symbol();
var nextId = 0;
var proto = Object.getPrototypeOf({});
var ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        __publicField(this, "proxy", new Proxy(this, objectProxyHandler));
        __publicField(this, "tag", createTag());
        __publicField(this, "tags", {});
        __publicField(this, "children", {});
        __publicField(this, "collectionTag", null);
        __publicField(this, "id", nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = createNode(childValue);
                if (childNode.tag) getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = createTag();
                    tag.value = childValue;
                }
                getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        __publicField(this, "proxy", new Proxy([
            this
        ], arrayProxyHandler));
        __publicField(this, "tag", createTag());
        __publicField(this, "tags", {});
        __publicField(this, "children", {});
        __publicField(this, "collectionTag", null);
        __publicField(this, "id", nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") consumeCollection(node);
        return objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return objectProxyHandler.has(node, prop);
    }
};
function createNode(value) {
    if (Array.isArray(value)) return new ArrayTreeNode(value);
    return new ObjectTreeNode(value);
}
function updateNode(node, newValue) {
    const { value, tags, children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            dirtyCollection(node);
            dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) updateNode(childNode, newChildValue);
        else {
            deleteNode(childNode);
            delete children[key];
        }
    }
}
function deleteNode(node) {
    if (node.tag) dirtyTag(node.tag, null);
    dirtyCollection(node);
    for(const key in node.tags)dirtyTag(node.tags[key], null);
    for(const key in node.children)deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key,
                value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            entries.unshift({
                key,
                value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get,
        put,
        getEntries,
        clear
    };
}
var referenceEqualityCheck = (a, b)=>a === b;
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function lruMemoize(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck = referenceEqualityCheck, maxSize = 1, resultEqualityCheck } = providedOptions;
    const comparator = createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function autotrackMemoize(func) {
    const node = createNode([]);
    let lastArgs = null;
    const shallowEqual = createCacheKeyComparator(referenceEqualityCheck);
    const cache = createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
    return {
        s: UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function weakMapMemoize(func, options = {}) {
    let fnNode = createCacheNode();
    const { resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new Ref(result) : result;
            }
        }
        terminatedNode.s = TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = __spreadValues(__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize, memoizeOptions = [], argsMemoize = weakMapMemoize, argsMemoizeOptions = [], devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
        const dependencies = getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc,
            memoizedResultFunc,
            dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize,
            argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);
// src/createStructuredSelector.ts
var createStructuredSelector = Object.assign((inputSelectorsObject, selectorCreator = createSelector)=>{
    assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>createStructuredSelector
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cC21f":[function(require,module,exports,__globalThis) {
// src/index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "thunk", ()=>thunk);
parcelHelpers.export(exports, "withExtraArgument", ()=>withExtraArgument);
function createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch, getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7HPJs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signUpUser", ()=>signUpUser);
parcelHelpers.export(exports, "signInUser", ()=>signInUser);
parcelHelpers.export(exports, "signOutUser", ()=>signOutUser);
var _auth = require("firebase/auth");
var _firebase = require("../config/firebase");
async function signUpUser(name, email, password) {
    return await (0, _auth.createUserWithEmailAndPassword)((0, _firebase.auth), email, password).then(async (userCredential)=>{
        const user = userCredential.user;
        await (0, _auth.updateProfile)(user, {
            displayName: name
        });
        return {
            status: "Success",
            accessToken: user?.stsTokenManager?.accessToken,
            refreshToken: user?.stsTokenManager?.refreshToken,
            displayName: name,
            email: user?.email,
            uid: user?.uid
        };
    }).catch((error)=>{
        return {
            status: "Error",
            code: error.code,
            errorMessage: error.message
        };
    });
}
async function signInUser(email, password) {
    return await (0, _auth.signInWithEmailAndPassword)((0, _firebase.auth), email, password).then((userCredential)=>{
        // Signed up
        const user = userCredential.user;
        return {
            status: "Success",
            accessToken: user?.stsTokenManager?.accessToken,
            refreshToken: user?.stsTokenManager?.refreshToken,
            displayName: user?.displayName,
            email: user?.email,
            uid: user?.uid
        };
    }).catch((error)=>{
        const errorCode = error.code;
        const errorMessage = error.message;
        return {
            status: "Error"
        };
    });
}
async function signOutUser() {
    return await (0, _auth.signOut)((0, _firebase.auth)).then().catch();
}

},{"firebase/auth":"dZ6yw","../config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dZ6yw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _auth = require("@firebase/auth");
parcelHelpers.exportAll(_auth, exports);

},{"@firebase/auth":"9RcX1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9RcX1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionCodeOperation", ()=>(0, _index8E6E89CbJs.A));
parcelHelpers.export(exports, "ActionCodeURL", ()=>(0, _index8E6E89CbJs.aj));
parcelHelpers.export(exports, "AuthCredential", ()=>(0, _index8E6E89CbJs.M));
parcelHelpers.export(exports, "AuthErrorCodes", ()=>(0, _index8E6E89CbJs.J));
parcelHelpers.export(exports, "EmailAuthCredential", ()=>(0, _index8E6E89CbJs.N));
parcelHelpers.export(exports, "EmailAuthProvider", ()=>(0, _index8E6E89CbJs.W));
parcelHelpers.export(exports, "FacebookAuthProvider", ()=>(0, _index8E6E89CbJs.X));
parcelHelpers.export(exports, "FactorId", ()=>(0, _index8E6E89CbJs.F));
parcelHelpers.export(exports, "GithubAuthProvider", ()=>(0, _index8E6E89CbJs.Z));
parcelHelpers.export(exports, "GoogleAuthProvider", ()=>(0, _index8E6E89CbJs.Y));
parcelHelpers.export(exports, "OAuthCredential", ()=>(0, _index8E6E89CbJs.Q));
parcelHelpers.export(exports, "OAuthProvider", ()=>(0, _index8E6E89CbJs._));
parcelHelpers.export(exports, "OperationType", ()=>(0, _index8E6E89CbJs.O));
parcelHelpers.export(exports, "PhoneAuthCredential", ()=>(0, _index8E6E89CbJs.U));
parcelHelpers.export(exports, "PhoneAuthProvider", ()=>(0, _index8E6E89CbJs.P));
parcelHelpers.export(exports, "PhoneMultiFactorGenerator", ()=>(0, _index8E6E89CbJs.n));
parcelHelpers.export(exports, "ProviderId", ()=>(0, _index8E6E89CbJs.q));
parcelHelpers.export(exports, "RecaptchaVerifier", ()=>(0, _index8E6E89CbJs.R));
parcelHelpers.export(exports, "SAMLAuthProvider", ()=>(0, _index8E6E89CbJs.$));
parcelHelpers.export(exports, "SignInMethod", ()=>(0, _index8E6E89CbJs.S));
parcelHelpers.export(exports, "TotpMultiFactorGenerator", ()=>(0, _index8E6E89CbJs.T));
parcelHelpers.export(exports, "TotpSecret", ()=>(0, _index8E6E89CbJs.o));
parcelHelpers.export(exports, "TwitterAuthProvider", ()=>(0, _index8E6E89CbJs.a0));
parcelHelpers.export(exports, "applyActionCode", ()=>(0, _index8E6E89CbJs.a8));
parcelHelpers.export(exports, "beforeAuthStateChanged", ()=>(0, _index8E6E89CbJs.y));
parcelHelpers.export(exports, "browserCookiePersistence", ()=>(0, _index8E6E89CbJs.a));
parcelHelpers.export(exports, "browserLocalPersistence", ()=>(0, _index8E6E89CbJs.b));
parcelHelpers.export(exports, "browserPopupRedirectResolver", ()=>(0, _index8E6E89CbJs.m));
parcelHelpers.export(exports, "browserSessionPersistence", ()=>(0, _index8E6E89CbJs.c));
parcelHelpers.export(exports, "checkActionCode", ()=>(0, _index8E6E89CbJs.a9));
parcelHelpers.export(exports, "confirmPasswordReset", ()=>(0, _index8E6E89CbJs.a7));
parcelHelpers.export(exports, "connectAuthEmulator", ()=>(0, _index8E6E89CbJs.L));
parcelHelpers.export(exports, "createUserWithEmailAndPassword", ()=>(0, _index8E6E89CbJs.ab));
parcelHelpers.export(exports, "debugErrorMap", ()=>(0, _index8E6E89CbJs.H));
parcelHelpers.export(exports, "deleteUser", ()=>(0, _index8E6E89CbJs.G));
parcelHelpers.export(exports, "fetchSignInMethodsForEmail", ()=>(0, _index8E6E89CbJs.ag));
parcelHelpers.export(exports, "getAdditionalUserInfo", ()=>(0, _index8E6E89CbJs.ar));
parcelHelpers.export(exports, "getAuth", ()=>(0, _index8E6E89CbJs.p));
parcelHelpers.export(exports, "getIdToken", ()=>(0, _index8E6E89CbJs.ao));
parcelHelpers.export(exports, "getIdTokenResult", ()=>(0, _index8E6E89CbJs.ap));
parcelHelpers.export(exports, "getMultiFactorResolver", ()=>(0, _index8E6E89CbJs.at));
parcelHelpers.export(exports, "getRedirectResult", ()=>(0, _index8E6E89CbJs.k));
parcelHelpers.export(exports, "inMemoryPersistence", ()=>(0, _index8E6E89CbJs.V));
parcelHelpers.export(exports, "indexedDBLocalPersistence", ()=>(0, _index8E6E89CbJs.i));
parcelHelpers.export(exports, "initializeAuth", ()=>(0, _index8E6E89CbJs.K));
parcelHelpers.export(exports, "initializeRecaptchaConfig", ()=>(0, _index8E6E89CbJs.v));
parcelHelpers.export(exports, "isSignInWithEmailLink", ()=>(0, _index8E6E89CbJs.ae));
parcelHelpers.export(exports, "linkWithCredential", ()=>(0, _index8E6E89CbJs.a3));
parcelHelpers.export(exports, "linkWithPhoneNumber", ()=>(0, _index8E6E89CbJs.l));
parcelHelpers.export(exports, "linkWithPopup", ()=>(0, _index8E6E89CbJs.e));
parcelHelpers.export(exports, "linkWithRedirect", ()=>(0, _index8E6E89CbJs.h));
parcelHelpers.export(exports, "multiFactor", ()=>(0, _index8E6E89CbJs.au));
parcelHelpers.export(exports, "onAuthStateChanged", ()=>(0, _index8E6E89CbJs.z));
parcelHelpers.export(exports, "onIdTokenChanged", ()=>(0, _index8E6E89CbJs.x));
parcelHelpers.export(exports, "parseActionCodeURL", ()=>(0, _index8E6E89CbJs.ak));
parcelHelpers.export(exports, "prodErrorMap", ()=>(0, _index8E6E89CbJs.I));
parcelHelpers.export(exports, "reauthenticateWithCredential", ()=>(0, _index8E6E89CbJs.a4));
parcelHelpers.export(exports, "reauthenticateWithPhoneNumber", ()=>(0, _index8E6E89CbJs.r));
parcelHelpers.export(exports, "reauthenticateWithPopup", ()=>(0, _index8E6E89CbJs.f));
parcelHelpers.export(exports, "reauthenticateWithRedirect", ()=>(0, _index8E6E89CbJs.j));
parcelHelpers.export(exports, "reload", ()=>(0, _index8E6E89CbJs.as));
parcelHelpers.export(exports, "revokeAccessToken", ()=>(0, _index8E6E89CbJs.E));
parcelHelpers.export(exports, "sendEmailVerification", ()=>(0, _index8E6E89CbJs.ah));
parcelHelpers.export(exports, "sendPasswordResetEmail", ()=>(0, _index8E6E89CbJs.a6));
parcelHelpers.export(exports, "sendSignInLinkToEmail", ()=>(0, _index8E6E89CbJs.ad));
parcelHelpers.export(exports, "setPersistence", ()=>(0, _index8E6E89CbJs.t));
parcelHelpers.export(exports, "signInAnonymously", ()=>(0, _index8E6E89CbJs.a1));
parcelHelpers.export(exports, "signInWithCredential", ()=>(0, _index8E6E89CbJs.a2));
parcelHelpers.export(exports, "signInWithCustomToken", ()=>(0, _index8E6E89CbJs.a5));
parcelHelpers.export(exports, "signInWithEmailAndPassword", ()=>(0, _index8E6E89CbJs.ac));
parcelHelpers.export(exports, "signInWithEmailLink", ()=>(0, _index8E6E89CbJs.af));
parcelHelpers.export(exports, "signInWithPhoneNumber", ()=>(0, _index8E6E89CbJs.s));
parcelHelpers.export(exports, "signInWithPopup", ()=>(0, _index8E6E89CbJs.d));
parcelHelpers.export(exports, "signInWithRedirect", ()=>(0, _index8E6E89CbJs.g));
parcelHelpers.export(exports, "signOut", ()=>(0, _index8E6E89CbJs.D));
parcelHelpers.export(exports, "unlink", ()=>(0, _index8E6E89CbJs.aq));
parcelHelpers.export(exports, "updateCurrentUser", ()=>(0, _index8E6E89CbJs.C));
parcelHelpers.export(exports, "updateEmail", ()=>(0, _index8E6E89CbJs.am));
parcelHelpers.export(exports, "updatePassword", ()=>(0, _index8E6E89CbJs.an));
parcelHelpers.export(exports, "updatePhoneNumber", ()=>(0, _index8E6E89CbJs.u));
parcelHelpers.export(exports, "updateProfile", ()=>(0, _index8E6E89CbJs.al));
parcelHelpers.export(exports, "useDeviceLanguage", ()=>(0, _index8E6E89CbJs.B));
parcelHelpers.export(exports, "validatePassword", ()=>(0, _index8E6E89CbJs.w));
parcelHelpers.export(exports, "verifyBeforeUpdateEmail", ()=>(0, _index8E6E89CbJs.ai));
parcelHelpers.export(exports, "verifyPasswordResetCode", ()=>(0, _index8E6E89CbJs.aa));
var _index8E6E89CbJs = require("./index-8e6e89cb.js");
var _app = require("@firebase/app");
var _util = require("@firebase/util");
var _logger = require("@firebase/logger");
var _tslib = require("tslib");
var _component = require("@firebase/component");

},{"./index-8e6e89cb.js":"1q5HL","@firebase/app":"1SyrH","@firebase/util":"guJD8","@firebase/logger":"3ul0m","tslib":"7YykB","@firebase/component":"2tpfU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1q5HL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>SAMLAuthProvider);
parcelHelpers.export(exports, "A", ()=>ActionCodeOperation);
parcelHelpers.export(exports, "B", ()=>useDeviceLanguage);
parcelHelpers.export(exports, "C", ()=>updateCurrentUser);
parcelHelpers.export(exports, "D", ()=>signOut);
parcelHelpers.export(exports, "E", ()=>revokeAccessToken);
parcelHelpers.export(exports, "F", ()=>FactorId);
parcelHelpers.export(exports, "G", ()=>deleteUser);
parcelHelpers.export(exports, "H", ()=>debugErrorMap);
parcelHelpers.export(exports, "I", ()=>prodErrorMap);
parcelHelpers.export(exports, "J", ()=>AUTH_ERROR_CODES_MAP_DO_NOT_USE_INTERNALLY);
parcelHelpers.export(exports, "K", ()=>initializeAuth);
parcelHelpers.export(exports, "L", ()=>connectAuthEmulator);
parcelHelpers.export(exports, "M", ()=>AuthCredential);
parcelHelpers.export(exports, "N", ()=>EmailAuthCredential);
parcelHelpers.export(exports, "O", ()=>OperationType);
parcelHelpers.export(exports, "P", ()=>PhoneAuthProvider);
parcelHelpers.export(exports, "Q", ()=>OAuthCredential);
parcelHelpers.export(exports, "R", ()=>RecaptchaVerifier);
parcelHelpers.export(exports, "S", ()=>SignInMethod);
parcelHelpers.export(exports, "T", ()=>TotpMultiFactorGenerator);
parcelHelpers.export(exports, "U", ()=>PhoneAuthCredential);
parcelHelpers.export(exports, "V", ()=>inMemoryPersistence);
parcelHelpers.export(exports, "W", ()=>EmailAuthProvider);
parcelHelpers.export(exports, "X", ()=>FacebookAuthProvider);
parcelHelpers.export(exports, "Y", ()=>GoogleAuthProvider);
parcelHelpers.export(exports, "Z", ()=>GithubAuthProvider);
parcelHelpers.export(exports, "_", ()=>OAuthProvider);
parcelHelpers.export(exports, "a", ()=>browserCookiePersistence);
parcelHelpers.export(exports, "a0", ()=>TwitterAuthProvider);
parcelHelpers.export(exports, "a1", ()=>signInAnonymously);
parcelHelpers.export(exports, "a2", ()=>signInWithCredential);
parcelHelpers.export(exports, "a3", ()=>linkWithCredential);
parcelHelpers.export(exports, "a4", ()=>reauthenticateWithCredential);
parcelHelpers.export(exports, "a5", ()=>signInWithCustomToken);
parcelHelpers.export(exports, "a6", ()=>sendPasswordResetEmail);
parcelHelpers.export(exports, "a7", ()=>confirmPasswordReset);
parcelHelpers.export(exports, "a8", ()=>applyActionCode);
parcelHelpers.export(exports, "a9", ()=>checkActionCode);
parcelHelpers.export(exports, "aA", ()=>_getProjectConfig);
parcelHelpers.export(exports, "aB", ()=>_isIOS7Or8);
parcelHelpers.export(exports, "aC", ()=>_createError);
parcelHelpers.export(exports, "aD", ()=>_assert);
parcelHelpers.export(exports, "aE", ()=>AuthEventManager);
parcelHelpers.export(exports, "aF", ()=>_getInstance);
parcelHelpers.export(exports, "aG", ()=>_persistenceKeyName);
parcelHelpers.export(exports, "aH", ()=>_getRedirectResult);
parcelHelpers.export(exports, "aI", ()=>_overrideRedirectResult);
parcelHelpers.export(exports, "aJ", ()=>_clearRedirectOutcomes);
parcelHelpers.export(exports, "aK", ()=>_castAuth);
parcelHelpers.export(exports, "aL", ()=>UserImpl);
parcelHelpers.export(exports, "aM", ()=>AuthImpl);
parcelHelpers.export(exports, "aN", ()=>_getClientVersion);
parcelHelpers.export(exports, "aO", ()=>_generateEventId);
parcelHelpers.export(exports, "aP", ()=>AuthPopup);
parcelHelpers.export(exports, "aQ", ()=>FetchProvider);
parcelHelpers.export(exports, "aR", ()=>SAMLAuthCredential);
parcelHelpers.export(exports, "aa", ()=>verifyPasswordResetCode);
parcelHelpers.export(exports, "ab", ()=>createUserWithEmailAndPassword);
parcelHelpers.export(exports, "ac", ()=>signInWithEmailAndPassword);
parcelHelpers.export(exports, "ad", ()=>sendSignInLinkToEmail);
parcelHelpers.export(exports, "ae", ()=>isSignInWithEmailLink);
parcelHelpers.export(exports, "af", ()=>signInWithEmailLink);
parcelHelpers.export(exports, "ag", ()=>fetchSignInMethodsForEmail);
parcelHelpers.export(exports, "ah", ()=>sendEmailVerification);
parcelHelpers.export(exports, "ai", ()=>verifyBeforeUpdateEmail);
parcelHelpers.export(exports, "aj", ()=>ActionCodeURL);
parcelHelpers.export(exports, "ak", ()=>parseActionCodeURL);
parcelHelpers.export(exports, "al", ()=>updateProfile);
parcelHelpers.export(exports, "am", ()=>updateEmail);
parcelHelpers.export(exports, "an", ()=>updatePassword);
parcelHelpers.export(exports, "ao", ()=>getIdToken);
parcelHelpers.export(exports, "ap", ()=>getIdTokenResult);
parcelHelpers.export(exports, "aq", ()=>unlink);
parcelHelpers.export(exports, "ar", ()=>getAdditionalUserInfo);
parcelHelpers.export(exports, "as", ()=>reload);
parcelHelpers.export(exports, "at", ()=>getMultiFactorResolver);
parcelHelpers.export(exports, "au", ()=>multiFactor);
parcelHelpers.export(exports, "av", ()=>debugAssert);
parcelHelpers.export(exports, "aw", ()=>_isIOS);
parcelHelpers.export(exports, "ax", ()=>_isAndroid);
parcelHelpers.export(exports, "ay", ()=>_fail);
parcelHelpers.export(exports, "az", ()=>_getRedirectUrl);
parcelHelpers.export(exports, "b", ()=>browserLocalPersistence);
parcelHelpers.export(exports, "c", ()=>browserSessionPersistence);
parcelHelpers.export(exports, "d", ()=>signInWithPopup);
parcelHelpers.export(exports, "e", ()=>linkWithPopup);
parcelHelpers.export(exports, "f", ()=>reauthenticateWithPopup);
parcelHelpers.export(exports, "g", ()=>signInWithRedirect);
parcelHelpers.export(exports, "h", ()=>linkWithRedirect);
parcelHelpers.export(exports, "i", ()=>indexedDBLocalPersistence);
parcelHelpers.export(exports, "j", ()=>reauthenticateWithRedirect);
parcelHelpers.export(exports, "k", ()=>getRedirectResult);
parcelHelpers.export(exports, "l", ()=>linkWithPhoneNumber);
parcelHelpers.export(exports, "m", ()=>browserPopupRedirectResolver);
parcelHelpers.export(exports, "n", ()=>PhoneMultiFactorGenerator);
parcelHelpers.export(exports, "o", ()=>TotpSecret);
parcelHelpers.export(exports, "p", ()=>getAuth);
parcelHelpers.export(exports, "q", ()=>ProviderId);
parcelHelpers.export(exports, "r", ()=>reauthenticateWithPhoneNumber);
parcelHelpers.export(exports, "s", ()=>signInWithPhoneNumber);
parcelHelpers.export(exports, "t", ()=>setPersistence);
parcelHelpers.export(exports, "u", ()=>updatePhoneNumber);
parcelHelpers.export(exports, "v", ()=>initializeRecaptchaConfig);
parcelHelpers.export(exports, "w", ()=>validatePassword);
parcelHelpers.export(exports, "x", ()=>onIdTokenChanged);
parcelHelpers.export(exports, "y", ()=>beforeAuthStateChanged);
parcelHelpers.export(exports, "z", ()=>onAuthStateChanged);
var _app = require("@firebase/app");
var _util = require("@firebase/util");
var _logger = require("@firebase/logger");
var _tslib = require("tslib");
var _component = require("@firebase/component");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const FactorId = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const ProviderId = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const SignInMethod = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const OperationType = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const ActionCodeOperation = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.',
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function _prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const debugErrorMap = _debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const prodErrorMap = _prodErrorMap;
const _DEFAULT_AUTH_ERROR_FACTORY = new (0, _util.ErrorFactory)('auth', 'Firebase', _prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const AUTH_ERROR_CODES_MAP_DO_NOT_USE_INTERNALLY = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type',
    INVALID_HOSTING_LINK_DOMAIN: 'auth/invalid-hosting-link-domain'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const logClient = new (0, _logger.Logger)('@firebase/auth');
function _logWarn(msg, ...args) {
    if (logClient.logLevel <= (0, _logger.LogLevel).WARN) logClient.warn(`Auth (${(0, _app.SDK_VERSION)}): ${msg}`, ...args);
}
function _logError(msg, ...args) {
    if (logClient.logLevel <= (0, _logger.LogLevel).ERROR) logClient.error(`Auth (${(0, _app.SDK_VERSION)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _fail(authOrCode, ...rest) {
    throw createErrorInternal(authOrCode, ...rest);
}
function _createError(authOrCode, ...rest) {
    return createErrorInternal(authOrCode, ...rest);
}
function _errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, prodErrorMap()), {
        [code]: message
    });
    const factory = new (0, _util.ErrorFactory)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function _serverAppCurrentUserOperationNotSupportedError(auth) {
    return _errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function _assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) _fail(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw _errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return _DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function _assert(assertion, authOrCode, ...rest) {
    if (!assertion) throw createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    _logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function debugAssert(assertion, message) {
    if (!assertion) debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _getCurrentUrl() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || '';
}
function _isHttpOrHttps() {
    return _getCurrentScheme() === 'http:' || _getCurrentScheme() === 'https:';
}
function _getCurrentScheme() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function _isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    (_isHttpOrHttps() || (0, _util.isBrowserExtension)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function _getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        debugAssert(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, _util.isMobileCordova)() || (0, _util.isReactNative)();
    }
    get() {
        if (!_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _emulatorUrl(config, path) {
    debugAssert(config.emulator, 'Emulator should always be set here');
    const { url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class FetchProvider {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const CookieAuthProxiedEndpoints = [
    "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ ,
    "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ ,
    "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ ,
    "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ ,
    "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ ,
    "/v1/token" /* Endpoint.TOKEN */ 
];
const DEFAULT_API_TIMEOUT_MS = new Delay(30000, 60000);
function _addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function _performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return _performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, _util.querystring)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = Object.assign({
            method,
            headers
        }, body);
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, _util.isCloudflareWorker)()) fetchArgs.referrerPolicy = 'no-referrer';
        if (auth.emulatorConfig && (0, _util.isCloudWorkstation)(auth.emulatorConfig.host)) fetchArgs.credentials = 'include';
        return FetchProvider.fetch()(await _getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function _performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw _makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw _makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw _makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw _makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw _errorWithCustomMessage(auth, authError, serverErrorMessage);
            else _fail(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        _fail(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function _performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await _performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) _fail(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
async function _getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    const authInternal = auth;
    const finalTarget = authInternal.config.emulator ? _emulatorUrl(auth.config, base) : `${auth.config.apiScheme}://${base}`;
    // Cookie auth works by MiTMing the signIn and token endpoints from the developer's backend,
    // saving the idToken and refreshToken into cookies, and then redacting the refreshToken
    // from the response
    if (CookieAuthProxiedEndpoints.includes(path)) {
        // Persistence manager is async, we need to await it. We can't just wait for auth initialized
        // here since auth initialization calls this function.
        await authInternal._persistenceManagerAvailable;
        if (authInternal._getPersistenceType() === "COOKIE" /* PersistenceType.COOKIE */ ) {
            const cookiePersistence = authInternal._getPersistence();
            return cookiePersistence._getFinalTarget(finalTarget).toString();
        }
    }
    return finalTarget;
}
function _parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject(_createError(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function _makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = _createError(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return _parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function getRecaptchaParams(auth) {
    return (await _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function getRecaptchaConfig(auth, request) {
    return _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function deleteAccount(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function deleteLinkedAccounts(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function getAccountInfo(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function getIdToken(user, forceRefresh = false) {
    return (0, _util.getModularInstance)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function getIdTokenResult(user, forceRefresh = false) {
    const userInternal = (0, _util.getModularInstance)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = _parseToken(token);
    _assert(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
    return {
        claims,
        token,
        authTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.iat)),
        expirationTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
    };
}
function secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function _parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        _logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, _util.base64Decode)(payload);
        if (!decoded) {
            _logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        _logError('Caught error parsing JWT payload as JSON', e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function _tokenExpiresIn(token) {
    const parsedToken = _parseToken(token);
    _assert(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    _assert(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    _assert(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError) && isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function isUserInvalidated({ code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await _logoutIfInvalidated(user, getAccountInfo(auth, {
        idToken
    }));
    _assert(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData,
        metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function reload(user) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId } = _a, provider = (0, _tslib.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function requestStsToken(auth, refreshToken) {
    const response = await _performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, _util.querystring)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost, apiKey } = auth.config;
        const url = await _getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        const options = {
            method: "POST" /* HttpMethod.POST */ ,
            headers,
            body
        };
        if (auth.emulatorConfig && (0, _util.isCloudWorkstation)(auth.emulatorConfig.host)) options.credentials = 'include';
        return FetchProvider.fetch()(url, options);
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function revokeToken(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        _assert(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        _assert(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        _assert(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : _tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        _assert(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = _tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        _assert(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken, refreshToken, expiresIn } = await requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken, accessToken, expirationTime } = object;
        const manager = new StsTokenManager();
        if (refreshToken) {
            _assert(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            _assert(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            _assert(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function assertStringOrUndefined(assertion, appName) {
    _assert(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName
    });
}
class UserImpl {
    constructor(_a){
        var { uid, auth, stsTokenManager } = _a, opt = (0, _tslib.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await _logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        _assert(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return getIdTokenResult(this, forceRefresh);
    }
    reload() {
        return reload(this);
    }
    _assign(user) {
        if (this === user) return;
        _assert(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new UserImpl(Object.assign(Object.assign({}, this), {
            auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        _assert(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await _reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, _app._isFirebaseServerApp)(this.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await _logoutIfInvalidated(this, deleteAccount(this.auth, {
            idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid, emailVerified, isAnonymous, providerData, stsTokenManager: plainObjectTokenManager } = object;
        _assert(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        _assert(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        assertStringOrUndefined(displayName, auth.name);
        assertStringOrUndefined(email, auth.name);
        _assert(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        _assert(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        assertStringOrUndefined(phoneNumber, auth.name);
        assertStringOrUndefined(photoURL, auth.name);
        assertStringOrUndefined(tenantId, auth.name);
        assertStringOrUndefined(_redirectEventId, auth.name);
        assertStringOrUndefined(createdAt, auth.name);
        assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new UserImpl({
            uid,
            auth,
            email,
            emailVerified,
            displayName,
            isAnonymous,
            photoURL,
            phoneNumber,
            tenantId,
            stsTokenManager,
            createdAt,
            lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new UserImpl({
            uid: idTokenResponse.localId,
            auth,
            stsTokenManager,
            isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await _reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        _assert(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new UserImpl({
            uid: coreAccount.localId,
            auth,
            stsTokenManager,
            isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData,
            metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const instanceCache = new Map();
function _getInstance(cls) {
    debugAssert(cls instanceof Function, 'Expected a class definition');
    let instance = instanceCache.get(cls);
    if (instance) {
        debugAssert(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const inMemoryPersistence = InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _persistenceKeyName(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config, name } = this.auth;
        this.fullUserKey = _persistenceKeyName(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = _persistenceKeyName("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        if (!blob) return null;
        if (typeof blob === 'string') {
            const response = await getAccountInfo(this.auth, {
                idToken: blob
            }).catch(()=>undefined);
            if (!response) return null;
            return UserImpl._fromGetAccountInfoResponse(this.auth, response, blob);
        }
        return UserImpl._fromJSON(this.auth, blob);
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new PersistenceUserManager(_getInstance(inMemoryPersistence), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || _getInstance(inMemoryPersistence);
        const key = _persistenceKeyName(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                let user;
                if (typeof blob === 'string') {
                    const response = await getAccountInfo(auth, {
                        idToken: blob
                    }).catch(()=>undefined);
                    if (!response) break;
                    user = await UserImpl._fromGetAccountInfoResponse(auth, response, blob);
                } else user = UserImpl._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function _getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if (_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if (_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if (_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if (_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if (_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || _isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if (_isAndroid(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function _isFirefox(ua = (0, _util.getUA)()) {
    return /firefox\//i.test(ua);
}
function _isSafari(userAgent = (0, _util.getUA)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function _isChromeIOS(ua = (0, _util.getUA)()) {
    return /crios\//i.test(ua);
}
function _isIEMobile(ua = (0, _util.getUA)()) {
    return /iemobile/i.test(ua);
}
function _isAndroid(ua = (0, _util.getUA)()) {
    return /android/i.test(ua);
}
function _isBlackBerry(ua = (0, _util.getUA)()) {
    return /blackberry/i.test(ua);
}
function _isWebOS(ua = (0, _util.getUA)()) {
    return /webos/i.test(ua);
}
function _isIOS(ua = (0, _util.getUA)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function _isIOS7Or8(ua = (0, _util.getUA)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function _isIOSStandalone(ua = (0, _util.getUA)()) {
    var _a;
    return _isIOS(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function _isIE10() {
    return (0, _util.isIE)() && document.documentMode === 10;
}
function _isMobileBrowser(ua = (0, _util.getUA)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return _isIOS(ua) || _isAndroid(ua) || _isWebOS(ua) || _isBlackBerry(ua) || /windows phone/i.test(ua) || _isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function _getClientVersion(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = _getBrowserName((0, _util.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${_getBrowserName((0, _util.getUA)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, _app.SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function _getPasswordPolicy(auth, request = {}) {
    return _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join('')) !== null && _c !== void 0 ? _c : '';
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class AuthImpl {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new Subscription(this);
        this.idTokenSubscription = new Subscription(this);
        this.beforeStateQueue = new AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = _DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        this._resolvePersistenceManagerAvailable = undefined;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
        // TODO(jamesdaniels) explore less hacky way to do this, cookie authentication needs
        // persistenceMananger to be available. see _getFinalTarget for more context
        this._persistenceManagerAvailable = new Promise((resolve)=>this._resolvePersistenceManagerAvailable = resolve);
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = _getInstance(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b, _c;
            if (this._deleted) return;
            this.persistenceManager = await PersistenceUserManager.create(this, persistenceHierarchy);
            (_a = this._resolvePersistenceManagerAvailable) === null || _a === void 0 || _a.call(this);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_b = this._popupRedirectResolver) === null || _b === void 0 ? void 0 : _b._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_c = this.currentUser) === null || _c === void 0 ? void 0 : _c.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await getAccountInfo(this, {
                idToken
            });
            const user = await UserImpl._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, _app._isFirebaseServerApp)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        _assert(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await _reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = _getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, _app._isFirebaseServerApp)(this.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, _util.getModularInstance)(userExtern) : null;
        if (user) _assert(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) _assert(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, _app._isFirebaseServerApp)(this.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, _app._isFirebaseServerApp)(this.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence(_getInstance(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await _getPasswordPolicy(this);
        const passwordPolicy = new PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistenceType() {
        return this.assertedPersistence.persistence.type;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, _util.ErrorFactory)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token,
                idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && _getInstance(popupRedirectResolver) || this._popupRedirectResolver;
            _assert(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await PersistenceUserManager.create(this, [
                _getInstance(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        _assert(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        _assert(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = _getClientVersion(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        if ((0, _app._isFirebaseServerApp)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        _logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function _castAuth(auth) {
    return (0, _util.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ class Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, _util.createSubscribe)((observer)=>this.observer = observer);
    }
    get next() {
        _assert(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function _setExternalJSProvider(p) {
    externalJSProvider = p;
}
function _loadJS(url) {
    return externalJSProvider.loadJS(url);
}
function _recaptchaV2ScriptUrl() {
    return externalJSProvider.recaptchaV2Script;
}
function _recaptchaEnterpriseScriptUrl() {
    return externalJSProvider.recaptchaEnterpriseScript;
}
function _gapiScriptUrl() {
    return externalJSProvider.gapiScript;
}
function _generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const _SOLVE_TIME_MS = 500;
const _EXPIRATION_TIME_MS = 60000;
const _WIDGET_ID_START = 1000000000000;
class MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = _WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || '';
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return '';
    }
}
class MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        _assert(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = generateRandomAlphaNumericString(50);
            const { callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, _EXPIRATION_TIME_MS);
        }, _SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ const RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const FAKE_TOKEN = 'NO_RECAPTCHA';
class RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = _castAuth(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if (isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve(FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = _recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    _loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber,
                    recaptchaToken,
                    captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken,
                    captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    var _a, _b;
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if ((_b = authInstance._getRecaptchaConfig()) === null || _b === void 0 ? void 0 : _b.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                var _a;
                if (((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function _initializeRecaptchaConfig(auth) {
    const authInternal = _castAuth(auth);
    const response = await getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function initializeAuth(app, deps) {
    const provider = (0, _app._getProvider)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, _util.deepEqual)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else _fail(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function _initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map(_getInstance);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function connectAuthEmulator(auth, url, options) {
    const authInternal = _castAuth(auth);
    _assert(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = extractProtocol(url);
    const { host, port } = extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host,
        port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        _assert(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        _assert((0, _util.deepEqual)(emulator, authInternal.config.emulator) && (0, _util.deepEqual)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    // Workaround to get cookies in Firebase Studio
    if ((0, _util.isCloudWorkstation)(host)) {
        (0, _util.pingServer)(`${protocol}//${host}${portStr}`);
        (0, _util.updateEmulatorBanner)('Auth', true);
    } else if (!disableWarnings) emitEmulatorWarning();
}
function extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function extractHostAndPort(url) {
    const protocol = extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host,
            port: parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host,
            port: parsePort(port)
        };
    }
}
function parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class AuthCredential {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function resetPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , _addTidIfNecessary(auth, request));
}
async function updateEmailPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function linkEmailPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function applyActionCode$1(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithPassword(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , _addTidIfNecessary(auth, request));
}
async function sendOobCode(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , _addTidIfNecessary(auth, request));
}
async function sendEmailVerification$1(auth, request) {
    return sendOobCode(auth, request);
}
async function sendPasswordResetEmail$1(auth, request) {
    return sendOobCode(auth, request);
}
async function sendSignInLinkToEmail$1(auth, request) {
    return sendOobCode(auth, request);
}
async function verifyAndChangeEmail(auth, request) {
    return sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithEmailLink$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , _addTidIfNecessary(auth, request));
}
async function signInWithEmailLinkForLinking(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class EmailAuthCredential extends AuthCredential {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new EmailAuthCredential(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new EmailAuthCredential(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return signInWithEmailLinkForLinking(auth, {
                    idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithIdp(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class OAuthCredential extends AuthCredential {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new OAuthCredential(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else _fail("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId, signInMethod } = obj, rest = (0, _tslib.__rest)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new OAuthCredential(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, _util.querystring)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function sendPhoneVerificationCode(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , _addTidIfNecessary(auth, request));
}
async function signInWithPhoneNumber$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , _addTidIfNecessary(auth, request));
}
async function linkWithPhoneNumber$1(auth, request) {
    const response = await _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , _addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw _makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: 'REAUTH'
    });
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , _addTidIfNecessary(auth, apiRequest), VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class PhoneAuthCredential extends AuthCredential {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new PhoneAuthCredential({
            verificationId,
            verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new PhoneAuthCredential({
            phoneNumber,
            temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return linkWithPhoneNumber$1(auth, Object.assign({
            idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof, phoneNumber, verificationId, verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof,
            phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId, verificationCode, phoneNumber, temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new PhoneAuthCredential({
            verificationId,
            verificationCode,
            phoneNumber,
            temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function parseDeepLink(url) {
    const link = (0, _util.querystringDecode)((0, _util.extractQuerystring)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, _util.querystringDecode)((0, _util.extractQuerystring)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, _util.querystringDecode)((0, _util.extractQuerystring)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, _util.querystringDecode)((0, _util.extractQuerystring)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class ActionCodeURL {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, _util.querystringDecode)((0, _util.extractQuerystring)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        _assert(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["lang" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = parseDeepLink(link);
        try {
            return new ActionCodeURL(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function parseActionCodeURL(link) {
    return ActionCodeURL.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class EmailAuthProvider {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = EmailAuthProvider.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return EmailAuthCredential._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = ActionCodeURL.parseLink(emailLink);
        _assert(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return EmailAuthCredential._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ EmailAuthProvider.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class BaseOAuthProvider extends FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class OAuthProvider extends BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        _assert('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return OAuthCredential._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        _assert(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return OAuthCredential._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return OAuthProvider.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return OAuthProvider.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken, oauthAccessToken, oauthTokenSecret, pendingToken, nonce, providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new OAuthProvider(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce,
                pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class FacebookAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return OAuthCredential._fromParams({
            providerId: FacebookAuthProvider.PROVIDER_ID,
            signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return FacebookAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ FacebookAuthProvider.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class GoogleAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return OAuthCredential._fromParams({
            providerId: GoogleAuthProvider.PROVIDER_ID,
            signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
            idToken,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return GoogleAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken, oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ GoogleAuthProvider.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class GithubAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return OAuthCredential._fromParams({
            providerId: GithubAuthProvider.PROVIDER_ID,
            signInMethod: GithubAuthProvider.GITHUB_SIGN_IN_METHOD,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return GithubAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return GithubAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return GithubAuthProvider.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ GithubAuthProvider.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ GithubAuthProvider.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class SAMLAuthCredential extends AuthCredential {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId, signInMethod, pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new SAMLAuthCredential(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new SAMLAuthCredential(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class SAMLAuthProvider extends FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        _assert(providerId.startsWith(SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return SAMLAuthProvider.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return SAMLAuthProvider.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = SAMLAuthCredential.fromJSON(json);
        _assert(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken, providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return SAMLAuthCredential._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class TwitterAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return OAuthCredential._fromParams({
            providerId: TwitterAuthProvider.PROVIDER_ID,
            signInMethod: TwitterAuthProvider.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return TwitterAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return TwitterAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken, oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return TwitterAuthProvider.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ TwitterAuthProvider.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ TwitterAuthProvider.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signUp(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await UserImpl._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = providerIdForResponse(idTokenResponse);
        const userCred = new UserCredentialImpl({
            user,
            providerId,
            _tokenResponse: idTokenResponse,
            operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = providerIdForResponse(response);
        return new UserCredentialImpl({
            user,
            providerId,
            _tokenResponse: response,
            operationType
        });
    }
}
function providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function signInAnonymously(auth) {
    var _a;
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorError extends (0, _util.FirebaseError) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new MultiFactorError(auth, error, operationType, user);
    }
}
function _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function unlink(user, providerId) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo } = await deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function _link$1(user, credential, bypassAuthState = false) {
    const response = await _logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function _assertLinkedStatus(expected, user, provider) {
    await _reloadWithoutSaving(user);
    const providerIds = providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    _assert(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _reauthenticate(user, credential, bypassAuthState = false) {
    const { auth } = user;
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await _logoutIfInvalidated(user, _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        _assert(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = _parseToken(response.idToken);
        _assert(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        _assert(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) _fail(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function signInWithCredential(auth, credential) {
    return _signInWithCredential(_castAuth(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function linkWithCredential(user, credential) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _assertLinkedStatus(false, userInternal, credential.providerId);
    return _link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function reauthenticateWithCredential(user, credential) {
    return _reauthenticate((0, _util.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithCustomToken$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function signInWithCustomToken(auth, customToken) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const response = await signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class PhoneMultiFactorInfoImpl extends MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new PhoneMultiFactorInfoImpl(enrollment);
    }
}
class TotpMultiFactorInfoImpl extends MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    _assert(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    _assert(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    _assert(typeof actionCodeSettings.linkDomain === 'undefined' || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        _assert(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        _assert(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function recachePasswordPolicy(auth) {
    const authInternal = _castAuth(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function sendPasswordResetEmail(auth, email, actionCodeSettings) {
    const authInternal = _castAuth(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) _setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function confirmPasswordReset(auth, oobCode, newPassword) {
    await resetPassword((0, _util.getModularInstance)(auth), {
        oobCode,
        newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function applyActionCode(auth, oobCode) {
    await applyActionCode$1((0, _util.getModularInstance)(auth), {
        oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function checkActionCode(auth, oobCode) {
    const authModular = (0, _util.getModularInstance)(auth);
    const response = await resetPassword(authModular, {
        oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    _assert(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            _assert(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            _assert(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            _assert(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = MultiFactorInfoImpl._fromServerResponse(_castAuth(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo
        },
        operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function verifyPasswordResetCode(auth, code) {
    const { data } = await checkActionCode((0, _util.getModularInstance)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function createUserWithEmailAndPassword(auth, email, password) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const request = {
        returnSecureToken: true,
        email,
        password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function signInWithEmailAndPassword(auth, email, password) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    return signInWithCredential((0, _util.getModularInstance)(auth), EmailAuthProvider.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function sendSignInLinkToEmail(auth, email, actionCodeSettings) {
    const authInternal = _castAuth(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        _assert(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) _setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function isSignInWithEmailLink(auth, emailLink) {
    const actionCodeUrl = ActionCodeURL.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function signInWithEmailLink(auth, email, emailLink) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, _util.getModularInstance)(auth);
    const credential = EmailAuthProvider.credentialWithLink(email, emailLink || _getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    _assert(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return signInWithCredential(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function createAuthUri(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function fetchSignInMethodsForEmail(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = _isHttpOrHttps() ? _getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri
    };
    const { signinMethods } = await createAuthUri((0, _util.getModularInstance)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function sendEmailVerification(user, actionCodeSettings) {
    const userInternal = (0, _util.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken
    };
    if (actionCodeSettings) _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email } = await sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function verifyBeforeUpdateEmail(user, newEmail, actionCodeSettings) {
    const userInternal = (0, _util.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken,
        newEmail
    };
    if (actionCodeSettings) _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email } = await verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function updateProfile$1(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function updateProfile(user, { displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, _util.getModularInstance)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken,
        displayName,
        photoUrl,
        returnSecureToken: true
    };
    const response = await _logoutIfInvalidated(userInternal, updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function updateEmail(user, newEmail) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function updatePassword(user, newPassword) {
    return updateEmailOrPassword((0, _util.getModularInstance)(user), null, newPassword);
}
async function updateEmailOrPassword(user, email, password) {
    const { auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await _logoutIfInvalidated(user, updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function _fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = _parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class FederatedAdditionalUserInfoWithUsername extends GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class FacebookAdditionalUserInfo extends GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class GithubAdditionalUserInfo extends FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class GoogleAdditionalUserInfo extends GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class TwitterAdditionalUserInfo extends FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function getAdditionalUserInfo(userCredential) {
    const { user, _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return _fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function setPersistence(auth, persistence) {
    return (0, _util.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function initializeRecaptchaConfig(auth) {
    return _initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function validatePassword(auth, password) {
    const authInternal = _castAuth(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function onIdTokenChanged(auth, nextOrObserver, error, completed) {
    return (0, _util.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function beforeAuthStateChanged(auth, callback, onAbort) {
    return (0, _util.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function onAuthStateChanged(auth, nextOrObserver, error, completed) {
    return (0, _util.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function useDeviceLanguage(auth) {
    (0, _util.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function updateCurrentUser(auth, user) {
    return (0, _util.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function signOut(auth) {
    return (0, _util.getModularInstance)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function revokeAccessToken(auth, token) {
    const authInternal = _castAuth(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function deleteUser(user) {
    return (0, _util.getModularInstance)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = _castAuth(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        _assert(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    _assert(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function getMultiFactorResolver(auth, error) {
    var _a;
    const authModular = (0, _util.getModularInstance)(auth);
    const errorInternal = error;
    _assert(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    _assert((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function startEnrollPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function finalizeEnrollPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function startEnrollTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function finalizeEnrollTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function withdrawMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , _addTidIfNecessary(auth, request));
}
class MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new MultiFactorUserImpl(user);
    }
    async getSession() {
        return MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await _logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await _logoutIfInvalidated(this.user, withdrawMfa(this.user.auth, {
                idToken,
                mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function multiFactor(user) {
    const userModular = (0, _util.getModularInstance)(user);
    if (!multiFactorUserCache.has(userModular)) multiFactorUserCache.set(userModular, MultiFactorUserImpl._fromUser(userModular));
    return multiFactorUserCache.get(userModular);
}
const STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem(STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem(STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const _POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class BrowserLocalPersistence extends BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = _isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if (_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key,
                    oldValue,
                    newValue
                }), /* poll */ true);
            });
        }, _POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const browserLocalPersistence = BrowserLocalPersistence;
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const POLLING_INTERVAL_MS = 1000;
// Pull a cookie value from document.cookie
function getDocumentCookie(name) {
    var _a, _b;
    const escapedName = name.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const matcher = RegExp(`${escapedName}=([^;]+)`);
    return (_b = (_a = document.cookie.match(matcher)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : null;
}
// Produce a sanitized cookie name from the persistence key
function getCookieName(key) {
    // __HOST- doesn't work in localhost https://issues.chromium.org/issues/40196122 but it has
    // desirable security properties, so lets use a different cookie name while in dev-mode.
    // Already checked isSecureContext in _isAvailable, so if it's http we're hitting local.
    const isDevMode = window.location.protocol === 'http:';
    return `${isDevMode ? '__dev_' : '__HOST-'}FIREBASE_${key.split(':')[3]}`;
}
class CookiePersistence {
    constructor(){
        this.type = "COOKIE" /* PersistenceType.COOKIE */ ;
        this.listenerUnsubscribes = new Map();
    }
    // used to get the URL to the backend to proxy to
    _getFinalTarget(originalUrl) {
        const url = new URL(`${window.location.origin}/__cookies__`);
        url.searchParams.set('finalTarget', originalUrl);
        return url;
    }
    // To be a usable persistence method in a chain browserCookiePersistence ensures that
    // prerequisites have been met, namely that we're in a secureContext, navigator and document are
    // available and cookies are enabled. Not all UAs support these method, so fallback accordingly.
    async _isAvailable() {
        var _a;
        if (typeof isSecureContext === 'boolean' && !isSecureContext) return false;
        if (typeof navigator === 'undefined' || typeof document === 'undefined') return false;
        return (_a = navigator.cookieEnabled) !== null && _a !== void 0 ? _a : true;
    }
    // Set should be a noop as we expect middleware to handle this
    async _set(_key, _value) {
        return;
    }
    // Attempt to get the cookie from cookieStore, fallback to document.cookie
    async _get(key) {
        if (!this._isAvailable()) return null;
        const name = getCookieName(key);
        if (window.cookieStore) {
            const cookie = await window.cookieStore.get(name);
            return cookie === null || cookie === void 0 ? void 0 : cookie.value;
        }
        return getDocumentCookie(name);
    }
    // Log out by overriding the idToken with a sentinel value of ""
    async _remove(key) {
        if (!this._isAvailable()) return;
        // To make sure we don't hit signout over and over again, only do this operation if we need to
        // with the logout sentinel value of "" this can cause race conditions. Unnecessary set-cookie
        // headers will reduce CDN hit rates too.
        const existingValue = await this._get(key);
        if (!existingValue) return;
        const name = getCookieName(key);
        document.cookie = `${name}=;Max-Age=34560000;Partitioned;Secure;SameSite=Strict;Path=/;Priority=High`;
        await fetch(`/__cookies__`, {
            method: 'DELETE'
        }).catch(()=>undefined);
    }
    // Listen for cookie changes, both cookieStore and fallback to polling document.cookie
    _addListener(key, listener) {
        if (!this._isAvailable()) return;
        const name = getCookieName(key);
        if (window.cookieStore) {
            const cb = (event)=>{
                const changedCookie = event.changed.find((change)=>change.name === name);
                if (changedCookie) listener(changedCookie.value);
                const deletedCookie = event.deleted.find((change)=>change.name === name);
                if (deletedCookie) listener(null);
            };
            const unsubscribe = ()=>window.cookieStore.removeEventListener('change', cb);
            this.listenerUnsubscribes.set(listener, unsubscribe);
            return window.cookieStore.addEventListener('change', cb);
        }
        let lastValue = getDocumentCookie(name);
        const interval = setInterval(()=>{
            const currentValue = getDocumentCookie(name);
            if (currentValue !== lastValue) {
                listener(currentValue);
                lastValue = currentValue;
            }
        }, POLLING_INTERVAL_MS);
        const unsubscribe = ()=>clearInterval(interval);
        this.listenerUnsubscribes.set(listener, unsubscribe);
    }
    _removeListener(_key, listener) {
        const unsubscribe = this.listenerUnsubscribes.get(listener);
        if (!unsubscribe) return;
        unsubscribe();
        this.listenerUnsubscribes.delete(listener);
    }
}
CookiePersistence.type = 'COOKIE';
/**
 * An implementation of {@link Persistence} of type `COOKIE`, for use on the client side in
 * applications leveraging hybrid rendering and middleware.
 *
 * @remarks This persistence method requires companion middleware to function, such as that provided
 * by {@link https://firebaseopensource.com/projects/firebaseextended/reactfire/ | ReactFire} for
 * NextJS.
 * @beta
 */ const browserCookiePersistence = CookiePersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class BrowserSessionPersistence extends BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const browserSessionPersistence = BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function _allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId, eventType, data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId,
            eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await _allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId,
            eventType,
            response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _generateEventId(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = _generateEventId('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType,
                eventId,
                data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function _window() {
    return window;
}
function _setWindowLocation(url) {
    _window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _isWorker() {
    return typeof _window()['WorkerGlobalScope'] !== 'undefined' && typeof _window()['importScripts'] === 'function';
}
async function _getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function _getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function _getWorkerGlobalScope() {
    return _isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DB_NAME = 'firebaseLocalStorageDb';
const DB_VERSION = 1;
const DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function getObjectStore(db, isReadWrite) {
    return db.transaction([
        DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore(DB_OBJECTSTORE_NAME);
}
function _deleteDatabase() {
    const request = indexedDB.deleteDatabase(DB_NAME);
    return new DBPromise(request).toPromise();
}
function _openDatabase() {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore(DB_OBJECTSTORE_NAME, {
                    keyPath: DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains(DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await _deleteDatabase();
                resolve(await _openDatabase());
            } else resolve(db);
        });
    });
}
async function _putObject(db, key, value) {
    const request = getObjectStore(db, true).put({
        [DB_DATA_KEYPATH]: key,
        value
    });
    return new DBPromise(request).toPromise();
}
async function getObject(db, key) {
    const request = getObjectStore(db, false).get(key);
    const data = await new DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function _deleteObject(db, key) {
    const request = getObjectStore(db, true).delete(key);
    return new DBPromise(request).toPromise();
}
const _POLLING_INTERVAL_MS = 800;
const _TRANSACTION_RETRY_COUNT = 3;
class IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await _openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > _TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return _isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = Receiver._getInstance(_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await _getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || _getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await _openDatabase();
            await _putObject(db, STORAGE_AVAILABLE_KEY, '1');
            await _deleteObject(db, STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = getObjectStore(db, false).getAll();
            return new DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), _POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const indexedDBLocalPersistence = IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function startSignInPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , _addTidIfNecessary(auth, request));
}
function finalizeSignInPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , _addTidIfNecessary(auth, request));
}
function finalizeSignInTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const _JSLOAD_CALLBACK = _generateCallbackName('rcb');
const NETWORK_TIMEOUT_DELAY = new Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = _window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = '') {
        _assert(isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && isV2(_window().grecaptcha)) return Promise.resolve(_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = _window().setTimeout(()=>{
                reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, NETWORK_TIMEOUT_DELAY.get());
            _window()[_JSLOAD_CALLBACK] = ()=>{
                _window().clearTimeout(networkTimeout);
                delete _window()[_JSLOAD_CALLBACK];
                const recaptcha = _window().grecaptcha;
                if (!recaptcha || !isV2(recaptcha)) {
                    reject(_createError(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${_recaptchaV2ScriptUrl()}?${(0, _util.querystring)({
                onload: _JSLOAD_CALLBACK,
                render: 'explicit',
                hl
            })}`;
            _loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject(_createError(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = _window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class MockReCaptchaLoaderImpl {
    async load(auth) {
        return new MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class RecaptchaVerifier {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = _castAuth(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        _assert(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        _assert(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new MockReCaptchaLoaderImpl() : new ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        _assert(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        _assert(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        _assert(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = _window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        _assert(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        _assert(_isHttpOrHttps() && !_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await getRecaptchaParams(this.auth);
        _assert(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        _assert(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = PhoneAuthCredential._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function signInWithPhoneNumber(auth, phoneNumber, appVerifier) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const verificationId = await _verifyPhoneNumber(authInternal, phoneNumber, (0, _util.getModularInstance)(appVerifier));
    return new ConfirmationResultImpl(verificationId, (cred)=>signInWithCredential(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function linkWithPhoneNumber(user, phoneNumber, appVerifier) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await _verifyPhoneNumber(userInternal.auth, phoneNumber, (0, _util.getModularInstance)(appVerifier));
    return new ConfirmationResultImpl(verificationId, (cred)=>linkWithCredential(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function reauthenticateWithPhoneNumber(user, phoneNumber, appVerifier) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await _verifyPhoneNumber(userInternal.auth, phoneNumber, (0, _util.getModularInstance)(appVerifier));
    return new ConfirmationResultImpl(verificationId, (cred)=>reauthenticateWithCredential(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function _verifyPhoneNumber(auth, options, verifier) {
    var _a;
    if (!auth._getRecaptchaConfig()) try {
        await _initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                _assert(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === FAKE_TOKEN) {
                        _assert((verifier === null || verifier === void 0 ? void 0 : verifier.type) === RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await injectRecaptchaV2Token(authInstance, request, verifier);
                        return startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                _assert(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                _assert(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === FAKE_TOKEN) {
                        _assert((verifier === null || verifier === void 0 ? void 0 : verifier.type) === RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await injectRecaptchaV2Token(authInstance, request, verifier);
                        return startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === FAKE_TOKEN) {
                    _assert((verifier === null || verifier === void 0 ? void 0 : verifier.type) === RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await injectRecaptchaV2Token(authInstance, request, verifier);
                    return sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier === null || verifier === void 0 || verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function updatePhoneNumber(user, credential) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await _link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    _assert(recaptchaV2Verifier.type === RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    _assert(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = Object.assign({}, request);
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse,
                clientType,
                recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse,
                clientType,
                recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class PhoneAuthProvider {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = PhoneAuthProvider.PROVIDER_ID;
        this.auth = _castAuth(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return _verifyPhoneNumber(this.auth, phoneOptions, (0, _util.getModularInstance)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return PhoneAuthCredential._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return PhoneAuthProvider.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return PhoneAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber, temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return PhoneAuthCredential._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ PhoneAuthProvider.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ PhoneAuthProvider.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function _withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return _getInstance(resolverOverride);
    _assert(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class IdpCredential extends AuthCredential {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function _signIn(params) {
    return _signInWithCredential(params.auth, new IdpCredential(params), params.bypassAuthState);
}
function _reauth(params) {
    const { auth, user } = params;
    _assert(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return _reauthenticate(user, new IdpCredential(params), params.bypassAuthState);
}
async function _link(params) {
    const { auth, user } = params;
    _assert(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return _link$1(user, new IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve,
                reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse, sessionId, postBody, tenantId, error, type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return _signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return _link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return _reauth;
            default:
                _fail(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        debugAssert(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        debugAssert(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const _POLL_WINDOW_CLOSE_TIMEOUT = new Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function signInWithPopup(auth, provider, resolver) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_createError(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = _castAuth(auth);
    _assertInstanceOf(auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(authInternal, resolver);
    const action = new PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function reauthenticateWithPopup(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_createError(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    const action = new PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function linkWithPopup(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    const action = new PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class PopupOperation extends AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if (PopupOperation.currentPopupAction) PopupOperation.currentPopupAction.cancel();
        PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        _assert(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        debugAssert(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = _generateEventId();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject(_createError(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject(_createError(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject(_createError(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, _POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const redirectOutcomeMap = new Map();
class RedirectAction extends AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await _getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function _getAndClearPendingRedirectStatus(resolver, auth) {
    const key = pendingRedirectKey(auth);
    const persistence = resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function _setPendingRedirectStatus(resolver, auth) {
    return resolverPersistence(resolver)._set(pendingRedirectKey(auth), 'true');
}
function _clearRedirectOutcomes() {
    redirectOutcomeMap.clear();
}
function _overrideRedirectResult(auth, result) {
    redirectOutcomeMap.set(auth._key(), result);
}
function resolverPersistence(resolver) {
    return _getInstance(resolver._redirectPersistence);
}
function pendingRedirectKey(auth) {
    return _persistenceKeyName(PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function signInWithRedirect(auth, provider, resolver) {
    return _signInWithRedirect(auth, provider, resolver);
}
async function _signInWithRedirect(auth, provider, resolver) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    _assertInstanceOf(auth, provider, FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = _withDefaultResolver(authInternal, resolver);
    await _setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function reauthenticateWithRedirect(user, provider, resolver) {
    return _reauthenticateWithRedirect(user, provider, resolver);
}
async function _reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    await _setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function linkWithRedirect(user, provider, resolver) {
    return _linkWithRedirect(user, provider, resolver);
}
async function _linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    await _assertLinkedStatus(false, userInternal, provider.providerId);
    await _setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function getRedirectResult(auth, resolver) {
    await _castAuth(auth)._initializationPromise;
    return _getRedirectResult(auth, resolver, false);
}
async function _getRedirectResult(auth, resolverExtern, bypassAuthState = false) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const resolver = _withDefaultResolver(authInternal, resolverExtern);
    const action = new RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function prepareUserForRedirect(user) {
    const eventId = _generateEventId(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class AuthEventManager {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError(_createError(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has(eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add(eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function isNullRedirectEvent({ type, error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _getProjectConfig(auth, request = {}) {
    return _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const HTTP_REGEX = /^https?/;
async function _validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains } = await _getProjectConfig(auth);
    for (const domain of authorizedDomains)try {
        if (matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    _fail(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function matchDomain(expected) {
    const currentUrl = _getCurrentUrl();
    const { protocol, hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!HTTP_REGEX.test(protocol)) return false;
    if (IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const NETWORK_TIMEOUT = new Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = _window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    resetUnloadedGapiModules();
                    reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = _window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = _window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = _generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            _window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return _loadJS(`${_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        cachedGApiLoader = null;
        throw error;
    });
}
let cachedGApiLoader = null;
function _loadGapi(auth) {
    cachedGApiLoader = cachedGApiLoader || loadGapi(auth);
    return cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const PING_TIMEOUT = new Delay(5000, 15000);
const IFRAME_PATH = '__/auth/iframe';
const EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function getIframeUrl(auth) {
    const config = auth.config;
    _assert(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? _emulatorUrl(config, EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, _app.SDK_VERSION)
    };
    const eid = EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, _util.querystring)(params).slice(1)}`;
}
async function _openIframe(auth) {
    const context = await _loadGapi(auth);
    const gapi1 = _window().gapi;
    _assert(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = _createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = _window().setTimeout(()=>{
                reject(networkError);
            }, PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                _window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const DEFAULT_WIDTH = 500;
const DEFAULT_HEIGHT = 600;
const TARGET_BLANK = '_blank';
const FIREFOX_EMPTY_URL = 'http://localhost';
class AuthPopup {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function _open(auth, url, name, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = Object.assign(Object.assign({}, BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top,
        left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, _util.getUA)().toLowerCase();
    if (name) target = _isChromeIOS(ua) ? TARGET_BLANK : name;
    if (_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if (_isIOSStandalone(ua) && target !== '_self') {
        openAsNewWindowIOS(url || '', target);
        return new AuthPopup(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    _assert(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new AuthPopup(newWin);
}
function openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function _getRedirectUrl(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    _assert(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    _assert(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType,
        redirectUrl,
        v: (0, _app.SDK_VERSION),
        eventId
    };
    if (provider instanceof FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, _util.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${getHandlerBase(auth)}?${(0, _util.querystring)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function getHandlerBase({ config }) {
    if (!config.emulator) return `https://${config.authDomain}/${WIDGET_PATH}`;
    return _emulatorUrl(config, EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = browserSessionPersistence;
        this._completeRedirectFn = _getRedirectResult;
        this._overrideRedirectResult = _overrideRedirectResult;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        debugAssert((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
        const url = await _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);
        return _open(auth, url, _generateEventId());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);
        _setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager, promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                debugAssert(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await _openIframe(auth);
        const manager = new AuthEventManager(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            _assert(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send(WEB_STORAGE_SUPPORT_KEY, {
            type: WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = _validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return _isMobileBrowser() || _isSafari() || _isIOS();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const browserPopupRedirectResolver = BrowserPopupRedirectResolver;
class MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class PhoneMultiFactorAssertionImpl extends MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return finalizeEnrollPhoneMfa(auth, {
            idToken,
            displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class PhoneMultiFactorGenerator {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ PhoneMultiFactorGenerator.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class TotpMultiFactorGenerator {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        _assert(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return TotpSecret._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ TotpMultiFactorGenerator.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class TotpMultiFactorAssertionImpl extends MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        _assert(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return finalizeEnrollTotpMfa(auth, {
            idToken,
            displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        _assert(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return finalizeSignInTotpMfa(auth, {
            mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class TotpSecret {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new TotpSecret(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if (_isEmptyString(accountName) || _isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if (_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || 'unknownuser';
            if (_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function _isEmptyString(input) {
    return typeof input === 'undefined' || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var name = "@firebase/auth";
var version = "1.10.7";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        _assert(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function registerAuth(clientPlatform) {
    (0, _app._registerComponent)(new (0, _component.Component)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey, authDomain } = app.options;
        _assert(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey,
            authDomain,
            clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: _getClientVersion(clientPlatform)
        };
        const authInstance = new AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        _initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, _app._registerComponent)(new (0, _component.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = _castAuth(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, _app.registerVersion)(name, version, getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, _app.registerVersion)(name, version, 'esm2017');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DEFAULT_ID_TOKEN_MAX_AGE = 300;
const authIdTokenMaxAge = (0, _util.getExperimentalSetting)('authIdTokenMaxAge') || DEFAULT_ID_TOKEN_MAX_AGE;
let lastPostedIdToken = null;
const mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if (lastPostedIdToken === idToken) return;
        lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function getAuth(app = (0, _app.getApp)()) {
    const provider = (0, _app._getProvider)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = initializeAuth(app, {
        popupRedirectResolver: browserPopupRedirectResolver,
        persistence: [
            indexedDBLocalPersistence,
            browserLocalPersistence,
            browserSessionPersistence
        ]
    });
    const authTokenSyncPath = (0, _util.getExperimentalSetting)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = mintCookieFactory(authTokenSyncUrl.toString());
            beforeAuthStateChanged(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            onIdTokenChanged(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, _util.getDefaultEmulatorHost)('auth');
    if (authEmulatorHost) connectAuthEmulator(auth, `http://${authEmulatorHost}`);
    return auth;
}
function getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = _createError("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
registerAuth("Browser" /* ClientPlatform.BROWSER */ );

},{"@firebase/app":"1SyrH","@firebase/util":"guJD8","@firebase/logger":"3ul0m","tslib":"7YykB","@firebase/component":"2tpfU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1SyrH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FirebaseError", ()=>(0, _util.FirebaseError));
parcelHelpers.export(exports, "SDK_VERSION", ()=>SDK_VERSION);
parcelHelpers.export(exports, "_DEFAULT_ENTRY_NAME", ()=>DEFAULT_ENTRY_NAME);
parcelHelpers.export(exports, "_addComponent", ()=>_addComponent);
parcelHelpers.export(exports, "_addOrOverwriteComponent", ()=>_addOrOverwriteComponent);
parcelHelpers.export(exports, "_apps", ()=>_apps);
parcelHelpers.export(exports, "_clearComponents", ()=>_clearComponents);
parcelHelpers.export(exports, "_components", ()=>_components);
parcelHelpers.export(exports, "_getProvider", ()=>_getProvider);
parcelHelpers.export(exports, "_isFirebaseApp", ()=>_isFirebaseApp);
parcelHelpers.export(exports, "_isFirebaseServerApp", ()=>_isFirebaseServerApp);
parcelHelpers.export(exports, "_registerComponent", ()=>_registerComponent);
parcelHelpers.export(exports, "_removeServiceInstance", ()=>_removeServiceInstance);
parcelHelpers.export(exports, "_serverApps", ()=>_serverApps);
parcelHelpers.export(exports, "deleteApp", ()=>deleteApp);
parcelHelpers.export(exports, "getApp", ()=>getApp);
parcelHelpers.export(exports, "getApps", ()=>getApps);
parcelHelpers.export(exports, "initializeApp", ()=>initializeApp);
parcelHelpers.export(exports, "initializeServerApp", ()=>initializeServerApp);
parcelHelpers.export(exports, "onLog", ()=>onLog);
parcelHelpers.export(exports, "registerVersion", ()=>registerVersion);
parcelHelpers.export(exports, "setLogLevel", ()=>setLogLevel);
var _component = require("@firebase/component");
var _logger = require("@firebase/logger");
var _util = require("@firebase/util");
var _idb = require("idb");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const name$q = "@firebase/app";
const version$1 = "0.13.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const logger = new (0, _logger.Logger)('@firebase/app');
const name$p = "@firebase/app-compat";
const name$o = "@firebase/analytics-compat";
const name$n = "@firebase/analytics";
const name$m = "@firebase/app-check-compat";
const name$l = "@firebase/app-check";
const name$k = "@firebase/auth";
const name$j = "@firebase/auth-compat";
const name$i = "@firebase/database";
const name$h = "@firebase/data-connect";
const name$g = "@firebase/database-compat";
const name$f = "@firebase/functions";
const name$e = "@firebase/functions-compat";
const name$d = "@firebase/installations";
const name$c = "@firebase/installations-compat";
const name$b = "@firebase/messaging";
const name$a = "@firebase/messaging-compat";
const name$9 = "@firebase/performance";
const name$8 = "@firebase/performance-compat";
const name$7 = "@firebase/remote-config";
const name$6 = "@firebase/remote-config-compat";
const name$5 = "@firebase/storage";
const name$4 = "@firebase/storage-compat";
const name$3 = "@firebase/firestore";
const name$2 = "@firebase/ai";
const name$1 = "@firebase/firestore-compat";
const name = "firebase";
const version = "11.9.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
    [name$q]: 'fire-core',
    [name$p]: 'fire-core-compat',
    [name$n]: 'fire-analytics',
    [name$o]: 'fire-analytics-compat',
    [name$l]: 'fire-app-check',
    [name$m]: 'fire-app-check-compat',
    [name$k]: 'fire-auth',
    [name$j]: 'fire-auth-compat',
    [name$i]: 'fire-rtdb',
    [name$h]: 'fire-data-connect',
    [name$g]: 'fire-rtdb-compat',
    [name$f]: 'fire-fn',
    [name$e]: 'fire-fn-compat',
    [name$d]: 'fire-iid',
    [name$c]: 'fire-iid-compat',
    [name$b]: 'fire-fcm',
    [name$a]: 'fire-fcm-compat',
    [name$9]: 'fire-perf',
    [name$8]: 'fire-perf-compat',
    [name$7]: 'fire-rc',
    [name$6]: 'fire-rc-compat',
    [name$5]: 'fire-gcs',
    [name$4]: 'fire-gcs-compat',
    [name$3]: 'fire-fst',
    [name$1]: 'fire-fst-compat',
    [name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const _apps = new Map();
/**
 * @internal
 */ const _serverApps = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function _addOrOverwriteComponent(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    for (const app of _apps.values())_addComponent(app, component);
    for (const serverApp of _serverApps.values())_addComponent(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function _getProvider(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function _removeServiceInstance(app, name, instanceIdentifier = DEFAULT_ENTRY_NAME) {
    _getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function _isFirebaseApp(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function _isFirebaseServerApp(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function _clearComponents() {
    _components.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const ERROR_FACTORY = new (0, _util.ErrorFactory)('app', 'Firebase', ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, _component.Component)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, _util.base64Decode)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class FirebaseServerAppImpl extends FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name,
            automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled
        }, serverConfig);
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        registerVersion(name$q, version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        deleteApp(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const SDK_VERSION = version;
function initializeApp(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name
        };
    }
    const config = Object.assign({
        name: DEFAULT_ENTRY_NAME,
        automaticDataCollectionEnabled: true
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, _util.getDefaultAppConfig)());
    if (!options) throw ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, _util.deepEqual)(options, existingApp.options) && (0, _util.deepEqual)(config, existingApp.config)) return existingApp;
        else throw ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, _component.ComponentContainer)(name);
    for (const component of _components.values())container.addComponent(component);
    const newApp = new FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
function initializeServerApp(_options, _serverAppConfig) {
    if ((0, _util.isBrowser)() && !(0, _util.isWebWorker)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = true;
    let appOptions;
    if (_isFirebaseApp(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = _serverApps.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, _component.ComponentContainer)(nameString);
    for (const component of _components.values())container.addComponent(component);
    const newApp = new FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    _serverApps.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function getApp(name = DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name);
    if (!app && name === DEFAULT_ENTRY_NAME && (0, _util.getDefaultAppConfig)()) return initializeApp();
    if (!app) throw ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function getApps() {
    return Array.from(_apps.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function deleteApp(app) {
    let cleanupProviders = false;
    const name = app.name;
    if (_apps.has(name)) {
        cleanupProviders = true;
        _apps.delete(name);
    } else if (_serverApps.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            _serverApps.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function registerVersion(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new (0, _component.Component)(`${library}-version`, ()=>({
            library,
            version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, _logger.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function setLogLevel(logLevel) {
    (0, _logger.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) dbPromise = (0, _idb.openDB)(DB_NAME, DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore(STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME);
        const result = await tx.objectStore(STORE_NAME).get(computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError)) logger.warn(e.message);
        else {
            const idbGetError = ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError)) logger.warn(e.message);
        else {
            const idbGetError = ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const MAX_HEADER_BYTES = 1024;
const MAX_NUM_STORED_HEARTBEATS = 30;
class HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date,
                    agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, _util.base64urlEncodeWithoutPadding)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            logger.warn(e);
            return '';
        }
    }
}
function getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend,
        unsentEntries
    };
}
class HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, _util.isIndexedDBAvailable)()) return false;
        else return (0, _util.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, _util.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function registerCoreComponents(variant) {
    _registerComponent(new (0, _component.Component)('platform-logger', (container)=>new PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    _registerComponent(new (0, _component.Component)('heartbeat', (container)=>new HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    registerVersion(name$q, version$1, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    registerVersion(name$q, version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ registerCoreComponents('');

},{"@firebase/component":"2tpfU","@firebase/logger":"3ul0m","@firebase/util":"guJD8","idb":"d2rZl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2tpfU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", ()=>Component);
parcelHelpers.export(exports, "ComponentContainer", ()=>ComponentContainer);
parcelHelpers.export(exports, "Provider", ()=>Provider);
var _util = require("@firebase/util");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class Component {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class Provider {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, _util.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class ComponentContainer {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

},{"@firebase/util":"guJD8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"guJD8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSTANTS", ()=>CONSTANTS);
parcelHelpers.export(exports, "DecodeBase64StringError", ()=>DecodeBase64StringError);
parcelHelpers.export(exports, "Deferred", ()=>Deferred);
parcelHelpers.export(exports, "ErrorFactory", ()=>ErrorFactory);
parcelHelpers.export(exports, "FirebaseError", ()=>FirebaseError);
parcelHelpers.export(exports, "MAX_VALUE_MILLIS", ()=>MAX_VALUE_MILLIS);
parcelHelpers.export(exports, "RANDOM_FACTOR", ()=>RANDOM_FACTOR);
parcelHelpers.export(exports, "Sha1", ()=>Sha1);
parcelHelpers.export(exports, "areCookiesEnabled", ()=>areCookiesEnabled);
parcelHelpers.export(exports, "assert", ()=>assert);
parcelHelpers.export(exports, "assertionError", ()=>assertionError);
parcelHelpers.export(exports, "async", ()=>async);
parcelHelpers.export(exports, "base64", ()=>base64);
parcelHelpers.export(exports, "base64Decode", ()=>base64Decode);
parcelHelpers.export(exports, "base64Encode", ()=>base64Encode);
parcelHelpers.export(exports, "base64urlEncodeWithoutPadding", ()=>base64urlEncodeWithoutPadding);
parcelHelpers.export(exports, "calculateBackoffMillis", ()=>calculateBackoffMillis);
parcelHelpers.export(exports, "contains", ()=>contains);
parcelHelpers.export(exports, "createMockUserToken", ()=>createMockUserToken);
parcelHelpers.export(exports, "createSubscribe", ()=>createSubscribe);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "deepCopy", ()=>deepCopy);
parcelHelpers.export(exports, "deepEqual", ()=>deepEqual);
parcelHelpers.export(exports, "deepExtend", ()=>deepExtend);
parcelHelpers.export(exports, "errorPrefix", ()=>errorPrefix);
parcelHelpers.export(exports, "extractQuerystring", ()=>extractQuerystring);
parcelHelpers.export(exports, "getDefaultAppConfig", ()=>getDefaultAppConfig);
parcelHelpers.export(exports, "getDefaultEmulatorHost", ()=>getDefaultEmulatorHost);
parcelHelpers.export(exports, "getDefaultEmulatorHostnameAndPort", ()=>getDefaultEmulatorHostnameAndPort);
parcelHelpers.export(exports, "getDefaults", ()=>getDefaults);
parcelHelpers.export(exports, "getExperimentalSetting", ()=>getExperimentalSetting);
parcelHelpers.export(exports, "getGlobal", ()=>getGlobal);
parcelHelpers.export(exports, "getModularInstance", ()=>getModularInstance);
parcelHelpers.export(exports, "getUA", ()=>getUA);
parcelHelpers.export(exports, "isAdmin", ()=>isAdmin);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "isBrowserExtension", ()=>isBrowserExtension);
parcelHelpers.export(exports, "isCloudWorkstation", ()=>isCloudWorkstation);
parcelHelpers.export(exports, "isCloudflareWorker", ()=>isCloudflareWorker);
parcelHelpers.export(exports, "isElectron", ()=>isElectron);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "isIE", ()=>isIE);
parcelHelpers.export(exports, "isIndexedDBAvailable", ()=>isIndexedDBAvailable);
parcelHelpers.export(exports, "isMobileCordova", ()=>isMobileCordova);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isNodeSdk", ()=>isNodeSdk);
parcelHelpers.export(exports, "isReactNative", ()=>isReactNative);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
parcelHelpers.export(exports, "isSafariOrWebkit", ()=>isSafariOrWebkit);
parcelHelpers.export(exports, "isUWP", ()=>isUWP);
parcelHelpers.export(exports, "isValidFormat", ()=>isValidFormat);
parcelHelpers.export(exports, "isValidTimestamp", ()=>isValidTimestamp);
parcelHelpers.export(exports, "isWebWorker", ()=>isWebWorker);
parcelHelpers.export(exports, "issuedAtTime", ()=>issuedAtTime);
parcelHelpers.export(exports, "jsonEval", ()=>jsonEval);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "ordinal", ()=>ordinal);
parcelHelpers.export(exports, "pingServer", ()=>pingServer);
parcelHelpers.export(exports, "promiseWithTimeout", ()=>promiseWithTimeout);
parcelHelpers.export(exports, "querystring", ()=>querystring);
parcelHelpers.export(exports, "querystringDecode", ()=>querystringDecode);
parcelHelpers.export(exports, "safeGet", ()=>safeGet);
parcelHelpers.export(exports, "stringLength", ()=>stringLength);
parcelHelpers.export(exports, "stringToByteArray", ()=>stringToByteArray);
parcelHelpers.export(exports, "stringify", ()=>stringify);
parcelHelpers.export(exports, "updateEmulatorBanner", ()=>updateEmulatorBanner);
parcelHelpers.export(exports, "validateArgCount", ()=>validateArgCount);
parcelHelpers.export(exports, "validateCallback", ()=>validateCallback);
parcelHelpers.export(exports, "validateContextObject", ()=>validateContextObject);
parcelHelpers.export(exports, "validateIndexedDBOpenable", ()=>validateIndexedDBOpenable);
parcelHelpers.export(exports, "validateNamespace", ()=>validateNamespace);
var _postinstallMjs = require("./postinstall.mjs");
var global = arguments[3];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const assert = function(assertion, message) {
    if (!assertion) throw assertionError(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const assertionError = function(message) {
    return new Error('Firebase Database (' + CONSTANTS.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const base64 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new DecodeBase64StringError();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class DecodeBase64StringError extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const base64Encode = function(str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const base64urlEncodeWithoutPadding = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const base64Decode = function(str) {
    try {
        return base64.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function deepExtend(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) continue;
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function getGlobal() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const getDefaultsFromGlobal = ()=>getGlobal().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const getDefaultsFromEnvVariable = ()=>{
    return;
};
const getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && base64Decode(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const getDefaults = ()=>{
    try {
        return (0, _postinstallMjs.getDefaultsFromPostinstall)() || getDefaultsFromGlobal() || getDefaultsFromEnvVariable() || getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const getDefaultEmulatorHost = (productName)=>{
    var _a, _b;
    return (_b = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const getDefaultEmulatorHostnameAndPort = (productName)=>{
    const host = getDefaultEmulatorHost(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const getDefaultAppConfig = ()=>{
    var _a;
    return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const getExperimentalSetting = (name)=>{
    var _a;
    return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class Deferred {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function isCloudWorkstation(host) {
    return host.endsWith('.cloudworkstations.dev');
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function pingServer(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function createMockUserToken(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat,
        exp: iat + 3600,
        auth_time: iat,
        sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        base64urlEncodeWithoutPadding(JSON.stringify(header)),
        base64urlEncodeWithoutPadding(JSON.stringify(payload)),
        signature
    ].join('.');
}
const emulatorStatus = {};
// Checks whether any products are running on an emulator
function getEmulatorSummary() {
    const summary = {
        prod: [],
        emulator: []
    };
    for (const key of Object.keys(emulatorStatus))if (emulatorStatus[key]) summary.emulator.push(key);
    else summary.prod.push(key);
    return summary;
}
function getOrCreateEl(id) {
    let parentDiv = document.getElementById(id);
    let created = false;
    if (!parentDiv) {
        parentDiv = document.createElement('div');
        parentDiv.setAttribute('id', id);
        created = true;
    }
    return {
        created,
        element: parentDiv
    };
}
let previouslyDismissed = false;
/**
 * Updates Emulator Banner. Primarily used for Firebase Studio
 * @param name
 * @param isRunningEmulator
 * @public
 */ function updateEmulatorBanner(name, isRunningEmulator) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !isCloudWorkstation(window.location.host) || emulatorStatus[name] === isRunningEmulator || emulatorStatus[name] || // If already set to use emulator, can't go back to prod.
    previouslyDismissed) return;
    emulatorStatus[name] = isRunningEmulator;
    function prefixedId(id) {
        return `__firebase__banner__${id}`;
    }
    const bannerId = '__firebase__banner';
    const summary = getEmulatorSummary();
    const showError = summary.prod.length > 0;
    function tearDown() {
        const element = document.getElementById(bannerId);
        if (element) element.remove();
    }
    function setupBannerStyles(bannerEl) {
        bannerEl.style.display = 'flex';
        bannerEl.style.background = '#7faaf0';
        bannerEl.style.position = 'fixed';
        bannerEl.style.bottom = '5px';
        bannerEl.style.left = '5px';
        bannerEl.style.padding = '.5em';
        bannerEl.style.borderRadius = '5px';
        bannerEl.style.alignItems = 'center';
    }
    function setupIconStyles(prependIcon, iconId) {
        prependIcon.setAttribute('width', '24');
        prependIcon.setAttribute('id', iconId);
        prependIcon.setAttribute('height', '24');
        prependIcon.setAttribute('viewBox', '0 0 24 24');
        prependIcon.setAttribute('fill', 'none');
        prependIcon.style.marginLeft = '-6px';
    }
    function setupCloseBtn() {
        const closeBtn = document.createElement('span');
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.marginLeft = '16px';
        closeBtn.style.fontSize = '24px';
        closeBtn.innerHTML = ' &times;';
        closeBtn.onclick = ()=>{
            previouslyDismissed = true;
            tearDown();
        };
        return closeBtn;
    }
    function setupLinkStyles(learnMoreLink, learnMoreId) {
        learnMoreLink.setAttribute('id', learnMoreId);
        learnMoreLink.innerText = 'Learn more';
        learnMoreLink.href = 'https://firebase.google.com/docs/studio/preview-apps#preview-backend';
        learnMoreLink.setAttribute('target', '__blank');
        learnMoreLink.style.paddingLeft = '5px';
        learnMoreLink.style.textDecoration = 'underline';
    }
    function setupDom() {
        const banner = getOrCreateEl(bannerId);
        const firebaseTextId = prefixedId('text');
        const firebaseText = document.getElementById(firebaseTextId) || document.createElement('span');
        const learnMoreId = prefixedId('learnmore');
        const learnMoreLink = document.getElementById(learnMoreId) || document.createElement('a');
        const prependIconId = prefixedId('preprendIcon');
        const prependIcon = document.getElementById(prependIconId) || document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        if (banner.created) {
            // update styles
            const bannerEl = banner.element;
            setupBannerStyles(bannerEl);
            setupLinkStyles(learnMoreLink, learnMoreId);
            const closeBtn = setupCloseBtn();
            setupIconStyles(prependIcon, prependIconId);
            bannerEl.append(prependIcon, firebaseText, learnMoreLink, closeBtn);
            document.body.appendChild(bannerEl);
        }
        if (showError) {
            firebaseText.innerText = `Preview backend disconnected.`;
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
        } else {
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
            firebaseText.innerText = 'Preview backend running in this workspace.';
        }
        firebaseText.setAttribute('id', firebaseTextId);
    }
    if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', setupDom);
    else setupDom();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function getUA() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function isMobileCordova() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    var _a;
    const forceEnvironment = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call(global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function isBrowser() {
    return typeof window !== 'undefined' || isWebWorker();
}
/**
 * Detect Web Worker context.
 */ function isWebWorker() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function isCloudflareWorker() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function isBrowserExtension() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function isReactNative() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function isIE() {
    const ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function isSafari() {
    return !isNode() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function isSafariOrWebkit() {
    return !isNode() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function isIndexedDBAvailable() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function validateIndexedDBOpenable() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, ErrorFactory.prototype.create);
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function stringify(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const decode = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header,
        claims,
        data,
        signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const isValidTimestamp = function(token) {
    const claims = decode(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const issuedAtTime = function(token) {
    const claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const isValidFormat = function(token) {
    const decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const isAdmin = function(token) {
    const claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function isEmpty(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function map(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function deepEqual(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function promiseWithTimeout(promise, timeInMS = 2000) {
    const deferredPromise = new Deferred();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function querystring(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function querystringDecode(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function extractQuerystring(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class Sha1 {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function createSubscribe(executor, onNoObservers) {
    const proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error,
            complete
        };
        if (observer.next === undefined) observer.next = noop;
        if (observer.error === undefined) observer.error = noop;
        if (observer.complete === undefined) observer.complete = noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function async(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const validateArgCount = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function errorPrefix(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function validateCallback(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const stringToByteArray = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const stringLength = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const MAX_VALUE_MILLIS = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function calculateBackoffMillis(backoffCount, intervalMillis = DEFAULT_INTERVAL_MILLIS, backoffFactor = DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function ordinal(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getModularInstance(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

},{"./postinstall.mjs":"hw48W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hw48W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultsFromPostinstall", ()=>getDefaultsFromPostinstall);
const getDefaultsFromPostinstall = ()=>undefined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ul0m":[function(require,module,exports,__globalThis) {
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogLevel", ()=>LogLevel);
parcelHelpers.export(exports, "Logger", ()=>Logger);
parcelHelpers.export(exports, "setLogLevel", ()=>setLogLevel);
parcelHelpers.export(exports, "setUserLogHandler", ()=>setUserLogHandler);
const instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */ const defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const ConsoleMethod = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.VERBOSE]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class Logger {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
        this._logHandler(this, LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.VERBOSE, ...args);
        this._logHandler(this, LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
        this._logHandler(this, LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
        this._logHandler(this, LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
        this._logHandler(this, LogLevel.ERROR, ...args);
    }
}
function setLogLevel(level) {
    instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    for (const instance of instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: LogLevel[level].toLowerCase(),
                message,
                args,
                type: instance.name
            });
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d2rZl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrap", ()=>(0, _wrapIdbValueJs.u));
parcelHelpers.export(exports, "wrap", ()=>(0, _wrapIdbValueJs.w));
parcelHelpers.export(exports, "deleteDB", ()=>deleteDB);
parcelHelpers.export(exports, "openDB", ()=>openDB);
var _wrapIdbValueJs = require("./wrap-idb-value.js");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, _wrapIdbValueJs.w)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, _wrapIdbValueJs.w)(request.result), event.oldVersion, event.newVersion, (0, _wrapIdbValueJs.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, _wrapIdbValueJs.w)(request).then(()=>undefined);
}
const readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if (cachedMethods.get(prop)) return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
(0, _wrapIdbValueJs.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!getMethod(target, prop) || oldTraps.has(target, prop)
    }));

},{"./wrap-idb-value.js":"voj9K","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"voj9K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>reverseTransformCache);
parcelHelpers.export(exports, "i", ()=>instanceOfAny);
parcelHelpers.export(exports, "r", ()=>replaceTraps);
parcelHelpers.export(exports, "u", ()=>unwrap);
parcelHelpers.export(exports, "w", ()=>wrap);
const instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return idbProxyableTypes || (idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return cursorAdvanceMethods || (cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve(wrap(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return wrap(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call(unwrap(this), storeNames, ...args);
        transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return wrap(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply(unwrap(this), args);
        return wrap(cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function') return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value)) return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value)=>reverseTransformCache.get(value);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7YykB":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", ()=>__rewriteRelativeImportExtension);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cmjIE":[function(require,module,exports,__globalThis) {
// Import the functions you need from the SDKs you need
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "auth", ()=>auth);
var _auth = require("firebase/auth");
var _app = require("firebase/app");
var _analytics = require("firebase/analytics");
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAv6VP9ikj9vxsiWlj5KjmCLc8GPuYsgxU",
    authDomain: "netflixgpt-a0f7e.firebaseapp.com",
    projectId: "netflixgpt-a0f7e",
    storageBucket: "netflixgpt-a0f7e.firebasestorage.app",
    messagingSenderId: "28282751301",
    appId: "1:28282751301:web:760f4171045d0cd8a1d62c",
    measurementId: "G-GY33357NVG"
};
// Initialize Firebase
const app = (0, _app.initializeApp)(firebaseConfig);
const analytics = (0, _analytics.getAnalytics)(app);
const auth = (0, _auth.getAuth)();

},{"firebase/auth":"dZ6yw","firebase/app":"4uLxM","firebase/analytics":"bDkyG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4uLxM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _app = require("@firebase/app");
parcelHelpers.exportAll(_app, exports);
var name = "firebase";
var version = "11.9.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, _app.registerVersion)(name, version, 'app');

},{"@firebase/app":"1SyrH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bDkyG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _analytics = require("@firebase/analytics");
parcelHelpers.exportAll(_analytics, exports);

},{"@firebase/analytics":"ac8tM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ac8tM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAnalytics", ()=>getAnalytics);
parcelHelpers.export(exports, "getGoogleAnalyticsClientId", ()=>getGoogleAnalyticsClientId);
parcelHelpers.export(exports, "initializeAnalytics", ()=>initializeAnalytics);
parcelHelpers.export(exports, "isSupported", ()=>isSupported);
parcelHelpers.export(exports, "logEvent", ()=>logEvent);
parcelHelpers.export(exports, "setAnalyticsCollectionEnabled", ()=>setAnalyticsCollectionEnabled);
parcelHelpers.export(exports, "setConsent", ()=>setConsent);
parcelHelpers.export(exports, "setCurrentScreen", ()=>setCurrentScreen);
parcelHelpers.export(exports, "setDefaultEventParameters", ()=>setDefaultEventParameters);
parcelHelpers.export(exports, "setUserId", ()=>setUserId);
parcelHelpers.export(exports, "setUserProperties", ()=>setUserProperties);
parcelHelpers.export(exports, "settings", ()=>settings);
var _app = require("@firebase/app");
var _logger = require("@firebase/logger");
var _util = require("@firebase/util");
var _component = require("@firebase/component");
var _installations = require("@firebase/installations");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const GA_FID_KEY = 'firebase_id';
const ORIGIN_KEY = 'origin';
const FETCH_TIMEOUT_MILLIS = 60000;
const DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const logger = new (0, _logger.Logger)('@firebase/analytics');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-initialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const ERROR_FACTORY = new (0, _util.ErrorFactory)('analytics', 'Analytics', ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith(GTAG_URL)) {
        const err = ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever initialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [consentAction, gtagParams] = args;
                // consentAction can be one of 'default' or 'update'.
                gtagCore("consent" /* GtagCommand.CONSENT */ , consentAction, gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === 'function') // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes(GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class RetryData {
    constructor(throttleMetadata = {}, intervalMillis = BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const defaultRetryData = new RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function fetchDynamicConfig(appFields) {
    var _a;
    const { appId, apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: getHeaders(apiKey)
    };
    const appUrl = DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = defaultRetryData, timeoutMillis) {
    const { appId, apiKey, measurementId } = app.options;
    if (!appId) throw ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId,
            appId
        };
        throw ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : FETCH_TIMEOUT_MILLIS);
    return attemptFetchDynamicConfigWithRetry({
        appId,
        apiKey,
        measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis, backoffCount }, signal, retryData = defaultRetryData // for testing
) {
    var _a;
    const { appId, measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId,
                measurementId
            };
        }
        throw e;
    }
    try {
        const response = await fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId,
                    measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, _util.calculateBackoffMillis)(backoffCount, retryData.intervalMillis, LONG_RETRY_FACTOR) : (0, _util.calculateBackoffMillis)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject(ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function isRetriableError(e) {
    if (!(e instanceof (0, _util.FirebaseError)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            'send_to': measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'screen_name': screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'user_id': id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, 'client_id', (clientId)=>{
            if (!clientId) reject(ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function _setConsentDefaultForInit(consentSettings) {
    defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function _setDefaultEventParametersForInit(customParams) {
    defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function validateIndexedDB() {
    if (!(0, _util.isIndexedDBAvailable)()) {
        logger.warn(ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    } else try {
        await (0, _util.validateIndexedDBOpenable)();
    } catch (e) {
        logger.warn(ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function _initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!findGtagScriptOnPage(dataLayerName)) insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if (defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , 'default', defaultConsentSettingsForInit);
        _setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) configProperties[GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if (defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , defaultEventParametersForInit);
        _setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function settings(options) {
    if (globalInitDone) throw ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) dataLayerName = options.dataLayerName;
    if (options.gtagName) gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, _util.isBrowserExtension)()) mismatchedEnvMessages.push('This is a browser extension environment.');
    if (!(0, _util.areCookiesEnabled)()) mismatchedEnvMessages.push('Cookies are not available.');
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(' ');
        const err = ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function factory(app, installations, options) {
    warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if (initializationPromisesMap[appId] != null) throw ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        getOrCreateDataLayer(dataLayerName);
        const { wrappedGtag, gtagCore } = wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagName);
        wrappedGtagFunction = wrappedGtag;
        gtagCoreFunction = gtagCore;
        globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    initializationPromisesMap[appId] = _initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCoreFunction, dataLayerName, options);
    const analyticsInstance = new AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function getAnalytics(app = (0, _app.getApp)()) {
    app = (0, _util.getModularInstance)(app);
    // Dependencies
    const analyticsProvider = (0, _app._getProvider)(app, ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return initializeAnalytics(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function initializeAnalytics(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, _app._getProvider)(app, ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, _util.deepEqual)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function isSupported() {
    if ((0, _util.isBrowserExtension)()) return false;
    if (!(0, _util.areCookiesEnabled)()) return false;
    if (!(0, _util.isIndexedDBAvailable)()) return false;
    try {
        const isDBOpenable = await (0, _util.validateIndexedDBOpenable)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function setCurrentScreen(analyticsInstance, screenName, options) {
    analyticsInstance = (0, _util.getModularInstance)(analyticsInstance);
    setCurrentScreen$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function getGoogleAnalyticsClientId(analyticsInstance) {
    analyticsInstance = (0, _util.getModularInstance)(analyticsInstance);
    return internalGetGoogleAnalyticsClientId(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function setUserId(analyticsInstance, id, options) {
    analyticsInstance = (0, _util.getModularInstance)(analyticsInstance);
    setUserId$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function setUserProperties(analyticsInstance, properties, options) {
    analyticsInstance = (0, _util.getModularInstance)(analyticsInstance);
    setUserProperties$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function setAnalyticsCollectionEnabled(analyticsInstance, enabled) {
    analyticsInstance = (0, _util.getModularInstance)(analyticsInstance);
    setAnalyticsCollectionEnabled$1(initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function setDefaultEventParameters(customParams) {
    // Check if reference to existing gtag function on window object exists
    if (wrappedGtagFunction) wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else _setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function logEvent(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, _util.getModularInstance)(analyticsInstance);
    logEvent$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function setConsent(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if (wrappedGtagFunction) wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , 'update', consentSettings);
    else _setConsentDefaultForInit(consentSettings);
}
const name = "@firebase/analytics";
const version = "0.10.16";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ function registerAnalytics() {
    (0, _app._registerComponent)(new (0, _component.Component)(ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container.getProvider('installations-internal').getImmediate();
        return factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, _app._registerComponent)(new (0, _component.Component)('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, _app.registerVersion)(name, version);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, _app.registerVersion)(name, version, 'esm2017');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider(ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>logEvent(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
registerAnalytics();

},{"@firebase/app":"1SyrH","@firebase/logger":"3ul0m","@firebase/util":"guJD8","@firebase/component":"2tpfU","@firebase/installations":"6vIbf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6vIbf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteInstallations", ()=>deleteInstallations);
parcelHelpers.export(exports, "getId", ()=>getId);
parcelHelpers.export(exports, "getInstallations", ()=>getInstallations);
parcelHelpers.export(exports, "getToken", ()=>getToken);
parcelHelpers.export(exports, "onIdChange", ()=>onIdChange);
var _app = require("@firebase/app");
var _component = require("@firebase/component");
var _util = require("@firebase/util");
var _idb = require("idb");
const name = "@firebase/installations";
const version = "0.6.17";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const PENDING_TIMEOUT_MS = 10000;
const PACKAGE_VERSION = `w:${version}`;
const INTERNAL_AUTH_VERSION = 'FIS_v2';
const INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const SERVICE = 'installations';
const SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const ERROR_FACTORY = new (0, _util.ErrorFactory)(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function isServerError(error) {
    return error instanceof (0, _util.FirebaseError) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getInstallationsEndpoint({ projectId }) {
    return `${INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function getHeaders({ apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, { refreshToken }) {
    const headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return `${INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function createInstallationRequest({ appConfig, heartbeatServiceProvider }, { fid }) {
    const endpoint = getInstallationsEndpoint(appConfig);
    const headers = getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid,
        authVersion: INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function encode(fidByteArray) {
    const b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function fidChanged(appConfig, fid) {
    const key = getKey(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    getBroadcastChannel();
    const key = getKey(appConfig);
    let callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
    const key = getKey(appConfig);
    const callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
    const callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function broadcastFidChange(key, fid) {
    const channel = getBroadcastChannel();
    if (channel) channel.postMessage({
        key,
        fid
    });
    closeBroadcastChannel();
}
let broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function getBroadcastChannel() {
    if (!broadcastChannel && 'BroadcastChannel' in self) {
        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        broadcastChannel.onmessage = (e)=>{
            callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DATABASE_NAME = 'firebase-installations-database';
const DATABASE_VERSION = 1;
const OBJECT_STORE_NAME = 'firebase-installations-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) dbPromise = (0, _idb.openDB)(DATABASE_NAME, DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore(OBJECT_STORE_NAME);
            }
        }
    });
    return dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function set(appConfig, value) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function remove(appConfig) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function update(appConfig, updateFn) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await update(installations.appConfig, (oldEntry)=>{
        const installationEntry = updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry,
        registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry,
        registrationPromise: waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await createInstallationRequest(installations, installationEntry);
        return set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if (isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await sleep(100);
        entry = await updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry, registrationPromise } = await getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function updateInstallationRequest(appConfig) {
    return update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function generateAuthTokenRequest({ appConfig, heartbeatServiceProvider }, installationEntry) {
    const endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await getErrorFromResponse('Generate Auth Token', response);
}
function getGenerateAuthTokenEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await update(installations.appConfig, (oldEntry)=>{
        if (!isEntryRegistered(oldEntry)) throw ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await sleep(100);
        entry = await updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function updateAuthTokenRequest(appConfig) {
    return update(appConfig, (oldEntry)=>{
        if (!isEntryRegistered(oldEntry)) throw ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken
        });
        await set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if (isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !isAuthTokenExpired(authToken);
}
function isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function getId(installations) {
    const installationsImpl = installations;
    const { installationEntry, registrationPromise } = await getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function getToken(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function completeInstallationRegistration(installations) {
    const { registrationPromise } = await getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = getDeleteEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers
    };
    const response = await retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await getErrorFromResponse('Delete Installation', response);
}
function getDeleteEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function deleteInstallations(installations) {
    const { appConfig } = installations;
    const entry = await update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await deleteInstallationRequest(appConfig, entry);
                await remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function onIdChange(installations, callback) {
    const { appConfig } = installations;
    addCallback(appConfig, callback);
    return ()=>{
        removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function getInstallations(app = (0, _app.getApp)()) {
    const installationsImpl = (0, _app._getProvider)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function extractAppConfig(app) {
    if (!app || !app.options) throw getMissingValueError('App Configuration');
    if (!app.name) throw getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const INSTALLATIONS_NAME = 'installations';
const INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = extractAppConfig(app);
    const heartbeatServiceProvider = (0, _app._getProvider)(app, 'heartbeat');
    const installationsImpl = {
        app,
        appConfig,
        heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, _app._getProvider)(app, INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>getId(installations),
        getToken: (forceRefresh)=>getToken(installations, forceRefresh)
    };
    return installationsInternal;
};
function registerInstallations() {
    (0, _app._registerComponent)(new (0, _component.Component)(INSTALLATIONS_NAME, publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, _app._registerComponent)(new (0, _component.Component)(INSTALLATIONS_NAME_INTERNAL, internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ registerInstallations();
(0, _app.registerVersion)(name, version);
// BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
(0, _app.registerVersion)(name, version, 'esm2017');

},{"@firebase/app":"1SyrH","@firebase/component":"2tpfU","@firebase/util":"guJD8","idb":"d2rZl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Io6av":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toggleGpt", ()=>toggleGpt);
parcelHelpers.export(exports, "setLanguage", ()=>setLanguage);
var _toolkit = require("@reduxjs/toolkit");
const featureSlice = (0, _toolkit.createSlice)({
    name: "feature",
    initialState: {
        gptSearch: false,
        language: "English"
    },
    reducers: {
        toggleGpt: (state)=>{
            state.gptSearch = !state.gptSearch;
        },
        setLanguage: (state, action)=>{
            state.language = action.payload;
        }
    }
});
const { toggleGpt, setLanguage } = featureSlice.actions;
exports.default = featureSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fZCF6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TMDB_API_OPTIONS", ()=>TMDB_API_OPTIONS);
parcelHelpers.export(exports, "TMDB_IMG_CDN", ()=>TMDB_IMG_CDN);
parcelHelpers.export(exports, "language", ()=>language);
const TMDB_API_OPTIONS = {
    method: "GET",
    headers: {
        accept: "application/json",
        Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJmZTM0ZTBkYTQxMWI0NTU4NzZhYTFjYTg3YTEzNTg0NSIsIm5iZiI6MTc0OTg4MjA3OC4xNjgsInN1YiI6IjY4NGQxNGRlYmJmZTMxY2M5MDI5NDZkOSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.RJqDRlB-66S-QapgQF13ormzXVO-THzcxXGjDaInVtI"} `
    }
};
const TMDB_IMG_CDN = "https://image.tmdb.org/t/p/original/";
const language = {
    English: {
        search: "Search",
        placeholder: "Search for movies"
    },
    Hindi: {
        search: "\u0916\u094B\u091C\u0947\u0902",
        placeholder: "\u092B\u093C\u093F\u0932\u094D\u092E\u0947\u0902 \u0916\u094B\u091C\u0947\u0902"
    },
    French: {
        search: "Recherche",
        placeholder: "Rechercher des films"
    },
    German: {
        search: "Suchen",
        placeholder: "Nach Filmen suchen"
    },
    Spanish: {
        search: "buscar",
        placeholder: "buscar peliculas"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eTDOq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MobileHeader);
var _jsxRuntime = require("react/jsx-runtime");
function MobileHeader({ feature, handleGptClick, setShowMenu, showMenu, signOutUser, user }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex absolute w-full p-2 bg-gradient-to-b from-10%  from-black z-20 justify-between align-middle  ",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: user.accesstoken && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "cursor-pointer py-2 px-4 rounded-lg bg-gradient-to-bl from-blue-900 to-red-500 text-white hover:scale-105 duration-300 text-xs  shadow-md shadow-red-500/50 ",
                    onClick: ()=>handleGptClick(),
                    children: feature.gptSearch ? "Homepage" : "AI Search"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: "https://help.nflxext.com/helpcenter/OneTrust/oneTrust_production/consent/87b6a5c0-0104-4e96-a291-092c11350111/01938dc4-59b3-7bbc-b635-c4131030e85f/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png",
                    alt: "",
                    className: "md:w-36 sm:w-28 w-28 "
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "relative flex items-center",
                onMouseEnter: ()=>setShowMenu(true),
                onMouseLeave: ()=>setShowMenu(false),
                children: user.accesstoken && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: "https://occ-0-2483-3647.1.nflxso.net/dnm/api/v6/vN7bi_My87NPKvsBoib006Llxzg/AAAABTfUlmnFRKf_OEUhru2aqso39FKxONTd5Dt_sWnNj5wAg4bbMBZ8sgZupTfnB9IQ8tmWcrzRiyZsCp1bLKb_n7VrnTw3_Ovw7Q.png?r=bd7",
                            alt: "User",
                            className: "w-7 h-7 cursor-pointer duration-300 hover:scale-105"
                        }),
                        showMenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "absolute top-[2%] right-0 bg-gray-800 text-white rounded-md opacity-90 z-50 w-36 ",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: signOutUser,
                                // onMouseEnter={() => setShowMenu(true)}
                                // onMouseLeave={() => setShowMenu(false)}
                                className: "hover:cursor-pointer block w-full text-left px-4 py-2 hover:bg-gray-800",
                                children: "Sign Out"
                            })
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"36F7x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signInValidate", ()=>signInValidate);
parcelHelpers.export(exports, "signUpValidate", ()=>signUpValidate);
var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
var nameRegex = /^[A-Za-z\s'-]{2,50}$/;
function signInValidate(email) {
    let isEmailValid = emailRegex.test(email);
    if (!isEmailValid) return "Incorrect Email";
    return null;
}
function signUpValidate(email, password, name) {
    let isNameValid = nameRegex.test(name);
    if (!isNameValid) return "Incorrect Name";
    let isEmailValid = emailRegex.test(email);
    if (!isEmailValid) return "Incorrect Email";
    let isPasswordValid = passwordRegex.test(password);
    if (!isPasswordValid) return "Incorrect Password";
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fDGWh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
const Spinner = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        role: "status",
        className: "flex items-center justify-center ",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                "aria-hidden": "true",
                className: "w-7 h-7 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
                viewBox: "0 0 100 101",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                        fill: "currentFill"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "sr-only",
                children: "Loading..."
            })
        ]
    });
};
exports.default = Spinner;

},{"react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1HNKH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _header = require("./Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _useNowPlayingMovies = require("../hooks/useNowPlayingMovies");
var _useNowPlayingMoviesDefault = parcelHelpers.interopDefault(_useNowPlayingMovies);
var _videoPlayer = require("./VideoPlayer");
var _videoPlayerDefault = parcelHelpers.interopDefault(_videoPlayer);
var _movieLists = require("./MovieLists");
var _movieListsDefault = parcelHelpers.interopDefault(_movieLists);
var _usePopularMovies = require("../hooks/usePopularMovies");
var _usePopularMoviesDefault = parcelHelpers.interopDefault(_usePopularMovies);
var _useUpcomingMovies = require("../hooks/useUpcomingMovies");
var _useUpcomingMoviesDefault = parcelHelpers.interopDefault(_useUpcomingMovies);
var _useTopRatedMovies = require("../hooks/useTopRatedMovies");
var _useTopRatedMoviesDefault = parcelHelpers.interopDefault(_useTopRatedMovies);
var _gptSearch = require("./GptSearch");
var _gptSearchDefault = parcelHelpers.interopDefault(_gptSearch);
var _reactRedux = require("react-redux");
const Browse = ()=>{
    const isgptSearchShow = (0, _reactRedux.useSelector)((store)=>store.feature.gptSearch);
    (0, _useNowPlayingMoviesDefault.default)();
    (0, _usePopularMoviesDefault.default)();
    (0, _useUpcomingMoviesDefault.default)();
    (0, _useTopRatedMoviesDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            isgptSearchShow ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gptSearchDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoPlayerDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movieListsDefault.default), {})
                ]
            })
        ]
    });
};
exports.default = Browse;

},{"react/jsx-runtime":"gonF6","./Header":"5keeC","../hooks/useNowPlayingMovies":"foXQa","./VideoPlayer":"bSylt","./MovieLists":"4TSm5","../hooks/usePopularMovies":"1LLH6","../hooks/useUpcomingMovies":"lKoOw","../hooks/useTopRatedMovies":"8Krfw","./GptSearch":"4Inds","react-redux":"aRDHF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"foXQa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _constants = require("../utils/constants");
var _movies = require("../store/slice/movies");
var _react = require("react");
const useNowPlayingMovies = ()=>{
    const isPresent = (0, _reactRedux.useSelector)((store)=>store.movies.nowplaying);
    const dispatchAction = (0, _reactRedux.useDispatch)();
    const getNowPlayingMovies = (url)=>{
        fetch(url, (0, _constants.TMDB_API_OPTIONS)).then((res)=>res.json()).then((json)=>{
            dispatchAction((0, _movies.addMovies)(json.results));
        }).catch((err)=>console.error(err));
    };
    (0, _react.useEffect)(()=>{
        if (!isPresent) getNowPlayingMovies("https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1");
    }, []);
};
exports.default = useNowPlayingMovies;

},{"react-redux":"aRDHF","../utils/constants":"fZCF6","../store/slice/movies":"5TvjQ","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5TvjQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addMovies", ()=>addMovies);
parcelHelpers.export(exports, "addPopularMovies", ()=>addPopularMovies);
parcelHelpers.export(exports, "addTopRatedMovies", ()=>addTopRatedMovies);
parcelHelpers.export(exports, "addUpcomingMovies", ()=>addUpcomingMovies);
parcelHelpers.export(exports, "emptyMovies", ()=>emptyMovies);
parcelHelpers.export(exports, "addAiRecommended", ()=>addAiRecommended);
var _toolkit = require("@reduxjs/toolkit");
const movies = (0, _toolkit.createSlice)({
    name: "movies",
    initialState: {
        nowplaying: null,
        popularMovies: null,
        topRated: null,
        upcoming: null,
        aiRecommended: null
    },
    reducers: {
        addMovies: (state, action)=>{
            state.nowplaying = action.payload;
        },
        addPopularMovies: (state, action)=>{
            state.popularMovies = action.payload;
        },
        addTopRatedMovies: (state, action)=>{
            state.topRated = action.payload;
        },
        addUpcomingMovies: (state, action)=>{
            state.upcoming = action.payload;
        },
        addAiRecommended: (state, action)=>{
            state.aiRecommended = action.payload;
        },
        emptyMovies: (state)=>{
            state.nowplaying = null;
            state.popularMovies = null;
            state.topRated = null;
            state.upcoming = null;
        }
    }
});
const { addMovies, addPopularMovies, addTopRatedMovies, addUpcomingMovies, emptyMovies, addAiRecommended } = movies.actions;
exports.default = movies.reducer;

},{"@reduxjs/toolkit":"7hE98","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bSylt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _videoTitle = require("./VideoTitle");
var _videoTitleDefault = parcelHelpers.interopDefault(_videoTitle);
var _videoBackground = require("./VideoBackground");
var _videoBackgroundDefault = parcelHelpers.interopDefault(_videoBackground);
var _random = require("../utils/random");
var _randomDefault = parcelHelpers.interopDefault(_random);
const VideoPlayer = ()=>{
    const movies = (0, _reactRedux.useSelector)((store)=>store.movies?.nowplaying);
    if (!movies) return;
    let { original_title, overview, id } = movies[(0, _randomDefault.default)(20)];
    // console.log(original_title,id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "pt-2 md:pt-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoTitleDefault.default), {
                title: original_title,
                overview: overview,
                movieId: id
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoBackgroundDefault.default), {
                movieId: id
            })
        ]
    });
};
exports.default = VideoPlayer;

},{"react/jsx-runtime":"gonF6","react-redux":"aRDHF","./VideoTitle":"9EAbS","./VideoBackground":"boGVy","../utils/random":"bYmEC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9EAbS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
const VideoTitle = ({ title, overview, movieId })=>{
    // console.log("title", movieId, title);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-full aspect-video bg-gradient-to-r from-black from-0% to-30% absolute pt-[20%]  md:pt-[28%] lg:pt-[20%]  px-5 md:px-10 text-white",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "md:text-3xl font-bold ",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "hidden xl:flex text-sm xl:w-1/3 mt-2",
                children: overview
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex space-x-2 my-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "flex md:hidden space-x-2 hover:cursor-pointer  hover:opacity-70 duration-200 rounded-md text-xs align-middle px-3 py-1 md:text-lg md:px-5 md:py-2 text-black bg-white font-bold",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Play), {
                                size: 15
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "",
                                children: "Play"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "hidden md:flex space-x-2 hover:cursor-pointer  hover:opacity-70 duration-200 rounded-md text-xs align-middle px-3 py-1 md:text-lg md:px-5 md:py-2 text-black bg-white font-bold",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Play), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "",
                                children: "Play"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "hidden lg:flex space-x-2 hover:cursor-pointer rounded-md text-lg sm:px-6 py-2 px-3  bg-gray-600 text-white font-bold",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.InfoIcon), {}),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: "More Info"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = VideoTitle;

},{"react/jsx-runtime":"gonF6","lucide-react":"3eiFh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3eiFh":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlarmCheck", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "AlarmCheckIcon", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "AlarmClockCheck", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "AlarmClockCheckIcon", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmCheck", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmClockCheck", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "AlarmClockMinus", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "AlarmClockMinusIcon", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "AlarmMinus", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "AlarmMinusIcon", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmClockMinus", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmMinus", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "AlarmClockPlus", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "AlarmClockPlusIcon", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "AlarmPlus", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "AlarmPlusIcon", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmClockPlus", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmPlus", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "ArrowDownAZ", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "ArrowDownAZIcon", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "ArrowDownAz", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "ArrowDownAzIcon", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownAZ", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownAz", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "ArrowDownWideNarrow", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "ArrowDownWideNarrowIcon", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownWideNarrow", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "LucideSortDesc", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "SortDesc", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "SortDescIcon", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "ArrowDownZA", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "ArrowDownZAIcon", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "ArrowDownZa", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "ArrowDownZaIcon", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownZA", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownZa", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "ArrowUpAZ", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "ArrowUpAZIcon", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "ArrowUpAz", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "ArrowUpAzIcon", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpAZ", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpAz", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "ArrowUpNarrowWide", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "ArrowUpNarrowWideIcon", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpNarrowWide", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "LucideSortAsc", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "SortAsc", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "SortAscIcon", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "ArrowUpZA", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "ArrowUpZAIcon", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "ArrowUpZa", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "ArrowUpZaIcon", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpZA", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpZa", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "Axis3D", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "Axis3DIcon", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "Axis3d", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "Axis3dIcon", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "LucideAxis3D", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "LucideAxis3d", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "BadgeCheck", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "BadgeCheckIcon", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeCheck", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "LucideVerified", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "Verified", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "VerifiedIcon", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizonalEnd", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizonalEndIcon", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizontalEnd", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizontalEndIcon", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenHorizonalEnd", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenHorizontalEnd", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizonalStart", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizonalStartIcon", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizontalStart", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizontalStartIcon", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenHorizonalStart", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenHorizontalStart", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "BookDashed", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "BookDashedIcon", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "BookTemplate", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "BookTemplateIcon", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "LucideBookDashed", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "LucideBookTemplate", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "Braces", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "BracesIcon", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "CurlyBraces", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "CurlyBracesIcon", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "LucideBraces", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "LucideCurlyBraces", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "Captions", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "CaptionsIcon", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "LucideCaptions", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "LucideSubtitles", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "Subtitles", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "SubtitlesIcon", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "AreaChart", ()=>(0, _chartAreaJsDefault.default));
parcelHelpers.export(exports, "AreaChartIcon", ()=>(0, _chartAreaJsDefault.default));
parcelHelpers.export(exports, "ChartArea", ()=>(0, _chartAreaJsDefault.default));
parcelHelpers.export(exports, "ChartAreaIcon", ()=>(0, _chartAreaJsDefault.default));
parcelHelpers.export(exports, "LucideAreaChart", ()=>(0, _chartAreaJsDefault.default));
parcelHelpers.export(exports, "LucideChartArea", ()=>(0, _chartAreaJsDefault.default));
parcelHelpers.export(exports, "BarChartHorizontalBig", ()=>(0, _chartBarBigJsDefault.default));
parcelHelpers.export(exports, "BarChartHorizontalBigIcon", ()=>(0, _chartBarBigJsDefault.default));
parcelHelpers.export(exports, "ChartBarBig", ()=>(0, _chartBarBigJsDefault.default));
parcelHelpers.export(exports, "ChartBarBigIcon", ()=>(0, _chartBarBigJsDefault.default));
parcelHelpers.export(exports, "LucideBarChartHorizontalBig", ()=>(0, _chartBarBigJsDefault.default));
parcelHelpers.export(exports, "LucideChartBarBig", ()=>(0, _chartBarBigJsDefault.default));
parcelHelpers.export(exports, "BarChartHorizontal", ()=>(0, _chartBarJsDefault.default));
parcelHelpers.export(exports, "BarChartHorizontalIcon", ()=>(0, _chartBarJsDefault.default));
parcelHelpers.export(exports, "ChartBar", ()=>(0, _chartBarJsDefault.default));
parcelHelpers.export(exports, "ChartBarIcon", ()=>(0, _chartBarJsDefault.default));
parcelHelpers.export(exports, "LucideBarChartHorizontal", ()=>(0, _chartBarJsDefault.default));
parcelHelpers.export(exports, "LucideChartBar", ()=>(0, _chartBarJsDefault.default));
parcelHelpers.export(exports, "CandlestickChart", ()=>(0, _chartCandlestickJsDefault.default));
parcelHelpers.export(exports, "CandlestickChartIcon", ()=>(0, _chartCandlestickJsDefault.default));
parcelHelpers.export(exports, "ChartCandlestick", ()=>(0, _chartCandlestickJsDefault.default));
parcelHelpers.export(exports, "ChartCandlestickIcon", ()=>(0, _chartCandlestickJsDefault.default));
parcelHelpers.export(exports, "LucideCandlestickChart", ()=>(0, _chartCandlestickJsDefault.default));
parcelHelpers.export(exports, "LucideChartCandlestick", ()=>(0, _chartCandlestickJsDefault.default));
parcelHelpers.export(exports, "BarChartBig", ()=>(0, _chartColumnBigJsDefault.default));
parcelHelpers.export(exports, "BarChartBigIcon", ()=>(0, _chartColumnBigJsDefault.default));
parcelHelpers.export(exports, "ChartColumnBig", ()=>(0, _chartColumnBigJsDefault.default));
parcelHelpers.export(exports, "ChartColumnBigIcon", ()=>(0, _chartColumnBigJsDefault.default));
parcelHelpers.export(exports, "LucideBarChartBig", ()=>(0, _chartColumnBigJsDefault.default));
parcelHelpers.export(exports, "LucideChartColumnBig", ()=>(0, _chartColumnBigJsDefault.default));
parcelHelpers.export(exports, "BarChart4", ()=>(0, _chartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "BarChart4Icon", ()=>(0, _chartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "ChartColumnIncreasing", ()=>(0, _chartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "ChartColumnIncreasingIcon", ()=>(0, _chartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "LucideBarChart4", ()=>(0, _chartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "LucideChartColumnIncreasing", ()=>(0, _chartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "ChartLine", ()=>(0, _chartLineJsDefault.default));
parcelHelpers.export(exports, "ChartLineIcon", ()=>(0, _chartLineJsDefault.default));
parcelHelpers.export(exports, "LineChart", ()=>(0, _chartLineJsDefault.default));
parcelHelpers.export(exports, "LineChartIcon", ()=>(0, _chartLineJsDefault.default));
parcelHelpers.export(exports, "LucideChartLine", ()=>(0, _chartLineJsDefault.default));
parcelHelpers.export(exports, "LucideLineChart", ()=>(0, _chartLineJsDefault.default));
parcelHelpers.export(exports, "BarChart", ()=>(0, _chartNoAxesColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "BarChartIcon", ()=>(0, _chartNoAxesColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "ChartNoAxesColumnIncreasing", ()=>(0, _chartNoAxesColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "ChartNoAxesColumnIncreasingIcon", ()=>(0, _chartNoAxesColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "LucideBarChart", ()=>(0, _chartNoAxesColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "LucideChartNoAxesColumnIncreasing", ()=>(0, _chartNoAxesColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "BarChart3", ()=>(0, _chartColumnJsDefault.default));
parcelHelpers.export(exports, "BarChart3Icon", ()=>(0, _chartColumnJsDefault.default));
parcelHelpers.export(exports, "ChartColumn", ()=>(0, _chartColumnJsDefault.default));
parcelHelpers.export(exports, "ChartColumnIcon", ()=>(0, _chartColumnJsDefault.default));
parcelHelpers.export(exports, "LucideBarChart3", ()=>(0, _chartColumnJsDefault.default));
parcelHelpers.export(exports, "LucideChartColumn", ()=>(0, _chartColumnJsDefault.default));
parcelHelpers.export(exports, "BarChart2", ()=>(0, _chartNoAxesColumnJsDefault.default));
parcelHelpers.export(exports, "BarChart2Icon", ()=>(0, _chartNoAxesColumnJsDefault.default));
parcelHelpers.export(exports, "ChartNoAxesColumn", ()=>(0, _chartNoAxesColumnJsDefault.default));
parcelHelpers.export(exports, "ChartNoAxesColumnIcon", ()=>(0, _chartNoAxesColumnJsDefault.default));
parcelHelpers.export(exports, "LucideBarChart2", ()=>(0, _chartNoAxesColumnJsDefault.default));
parcelHelpers.export(exports, "LucideChartNoAxesColumn", ()=>(0, _chartNoAxesColumnJsDefault.default));
parcelHelpers.export(exports, "ChartNoAxesGantt", ()=>(0, _chartNoAxesGanttJsDefault.default));
parcelHelpers.export(exports, "ChartNoAxesGanttIcon", ()=>(0, _chartNoAxesGanttJsDefault.default));
parcelHelpers.export(exports, "GanttChart", ()=>(0, _chartNoAxesGanttJsDefault.default));
parcelHelpers.export(exports, "GanttChartIcon", ()=>(0, _chartNoAxesGanttJsDefault.default));
parcelHelpers.export(exports, "LucideChartNoAxesGantt", ()=>(0, _chartNoAxesGanttJsDefault.default));
parcelHelpers.export(exports, "LucideGanttChart", ()=>(0, _chartNoAxesGanttJsDefault.default));
parcelHelpers.export(exports, "ChartPie", ()=>(0, _chartPieJsDefault.default));
parcelHelpers.export(exports, "ChartPieIcon", ()=>(0, _chartPieJsDefault.default));
parcelHelpers.export(exports, "LucideChartPie", ()=>(0, _chartPieJsDefault.default));
parcelHelpers.export(exports, "LucidePieChart", ()=>(0, _chartPieJsDefault.default));
parcelHelpers.export(exports, "PieChart", ()=>(0, _chartPieJsDefault.default));
parcelHelpers.export(exports, "PieChartIcon", ()=>(0, _chartPieJsDefault.default));
parcelHelpers.export(exports, "ChartScatter", ()=>(0, _chartScatterJsDefault.default));
parcelHelpers.export(exports, "ChartScatterIcon", ()=>(0, _chartScatterJsDefault.default));
parcelHelpers.export(exports, "LucideChartScatter", ()=>(0, _chartScatterJsDefault.default));
parcelHelpers.export(exports, "LucideScatterChart", ()=>(0, _chartScatterJsDefault.default));
parcelHelpers.export(exports, "ScatterChart", ()=>(0, _chartScatterJsDefault.default));
parcelHelpers.export(exports, "ScatterChartIcon", ()=>(0, _chartScatterJsDefault.default));
parcelHelpers.export(exports, "AlertCircle", ()=>(0, _circleAlertJsDefault.default));
parcelHelpers.export(exports, "AlertCircleIcon", ()=>(0, _circleAlertJsDefault.default));
parcelHelpers.export(exports, "CircleAlert", ()=>(0, _circleAlertJsDefault.default));
parcelHelpers.export(exports, "CircleAlertIcon", ()=>(0, _circleAlertJsDefault.default));
parcelHelpers.export(exports, "LucideAlertCircle", ()=>(0, _circleAlertJsDefault.default));
parcelHelpers.export(exports, "LucideCircleAlert", ()=>(0, _circleAlertJsDefault.default));
parcelHelpers.export(exports, "ArrowDownCircle", ()=>(0, _circleArrowDownJsDefault.default));
parcelHelpers.export(exports, "ArrowDownCircleIcon", ()=>(0, _circleArrowDownJsDefault.default));
parcelHelpers.export(exports, "CircleArrowDown", ()=>(0, _circleArrowDownJsDefault.default));
parcelHelpers.export(exports, "CircleArrowDownIcon", ()=>(0, _circleArrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownCircle", ()=>(0, _circleArrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideCircleArrowDown", ()=>(0, _circleArrowDownJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftFromCircle", ()=>(0, _circleArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftFromCircleIcon", ()=>(0, _circleArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "CircleArrowOutDownLeft", ()=>(0, _circleArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "CircleArrowOutDownLeftIcon", ()=>(0, _circleArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownLeftFromCircle", ()=>(0, _circleArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideCircleArrowOutDownLeft", ()=>(0, _circleArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftCircle", ()=>(0, _circleArrowLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftCircleIcon", ()=>(0, _circleArrowLeftJsDefault.default));
parcelHelpers.export(exports, "CircleArrowLeft", ()=>(0, _circleArrowLeftJsDefault.default));
parcelHelpers.export(exports, "CircleArrowLeftIcon", ()=>(0, _circleArrowLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeftCircle", ()=>(0, _circleArrowLeftJsDefault.default));
parcelHelpers.export(exports, "LucideCircleArrowLeft", ()=>(0, _circleArrowLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightFromCircle", ()=>(0, _circleArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightFromCircleIcon", ()=>(0, _circleArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "CircleArrowOutDownRight", ()=>(0, _circleArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "CircleArrowOutDownRightIcon", ()=>(0, _circleArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownRightFromCircle", ()=>(0, _circleArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideCircleArrowOutDownRight", ()=>(0, _circleArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftFromCircle", ()=>(0, _circleArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftFromCircleIcon", ()=>(0, _circleArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "CircleArrowOutUpLeft", ()=>(0, _circleArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "CircleArrowOutUpLeftIcon", ()=>(0, _circleArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpLeftFromCircle", ()=>(0, _circleArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideCircleArrowOutUpLeft", ()=>(0, _circleArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightFromCircle", ()=>(0, _circleArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightFromCircleIcon", ()=>(0, _circleArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "CircleArrowOutUpRight", ()=>(0, _circleArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "CircleArrowOutUpRightIcon", ()=>(0, _circleArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpRightFromCircle", ()=>(0, _circleArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideCircleArrowOutUpRight", ()=>(0, _circleArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "ArrowRightCircle", ()=>(0, _circleArrowRightJsDefault.default));
parcelHelpers.export(exports, "ArrowRightCircleIcon", ()=>(0, _circleArrowRightJsDefault.default));
parcelHelpers.export(exports, "CircleArrowRight", ()=>(0, _circleArrowRightJsDefault.default));
parcelHelpers.export(exports, "CircleArrowRightIcon", ()=>(0, _circleArrowRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRightCircle", ()=>(0, _circleArrowRightJsDefault.default));
parcelHelpers.export(exports, "LucideCircleArrowRight", ()=>(0, _circleArrowRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpCircle", ()=>(0, _circleArrowUpJsDefault.default));
parcelHelpers.export(exports, "ArrowUpCircleIcon", ()=>(0, _circleArrowUpJsDefault.default));
parcelHelpers.export(exports, "CircleArrowUp", ()=>(0, _circleArrowUpJsDefault.default));
parcelHelpers.export(exports, "CircleArrowUpIcon", ()=>(0, _circleArrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpCircle", ()=>(0, _circleArrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideCircleArrowUp", ()=>(0, _circleArrowUpJsDefault.default));
parcelHelpers.export(exports, "CheckCircle2", ()=>(0, _circleCheckJsDefault.default));
parcelHelpers.export(exports, "CheckCircle2Icon", ()=>(0, _circleCheckJsDefault.default));
parcelHelpers.export(exports, "CircleCheck", ()=>(0, _circleCheckJsDefault.default));
parcelHelpers.export(exports, "CircleCheckIcon", ()=>(0, _circleCheckJsDefault.default));
parcelHelpers.export(exports, "LucideCheckCircle2", ()=>(0, _circleCheckJsDefault.default));
parcelHelpers.export(exports, "LucideCircleCheck", ()=>(0, _circleCheckJsDefault.default));
parcelHelpers.export(exports, "CheckCircle", ()=>(0, _circleCheckBigJsDefault.default));
parcelHelpers.export(exports, "CheckCircleIcon", ()=>(0, _circleCheckBigJsDefault.default));
parcelHelpers.export(exports, "CircleCheckBig", ()=>(0, _circleCheckBigJsDefault.default));
parcelHelpers.export(exports, "CircleCheckBigIcon", ()=>(0, _circleCheckBigJsDefault.default));
parcelHelpers.export(exports, "LucideCheckCircle", ()=>(0, _circleCheckBigJsDefault.default));
parcelHelpers.export(exports, "LucideCircleCheckBig", ()=>(0, _circleCheckBigJsDefault.default));
parcelHelpers.export(exports, "ChevronDownCircle", ()=>(0, _circleChevronDownJsDefault.default));
parcelHelpers.export(exports, "ChevronDownCircleIcon", ()=>(0, _circleChevronDownJsDefault.default));
parcelHelpers.export(exports, "CircleChevronDown", ()=>(0, _circleChevronDownJsDefault.default));
parcelHelpers.export(exports, "CircleChevronDownIcon", ()=>(0, _circleChevronDownJsDefault.default));
parcelHelpers.export(exports, "LucideChevronDownCircle", ()=>(0, _circleChevronDownJsDefault.default));
parcelHelpers.export(exports, "LucideCircleChevronDown", ()=>(0, _circleChevronDownJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftCircle", ()=>(0, _circleChevronLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftCircleIcon", ()=>(0, _circleChevronLeftJsDefault.default));
parcelHelpers.export(exports, "CircleChevronLeft", ()=>(0, _circleChevronLeftJsDefault.default));
parcelHelpers.export(exports, "CircleChevronLeftIcon", ()=>(0, _circleChevronLeftJsDefault.default));
parcelHelpers.export(exports, "LucideChevronLeftCircle", ()=>(0, _circleChevronLeftJsDefault.default));
parcelHelpers.export(exports, "LucideCircleChevronLeft", ()=>(0, _circleChevronLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronRightCircle", ()=>(0, _circleChevronRightJsDefault.default));
parcelHelpers.export(exports, "ChevronRightCircleIcon", ()=>(0, _circleChevronRightJsDefault.default));
parcelHelpers.export(exports, "CircleChevronRight", ()=>(0, _circleChevronRightJsDefault.default));
parcelHelpers.export(exports, "CircleChevronRightIcon", ()=>(0, _circleChevronRightJsDefault.default));
parcelHelpers.export(exports, "LucideChevronRightCircle", ()=>(0, _circleChevronRightJsDefault.default));
parcelHelpers.export(exports, "LucideCircleChevronRight", ()=>(0, _circleChevronRightJsDefault.default));
parcelHelpers.export(exports, "ChevronUpCircle", ()=>(0, _circleChevronUpJsDefault.default));
parcelHelpers.export(exports, "ChevronUpCircleIcon", ()=>(0, _circleChevronUpJsDefault.default));
parcelHelpers.export(exports, "CircleChevronUp", ()=>(0, _circleChevronUpJsDefault.default));
parcelHelpers.export(exports, "CircleChevronUpIcon", ()=>(0, _circleChevronUpJsDefault.default));
parcelHelpers.export(exports, "LucideChevronUpCircle", ()=>(0, _circleChevronUpJsDefault.default));
parcelHelpers.export(exports, "LucideCircleChevronUp", ()=>(0, _circleChevronUpJsDefault.default));
parcelHelpers.export(exports, "CircleDivide", ()=>(0, _circleDivideJsDefault.default));
parcelHelpers.export(exports, "CircleDivideIcon", ()=>(0, _circleDivideJsDefault.default));
parcelHelpers.export(exports, "DivideCircle", ()=>(0, _circleDivideJsDefault.default));
parcelHelpers.export(exports, "DivideCircleIcon", ()=>(0, _circleDivideJsDefault.default));
parcelHelpers.export(exports, "LucideCircleDivide", ()=>(0, _circleDivideJsDefault.default));
parcelHelpers.export(exports, "LucideDivideCircle", ()=>(0, _circleDivideJsDefault.default));
parcelHelpers.export(exports, "CircleGauge", ()=>(0, _circleGaugeJsDefault.default));
parcelHelpers.export(exports, "CircleGaugeIcon", ()=>(0, _circleGaugeJsDefault.default));
parcelHelpers.export(exports, "GaugeCircle", ()=>(0, _circleGaugeJsDefault.default));
parcelHelpers.export(exports, "GaugeCircleIcon", ()=>(0, _circleGaugeJsDefault.default));
parcelHelpers.export(exports, "LucideCircleGauge", ()=>(0, _circleGaugeJsDefault.default));
parcelHelpers.export(exports, "LucideGaugeCircle", ()=>(0, _circleGaugeJsDefault.default));
parcelHelpers.export(exports, "CircleHelp", ()=>(0, _circleHelpJsDefault.default));
parcelHelpers.export(exports, "CircleHelpIcon", ()=>(0, _circleHelpJsDefault.default));
parcelHelpers.export(exports, "HelpCircle", ()=>(0, _circleHelpJsDefault.default));
parcelHelpers.export(exports, "HelpCircleIcon", ()=>(0, _circleHelpJsDefault.default));
parcelHelpers.export(exports, "LucideCircleHelp", ()=>(0, _circleHelpJsDefault.default));
parcelHelpers.export(exports, "LucideHelpCircle", ()=>(0, _circleHelpJsDefault.default));
parcelHelpers.export(exports, "CircleMinus", ()=>(0, _circleMinusJsDefault.default));
parcelHelpers.export(exports, "CircleMinusIcon", ()=>(0, _circleMinusJsDefault.default));
parcelHelpers.export(exports, "LucideCircleMinus", ()=>(0, _circleMinusJsDefault.default));
parcelHelpers.export(exports, "LucideMinusCircle", ()=>(0, _circleMinusJsDefault.default));
parcelHelpers.export(exports, "MinusCircle", ()=>(0, _circleMinusJsDefault.default));
parcelHelpers.export(exports, "MinusCircleIcon", ()=>(0, _circleMinusJsDefault.default));
parcelHelpers.export(exports, "CircleParkingOff", ()=>(0, _circleParkingOffJsDefault.default));
parcelHelpers.export(exports, "CircleParkingOffIcon", ()=>(0, _circleParkingOffJsDefault.default));
parcelHelpers.export(exports, "LucideCircleParkingOff", ()=>(0, _circleParkingOffJsDefault.default));
parcelHelpers.export(exports, "LucideParkingCircleOff", ()=>(0, _circleParkingOffJsDefault.default));
parcelHelpers.export(exports, "ParkingCircleOff", ()=>(0, _circleParkingOffJsDefault.default));
parcelHelpers.export(exports, "ParkingCircleOffIcon", ()=>(0, _circleParkingOffJsDefault.default));
parcelHelpers.export(exports, "CircleParking", ()=>(0, _circleParkingJsDefault.default));
parcelHelpers.export(exports, "CircleParkingIcon", ()=>(0, _circleParkingJsDefault.default));
parcelHelpers.export(exports, "LucideCircleParking", ()=>(0, _circleParkingJsDefault.default));
parcelHelpers.export(exports, "LucideParkingCircle", ()=>(0, _circleParkingJsDefault.default));
parcelHelpers.export(exports, "ParkingCircle", ()=>(0, _circleParkingJsDefault.default));
parcelHelpers.export(exports, "ParkingCircleIcon", ()=>(0, _circleParkingJsDefault.default));
parcelHelpers.export(exports, "CirclePause", ()=>(0, _circlePauseJsDefault.default));
parcelHelpers.export(exports, "CirclePauseIcon", ()=>(0, _circlePauseJsDefault.default));
parcelHelpers.export(exports, "LucideCirclePause", ()=>(0, _circlePauseJsDefault.default));
parcelHelpers.export(exports, "LucidePauseCircle", ()=>(0, _circlePauseJsDefault.default));
parcelHelpers.export(exports, "PauseCircle", ()=>(0, _circlePauseJsDefault.default));
parcelHelpers.export(exports, "PauseCircleIcon", ()=>(0, _circlePauseJsDefault.default));
parcelHelpers.export(exports, "CirclePlay", ()=>(0, _circlePlayJsDefault.default));
parcelHelpers.export(exports, "CirclePlayIcon", ()=>(0, _circlePlayJsDefault.default));
parcelHelpers.export(exports, "LucideCirclePlay", ()=>(0, _circlePlayJsDefault.default));
parcelHelpers.export(exports, "LucidePlayCircle", ()=>(0, _circlePlayJsDefault.default));
parcelHelpers.export(exports, "PlayCircle", ()=>(0, _circlePlayJsDefault.default));
parcelHelpers.export(exports, "PlayCircleIcon", ()=>(0, _circlePlayJsDefault.default));
parcelHelpers.export(exports, "CirclePercent", ()=>(0, _circlePercentJsDefault.default));
parcelHelpers.export(exports, "CirclePercentIcon", ()=>(0, _circlePercentJsDefault.default));
parcelHelpers.export(exports, "LucideCirclePercent", ()=>(0, _circlePercentJsDefault.default));
parcelHelpers.export(exports, "LucidePercentCircle", ()=>(0, _circlePercentJsDefault.default));
parcelHelpers.export(exports, "PercentCircle", ()=>(0, _circlePercentJsDefault.default));
parcelHelpers.export(exports, "PercentCircleIcon", ()=>(0, _circlePercentJsDefault.default));
parcelHelpers.export(exports, "CirclePower", ()=>(0, _circlePowerJsDefault.default));
parcelHelpers.export(exports, "CirclePowerIcon", ()=>(0, _circlePowerJsDefault.default));
parcelHelpers.export(exports, "LucideCirclePower", ()=>(0, _circlePowerJsDefault.default));
parcelHelpers.export(exports, "LucidePowerCircle", ()=>(0, _circlePowerJsDefault.default));
parcelHelpers.export(exports, "PowerCircle", ()=>(0, _circlePowerJsDefault.default));
parcelHelpers.export(exports, "PowerCircleIcon", ()=>(0, _circlePowerJsDefault.default));
parcelHelpers.export(exports, "CirclePlus", ()=>(0, _circlePlusJsDefault.default));
parcelHelpers.export(exports, "CirclePlusIcon", ()=>(0, _circlePlusJsDefault.default));
parcelHelpers.export(exports, "LucideCirclePlus", ()=>(0, _circlePlusJsDefault.default));
parcelHelpers.export(exports, "LucidePlusCircle", ()=>(0, _circlePlusJsDefault.default));
parcelHelpers.export(exports, "PlusCircle", ()=>(0, _circlePlusJsDefault.default));
parcelHelpers.export(exports, "PlusCircleIcon", ()=>(0, _circlePlusJsDefault.default));
parcelHelpers.export(exports, "CircleSlash2", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "CircleSlash2Icon", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "CircleSlashed", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "CircleSlashedIcon", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "LucideCircleSlash2", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "LucideCircleSlashed", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "CircleStop", ()=>(0, _circleStopJsDefault.default));
parcelHelpers.export(exports, "CircleStopIcon", ()=>(0, _circleStopJsDefault.default));
parcelHelpers.export(exports, "LucideCircleStop", ()=>(0, _circleStopJsDefault.default));
parcelHelpers.export(exports, "LucideStopCircle", ()=>(0, _circleStopJsDefault.default));
parcelHelpers.export(exports, "StopCircle", ()=>(0, _circleStopJsDefault.default));
parcelHelpers.export(exports, "StopCircleIcon", ()=>(0, _circleStopJsDefault.default));
parcelHelpers.export(exports, "CircleUserRound", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "CircleUserRoundIcon", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "LucideCircleUserRound", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "LucideUserCircle2", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "UserCircle2", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "UserCircle2Icon", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "CircleUser", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "CircleUserIcon", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "LucideCircleUser", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "LucideUserCircle", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "UserCircle", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "UserCircleIcon", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "CircleX", ()=>(0, _circleXJsDefault.default));
parcelHelpers.export(exports, "CircleXIcon", ()=>(0, _circleXJsDefault.default));
parcelHelpers.export(exports, "LucideCircleX", ()=>(0, _circleXJsDefault.default));
parcelHelpers.export(exports, "LucideXCircle", ()=>(0, _circleXJsDefault.default));
parcelHelpers.export(exports, "XCircle", ()=>(0, _circleXJsDefault.default));
parcelHelpers.export(exports, "XCircleIcon", ()=>(0, _circleXJsDefault.default));
parcelHelpers.export(exports, "ClipboardPenLine", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "ClipboardPenLineIcon", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "ClipboardSignature", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "ClipboardSignatureIcon", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardPenLine", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardSignature", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "ClipboardEdit", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "ClipboardEditIcon", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "ClipboardPen", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "ClipboardPenIcon", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardEdit", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardPen", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "CloudDownload", ()=>(0, _cloudDownloadJsDefault.default));
parcelHelpers.export(exports, "CloudDownloadIcon", ()=>(0, _cloudDownloadJsDefault.default));
parcelHelpers.export(exports, "DownloadCloud", ()=>(0, _cloudDownloadJsDefault.default));
parcelHelpers.export(exports, "DownloadCloudIcon", ()=>(0, _cloudDownloadJsDefault.default));
parcelHelpers.export(exports, "LucideCloudDownload", ()=>(0, _cloudDownloadJsDefault.default));
parcelHelpers.export(exports, "LucideDownloadCloud", ()=>(0, _cloudDownloadJsDefault.default));
parcelHelpers.export(exports, "CloudUpload", ()=>(0, _cloudUploadJsDefault.default));
parcelHelpers.export(exports, "CloudUploadIcon", ()=>(0, _cloudUploadJsDefault.default));
parcelHelpers.export(exports, "LucideCloudUpload", ()=>(0, _cloudUploadJsDefault.default));
parcelHelpers.export(exports, "LucideUploadCloud", ()=>(0, _cloudUploadJsDefault.default));
parcelHelpers.export(exports, "UploadCloud", ()=>(0, _cloudUploadJsDefault.default));
parcelHelpers.export(exports, "UploadCloudIcon", ()=>(0, _cloudUploadJsDefault.default));
parcelHelpers.export(exports, "Code2", ()=>(0, _codeXmlJsDefault.default));
parcelHelpers.export(exports, "Code2Icon", ()=>(0, _codeXmlJsDefault.default));
parcelHelpers.export(exports, "CodeXml", ()=>(0, _codeXmlJsDefault.default));
parcelHelpers.export(exports, "CodeXmlIcon", ()=>(0, _codeXmlJsDefault.default));
parcelHelpers.export(exports, "LucideCode2", ()=>(0, _codeXmlJsDefault.default));
parcelHelpers.export(exports, "LucideCodeXml", ()=>(0, _codeXmlJsDefault.default));
parcelHelpers.export(exports, "Columns", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "Columns2", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "Columns2Icon", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "ColumnsIcon", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "LucideColumns", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "LucideColumns2", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "Columns3Cog", ()=>(0, _columns3CogJsDefault.default));
parcelHelpers.export(exports, "Columns3CogIcon", ()=>(0, _columns3CogJsDefault.default));
parcelHelpers.export(exports, "ColumnsSettings", ()=>(0, _columns3CogJsDefault.default));
parcelHelpers.export(exports, "ColumnsSettingsIcon", ()=>(0, _columns3CogJsDefault.default));
parcelHelpers.export(exports, "LucideColumns3Cog", ()=>(0, _columns3CogJsDefault.default));
parcelHelpers.export(exports, "LucideColumnsSettings", ()=>(0, _columns3CogJsDefault.default));
parcelHelpers.export(exports, "LucideTableConfig", ()=>(0, _columns3CogJsDefault.default));
parcelHelpers.export(exports, "TableConfig", ()=>(0, _columns3CogJsDefault.default));
parcelHelpers.export(exports, "TableConfigIcon", ()=>(0, _columns3CogJsDefault.default));
parcelHelpers.export(exports, "Columns3", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "Columns3Icon", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "LucideColumns3", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "LucidePanelsLeftRight", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "PanelsLeftRight", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "PanelsLeftRightIcon", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "Contact2", ()=>(0, _contactRoundJsDefault.default));
parcelHelpers.export(exports, "Contact2Icon", ()=>(0, _contactRoundJsDefault.default));
parcelHelpers.export(exports, "ContactRound", ()=>(0, _contactRoundJsDefault.default));
parcelHelpers.export(exports, "ContactRoundIcon", ()=>(0, _contactRoundJsDefault.default));
parcelHelpers.export(exports, "LucideContact2", ()=>(0, _contactRoundJsDefault.default));
parcelHelpers.export(exports, "LucideContactRound", ()=>(0, _contactRoundJsDefault.default));
parcelHelpers.export(exports, "DiamondPercent", ()=>(0, _diamondPercentJsDefault.default));
parcelHelpers.export(exports, "DiamondPercentIcon", ()=>(0, _diamondPercentJsDefault.default));
parcelHelpers.export(exports, "LucideDiamondPercent", ()=>(0, _diamondPercentJsDefault.default));
parcelHelpers.export(exports, "LucidePercentDiamond", ()=>(0, _diamondPercentJsDefault.default));
parcelHelpers.export(exports, "PercentDiamond", ()=>(0, _diamondPercentJsDefault.default));
parcelHelpers.export(exports, "PercentDiamondIcon", ()=>(0, _diamondPercentJsDefault.default));
parcelHelpers.export(exports, "Earth", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "EarthIcon", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "Globe2", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "Globe2Icon", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "LucideEarth", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "LucideGlobe2", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "EllipsisVertical", ()=>(0, _ellipsisVerticalJsDefault.default));
parcelHelpers.export(exports, "EllipsisVerticalIcon", ()=>(0, _ellipsisVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideEllipsisVertical", ()=>(0, _ellipsisVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideMoreVertical", ()=>(0, _ellipsisVerticalJsDefault.default));
parcelHelpers.export(exports, "MoreVertical", ()=>(0, _ellipsisVerticalJsDefault.default));
parcelHelpers.export(exports, "MoreVerticalIcon", ()=>(0, _ellipsisVerticalJsDefault.default));
parcelHelpers.export(exports, "Ellipsis", ()=>(0, _ellipsisJsDefault.default));
parcelHelpers.export(exports, "EllipsisIcon", ()=>(0, _ellipsisJsDefault.default));
parcelHelpers.export(exports, "LucideEllipsis", ()=>(0, _ellipsisJsDefault.default));
parcelHelpers.export(exports, "LucideMoreHorizontal", ()=>(0, _ellipsisJsDefault.default));
parcelHelpers.export(exports, "MoreHorizontal", ()=>(0, _ellipsisJsDefault.default));
parcelHelpers.export(exports, "MoreHorizontalIcon", ()=>(0, _ellipsisJsDefault.default));
parcelHelpers.export(exports, "FileAxis3D", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "FileAxis3DIcon", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "FileAxis3d", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "FileAxis3dIcon", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "LucideFileAxis3D", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "LucideFileAxis3d", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "FileBarChart2", ()=>(0, _fileChartColumnJsDefault.default));
parcelHelpers.export(exports, "FileBarChart2Icon", ()=>(0, _fileChartColumnJsDefault.default));
parcelHelpers.export(exports, "FileChartColumn", ()=>(0, _fileChartColumnJsDefault.default));
parcelHelpers.export(exports, "FileChartColumnIcon", ()=>(0, _fileChartColumnJsDefault.default));
parcelHelpers.export(exports, "LucideFileBarChart2", ()=>(0, _fileChartColumnJsDefault.default));
parcelHelpers.export(exports, "LucideFileChartColumn", ()=>(0, _fileChartColumnJsDefault.default));
parcelHelpers.export(exports, "FileBarChart", ()=>(0, _fileChartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "FileBarChartIcon", ()=>(0, _fileChartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "FileChartColumnIncreasing", ()=>(0, _fileChartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "FileChartColumnIncreasingIcon", ()=>(0, _fileChartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "LucideFileBarChart", ()=>(0, _fileChartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "LucideFileChartColumnIncreasing", ()=>(0, _fileChartColumnIncreasingJsDefault.default));
parcelHelpers.export(exports, "FileChartLine", ()=>(0, _fileChartLineJsDefault.default));
parcelHelpers.export(exports, "FileChartLineIcon", ()=>(0, _fileChartLineJsDefault.default));
parcelHelpers.export(exports, "FileLineChart", ()=>(0, _fileChartLineJsDefault.default));
parcelHelpers.export(exports, "FileLineChartIcon", ()=>(0, _fileChartLineJsDefault.default));
parcelHelpers.export(exports, "LucideFileChartLine", ()=>(0, _fileChartLineJsDefault.default));
parcelHelpers.export(exports, "LucideFileLineChart", ()=>(0, _fileChartLineJsDefault.default));
parcelHelpers.export(exports, "FileChartPie", ()=>(0, _fileChartPieJsDefault.default));
parcelHelpers.export(exports, "FileChartPieIcon", ()=>(0, _fileChartPieJsDefault.default));
parcelHelpers.export(exports, "FilePieChart", ()=>(0, _fileChartPieJsDefault.default));
parcelHelpers.export(exports, "FilePieChartIcon", ()=>(0, _fileChartPieJsDefault.default));
parcelHelpers.export(exports, "LucideFileChartPie", ()=>(0, _fileChartPieJsDefault.default));
parcelHelpers.export(exports, "LucideFilePieChart", ()=>(0, _fileChartPieJsDefault.default));
parcelHelpers.export(exports, "FileCog", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "FileCog2", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "FileCog2Icon", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "FileCogIcon", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "LucideFileCog", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "LucideFileCog2", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "FilePenLine", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "FilePenLineIcon", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "FileSignature", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "FileSignatureIcon", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "LucideFilePenLine", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "LucideFileSignature", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "FileEdit", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "FileEditIcon", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "FilePen", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "FilePenIcon", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "LucideFileEdit", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "LucideFilePen", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "FolderCog", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "FolderCog2", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "FolderCog2Icon", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "FolderCogIcon", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "LucideFolderCog", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "LucideFolderCog2", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "FolderEdit", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "FolderEditIcon", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "FolderPen", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "FolderPenIcon", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "LucideFolderEdit", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "LucideFolderPen", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "FilterX", ()=>(0, _funnelXJsDefault.default));
parcelHelpers.export(exports, "FilterXIcon", ()=>(0, _funnelXJsDefault.default));
parcelHelpers.export(exports, "FunnelX", ()=>(0, _funnelXJsDefault.default));
parcelHelpers.export(exports, "FunnelXIcon", ()=>(0, _funnelXJsDefault.default));
parcelHelpers.export(exports, "LucideFilterX", ()=>(0, _funnelXJsDefault.default));
parcelHelpers.export(exports, "LucideFunnelX", ()=>(0, _funnelXJsDefault.default));
parcelHelpers.export(exports, "Filter", ()=>(0, _funnelJsDefault.default));
parcelHelpers.export(exports, "FilterIcon", ()=>(0, _funnelJsDefault.default));
parcelHelpers.export(exports, "Funnel", ()=>(0, _funnelJsDefault.default));
parcelHelpers.export(exports, "FunnelIcon", ()=>(0, _funnelJsDefault.default));
parcelHelpers.export(exports, "LucideFilter", ()=>(0, _funnelJsDefault.default));
parcelHelpers.export(exports, "LucideFunnel", ()=>(0, _funnelJsDefault.default));
parcelHelpers.export(exports, "GitCommit", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "GitCommitHorizontal", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "GitCommitHorizontalIcon", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "GitCommitIcon", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideGitCommit", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideGitCommitHorizontal", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "Grid2X2Check", ()=>(0, _grid2X2CheckJsDefault.default));
parcelHelpers.export(exports, "Grid2X2CheckIcon", ()=>(0, _grid2X2CheckJsDefault.default));
parcelHelpers.export(exports, "Grid2x2Check", ()=>(0, _grid2X2CheckJsDefault.default));
parcelHelpers.export(exports, "Grid2x2CheckIcon", ()=>(0, _grid2X2CheckJsDefault.default));
parcelHelpers.export(exports, "LucideGrid2X2Check", ()=>(0, _grid2X2CheckJsDefault.default));
parcelHelpers.export(exports, "LucideGrid2x2Check", ()=>(0, _grid2X2CheckJsDefault.default));
parcelHelpers.export(exports, "Grid2X2Plus", ()=>(0, _grid2X2PlusJsDefault.default));
parcelHelpers.export(exports, "Grid2X2PlusIcon", ()=>(0, _grid2X2PlusJsDefault.default));
parcelHelpers.export(exports, "Grid2x2Plus", ()=>(0, _grid2X2PlusJsDefault.default));
parcelHelpers.export(exports, "Grid2x2PlusIcon", ()=>(0, _grid2X2PlusJsDefault.default));
parcelHelpers.export(exports, "LucideGrid2X2Plus", ()=>(0, _grid2X2PlusJsDefault.default));
parcelHelpers.export(exports, "LucideGrid2x2Plus", ()=>(0, _grid2X2PlusJsDefault.default));
parcelHelpers.export(exports, "Grid2X2X", ()=>(0, _grid2X2XJsDefault.default));
parcelHelpers.export(exports, "Grid2X2XIcon", ()=>(0, _grid2X2XJsDefault.default));
parcelHelpers.export(exports, "Grid2x2X", ()=>(0, _grid2X2XJsDefault.default));
parcelHelpers.export(exports, "Grid2x2XIcon", ()=>(0, _grid2X2XJsDefault.default));
parcelHelpers.export(exports, "LucideGrid2X2X", ()=>(0, _grid2X2XJsDefault.default));
parcelHelpers.export(exports, "LucideGrid2x2X", ()=>(0, _grid2X2XJsDefault.default));
parcelHelpers.export(exports, "Grid2X2", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "Grid2X2Icon", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "Grid2x2", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "Grid2x2Icon", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "LucideGrid2X2", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "LucideGrid2x2", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "Grid3X3", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "Grid3X3Icon", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "Grid3x3", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "Grid3x3Icon", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "GridIcon", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "LucideGrid", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "LucideGrid3X3", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "LucideGrid3x3", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "HandHelping", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "HandHelpingIcon", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "HelpingHand", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "HelpingHandIcon", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "LucideHandHelping", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "LucideHelpingHand", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "Home", ()=>(0, _houseJsDefault.default));
parcelHelpers.export(exports, "HomeIcon", ()=>(0, _houseJsDefault.default));
parcelHelpers.export(exports, "House", ()=>(0, _houseJsDefault.default));
parcelHelpers.export(exports, "HouseIcon", ()=>(0, _houseJsDefault.default));
parcelHelpers.export(exports, "LucideHome", ()=>(0, _houseJsDefault.default));
parcelHelpers.export(exports, "LucideHouse", ()=>(0, _houseJsDefault.default));
parcelHelpers.export(exports, "IceCream2", ()=>(0, _iceCreamBowlJsDefault.default));
parcelHelpers.export(exports, "IceCream2Icon", ()=>(0, _iceCreamBowlJsDefault.default));
parcelHelpers.export(exports, "IceCreamBowl", ()=>(0, _iceCreamBowlJsDefault.default));
parcelHelpers.export(exports, "IceCreamBowlIcon", ()=>(0, _iceCreamBowlJsDefault.default));
parcelHelpers.export(exports, "LucideIceCream2", ()=>(0, _iceCreamBowlJsDefault.default));
parcelHelpers.export(exports, "LucideIceCreamBowl", ()=>(0, _iceCreamBowlJsDefault.default));
parcelHelpers.export(exports, "IceCream", ()=>(0, _iceCreamConeJsDefault.default));
parcelHelpers.export(exports, "IceCreamCone", ()=>(0, _iceCreamConeJsDefault.default));
parcelHelpers.export(exports, "IceCreamConeIcon", ()=>(0, _iceCreamConeJsDefault.default));
parcelHelpers.export(exports, "IceCreamIcon", ()=>(0, _iceCreamConeJsDefault.default));
parcelHelpers.export(exports, "LucideIceCream", ()=>(0, _iceCreamConeJsDefault.default));
parcelHelpers.export(exports, "LucideIceCreamCone", ()=>(0, _iceCreamConeJsDefault.default));
parcelHelpers.export(exports, "IndentDecrease", ()=>(0, _indentDecreaseJsDefault.default));
parcelHelpers.export(exports, "IndentDecreaseIcon", ()=>(0, _indentDecreaseJsDefault.default));
parcelHelpers.export(exports, "LucideIndentDecrease", ()=>(0, _indentDecreaseJsDefault.default));
parcelHelpers.export(exports, "LucideOutdent", ()=>(0, _indentDecreaseJsDefault.default));
parcelHelpers.export(exports, "Outdent", ()=>(0, _indentDecreaseJsDefault.default));
parcelHelpers.export(exports, "OutdentIcon", ()=>(0, _indentDecreaseJsDefault.default));
parcelHelpers.export(exports, "Indent", ()=>(0, _indentIncreaseJsDefault.default));
parcelHelpers.export(exports, "IndentIcon", ()=>(0, _indentIncreaseJsDefault.default));
parcelHelpers.export(exports, "IndentIncrease", ()=>(0, _indentIncreaseJsDefault.default));
parcelHelpers.export(exports, "IndentIncreaseIcon", ()=>(0, _indentIncreaseJsDefault.default));
parcelHelpers.export(exports, "LucideIndent", ()=>(0, _indentIncreaseJsDefault.default));
parcelHelpers.export(exports, "LucideIndentIncrease", ()=>(0, _indentIncreaseJsDefault.default));
parcelHelpers.export(exports, "Laptop2", ()=>(0, _laptopMinimalJsDefault.default));
parcelHelpers.export(exports, "Laptop2Icon", ()=>(0, _laptopMinimalJsDefault.default));
parcelHelpers.export(exports, "LaptopMinimal", ()=>(0, _laptopMinimalJsDefault.default));
parcelHelpers.export(exports, "LaptopMinimalIcon", ()=>(0, _laptopMinimalJsDefault.default));
parcelHelpers.export(exports, "LucideLaptop2", ()=>(0, _laptopMinimalJsDefault.default));
parcelHelpers.export(exports, "LucideLaptopMinimal", ()=>(0, _laptopMinimalJsDefault.default));
parcelHelpers.export(exports, "Layers", ()=>(0, _layersJsDefault.default));
parcelHelpers.export(exports, "Layers3", ()=>(0, _layersJsDefault.default));
parcelHelpers.export(exports, "Layers3Icon", ()=>(0, _layersJsDefault.default));
parcelHelpers.export(exports, "LayersIcon", ()=>(0, _layersJsDefault.default));
parcelHelpers.export(exports, "LucideLayers", ()=>(0, _layersJsDefault.default));
parcelHelpers.export(exports, "LucideLayers3", ()=>(0, _layersJsDefault.default));
parcelHelpers.export(exports, "Loader2", ()=>(0, _loaderCircleJsDefault.default));
parcelHelpers.export(exports, "Loader2Icon", ()=>(0, _loaderCircleJsDefault.default));
parcelHelpers.export(exports, "LoaderCircle", ()=>(0, _loaderCircleJsDefault.default));
parcelHelpers.export(exports, "LoaderCircleIcon", ()=>(0, _loaderCircleJsDefault.default));
parcelHelpers.export(exports, "LucideLoader2", ()=>(0, _loaderCircleJsDefault.default));
parcelHelpers.export(exports, "LucideLoaderCircle", ()=>(0, _loaderCircleJsDefault.default));
parcelHelpers.export(exports, "LockKeyholeOpen", ()=>(0, _lockKeyholeOpenJsDefault.default));
parcelHelpers.export(exports, "LockKeyholeOpenIcon", ()=>(0, _lockKeyholeOpenJsDefault.default));
parcelHelpers.export(exports, "LucideLockKeyholeOpen", ()=>(0, _lockKeyholeOpenJsDefault.default));
parcelHelpers.export(exports, "LucideUnlockKeyhole", ()=>(0, _lockKeyholeOpenJsDefault.default));
parcelHelpers.export(exports, "UnlockKeyhole", ()=>(0, _lockKeyholeOpenJsDefault.default));
parcelHelpers.export(exports, "UnlockKeyholeIcon", ()=>(0, _lockKeyholeOpenJsDefault.default));
parcelHelpers.export(exports, "LockOpen", ()=>(0, _lockOpenJsDefault.default));
parcelHelpers.export(exports, "LockOpenIcon", ()=>(0, _lockOpenJsDefault.default));
parcelHelpers.export(exports, "LucideLockOpen", ()=>(0, _lockOpenJsDefault.default));
parcelHelpers.export(exports, "LucideUnlock", ()=>(0, _lockOpenJsDefault.default));
parcelHelpers.export(exports, "Unlock", ()=>(0, _lockOpenJsDefault.default));
parcelHelpers.export(exports, "UnlockIcon", ()=>(0, _lockOpenJsDefault.default));
parcelHelpers.export(exports, "LucideMic2", ()=>(0, _micVocalJsDefault.default));
parcelHelpers.export(exports, "LucideMicVocal", ()=>(0, _micVocalJsDefault.default));
parcelHelpers.export(exports, "Mic2", ()=>(0, _micVocalJsDefault.default));
parcelHelpers.export(exports, "Mic2Icon", ()=>(0, _micVocalJsDefault.default));
parcelHelpers.export(exports, "MicVocal", ()=>(0, _micVocalJsDefault.default));
parcelHelpers.export(exports, "MicVocalIcon", ()=>(0, _micVocalJsDefault.default));
parcelHelpers.export(exports, "LucideMove3D", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "LucideMove3d", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "Move3D", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "Move3DIcon", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "Move3d", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "Move3dIcon", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "AlertOctagon", ()=>(0, _octagonAlertJsDefault.default));
parcelHelpers.export(exports, "AlertOctagonIcon", ()=>(0, _octagonAlertJsDefault.default));
parcelHelpers.export(exports, "LucideAlertOctagon", ()=>(0, _octagonAlertJsDefault.default));
parcelHelpers.export(exports, "LucideOctagonAlert", ()=>(0, _octagonAlertJsDefault.default));
parcelHelpers.export(exports, "OctagonAlert", ()=>(0, _octagonAlertJsDefault.default));
parcelHelpers.export(exports, "OctagonAlertIcon", ()=>(0, _octagonAlertJsDefault.default));
parcelHelpers.export(exports, "LucideOctagonPause", ()=>(0, _octagonPauseJsDefault.default));
parcelHelpers.export(exports, "LucidePauseOctagon", ()=>(0, _octagonPauseJsDefault.default));
parcelHelpers.export(exports, "OctagonPause", ()=>(0, _octagonPauseJsDefault.default));
parcelHelpers.export(exports, "OctagonPauseIcon", ()=>(0, _octagonPauseJsDefault.default));
parcelHelpers.export(exports, "PauseOctagon", ()=>(0, _octagonPauseJsDefault.default));
parcelHelpers.export(exports, "PauseOctagonIcon", ()=>(0, _octagonPauseJsDefault.default));
parcelHelpers.export(exports, "LucideOctagonX", ()=>(0, _octagonXJsDefault.default));
parcelHelpers.export(exports, "LucideXOctagon", ()=>(0, _octagonXJsDefault.default));
parcelHelpers.export(exports, "OctagonX", ()=>(0, _octagonXJsDefault.default));
parcelHelpers.export(exports, "OctagonXIcon", ()=>(0, _octagonXJsDefault.default));
parcelHelpers.export(exports, "XOctagon", ()=>(0, _octagonXJsDefault.default));
parcelHelpers.export(exports, "XOctagonIcon", ()=>(0, _octagonXJsDefault.default));
parcelHelpers.export(exports, "LucidePaintbrush2", ()=>(0, _paintbrushVerticalJsDefault.default));
parcelHelpers.export(exports, "LucidePaintbrushVertical", ()=>(0, _paintbrushVerticalJsDefault.default));
parcelHelpers.export(exports, "Paintbrush2", ()=>(0, _paintbrushVerticalJsDefault.default));
parcelHelpers.export(exports, "Paintbrush2Icon", ()=>(0, _paintbrushVerticalJsDefault.default));
parcelHelpers.export(exports, "PaintbrushVertical", ()=>(0, _paintbrushVerticalJsDefault.default));
parcelHelpers.export(exports, "PaintbrushVerticalIcon", ()=>(0, _paintbrushVerticalJsDefault.default));
parcelHelpers.export(exports, "LucidePanelBottomDashed", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelBottomInactive", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "PanelBottomDashed", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "PanelBottomDashedIcon", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "PanelBottomInactive", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "PanelBottomInactiveIcon", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelLeftDashed", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelLeftInactive", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "PanelLeftDashed", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "PanelLeftDashedIcon", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "PanelLeftInactive", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "PanelLeftInactiveIcon", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelLeftClose", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "LucideSidebarClose", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "PanelLeftClose", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "PanelLeftCloseIcon", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "SidebarClose", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "SidebarCloseIcon", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "LucidePanelLeftOpen", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "LucideSidebarOpen", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "PanelLeftOpen", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "PanelLeftOpenIcon", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "SidebarOpen", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "SidebarOpenIcon", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "LucidePanelLeft", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "LucideSidebar", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "PanelLeft", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "PanelLeftIcon", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "Sidebar", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "SidebarIcon", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "LucidePanelRightDashed", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelRightInactive", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "PanelRightDashed", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "PanelRightDashedIcon", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "PanelRightInactive", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "PanelRightInactiveIcon", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelTopDashed", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelTopInactive", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "PanelTopDashed", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "PanelTopDashedIcon", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "PanelTopInactive", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "PanelTopInactiveIcon", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "Layout", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "LayoutIcon", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "LucideLayout", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "LucidePanelsTopLeft", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "PanelsTopLeft", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "PanelsTopLeftIcon", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "Edit3", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "Edit3Icon", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "LucideEdit3", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "LucidePenLine", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "PenLine", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "PenLineIcon", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "Edit2", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "Edit2Icon", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "LucideEdit2", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "LucidePen", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "Pen", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "PenIcon", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "LucidePlugZap", ()=>(0, _plugZapJsDefault.default));
parcelHelpers.export(exports, "LucidePlugZap2", ()=>(0, _plugZapJsDefault.default));
parcelHelpers.export(exports, "PlugZap", ()=>(0, _plugZapJsDefault.default));
parcelHelpers.export(exports, "PlugZap2", ()=>(0, _plugZapJsDefault.default));
parcelHelpers.export(exports, "PlugZap2Icon", ()=>(0, _plugZapJsDefault.default));
parcelHelpers.export(exports, "PlugZapIcon", ()=>(0, _plugZapJsDefault.default));
parcelHelpers.export(exports, "FormInput", ()=>(0, _rectangleEllipsisJsDefault.default));
parcelHelpers.export(exports, "FormInputIcon", ()=>(0, _rectangleEllipsisJsDefault.default));
parcelHelpers.export(exports, "LucideFormInput", ()=>(0, _rectangleEllipsisJsDefault.default));
parcelHelpers.export(exports, "LucideRectangleEllipsis", ()=>(0, _rectangleEllipsisJsDefault.default));
parcelHelpers.export(exports, "RectangleEllipsis", ()=>(0, _rectangleEllipsisJsDefault.default));
parcelHelpers.export(exports, "RectangleEllipsisIcon", ()=>(0, _rectangleEllipsisJsDefault.default));
parcelHelpers.export(exports, "LucideRotate3D", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "LucideRotate3d", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "Rotate3D", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "Rotate3DIcon", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "Rotate3d", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "Rotate3dIcon", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "LucideRows", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "LucideRows2", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "Rows", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "Rows2", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "Rows2Icon", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "RowsIcon", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "LucidePanelsTopBottom", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "LucideRows3", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "PanelsTopBottom", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "PanelsTopBottomIcon", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "Rows3", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "Rows3Icon", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "LucideScale3D", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "LucideScale3d", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "Scale3D", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "Scale3DIcon", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "Scale3d", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "Scale3dIcon", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "LucideSendHorizonal", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideSendHorizontal", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "SendHorizonal", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "SendHorizonalIcon", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "SendHorizontal", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "SendHorizontalIcon", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideShieldClose", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "LucideShieldX", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "ShieldClose", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "ShieldCloseIcon", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "ShieldX", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "ShieldXIcon", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "LucideSliders", ()=>(0, _slidersVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideSlidersVertical", ()=>(0, _slidersVerticalJsDefault.default));
parcelHelpers.export(exports, "Sliders", ()=>(0, _slidersVerticalJsDefault.default));
parcelHelpers.export(exports, "SlidersIcon", ()=>(0, _slidersVerticalJsDefault.default));
parcelHelpers.export(exports, "SlidersVertical", ()=>(0, _slidersVerticalJsDefault.default));
parcelHelpers.export(exports, "SlidersVerticalIcon", ()=>(0, _slidersVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideSparkles", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "LucideStars", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "Sparkles", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "SparklesIcon", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "Stars", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "StarsIcon", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "ActivitySquare", ()=>(0, _squareActivityJsDefault.default));
parcelHelpers.export(exports, "ActivitySquareIcon", ()=>(0, _squareActivityJsDefault.default));
parcelHelpers.export(exports, "LucideActivitySquare", ()=>(0, _squareActivityJsDefault.default));
parcelHelpers.export(exports, "LucideSquareActivity", ()=>(0, _squareActivityJsDefault.default));
parcelHelpers.export(exports, "SquareActivity", ()=>(0, _squareActivityJsDefault.default));
parcelHelpers.export(exports, "SquareActivityIcon", ()=>(0, _squareActivityJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftSquare", ()=>(0, _squareArrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftSquareIcon", ()=>(0, _squareArrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownLeftSquare", ()=>(0, _squareArrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowDownLeft", ()=>(0, _squareArrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "SquareArrowDownLeft", ()=>(0, _squareArrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "SquareArrowDownLeftIcon", ()=>(0, _squareArrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightSquare", ()=>(0, _squareArrowDownRightJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightSquareIcon", ()=>(0, _squareArrowDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownRightSquare", ()=>(0, _squareArrowDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowDownRight", ()=>(0, _squareArrowDownRightJsDefault.default));
parcelHelpers.export(exports, "SquareArrowDownRight", ()=>(0, _squareArrowDownRightJsDefault.default));
parcelHelpers.export(exports, "SquareArrowDownRightIcon", ()=>(0, _squareArrowDownRightJsDefault.default));
parcelHelpers.export(exports, "ArrowDownSquare", ()=>(0, _squareArrowDownJsDefault.default));
parcelHelpers.export(exports, "ArrowDownSquareIcon", ()=>(0, _squareArrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownSquare", ()=>(0, _squareArrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowDown", ()=>(0, _squareArrowDownJsDefault.default));
parcelHelpers.export(exports, "SquareArrowDown", ()=>(0, _squareArrowDownJsDefault.default));
parcelHelpers.export(exports, "SquareArrowDownIcon", ()=>(0, _squareArrowDownJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightFromSquare", ()=>(0, _squareArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightFromSquareIcon", ()=>(0, _squareArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownRightFromSquare", ()=>(0, _squareArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowOutDownRight", ()=>(0, _squareArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "SquareArrowOutDownRight", ()=>(0, _squareArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "SquareArrowOutDownRightIcon", ()=>(0, _squareArrowOutDownRightJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftFromSquare", ()=>(0, _squareArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftFromSquareIcon", ()=>(0, _squareArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownLeftFromSquare", ()=>(0, _squareArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowOutDownLeft", ()=>(0, _squareArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "SquareArrowOutDownLeft", ()=>(0, _squareArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "SquareArrowOutDownLeftIcon", ()=>(0, _squareArrowOutDownLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftSquare", ()=>(0, _squareArrowLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftSquareIcon", ()=>(0, _squareArrowLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeftSquare", ()=>(0, _squareArrowLeftJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowLeft", ()=>(0, _squareArrowLeftJsDefault.default));
parcelHelpers.export(exports, "SquareArrowLeft", ()=>(0, _squareArrowLeftJsDefault.default));
parcelHelpers.export(exports, "SquareArrowLeftIcon", ()=>(0, _squareArrowLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftFromSquare", ()=>(0, _squareArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftFromSquareIcon", ()=>(0, _squareArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpLeftFromSquare", ()=>(0, _squareArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowOutUpLeft", ()=>(0, _squareArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "SquareArrowOutUpLeft", ()=>(0, _squareArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "SquareArrowOutUpLeftIcon", ()=>(0, _squareArrowOutUpLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightFromSquare", ()=>(0, _squareArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightFromSquareIcon", ()=>(0, _squareArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpRightFromSquare", ()=>(0, _squareArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowOutUpRight", ()=>(0, _squareArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "SquareArrowOutUpRight", ()=>(0, _squareArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "SquareArrowOutUpRightIcon", ()=>(0, _squareArrowOutUpRightJsDefault.default));
parcelHelpers.export(exports, "ArrowRightSquare", ()=>(0, _squareArrowRightJsDefault.default));
parcelHelpers.export(exports, "ArrowRightSquareIcon", ()=>(0, _squareArrowRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRightSquare", ()=>(0, _squareArrowRightJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowRight", ()=>(0, _squareArrowRightJsDefault.default));
parcelHelpers.export(exports, "SquareArrowRight", ()=>(0, _squareArrowRightJsDefault.default));
parcelHelpers.export(exports, "SquareArrowRightIcon", ()=>(0, _squareArrowRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftSquare", ()=>(0, _squareArrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftSquareIcon", ()=>(0, _squareArrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpLeftSquare", ()=>(0, _squareArrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowUpLeft", ()=>(0, _squareArrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "SquareArrowUpLeft", ()=>(0, _squareArrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "SquareArrowUpLeftIcon", ()=>(0, _squareArrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightSquare", ()=>(0, _squareArrowUpRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightSquareIcon", ()=>(0, _squareArrowUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpRightSquare", ()=>(0, _squareArrowUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowUpRight", ()=>(0, _squareArrowUpRightJsDefault.default));
parcelHelpers.export(exports, "SquareArrowUpRight", ()=>(0, _squareArrowUpRightJsDefault.default));
parcelHelpers.export(exports, "SquareArrowUpRightIcon", ()=>(0, _squareArrowUpRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpSquare", ()=>(0, _squareArrowUpJsDefault.default));
parcelHelpers.export(exports, "ArrowUpSquareIcon", ()=>(0, _squareArrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpSquare", ()=>(0, _squareArrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideSquareArrowUp", ()=>(0, _squareArrowUpJsDefault.default));
parcelHelpers.export(exports, "SquareArrowUp", ()=>(0, _squareArrowUpJsDefault.default));
parcelHelpers.export(exports, "SquareArrowUpIcon", ()=>(0, _squareArrowUpJsDefault.default));
parcelHelpers.export(exports, "AsteriskSquare", ()=>(0, _squareAsteriskJsDefault.default));
parcelHelpers.export(exports, "AsteriskSquareIcon", ()=>(0, _squareAsteriskJsDefault.default));
parcelHelpers.export(exports, "LucideAsteriskSquare", ()=>(0, _squareAsteriskJsDefault.default));
parcelHelpers.export(exports, "LucideSquareAsterisk", ()=>(0, _squareAsteriskJsDefault.default));
parcelHelpers.export(exports, "SquareAsterisk", ()=>(0, _squareAsteriskJsDefault.default));
parcelHelpers.export(exports, "SquareAsteriskIcon", ()=>(0, _squareAsteriskJsDefault.default));
parcelHelpers.export(exports, "LucideScissorsSquareDashedBottom", ()=>(0, _squareBottomDashedScissorsJsDefault.default));
parcelHelpers.export(exports, "LucideSquareBottomDashedScissors", ()=>(0, _squareBottomDashedScissorsJsDefault.default));
parcelHelpers.export(exports, "ScissorsSquareDashedBottom", ()=>(0, _squareBottomDashedScissorsJsDefault.default));
parcelHelpers.export(exports, "ScissorsSquareDashedBottomIcon", ()=>(0, _squareBottomDashedScissorsJsDefault.default));
parcelHelpers.export(exports, "SquareBottomDashedScissors", ()=>(0, _squareBottomDashedScissorsJsDefault.default));
parcelHelpers.export(exports, "SquareBottomDashedScissorsIcon", ()=>(0, _squareBottomDashedScissorsJsDefault.default));
parcelHelpers.export(exports, "GanttChartSquare", ()=>(0, _squareChartGanttJsDefault.default));
parcelHelpers.export(exports, "GanttChartSquareIcon", ()=>(0, _squareChartGanttJsDefault.default));
parcelHelpers.export(exports, "LucideGanttChartSquare", ()=>(0, _squareChartGanttJsDefault.default));
parcelHelpers.export(exports, "LucideSquareChartGantt", ()=>(0, _squareChartGanttJsDefault.default));
parcelHelpers.export(exports, "LucideSquareGanttChart", ()=>(0, _squareChartGanttJsDefault.default));
parcelHelpers.export(exports, "SquareChartGantt", ()=>(0, _squareChartGanttJsDefault.default));
parcelHelpers.export(exports, "SquareChartGanttIcon", ()=>(0, _squareChartGanttJsDefault.default));
parcelHelpers.export(exports, "SquareGanttChart", ()=>(0, _squareChartGanttJsDefault.default));
parcelHelpers.export(exports, "SquareGanttChartIcon", ()=>(0, _squareChartGanttJsDefault.default));
parcelHelpers.export(exports, "CheckSquare", ()=>(0, _squareCheckBigJsDefault.default));
parcelHelpers.export(exports, "CheckSquareIcon", ()=>(0, _squareCheckBigJsDefault.default));
parcelHelpers.export(exports, "LucideCheckSquare", ()=>(0, _squareCheckBigJsDefault.default));
parcelHelpers.export(exports, "LucideSquareCheckBig", ()=>(0, _squareCheckBigJsDefault.default));
parcelHelpers.export(exports, "SquareCheckBig", ()=>(0, _squareCheckBigJsDefault.default));
parcelHelpers.export(exports, "SquareCheckBigIcon", ()=>(0, _squareCheckBigJsDefault.default));
parcelHelpers.export(exports, "ChevronDownSquare", ()=>(0, _squareChevronDownJsDefault.default));
parcelHelpers.export(exports, "ChevronDownSquareIcon", ()=>(0, _squareChevronDownJsDefault.default));
parcelHelpers.export(exports, "LucideChevronDownSquare", ()=>(0, _squareChevronDownJsDefault.default));
parcelHelpers.export(exports, "LucideSquareChevronDown", ()=>(0, _squareChevronDownJsDefault.default));
parcelHelpers.export(exports, "SquareChevronDown", ()=>(0, _squareChevronDownJsDefault.default));
parcelHelpers.export(exports, "SquareChevronDownIcon", ()=>(0, _squareChevronDownJsDefault.default));
parcelHelpers.export(exports, "CheckSquare2", ()=>(0, _squareCheckJsDefault.default));
parcelHelpers.export(exports, "CheckSquare2Icon", ()=>(0, _squareCheckJsDefault.default));
parcelHelpers.export(exports, "LucideCheckSquare2", ()=>(0, _squareCheckJsDefault.default));
parcelHelpers.export(exports, "LucideSquareCheck", ()=>(0, _squareCheckJsDefault.default));
parcelHelpers.export(exports, "SquareCheck", ()=>(0, _squareCheckJsDefault.default));
parcelHelpers.export(exports, "SquareCheckIcon", ()=>(0, _squareCheckJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftSquare", ()=>(0, _squareChevronLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftSquareIcon", ()=>(0, _squareChevronLeftJsDefault.default));
parcelHelpers.export(exports, "LucideChevronLeftSquare", ()=>(0, _squareChevronLeftJsDefault.default));
parcelHelpers.export(exports, "LucideSquareChevronLeft", ()=>(0, _squareChevronLeftJsDefault.default));
parcelHelpers.export(exports, "SquareChevronLeft", ()=>(0, _squareChevronLeftJsDefault.default));
parcelHelpers.export(exports, "SquareChevronLeftIcon", ()=>(0, _squareChevronLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronRightSquare", ()=>(0, _squareChevronRightJsDefault.default));
parcelHelpers.export(exports, "ChevronRightSquareIcon", ()=>(0, _squareChevronRightJsDefault.default));
parcelHelpers.export(exports, "LucideChevronRightSquare", ()=>(0, _squareChevronRightJsDefault.default));
parcelHelpers.export(exports, "LucideSquareChevronRight", ()=>(0, _squareChevronRightJsDefault.default));
parcelHelpers.export(exports, "SquareChevronRight", ()=>(0, _squareChevronRightJsDefault.default));
parcelHelpers.export(exports, "SquareChevronRightIcon", ()=>(0, _squareChevronRightJsDefault.default));
parcelHelpers.export(exports, "CodeSquare", ()=>(0, _squareCodeJsDefault.default));
parcelHelpers.export(exports, "CodeSquareIcon", ()=>(0, _squareCodeJsDefault.default));
parcelHelpers.export(exports, "LucideCodeSquare", ()=>(0, _squareCodeJsDefault.default));
parcelHelpers.export(exports, "LucideSquareCode", ()=>(0, _squareCodeJsDefault.default));
parcelHelpers.export(exports, "SquareCode", ()=>(0, _squareCodeJsDefault.default));
parcelHelpers.export(exports, "SquareCodeIcon", ()=>(0, _squareCodeJsDefault.default));
parcelHelpers.export(exports, "ChevronUpSquare", ()=>(0, _squareChevronUpJsDefault.default));
parcelHelpers.export(exports, "ChevronUpSquareIcon", ()=>(0, _squareChevronUpJsDefault.default));
parcelHelpers.export(exports, "LucideChevronUpSquare", ()=>(0, _squareChevronUpJsDefault.default));
parcelHelpers.export(exports, "LucideSquareChevronUp", ()=>(0, _squareChevronUpJsDefault.default));
parcelHelpers.export(exports, "SquareChevronUp", ()=>(0, _squareChevronUpJsDefault.default));
parcelHelpers.export(exports, "SquareChevronUpIcon", ()=>(0, _squareChevronUpJsDefault.default));
parcelHelpers.export(exports, "LucideMousePointerSquareDashed", ()=>(0, _squareDashedMousePointerJsDefault.default));
parcelHelpers.export(exports, "LucideSquareDashedMousePointer", ()=>(0, _squareDashedMousePointerJsDefault.default));
parcelHelpers.export(exports, "MousePointerSquareDashed", ()=>(0, _squareDashedMousePointerJsDefault.default));
parcelHelpers.export(exports, "MousePointerSquareDashedIcon", ()=>(0, _squareDashedMousePointerJsDefault.default));
parcelHelpers.export(exports, "SquareDashedMousePointer", ()=>(0, _squareDashedMousePointerJsDefault.default));
parcelHelpers.export(exports, "SquareDashedMousePointerIcon", ()=>(0, _squareDashedMousePointerJsDefault.default));
parcelHelpers.export(exports, "BoxSelect", ()=>(0, _squareDashedJsDefault.default));
parcelHelpers.export(exports, "BoxSelectIcon", ()=>(0, _squareDashedJsDefault.default));
parcelHelpers.export(exports, "LucideBoxSelect", ()=>(0, _squareDashedJsDefault.default));
parcelHelpers.export(exports, "LucideSquareDashed", ()=>(0, _squareDashedJsDefault.default));
parcelHelpers.export(exports, "SquareDashed", ()=>(0, _squareDashedJsDefault.default));
parcelHelpers.export(exports, "SquareDashedIcon", ()=>(0, _squareDashedJsDefault.default));
parcelHelpers.export(exports, "KanbanSquareDashed", ()=>(0, _squareDashedKanbanJsDefault.default));
parcelHelpers.export(exports, "KanbanSquareDashedIcon", ()=>(0, _squareDashedKanbanJsDefault.default));
parcelHelpers.export(exports, "LucideKanbanSquareDashed", ()=>(0, _squareDashedKanbanJsDefault.default));
parcelHelpers.export(exports, "LucideSquareDashedKanban", ()=>(0, _squareDashedKanbanJsDefault.default));
parcelHelpers.export(exports, "SquareDashedKanban", ()=>(0, _squareDashedKanbanJsDefault.default));
parcelHelpers.export(exports, "SquareDashedKanbanIcon", ()=>(0, _squareDashedKanbanJsDefault.default));
parcelHelpers.export(exports, "DivideSquare", ()=>(0, _squareDivideJsDefault.default));
parcelHelpers.export(exports, "DivideSquareIcon", ()=>(0, _squareDivideJsDefault.default));
parcelHelpers.export(exports, "LucideDivideSquare", ()=>(0, _squareDivideJsDefault.default));
parcelHelpers.export(exports, "LucideSquareDivide", ()=>(0, _squareDivideJsDefault.default));
parcelHelpers.export(exports, "SquareDivide", ()=>(0, _squareDivideJsDefault.default));
parcelHelpers.export(exports, "SquareDivideIcon", ()=>(0, _squareDivideJsDefault.default));
parcelHelpers.export(exports, "DotSquare", ()=>(0, _squareDotJsDefault.default));
parcelHelpers.export(exports, "DotSquareIcon", ()=>(0, _squareDotJsDefault.default));
parcelHelpers.export(exports, "LucideDotSquare", ()=>(0, _squareDotJsDefault.default));
parcelHelpers.export(exports, "LucideSquareDot", ()=>(0, _squareDotJsDefault.default));
parcelHelpers.export(exports, "SquareDot", ()=>(0, _squareDotJsDefault.default));
parcelHelpers.export(exports, "SquareDotIcon", ()=>(0, _squareDotJsDefault.default));
parcelHelpers.export(exports, "EqualSquare", ()=>(0, _squareEqualJsDefault.default));
parcelHelpers.export(exports, "EqualSquareIcon", ()=>(0, _squareEqualJsDefault.default));
parcelHelpers.export(exports, "LucideEqualSquare", ()=>(0, _squareEqualJsDefault.default));
parcelHelpers.export(exports, "LucideSquareEqual", ()=>(0, _squareEqualJsDefault.default));
parcelHelpers.export(exports, "SquareEqual", ()=>(0, _squareEqualJsDefault.default));
parcelHelpers.export(exports, "SquareEqualIcon", ()=>(0, _squareEqualJsDefault.default));
parcelHelpers.export(exports, "FunctionSquare", ()=>(0, _squareFunctionJsDefault.default));
parcelHelpers.export(exports, "FunctionSquareIcon", ()=>(0, _squareFunctionJsDefault.default));
parcelHelpers.export(exports, "LucideFunctionSquare", ()=>(0, _squareFunctionJsDefault.default));
parcelHelpers.export(exports, "LucideSquareFunction", ()=>(0, _squareFunctionJsDefault.default));
parcelHelpers.export(exports, "SquareFunction", ()=>(0, _squareFunctionJsDefault.default));
parcelHelpers.export(exports, "SquareFunctionIcon", ()=>(0, _squareFunctionJsDefault.default));
parcelHelpers.export(exports, "KanbanSquare", ()=>(0, _squareKanbanJsDefault.default));
parcelHelpers.export(exports, "KanbanSquareIcon", ()=>(0, _squareKanbanJsDefault.default));
parcelHelpers.export(exports, "LucideKanbanSquare", ()=>(0, _squareKanbanJsDefault.default));
parcelHelpers.export(exports, "LucideSquareKanban", ()=>(0, _squareKanbanJsDefault.default));
parcelHelpers.export(exports, "SquareKanban", ()=>(0, _squareKanbanJsDefault.default));
parcelHelpers.export(exports, "SquareKanbanIcon", ()=>(0, _squareKanbanJsDefault.default));
parcelHelpers.export(exports, "LibrarySquare", ()=>(0, _squareLibraryJsDefault.default));
parcelHelpers.export(exports, "LibrarySquareIcon", ()=>(0, _squareLibraryJsDefault.default));
parcelHelpers.export(exports, "LucideLibrarySquare", ()=>(0, _squareLibraryJsDefault.default));
parcelHelpers.export(exports, "LucideSquareLibrary", ()=>(0, _squareLibraryJsDefault.default));
parcelHelpers.export(exports, "SquareLibrary", ()=>(0, _squareLibraryJsDefault.default));
parcelHelpers.export(exports, "SquareLibraryIcon", ()=>(0, _squareLibraryJsDefault.default));
parcelHelpers.export(exports, "LucideMSquare", ()=>(0, _squareMJsDefault.default));
parcelHelpers.export(exports, "LucideSquareM", ()=>(0, _squareMJsDefault.default));
parcelHelpers.export(exports, "MSquare", ()=>(0, _squareMJsDefault.default));
parcelHelpers.export(exports, "MSquareIcon", ()=>(0, _squareMJsDefault.default));
parcelHelpers.export(exports, "SquareM", ()=>(0, _squareMJsDefault.default));
parcelHelpers.export(exports, "SquareMIcon", ()=>(0, _squareMJsDefault.default));
parcelHelpers.export(exports, "LucideMenuSquare", ()=>(0, _squareMenuJsDefault.default));
parcelHelpers.export(exports, "LucideSquareMenu", ()=>(0, _squareMenuJsDefault.default));
parcelHelpers.export(exports, "MenuSquare", ()=>(0, _squareMenuJsDefault.default));
parcelHelpers.export(exports, "MenuSquareIcon", ()=>(0, _squareMenuJsDefault.default));
parcelHelpers.export(exports, "SquareMenu", ()=>(0, _squareMenuJsDefault.default));
parcelHelpers.export(exports, "SquareMenuIcon", ()=>(0, _squareMenuJsDefault.default));
parcelHelpers.export(exports, "LucideMinusSquare", ()=>(0, _squareMinusJsDefault.default));
parcelHelpers.export(exports, "LucideSquareMinus", ()=>(0, _squareMinusJsDefault.default));
parcelHelpers.export(exports, "MinusSquare", ()=>(0, _squareMinusJsDefault.default));
parcelHelpers.export(exports, "MinusSquareIcon", ()=>(0, _squareMinusJsDefault.default));
parcelHelpers.export(exports, "SquareMinus", ()=>(0, _squareMinusJsDefault.default));
parcelHelpers.export(exports, "SquareMinusIcon", ()=>(0, _squareMinusJsDefault.default));
parcelHelpers.export(exports, "Inspect", ()=>(0, _squareMousePointerJsDefault.default));
parcelHelpers.export(exports, "InspectIcon", ()=>(0, _squareMousePointerJsDefault.default));
parcelHelpers.export(exports, "LucideInspect", ()=>(0, _squareMousePointerJsDefault.default));
parcelHelpers.export(exports, "LucideSquareMousePointer", ()=>(0, _squareMousePointerJsDefault.default));
parcelHelpers.export(exports, "SquareMousePointer", ()=>(0, _squareMousePointerJsDefault.default));
parcelHelpers.export(exports, "SquareMousePointerIcon", ()=>(0, _squareMousePointerJsDefault.default));
parcelHelpers.export(exports, "LucideParkingSquareOff", ()=>(0, _squareParkingOffJsDefault.default));
parcelHelpers.export(exports, "LucideSquareParkingOff", ()=>(0, _squareParkingOffJsDefault.default));
parcelHelpers.export(exports, "ParkingSquareOff", ()=>(0, _squareParkingOffJsDefault.default));
parcelHelpers.export(exports, "ParkingSquareOffIcon", ()=>(0, _squareParkingOffJsDefault.default));
parcelHelpers.export(exports, "SquareParkingOff", ()=>(0, _squareParkingOffJsDefault.default));
parcelHelpers.export(exports, "SquareParkingOffIcon", ()=>(0, _squareParkingOffJsDefault.default));
parcelHelpers.export(exports, "LucideParkingSquare", ()=>(0, _squareParkingJsDefault.default));
parcelHelpers.export(exports, "LucideSquareParking", ()=>(0, _squareParkingJsDefault.default));
parcelHelpers.export(exports, "ParkingSquare", ()=>(0, _squareParkingJsDefault.default));
parcelHelpers.export(exports, "ParkingSquareIcon", ()=>(0, _squareParkingJsDefault.default));
parcelHelpers.export(exports, "SquareParking", ()=>(0, _squareParkingJsDefault.default));
parcelHelpers.export(exports, "SquareParkingIcon", ()=>(0, _squareParkingJsDefault.default));
parcelHelpers.export(exports, "Edit", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "EditIcon", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "LucideEdit", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "LucidePenBox", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "LucidePenSquare", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "LucideSquarePen", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "PenBox", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "PenBoxIcon", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "PenSquare", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "PenSquareIcon", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "SquarePen", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "SquarePenIcon", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "LucidePercentSquare", ()=>(0, _squarePercentJsDefault.default));
parcelHelpers.export(exports, "LucideSquarePercent", ()=>(0, _squarePercentJsDefault.default));
parcelHelpers.export(exports, "PercentSquare", ()=>(0, _squarePercentJsDefault.default));
parcelHelpers.export(exports, "PercentSquareIcon", ()=>(0, _squarePercentJsDefault.default));
parcelHelpers.export(exports, "SquarePercent", ()=>(0, _squarePercentJsDefault.default));
parcelHelpers.export(exports, "SquarePercentIcon", ()=>(0, _squarePercentJsDefault.default));
parcelHelpers.export(exports, "LucidePiSquare", ()=>(0, _squarePiJsDefault.default));
parcelHelpers.export(exports, "LucideSquarePi", ()=>(0, _squarePiJsDefault.default));
parcelHelpers.export(exports, "PiSquare", ()=>(0, _squarePiJsDefault.default));
parcelHelpers.export(exports, "PiSquareIcon", ()=>(0, _squarePiJsDefault.default));
parcelHelpers.export(exports, "SquarePi", ()=>(0, _squarePiJsDefault.default));
parcelHelpers.export(exports, "SquarePiIcon", ()=>(0, _squarePiJsDefault.default));
parcelHelpers.export(exports, "LucidePlaySquare", ()=>(0, _squarePlayJsDefault.default));
parcelHelpers.export(exports, "LucideSquarePlay", ()=>(0, _squarePlayJsDefault.default));
parcelHelpers.export(exports, "PlaySquare", ()=>(0, _squarePlayJsDefault.default));
parcelHelpers.export(exports, "PlaySquareIcon", ()=>(0, _squarePlayJsDefault.default));
parcelHelpers.export(exports, "SquarePlay", ()=>(0, _squarePlayJsDefault.default));
parcelHelpers.export(exports, "SquarePlayIcon", ()=>(0, _squarePlayJsDefault.default));
parcelHelpers.export(exports, "LucidePilcrowSquare", ()=>(0, _squarePilcrowJsDefault.default));
parcelHelpers.export(exports, "LucideSquarePilcrow", ()=>(0, _squarePilcrowJsDefault.default));
parcelHelpers.export(exports, "PilcrowSquare", ()=>(0, _squarePilcrowJsDefault.default));
parcelHelpers.export(exports, "PilcrowSquareIcon", ()=>(0, _squarePilcrowJsDefault.default));
parcelHelpers.export(exports, "SquarePilcrow", ()=>(0, _squarePilcrowJsDefault.default));
parcelHelpers.export(exports, "SquarePilcrowIcon", ()=>(0, _squarePilcrowJsDefault.default));
parcelHelpers.export(exports, "LucidePlusSquare", ()=>(0, _squarePlusJsDefault.default));
parcelHelpers.export(exports, "LucideSquarePlus", ()=>(0, _squarePlusJsDefault.default));
parcelHelpers.export(exports, "PlusSquare", ()=>(0, _squarePlusJsDefault.default));
parcelHelpers.export(exports, "PlusSquareIcon", ()=>(0, _squarePlusJsDefault.default));
parcelHelpers.export(exports, "SquarePlus", ()=>(0, _squarePlusJsDefault.default));
parcelHelpers.export(exports, "SquarePlusIcon", ()=>(0, _squarePlusJsDefault.default));
parcelHelpers.export(exports, "LucidePowerSquare", ()=>(0, _squarePowerJsDefault.default));
parcelHelpers.export(exports, "LucideSquarePower", ()=>(0, _squarePowerJsDefault.default));
parcelHelpers.export(exports, "PowerSquare", ()=>(0, _squarePowerJsDefault.default));
parcelHelpers.export(exports, "PowerSquareIcon", ()=>(0, _squarePowerJsDefault.default));
parcelHelpers.export(exports, "SquarePower", ()=>(0, _squarePowerJsDefault.default));
parcelHelpers.export(exports, "SquarePowerIcon", ()=>(0, _squarePowerJsDefault.default));
parcelHelpers.export(exports, "LucideScissorsSquare", ()=>(0, _squareScissorsJsDefault.default));
parcelHelpers.export(exports, "LucideSquareScissors", ()=>(0, _squareScissorsJsDefault.default));
parcelHelpers.export(exports, "ScissorsSquare", ()=>(0, _squareScissorsJsDefault.default));
parcelHelpers.export(exports, "ScissorsSquareIcon", ()=>(0, _squareScissorsJsDefault.default));
parcelHelpers.export(exports, "SquareScissors", ()=>(0, _squareScissorsJsDefault.default));
parcelHelpers.export(exports, "SquareScissorsIcon", ()=>(0, _squareScissorsJsDefault.default));
parcelHelpers.export(exports, "LucideSigmaSquare", ()=>(0, _squareSigmaJsDefault.default));
parcelHelpers.export(exports, "LucideSquareSigma", ()=>(0, _squareSigmaJsDefault.default));
parcelHelpers.export(exports, "SigmaSquare", ()=>(0, _squareSigmaJsDefault.default));
parcelHelpers.export(exports, "SigmaSquareIcon", ()=>(0, _squareSigmaJsDefault.default));
parcelHelpers.export(exports, "SquareSigma", ()=>(0, _squareSigmaJsDefault.default));
parcelHelpers.export(exports, "SquareSigmaIcon", ()=>(0, _squareSigmaJsDefault.default));
parcelHelpers.export(exports, "LucideSlashSquare", ()=>(0, _squareSlashJsDefault.default));
parcelHelpers.export(exports, "LucideSquareSlash", ()=>(0, _squareSlashJsDefault.default));
parcelHelpers.export(exports, "SlashSquare", ()=>(0, _squareSlashJsDefault.default));
parcelHelpers.export(exports, "SlashSquareIcon", ()=>(0, _squareSlashJsDefault.default));
parcelHelpers.export(exports, "SquareSlash", ()=>(0, _squareSlashJsDefault.default));
parcelHelpers.export(exports, "SquareSlashIcon", ()=>(0, _squareSlashJsDefault.default));
parcelHelpers.export(exports, "LucideSplitSquareHorizontal", ()=>(0, _squareSplitHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideSquareSplitHorizontal", ()=>(0, _squareSplitHorizontalJsDefault.default));
parcelHelpers.export(exports, "SplitSquareHorizontal", ()=>(0, _squareSplitHorizontalJsDefault.default));
parcelHelpers.export(exports, "SplitSquareHorizontalIcon", ()=>(0, _squareSplitHorizontalJsDefault.default));
parcelHelpers.export(exports, "SquareSplitHorizontal", ()=>(0, _squareSplitHorizontalJsDefault.default));
parcelHelpers.export(exports, "SquareSplitHorizontalIcon", ()=>(0, _squareSplitHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideSquareTerminal", ()=>(0, _squareTerminalJsDefault.default));
parcelHelpers.export(exports, "LucideTerminalSquare", ()=>(0, _squareTerminalJsDefault.default));
parcelHelpers.export(exports, "SquareTerminal", ()=>(0, _squareTerminalJsDefault.default));
parcelHelpers.export(exports, "SquareTerminalIcon", ()=>(0, _squareTerminalJsDefault.default));
parcelHelpers.export(exports, "TerminalSquare", ()=>(0, _squareTerminalJsDefault.default));
parcelHelpers.export(exports, "TerminalSquareIcon", ()=>(0, _squareTerminalJsDefault.default));
parcelHelpers.export(exports, "LucideSplitSquareVertical", ()=>(0, _squareSplitVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideSquareSplitVertical", ()=>(0, _squareSplitVerticalJsDefault.default));
parcelHelpers.export(exports, "SplitSquareVertical", ()=>(0, _squareSplitVerticalJsDefault.default));
parcelHelpers.export(exports, "SplitSquareVerticalIcon", ()=>(0, _squareSplitVerticalJsDefault.default));
parcelHelpers.export(exports, "SquareSplitVertical", ()=>(0, _squareSplitVerticalJsDefault.default));
parcelHelpers.export(exports, "SquareSplitVerticalIcon", ()=>(0, _squareSplitVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideSquareUserRound", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "LucideUserSquare2", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "SquareUserRound", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "SquareUserRoundIcon", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "UserSquare2", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "UserSquare2Icon", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "LucideSquareUser", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "LucideUserSquare", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "SquareUser", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "SquareUserIcon", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "UserSquare", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "UserSquareIcon", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "LucideSquareX", ()=>(0, _squareXJsDefault.default));
parcelHelpers.export(exports, "LucideXSquare", ()=>(0, _squareXJsDefault.default));
parcelHelpers.export(exports, "SquareX", ()=>(0, _squareXJsDefault.default));
parcelHelpers.export(exports, "SquareXIcon", ()=>(0, _squareXJsDefault.default));
parcelHelpers.export(exports, "XSquare", ()=>(0, _squareXJsDefault.default));
parcelHelpers.export(exports, "XSquareIcon", ()=>(0, _squareXJsDefault.default));
parcelHelpers.export(exports, "LucideTestTube2", ()=>(0, _testTubeDiagonalJsDefault.default));
parcelHelpers.export(exports, "LucideTestTubeDiagonal", ()=>(0, _testTubeDiagonalJsDefault.default));
parcelHelpers.export(exports, "TestTube2", ()=>(0, _testTubeDiagonalJsDefault.default));
parcelHelpers.export(exports, "TestTube2Icon", ()=>(0, _testTubeDiagonalJsDefault.default));
parcelHelpers.export(exports, "TestTubeDiagonal", ()=>(0, _testTubeDiagonalJsDefault.default));
parcelHelpers.export(exports, "TestTubeDiagonalIcon", ()=>(0, _testTubeDiagonalJsDefault.default));
parcelHelpers.export(exports, "LucideTextSelect", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "LucideTextSelection", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "TextSelect", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "TextSelectIcon", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "TextSelection", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "TextSelectionIcon", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "LucideTrain", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "LucideTramFront", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "Train", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "TrainIcon", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "TramFront", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "TramFrontIcon", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "LucidePalmtree", ()=>(0, _treePalmJsDefault.default));
parcelHelpers.export(exports, "LucideTreePalm", ()=>(0, _treePalmJsDefault.default));
parcelHelpers.export(exports, "Palmtree", ()=>(0, _treePalmJsDefault.default));
parcelHelpers.export(exports, "PalmtreeIcon", ()=>(0, _treePalmJsDefault.default));
parcelHelpers.export(exports, "TreePalm", ()=>(0, _treePalmJsDefault.default));
parcelHelpers.export(exports, "TreePalmIcon", ()=>(0, _treePalmJsDefault.default));
parcelHelpers.export(exports, "AlertTriangle", ()=>(0, _triangleAlertJsDefault.default));
parcelHelpers.export(exports, "AlertTriangleIcon", ()=>(0, _triangleAlertJsDefault.default));
parcelHelpers.export(exports, "LucideAlertTriangle", ()=>(0, _triangleAlertJsDefault.default));
parcelHelpers.export(exports, "LucideTriangleAlert", ()=>(0, _triangleAlertJsDefault.default));
parcelHelpers.export(exports, "TriangleAlert", ()=>(0, _triangleAlertJsDefault.default));
parcelHelpers.export(exports, "TriangleAlertIcon", ()=>(0, _triangleAlertJsDefault.default));
parcelHelpers.export(exports, "LucideTv2", ()=>(0, _tvMinimalJsDefault.default));
parcelHelpers.export(exports, "LucideTvMinimal", ()=>(0, _tvMinimalJsDefault.default));
parcelHelpers.export(exports, "Tv2", ()=>(0, _tvMinimalJsDefault.default));
parcelHelpers.export(exports, "Tv2Icon", ()=>(0, _tvMinimalJsDefault.default));
parcelHelpers.export(exports, "TvMinimal", ()=>(0, _tvMinimalJsDefault.default));
parcelHelpers.export(exports, "TvMinimalIcon", ()=>(0, _tvMinimalJsDefault.default));
parcelHelpers.export(exports, "LucideSchool2", ()=>(0, _universityJsDefault.default));
parcelHelpers.export(exports, "LucideUniversity", ()=>(0, _universityJsDefault.default));
parcelHelpers.export(exports, "School2", ()=>(0, _universityJsDefault.default));
parcelHelpers.export(exports, "School2Icon", ()=>(0, _universityJsDefault.default));
parcelHelpers.export(exports, "University", ()=>(0, _universityJsDefault.default));
parcelHelpers.export(exports, "UniversityIcon", ()=>(0, _universityJsDefault.default));
parcelHelpers.export(exports, "LucideUserCheck2", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundCheck", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "UserCheck2", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "UserCheck2Icon", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "UserRoundCheck", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "UserRoundCheckIcon", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "LucideUserCog2", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundCog", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "UserCog2", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "UserCog2Icon", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "UserRoundCog", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "UserRoundCogIcon", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "LucideUserMinus2", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundMinus", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "UserMinus2", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "UserMinus2Icon", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "UserRoundMinus", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "UserRoundMinusIcon", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "LucideUserPlus2", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundPlus", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "UserPlus2", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "UserPlus2Icon", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "UserRoundPlus", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "UserRoundPlusIcon", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundX", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "LucideUserX2", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "UserRoundX", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "UserRoundXIcon", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "UserX2", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "UserX2Icon", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "LucideUser2", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "LucideUserRound", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "User2", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "User2Icon", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "UserRound", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "UserRoundIcon", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "LucideUsers2", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "LucideUsersRound", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "Users2", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "Users2Icon", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "UsersRound", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "UsersRoundIcon", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "ForkKnifeCrossed", ()=>(0, _utensilsCrossedJsDefault.default));
parcelHelpers.export(exports, "ForkKnifeCrossedIcon", ()=>(0, _utensilsCrossedJsDefault.default));
parcelHelpers.export(exports, "LucideForkKnifeCrossed", ()=>(0, _utensilsCrossedJsDefault.default));
parcelHelpers.export(exports, "LucideUtensilsCrossed", ()=>(0, _utensilsCrossedJsDefault.default));
parcelHelpers.export(exports, "UtensilsCrossed", ()=>(0, _utensilsCrossedJsDefault.default));
parcelHelpers.export(exports, "UtensilsCrossedIcon", ()=>(0, _utensilsCrossedJsDefault.default));
parcelHelpers.export(exports, "ForkKnife", ()=>(0, _utensilsJsDefault.default));
parcelHelpers.export(exports, "ForkKnifeIcon", ()=>(0, _utensilsJsDefault.default));
parcelHelpers.export(exports, "LucideForkKnife", ()=>(0, _utensilsJsDefault.default));
parcelHelpers.export(exports, "LucideUtensils", ()=>(0, _utensilsJsDefault.default));
parcelHelpers.export(exports, "Utensils", ()=>(0, _utensilsJsDefault.default));
parcelHelpers.export(exports, "UtensilsIcon", ()=>(0, _utensilsJsDefault.default));
parcelHelpers.export(exports, "LucideWallet2", ()=>(0, _walletMinimalJsDefault.default));
parcelHelpers.export(exports, "LucideWalletMinimal", ()=>(0, _walletMinimalJsDefault.default));
parcelHelpers.export(exports, "Wallet2", ()=>(0, _walletMinimalJsDefault.default));
parcelHelpers.export(exports, "Wallet2Icon", ()=>(0, _walletMinimalJsDefault.default));
parcelHelpers.export(exports, "WalletMinimal", ()=>(0, _walletMinimalJsDefault.default));
parcelHelpers.export(exports, "WalletMinimalIcon", ()=>(0, _walletMinimalJsDefault.default));
parcelHelpers.export(exports, "LucideWand2", ()=>(0, _wandSparklesJsDefault.default));
parcelHelpers.export(exports, "LucideWandSparkles", ()=>(0, _wandSparklesJsDefault.default));
parcelHelpers.export(exports, "Wand2", ()=>(0, _wandSparklesJsDefault.default));
parcelHelpers.export(exports, "Wand2Icon", ()=>(0, _wandSparklesJsDefault.default));
parcelHelpers.export(exports, "WandSparkles", ()=>(0, _wandSparklesJsDefault.default));
parcelHelpers.export(exports, "WandSparklesIcon", ()=>(0, _wandSparklesJsDefault.default));
parcelHelpers.export(exports, "AArrowDown", ()=>(0, _aArrowDownJsDefault.default));
parcelHelpers.export(exports, "AArrowDownIcon", ()=>(0, _aArrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideAArrowDown", ()=>(0, _aArrowDownJsDefault.default));
parcelHelpers.export(exports, "AArrowUp", ()=>(0, _aArrowUpJsDefault.default));
parcelHelpers.export(exports, "AArrowUpIcon", ()=>(0, _aArrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideAArrowUp", ()=>(0, _aArrowUpJsDefault.default));
parcelHelpers.export(exports, "ALargeSmall", ()=>(0, _aLargeSmallJsDefault.default));
parcelHelpers.export(exports, "ALargeSmallIcon", ()=>(0, _aLargeSmallJsDefault.default));
parcelHelpers.export(exports, "LucideALargeSmall", ()=>(0, _aLargeSmallJsDefault.default));
parcelHelpers.export(exports, "Accessibility", ()=>(0, _accessibilityJsDefault.default));
parcelHelpers.export(exports, "AccessibilityIcon", ()=>(0, _accessibilityJsDefault.default));
parcelHelpers.export(exports, "LucideAccessibility", ()=>(0, _accessibilityJsDefault.default));
parcelHelpers.export(exports, "Activity", ()=>(0, _activityJsDefault.default));
parcelHelpers.export(exports, "ActivityIcon", ()=>(0, _activityJsDefault.default));
parcelHelpers.export(exports, "LucideActivity", ()=>(0, _activityJsDefault.default));
parcelHelpers.export(exports, "AirVent", ()=>(0, _airVentJsDefault.default));
parcelHelpers.export(exports, "AirVentIcon", ()=>(0, _airVentJsDefault.default));
parcelHelpers.export(exports, "LucideAirVent", ()=>(0, _airVentJsDefault.default));
parcelHelpers.export(exports, "Airplay", ()=>(0, _airplayJsDefault.default));
parcelHelpers.export(exports, "AirplayIcon", ()=>(0, _airplayJsDefault.default));
parcelHelpers.export(exports, "LucideAirplay", ()=>(0, _airplayJsDefault.default));
parcelHelpers.export(exports, "AlarmClockOff", ()=>(0, _alarmClockOffJsDefault.default));
parcelHelpers.export(exports, "AlarmClockOffIcon", ()=>(0, _alarmClockOffJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmClockOff", ()=>(0, _alarmClockOffJsDefault.default));
parcelHelpers.export(exports, "AlarmClock", ()=>(0, _alarmClockJsDefault.default));
parcelHelpers.export(exports, "AlarmClockIcon", ()=>(0, _alarmClockJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmClock", ()=>(0, _alarmClockJsDefault.default));
parcelHelpers.export(exports, "AlarmSmoke", ()=>(0, _alarmSmokeJsDefault.default));
parcelHelpers.export(exports, "AlarmSmokeIcon", ()=>(0, _alarmSmokeJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmSmoke", ()=>(0, _alarmSmokeJsDefault.default));
parcelHelpers.export(exports, "AlignCenterHorizontal", ()=>(0, _alignCenterHorizontalJsDefault.default));
parcelHelpers.export(exports, "AlignCenterHorizontalIcon", ()=>(0, _alignCenterHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignCenterHorizontal", ()=>(0, _alignCenterHorizontalJsDefault.default));
parcelHelpers.export(exports, "Album", ()=>(0, _albumJsDefault.default));
parcelHelpers.export(exports, "AlbumIcon", ()=>(0, _albumJsDefault.default));
parcelHelpers.export(exports, "LucideAlbum", ()=>(0, _albumJsDefault.default));
parcelHelpers.export(exports, "AlignCenterVertical", ()=>(0, _alignCenterVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignCenterVerticalIcon", ()=>(0, _alignCenterVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignCenterVertical", ()=>(0, _alignCenterVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignCenter", ()=>(0, _alignCenterJsDefault.default));
parcelHelpers.export(exports, "AlignCenterIcon", ()=>(0, _alignCenterJsDefault.default));
parcelHelpers.export(exports, "LucideAlignCenter", ()=>(0, _alignCenterJsDefault.default));
parcelHelpers.export(exports, "AlignEndHorizontal", ()=>(0, _alignEndHorizontalJsDefault.default));
parcelHelpers.export(exports, "AlignEndHorizontalIcon", ()=>(0, _alignEndHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignEndHorizontal", ()=>(0, _alignEndHorizontalJsDefault.default));
parcelHelpers.export(exports, "AlignEndVertical", ()=>(0, _alignEndVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignEndVerticalIcon", ()=>(0, _alignEndVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignEndVertical", ()=>(0, _alignEndVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeCenter", ()=>(0, _alignHorizontalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeCenterIcon", ()=>(0, _alignHorizontalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalDistributeCenter", ()=>(0, _alignHorizontalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeEnd", ()=>(0, _alignHorizontalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeEndIcon", ()=>(0, _alignHorizontalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalDistributeEnd", ()=>(0, _alignHorizontalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeStart", ()=>(0, _alignHorizontalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeStartIcon", ()=>(0, _alignHorizontalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalDistributeStart", ()=>(0, _alignHorizontalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyCenter", ()=>(0, _alignHorizontalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyCenterIcon", ()=>(0, _alignHorizontalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalJustifyCenter", ()=>(0, _alignHorizontalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyEnd", ()=>(0, _alignHorizontalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyEndIcon", ()=>(0, _alignHorizontalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalJustifyEnd", ()=>(0, _alignHorizontalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyStart", ()=>(0, _alignHorizontalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyStartIcon", ()=>(0, _alignHorizontalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalJustifyStart", ()=>(0, _alignHorizontalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalSpaceAround", ()=>(0, _alignHorizontalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalSpaceAroundIcon", ()=>(0, _alignHorizontalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalSpaceAround", ()=>(0, _alignHorizontalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalSpaceBetween", ()=>(0, _alignHorizontalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalSpaceBetweenIcon", ()=>(0, _alignHorizontalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalSpaceBetween", ()=>(0, _alignHorizontalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "AlignJustify", ()=>(0, _alignJustifyJsDefault.default));
parcelHelpers.export(exports, "AlignJustifyIcon", ()=>(0, _alignJustifyJsDefault.default));
parcelHelpers.export(exports, "LucideAlignJustify", ()=>(0, _alignJustifyJsDefault.default));
parcelHelpers.export(exports, "AlignRight", ()=>(0, _alignRightJsDefault.default));
parcelHelpers.export(exports, "AlignRightIcon", ()=>(0, _alignRightJsDefault.default));
parcelHelpers.export(exports, "LucideAlignRight", ()=>(0, _alignRightJsDefault.default));
parcelHelpers.export(exports, "AlignLeft", ()=>(0, _alignLeftJsDefault.default));
parcelHelpers.export(exports, "AlignLeftIcon", ()=>(0, _alignLeftJsDefault.default));
parcelHelpers.export(exports, "LucideAlignLeft", ()=>(0, _alignLeftJsDefault.default));
parcelHelpers.export(exports, "AlignStartHorizontal", ()=>(0, _alignStartHorizontalJsDefault.default));
parcelHelpers.export(exports, "AlignStartHorizontalIcon", ()=>(0, _alignStartHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignStartHorizontal", ()=>(0, _alignStartHorizontalJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeCenter", ()=>(0, _alignVerticalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeCenterIcon", ()=>(0, _alignVerticalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalDistributeCenter", ()=>(0, _alignVerticalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "AlignStartVertical", ()=>(0, _alignStartVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignStartVerticalIcon", ()=>(0, _alignStartVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignStartVertical", ()=>(0, _alignStartVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeStart", ()=>(0, _alignVerticalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeStartIcon", ()=>(0, _alignVerticalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalDistributeStart", ()=>(0, _alignVerticalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeEnd", ()=>(0, _alignVerticalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeEndIcon", ()=>(0, _alignVerticalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalDistributeEnd", ()=>(0, _alignVerticalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyCenter", ()=>(0, _alignVerticalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyCenterIcon", ()=>(0, _alignVerticalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalJustifyCenter", ()=>(0, _alignVerticalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyEnd", ()=>(0, _alignVerticalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyEndIcon", ()=>(0, _alignVerticalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalJustifyEnd", ()=>(0, _alignVerticalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyStart", ()=>(0, _alignVerticalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyStartIcon", ()=>(0, _alignVerticalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalJustifyStart", ()=>(0, _alignVerticalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalSpaceAround", ()=>(0, _alignVerticalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalSpaceAroundIcon", ()=>(0, _alignVerticalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalSpaceAround", ()=>(0, _alignVerticalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalSpaceBetween", ()=>(0, _alignVerticalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalSpaceBetweenIcon", ()=>(0, _alignVerticalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalSpaceBetween", ()=>(0, _alignVerticalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "Ambulance", ()=>(0, _ambulanceJsDefault.default));
parcelHelpers.export(exports, "AmbulanceIcon", ()=>(0, _ambulanceJsDefault.default));
parcelHelpers.export(exports, "LucideAmbulance", ()=>(0, _ambulanceJsDefault.default));
parcelHelpers.export(exports, "Ampersand", ()=>(0, _ampersandJsDefault.default));
parcelHelpers.export(exports, "AmpersandIcon", ()=>(0, _ampersandJsDefault.default));
parcelHelpers.export(exports, "LucideAmpersand", ()=>(0, _ampersandJsDefault.default));
parcelHelpers.export(exports, "Ampersands", ()=>(0, _ampersandsJsDefault.default));
parcelHelpers.export(exports, "AmpersandsIcon", ()=>(0, _ampersandsJsDefault.default));
parcelHelpers.export(exports, "LucideAmpersands", ()=>(0, _ampersandsJsDefault.default));
parcelHelpers.export(exports, "Amphora", ()=>(0, _amphoraJsDefault.default));
parcelHelpers.export(exports, "AmphoraIcon", ()=>(0, _amphoraJsDefault.default));
parcelHelpers.export(exports, "LucideAmphora", ()=>(0, _amphoraJsDefault.default));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchorJsDefault.default));
parcelHelpers.export(exports, "AnchorIcon", ()=>(0, _anchorJsDefault.default));
parcelHelpers.export(exports, "LucideAnchor", ()=>(0, _anchorJsDefault.default));
parcelHelpers.export(exports, "Annoyed", ()=>(0, _annoyedJsDefault.default));
parcelHelpers.export(exports, "AnnoyedIcon", ()=>(0, _annoyedJsDefault.default));
parcelHelpers.export(exports, "LucideAnnoyed", ()=>(0, _annoyedJsDefault.default));
parcelHelpers.export(exports, "Angry", ()=>(0, _angryJsDefault.default));
parcelHelpers.export(exports, "AngryIcon", ()=>(0, _angryJsDefault.default));
parcelHelpers.export(exports, "LucideAngry", ()=>(0, _angryJsDefault.default));
parcelHelpers.export(exports, "Antenna", ()=>(0, _antennaJsDefault.default));
parcelHelpers.export(exports, "AntennaIcon", ()=>(0, _antennaJsDefault.default));
parcelHelpers.export(exports, "LucideAntenna", ()=>(0, _antennaJsDefault.default));
parcelHelpers.export(exports, "AppWindowMac", ()=>(0, _appWindowMacJsDefault.default));
parcelHelpers.export(exports, "AppWindowMacIcon", ()=>(0, _appWindowMacJsDefault.default));
parcelHelpers.export(exports, "LucideAppWindowMac", ()=>(0, _appWindowMacJsDefault.default));
parcelHelpers.export(exports, "Anvil", ()=>(0, _anvilJsDefault.default));
parcelHelpers.export(exports, "AnvilIcon", ()=>(0, _anvilJsDefault.default));
parcelHelpers.export(exports, "LucideAnvil", ()=>(0, _anvilJsDefault.default));
parcelHelpers.export(exports, "Aperture", ()=>(0, _apertureJsDefault.default));
parcelHelpers.export(exports, "ApertureIcon", ()=>(0, _apertureJsDefault.default));
parcelHelpers.export(exports, "LucideAperture", ()=>(0, _apertureJsDefault.default));
parcelHelpers.export(exports, "AppWindow", ()=>(0, _appWindowJsDefault.default));
parcelHelpers.export(exports, "AppWindowIcon", ()=>(0, _appWindowJsDefault.default));
parcelHelpers.export(exports, "LucideAppWindow", ()=>(0, _appWindowJsDefault.default));
parcelHelpers.export(exports, "Apple", ()=>(0, _appleJsDefault.default));
parcelHelpers.export(exports, "AppleIcon", ()=>(0, _appleJsDefault.default));
parcelHelpers.export(exports, "LucideApple", ()=>(0, _appleJsDefault.default));
parcelHelpers.export(exports, "ArchiveRestore", ()=>(0, _archiveRestoreJsDefault.default));
parcelHelpers.export(exports, "ArchiveRestoreIcon", ()=>(0, _archiveRestoreJsDefault.default));
parcelHelpers.export(exports, "LucideArchiveRestore", ()=>(0, _archiveRestoreJsDefault.default));
parcelHelpers.export(exports, "ArchiveX", ()=>(0, _archiveXJsDefault.default));
parcelHelpers.export(exports, "ArchiveXIcon", ()=>(0, _archiveXJsDefault.default));
parcelHelpers.export(exports, "LucideArchiveX", ()=>(0, _archiveXJsDefault.default));
parcelHelpers.export(exports, "Archive", ()=>(0, _archiveJsDefault.default));
parcelHelpers.export(exports, "ArchiveIcon", ()=>(0, _archiveJsDefault.default));
parcelHelpers.export(exports, "LucideArchive", ()=>(0, _archiveJsDefault.default));
parcelHelpers.export(exports, "Armchair", ()=>(0, _armchairJsDefault.default));
parcelHelpers.export(exports, "ArmchairIcon", ()=>(0, _armchairJsDefault.default));
parcelHelpers.export(exports, "LucideArmchair", ()=>(0, _armchairJsDefault.default));
parcelHelpers.export(exports, "ArrowBigDownDash", ()=>(0, _arrowBigDownDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigDownDashIcon", ()=>(0, _arrowBigDownDashJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigDownDash", ()=>(0, _arrowBigDownDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigDown", ()=>(0, _arrowBigDownJsDefault.default));
parcelHelpers.export(exports, "ArrowBigDownIcon", ()=>(0, _arrowBigDownJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigDown", ()=>(0, _arrowBigDownJsDefault.default));
parcelHelpers.export(exports, "ArrowBigLeftDash", ()=>(0, _arrowBigLeftDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigLeftDashIcon", ()=>(0, _arrowBigLeftDashJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigLeftDash", ()=>(0, _arrowBigLeftDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigLeft", ()=>(0, _arrowBigLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowBigLeftIcon", ()=>(0, _arrowBigLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigLeft", ()=>(0, _arrowBigLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowBigRight", ()=>(0, _arrowBigRightJsDefault.default));
parcelHelpers.export(exports, "ArrowBigRightIcon", ()=>(0, _arrowBigRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigRight", ()=>(0, _arrowBigRightJsDefault.default));
parcelHelpers.export(exports, "ArrowBigUpDash", ()=>(0, _arrowBigUpDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigUpDashIcon", ()=>(0, _arrowBigUpDashJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigUpDash", ()=>(0, _arrowBigUpDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigRightDash", ()=>(0, _arrowBigRightDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigRightDashIcon", ()=>(0, _arrowBigRightDashJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigRightDash", ()=>(0, _arrowBigRightDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigUp", ()=>(0, _arrowBigUpJsDefault.default));
parcelHelpers.export(exports, "ArrowBigUpIcon", ()=>(0, _arrowBigUpJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigUp", ()=>(0, _arrowBigUpJsDefault.default));
parcelHelpers.export(exports, "ArrowDownFromLine", ()=>(0, _arrowDownFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowDownFromLineIcon", ()=>(0, _arrowDownFromLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownFromLine", ()=>(0, _arrowDownFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeft", ()=>(0, _arrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftIcon", ()=>(0, _arrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownLeft", ()=>(0, _arrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowDownNarrowWide", ()=>(0, _arrowDownNarrowWideJsDefault.default));
parcelHelpers.export(exports, "ArrowDownNarrowWideIcon", ()=>(0, _arrowDownNarrowWideJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownNarrowWide", ()=>(0, _arrowDownNarrowWideJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRight", ()=>(0, _arrowDownRightJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightIcon", ()=>(0, _arrowDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownRight", ()=>(0, _arrowDownRightJsDefault.default));
parcelHelpers.export(exports, "ArrowDownToDot", ()=>(0, _arrowDownToDotJsDefault.default));
parcelHelpers.export(exports, "ArrowDownToDotIcon", ()=>(0, _arrowDownToDotJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownToDot", ()=>(0, _arrowDownToDotJsDefault.default));
parcelHelpers.export(exports, "ArrowDownToLine", ()=>(0, _arrowDownToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowDownToLineIcon", ()=>(0, _arrowDownToLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownToLine", ()=>(0, _arrowDownToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowDownUp", ()=>(0, _arrowDownUpJsDefault.default));
parcelHelpers.export(exports, "ArrowDownUpIcon", ()=>(0, _arrowDownUpJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownUp", ()=>(0, _arrowDownUpJsDefault.default));
parcelHelpers.export(exports, "ArrowDown", ()=>(0, _arrowDownJsDefault.default));
parcelHelpers.export(exports, "ArrowDownIcon", ()=>(0, _arrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDown", ()=>(0, _arrowDownJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftFromLine", ()=>(0, _arrowLeftFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftFromLineIcon", ()=>(0, _arrowLeftFromLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeftFromLine", ()=>(0, _arrowLeftFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftRight", ()=>(0, _arrowLeftRightJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftRightIcon", ()=>(0, _arrowLeftRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeftRight", ()=>(0, _arrowLeftRightJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftToLine", ()=>(0, _arrowLeftToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftToLineIcon", ()=>(0, _arrowLeftToLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeftToLine", ()=>(0, _arrowLeftToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowLeft", ()=>(0, _arrowLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftIcon", ()=>(0, _arrowLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeft", ()=>(0, _arrowLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowRightFromLine", ()=>(0, _arrowRightFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowRightFromLineIcon", ()=>(0, _arrowRightFromLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRightFromLine", ()=>(0, _arrowRightFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowRightLeft", ()=>(0, _arrowRightLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowRightLeftIcon", ()=>(0, _arrowRightLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRightLeft", ()=>(0, _arrowRightLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowRightToLine", ()=>(0, _arrowRightToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowRightToLineIcon", ()=>(0, _arrowRightToLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRightToLine", ()=>(0, _arrowRightToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowRight", ()=>(0, _arrowRightJsDefault.default));
parcelHelpers.export(exports, "ArrowRightIcon", ()=>(0, _arrowRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRight", ()=>(0, _arrowRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpDown", ()=>(0, _arrowUpDownJsDefault.default));
parcelHelpers.export(exports, "ArrowUpDownIcon", ()=>(0, _arrowUpDownJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpDown", ()=>(0, _arrowUpDownJsDefault.default));
parcelHelpers.export(exports, "ArrowUpFromDot", ()=>(0, _arrowUpFromDotJsDefault.default));
parcelHelpers.export(exports, "ArrowUpFromDotIcon", ()=>(0, _arrowUpFromDotJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpFromDot", ()=>(0, _arrowUpFromDotJsDefault.default));
parcelHelpers.export(exports, "ArrowUpFromLine", ()=>(0, _arrowUpFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowUpFromLineIcon", ()=>(0, _arrowUpFromLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpFromLine", ()=>(0, _arrowUpFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRight", ()=>(0, _arrowUpRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightIcon", ()=>(0, _arrowUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpRight", ()=>(0, _arrowUpRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeft", ()=>(0, _arrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftIcon", ()=>(0, _arrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpLeft", ()=>(0, _arrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowUpToLine", ()=>(0, _arrowUpToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowUpToLineIcon", ()=>(0, _arrowUpToLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpToLine", ()=>(0, _arrowUpToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowUpWideNarrow", ()=>(0, _arrowUpWideNarrowJsDefault.default));
parcelHelpers.export(exports, "ArrowUpWideNarrowIcon", ()=>(0, _arrowUpWideNarrowJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpWideNarrow", ()=>(0, _arrowUpWideNarrowJsDefault.default));
parcelHelpers.export(exports, "ArrowUp", ()=>(0, _arrowUpJsDefault.default));
parcelHelpers.export(exports, "ArrowUpIcon", ()=>(0, _arrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUp", ()=>(0, _arrowUpJsDefault.default));
parcelHelpers.export(exports, "ArrowsUpFromLine", ()=>(0, _arrowsUpFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowsUpFromLineIcon", ()=>(0, _arrowsUpFromLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowsUpFromLine", ()=>(0, _arrowsUpFromLineJsDefault.default));
parcelHelpers.export(exports, "Asterisk", ()=>(0, _asteriskJsDefault.default));
parcelHelpers.export(exports, "AsteriskIcon", ()=>(0, _asteriskJsDefault.default));
parcelHelpers.export(exports, "LucideAsterisk", ()=>(0, _asteriskJsDefault.default));
parcelHelpers.export(exports, "AtSign", ()=>(0, _atSignJsDefault.default));
parcelHelpers.export(exports, "AtSignIcon", ()=>(0, _atSignJsDefault.default));
parcelHelpers.export(exports, "LucideAtSign", ()=>(0, _atSignJsDefault.default));
parcelHelpers.export(exports, "Atom", ()=>(0, _atomJsDefault.default));
parcelHelpers.export(exports, "AtomIcon", ()=>(0, _atomJsDefault.default));
parcelHelpers.export(exports, "LucideAtom", ()=>(0, _atomJsDefault.default));
parcelHelpers.export(exports, "AudioLines", ()=>(0, _audioLinesJsDefault.default));
parcelHelpers.export(exports, "AudioLinesIcon", ()=>(0, _audioLinesJsDefault.default));
parcelHelpers.export(exports, "LucideAudioLines", ()=>(0, _audioLinesJsDefault.default));
parcelHelpers.export(exports, "AudioWaveform", ()=>(0, _audioWaveformJsDefault.default));
parcelHelpers.export(exports, "AudioWaveformIcon", ()=>(0, _audioWaveformJsDefault.default));
parcelHelpers.export(exports, "LucideAudioWaveform", ()=>(0, _audioWaveformJsDefault.default));
parcelHelpers.export(exports, "Award", ()=>(0, _awardJsDefault.default));
parcelHelpers.export(exports, "AwardIcon", ()=>(0, _awardJsDefault.default));
parcelHelpers.export(exports, "LucideAward", ()=>(0, _awardJsDefault.default));
parcelHelpers.export(exports, "Axe", ()=>(0, _axeJsDefault.default));
parcelHelpers.export(exports, "AxeIcon", ()=>(0, _axeJsDefault.default));
parcelHelpers.export(exports, "LucideAxe", ()=>(0, _axeJsDefault.default));
parcelHelpers.export(exports, "Baby", ()=>(0, _babyJsDefault.default));
parcelHelpers.export(exports, "BabyIcon", ()=>(0, _babyJsDefault.default));
parcelHelpers.export(exports, "LucideBaby", ()=>(0, _babyJsDefault.default));
parcelHelpers.export(exports, "Backpack", ()=>(0, _backpackJsDefault.default));
parcelHelpers.export(exports, "BackpackIcon", ()=>(0, _backpackJsDefault.default));
parcelHelpers.export(exports, "LucideBackpack", ()=>(0, _backpackJsDefault.default));
parcelHelpers.export(exports, "BadgeAlert", ()=>(0, _badgeAlertJsDefault.default));
parcelHelpers.export(exports, "BadgeAlertIcon", ()=>(0, _badgeAlertJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeAlert", ()=>(0, _badgeAlertJsDefault.default));
parcelHelpers.export(exports, "BadgeCent", ()=>(0, _badgeCentJsDefault.default));
parcelHelpers.export(exports, "BadgeCentIcon", ()=>(0, _badgeCentJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeCent", ()=>(0, _badgeCentJsDefault.default));
parcelHelpers.export(exports, "BadgeDollarSign", ()=>(0, _badgeDollarSignJsDefault.default));
parcelHelpers.export(exports, "BadgeDollarSignIcon", ()=>(0, _badgeDollarSignJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeDollarSign", ()=>(0, _badgeDollarSignJsDefault.default));
parcelHelpers.export(exports, "BadgeEuro", ()=>(0, _badgeEuroJsDefault.default));
parcelHelpers.export(exports, "BadgeEuroIcon", ()=>(0, _badgeEuroJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeEuro", ()=>(0, _badgeEuroJsDefault.default));
parcelHelpers.export(exports, "BadgeHelp", ()=>(0, _badgeHelpJsDefault.default));
parcelHelpers.export(exports, "BadgeHelpIcon", ()=>(0, _badgeHelpJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeHelp", ()=>(0, _badgeHelpJsDefault.default));
parcelHelpers.export(exports, "BadgeIndianRupee", ()=>(0, _badgeIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "BadgeIndianRupeeIcon", ()=>(0, _badgeIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeIndianRupee", ()=>(0, _badgeIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "BadgeMinus", ()=>(0, _badgeMinusJsDefault.default));
parcelHelpers.export(exports, "BadgeMinusIcon", ()=>(0, _badgeMinusJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeMinus", ()=>(0, _badgeMinusJsDefault.default));
parcelHelpers.export(exports, "BadgeJapaneseYen", ()=>(0, _badgeJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "BadgeJapaneseYenIcon", ()=>(0, _badgeJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeJapaneseYen", ()=>(0, _badgeJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "BadgeInfo", ()=>(0, _badgeInfoJsDefault.default));
parcelHelpers.export(exports, "BadgeInfoIcon", ()=>(0, _badgeInfoJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeInfo", ()=>(0, _badgeInfoJsDefault.default));
parcelHelpers.export(exports, "BadgePercent", ()=>(0, _badgePercentJsDefault.default));
parcelHelpers.export(exports, "BadgePercentIcon", ()=>(0, _badgePercentJsDefault.default));
parcelHelpers.export(exports, "LucideBadgePercent", ()=>(0, _badgePercentJsDefault.default));
parcelHelpers.export(exports, "BadgePlus", ()=>(0, _badgePlusJsDefault.default));
parcelHelpers.export(exports, "BadgePlusIcon", ()=>(0, _badgePlusJsDefault.default));
parcelHelpers.export(exports, "LucideBadgePlus", ()=>(0, _badgePlusJsDefault.default));
parcelHelpers.export(exports, "BadgeRussianRuble", ()=>(0, _badgeRussianRubleJsDefault.default));
parcelHelpers.export(exports, "BadgeRussianRubleIcon", ()=>(0, _badgeRussianRubleJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeRussianRuble", ()=>(0, _badgeRussianRubleJsDefault.default));
parcelHelpers.export(exports, "BadgePoundSterling", ()=>(0, _badgePoundSterlingJsDefault.default));
parcelHelpers.export(exports, "BadgePoundSterlingIcon", ()=>(0, _badgePoundSterlingJsDefault.default));
parcelHelpers.export(exports, "LucideBadgePoundSterling", ()=>(0, _badgePoundSterlingJsDefault.default));
parcelHelpers.export(exports, "BadgeSwissFranc", ()=>(0, _badgeSwissFrancJsDefault.default));
parcelHelpers.export(exports, "BadgeSwissFrancIcon", ()=>(0, _badgeSwissFrancJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeSwissFranc", ()=>(0, _badgeSwissFrancJsDefault.default));
parcelHelpers.export(exports, "BadgeX", ()=>(0, _badgeXJsDefault.default));
parcelHelpers.export(exports, "BadgeXIcon", ()=>(0, _badgeXJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeX", ()=>(0, _badgeXJsDefault.default));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeJsDefault.default));
parcelHelpers.export(exports, "BadgeIcon", ()=>(0, _badgeJsDefault.default));
parcelHelpers.export(exports, "LucideBadge", ()=>(0, _badgeJsDefault.default));
parcelHelpers.export(exports, "BaggageClaim", ()=>(0, _baggageClaimJsDefault.default));
parcelHelpers.export(exports, "BaggageClaimIcon", ()=>(0, _baggageClaimJsDefault.default));
parcelHelpers.export(exports, "LucideBaggageClaim", ()=>(0, _baggageClaimJsDefault.default));
parcelHelpers.export(exports, "Ban", ()=>(0, _banJsDefault.default));
parcelHelpers.export(exports, "BanIcon", ()=>(0, _banJsDefault.default));
parcelHelpers.export(exports, "LucideBan", ()=>(0, _banJsDefault.default));
parcelHelpers.export(exports, "Banana", ()=>(0, _bananaJsDefault.default));
parcelHelpers.export(exports, "BananaIcon", ()=>(0, _bananaJsDefault.default));
parcelHelpers.export(exports, "LucideBanana", ()=>(0, _bananaJsDefault.default));
parcelHelpers.export(exports, "Bandage", ()=>(0, _bandageJsDefault.default));
parcelHelpers.export(exports, "BandageIcon", ()=>(0, _bandageJsDefault.default));
parcelHelpers.export(exports, "LucideBandage", ()=>(0, _bandageJsDefault.default));
parcelHelpers.export(exports, "BanknoteArrowDown", ()=>(0, _banknoteArrowDownJsDefault.default));
parcelHelpers.export(exports, "BanknoteArrowDownIcon", ()=>(0, _banknoteArrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideBanknoteArrowDown", ()=>(0, _banknoteArrowDownJsDefault.default));
parcelHelpers.export(exports, "BanknoteArrowUp", ()=>(0, _banknoteArrowUpJsDefault.default));
parcelHelpers.export(exports, "BanknoteArrowUpIcon", ()=>(0, _banknoteArrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideBanknoteArrowUp", ()=>(0, _banknoteArrowUpJsDefault.default));
parcelHelpers.export(exports, "BanknoteX", ()=>(0, _banknoteXJsDefault.default));
parcelHelpers.export(exports, "BanknoteXIcon", ()=>(0, _banknoteXJsDefault.default));
parcelHelpers.export(exports, "LucideBanknoteX", ()=>(0, _banknoteXJsDefault.default));
parcelHelpers.export(exports, "Banknote", ()=>(0, _banknoteJsDefault.default));
parcelHelpers.export(exports, "BanknoteIcon", ()=>(0, _banknoteJsDefault.default));
parcelHelpers.export(exports, "LucideBanknote", ()=>(0, _banknoteJsDefault.default));
parcelHelpers.export(exports, "Barcode", ()=>(0, _barcodeJsDefault.default));
parcelHelpers.export(exports, "BarcodeIcon", ()=>(0, _barcodeJsDefault.default));
parcelHelpers.export(exports, "LucideBarcode", ()=>(0, _barcodeJsDefault.default));
parcelHelpers.export(exports, "Baseline", ()=>(0, _baselineJsDefault.default));
parcelHelpers.export(exports, "BaselineIcon", ()=>(0, _baselineJsDefault.default));
parcelHelpers.export(exports, "LucideBaseline", ()=>(0, _baselineJsDefault.default));
parcelHelpers.export(exports, "Bath", ()=>(0, _bathJsDefault.default));
parcelHelpers.export(exports, "BathIcon", ()=>(0, _bathJsDefault.default));
parcelHelpers.export(exports, "LucideBath", ()=>(0, _bathJsDefault.default));
parcelHelpers.export(exports, "BatteryCharging", ()=>(0, _batteryChargingJsDefault.default));
parcelHelpers.export(exports, "BatteryChargingIcon", ()=>(0, _batteryChargingJsDefault.default));
parcelHelpers.export(exports, "LucideBatteryCharging", ()=>(0, _batteryChargingJsDefault.default));
parcelHelpers.export(exports, "BatteryFull", ()=>(0, _batteryFullJsDefault.default));
parcelHelpers.export(exports, "BatteryFullIcon", ()=>(0, _batteryFullJsDefault.default));
parcelHelpers.export(exports, "LucideBatteryFull", ()=>(0, _batteryFullJsDefault.default));
parcelHelpers.export(exports, "BatteryLow", ()=>(0, _batteryLowJsDefault.default));
parcelHelpers.export(exports, "BatteryLowIcon", ()=>(0, _batteryLowJsDefault.default));
parcelHelpers.export(exports, "LucideBatteryLow", ()=>(0, _batteryLowJsDefault.default));
parcelHelpers.export(exports, "BatteryMedium", ()=>(0, _batteryMediumJsDefault.default));
parcelHelpers.export(exports, "BatteryMediumIcon", ()=>(0, _batteryMediumJsDefault.default));
parcelHelpers.export(exports, "LucideBatteryMedium", ()=>(0, _batteryMediumJsDefault.default));
parcelHelpers.export(exports, "BatteryPlus", ()=>(0, _batteryPlusJsDefault.default));
parcelHelpers.export(exports, "BatteryPlusIcon", ()=>(0, _batteryPlusJsDefault.default));
parcelHelpers.export(exports, "LucideBatteryPlus", ()=>(0, _batteryPlusJsDefault.default));
parcelHelpers.export(exports, "BatteryWarning", ()=>(0, _batteryWarningJsDefault.default));
parcelHelpers.export(exports, "BatteryWarningIcon", ()=>(0, _batteryWarningJsDefault.default));
parcelHelpers.export(exports, "LucideBatteryWarning", ()=>(0, _batteryWarningJsDefault.default));
parcelHelpers.export(exports, "Battery", ()=>(0, _batteryJsDefault.default));
parcelHelpers.export(exports, "BatteryIcon", ()=>(0, _batteryJsDefault.default));
parcelHelpers.export(exports, "LucideBattery", ()=>(0, _batteryJsDefault.default));
parcelHelpers.export(exports, "Beaker", ()=>(0, _beakerJsDefault.default));
parcelHelpers.export(exports, "BeakerIcon", ()=>(0, _beakerJsDefault.default));
parcelHelpers.export(exports, "LucideBeaker", ()=>(0, _beakerJsDefault.default));
parcelHelpers.export(exports, "BeanOff", ()=>(0, _beanOffJsDefault.default));
parcelHelpers.export(exports, "BeanOffIcon", ()=>(0, _beanOffJsDefault.default));
parcelHelpers.export(exports, "LucideBeanOff", ()=>(0, _beanOffJsDefault.default));
parcelHelpers.export(exports, "BedDouble", ()=>(0, _bedDoubleJsDefault.default));
parcelHelpers.export(exports, "BedDoubleIcon", ()=>(0, _bedDoubleJsDefault.default));
parcelHelpers.export(exports, "LucideBedDouble", ()=>(0, _bedDoubleJsDefault.default));
parcelHelpers.export(exports, "BedSingle", ()=>(0, _bedSingleJsDefault.default));
parcelHelpers.export(exports, "BedSingleIcon", ()=>(0, _bedSingleJsDefault.default));
parcelHelpers.export(exports, "LucideBedSingle", ()=>(0, _bedSingleJsDefault.default));
parcelHelpers.export(exports, "Bean", ()=>(0, _beanJsDefault.default));
parcelHelpers.export(exports, "BeanIcon", ()=>(0, _beanJsDefault.default));
parcelHelpers.export(exports, "LucideBean", ()=>(0, _beanJsDefault.default));
parcelHelpers.export(exports, "Bed", ()=>(0, _bedJsDefault.default));
parcelHelpers.export(exports, "BedIcon", ()=>(0, _bedJsDefault.default));
parcelHelpers.export(exports, "LucideBed", ()=>(0, _bedJsDefault.default));
parcelHelpers.export(exports, "Beef", ()=>(0, _beefJsDefault.default));
parcelHelpers.export(exports, "BeefIcon", ()=>(0, _beefJsDefault.default));
parcelHelpers.export(exports, "LucideBeef", ()=>(0, _beefJsDefault.default));
parcelHelpers.export(exports, "BeerOff", ()=>(0, _beerOffJsDefault.default));
parcelHelpers.export(exports, "BeerOffIcon", ()=>(0, _beerOffJsDefault.default));
parcelHelpers.export(exports, "LucideBeerOff", ()=>(0, _beerOffJsDefault.default));
parcelHelpers.export(exports, "Beer", ()=>(0, _beerJsDefault.default));
parcelHelpers.export(exports, "BeerIcon", ()=>(0, _beerJsDefault.default));
parcelHelpers.export(exports, "LucideBeer", ()=>(0, _beerJsDefault.default));
parcelHelpers.export(exports, "BellDot", ()=>(0, _bellDotJsDefault.default));
parcelHelpers.export(exports, "BellDotIcon", ()=>(0, _bellDotJsDefault.default));
parcelHelpers.export(exports, "LucideBellDot", ()=>(0, _bellDotJsDefault.default));
parcelHelpers.export(exports, "BellElectric", ()=>(0, _bellElectricJsDefault.default));
parcelHelpers.export(exports, "BellElectricIcon", ()=>(0, _bellElectricJsDefault.default));
parcelHelpers.export(exports, "LucideBellElectric", ()=>(0, _bellElectricJsDefault.default));
parcelHelpers.export(exports, "BellOff", ()=>(0, _bellOffJsDefault.default));
parcelHelpers.export(exports, "BellOffIcon", ()=>(0, _bellOffJsDefault.default));
parcelHelpers.export(exports, "LucideBellOff", ()=>(0, _bellOffJsDefault.default));
parcelHelpers.export(exports, "BellMinus", ()=>(0, _bellMinusJsDefault.default));
parcelHelpers.export(exports, "BellMinusIcon", ()=>(0, _bellMinusJsDefault.default));
parcelHelpers.export(exports, "LucideBellMinus", ()=>(0, _bellMinusJsDefault.default));
parcelHelpers.export(exports, "BellPlus", ()=>(0, _bellPlusJsDefault.default));
parcelHelpers.export(exports, "BellPlusIcon", ()=>(0, _bellPlusJsDefault.default));
parcelHelpers.export(exports, "LucideBellPlus", ()=>(0, _bellPlusJsDefault.default));
parcelHelpers.export(exports, "BellRing", ()=>(0, _bellRingJsDefault.default));
parcelHelpers.export(exports, "BellRingIcon", ()=>(0, _bellRingJsDefault.default));
parcelHelpers.export(exports, "LucideBellRing", ()=>(0, _bellRingJsDefault.default));
parcelHelpers.export(exports, "Bell", ()=>(0, _bellJsDefault.default));
parcelHelpers.export(exports, "BellIcon", ()=>(0, _bellJsDefault.default));
parcelHelpers.export(exports, "LucideBell", ()=>(0, _bellJsDefault.default));
parcelHelpers.export(exports, "BetweenVerticalEnd", ()=>(0, _betweenVerticalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenVerticalEndIcon", ()=>(0, _betweenVerticalEndJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenVerticalEnd", ()=>(0, _betweenVerticalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenVerticalStart", ()=>(0, _betweenVerticalStartJsDefault.default));
parcelHelpers.export(exports, "BetweenVerticalStartIcon", ()=>(0, _betweenVerticalStartJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenVerticalStart", ()=>(0, _betweenVerticalStartJsDefault.default));
parcelHelpers.export(exports, "BicepsFlexed", ()=>(0, _bicepsFlexedJsDefault.default));
parcelHelpers.export(exports, "BicepsFlexedIcon", ()=>(0, _bicepsFlexedJsDefault.default));
parcelHelpers.export(exports, "LucideBicepsFlexed", ()=>(0, _bicepsFlexedJsDefault.default));
parcelHelpers.export(exports, "Bike", ()=>(0, _bikeJsDefault.default));
parcelHelpers.export(exports, "BikeIcon", ()=>(0, _bikeJsDefault.default));
parcelHelpers.export(exports, "LucideBike", ()=>(0, _bikeJsDefault.default));
parcelHelpers.export(exports, "Binary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "BinaryIcon", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "LucideBinary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "Binoculars", ()=>(0, _binocularsJsDefault.default));
parcelHelpers.export(exports, "BinocularsIcon", ()=>(0, _binocularsJsDefault.default));
parcelHelpers.export(exports, "LucideBinoculars", ()=>(0, _binocularsJsDefault.default));
parcelHelpers.export(exports, "Biohazard", ()=>(0, _biohazardJsDefault.default));
parcelHelpers.export(exports, "BiohazardIcon", ()=>(0, _biohazardJsDefault.default));
parcelHelpers.export(exports, "LucideBiohazard", ()=>(0, _biohazardJsDefault.default));
parcelHelpers.export(exports, "Bird", ()=>(0, _birdJsDefault.default));
parcelHelpers.export(exports, "BirdIcon", ()=>(0, _birdJsDefault.default));
parcelHelpers.export(exports, "LucideBird", ()=>(0, _birdJsDefault.default));
parcelHelpers.export(exports, "Bitcoin", ()=>(0, _bitcoinJsDefault.default));
parcelHelpers.export(exports, "BitcoinIcon", ()=>(0, _bitcoinJsDefault.default));
parcelHelpers.export(exports, "LucideBitcoin", ()=>(0, _bitcoinJsDefault.default));
parcelHelpers.export(exports, "Blend", ()=>(0, _blendJsDefault.default));
parcelHelpers.export(exports, "BlendIcon", ()=>(0, _blendJsDefault.default));
parcelHelpers.export(exports, "LucideBlend", ()=>(0, _blendJsDefault.default));
parcelHelpers.export(exports, "Blinds", ()=>(0, _blindsJsDefault.default));
parcelHelpers.export(exports, "BlindsIcon", ()=>(0, _blindsJsDefault.default));
parcelHelpers.export(exports, "LucideBlinds", ()=>(0, _blindsJsDefault.default));
parcelHelpers.export(exports, "Blocks", ()=>(0, _blocksJsDefault.default));
parcelHelpers.export(exports, "BlocksIcon", ()=>(0, _blocksJsDefault.default));
parcelHelpers.export(exports, "LucideBlocks", ()=>(0, _blocksJsDefault.default));
parcelHelpers.export(exports, "BluetoothConnected", ()=>(0, _bluetoothConnectedJsDefault.default));
parcelHelpers.export(exports, "BluetoothConnectedIcon", ()=>(0, _bluetoothConnectedJsDefault.default));
parcelHelpers.export(exports, "LucideBluetoothConnected", ()=>(0, _bluetoothConnectedJsDefault.default));
parcelHelpers.export(exports, "BluetoothOff", ()=>(0, _bluetoothOffJsDefault.default));
parcelHelpers.export(exports, "BluetoothOffIcon", ()=>(0, _bluetoothOffJsDefault.default));
parcelHelpers.export(exports, "LucideBluetoothOff", ()=>(0, _bluetoothOffJsDefault.default));
parcelHelpers.export(exports, "BluetoothSearching", ()=>(0, _bluetoothSearchingJsDefault.default));
parcelHelpers.export(exports, "BluetoothSearchingIcon", ()=>(0, _bluetoothSearchingJsDefault.default));
parcelHelpers.export(exports, "LucideBluetoothSearching", ()=>(0, _bluetoothSearchingJsDefault.default));
parcelHelpers.export(exports, "Bluetooth", ()=>(0, _bluetoothJsDefault.default));
parcelHelpers.export(exports, "BluetoothIcon", ()=>(0, _bluetoothJsDefault.default));
parcelHelpers.export(exports, "LucideBluetooth", ()=>(0, _bluetoothJsDefault.default));
parcelHelpers.export(exports, "Bold", ()=>(0, _boldJsDefault.default));
parcelHelpers.export(exports, "BoldIcon", ()=>(0, _boldJsDefault.default));
parcelHelpers.export(exports, "LucideBold", ()=>(0, _boldJsDefault.default));
parcelHelpers.export(exports, "Bolt", ()=>(0, _boltJsDefault.default));
parcelHelpers.export(exports, "BoltIcon", ()=>(0, _boltJsDefault.default));
parcelHelpers.export(exports, "LucideBolt", ()=>(0, _boltJsDefault.default));
parcelHelpers.export(exports, "Bomb", ()=>(0, _bombJsDefault.default));
parcelHelpers.export(exports, "BombIcon", ()=>(0, _bombJsDefault.default));
parcelHelpers.export(exports, "LucideBomb", ()=>(0, _bombJsDefault.default));
parcelHelpers.export(exports, "Bone", ()=>(0, _boneJsDefault.default));
parcelHelpers.export(exports, "BoneIcon", ()=>(0, _boneJsDefault.default));
parcelHelpers.export(exports, "LucideBone", ()=>(0, _boneJsDefault.default));
parcelHelpers.export(exports, "BookA", ()=>(0, _bookAJsDefault.default));
parcelHelpers.export(exports, "BookAIcon", ()=>(0, _bookAJsDefault.default));
parcelHelpers.export(exports, "LucideBookA", ()=>(0, _bookAJsDefault.default));
parcelHelpers.export(exports, "BookAlert", ()=>(0, _bookAlertJsDefault.default));
parcelHelpers.export(exports, "BookAlertIcon", ()=>(0, _bookAlertJsDefault.default));
parcelHelpers.export(exports, "LucideBookAlert", ()=>(0, _bookAlertJsDefault.default));
parcelHelpers.export(exports, "BookAudio", ()=>(0, _bookAudioJsDefault.default));
parcelHelpers.export(exports, "BookAudioIcon", ()=>(0, _bookAudioJsDefault.default));
parcelHelpers.export(exports, "LucideBookAudio", ()=>(0, _bookAudioJsDefault.default));
parcelHelpers.export(exports, "BookCheck", ()=>(0, _bookCheckJsDefault.default));
parcelHelpers.export(exports, "BookCheckIcon", ()=>(0, _bookCheckJsDefault.default));
parcelHelpers.export(exports, "LucideBookCheck", ()=>(0, _bookCheckJsDefault.default));
parcelHelpers.export(exports, "BookCopy", ()=>(0, _bookCopyJsDefault.default));
parcelHelpers.export(exports, "BookCopyIcon", ()=>(0, _bookCopyJsDefault.default));
parcelHelpers.export(exports, "LucideBookCopy", ()=>(0, _bookCopyJsDefault.default));
parcelHelpers.export(exports, "BookDown", ()=>(0, _bookDownJsDefault.default));
parcelHelpers.export(exports, "BookDownIcon", ()=>(0, _bookDownJsDefault.default));
parcelHelpers.export(exports, "LucideBookDown", ()=>(0, _bookDownJsDefault.default));
parcelHelpers.export(exports, "BookHeadphones", ()=>(0, _bookHeadphonesJsDefault.default));
parcelHelpers.export(exports, "BookHeadphonesIcon", ()=>(0, _bookHeadphonesJsDefault.default));
parcelHelpers.export(exports, "LucideBookHeadphones", ()=>(0, _bookHeadphonesJsDefault.default));
parcelHelpers.export(exports, "BookHeart", ()=>(0, _bookHeartJsDefault.default));
parcelHelpers.export(exports, "BookHeartIcon", ()=>(0, _bookHeartJsDefault.default));
parcelHelpers.export(exports, "LucideBookHeart", ()=>(0, _bookHeartJsDefault.default));
parcelHelpers.export(exports, "BookImage", ()=>(0, _bookImageJsDefault.default));
parcelHelpers.export(exports, "BookImageIcon", ()=>(0, _bookImageJsDefault.default));
parcelHelpers.export(exports, "LucideBookImage", ()=>(0, _bookImageJsDefault.default));
parcelHelpers.export(exports, "BookKey", ()=>(0, _bookKeyJsDefault.default));
parcelHelpers.export(exports, "BookKeyIcon", ()=>(0, _bookKeyJsDefault.default));
parcelHelpers.export(exports, "LucideBookKey", ()=>(0, _bookKeyJsDefault.default));
parcelHelpers.export(exports, "BookLock", ()=>(0, _bookLockJsDefault.default));
parcelHelpers.export(exports, "BookLockIcon", ()=>(0, _bookLockJsDefault.default));
parcelHelpers.export(exports, "LucideBookLock", ()=>(0, _bookLockJsDefault.default));
parcelHelpers.export(exports, "BookMarked", ()=>(0, _bookMarkedJsDefault.default));
parcelHelpers.export(exports, "BookMarkedIcon", ()=>(0, _bookMarkedJsDefault.default));
parcelHelpers.export(exports, "LucideBookMarked", ()=>(0, _bookMarkedJsDefault.default));
parcelHelpers.export(exports, "BookMinus", ()=>(0, _bookMinusJsDefault.default));
parcelHelpers.export(exports, "BookMinusIcon", ()=>(0, _bookMinusJsDefault.default));
parcelHelpers.export(exports, "LucideBookMinus", ()=>(0, _bookMinusJsDefault.default));
parcelHelpers.export(exports, "BookOpenCheck", ()=>(0, _bookOpenCheckJsDefault.default));
parcelHelpers.export(exports, "BookOpenCheckIcon", ()=>(0, _bookOpenCheckJsDefault.default));
parcelHelpers.export(exports, "LucideBookOpenCheck", ()=>(0, _bookOpenCheckJsDefault.default));
parcelHelpers.export(exports, "BookOpenText", ()=>(0, _bookOpenTextJsDefault.default));
parcelHelpers.export(exports, "BookOpenTextIcon", ()=>(0, _bookOpenTextJsDefault.default));
parcelHelpers.export(exports, "LucideBookOpenText", ()=>(0, _bookOpenTextJsDefault.default));
parcelHelpers.export(exports, "BookOpen", ()=>(0, _bookOpenJsDefault.default));
parcelHelpers.export(exports, "BookOpenIcon", ()=>(0, _bookOpenJsDefault.default));
parcelHelpers.export(exports, "LucideBookOpen", ()=>(0, _bookOpenJsDefault.default));
parcelHelpers.export(exports, "BookPlus", ()=>(0, _bookPlusJsDefault.default));
parcelHelpers.export(exports, "BookPlusIcon", ()=>(0, _bookPlusJsDefault.default));
parcelHelpers.export(exports, "LucideBookPlus", ()=>(0, _bookPlusJsDefault.default));
parcelHelpers.export(exports, "BookText", ()=>(0, _bookTextJsDefault.default));
parcelHelpers.export(exports, "BookTextIcon", ()=>(0, _bookTextJsDefault.default));
parcelHelpers.export(exports, "LucideBookText", ()=>(0, _bookTextJsDefault.default));
parcelHelpers.export(exports, "BookUp2", ()=>(0, _bookUp2JsDefault.default));
parcelHelpers.export(exports, "BookUp2Icon", ()=>(0, _bookUp2JsDefault.default));
parcelHelpers.export(exports, "LucideBookUp2", ()=>(0, _bookUp2JsDefault.default));
parcelHelpers.export(exports, "BookType", ()=>(0, _bookTypeJsDefault.default));
parcelHelpers.export(exports, "BookTypeIcon", ()=>(0, _bookTypeJsDefault.default));
parcelHelpers.export(exports, "LucideBookType", ()=>(0, _bookTypeJsDefault.default));
parcelHelpers.export(exports, "BookUp", ()=>(0, _bookUpJsDefault.default));
parcelHelpers.export(exports, "BookUpIcon", ()=>(0, _bookUpJsDefault.default));
parcelHelpers.export(exports, "LucideBookUp", ()=>(0, _bookUpJsDefault.default));
parcelHelpers.export(exports, "BookUser", ()=>(0, _bookUserJsDefault.default));
parcelHelpers.export(exports, "BookUserIcon", ()=>(0, _bookUserJsDefault.default));
parcelHelpers.export(exports, "LucideBookUser", ()=>(0, _bookUserJsDefault.default));
parcelHelpers.export(exports, "BookX", ()=>(0, _bookXJsDefault.default));
parcelHelpers.export(exports, "BookXIcon", ()=>(0, _bookXJsDefault.default));
parcelHelpers.export(exports, "LucideBookX", ()=>(0, _bookXJsDefault.default));
parcelHelpers.export(exports, "Book", ()=>(0, _bookJsDefault.default));
parcelHelpers.export(exports, "BookIcon", ()=>(0, _bookJsDefault.default));
parcelHelpers.export(exports, "LucideBook", ()=>(0, _bookJsDefault.default));
parcelHelpers.export(exports, "BookmarkMinus", ()=>(0, _bookmarkMinusJsDefault.default));
parcelHelpers.export(exports, "BookmarkMinusIcon", ()=>(0, _bookmarkMinusJsDefault.default));
parcelHelpers.export(exports, "LucideBookmarkMinus", ()=>(0, _bookmarkMinusJsDefault.default));
parcelHelpers.export(exports, "BookmarkCheck", ()=>(0, _bookmarkCheckJsDefault.default));
parcelHelpers.export(exports, "BookmarkCheckIcon", ()=>(0, _bookmarkCheckJsDefault.default));
parcelHelpers.export(exports, "LucideBookmarkCheck", ()=>(0, _bookmarkCheckJsDefault.default));
parcelHelpers.export(exports, "BookmarkPlus", ()=>(0, _bookmarkPlusJsDefault.default));
parcelHelpers.export(exports, "BookmarkPlusIcon", ()=>(0, _bookmarkPlusJsDefault.default));
parcelHelpers.export(exports, "LucideBookmarkPlus", ()=>(0, _bookmarkPlusJsDefault.default));
parcelHelpers.export(exports, "BookmarkX", ()=>(0, _bookmarkXJsDefault.default));
parcelHelpers.export(exports, "BookmarkXIcon", ()=>(0, _bookmarkXJsDefault.default));
parcelHelpers.export(exports, "LucideBookmarkX", ()=>(0, _bookmarkXJsDefault.default));
parcelHelpers.export(exports, "Bookmark", ()=>(0, _bookmarkJsDefault.default));
parcelHelpers.export(exports, "BookmarkIcon", ()=>(0, _bookmarkJsDefault.default));
parcelHelpers.export(exports, "LucideBookmark", ()=>(0, _bookmarkJsDefault.default));
parcelHelpers.export(exports, "BoomBox", ()=>(0, _boomBoxJsDefault.default));
parcelHelpers.export(exports, "BoomBoxIcon", ()=>(0, _boomBoxJsDefault.default));
parcelHelpers.export(exports, "LucideBoomBox", ()=>(0, _boomBoxJsDefault.default));
parcelHelpers.export(exports, "BotMessageSquare", ()=>(0, _botMessageSquareJsDefault.default));
parcelHelpers.export(exports, "BotMessageSquareIcon", ()=>(0, _botMessageSquareJsDefault.default));
parcelHelpers.export(exports, "LucideBotMessageSquare", ()=>(0, _botMessageSquareJsDefault.default));
parcelHelpers.export(exports, "BotOff", ()=>(0, _botOffJsDefault.default));
parcelHelpers.export(exports, "BotOffIcon", ()=>(0, _botOffJsDefault.default));
parcelHelpers.export(exports, "LucideBotOff", ()=>(0, _botOffJsDefault.default));
parcelHelpers.export(exports, "Bot", ()=>(0, _botJsDefault.default));
parcelHelpers.export(exports, "BotIcon", ()=>(0, _botJsDefault.default));
parcelHelpers.export(exports, "LucideBot", ()=>(0, _botJsDefault.default));
parcelHelpers.export(exports, "BowArrow", ()=>(0, _bowArrowJsDefault.default));
parcelHelpers.export(exports, "BowArrowIcon", ()=>(0, _bowArrowJsDefault.default));
parcelHelpers.export(exports, "LucideBowArrow", ()=>(0, _bowArrowJsDefault.default));
parcelHelpers.export(exports, "Box", ()=>(0, _boxJsDefault.default));
parcelHelpers.export(exports, "BoxIcon", ()=>(0, _boxJsDefault.default));
parcelHelpers.export(exports, "LucideBox", ()=>(0, _boxJsDefault.default));
parcelHelpers.export(exports, "Boxes", ()=>(0, _boxesJsDefault.default));
parcelHelpers.export(exports, "BoxesIcon", ()=>(0, _boxesJsDefault.default));
parcelHelpers.export(exports, "LucideBoxes", ()=>(0, _boxesJsDefault.default));
parcelHelpers.export(exports, "Brackets", ()=>(0, _bracketsJsDefault.default));
parcelHelpers.export(exports, "BracketsIcon", ()=>(0, _bracketsJsDefault.default));
parcelHelpers.export(exports, "LucideBrackets", ()=>(0, _bracketsJsDefault.default));
parcelHelpers.export(exports, "BrainCircuit", ()=>(0, _brainCircuitJsDefault.default));
parcelHelpers.export(exports, "BrainCircuitIcon", ()=>(0, _brainCircuitJsDefault.default));
parcelHelpers.export(exports, "LucideBrainCircuit", ()=>(0, _brainCircuitJsDefault.default));
parcelHelpers.export(exports, "BrainCog", ()=>(0, _brainCogJsDefault.default));
parcelHelpers.export(exports, "BrainCogIcon", ()=>(0, _brainCogJsDefault.default));
parcelHelpers.export(exports, "LucideBrainCog", ()=>(0, _brainCogJsDefault.default));
parcelHelpers.export(exports, "Brain", ()=>(0, _brainJsDefault.default));
parcelHelpers.export(exports, "BrainIcon", ()=>(0, _brainJsDefault.default));
parcelHelpers.export(exports, "LucideBrain", ()=>(0, _brainJsDefault.default));
parcelHelpers.export(exports, "BrickWall", ()=>(0, _brickWallJsDefault.default));
parcelHelpers.export(exports, "BrickWallIcon", ()=>(0, _brickWallJsDefault.default));
parcelHelpers.export(exports, "LucideBrickWall", ()=>(0, _brickWallJsDefault.default));
parcelHelpers.export(exports, "BrickWallFire", ()=>(0, _brickWallFireJsDefault.default));
parcelHelpers.export(exports, "BrickWallFireIcon", ()=>(0, _brickWallFireJsDefault.default));
parcelHelpers.export(exports, "LucideBrickWallFire", ()=>(0, _brickWallFireJsDefault.default));
parcelHelpers.export(exports, "BriefcaseBusiness", ()=>(0, _briefcaseBusinessJsDefault.default));
parcelHelpers.export(exports, "BriefcaseBusinessIcon", ()=>(0, _briefcaseBusinessJsDefault.default));
parcelHelpers.export(exports, "LucideBriefcaseBusiness", ()=>(0, _briefcaseBusinessJsDefault.default));
parcelHelpers.export(exports, "BriefcaseConveyorBelt", ()=>(0, _briefcaseConveyorBeltJsDefault.default));
parcelHelpers.export(exports, "BriefcaseConveyorBeltIcon", ()=>(0, _briefcaseConveyorBeltJsDefault.default));
parcelHelpers.export(exports, "LucideBriefcaseConveyorBelt", ()=>(0, _briefcaseConveyorBeltJsDefault.default));
parcelHelpers.export(exports, "BriefcaseMedical", ()=>(0, _briefcaseMedicalJsDefault.default));
parcelHelpers.export(exports, "BriefcaseMedicalIcon", ()=>(0, _briefcaseMedicalJsDefault.default));
parcelHelpers.export(exports, "LucideBriefcaseMedical", ()=>(0, _briefcaseMedicalJsDefault.default));
parcelHelpers.export(exports, "Briefcase", ()=>(0, _briefcaseJsDefault.default));
parcelHelpers.export(exports, "BriefcaseIcon", ()=>(0, _briefcaseJsDefault.default));
parcelHelpers.export(exports, "LucideBriefcase", ()=>(0, _briefcaseJsDefault.default));
parcelHelpers.export(exports, "BringToFront", ()=>(0, _bringToFrontJsDefault.default));
parcelHelpers.export(exports, "BringToFrontIcon", ()=>(0, _bringToFrontJsDefault.default));
parcelHelpers.export(exports, "LucideBringToFront", ()=>(0, _bringToFrontJsDefault.default));
parcelHelpers.export(exports, "BrushCleaning", ()=>(0, _brushCleaningJsDefault.default));
parcelHelpers.export(exports, "BrushCleaningIcon", ()=>(0, _brushCleaningJsDefault.default));
parcelHelpers.export(exports, "LucideBrushCleaning", ()=>(0, _brushCleaningJsDefault.default));
parcelHelpers.export(exports, "Brush", ()=>(0, _brushJsDefault.default));
parcelHelpers.export(exports, "BrushIcon", ()=>(0, _brushJsDefault.default));
parcelHelpers.export(exports, "LucideBrush", ()=>(0, _brushJsDefault.default));
parcelHelpers.export(exports, "Bubbles", ()=>(0, _bubblesJsDefault.default));
parcelHelpers.export(exports, "BubblesIcon", ()=>(0, _bubblesJsDefault.default));
parcelHelpers.export(exports, "LucideBubbles", ()=>(0, _bubblesJsDefault.default));
parcelHelpers.export(exports, "BugOff", ()=>(0, _bugOffJsDefault.default));
parcelHelpers.export(exports, "BugOffIcon", ()=>(0, _bugOffJsDefault.default));
parcelHelpers.export(exports, "LucideBugOff", ()=>(0, _bugOffJsDefault.default));
parcelHelpers.export(exports, "BugPlay", ()=>(0, _bugPlayJsDefault.default));
parcelHelpers.export(exports, "BugPlayIcon", ()=>(0, _bugPlayJsDefault.default));
parcelHelpers.export(exports, "LucideBugPlay", ()=>(0, _bugPlayJsDefault.default));
parcelHelpers.export(exports, "Bug", ()=>(0, _bugJsDefault.default));
parcelHelpers.export(exports, "BugIcon", ()=>(0, _bugJsDefault.default));
parcelHelpers.export(exports, "LucideBug", ()=>(0, _bugJsDefault.default));
parcelHelpers.export(exports, "Building2", ()=>(0, _building2JsDefault.default));
parcelHelpers.export(exports, "Building2Icon", ()=>(0, _building2JsDefault.default));
parcelHelpers.export(exports, "LucideBuilding2", ()=>(0, _building2JsDefault.default));
parcelHelpers.export(exports, "Building", ()=>(0, _buildingJsDefault.default));
parcelHelpers.export(exports, "BuildingIcon", ()=>(0, _buildingJsDefault.default));
parcelHelpers.export(exports, "LucideBuilding", ()=>(0, _buildingJsDefault.default));
parcelHelpers.export(exports, "BusFront", ()=>(0, _busFrontJsDefault.default));
parcelHelpers.export(exports, "BusFrontIcon", ()=>(0, _busFrontJsDefault.default));
parcelHelpers.export(exports, "LucideBusFront", ()=>(0, _busFrontJsDefault.default));
parcelHelpers.export(exports, "Bus", ()=>(0, _busJsDefault.default));
parcelHelpers.export(exports, "BusIcon", ()=>(0, _busJsDefault.default));
parcelHelpers.export(exports, "LucideBus", ()=>(0, _busJsDefault.default));
parcelHelpers.export(exports, "CableCar", ()=>(0, _cableCarJsDefault.default));
parcelHelpers.export(exports, "CableCarIcon", ()=>(0, _cableCarJsDefault.default));
parcelHelpers.export(exports, "LucideCableCar", ()=>(0, _cableCarJsDefault.default));
parcelHelpers.export(exports, "Cable", ()=>(0, _cableJsDefault.default));
parcelHelpers.export(exports, "CableIcon", ()=>(0, _cableJsDefault.default));
parcelHelpers.export(exports, "LucideCable", ()=>(0, _cableJsDefault.default));
parcelHelpers.export(exports, "CakeSlice", ()=>(0, _cakeSliceJsDefault.default));
parcelHelpers.export(exports, "CakeSliceIcon", ()=>(0, _cakeSliceJsDefault.default));
parcelHelpers.export(exports, "LucideCakeSlice", ()=>(0, _cakeSliceJsDefault.default));
parcelHelpers.export(exports, "Cake", ()=>(0, _cakeJsDefault.default));
parcelHelpers.export(exports, "CakeIcon", ()=>(0, _cakeJsDefault.default));
parcelHelpers.export(exports, "LucideCake", ()=>(0, _cakeJsDefault.default));
parcelHelpers.export(exports, "Calculator", ()=>(0, _calculatorJsDefault.default));
parcelHelpers.export(exports, "CalculatorIcon", ()=>(0, _calculatorJsDefault.default));
parcelHelpers.export(exports, "LucideCalculator", ()=>(0, _calculatorJsDefault.default));
parcelHelpers.export(exports, "Calendar1", ()=>(0, _calendar1JsDefault.default));
parcelHelpers.export(exports, "Calendar1Icon", ()=>(0, _calendar1JsDefault.default));
parcelHelpers.export(exports, "LucideCalendar1", ()=>(0, _calendar1JsDefault.default));
parcelHelpers.export(exports, "CalendarArrowDown", ()=>(0, _calendarArrowDownJsDefault.default));
parcelHelpers.export(exports, "CalendarArrowDownIcon", ()=>(0, _calendarArrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarArrowDown", ()=>(0, _calendarArrowDownJsDefault.default));
parcelHelpers.export(exports, "CalendarArrowUp", ()=>(0, _calendarArrowUpJsDefault.default));
parcelHelpers.export(exports, "CalendarArrowUpIcon", ()=>(0, _calendarArrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarArrowUp", ()=>(0, _calendarArrowUpJsDefault.default));
parcelHelpers.export(exports, "CalendarCheck2", ()=>(0, _calendarCheck2JsDefault.default));
parcelHelpers.export(exports, "CalendarCheck2Icon", ()=>(0, _calendarCheck2JsDefault.default));
parcelHelpers.export(exports, "LucideCalendarCheck2", ()=>(0, _calendarCheck2JsDefault.default));
parcelHelpers.export(exports, "CalendarCheck", ()=>(0, _calendarCheckJsDefault.default));
parcelHelpers.export(exports, "CalendarCheckIcon", ()=>(0, _calendarCheckJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarCheck", ()=>(0, _calendarCheckJsDefault.default));
parcelHelpers.export(exports, "CalendarClock", ()=>(0, _calendarClockJsDefault.default));
parcelHelpers.export(exports, "CalendarClockIcon", ()=>(0, _calendarClockJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarClock", ()=>(0, _calendarClockJsDefault.default));
parcelHelpers.export(exports, "CalendarDays", ()=>(0, _calendarDaysJsDefault.default));
parcelHelpers.export(exports, "CalendarDaysIcon", ()=>(0, _calendarDaysJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarDays", ()=>(0, _calendarDaysJsDefault.default));
parcelHelpers.export(exports, "CalendarCog", ()=>(0, _calendarCogJsDefault.default));
parcelHelpers.export(exports, "CalendarCogIcon", ()=>(0, _calendarCogJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarCog", ()=>(0, _calendarCogJsDefault.default));
parcelHelpers.export(exports, "CalendarFold", ()=>(0, _calendarFoldJsDefault.default));
parcelHelpers.export(exports, "CalendarFoldIcon", ()=>(0, _calendarFoldJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarFold", ()=>(0, _calendarFoldJsDefault.default));
parcelHelpers.export(exports, "CalendarHeart", ()=>(0, _calendarHeartJsDefault.default));
parcelHelpers.export(exports, "CalendarHeartIcon", ()=>(0, _calendarHeartJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarHeart", ()=>(0, _calendarHeartJsDefault.default));
parcelHelpers.export(exports, "CalendarMinus2", ()=>(0, _calendarMinus2JsDefault.default));
parcelHelpers.export(exports, "CalendarMinus2Icon", ()=>(0, _calendarMinus2JsDefault.default));
parcelHelpers.export(exports, "LucideCalendarMinus2", ()=>(0, _calendarMinus2JsDefault.default));
parcelHelpers.export(exports, "CalendarMinus", ()=>(0, _calendarMinusJsDefault.default));
parcelHelpers.export(exports, "CalendarMinusIcon", ()=>(0, _calendarMinusJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarMinus", ()=>(0, _calendarMinusJsDefault.default));
parcelHelpers.export(exports, "CalendarOff", ()=>(0, _calendarOffJsDefault.default));
parcelHelpers.export(exports, "CalendarOffIcon", ()=>(0, _calendarOffJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarOff", ()=>(0, _calendarOffJsDefault.default));
parcelHelpers.export(exports, "CalendarPlus2", ()=>(0, _calendarPlus2JsDefault.default));
parcelHelpers.export(exports, "CalendarPlus2Icon", ()=>(0, _calendarPlus2JsDefault.default));
parcelHelpers.export(exports, "LucideCalendarPlus2", ()=>(0, _calendarPlus2JsDefault.default));
parcelHelpers.export(exports, "CalendarPlus", ()=>(0, _calendarPlusJsDefault.default));
parcelHelpers.export(exports, "CalendarPlusIcon", ()=>(0, _calendarPlusJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarPlus", ()=>(0, _calendarPlusJsDefault.default));
parcelHelpers.export(exports, "CalendarRange", ()=>(0, _calendarRangeJsDefault.default));
parcelHelpers.export(exports, "CalendarRangeIcon", ()=>(0, _calendarRangeJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarRange", ()=>(0, _calendarRangeJsDefault.default));
parcelHelpers.export(exports, "CalendarSearch", ()=>(0, _calendarSearchJsDefault.default));
parcelHelpers.export(exports, "CalendarSearchIcon", ()=>(0, _calendarSearchJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarSearch", ()=>(0, _calendarSearchJsDefault.default));
parcelHelpers.export(exports, "CalendarX2", ()=>(0, _calendarX2JsDefault.default));
parcelHelpers.export(exports, "CalendarX2Icon", ()=>(0, _calendarX2JsDefault.default));
parcelHelpers.export(exports, "LucideCalendarX2", ()=>(0, _calendarX2JsDefault.default));
parcelHelpers.export(exports, "CalendarSync", ()=>(0, _calendarSyncJsDefault.default));
parcelHelpers.export(exports, "CalendarSyncIcon", ()=>(0, _calendarSyncJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarSync", ()=>(0, _calendarSyncJsDefault.default));
parcelHelpers.export(exports, "CalendarX", ()=>(0, _calendarXJsDefault.default));
parcelHelpers.export(exports, "CalendarXIcon", ()=>(0, _calendarXJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarX", ()=>(0, _calendarXJsDefault.default));
parcelHelpers.export(exports, "Calendar", ()=>(0, _calendarJsDefault.default));
parcelHelpers.export(exports, "CalendarIcon", ()=>(0, _calendarJsDefault.default));
parcelHelpers.export(exports, "LucideCalendar", ()=>(0, _calendarJsDefault.default));
parcelHelpers.export(exports, "CameraOff", ()=>(0, _cameraOffJsDefault.default));
parcelHelpers.export(exports, "CameraOffIcon", ()=>(0, _cameraOffJsDefault.default));
parcelHelpers.export(exports, "LucideCameraOff", ()=>(0, _cameraOffJsDefault.default));
parcelHelpers.export(exports, "Camera", ()=>(0, _cameraJsDefault.default));
parcelHelpers.export(exports, "CameraIcon", ()=>(0, _cameraJsDefault.default));
parcelHelpers.export(exports, "LucideCamera", ()=>(0, _cameraJsDefault.default));
parcelHelpers.export(exports, "CandyCane", ()=>(0, _candyCaneJsDefault.default));
parcelHelpers.export(exports, "CandyCaneIcon", ()=>(0, _candyCaneJsDefault.default));
parcelHelpers.export(exports, "LucideCandyCane", ()=>(0, _candyCaneJsDefault.default));
parcelHelpers.export(exports, "CandyOff", ()=>(0, _candyOffJsDefault.default));
parcelHelpers.export(exports, "CandyOffIcon", ()=>(0, _candyOffJsDefault.default));
parcelHelpers.export(exports, "LucideCandyOff", ()=>(0, _candyOffJsDefault.default));
parcelHelpers.export(exports, "Cannabis", ()=>(0, _cannabisJsDefault.default));
parcelHelpers.export(exports, "CannabisIcon", ()=>(0, _cannabisJsDefault.default));
parcelHelpers.export(exports, "LucideCannabis", ()=>(0, _cannabisJsDefault.default));
parcelHelpers.export(exports, "Candy", ()=>(0, _candyJsDefault.default));
parcelHelpers.export(exports, "CandyIcon", ()=>(0, _candyJsDefault.default));
parcelHelpers.export(exports, "LucideCandy", ()=>(0, _candyJsDefault.default));
parcelHelpers.export(exports, "CaptionsOff", ()=>(0, _captionsOffJsDefault.default));
parcelHelpers.export(exports, "CaptionsOffIcon", ()=>(0, _captionsOffJsDefault.default));
parcelHelpers.export(exports, "LucideCaptionsOff", ()=>(0, _captionsOffJsDefault.default));
parcelHelpers.export(exports, "CarFront", ()=>(0, _carFrontJsDefault.default));
parcelHelpers.export(exports, "CarFrontIcon", ()=>(0, _carFrontJsDefault.default));
parcelHelpers.export(exports, "LucideCarFront", ()=>(0, _carFrontJsDefault.default));
parcelHelpers.export(exports, "Car", ()=>(0, _carJsDefault.default));
parcelHelpers.export(exports, "CarIcon", ()=>(0, _carJsDefault.default));
parcelHelpers.export(exports, "LucideCar", ()=>(0, _carJsDefault.default));
parcelHelpers.export(exports, "CarTaxiFront", ()=>(0, _carTaxiFrontJsDefault.default));
parcelHelpers.export(exports, "CarTaxiFrontIcon", ()=>(0, _carTaxiFrontJsDefault.default));
parcelHelpers.export(exports, "LucideCarTaxiFront", ()=>(0, _carTaxiFrontJsDefault.default));
parcelHelpers.export(exports, "Caravan", ()=>(0, _caravanJsDefault.default));
parcelHelpers.export(exports, "CaravanIcon", ()=>(0, _caravanJsDefault.default));
parcelHelpers.export(exports, "LucideCaravan", ()=>(0, _caravanJsDefault.default));
parcelHelpers.export(exports, "CardSim", ()=>(0, _cardSimJsDefault.default));
parcelHelpers.export(exports, "CardSimIcon", ()=>(0, _cardSimJsDefault.default));
parcelHelpers.export(exports, "LucideCardSim", ()=>(0, _cardSimJsDefault.default));
parcelHelpers.export(exports, "Carrot", ()=>(0, _carrotJsDefault.default));
parcelHelpers.export(exports, "CarrotIcon", ()=>(0, _carrotJsDefault.default));
parcelHelpers.export(exports, "LucideCarrot", ()=>(0, _carrotJsDefault.default));
parcelHelpers.export(exports, "CaseLower", ()=>(0, _caseLowerJsDefault.default));
parcelHelpers.export(exports, "CaseLowerIcon", ()=>(0, _caseLowerJsDefault.default));
parcelHelpers.export(exports, "LucideCaseLower", ()=>(0, _caseLowerJsDefault.default));
parcelHelpers.export(exports, "CaseSensitive", ()=>(0, _caseSensitiveJsDefault.default));
parcelHelpers.export(exports, "CaseSensitiveIcon", ()=>(0, _caseSensitiveJsDefault.default));
parcelHelpers.export(exports, "LucideCaseSensitive", ()=>(0, _caseSensitiveJsDefault.default));
parcelHelpers.export(exports, "CaseUpper", ()=>(0, _caseUpperJsDefault.default));
parcelHelpers.export(exports, "CaseUpperIcon", ()=>(0, _caseUpperJsDefault.default));
parcelHelpers.export(exports, "LucideCaseUpper", ()=>(0, _caseUpperJsDefault.default));
parcelHelpers.export(exports, "CassetteTape", ()=>(0, _cassetteTapeJsDefault.default));
parcelHelpers.export(exports, "CassetteTapeIcon", ()=>(0, _cassetteTapeJsDefault.default));
parcelHelpers.export(exports, "LucideCassetteTape", ()=>(0, _cassetteTapeJsDefault.default));
parcelHelpers.export(exports, "Cast", ()=>(0, _castJsDefault.default));
parcelHelpers.export(exports, "CastIcon", ()=>(0, _castJsDefault.default));
parcelHelpers.export(exports, "LucideCast", ()=>(0, _castJsDefault.default));
parcelHelpers.export(exports, "Castle", ()=>(0, _castleJsDefault.default));
parcelHelpers.export(exports, "CastleIcon", ()=>(0, _castleJsDefault.default));
parcelHelpers.export(exports, "LucideCastle", ()=>(0, _castleJsDefault.default));
parcelHelpers.export(exports, "Cat", ()=>(0, _catJsDefault.default));
parcelHelpers.export(exports, "CatIcon", ()=>(0, _catJsDefault.default));
parcelHelpers.export(exports, "LucideCat", ()=>(0, _catJsDefault.default));
parcelHelpers.export(exports, "Cctv", ()=>(0, _cctvJsDefault.default));
parcelHelpers.export(exports, "CctvIcon", ()=>(0, _cctvJsDefault.default));
parcelHelpers.export(exports, "LucideCctv", ()=>(0, _cctvJsDefault.default));
parcelHelpers.export(exports, "ChartBarDecreasing", ()=>(0, _chartBarDecreasingJsDefault.default));
parcelHelpers.export(exports, "ChartBarDecreasingIcon", ()=>(0, _chartBarDecreasingJsDefault.default));
parcelHelpers.export(exports, "LucideChartBarDecreasing", ()=>(0, _chartBarDecreasingJsDefault.default));
parcelHelpers.export(exports, "ChartBarIncreasing", ()=>(0, _chartBarIncreasingJsDefault.default));
parcelHelpers.export(exports, "ChartBarIncreasingIcon", ()=>(0, _chartBarIncreasingJsDefault.default));
parcelHelpers.export(exports, "LucideChartBarIncreasing", ()=>(0, _chartBarIncreasingJsDefault.default));
parcelHelpers.export(exports, "ChartBarStacked", ()=>(0, _chartBarStackedJsDefault.default));
parcelHelpers.export(exports, "ChartBarStackedIcon", ()=>(0, _chartBarStackedJsDefault.default));
parcelHelpers.export(exports, "LucideChartBarStacked", ()=>(0, _chartBarStackedJsDefault.default));
parcelHelpers.export(exports, "ChartColumnDecreasing", ()=>(0, _chartColumnDecreasingJsDefault.default));
parcelHelpers.export(exports, "ChartColumnDecreasingIcon", ()=>(0, _chartColumnDecreasingJsDefault.default));
parcelHelpers.export(exports, "LucideChartColumnDecreasing", ()=>(0, _chartColumnDecreasingJsDefault.default));
parcelHelpers.export(exports, "ChartColumnStacked", ()=>(0, _chartColumnStackedJsDefault.default));
parcelHelpers.export(exports, "ChartColumnStackedIcon", ()=>(0, _chartColumnStackedJsDefault.default));
parcelHelpers.export(exports, "LucideChartColumnStacked", ()=>(0, _chartColumnStackedJsDefault.default));
parcelHelpers.export(exports, "ChartGantt", ()=>(0, _chartGanttJsDefault.default));
parcelHelpers.export(exports, "ChartGanttIcon", ()=>(0, _chartGanttJsDefault.default));
parcelHelpers.export(exports, "LucideChartGantt", ()=>(0, _chartGanttJsDefault.default));
parcelHelpers.export(exports, "ChartNetwork", ()=>(0, _chartNetworkJsDefault.default));
parcelHelpers.export(exports, "ChartNetworkIcon", ()=>(0, _chartNetworkJsDefault.default));
parcelHelpers.export(exports, "LucideChartNetwork", ()=>(0, _chartNetworkJsDefault.default));
parcelHelpers.export(exports, "ChartNoAxesColumnDecreasing", ()=>(0, _chartNoAxesColumnDecreasingJsDefault.default));
parcelHelpers.export(exports, "ChartNoAxesColumnDecreasingIcon", ()=>(0, _chartNoAxesColumnDecreasingJsDefault.default));
parcelHelpers.export(exports, "LucideChartNoAxesColumnDecreasing", ()=>(0, _chartNoAxesColumnDecreasingJsDefault.default));
parcelHelpers.export(exports, "ChartNoAxesCombined", ()=>(0, _chartNoAxesCombinedJsDefault.default));
parcelHelpers.export(exports, "ChartNoAxesCombinedIcon", ()=>(0, _chartNoAxesCombinedJsDefault.default));
parcelHelpers.export(exports, "LucideChartNoAxesCombined", ()=>(0, _chartNoAxesCombinedJsDefault.default));
parcelHelpers.export(exports, "ChartSpline", ()=>(0, _chartSplineJsDefault.default));
parcelHelpers.export(exports, "ChartSplineIcon", ()=>(0, _chartSplineJsDefault.default));
parcelHelpers.export(exports, "LucideChartSpline", ()=>(0, _chartSplineJsDefault.default));
parcelHelpers.export(exports, "CheckCheck", ()=>(0, _checkCheckJsDefault.default));
parcelHelpers.export(exports, "CheckCheckIcon", ()=>(0, _checkCheckJsDefault.default));
parcelHelpers.export(exports, "LucideCheckCheck", ()=>(0, _checkCheckJsDefault.default));
parcelHelpers.export(exports, "CheckLine", ()=>(0, _checkLineJsDefault.default));
parcelHelpers.export(exports, "CheckLineIcon", ()=>(0, _checkLineJsDefault.default));
parcelHelpers.export(exports, "LucideCheckLine", ()=>(0, _checkLineJsDefault.default));
parcelHelpers.export(exports, "Check", ()=>(0, _checkJsDefault.default));
parcelHelpers.export(exports, "CheckIcon", ()=>(0, _checkJsDefault.default));
parcelHelpers.export(exports, "LucideCheck", ()=>(0, _checkJsDefault.default));
parcelHelpers.export(exports, "ChefHat", ()=>(0, _chefHatJsDefault.default));
parcelHelpers.export(exports, "ChefHatIcon", ()=>(0, _chefHatJsDefault.default));
parcelHelpers.export(exports, "LucideChefHat", ()=>(0, _chefHatJsDefault.default));
parcelHelpers.export(exports, "Cherry", ()=>(0, _cherryJsDefault.default));
parcelHelpers.export(exports, "CherryIcon", ()=>(0, _cherryJsDefault.default));
parcelHelpers.export(exports, "LucideCherry", ()=>(0, _cherryJsDefault.default));
parcelHelpers.export(exports, "ChevronDown", ()=>(0, _chevronDownJsDefault.default));
parcelHelpers.export(exports, "ChevronDownIcon", ()=>(0, _chevronDownJsDefault.default));
parcelHelpers.export(exports, "LucideChevronDown", ()=>(0, _chevronDownJsDefault.default));
parcelHelpers.export(exports, "ChevronFirst", ()=>(0, _chevronFirstJsDefault.default));
parcelHelpers.export(exports, "ChevronFirstIcon", ()=>(0, _chevronFirstJsDefault.default));
parcelHelpers.export(exports, "LucideChevronFirst", ()=>(0, _chevronFirstJsDefault.default));
parcelHelpers.export(exports, "ChevronLast", ()=>(0, _chevronLastJsDefault.default));
parcelHelpers.export(exports, "ChevronLastIcon", ()=>(0, _chevronLastJsDefault.default));
parcelHelpers.export(exports, "LucideChevronLast", ()=>(0, _chevronLastJsDefault.default));
parcelHelpers.export(exports, "ChevronLeft", ()=>(0, _chevronLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftIcon", ()=>(0, _chevronLeftJsDefault.default));
parcelHelpers.export(exports, "LucideChevronLeft", ()=>(0, _chevronLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronRight", ()=>(0, _chevronRightJsDefault.default));
parcelHelpers.export(exports, "ChevronRightIcon", ()=>(0, _chevronRightJsDefault.default));
parcelHelpers.export(exports, "LucideChevronRight", ()=>(0, _chevronRightJsDefault.default));
parcelHelpers.export(exports, "ChevronUp", ()=>(0, _chevronUpJsDefault.default));
parcelHelpers.export(exports, "ChevronUpIcon", ()=>(0, _chevronUpJsDefault.default));
parcelHelpers.export(exports, "LucideChevronUp", ()=>(0, _chevronUpJsDefault.default));
parcelHelpers.export(exports, "ChevronsDownUp", ()=>(0, _chevronsDownUpJsDefault.default));
parcelHelpers.export(exports, "ChevronsDownUpIcon", ()=>(0, _chevronsDownUpJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsDownUp", ()=>(0, _chevronsDownUpJsDefault.default));
parcelHelpers.export(exports, "ChevronsDown", ()=>(0, _chevronsDownJsDefault.default));
parcelHelpers.export(exports, "ChevronsDownIcon", ()=>(0, _chevronsDownJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsDown", ()=>(0, _chevronsDownJsDefault.default));
parcelHelpers.export(exports, "ChevronsLeftRightEllipsis", ()=>(0, _chevronsLeftRightEllipsisJsDefault.default));
parcelHelpers.export(exports, "ChevronsLeftRightEllipsisIcon", ()=>(0, _chevronsLeftRightEllipsisJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsLeftRightEllipsis", ()=>(0, _chevronsLeftRightEllipsisJsDefault.default));
parcelHelpers.export(exports, "ChevronsLeftRight", ()=>(0, _chevronsLeftRightJsDefault.default));
parcelHelpers.export(exports, "ChevronsLeftRightIcon", ()=>(0, _chevronsLeftRightJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsLeftRight", ()=>(0, _chevronsLeftRightJsDefault.default));
parcelHelpers.export(exports, "ChevronsLeft", ()=>(0, _chevronsLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronsLeftIcon", ()=>(0, _chevronsLeftJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsLeft", ()=>(0, _chevronsLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronsRightLeft", ()=>(0, _chevronsRightLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronsRightLeftIcon", ()=>(0, _chevronsRightLeftJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsRightLeft", ()=>(0, _chevronsRightLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronsRight", ()=>(0, _chevronsRightJsDefault.default));
parcelHelpers.export(exports, "ChevronsRightIcon", ()=>(0, _chevronsRightJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsRight", ()=>(0, _chevronsRightJsDefault.default));
parcelHelpers.export(exports, "ChevronsUpDown", ()=>(0, _chevronsUpDownJsDefault.default));
parcelHelpers.export(exports, "ChevronsUpDownIcon", ()=>(0, _chevronsUpDownJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsUpDown", ()=>(0, _chevronsUpDownJsDefault.default));
parcelHelpers.export(exports, "ChevronsUp", ()=>(0, _chevronsUpJsDefault.default));
parcelHelpers.export(exports, "ChevronsUpIcon", ()=>(0, _chevronsUpJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsUp", ()=>(0, _chevronsUpJsDefault.default));
parcelHelpers.export(exports, "Chrome", ()=>(0, _chromeJsDefault.default));
parcelHelpers.export(exports, "ChromeIcon", ()=>(0, _chromeJsDefault.default));
parcelHelpers.export(exports, "LucideChrome", ()=>(0, _chromeJsDefault.default));
parcelHelpers.export(exports, "Church", ()=>(0, _churchJsDefault.default));
parcelHelpers.export(exports, "ChurchIcon", ()=>(0, _churchJsDefault.default));
parcelHelpers.export(exports, "LucideChurch", ()=>(0, _churchJsDefault.default));
parcelHelpers.export(exports, "Cigarette", ()=>(0, _cigaretteJsDefault.default));
parcelHelpers.export(exports, "CigaretteIcon", ()=>(0, _cigaretteJsDefault.default));
parcelHelpers.export(exports, "LucideCigarette", ()=>(0, _cigaretteJsDefault.default));
parcelHelpers.export(exports, "CigaretteOff", ()=>(0, _cigaretteOffJsDefault.default));
parcelHelpers.export(exports, "CigaretteOffIcon", ()=>(0, _cigaretteOffJsDefault.default));
parcelHelpers.export(exports, "LucideCigaretteOff", ()=>(0, _cigaretteOffJsDefault.default));
parcelHelpers.export(exports, "CircleDashed", ()=>(0, _circleDashedJsDefault.default));
parcelHelpers.export(exports, "CircleDashedIcon", ()=>(0, _circleDashedJsDefault.default));
parcelHelpers.export(exports, "LucideCircleDashed", ()=>(0, _circleDashedJsDefault.default));
parcelHelpers.export(exports, "CircleDollarSign", ()=>(0, _circleDollarSignJsDefault.default));
parcelHelpers.export(exports, "CircleDollarSignIcon", ()=>(0, _circleDollarSignJsDefault.default));
parcelHelpers.export(exports, "LucideCircleDollarSign", ()=>(0, _circleDollarSignJsDefault.default));
parcelHelpers.export(exports, "CircleDotDashed", ()=>(0, _circleDotDashedJsDefault.default));
parcelHelpers.export(exports, "CircleDotDashedIcon", ()=>(0, _circleDotDashedJsDefault.default));
parcelHelpers.export(exports, "LucideCircleDotDashed", ()=>(0, _circleDotDashedJsDefault.default));
parcelHelpers.export(exports, "CircleDot", ()=>(0, _circleDotJsDefault.default));
parcelHelpers.export(exports, "CircleDotIcon", ()=>(0, _circleDotJsDefault.default));
parcelHelpers.export(exports, "LucideCircleDot", ()=>(0, _circleDotJsDefault.default));
parcelHelpers.export(exports, "CircleEllipsis", ()=>(0, _circleEllipsisJsDefault.default));
parcelHelpers.export(exports, "CircleEllipsisIcon", ()=>(0, _circleEllipsisJsDefault.default));
parcelHelpers.export(exports, "LucideCircleEllipsis", ()=>(0, _circleEllipsisJsDefault.default));
parcelHelpers.export(exports, "CircleEqual", ()=>(0, _circleEqualJsDefault.default));
parcelHelpers.export(exports, "CircleEqualIcon", ()=>(0, _circleEqualJsDefault.default));
parcelHelpers.export(exports, "LucideCircleEqual", ()=>(0, _circleEqualJsDefault.default));
parcelHelpers.export(exports, "CircleFadingArrowUp", ()=>(0, _circleFadingArrowUpJsDefault.default));
parcelHelpers.export(exports, "CircleFadingArrowUpIcon", ()=>(0, _circleFadingArrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideCircleFadingArrowUp", ()=>(0, _circleFadingArrowUpJsDefault.default));
parcelHelpers.export(exports, "CircleFadingPlus", ()=>(0, _circleFadingPlusJsDefault.default));
parcelHelpers.export(exports, "CircleFadingPlusIcon", ()=>(0, _circleFadingPlusJsDefault.default));
parcelHelpers.export(exports, "LucideCircleFadingPlus", ()=>(0, _circleFadingPlusJsDefault.default));
parcelHelpers.export(exports, "CircleOff", ()=>(0, _circleOffJsDefault.default));
parcelHelpers.export(exports, "CircleOffIcon", ()=>(0, _circleOffJsDefault.default));
parcelHelpers.export(exports, "LucideCircleOff", ()=>(0, _circleOffJsDefault.default));
parcelHelpers.export(exports, "CirclePoundSterling", ()=>(0, _circlePoundSterlingJsDefault.default));
parcelHelpers.export(exports, "CirclePoundSterlingIcon", ()=>(0, _circlePoundSterlingJsDefault.default));
parcelHelpers.export(exports, "LucideCirclePoundSterling", ()=>(0, _circlePoundSterlingJsDefault.default));
parcelHelpers.export(exports, "CircleSlash", ()=>(0, _circleSlashJsDefault.default));
parcelHelpers.export(exports, "CircleSlashIcon", ()=>(0, _circleSlashJsDefault.default));
parcelHelpers.export(exports, "LucideCircleSlash", ()=>(0, _circleSlashJsDefault.default));
parcelHelpers.export(exports, "CircleSmall", ()=>(0, _circleSmallJsDefault.default));
parcelHelpers.export(exports, "CircleSmallIcon", ()=>(0, _circleSmallJsDefault.default));
parcelHelpers.export(exports, "LucideCircleSmall", ()=>(0, _circleSmallJsDefault.default));
parcelHelpers.export(exports, "Circle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "CircleIcon", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "LucideCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "CircuitBoard", ()=>(0, _circuitBoardJsDefault.default));
parcelHelpers.export(exports, "CircuitBoardIcon", ()=>(0, _circuitBoardJsDefault.default));
parcelHelpers.export(exports, "LucideCircuitBoard", ()=>(0, _circuitBoardJsDefault.default));
parcelHelpers.export(exports, "Citrus", ()=>(0, _citrusJsDefault.default));
parcelHelpers.export(exports, "CitrusIcon", ()=>(0, _citrusJsDefault.default));
parcelHelpers.export(exports, "LucideCitrus", ()=>(0, _citrusJsDefault.default));
parcelHelpers.export(exports, "Clapperboard", ()=>(0, _clapperboardJsDefault.default));
parcelHelpers.export(exports, "ClapperboardIcon", ()=>(0, _clapperboardJsDefault.default));
parcelHelpers.export(exports, "LucideClapperboard", ()=>(0, _clapperboardJsDefault.default));
parcelHelpers.export(exports, "ClipboardCheck", ()=>(0, _clipboardCheckJsDefault.default));
parcelHelpers.export(exports, "ClipboardCheckIcon", ()=>(0, _clipboardCheckJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardCheck", ()=>(0, _clipboardCheckJsDefault.default));
parcelHelpers.export(exports, "ClipboardCopy", ()=>(0, _clipboardCopyJsDefault.default));
parcelHelpers.export(exports, "ClipboardCopyIcon", ()=>(0, _clipboardCopyJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardCopy", ()=>(0, _clipboardCopyJsDefault.default));
parcelHelpers.export(exports, "ClipboardList", ()=>(0, _clipboardListJsDefault.default));
parcelHelpers.export(exports, "ClipboardListIcon", ()=>(0, _clipboardListJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardList", ()=>(0, _clipboardListJsDefault.default));
parcelHelpers.export(exports, "ClipboardMinus", ()=>(0, _clipboardMinusJsDefault.default));
parcelHelpers.export(exports, "ClipboardMinusIcon", ()=>(0, _clipboardMinusJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardMinus", ()=>(0, _clipboardMinusJsDefault.default));
parcelHelpers.export(exports, "ClipboardPaste", ()=>(0, _clipboardPasteJsDefault.default));
parcelHelpers.export(exports, "ClipboardPasteIcon", ()=>(0, _clipboardPasteJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardPaste", ()=>(0, _clipboardPasteJsDefault.default));
parcelHelpers.export(exports, "ClipboardPlus", ()=>(0, _clipboardPlusJsDefault.default));
parcelHelpers.export(exports, "ClipboardPlusIcon", ()=>(0, _clipboardPlusJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardPlus", ()=>(0, _clipboardPlusJsDefault.default));
parcelHelpers.export(exports, "ClipboardType", ()=>(0, _clipboardTypeJsDefault.default));
parcelHelpers.export(exports, "ClipboardTypeIcon", ()=>(0, _clipboardTypeJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardType", ()=>(0, _clipboardTypeJsDefault.default));
parcelHelpers.export(exports, "ClipboardX", ()=>(0, _clipboardXJsDefault.default));
parcelHelpers.export(exports, "ClipboardXIcon", ()=>(0, _clipboardXJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardX", ()=>(0, _clipboardXJsDefault.default));
parcelHelpers.export(exports, "Clipboard", ()=>(0, _clipboardJsDefault.default));
parcelHelpers.export(exports, "ClipboardIcon", ()=>(0, _clipboardJsDefault.default));
parcelHelpers.export(exports, "LucideClipboard", ()=>(0, _clipboardJsDefault.default));
parcelHelpers.export(exports, "Clock1", ()=>(0, _clock1JsDefault.default));
parcelHelpers.export(exports, "Clock1Icon", ()=>(0, _clock1JsDefault.default));
parcelHelpers.export(exports, "LucideClock1", ()=>(0, _clock1JsDefault.default));
parcelHelpers.export(exports, "Clock10", ()=>(0, _clock10JsDefault.default));
parcelHelpers.export(exports, "Clock10Icon", ()=>(0, _clock10JsDefault.default));
parcelHelpers.export(exports, "LucideClock10", ()=>(0, _clock10JsDefault.default));
parcelHelpers.export(exports, "Clock11", ()=>(0, _clock11JsDefault.default));
parcelHelpers.export(exports, "Clock11Icon", ()=>(0, _clock11JsDefault.default));
parcelHelpers.export(exports, "LucideClock11", ()=>(0, _clock11JsDefault.default));
parcelHelpers.export(exports, "Clock12", ()=>(0, _clock12JsDefault.default));
parcelHelpers.export(exports, "Clock12Icon", ()=>(0, _clock12JsDefault.default));
parcelHelpers.export(exports, "LucideClock12", ()=>(0, _clock12JsDefault.default));
parcelHelpers.export(exports, "Clock2", ()=>(0, _clock2JsDefault.default));
parcelHelpers.export(exports, "Clock2Icon", ()=>(0, _clock2JsDefault.default));
parcelHelpers.export(exports, "LucideClock2", ()=>(0, _clock2JsDefault.default));
parcelHelpers.export(exports, "Clock4", ()=>(0, _clock4JsDefault.default));
parcelHelpers.export(exports, "Clock4Icon", ()=>(0, _clock4JsDefault.default));
parcelHelpers.export(exports, "LucideClock4", ()=>(0, _clock4JsDefault.default));
parcelHelpers.export(exports, "Clock3", ()=>(0, _clock3JsDefault.default));
parcelHelpers.export(exports, "Clock3Icon", ()=>(0, _clock3JsDefault.default));
parcelHelpers.export(exports, "LucideClock3", ()=>(0, _clock3JsDefault.default));
parcelHelpers.export(exports, "Clock5", ()=>(0, _clock5JsDefault.default));
parcelHelpers.export(exports, "Clock5Icon", ()=>(0, _clock5JsDefault.default));
parcelHelpers.export(exports, "LucideClock5", ()=>(0, _clock5JsDefault.default));
parcelHelpers.export(exports, "Clock6", ()=>(0, _clock6JsDefault.default));
parcelHelpers.export(exports, "Clock6Icon", ()=>(0, _clock6JsDefault.default));
parcelHelpers.export(exports, "LucideClock6", ()=>(0, _clock6JsDefault.default));
parcelHelpers.export(exports, "Clock7", ()=>(0, _clock7JsDefault.default));
parcelHelpers.export(exports, "Clock7Icon", ()=>(0, _clock7JsDefault.default));
parcelHelpers.export(exports, "LucideClock7", ()=>(0, _clock7JsDefault.default));
parcelHelpers.export(exports, "Clock8", ()=>(0, _clock8JsDefault.default));
parcelHelpers.export(exports, "Clock8Icon", ()=>(0, _clock8JsDefault.default));
parcelHelpers.export(exports, "LucideClock8", ()=>(0, _clock8JsDefault.default));
parcelHelpers.export(exports, "ClockAlert", ()=>(0, _clockAlertJsDefault.default));
parcelHelpers.export(exports, "ClockAlertIcon", ()=>(0, _clockAlertJsDefault.default));
parcelHelpers.export(exports, "LucideClockAlert", ()=>(0, _clockAlertJsDefault.default));
parcelHelpers.export(exports, "Clock9", ()=>(0, _clock9JsDefault.default));
parcelHelpers.export(exports, "Clock9Icon", ()=>(0, _clock9JsDefault.default));
parcelHelpers.export(exports, "LucideClock9", ()=>(0, _clock9JsDefault.default));
parcelHelpers.export(exports, "ClockArrowDown", ()=>(0, _clockArrowDownJsDefault.default));
parcelHelpers.export(exports, "ClockArrowDownIcon", ()=>(0, _clockArrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideClockArrowDown", ()=>(0, _clockArrowDownJsDefault.default));
parcelHelpers.export(exports, "ClockArrowUp", ()=>(0, _clockArrowUpJsDefault.default));
parcelHelpers.export(exports, "ClockArrowUpIcon", ()=>(0, _clockArrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideClockArrowUp", ()=>(0, _clockArrowUpJsDefault.default));
parcelHelpers.export(exports, "ClockFading", ()=>(0, _clockFadingJsDefault.default));
parcelHelpers.export(exports, "ClockFadingIcon", ()=>(0, _clockFadingJsDefault.default));
parcelHelpers.export(exports, "LucideClockFading", ()=>(0, _clockFadingJsDefault.default));
parcelHelpers.export(exports, "ClockPlus", ()=>(0, _clockPlusJsDefault.default));
parcelHelpers.export(exports, "ClockPlusIcon", ()=>(0, _clockPlusJsDefault.default));
parcelHelpers.export(exports, "LucideClockPlus", ()=>(0, _clockPlusJsDefault.default));
parcelHelpers.export(exports, "Clock", ()=>(0, _clockJsDefault.default));
parcelHelpers.export(exports, "ClockIcon", ()=>(0, _clockJsDefault.default));
parcelHelpers.export(exports, "LucideClock", ()=>(0, _clockJsDefault.default));
parcelHelpers.export(exports, "CloudAlert", ()=>(0, _cloudAlertJsDefault.default));
parcelHelpers.export(exports, "CloudAlertIcon", ()=>(0, _cloudAlertJsDefault.default));
parcelHelpers.export(exports, "LucideCloudAlert", ()=>(0, _cloudAlertJsDefault.default));
parcelHelpers.export(exports, "CloudCheck", ()=>(0, _cloudCheckJsDefault.default));
parcelHelpers.export(exports, "CloudCheckIcon", ()=>(0, _cloudCheckJsDefault.default));
parcelHelpers.export(exports, "LucideCloudCheck", ()=>(0, _cloudCheckJsDefault.default));
parcelHelpers.export(exports, "CloudCog", ()=>(0, _cloudCogJsDefault.default));
parcelHelpers.export(exports, "CloudCogIcon", ()=>(0, _cloudCogJsDefault.default));
parcelHelpers.export(exports, "LucideCloudCog", ()=>(0, _cloudCogJsDefault.default));
parcelHelpers.export(exports, "CloudDrizzle", ()=>(0, _cloudDrizzleJsDefault.default));
parcelHelpers.export(exports, "CloudDrizzleIcon", ()=>(0, _cloudDrizzleJsDefault.default));
parcelHelpers.export(exports, "LucideCloudDrizzle", ()=>(0, _cloudDrizzleJsDefault.default));
parcelHelpers.export(exports, "CloudFog", ()=>(0, _cloudFogJsDefault.default));
parcelHelpers.export(exports, "CloudFogIcon", ()=>(0, _cloudFogJsDefault.default));
parcelHelpers.export(exports, "LucideCloudFog", ()=>(0, _cloudFogJsDefault.default));
parcelHelpers.export(exports, "CloudHail", ()=>(0, _cloudHailJsDefault.default));
parcelHelpers.export(exports, "CloudHailIcon", ()=>(0, _cloudHailJsDefault.default));
parcelHelpers.export(exports, "LucideCloudHail", ()=>(0, _cloudHailJsDefault.default));
parcelHelpers.export(exports, "CloudMoonRain", ()=>(0, _cloudMoonRainJsDefault.default));
parcelHelpers.export(exports, "CloudMoonRainIcon", ()=>(0, _cloudMoonRainJsDefault.default));
parcelHelpers.export(exports, "LucideCloudMoonRain", ()=>(0, _cloudMoonRainJsDefault.default));
parcelHelpers.export(exports, "CloudLightning", ()=>(0, _cloudLightningJsDefault.default));
parcelHelpers.export(exports, "CloudLightningIcon", ()=>(0, _cloudLightningJsDefault.default));
parcelHelpers.export(exports, "LucideCloudLightning", ()=>(0, _cloudLightningJsDefault.default));
parcelHelpers.export(exports, "CloudMoon", ()=>(0, _cloudMoonJsDefault.default));
parcelHelpers.export(exports, "CloudMoonIcon", ()=>(0, _cloudMoonJsDefault.default));
parcelHelpers.export(exports, "LucideCloudMoon", ()=>(0, _cloudMoonJsDefault.default));
parcelHelpers.export(exports, "CloudOff", ()=>(0, _cloudOffJsDefault.default));
parcelHelpers.export(exports, "CloudOffIcon", ()=>(0, _cloudOffJsDefault.default));
parcelHelpers.export(exports, "LucideCloudOff", ()=>(0, _cloudOffJsDefault.default));
parcelHelpers.export(exports, "CloudRainWind", ()=>(0, _cloudRainWindJsDefault.default));
parcelHelpers.export(exports, "CloudRainWindIcon", ()=>(0, _cloudRainWindJsDefault.default));
parcelHelpers.export(exports, "LucideCloudRainWind", ()=>(0, _cloudRainWindJsDefault.default));
parcelHelpers.export(exports, "CloudRain", ()=>(0, _cloudRainJsDefault.default));
parcelHelpers.export(exports, "CloudRainIcon", ()=>(0, _cloudRainJsDefault.default));
parcelHelpers.export(exports, "LucideCloudRain", ()=>(0, _cloudRainJsDefault.default));
parcelHelpers.export(exports, "CloudSnow", ()=>(0, _cloudSnowJsDefault.default));
parcelHelpers.export(exports, "CloudSnowIcon", ()=>(0, _cloudSnowJsDefault.default));
parcelHelpers.export(exports, "LucideCloudSnow", ()=>(0, _cloudSnowJsDefault.default));
parcelHelpers.export(exports, "CloudSunRain", ()=>(0, _cloudSunRainJsDefault.default));
parcelHelpers.export(exports, "CloudSunRainIcon", ()=>(0, _cloudSunRainJsDefault.default));
parcelHelpers.export(exports, "LucideCloudSunRain", ()=>(0, _cloudSunRainJsDefault.default));
parcelHelpers.export(exports, "CloudSun", ()=>(0, _cloudSunJsDefault.default));
parcelHelpers.export(exports, "CloudSunIcon", ()=>(0, _cloudSunJsDefault.default));
parcelHelpers.export(exports, "LucideCloudSun", ()=>(0, _cloudSunJsDefault.default));
parcelHelpers.export(exports, "Cloud", ()=>(0, _cloudJsDefault.default));
parcelHelpers.export(exports, "CloudIcon", ()=>(0, _cloudJsDefault.default));
parcelHelpers.export(exports, "LucideCloud", ()=>(0, _cloudJsDefault.default));
parcelHelpers.export(exports, "Cloudy", ()=>(0, _cloudyJsDefault.default));
parcelHelpers.export(exports, "CloudyIcon", ()=>(0, _cloudyJsDefault.default));
parcelHelpers.export(exports, "LucideCloudy", ()=>(0, _cloudyJsDefault.default));
parcelHelpers.export(exports, "Clover", ()=>(0, _cloverJsDefault.default));
parcelHelpers.export(exports, "CloverIcon", ()=>(0, _cloverJsDefault.default));
parcelHelpers.export(exports, "LucideClover", ()=>(0, _cloverJsDefault.default));
parcelHelpers.export(exports, "Club", ()=>(0, _clubJsDefault.default));
parcelHelpers.export(exports, "ClubIcon", ()=>(0, _clubJsDefault.default));
parcelHelpers.export(exports, "LucideClub", ()=>(0, _clubJsDefault.default));
parcelHelpers.export(exports, "Code", ()=>(0, _codeJsDefault.default));
parcelHelpers.export(exports, "CodeIcon", ()=>(0, _codeJsDefault.default));
parcelHelpers.export(exports, "LucideCode", ()=>(0, _codeJsDefault.default));
parcelHelpers.export(exports, "Codepen", ()=>(0, _codepenJsDefault.default));
parcelHelpers.export(exports, "CodepenIcon", ()=>(0, _codepenJsDefault.default));
parcelHelpers.export(exports, "LucideCodepen", ()=>(0, _codepenJsDefault.default));
parcelHelpers.export(exports, "Codesandbox", ()=>(0, _codesandboxJsDefault.default));
parcelHelpers.export(exports, "CodesandboxIcon", ()=>(0, _codesandboxJsDefault.default));
parcelHelpers.export(exports, "LucideCodesandbox", ()=>(0, _codesandboxJsDefault.default));
parcelHelpers.export(exports, "Coffee", ()=>(0, _coffeeJsDefault.default));
parcelHelpers.export(exports, "CoffeeIcon", ()=>(0, _coffeeJsDefault.default));
parcelHelpers.export(exports, "LucideCoffee", ()=>(0, _coffeeJsDefault.default));
parcelHelpers.export(exports, "Cog", ()=>(0, _cogJsDefault.default));
parcelHelpers.export(exports, "CogIcon", ()=>(0, _cogJsDefault.default));
parcelHelpers.export(exports, "LucideCog", ()=>(0, _cogJsDefault.default));
parcelHelpers.export(exports, "Coins", ()=>(0, _coinsJsDefault.default));
parcelHelpers.export(exports, "CoinsIcon", ()=>(0, _coinsJsDefault.default));
parcelHelpers.export(exports, "LucideCoins", ()=>(0, _coinsJsDefault.default));
parcelHelpers.export(exports, "Columns4", ()=>(0, _columns4JsDefault.default));
parcelHelpers.export(exports, "Columns4Icon", ()=>(0, _columns4JsDefault.default));
parcelHelpers.export(exports, "LucideColumns4", ()=>(0, _columns4JsDefault.default));
parcelHelpers.export(exports, "Combine", ()=>(0, _combineJsDefault.default));
parcelHelpers.export(exports, "CombineIcon", ()=>(0, _combineJsDefault.default));
parcelHelpers.export(exports, "LucideCombine", ()=>(0, _combineJsDefault.default));
parcelHelpers.export(exports, "Command", ()=>(0, _commandJsDefault.default));
parcelHelpers.export(exports, "CommandIcon", ()=>(0, _commandJsDefault.default));
parcelHelpers.export(exports, "LucideCommand", ()=>(0, _commandJsDefault.default));
parcelHelpers.export(exports, "Compass", ()=>(0, _compassJsDefault.default));
parcelHelpers.export(exports, "CompassIcon", ()=>(0, _compassJsDefault.default));
parcelHelpers.export(exports, "LucideCompass", ()=>(0, _compassJsDefault.default));
parcelHelpers.export(exports, "Component", ()=>(0, _componentJsDefault.default));
parcelHelpers.export(exports, "ComponentIcon", ()=>(0, _componentJsDefault.default));
parcelHelpers.export(exports, "LucideComponent", ()=>(0, _componentJsDefault.default));
parcelHelpers.export(exports, "ConciergeBell", ()=>(0, _conciergeBellJsDefault.default));
parcelHelpers.export(exports, "ConciergeBellIcon", ()=>(0, _conciergeBellJsDefault.default));
parcelHelpers.export(exports, "LucideConciergeBell", ()=>(0, _conciergeBellJsDefault.default));
parcelHelpers.export(exports, "Computer", ()=>(0, _computerJsDefault.default));
parcelHelpers.export(exports, "ComputerIcon", ()=>(0, _computerJsDefault.default));
parcelHelpers.export(exports, "LucideComputer", ()=>(0, _computerJsDefault.default));
parcelHelpers.export(exports, "Cone", ()=>(0, _coneJsDefault.default));
parcelHelpers.export(exports, "ConeIcon", ()=>(0, _coneJsDefault.default));
parcelHelpers.export(exports, "LucideCone", ()=>(0, _coneJsDefault.default));
parcelHelpers.export(exports, "Construction", ()=>(0, _constructionJsDefault.default));
parcelHelpers.export(exports, "ConstructionIcon", ()=>(0, _constructionJsDefault.default));
parcelHelpers.export(exports, "LucideConstruction", ()=>(0, _constructionJsDefault.default));
parcelHelpers.export(exports, "Contact", ()=>(0, _contactJsDefault.default));
parcelHelpers.export(exports, "ContactIcon", ()=>(0, _contactJsDefault.default));
parcelHelpers.export(exports, "LucideContact", ()=>(0, _contactJsDefault.default));
parcelHelpers.export(exports, "Container", ()=>(0, _containerJsDefault.default));
parcelHelpers.export(exports, "ContainerIcon", ()=>(0, _containerJsDefault.default));
parcelHelpers.export(exports, "LucideContainer", ()=>(0, _containerJsDefault.default));
parcelHelpers.export(exports, "Contrast", ()=>(0, _contrastJsDefault.default));
parcelHelpers.export(exports, "ContrastIcon", ()=>(0, _contrastJsDefault.default));
parcelHelpers.export(exports, "LucideContrast", ()=>(0, _contrastJsDefault.default));
parcelHelpers.export(exports, "Cookie", ()=>(0, _cookieJsDefault.default));
parcelHelpers.export(exports, "CookieIcon", ()=>(0, _cookieJsDefault.default));
parcelHelpers.export(exports, "LucideCookie", ()=>(0, _cookieJsDefault.default));
parcelHelpers.export(exports, "CookingPot", ()=>(0, _cookingPotJsDefault.default));
parcelHelpers.export(exports, "CookingPotIcon", ()=>(0, _cookingPotJsDefault.default));
parcelHelpers.export(exports, "LucideCookingPot", ()=>(0, _cookingPotJsDefault.default));
parcelHelpers.export(exports, "CopyCheck", ()=>(0, _copyCheckJsDefault.default));
parcelHelpers.export(exports, "CopyCheckIcon", ()=>(0, _copyCheckJsDefault.default));
parcelHelpers.export(exports, "LucideCopyCheck", ()=>(0, _copyCheckJsDefault.default));
parcelHelpers.export(exports, "CopyMinus", ()=>(0, _copyMinusJsDefault.default));
parcelHelpers.export(exports, "CopyMinusIcon", ()=>(0, _copyMinusJsDefault.default));
parcelHelpers.export(exports, "LucideCopyMinus", ()=>(0, _copyMinusJsDefault.default));
parcelHelpers.export(exports, "CopyPlus", ()=>(0, _copyPlusJsDefault.default));
parcelHelpers.export(exports, "CopyPlusIcon", ()=>(0, _copyPlusJsDefault.default));
parcelHelpers.export(exports, "LucideCopyPlus", ()=>(0, _copyPlusJsDefault.default));
parcelHelpers.export(exports, "CopySlash", ()=>(0, _copySlashJsDefault.default));
parcelHelpers.export(exports, "CopySlashIcon", ()=>(0, _copySlashJsDefault.default));
parcelHelpers.export(exports, "LucideCopySlash", ()=>(0, _copySlashJsDefault.default));
parcelHelpers.export(exports, "CopyX", ()=>(0, _copyXJsDefault.default));
parcelHelpers.export(exports, "CopyXIcon", ()=>(0, _copyXJsDefault.default));
parcelHelpers.export(exports, "LucideCopyX", ()=>(0, _copyXJsDefault.default));
parcelHelpers.export(exports, "Copy", ()=>(0, _copyJsDefault.default));
parcelHelpers.export(exports, "CopyIcon", ()=>(0, _copyJsDefault.default));
parcelHelpers.export(exports, "LucideCopy", ()=>(0, _copyJsDefault.default));
parcelHelpers.export(exports, "Copyright", ()=>(0, _copyrightJsDefault.default));
parcelHelpers.export(exports, "CopyrightIcon", ()=>(0, _copyrightJsDefault.default));
parcelHelpers.export(exports, "LucideCopyright", ()=>(0, _copyrightJsDefault.default));
parcelHelpers.export(exports, "Copyleft", ()=>(0, _copyleftJsDefault.default));
parcelHelpers.export(exports, "CopyleftIcon", ()=>(0, _copyleftJsDefault.default));
parcelHelpers.export(exports, "LucideCopyleft", ()=>(0, _copyleftJsDefault.default));
parcelHelpers.export(exports, "CornerDownLeft", ()=>(0, _cornerDownLeftJsDefault.default));
parcelHelpers.export(exports, "CornerDownLeftIcon", ()=>(0, _cornerDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideCornerDownLeft", ()=>(0, _cornerDownLeftJsDefault.default));
parcelHelpers.export(exports, "CornerDownRight", ()=>(0, _cornerDownRightJsDefault.default));
parcelHelpers.export(exports, "CornerDownRightIcon", ()=>(0, _cornerDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideCornerDownRight", ()=>(0, _cornerDownRightJsDefault.default));
parcelHelpers.export(exports, "CornerLeftDown", ()=>(0, _cornerLeftDownJsDefault.default));
parcelHelpers.export(exports, "CornerLeftDownIcon", ()=>(0, _cornerLeftDownJsDefault.default));
parcelHelpers.export(exports, "LucideCornerLeftDown", ()=>(0, _cornerLeftDownJsDefault.default));
parcelHelpers.export(exports, "CornerLeftUp", ()=>(0, _cornerLeftUpJsDefault.default));
parcelHelpers.export(exports, "CornerLeftUpIcon", ()=>(0, _cornerLeftUpJsDefault.default));
parcelHelpers.export(exports, "LucideCornerLeftUp", ()=>(0, _cornerLeftUpJsDefault.default));
parcelHelpers.export(exports, "CornerRightUp", ()=>(0, _cornerRightUpJsDefault.default));
parcelHelpers.export(exports, "CornerRightUpIcon", ()=>(0, _cornerRightUpJsDefault.default));
parcelHelpers.export(exports, "LucideCornerRightUp", ()=>(0, _cornerRightUpJsDefault.default));
parcelHelpers.export(exports, "CornerUpLeft", ()=>(0, _cornerUpLeftJsDefault.default));
parcelHelpers.export(exports, "CornerUpLeftIcon", ()=>(0, _cornerUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideCornerUpLeft", ()=>(0, _cornerUpLeftJsDefault.default));
parcelHelpers.export(exports, "CornerRightDown", ()=>(0, _cornerRightDownJsDefault.default));
parcelHelpers.export(exports, "CornerRightDownIcon", ()=>(0, _cornerRightDownJsDefault.default));
parcelHelpers.export(exports, "LucideCornerRightDown", ()=>(0, _cornerRightDownJsDefault.default));
parcelHelpers.export(exports, "CornerUpRight", ()=>(0, _cornerUpRightJsDefault.default));
parcelHelpers.export(exports, "CornerUpRightIcon", ()=>(0, _cornerUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideCornerUpRight", ()=>(0, _cornerUpRightJsDefault.default));
parcelHelpers.export(exports, "CreativeCommons", ()=>(0, _creativeCommonsJsDefault.default));
parcelHelpers.export(exports, "CreativeCommonsIcon", ()=>(0, _creativeCommonsJsDefault.default));
parcelHelpers.export(exports, "LucideCreativeCommons", ()=>(0, _creativeCommonsJsDefault.default));
parcelHelpers.export(exports, "Cpu", ()=>(0, _cpuJsDefault.default));
parcelHelpers.export(exports, "CpuIcon", ()=>(0, _cpuJsDefault.default));
parcelHelpers.export(exports, "LucideCpu", ()=>(0, _cpuJsDefault.default));
parcelHelpers.export(exports, "Croissant", ()=>(0, _croissantJsDefault.default));
parcelHelpers.export(exports, "CroissantIcon", ()=>(0, _croissantJsDefault.default));
parcelHelpers.export(exports, "LucideCroissant", ()=>(0, _croissantJsDefault.default));
parcelHelpers.export(exports, "CreditCard", ()=>(0, _creditCardJsDefault.default));
parcelHelpers.export(exports, "CreditCardIcon", ()=>(0, _creditCardJsDefault.default));
parcelHelpers.export(exports, "LucideCreditCard", ()=>(0, _creditCardJsDefault.default));
parcelHelpers.export(exports, "Crop", ()=>(0, _cropJsDefault.default));
parcelHelpers.export(exports, "CropIcon", ()=>(0, _cropJsDefault.default));
parcelHelpers.export(exports, "LucideCrop", ()=>(0, _cropJsDefault.default));
parcelHelpers.export(exports, "Cross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "CrossIcon", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "LucideCross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "Crosshair", ()=>(0, _crosshairJsDefault.default));
parcelHelpers.export(exports, "CrosshairIcon", ()=>(0, _crosshairJsDefault.default));
parcelHelpers.export(exports, "LucideCrosshair", ()=>(0, _crosshairJsDefault.default));
parcelHelpers.export(exports, "Crown", ()=>(0, _crownJsDefault.default));
parcelHelpers.export(exports, "CrownIcon", ()=>(0, _crownJsDefault.default));
parcelHelpers.export(exports, "LucideCrown", ()=>(0, _crownJsDefault.default));
parcelHelpers.export(exports, "Cuboid", ()=>(0, _cuboidJsDefault.default));
parcelHelpers.export(exports, "CuboidIcon", ()=>(0, _cuboidJsDefault.default));
parcelHelpers.export(exports, "LucideCuboid", ()=>(0, _cuboidJsDefault.default));
parcelHelpers.export(exports, "CupSoda", ()=>(0, _cupSodaJsDefault.default));
parcelHelpers.export(exports, "CupSodaIcon", ()=>(0, _cupSodaJsDefault.default));
parcelHelpers.export(exports, "LucideCupSoda", ()=>(0, _cupSodaJsDefault.default));
parcelHelpers.export(exports, "Currency", ()=>(0, _currencyJsDefault.default));
parcelHelpers.export(exports, "CurrencyIcon", ()=>(0, _currencyJsDefault.default));
parcelHelpers.export(exports, "LucideCurrency", ()=>(0, _currencyJsDefault.default));
parcelHelpers.export(exports, "Cylinder", ()=>(0, _cylinderJsDefault.default));
parcelHelpers.export(exports, "CylinderIcon", ()=>(0, _cylinderJsDefault.default));
parcelHelpers.export(exports, "LucideCylinder", ()=>(0, _cylinderJsDefault.default));
parcelHelpers.export(exports, "Dam", ()=>(0, _damJsDefault.default));
parcelHelpers.export(exports, "DamIcon", ()=>(0, _damJsDefault.default));
parcelHelpers.export(exports, "LucideDam", ()=>(0, _damJsDefault.default));
parcelHelpers.export(exports, "DatabaseBackup", ()=>(0, _databaseBackupJsDefault.default));
parcelHelpers.export(exports, "DatabaseBackupIcon", ()=>(0, _databaseBackupJsDefault.default));
parcelHelpers.export(exports, "LucideDatabaseBackup", ()=>(0, _databaseBackupJsDefault.default));
parcelHelpers.export(exports, "DatabaseZap", ()=>(0, _databaseZapJsDefault.default));
parcelHelpers.export(exports, "DatabaseZapIcon", ()=>(0, _databaseZapJsDefault.default));
parcelHelpers.export(exports, "LucideDatabaseZap", ()=>(0, _databaseZapJsDefault.default));
parcelHelpers.export(exports, "Database", ()=>(0, _databaseJsDefault.default));
parcelHelpers.export(exports, "DatabaseIcon", ()=>(0, _databaseJsDefault.default));
parcelHelpers.export(exports, "LucideDatabase", ()=>(0, _databaseJsDefault.default));
parcelHelpers.export(exports, "DecimalsArrowLeft", ()=>(0, _decimalsArrowLeftJsDefault.default));
parcelHelpers.export(exports, "DecimalsArrowLeftIcon", ()=>(0, _decimalsArrowLeftJsDefault.default));
parcelHelpers.export(exports, "LucideDecimalsArrowLeft", ()=>(0, _decimalsArrowLeftJsDefault.default));
parcelHelpers.export(exports, "DecimalsArrowRight", ()=>(0, _decimalsArrowRightJsDefault.default));
parcelHelpers.export(exports, "DecimalsArrowRightIcon", ()=>(0, _decimalsArrowRightJsDefault.default));
parcelHelpers.export(exports, "LucideDecimalsArrowRight", ()=>(0, _decimalsArrowRightJsDefault.default));
parcelHelpers.export(exports, "Delete", ()=>(0, _deleteJsDefault.default));
parcelHelpers.export(exports, "DeleteIcon", ()=>(0, _deleteJsDefault.default));
parcelHelpers.export(exports, "LucideDelete", ()=>(0, _deleteJsDefault.default));
parcelHelpers.export(exports, "Dessert", ()=>(0, _dessertJsDefault.default));
parcelHelpers.export(exports, "DessertIcon", ()=>(0, _dessertJsDefault.default));
parcelHelpers.export(exports, "LucideDessert", ()=>(0, _dessertJsDefault.default));
parcelHelpers.export(exports, "Diameter", ()=>(0, _diameterJsDefault.default));
parcelHelpers.export(exports, "DiameterIcon", ()=>(0, _diameterJsDefault.default));
parcelHelpers.export(exports, "LucideDiameter", ()=>(0, _diameterJsDefault.default));
parcelHelpers.export(exports, "DiamondMinus", ()=>(0, _diamondMinusJsDefault.default));
parcelHelpers.export(exports, "DiamondMinusIcon", ()=>(0, _diamondMinusJsDefault.default));
parcelHelpers.export(exports, "LucideDiamondMinus", ()=>(0, _diamondMinusJsDefault.default));
parcelHelpers.export(exports, "Diamond", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "DiamondIcon", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "LucideDiamond", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "DiamondPlus", ()=>(0, _diamondPlusJsDefault.default));
parcelHelpers.export(exports, "DiamondPlusIcon", ()=>(0, _diamondPlusJsDefault.default));
parcelHelpers.export(exports, "LucideDiamondPlus", ()=>(0, _diamondPlusJsDefault.default));
parcelHelpers.export(exports, "Dice1", ()=>(0, _dice1JsDefault.default));
parcelHelpers.export(exports, "Dice1Icon", ()=>(0, _dice1JsDefault.default));
parcelHelpers.export(exports, "LucideDice1", ()=>(0, _dice1JsDefault.default));
parcelHelpers.export(exports, "Dice2", ()=>(0, _dice2JsDefault.default));
parcelHelpers.export(exports, "Dice2Icon", ()=>(0, _dice2JsDefault.default));
parcelHelpers.export(exports, "LucideDice2", ()=>(0, _dice2JsDefault.default));
parcelHelpers.export(exports, "Dice3", ()=>(0, _dice3JsDefault.default));
parcelHelpers.export(exports, "Dice3Icon", ()=>(0, _dice3JsDefault.default));
parcelHelpers.export(exports, "LucideDice3", ()=>(0, _dice3JsDefault.default));
parcelHelpers.export(exports, "Dice4", ()=>(0, _dice4JsDefault.default));
parcelHelpers.export(exports, "Dice4Icon", ()=>(0, _dice4JsDefault.default));
parcelHelpers.export(exports, "LucideDice4", ()=>(0, _dice4JsDefault.default));
parcelHelpers.export(exports, "Dice5", ()=>(0, _dice5JsDefault.default));
parcelHelpers.export(exports, "Dice5Icon", ()=>(0, _dice5JsDefault.default));
parcelHelpers.export(exports, "LucideDice5", ()=>(0, _dice5JsDefault.default));
parcelHelpers.export(exports, "Dice6", ()=>(0, _dice6JsDefault.default));
parcelHelpers.export(exports, "Dice6Icon", ()=>(0, _dice6JsDefault.default));
parcelHelpers.export(exports, "LucideDice6", ()=>(0, _dice6JsDefault.default));
parcelHelpers.export(exports, "Dices", ()=>(0, _dicesJsDefault.default));
parcelHelpers.export(exports, "DicesIcon", ()=>(0, _dicesJsDefault.default));
parcelHelpers.export(exports, "LucideDices", ()=>(0, _dicesJsDefault.default));
parcelHelpers.export(exports, "Diff", ()=>(0, _diffJsDefault.default));
parcelHelpers.export(exports, "DiffIcon", ()=>(0, _diffJsDefault.default));
parcelHelpers.export(exports, "LucideDiff", ()=>(0, _diffJsDefault.default));
parcelHelpers.export(exports, "Disc2", ()=>(0, _disc2JsDefault.default));
parcelHelpers.export(exports, "Disc2Icon", ()=>(0, _disc2JsDefault.default));
parcelHelpers.export(exports, "LucideDisc2", ()=>(0, _disc2JsDefault.default));
parcelHelpers.export(exports, "Disc3", ()=>(0, _disc3JsDefault.default));
parcelHelpers.export(exports, "Disc3Icon", ()=>(0, _disc3JsDefault.default));
parcelHelpers.export(exports, "LucideDisc3", ()=>(0, _disc3JsDefault.default));
parcelHelpers.export(exports, "DiscAlbum", ()=>(0, _discAlbumJsDefault.default));
parcelHelpers.export(exports, "DiscAlbumIcon", ()=>(0, _discAlbumJsDefault.default));
parcelHelpers.export(exports, "LucideDiscAlbum", ()=>(0, _discAlbumJsDefault.default));
parcelHelpers.export(exports, "Divide", ()=>(0, _divideJsDefault.default));
parcelHelpers.export(exports, "DivideIcon", ()=>(0, _divideJsDefault.default));
parcelHelpers.export(exports, "LucideDivide", ()=>(0, _divideJsDefault.default));
parcelHelpers.export(exports, "Disc", ()=>(0, _discJsDefault.default));
parcelHelpers.export(exports, "DiscIcon", ()=>(0, _discJsDefault.default));
parcelHelpers.export(exports, "LucideDisc", ()=>(0, _discJsDefault.default));
parcelHelpers.export(exports, "DnaOff", ()=>(0, _dnaOffJsDefault.default));
parcelHelpers.export(exports, "DnaOffIcon", ()=>(0, _dnaOffJsDefault.default));
parcelHelpers.export(exports, "LucideDnaOff", ()=>(0, _dnaOffJsDefault.default));
parcelHelpers.export(exports, "Dna", ()=>(0, _dnaJsDefault.default));
parcelHelpers.export(exports, "DnaIcon", ()=>(0, _dnaJsDefault.default));
parcelHelpers.export(exports, "LucideDna", ()=>(0, _dnaJsDefault.default));
parcelHelpers.export(exports, "Dock", ()=>(0, _dockJsDefault.default));
parcelHelpers.export(exports, "DockIcon", ()=>(0, _dockJsDefault.default));
parcelHelpers.export(exports, "LucideDock", ()=>(0, _dockJsDefault.default));
parcelHelpers.export(exports, "Dog", ()=>(0, _dogJsDefault.default));
parcelHelpers.export(exports, "DogIcon", ()=>(0, _dogJsDefault.default));
parcelHelpers.export(exports, "LucideDog", ()=>(0, _dogJsDefault.default));
parcelHelpers.export(exports, "DollarSign", ()=>(0, _dollarSignJsDefault.default));
parcelHelpers.export(exports, "DollarSignIcon", ()=>(0, _dollarSignJsDefault.default));
parcelHelpers.export(exports, "LucideDollarSign", ()=>(0, _dollarSignJsDefault.default));
parcelHelpers.export(exports, "Donut", ()=>(0, _donutJsDefault.default));
parcelHelpers.export(exports, "DonutIcon", ()=>(0, _donutJsDefault.default));
parcelHelpers.export(exports, "LucideDonut", ()=>(0, _donutJsDefault.default));
parcelHelpers.export(exports, "DoorClosedLocked", ()=>(0, _doorClosedLockedJsDefault.default));
parcelHelpers.export(exports, "DoorClosedLockedIcon", ()=>(0, _doorClosedLockedJsDefault.default));
parcelHelpers.export(exports, "LucideDoorClosedLocked", ()=>(0, _doorClosedLockedJsDefault.default));
parcelHelpers.export(exports, "DoorClosed", ()=>(0, _doorClosedJsDefault.default));
parcelHelpers.export(exports, "DoorClosedIcon", ()=>(0, _doorClosedJsDefault.default));
parcelHelpers.export(exports, "LucideDoorClosed", ()=>(0, _doorClosedJsDefault.default));
parcelHelpers.export(exports, "DoorOpen", ()=>(0, _doorOpenJsDefault.default));
parcelHelpers.export(exports, "DoorOpenIcon", ()=>(0, _doorOpenJsDefault.default));
parcelHelpers.export(exports, "LucideDoorOpen", ()=>(0, _doorOpenJsDefault.default));
parcelHelpers.export(exports, "Dot", ()=>(0, _dotJsDefault.default));
parcelHelpers.export(exports, "DotIcon", ()=>(0, _dotJsDefault.default));
parcelHelpers.export(exports, "LucideDot", ()=>(0, _dotJsDefault.default));
parcelHelpers.export(exports, "Download", ()=>(0, _downloadJsDefault.default));
parcelHelpers.export(exports, "DownloadIcon", ()=>(0, _downloadJsDefault.default));
parcelHelpers.export(exports, "LucideDownload", ()=>(0, _downloadJsDefault.default));
parcelHelpers.export(exports, "DraftingCompass", ()=>(0, _draftingCompassJsDefault.default));
parcelHelpers.export(exports, "DraftingCompassIcon", ()=>(0, _draftingCompassJsDefault.default));
parcelHelpers.export(exports, "LucideDraftingCompass", ()=>(0, _draftingCompassJsDefault.default));
parcelHelpers.export(exports, "Drama", ()=>(0, _dramaJsDefault.default));
parcelHelpers.export(exports, "DramaIcon", ()=>(0, _dramaJsDefault.default));
parcelHelpers.export(exports, "LucideDrama", ()=>(0, _dramaJsDefault.default));
parcelHelpers.export(exports, "Dribbble", ()=>(0, _dribbbleJsDefault.default));
parcelHelpers.export(exports, "DribbbleIcon", ()=>(0, _dribbbleJsDefault.default));
parcelHelpers.export(exports, "LucideDribbble", ()=>(0, _dribbbleJsDefault.default));
parcelHelpers.export(exports, "DropletOff", ()=>(0, _dropletOffJsDefault.default));
parcelHelpers.export(exports, "DropletOffIcon", ()=>(0, _dropletOffJsDefault.default));
parcelHelpers.export(exports, "LucideDropletOff", ()=>(0, _dropletOffJsDefault.default));
parcelHelpers.export(exports, "Droplet", ()=>(0, _dropletJsDefault.default));
parcelHelpers.export(exports, "DropletIcon", ()=>(0, _dropletJsDefault.default));
parcelHelpers.export(exports, "LucideDroplet", ()=>(0, _dropletJsDefault.default));
parcelHelpers.export(exports, "Drill", ()=>(0, _drillJsDefault.default));
parcelHelpers.export(exports, "DrillIcon", ()=>(0, _drillJsDefault.default));
parcelHelpers.export(exports, "LucideDrill", ()=>(0, _drillJsDefault.default));
parcelHelpers.export(exports, "Droplets", ()=>(0, _dropletsJsDefault.default));
parcelHelpers.export(exports, "DropletsIcon", ()=>(0, _dropletsJsDefault.default));
parcelHelpers.export(exports, "LucideDroplets", ()=>(0, _dropletsJsDefault.default));
parcelHelpers.export(exports, "Drum", ()=>(0, _drumJsDefault.default));
parcelHelpers.export(exports, "DrumIcon", ()=>(0, _drumJsDefault.default));
parcelHelpers.export(exports, "LucideDrum", ()=>(0, _drumJsDefault.default));
parcelHelpers.export(exports, "Drumstick", ()=>(0, _drumstickJsDefault.default));
parcelHelpers.export(exports, "DrumstickIcon", ()=>(0, _drumstickJsDefault.default));
parcelHelpers.export(exports, "LucideDrumstick", ()=>(0, _drumstickJsDefault.default));
parcelHelpers.export(exports, "Dumbbell", ()=>(0, _dumbbellJsDefault.default));
parcelHelpers.export(exports, "DumbbellIcon", ()=>(0, _dumbbellJsDefault.default));
parcelHelpers.export(exports, "LucideDumbbell", ()=>(0, _dumbbellJsDefault.default));
parcelHelpers.export(exports, "EarOff", ()=>(0, _earOffJsDefault.default));
parcelHelpers.export(exports, "EarOffIcon", ()=>(0, _earOffJsDefault.default));
parcelHelpers.export(exports, "LucideEarOff", ()=>(0, _earOffJsDefault.default));
parcelHelpers.export(exports, "Ear", ()=>(0, _earJsDefault.default));
parcelHelpers.export(exports, "EarIcon", ()=>(0, _earJsDefault.default));
parcelHelpers.export(exports, "LucideEar", ()=>(0, _earJsDefault.default));
parcelHelpers.export(exports, "EarthLock", ()=>(0, _earthLockJsDefault.default));
parcelHelpers.export(exports, "EarthLockIcon", ()=>(0, _earthLockJsDefault.default));
parcelHelpers.export(exports, "LucideEarthLock", ()=>(0, _earthLockJsDefault.default));
parcelHelpers.export(exports, "Eclipse", ()=>(0, _eclipseJsDefault.default));
parcelHelpers.export(exports, "EclipseIcon", ()=>(0, _eclipseJsDefault.default));
parcelHelpers.export(exports, "LucideEclipse", ()=>(0, _eclipseJsDefault.default));
parcelHelpers.export(exports, "EggFried", ()=>(0, _eggFriedJsDefault.default));
parcelHelpers.export(exports, "EggFriedIcon", ()=>(0, _eggFriedJsDefault.default));
parcelHelpers.export(exports, "LucideEggFried", ()=>(0, _eggFriedJsDefault.default));
parcelHelpers.export(exports, "EggOff", ()=>(0, _eggOffJsDefault.default));
parcelHelpers.export(exports, "EggOffIcon", ()=>(0, _eggOffJsDefault.default));
parcelHelpers.export(exports, "LucideEggOff", ()=>(0, _eggOffJsDefault.default));
parcelHelpers.export(exports, "Egg", ()=>(0, _eggJsDefault.default));
parcelHelpers.export(exports, "EggIcon", ()=>(0, _eggJsDefault.default));
parcelHelpers.export(exports, "LucideEgg", ()=>(0, _eggJsDefault.default));
parcelHelpers.export(exports, "EqualApproximately", ()=>(0, _equalApproximatelyJsDefault.default));
parcelHelpers.export(exports, "EqualApproximatelyIcon", ()=>(0, _equalApproximatelyJsDefault.default));
parcelHelpers.export(exports, "LucideEqualApproximately", ()=>(0, _equalApproximatelyJsDefault.default));
parcelHelpers.export(exports, "EqualNot", ()=>(0, _equalNotJsDefault.default));
parcelHelpers.export(exports, "EqualNotIcon", ()=>(0, _equalNotJsDefault.default));
parcelHelpers.export(exports, "LucideEqualNot", ()=>(0, _equalNotJsDefault.default));
parcelHelpers.export(exports, "Equal", ()=>(0, _equalJsDefault.default));
parcelHelpers.export(exports, "EqualIcon", ()=>(0, _equalJsDefault.default));
parcelHelpers.export(exports, "LucideEqual", ()=>(0, _equalJsDefault.default));
parcelHelpers.export(exports, "Eraser", ()=>(0, _eraserJsDefault.default));
parcelHelpers.export(exports, "EraserIcon", ()=>(0, _eraserJsDefault.default));
parcelHelpers.export(exports, "LucideEraser", ()=>(0, _eraserJsDefault.default));
parcelHelpers.export(exports, "EthernetPort", ()=>(0, _ethernetPortJsDefault.default));
parcelHelpers.export(exports, "EthernetPortIcon", ()=>(0, _ethernetPortJsDefault.default));
parcelHelpers.export(exports, "LucideEthernetPort", ()=>(0, _ethernetPortJsDefault.default));
parcelHelpers.export(exports, "Euro", ()=>(0, _euroJsDefault.default));
parcelHelpers.export(exports, "EuroIcon", ()=>(0, _euroJsDefault.default));
parcelHelpers.export(exports, "LucideEuro", ()=>(0, _euroJsDefault.default));
parcelHelpers.export(exports, "Expand", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "ExpandIcon", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "LucideExpand", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "ExternalLink", ()=>(0, _externalLinkJsDefault.default));
parcelHelpers.export(exports, "ExternalLinkIcon", ()=>(0, _externalLinkJsDefault.default));
parcelHelpers.export(exports, "LucideExternalLink", ()=>(0, _externalLinkJsDefault.default));
parcelHelpers.export(exports, "EyeOff", ()=>(0, _eyeOffJsDefault.default));
parcelHelpers.export(exports, "EyeOffIcon", ()=>(0, _eyeOffJsDefault.default));
parcelHelpers.export(exports, "LucideEyeOff", ()=>(0, _eyeOffJsDefault.default));
parcelHelpers.export(exports, "EyeClosed", ()=>(0, _eyeClosedJsDefault.default));
parcelHelpers.export(exports, "EyeClosedIcon", ()=>(0, _eyeClosedJsDefault.default));
parcelHelpers.export(exports, "LucideEyeClosed", ()=>(0, _eyeClosedJsDefault.default));
parcelHelpers.export(exports, "Eye", ()=>(0, _eyeJsDefault.default));
parcelHelpers.export(exports, "EyeIcon", ()=>(0, _eyeJsDefault.default));
parcelHelpers.export(exports, "LucideEye", ()=>(0, _eyeJsDefault.default));
parcelHelpers.export(exports, "Factory", ()=>(0, _factoryJsDefault.default));
parcelHelpers.export(exports, "FactoryIcon", ()=>(0, _factoryJsDefault.default));
parcelHelpers.export(exports, "LucideFactory", ()=>(0, _factoryJsDefault.default));
parcelHelpers.export(exports, "Facebook", ()=>(0, _facebookJsDefault.default));
parcelHelpers.export(exports, "FacebookIcon", ()=>(0, _facebookJsDefault.default));
parcelHelpers.export(exports, "LucideFacebook", ()=>(0, _facebookJsDefault.default));
parcelHelpers.export(exports, "Fan", ()=>(0, _fanJsDefault.default));
parcelHelpers.export(exports, "FanIcon", ()=>(0, _fanJsDefault.default));
parcelHelpers.export(exports, "LucideFan", ()=>(0, _fanJsDefault.default));
parcelHelpers.export(exports, "FastForward", ()=>(0, _fastForwardJsDefault.default));
parcelHelpers.export(exports, "FastForwardIcon", ()=>(0, _fastForwardJsDefault.default));
parcelHelpers.export(exports, "LucideFastForward", ()=>(0, _fastForwardJsDefault.default));
parcelHelpers.export(exports, "Feather", ()=>(0, _featherJsDefault.default));
parcelHelpers.export(exports, "FeatherIcon", ()=>(0, _featherJsDefault.default));
parcelHelpers.export(exports, "LucideFeather", ()=>(0, _featherJsDefault.default));
parcelHelpers.export(exports, "Fence", ()=>(0, _fenceJsDefault.default));
parcelHelpers.export(exports, "FenceIcon", ()=>(0, _fenceJsDefault.default));
parcelHelpers.export(exports, "LucideFence", ()=>(0, _fenceJsDefault.default));
parcelHelpers.export(exports, "Figma", ()=>(0, _figmaJsDefault.default));
parcelHelpers.export(exports, "FigmaIcon", ()=>(0, _figmaJsDefault.default));
parcelHelpers.export(exports, "LucideFigma", ()=>(0, _figmaJsDefault.default));
parcelHelpers.export(exports, "FerrisWheel", ()=>(0, _ferrisWheelJsDefault.default));
parcelHelpers.export(exports, "FerrisWheelIcon", ()=>(0, _ferrisWheelJsDefault.default));
parcelHelpers.export(exports, "LucideFerrisWheel", ()=>(0, _ferrisWheelJsDefault.default));
parcelHelpers.export(exports, "FileArchive", ()=>(0, _fileArchiveJsDefault.default));
parcelHelpers.export(exports, "FileArchiveIcon", ()=>(0, _fileArchiveJsDefault.default));
parcelHelpers.export(exports, "LucideFileArchive", ()=>(0, _fileArchiveJsDefault.default));
parcelHelpers.export(exports, "FileAudio2", ()=>(0, _fileAudio2JsDefault.default));
parcelHelpers.export(exports, "FileAudio2Icon", ()=>(0, _fileAudio2JsDefault.default));
parcelHelpers.export(exports, "LucideFileAudio2", ()=>(0, _fileAudio2JsDefault.default));
parcelHelpers.export(exports, "FileAudio", ()=>(0, _fileAudioJsDefault.default));
parcelHelpers.export(exports, "FileAudioIcon", ()=>(0, _fileAudioJsDefault.default));
parcelHelpers.export(exports, "LucideFileAudio", ()=>(0, _fileAudioJsDefault.default));
parcelHelpers.export(exports, "FileBadge2", ()=>(0, _fileBadge2JsDefault.default));
parcelHelpers.export(exports, "FileBadge2Icon", ()=>(0, _fileBadge2JsDefault.default));
parcelHelpers.export(exports, "LucideFileBadge2", ()=>(0, _fileBadge2JsDefault.default));
parcelHelpers.export(exports, "FileBadge", ()=>(0, _fileBadgeJsDefault.default));
parcelHelpers.export(exports, "FileBadgeIcon", ()=>(0, _fileBadgeJsDefault.default));
parcelHelpers.export(exports, "LucideFileBadge", ()=>(0, _fileBadgeJsDefault.default));
parcelHelpers.export(exports, "FileBox", ()=>(0, _fileBoxJsDefault.default));
parcelHelpers.export(exports, "FileBoxIcon", ()=>(0, _fileBoxJsDefault.default));
parcelHelpers.export(exports, "LucideFileBox", ()=>(0, _fileBoxJsDefault.default));
parcelHelpers.export(exports, "FileCheck2", ()=>(0, _fileCheck2JsDefault.default));
parcelHelpers.export(exports, "FileCheck2Icon", ()=>(0, _fileCheck2JsDefault.default));
parcelHelpers.export(exports, "LucideFileCheck2", ()=>(0, _fileCheck2JsDefault.default));
parcelHelpers.export(exports, "FileCheck", ()=>(0, _fileCheckJsDefault.default));
parcelHelpers.export(exports, "FileCheckIcon", ()=>(0, _fileCheckJsDefault.default));
parcelHelpers.export(exports, "LucideFileCheck", ()=>(0, _fileCheckJsDefault.default));
parcelHelpers.export(exports, "FileClock", ()=>(0, _fileClockJsDefault.default));
parcelHelpers.export(exports, "FileClockIcon", ()=>(0, _fileClockJsDefault.default));
parcelHelpers.export(exports, "LucideFileClock", ()=>(0, _fileClockJsDefault.default));
parcelHelpers.export(exports, "FileCode2", ()=>(0, _fileCode2JsDefault.default));
parcelHelpers.export(exports, "FileCode2Icon", ()=>(0, _fileCode2JsDefault.default));
parcelHelpers.export(exports, "LucideFileCode2", ()=>(0, _fileCode2JsDefault.default));
parcelHelpers.export(exports, "FileCode", ()=>(0, _fileCodeJsDefault.default));
parcelHelpers.export(exports, "FileCodeIcon", ()=>(0, _fileCodeJsDefault.default));
parcelHelpers.export(exports, "LucideFileCode", ()=>(0, _fileCodeJsDefault.default));
parcelHelpers.export(exports, "FileDiff", ()=>(0, _fileDiffJsDefault.default));
parcelHelpers.export(exports, "FileDiffIcon", ()=>(0, _fileDiffJsDefault.default));
parcelHelpers.export(exports, "LucideFileDiff", ()=>(0, _fileDiffJsDefault.default));
parcelHelpers.export(exports, "FileDigit", ()=>(0, _fileDigitJsDefault.default));
parcelHelpers.export(exports, "FileDigitIcon", ()=>(0, _fileDigitJsDefault.default));
parcelHelpers.export(exports, "LucideFileDigit", ()=>(0, _fileDigitJsDefault.default));
parcelHelpers.export(exports, "FileDown", ()=>(0, _fileDownJsDefault.default));
parcelHelpers.export(exports, "FileDownIcon", ()=>(0, _fileDownJsDefault.default));
parcelHelpers.export(exports, "LucideFileDown", ()=>(0, _fileDownJsDefault.default));
parcelHelpers.export(exports, "FileHeart", ()=>(0, _fileHeartJsDefault.default));
parcelHelpers.export(exports, "FileHeartIcon", ()=>(0, _fileHeartJsDefault.default));
parcelHelpers.export(exports, "LucideFileHeart", ()=>(0, _fileHeartJsDefault.default));
parcelHelpers.export(exports, "FileImage", ()=>(0, _fileImageJsDefault.default));
parcelHelpers.export(exports, "FileImageIcon", ()=>(0, _fileImageJsDefault.default));
parcelHelpers.export(exports, "LucideFileImage", ()=>(0, _fileImageJsDefault.default));
parcelHelpers.export(exports, "FileInput", ()=>(0, _fileInputJsDefault.default));
parcelHelpers.export(exports, "FileInputIcon", ()=>(0, _fileInputJsDefault.default));
parcelHelpers.export(exports, "LucideFileInput", ()=>(0, _fileInputJsDefault.default));
parcelHelpers.export(exports, "FileJson2", ()=>(0, _fileJson2JsDefault.default));
parcelHelpers.export(exports, "FileJson2Icon", ()=>(0, _fileJson2JsDefault.default));
parcelHelpers.export(exports, "LucideFileJson2", ()=>(0, _fileJson2JsDefault.default));
parcelHelpers.export(exports, "FileJson", ()=>(0, _fileJsonJsDefault.default));
parcelHelpers.export(exports, "FileJsonIcon", ()=>(0, _fileJsonJsDefault.default));
parcelHelpers.export(exports, "LucideFileJson", ()=>(0, _fileJsonJsDefault.default));
parcelHelpers.export(exports, "FileKey2", ()=>(0, _fileKey2JsDefault.default));
parcelHelpers.export(exports, "FileKey2Icon", ()=>(0, _fileKey2JsDefault.default));
parcelHelpers.export(exports, "LucideFileKey2", ()=>(0, _fileKey2JsDefault.default));
parcelHelpers.export(exports, "FileKey", ()=>(0, _fileKeyJsDefault.default));
parcelHelpers.export(exports, "FileKeyIcon", ()=>(0, _fileKeyJsDefault.default));
parcelHelpers.export(exports, "LucideFileKey", ()=>(0, _fileKeyJsDefault.default));
parcelHelpers.export(exports, "FileLock2", ()=>(0, _fileLock2JsDefault.default));
parcelHelpers.export(exports, "FileLock2Icon", ()=>(0, _fileLock2JsDefault.default));
parcelHelpers.export(exports, "LucideFileLock2", ()=>(0, _fileLock2JsDefault.default));
parcelHelpers.export(exports, "FileLock", ()=>(0, _fileLockJsDefault.default));
parcelHelpers.export(exports, "FileLockIcon", ()=>(0, _fileLockJsDefault.default));
parcelHelpers.export(exports, "LucideFileLock", ()=>(0, _fileLockJsDefault.default));
parcelHelpers.export(exports, "FileMinus2", ()=>(0, _fileMinus2JsDefault.default));
parcelHelpers.export(exports, "FileMinus2Icon", ()=>(0, _fileMinus2JsDefault.default));
parcelHelpers.export(exports, "LucideFileMinus2", ()=>(0, _fileMinus2JsDefault.default));
parcelHelpers.export(exports, "FileMinus", ()=>(0, _fileMinusJsDefault.default));
parcelHelpers.export(exports, "FileMinusIcon", ()=>(0, _fileMinusJsDefault.default));
parcelHelpers.export(exports, "LucideFileMinus", ()=>(0, _fileMinusJsDefault.default));
parcelHelpers.export(exports, "FileMusic", ()=>(0, _fileMusicJsDefault.default));
parcelHelpers.export(exports, "FileMusicIcon", ()=>(0, _fileMusicJsDefault.default));
parcelHelpers.export(exports, "LucideFileMusic", ()=>(0, _fileMusicJsDefault.default));
parcelHelpers.export(exports, "FileOutput", ()=>(0, _fileOutputJsDefault.default));
parcelHelpers.export(exports, "FileOutputIcon", ()=>(0, _fileOutputJsDefault.default));
parcelHelpers.export(exports, "LucideFileOutput", ()=>(0, _fileOutputJsDefault.default));
parcelHelpers.export(exports, "FilePlus2", ()=>(0, _filePlus2JsDefault.default));
parcelHelpers.export(exports, "FilePlus2Icon", ()=>(0, _filePlus2JsDefault.default));
parcelHelpers.export(exports, "LucideFilePlus2", ()=>(0, _filePlus2JsDefault.default));
parcelHelpers.export(exports, "FilePlus", ()=>(0, _filePlusJsDefault.default));
parcelHelpers.export(exports, "FilePlusIcon", ()=>(0, _filePlusJsDefault.default));
parcelHelpers.export(exports, "LucideFilePlus", ()=>(0, _filePlusJsDefault.default));
parcelHelpers.export(exports, "FileQuestion", ()=>(0, _fileQuestionJsDefault.default));
parcelHelpers.export(exports, "FileQuestionIcon", ()=>(0, _fileQuestionJsDefault.default));
parcelHelpers.export(exports, "LucideFileQuestion", ()=>(0, _fileQuestionJsDefault.default));
parcelHelpers.export(exports, "FileScan", ()=>(0, _fileScanJsDefault.default));
parcelHelpers.export(exports, "FileScanIcon", ()=>(0, _fileScanJsDefault.default));
parcelHelpers.export(exports, "LucideFileScan", ()=>(0, _fileScanJsDefault.default));
parcelHelpers.export(exports, "FileSearch2", ()=>(0, _fileSearch2JsDefault.default));
parcelHelpers.export(exports, "FileSearch2Icon", ()=>(0, _fileSearch2JsDefault.default));
parcelHelpers.export(exports, "LucideFileSearch2", ()=>(0, _fileSearch2JsDefault.default));
parcelHelpers.export(exports, "FileSearch", ()=>(0, _fileSearchJsDefault.default));
parcelHelpers.export(exports, "FileSearchIcon", ()=>(0, _fileSearchJsDefault.default));
parcelHelpers.export(exports, "LucideFileSearch", ()=>(0, _fileSearchJsDefault.default));
parcelHelpers.export(exports, "FileSliders", ()=>(0, _fileSlidersJsDefault.default));
parcelHelpers.export(exports, "FileSlidersIcon", ()=>(0, _fileSlidersJsDefault.default));
parcelHelpers.export(exports, "LucideFileSliders", ()=>(0, _fileSlidersJsDefault.default));
parcelHelpers.export(exports, "FileSpreadsheet", ()=>(0, _fileSpreadsheetJsDefault.default));
parcelHelpers.export(exports, "FileSpreadsheetIcon", ()=>(0, _fileSpreadsheetJsDefault.default));
parcelHelpers.export(exports, "LucideFileSpreadsheet", ()=>(0, _fileSpreadsheetJsDefault.default));
parcelHelpers.export(exports, "FileStack", ()=>(0, _fileStackJsDefault.default));
parcelHelpers.export(exports, "FileStackIcon", ()=>(0, _fileStackJsDefault.default));
parcelHelpers.export(exports, "LucideFileStack", ()=>(0, _fileStackJsDefault.default));
parcelHelpers.export(exports, "FileSymlink", ()=>(0, _fileSymlinkJsDefault.default));
parcelHelpers.export(exports, "FileSymlinkIcon", ()=>(0, _fileSymlinkJsDefault.default));
parcelHelpers.export(exports, "LucideFileSymlink", ()=>(0, _fileSymlinkJsDefault.default));
parcelHelpers.export(exports, "FileTerminal", ()=>(0, _fileTerminalJsDefault.default));
parcelHelpers.export(exports, "FileTerminalIcon", ()=>(0, _fileTerminalJsDefault.default));
parcelHelpers.export(exports, "LucideFileTerminal", ()=>(0, _fileTerminalJsDefault.default));
parcelHelpers.export(exports, "FileText", ()=>(0, _fileTextJsDefault.default));
parcelHelpers.export(exports, "FileTextIcon", ()=>(0, _fileTextJsDefault.default));
parcelHelpers.export(exports, "LucideFileText", ()=>(0, _fileTextJsDefault.default));
parcelHelpers.export(exports, "FileType2", ()=>(0, _fileType2JsDefault.default));
parcelHelpers.export(exports, "FileType2Icon", ()=>(0, _fileType2JsDefault.default));
parcelHelpers.export(exports, "LucideFileType2", ()=>(0, _fileType2JsDefault.default));
parcelHelpers.export(exports, "FileUp", ()=>(0, _fileUpJsDefault.default));
parcelHelpers.export(exports, "FileUpIcon", ()=>(0, _fileUpJsDefault.default));
parcelHelpers.export(exports, "LucideFileUp", ()=>(0, _fileUpJsDefault.default));
parcelHelpers.export(exports, "FileType", ()=>(0, _fileTypeJsDefault.default));
parcelHelpers.export(exports, "FileTypeIcon", ()=>(0, _fileTypeJsDefault.default));
parcelHelpers.export(exports, "LucideFileType", ()=>(0, _fileTypeJsDefault.default));
parcelHelpers.export(exports, "FileUser", ()=>(0, _fileUserJsDefault.default));
parcelHelpers.export(exports, "FileUserIcon", ()=>(0, _fileUserJsDefault.default));
parcelHelpers.export(exports, "LucideFileUser", ()=>(0, _fileUserJsDefault.default));
parcelHelpers.export(exports, "FileVideo2", ()=>(0, _fileVideo2JsDefault.default));
parcelHelpers.export(exports, "FileVideo2Icon", ()=>(0, _fileVideo2JsDefault.default));
parcelHelpers.export(exports, "LucideFileVideo2", ()=>(0, _fileVideo2JsDefault.default));
parcelHelpers.export(exports, "FileVideo", ()=>(0, _fileVideoJsDefault.default));
parcelHelpers.export(exports, "FileVideoIcon", ()=>(0, _fileVideoJsDefault.default));
parcelHelpers.export(exports, "LucideFileVideo", ()=>(0, _fileVideoJsDefault.default));
parcelHelpers.export(exports, "FileVolume2", ()=>(0, _fileVolume2JsDefault.default));
parcelHelpers.export(exports, "FileVolume2Icon", ()=>(0, _fileVolume2JsDefault.default));
parcelHelpers.export(exports, "LucideFileVolume2", ()=>(0, _fileVolume2JsDefault.default));
parcelHelpers.export(exports, "FileVolume", ()=>(0, _fileVolumeJsDefault.default));
parcelHelpers.export(exports, "FileVolumeIcon", ()=>(0, _fileVolumeJsDefault.default));
parcelHelpers.export(exports, "LucideFileVolume", ()=>(0, _fileVolumeJsDefault.default));
parcelHelpers.export(exports, "FileWarning", ()=>(0, _fileWarningJsDefault.default));
parcelHelpers.export(exports, "FileWarningIcon", ()=>(0, _fileWarningJsDefault.default));
parcelHelpers.export(exports, "LucideFileWarning", ()=>(0, _fileWarningJsDefault.default));
parcelHelpers.export(exports, "FileX", ()=>(0, _fileXJsDefault.default));
parcelHelpers.export(exports, "FileXIcon", ()=>(0, _fileXJsDefault.default));
parcelHelpers.export(exports, "LucideFileX", ()=>(0, _fileXJsDefault.default));
parcelHelpers.export(exports, "FileX2", ()=>(0, _fileX2JsDefault.default));
parcelHelpers.export(exports, "FileX2Icon", ()=>(0, _fileX2JsDefault.default));
parcelHelpers.export(exports, "LucideFileX2", ()=>(0, _fileX2JsDefault.default));
parcelHelpers.export(exports, "Files", ()=>(0, _filesJsDefault.default));
parcelHelpers.export(exports, "FilesIcon", ()=>(0, _filesJsDefault.default));
parcelHelpers.export(exports, "LucideFiles", ()=>(0, _filesJsDefault.default));
parcelHelpers.export(exports, "File", ()=>(0, _fileJsDefault.default));
parcelHelpers.export(exports, "FileIcon", ()=>(0, _fileJsDefault.default));
parcelHelpers.export(exports, "LucideFile", ()=>(0, _fileJsDefault.default));
parcelHelpers.export(exports, "Film", ()=>(0, _filmJsDefault.default));
parcelHelpers.export(exports, "FilmIcon", ()=>(0, _filmJsDefault.default));
parcelHelpers.export(exports, "LucideFilm", ()=>(0, _filmJsDefault.default));
parcelHelpers.export(exports, "Fingerprint", ()=>(0, _fingerprintJsDefault.default));
parcelHelpers.export(exports, "FingerprintIcon", ()=>(0, _fingerprintJsDefault.default));
parcelHelpers.export(exports, "LucideFingerprint", ()=>(0, _fingerprintJsDefault.default));
parcelHelpers.export(exports, "FireExtinguisher", ()=>(0, _fireExtinguisherJsDefault.default));
parcelHelpers.export(exports, "FireExtinguisherIcon", ()=>(0, _fireExtinguisherJsDefault.default));
parcelHelpers.export(exports, "LucideFireExtinguisher", ()=>(0, _fireExtinguisherJsDefault.default));
parcelHelpers.export(exports, "FishOff", ()=>(0, _fishOffJsDefault.default));
parcelHelpers.export(exports, "FishOffIcon", ()=>(0, _fishOffJsDefault.default));
parcelHelpers.export(exports, "LucideFishOff", ()=>(0, _fishOffJsDefault.default));
parcelHelpers.export(exports, "FishSymbol", ()=>(0, _fishSymbolJsDefault.default));
parcelHelpers.export(exports, "FishSymbolIcon", ()=>(0, _fishSymbolJsDefault.default));
parcelHelpers.export(exports, "LucideFishSymbol", ()=>(0, _fishSymbolJsDefault.default));
parcelHelpers.export(exports, "Fish", ()=>(0, _fishJsDefault.default));
parcelHelpers.export(exports, "FishIcon", ()=>(0, _fishJsDefault.default));
parcelHelpers.export(exports, "LucideFish", ()=>(0, _fishJsDefault.default));
parcelHelpers.export(exports, "FlagOff", ()=>(0, _flagOffJsDefault.default));
parcelHelpers.export(exports, "FlagOffIcon", ()=>(0, _flagOffJsDefault.default));
parcelHelpers.export(exports, "LucideFlagOff", ()=>(0, _flagOffJsDefault.default));
parcelHelpers.export(exports, "FlagTriangleLeft", ()=>(0, _flagTriangleLeftJsDefault.default));
parcelHelpers.export(exports, "FlagTriangleLeftIcon", ()=>(0, _flagTriangleLeftJsDefault.default));
parcelHelpers.export(exports, "LucideFlagTriangleLeft", ()=>(0, _flagTriangleLeftJsDefault.default));
parcelHelpers.export(exports, "FlagTriangleRight", ()=>(0, _flagTriangleRightJsDefault.default));
parcelHelpers.export(exports, "FlagTriangleRightIcon", ()=>(0, _flagTriangleRightJsDefault.default));
parcelHelpers.export(exports, "LucideFlagTriangleRight", ()=>(0, _flagTriangleRightJsDefault.default));
parcelHelpers.export(exports, "Flag", ()=>(0, _flagJsDefault.default));
parcelHelpers.export(exports, "FlagIcon", ()=>(0, _flagJsDefault.default));
parcelHelpers.export(exports, "LucideFlag", ()=>(0, _flagJsDefault.default));
parcelHelpers.export(exports, "FlameKindling", ()=>(0, _flameKindlingJsDefault.default));
parcelHelpers.export(exports, "FlameKindlingIcon", ()=>(0, _flameKindlingJsDefault.default));
parcelHelpers.export(exports, "LucideFlameKindling", ()=>(0, _flameKindlingJsDefault.default));
parcelHelpers.export(exports, "Flame", ()=>(0, _flameJsDefault.default));
parcelHelpers.export(exports, "FlameIcon", ()=>(0, _flameJsDefault.default));
parcelHelpers.export(exports, "LucideFlame", ()=>(0, _flameJsDefault.default));
parcelHelpers.export(exports, "Flashlight", ()=>(0, _flashlightJsDefault.default));
parcelHelpers.export(exports, "FlashlightIcon", ()=>(0, _flashlightJsDefault.default));
parcelHelpers.export(exports, "LucideFlashlight", ()=>(0, _flashlightJsDefault.default));
parcelHelpers.export(exports, "FlaskConicalOff", ()=>(0, _flaskConicalOffJsDefault.default));
parcelHelpers.export(exports, "FlaskConicalOffIcon", ()=>(0, _flaskConicalOffJsDefault.default));
parcelHelpers.export(exports, "LucideFlaskConicalOff", ()=>(0, _flaskConicalOffJsDefault.default));
parcelHelpers.export(exports, "FlashlightOff", ()=>(0, _flashlightOffJsDefault.default));
parcelHelpers.export(exports, "FlashlightOffIcon", ()=>(0, _flashlightOffJsDefault.default));
parcelHelpers.export(exports, "LucideFlashlightOff", ()=>(0, _flashlightOffJsDefault.default));
parcelHelpers.export(exports, "FlaskConical", ()=>(0, _flaskConicalJsDefault.default));
parcelHelpers.export(exports, "FlaskConicalIcon", ()=>(0, _flaskConicalJsDefault.default));
parcelHelpers.export(exports, "LucideFlaskConical", ()=>(0, _flaskConicalJsDefault.default));
parcelHelpers.export(exports, "FlaskRound", ()=>(0, _flaskRoundJsDefault.default));
parcelHelpers.export(exports, "FlaskRoundIcon", ()=>(0, _flaskRoundJsDefault.default));
parcelHelpers.export(exports, "LucideFlaskRound", ()=>(0, _flaskRoundJsDefault.default));
parcelHelpers.export(exports, "FlipHorizontal2", ()=>(0, _flipHorizontal2JsDefault.default));
parcelHelpers.export(exports, "FlipHorizontal2Icon", ()=>(0, _flipHorizontal2JsDefault.default));
parcelHelpers.export(exports, "LucideFlipHorizontal2", ()=>(0, _flipHorizontal2JsDefault.default));
parcelHelpers.export(exports, "FlipHorizontal", ()=>(0, _flipHorizontalJsDefault.default));
parcelHelpers.export(exports, "FlipHorizontalIcon", ()=>(0, _flipHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideFlipHorizontal", ()=>(0, _flipHorizontalJsDefault.default));
parcelHelpers.export(exports, "FlipVertical2", ()=>(0, _flipVertical2JsDefault.default));
parcelHelpers.export(exports, "FlipVertical2Icon", ()=>(0, _flipVertical2JsDefault.default));
parcelHelpers.export(exports, "LucideFlipVertical2", ()=>(0, _flipVertical2JsDefault.default));
parcelHelpers.export(exports, "FlipVertical", ()=>(0, _flipVerticalJsDefault.default));
parcelHelpers.export(exports, "FlipVerticalIcon", ()=>(0, _flipVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideFlipVertical", ()=>(0, _flipVerticalJsDefault.default));
parcelHelpers.export(exports, "Flower2", ()=>(0, _flower2JsDefault.default));
parcelHelpers.export(exports, "Flower2Icon", ()=>(0, _flower2JsDefault.default));
parcelHelpers.export(exports, "LucideFlower2", ()=>(0, _flower2JsDefault.default));
parcelHelpers.export(exports, "Flower", ()=>(0, _flowerJsDefault.default));
parcelHelpers.export(exports, "FlowerIcon", ()=>(0, _flowerJsDefault.default));
parcelHelpers.export(exports, "LucideFlower", ()=>(0, _flowerJsDefault.default));
parcelHelpers.export(exports, "Focus", ()=>(0, _focusJsDefault.default));
parcelHelpers.export(exports, "FocusIcon", ()=>(0, _focusJsDefault.default));
parcelHelpers.export(exports, "LucideFocus", ()=>(0, _focusJsDefault.default));
parcelHelpers.export(exports, "FoldHorizontal", ()=>(0, _foldHorizontalJsDefault.default));
parcelHelpers.export(exports, "FoldHorizontalIcon", ()=>(0, _foldHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideFoldHorizontal", ()=>(0, _foldHorizontalJsDefault.default));
parcelHelpers.export(exports, "FoldVertical", ()=>(0, _foldVerticalJsDefault.default));
parcelHelpers.export(exports, "FoldVerticalIcon", ()=>(0, _foldVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideFoldVertical", ()=>(0, _foldVerticalJsDefault.default));
parcelHelpers.export(exports, "FolderArchive", ()=>(0, _folderArchiveJsDefault.default));
parcelHelpers.export(exports, "FolderArchiveIcon", ()=>(0, _folderArchiveJsDefault.default));
parcelHelpers.export(exports, "LucideFolderArchive", ()=>(0, _folderArchiveJsDefault.default));
parcelHelpers.export(exports, "FolderCheck", ()=>(0, _folderCheckJsDefault.default));
parcelHelpers.export(exports, "FolderCheckIcon", ()=>(0, _folderCheckJsDefault.default));
parcelHelpers.export(exports, "LucideFolderCheck", ()=>(0, _folderCheckJsDefault.default));
parcelHelpers.export(exports, "FolderClock", ()=>(0, _folderClockJsDefault.default));
parcelHelpers.export(exports, "FolderClockIcon", ()=>(0, _folderClockJsDefault.default));
parcelHelpers.export(exports, "LucideFolderClock", ()=>(0, _folderClockJsDefault.default));
parcelHelpers.export(exports, "FolderClosed", ()=>(0, _folderClosedJsDefault.default));
parcelHelpers.export(exports, "FolderClosedIcon", ()=>(0, _folderClosedJsDefault.default));
parcelHelpers.export(exports, "LucideFolderClosed", ()=>(0, _folderClosedJsDefault.default));
parcelHelpers.export(exports, "FolderCode", ()=>(0, _folderCodeJsDefault.default));
parcelHelpers.export(exports, "FolderCodeIcon", ()=>(0, _folderCodeJsDefault.default));
parcelHelpers.export(exports, "LucideFolderCode", ()=>(0, _folderCodeJsDefault.default));
parcelHelpers.export(exports, "FolderDot", ()=>(0, _folderDotJsDefault.default));
parcelHelpers.export(exports, "FolderDotIcon", ()=>(0, _folderDotJsDefault.default));
parcelHelpers.export(exports, "LucideFolderDot", ()=>(0, _folderDotJsDefault.default));
parcelHelpers.export(exports, "FolderDown", ()=>(0, _folderDownJsDefault.default));
parcelHelpers.export(exports, "FolderDownIcon", ()=>(0, _folderDownJsDefault.default));
parcelHelpers.export(exports, "LucideFolderDown", ()=>(0, _folderDownJsDefault.default));
parcelHelpers.export(exports, "FolderGit2", ()=>(0, _folderGit2JsDefault.default));
parcelHelpers.export(exports, "FolderGit2Icon", ()=>(0, _folderGit2JsDefault.default));
parcelHelpers.export(exports, "LucideFolderGit2", ()=>(0, _folderGit2JsDefault.default));
parcelHelpers.export(exports, "FolderGit", ()=>(0, _folderGitJsDefault.default));
parcelHelpers.export(exports, "FolderGitIcon", ()=>(0, _folderGitJsDefault.default));
parcelHelpers.export(exports, "LucideFolderGit", ()=>(0, _folderGitJsDefault.default));
parcelHelpers.export(exports, "FolderHeart", ()=>(0, _folderHeartJsDefault.default));
parcelHelpers.export(exports, "FolderHeartIcon", ()=>(0, _folderHeartJsDefault.default));
parcelHelpers.export(exports, "LucideFolderHeart", ()=>(0, _folderHeartJsDefault.default));
parcelHelpers.export(exports, "FolderInput", ()=>(0, _folderInputJsDefault.default));
parcelHelpers.export(exports, "FolderInputIcon", ()=>(0, _folderInputJsDefault.default));
parcelHelpers.export(exports, "LucideFolderInput", ()=>(0, _folderInputJsDefault.default));
parcelHelpers.export(exports, "FolderKanban", ()=>(0, _folderKanbanJsDefault.default));
parcelHelpers.export(exports, "FolderKanbanIcon", ()=>(0, _folderKanbanJsDefault.default));
parcelHelpers.export(exports, "LucideFolderKanban", ()=>(0, _folderKanbanJsDefault.default));
parcelHelpers.export(exports, "FolderKey", ()=>(0, _folderKeyJsDefault.default));
parcelHelpers.export(exports, "FolderKeyIcon", ()=>(0, _folderKeyJsDefault.default));
parcelHelpers.export(exports, "LucideFolderKey", ()=>(0, _folderKeyJsDefault.default));
parcelHelpers.export(exports, "FolderLock", ()=>(0, _folderLockJsDefault.default));
parcelHelpers.export(exports, "FolderLockIcon", ()=>(0, _folderLockJsDefault.default));
parcelHelpers.export(exports, "LucideFolderLock", ()=>(0, _folderLockJsDefault.default));
parcelHelpers.export(exports, "FolderMinus", ()=>(0, _folderMinusJsDefault.default));
parcelHelpers.export(exports, "FolderMinusIcon", ()=>(0, _folderMinusJsDefault.default));
parcelHelpers.export(exports, "LucideFolderMinus", ()=>(0, _folderMinusJsDefault.default));
parcelHelpers.export(exports, "FolderOpenDot", ()=>(0, _folderOpenDotJsDefault.default));
parcelHelpers.export(exports, "FolderOpenDotIcon", ()=>(0, _folderOpenDotJsDefault.default));
parcelHelpers.export(exports, "LucideFolderOpenDot", ()=>(0, _folderOpenDotJsDefault.default));
parcelHelpers.export(exports, "FolderOpen", ()=>(0, _folderOpenJsDefault.default));
parcelHelpers.export(exports, "FolderOpenIcon", ()=>(0, _folderOpenJsDefault.default));
parcelHelpers.export(exports, "LucideFolderOpen", ()=>(0, _folderOpenJsDefault.default));
parcelHelpers.export(exports, "FolderOutput", ()=>(0, _folderOutputJsDefault.default));
parcelHelpers.export(exports, "FolderOutputIcon", ()=>(0, _folderOutputJsDefault.default));
parcelHelpers.export(exports, "LucideFolderOutput", ()=>(0, _folderOutputJsDefault.default));
parcelHelpers.export(exports, "FolderPlus", ()=>(0, _folderPlusJsDefault.default));
parcelHelpers.export(exports, "FolderPlusIcon", ()=>(0, _folderPlusJsDefault.default));
parcelHelpers.export(exports, "LucideFolderPlus", ()=>(0, _folderPlusJsDefault.default));
parcelHelpers.export(exports, "FolderRoot", ()=>(0, _folderRootJsDefault.default));
parcelHelpers.export(exports, "FolderRootIcon", ()=>(0, _folderRootJsDefault.default));
parcelHelpers.export(exports, "LucideFolderRoot", ()=>(0, _folderRootJsDefault.default));
parcelHelpers.export(exports, "FolderSearch2", ()=>(0, _folderSearch2JsDefault.default));
parcelHelpers.export(exports, "FolderSearch2Icon", ()=>(0, _folderSearch2JsDefault.default));
parcelHelpers.export(exports, "LucideFolderSearch2", ()=>(0, _folderSearch2JsDefault.default));
parcelHelpers.export(exports, "FolderSearch", ()=>(0, _folderSearchJsDefault.default));
parcelHelpers.export(exports, "FolderSearchIcon", ()=>(0, _folderSearchJsDefault.default));
parcelHelpers.export(exports, "LucideFolderSearch", ()=>(0, _folderSearchJsDefault.default));
parcelHelpers.export(exports, "FolderSymlink", ()=>(0, _folderSymlinkJsDefault.default));
parcelHelpers.export(exports, "FolderSymlinkIcon", ()=>(0, _folderSymlinkJsDefault.default));
parcelHelpers.export(exports, "LucideFolderSymlink", ()=>(0, _folderSymlinkJsDefault.default));
parcelHelpers.export(exports, "FolderSync", ()=>(0, _folderSyncJsDefault.default));
parcelHelpers.export(exports, "FolderSyncIcon", ()=>(0, _folderSyncJsDefault.default));
parcelHelpers.export(exports, "LucideFolderSync", ()=>(0, _folderSyncJsDefault.default));
parcelHelpers.export(exports, "FolderTree", ()=>(0, _folderTreeJsDefault.default));
parcelHelpers.export(exports, "FolderTreeIcon", ()=>(0, _folderTreeJsDefault.default));
parcelHelpers.export(exports, "LucideFolderTree", ()=>(0, _folderTreeJsDefault.default));
parcelHelpers.export(exports, "FolderUp", ()=>(0, _folderUpJsDefault.default));
parcelHelpers.export(exports, "FolderUpIcon", ()=>(0, _folderUpJsDefault.default));
parcelHelpers.export(exports, "LucideFolderUp", ()=>(0, _folderUpJsDefault.default));
parcelHelpers.export(exports, "FolderX", ()=>(0, _folderXJsDefault.default));
parcelHelpers.export(exports, "FolderXIcon", ()=>(0, _folderXJsDefault.default));
parcelHelpers.export(exports, "LucideFolderX", ()=>(0, _folderXJsDefault.default));
parcelHelpers.export(exports, "Folder", ()=>(0, _folderJsDefault.default));
parcelHelpers.export(exports, "FolderIcon", ()=>(0, _folderJsDefault.default));
parcelHelpers.export(exports, "LucideFolder", ()=>(0, _folderJsDefault.default));
parcelHelpers.export(exports, "Folders", ()=>(0, _foldersJsDefault.default));
parcelHelpers.export(exports, "FoldersIcon", ()=>(0, _foldersJsDefault.default));
parcelHelpers.export(exports, "LucideFolders", ()=>(0, _foldersJsDefault.default));
parcelHelpers.export(exports, "Footprints", ()=>(0, _footprintsJsDefault.default));
parcelHelpers.export(exports, "FootprintsIcon", ()=>(0, _footprintsJsDefault.default));
parcelHelpers.export(exports, "LucideFootprints", ()=>(0, _footprintsJsDefault.default));
parcelHelpers.export(exports, "Forklift", ()=>(0, _forkliftJsDefault.default));
parcelHelpers.export(exports, "ForkliftIcon", ()=>(0, _forkliftJsDefault.default));
parcelHelpers.export(exports, "LucideForklift", ()=>(0, _forkliftJsDefault.default));
parcelHelpers.export(exports, "Forward", ()=>(0, _forwardJsDefault.default));
parcelHelpers.export(exports, "ForwardIcon", ()=>(0, _forwardJsDefault.default));
parcelHelpers.export(exports, "LucideForward", ()=>(0, _forwardJsDefault.default));
parcelHelpers.export(exports, "Frame", ()=>(0, _frameJsDefault.default));
parcelHelpers.export(exports, "FrameIcon", ()=>(0, _frameJsDefault.default));
parcelHelpers.export(exports, "LucideFrame", ()=>(0, _frameJsDefault.default));
parcelHelpers.export(exports, "Framer", ()=>(0, _framerJsDefault.default));
parcelHelpers.export(exports, "FramerIcon", ()=>(0, _framerJsDefault.default));
parcelHelpers.export(exports, "LucideFramer", ()=>(0, _framerJsDefault.default));
parcelHelpers.export(exports, "Fuel", ()=>(0, _fuelJsDefault.default));
parcelHelpers.export(exports, "FuelIcon", ()=>(0, _fuelJsDefault.default));
parcelHelpers.export(exports, "LucideFuel", ()=>(0, _fuelJsDefault.default));
parcelHelpers.export(exports, "Fullscreen", ()=>(0, _fullscreenJsDefault.default));
parcelHelpers.export(exports, "FullscreenIcon", ()=>(0, _fullscreenJsDefault.default));
parcelHelpers.export(exports, "LucideFullscreen", ()=>(0, _fullscreenJsDefault.default));
parcelHelpers.export(exports, "Frown", ()=>(0, _frownJsDefault.default));
parcelHelpers.export(exports, "FrownIcon", ()=>(0, _frownJsDefault.default));
parcelHelpers.export(exports, "LucideFrown", ()=>(0, _frownJsDefault.default));
parcelHelpers.export(exports, "FunnelPlus", ()=>(0, _funnelPlusJsDefault.default));
parcelHelpers.export(exports, "FunnelPlusIcon", ()=>(0, _funnelPlusJsDefault.default));
parcelHelpers.export(exports, "LucideFunnelPlus", ()=>(0, _funnelPlusJsDefault.default));
parcelHelpers.export(exports, "GalleryHorizontalEnd", ()=>(0, _galleryHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "GalleryHorizontalEndIcon", ()=>(0, _galleryHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "LucideGalleryHorizontalEnd", ()=>(0, _galleryHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "GalleryHorizontal", ()=>(0, _galleryHorizontalJsDefault.default));
parcelHelpers.export(exports, "GalleryHorizontalIcon", ()=>(0, _galleryHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideGalleryHorizontal", ()=>(0, _galleryHorizontalJsDefault.default));
parcelHelpers.export(exports, "GalleryThumbnails", ()=>(0, _galleryThumbnailsJsDefault.default));
parcelHelpers.export(exports, "GalleryThumbnailsIcon", ()=>(0, _galleryThumbnailsJsDefault.default));
parcelHelpers.export(exports, "LucideGalleryThumbnails", ()=>(0, _galleryThumbnailsJsDefault.default));
parcelHelpers.export(exports, "GalleryVerticalEnd", ()=>(0, _galleryVerticalEndJsDefault.default));
parcelHelpers.export(exports, "GalleryVerticalEndIcon", ()=>(0, _galleryVerticalEndJsDefault.default));
parcelHelpers.export(exports, "LucideGalleryVerticalEnd", ()=>(0, _galleryVerticalEndJsDefault.default));
parcelHelpers.export(exports, "GalleryVertical", ()=>(0, _galleryVerticalJsDefault.default));
parcelHelpers.export(exports, "GalleryVerticalIcon", ()=>(0, _galleryVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideGalleryVertical", ()=>(0, _galleryVerticalJsDefault.default));
parcelHelpers.export(exports, "Gamepad2", ()=>(0, _gamepad2JsDefault.default));
parcelHelpers.export(exports, "Gamepad2Icon", ()=>(0, _gamepad2JsDefault.default));
parcelHelpers.export(exports, "LucideGamepad2", ()=>(0, _gamepad2JsDefault.default));
parcelHelpers.export(exports, "Gamepad", ()=>(0, _gamepadJsDefault.default));
parcelHelpers.export(exports, "GamepadIcon", ()=>(0, _gamepadJsDefault.default));
parcelHelpers.export(exports, "LucideGamepad", ()=>(0, _gamepadJsDefault.default));
parcelHelpers.export(exports, "Gauge", ()=>(0, _gaugeJsDefault.default));
parcelHelpers.export(exports, "GaugeIcon", ()=>(0, _gaugeJsDefault.default));
parcelHelpers.export(exports, "LucideGauge", ()=>(0, _gaugeJsDefault.default));
parcelHelpers.export(exports, "Gavel", ()=>(0, _gavelJsDefault.default));
parcelHelpers.export(exports, "GavelIcon", ()=>(0, _gavelJsDefault.default));
parcelHelpers.export(exports, "LucideGavel", ()=>(0, _gavelJsDefault.default));
parcelHelpers.export(exports, "Gem", ()=>(0, _gemJsDefault.default));
parcelHelpers.export(exports, "GemIcon", ()=>(0, _gemJsDefault.default));
parcelHelpers.export(exports, "LucideGem", ()=>(0, _gemJsDefault.default));
parcelHelpers.export(exports, "Gift", ()=>(0, _giftJsDefault.default));
parcelHelpers.export(exports, "GiftIcon", ()=>(0, _giftJsDefault.default));
parcelHelpers.export(exports, "LucideGift", ()=>(0, _giftJsDefault.default));
parcelHelpers.export(exports, "Ghost", ()=>(0, _ghostJsDefault.default));
parcelHelpers.export(exports, "GhostIcon", ()=>(0, _ghostJsDefault.default));
parcelHelpers.export(exports, "LucideGhost", ()=>(0, _ghostJsDefault.default));
parcelHelpers.export(exports, "GitBranchPlus", ()=>(0, _gitBranchPlusJsDefault.default));
parcelHelpers.export(exports, "GitBranchPlusIcon", ()=>(0, _gitBranchPlusJsDefault.default));
parcelHelpers.export(exports, "LucideGitBranchPlus", ()=>(0, _gitBranchPlusJsDefault.default));
parcelHelpers.export(exports, "GitBranch", ()=>(0, _gitBranchJsDefault.default));
parcelHelpers.export(exports, "GitBranchIcon", ()=>(0, _gitBranchJsDefault.default));
parcelHelpers.export(exports, "LucideGitBranch", ()=>(0, _gitBranchJsDefault.default));
parcelHelpers.export(exports, "GitCommitVertical", ()=>(0, _gitCommitVerticalJsDefault.default));
parcelHelpers.export(exports, "GitCommitVerticalIcon", ()=>(0, _gitCommitVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideGitCommitVertical", ()=>(0, _gitCommitVerticalJsDefault.default));
parcelHelpers.export(exports, "GitCompareArrows", ()=>(0, _gitCompareArrowsJsDefault.default));
parcelHelpers.export(exports, "GitCompareArrowsIcon", ()=>(0, _gitCompareArrowsJsDefault.default));
parcelHelpers.export(exports, "LucideGitCompareArrows", ()=>(0, _gitCompareArrowsJsDefault.default));
parcelHelpers.export(exports, "GitCompare", ()=>(0, _gitCompareJsDefault.default));
parcelHelpers.export(exports, "GitCompareIcon", ()=>(0, _gitCompareJsDefault.default));
parcelHelpers.export(exports, "LucideGitCompare", ()=>(0, _gitCompareJsDefault.default));
parcelHelpers.export(exports, "GitFork", ()=>(0, _gitForkJsDefault.default));
parcelHelpers.export(exports, "GitForkIcon", ()=>(0, _gitForkJsDefault.default));
parcelHelpers.export(exports, "LucideGitFork", ()=>(0, _gitForkJsDefault.default));
parcelHelpers.export(exports, "GitGraph", ()=>(0, _gitGraphJsDefault.default));
parcelHelpers.export(exports, "GitGraphIcon", ()=>(0, _gitGraphJsDefault.default));
parcelHelpers.export(exports, "LucideGitGraph", ()=>(0, _gitGraphJsDefault.default));
parcelHelpers.export(exports, "GitMerge", ()=>(0, _gitMergeJsDefault.default));
parcelHelpers.export(exports, "GitMergeIcon", ()=>(0, _gitMergeJsDefault.default));
parcelHelpers.export(exports, "LucideGitMerge", ()=>(0, _gitMergeJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestArrow", ()=>(0, _gitPullRequestArrowJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestArrowIcon", ()=>(0, _gitPullRequestArrowJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequestArrow", ()=>(0, _gitPullRequestArrowJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestClosed", ()=>(0, _gitPullRequestClosedJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestClosedIcon", ()=>(0, _gitPullRequestClosedJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequestClosed", ()=>(0, _gitPullRequestClosedJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestCreateArrow", ()=>(0, _gitPullRequestCreateArrowJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestCreateArrowIcon", ()=>(0, _gitPullRequestCreateArrowJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequestCreateArrow", ()=>(0, _gitPullRequestCreateArrowJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestCreate", ()=>(0, _gitPullRequestCreateJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestCreateIcon", ()=>(0, _gitPullRequestCreateJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequestCreate", ()=>(0, _gitPullRequestCreateJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestDraft", ()=>(0, _gitPullRequestDraftJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestDraftIcon", ()=>(0, _gitPullRequestDraftJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequestDraft", ()=>(0, _gitPullRequestDraftJsDefault.default));
parcelHelpers.export(exports, "GitPullRequest", ()=>(0, _gitPullRequestJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestIcon", ()=>(0, _gitPullRequestJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequest", ()=>(0, _gitPullRequestJsDefault.default));
parcelHelpers.export(exports, "Github", ()=>(0, _githubJsDefault.default));
parcelHelpers.export(exports, "GithubIcon", ()=>(0, _githubJsDefault.default));
parcelHelpers.export(exports, "LucideGithub", ()=>(0, _githubJsDefault.default));
parcelHelpers.export(exports, "Gitlab", ()=>(0, _gitlabJsDefault.default));
parcelHelpers.export(exports, "GitlabIcon", ()=>(0, _gitlabJsDefault.default));
parcelHelpers.export(exports, "LucideGitlab", ()=>(0, _gitlabJsDefault.default));
parcelHelpers.export(exports, "GlassWater", ()=>(0, _glassWaterJsDefault.default));
parcelHelpers.export(exports, "GlassWaterIcon", ()=>(0, _glassWaterJsDefault.default));
parcelHelpers.export(exports, "LucideGlassWater", ()=>(0, _glassWaterJsDefault.default));
parcelHelpers.export(exports, "Glasses", ()=>(0, _glassesJsDefault.default));
parcelHelpers.export(exports, "GlassesIcon", ()=>(0, _glassesJsDefault.default));
parcelHelpers.export(exports, "LucideGlasses", ()=>(0, _glassesJsDefault.default));
parcelHelpers.export(exports, "GlobeLock", ()=>(0, _globeLockJsDefault.default));
parcelHelpers.export(exports, "GlobeLockIcon", ()=>(0, _globeLockJsDefault.default));
parcelHelpers.export(exports, "LucideGlobeLock", ()=>(0, _globeLockJsDefault.default));
parcelHelpers.export(exports, "Globe", ()=>(0, _globeJsDefault.default));
parcelHelpers.export(exports, "GlobeIcon", ()=>(0, _globeJsDefault.default));
parcelHelpers.export(exports, "LucideGlobe", ()=>(0, _globeJsDefault.default));
parcelHelpers.export(exports, "Goal", ()=>(0, _goalJsDefault.default));
parcelHelpers.export(exports, "GoalIcon", ()=>(0, _goalJsDefault.default));
parcelHelpers.export(exports, "LucideGoal", ()=>(0, _goalJsDefault.default));
parcelHelpers.export(exports, "Gpu", ()=>(0, _gpuJsDefault.default));
parcelHelpers.export(exports, "GpuIcon", ()=>(0, _gpuJsDefault.default));
parcelHelpers.export(exports, "LucideGpu", ()=>(0, _gpuJsDefault.default));
parcelHelpers.export(exports, "Grab", ()=>(0, _grabJsDefault.default));
parcelHelpers.export(exports, "GrabIcon", ()=>(0, _grabJsDefault.default));
parcelHelpers.export(exports, "LucideGrab", ()=>(0, _grabJsDefault.default));
parcelHelpers.export(exports, "GraduationCap", ()=>(0, _graduationCapJsDefault.default));
parcelHelpers.export(exports, "GraduationCapIcon", ()=>(0, _graduationCapJsDefault.default));
parcelHelpers.export(exports, "LucideGraduationCap", ()=>(0, _graduationCapJsDefault.default));
parcelHelpers.export(exports, "Grape", ()=>(0, _grapeJsDefault.default));
parcelHelpers.export(exports, "GrapeIcon", ()=>(0, _grapeJsDefault.default));
parcelHelpers.export(exports, "LucideGrape", ()=>(0, _grapeJsDefault.default));
parcelHelpers.export(exports, "Grid3x2", ()=>(0, _grid3X2JsDefault.default));
parcelHelpers.export(exports, "Grid3x2Icon", ()=>(0, _grid3X2JsDefault.default));
parcelHelpers.export(exports, "LucideGrid3x2", ()=>(0, _grid3X2JsDefault.default));
parcelHelpers.export(exports, "GripHorizontal", ()=>(0, _gripHorizontalJsDefault.default));
parcelHelpers.export(exports, "GripHorizontalIcon", ()=>(0, _gripHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideGripHorizontal", ()=>(0, _gripHorizontalJsDefault.default));
parcelHelpers.export(exports, "GripVertical", ()=>(0, _gripVerticalJsDefault.default));
parcelHelpers.export(exports, "GripVerticalIcon", ()=>(0, _gripVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideGripVertical", ()=>(0, _gripVerticalJsDefault.default));
parcelHelpers.export(exports, "Grip", ()=>(0, _gripJsDefault.default));
parcelHelpers.export(exports, "GripIcon", ()=>(0, _gripJsDefault.default));
parcelHelpers.export(exports, "LucideGrip", ()=>(0, _gripJsDefault.default));
parcelHelpers.export(exports, "Group", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "GroupIcon", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "LucideGroup", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "Guitar", ()=>(0, _guitarJsDefault.default));
parcelHelpers.export(exports, "GuitarIcon", ()=>(0, _guitarJsDefault.default));
parcelHelpers.export(exports, "LucideGuitar", ()=>(0, _guitarJsDefault.default));
parcelHelpers.export(exports, "Ham", ()=>(0, _hamJsDefault.default));
parcelHelpers.export(exports, "HamIcon", ()=>(0, _hamJsDefault.default));
parcelHelpers.export(exports, "LucideHam", ()=>(0, _hamJsDefault.default));
parcelHelpers.export(exports, "Hamburger", ()=>(0, _hamburgerJsDefault.default));
parcelHelpers.export(exports, "HamburgerIcon", ()=>(0, _hamburgerJsDefault.default));
parcelHelpers.export(exports, "LucideHamburger", ()=>(0, _hamburgerJsDefault.default));
parcelHelpers.export(exports, "Hammer", ()=>(0, _hammerJsDefault.default));
parcelHelpers.export(exports, "HammerIcon", ()=>(0, _hammerJsDefault.default));
parcelHelpers.export(exports, "LucideHammer", ()=>(0, _hammerJsDefault.default));
parcelHelpers.export(exports, "HandCoins", ()=>(0, _handCoinsJsDefault.default));
parcelHelpers.export(exports, "HandCoinsIcon", ()=>(0, _handCoinsJsDefault.default));
parcelHelpers.export(exports, "LucideHandCoins", ()=>(0, _handCoinsJsDefault.default));
parcelHelpers.export(exports, "HandHeart", ()=>(0, _handHeartJsDefault.default));
parcelHelpers.export(exports, "HandHeartIcon", ()=>(0, _handHeartJsDefault.default));
parcelHelpers.export(exports, "LucideHandHeart", ()=>(0, _handHeartJsDefault.default));
parcelHelpers.export(exports, "HandMetal", ()=>(0, _handMetalJsDefault.default));
parcelHelpers.export(exports, "HandMetalIcon", ()=>(0, _handMetalJsDefault.default));
parcelHelpers.export(exports, "LucideHandMetal", ()=>(0, _handMetalJsDefault.default));
parcelHelpers.export(exports, "HandPlatter", ()=>(0, _handPlatterJsDefault.default));
parcelHelpers.export(exports, "HandPlatterIcon", ()=>(0, _handPlatterJsDefault.default));
parcelHelpers.export(exports, "LucideHandPlatter", ()=>(0, _handPlatterJsDefault.default));
parcelHelpers.export(exports, "Hand", ()=>(0, _handJsDefault.default));
parcelHelpers.export(exports, "HandIcon", ()=>(0, _handJsDefault.default));
parcelHelpers.export(exports, "LucideHand", ()=>(0, _handJsDefault.default));
parcelHelpers.export(exports, "Handshake", ()=>(0, _handshakeJsDefault.default));
parcelHelpers.export(exports, "HandshakeIcon", ()=>(0, _handshakeJsDefault.default));
parcelHelpers.export(exports, "LucideHandshake", ()=>(0, _handshakeJsDefault.default));
parcelHelpers.export(exports, "HardDriveDownload", ()=>(0, _hardDriveDownloadJsDefault.default));
parcelHelpers.export(exports, "HardDriveDownloadIcon", ()=>(0, _hardDriveDownloadJsDefault.default));
parcelHelpers.export(exports, "LucideHardDriveDownload", ()=>(0, _hardDriveDownloadJsDefault.default));
parcelHelpers.export(exports, "HardDriveUpload", ()=>(0, _hardDriveUploadJsDefault.default));
parcelHelpers.export(exports, "HardDriveUploadIcon", ()=>(0, _hardDriveUploadJsDefault.default));
parcelHelpers.export(exports, "LucideHardDriveUpload", ()=>(0, _hardDriveUploadJsDefault.default));
parcelHelpers.export(exports, "HardDrive", ()=>(0, _hardDriveJsDefault.default));
parcelHelpers.export(exports, "HardDriveIcon", ()=>(0, _hardDriveJsDefault.default));
parcelHelpers.export(exports, "LucideHardDrive", ()=>(0, _hardDriveJsDefault.default));
parcelHelpers.export(exports, "Hash", ()=>(0, _hashJsDefault.default));
parcelHelpers.export(exports, "HashIcon", ()=>(0, _hashJsDefault.default));
parcelHelpers.export(exports, "LucideHash", ()=>(0, _hashJsDefault.default));
parcelHelpers.export(exports, "HardHat", ()=>(0, _hardHatJsDefault.default));
parcelHelpers.export(exports, "HardHatIcon", ()=>(0, _hardHatJsDefault.default));
parcelHelpers.export(exports, "LucideHardHat", ()=>(0, _hardHatJsDefault.default));
parcelHelpers.export(exports, "Haze", ()=>(0, _hazeJsDefault.default));
parcelHelpers.export(exports, "HazeIcon", ()=>(0, _hazeJsDefault.default));
parcelHelpers.export(exports, "LucideHaze", ()=>(0, _hazeJsDefault.default));
parcelHelpers.export(exports, "HdmiPort", ()=>(0, _hdmiPortJsDefault.default));
parcelHelpers.export(exports, "HdmiPortIcon", ()=>(0, _hdmiPortJsDefault.default));
parcelHelpers.export(exports, "LucideHdmiPort", ()=>(0, _hdmiPortJsDefault.default));
parcelHelpers.export(exports, "Heading1", ()=>(0, _heading1JsDefault.default));
parcelHelpers.export(exports, "Heading1Icon", ()=>(0, _heading1JsDefault.default));
parcelHelpers.export(exports, "LucideHeading1", ()=>(0, _heading1JsDefault.default));
parcelHelpers.export(exports, "Heading2", ()=>(0, _heading2JsDefault.default));
parcelHelpers.export(exports, "Heading2Icon", ()=>(0, _heading2JsDefault.default));
parcelHelpers.export(exports, "LucideHeading2", ()=>(0, _heading2JsDefault.default));
parcelHelpers.export(exports, "Heading3", ()=>(0, _heading3JsDefault.default));
parcelHelpers.export(exports, "Heading3Icon", ()=>(0, _heading3JsDefault.default));
parcelHelpers.export(exports, "LucideHeading3", ()=>(0, _heading3JsDefault.default));
parcelHelpers.export(exports, "Heading4", ()=>(0, _heading4JsDefault.default));
parcelHelpers.export(exports, "Heading4Icon", ()=>(0, _heading4JsDefault.default));
parcelHelpers.export(exports, "LucideHeading4", ()=>(0, _heading4JsDefault.default));
parcelHelpers.export(exports, "Heading5", ()=>(0, _heading5JsDefault.default));
parcelHelpers.export(exports, "Heading5Icon", ()=>(0, _heading5JsDefault.default));
parcelHelpers.export(exports, "LucideHeading5", ()=>(0, _heading5JsDefault.default));
parcelHelpers.export(exports, "Heading6", ()=>(0, _heading6JsDefault.default));
parcelHelpers.export(exports, "Heading6Icon", ()=>(0, _heading6JsDefault.default));
parcelHelpers.export(exports, "LucideHeading6", ()=>(0, _heading6JsDefault.default));
parcelHelpers.export(exports, "Heading", ()=>(0, _headingJsDefault.default));
parcelHelpers.export(exports, "HeadingIcon", ()=>(0, _headingJsDefault.default));
parcelHelpers.export(exports, "LucideHeading", ()=>(0, _headingJsDefault.default));
parcelHelpers.export(exports, "HeadphoneOff", ()=>(0, _headphoneOffJsDefault.default));
parcelHelpers.export(exports, "HeadphoneOffIcon", ()=>(0, _headphoneOffJsDefault.default));
parcelHelpers.export(exports, "LucideHeadphoneOff", ()=>(0, _headphoneOffJsDefault.default));
parcelHelpers.export(exports, "Headphones", ()=>(0, _headphonesJsDefault.default));
parcelHelpers.export(exports, "HeadphonesIcon", ()=>(0, _headphonesJsDefault.default));
parcelHelpers.export(exports, "LucideHeadphones", ()=>(0, _headphonesJsDefault.default));
parcelHelpers.export(exports, "Headset", ()=>(0, _headsetJsDefault.default));
parcelHelpers.export(exports, "HeadsetIcon", ()=>(0, _headsetJsDefault.default));
parcelHelpers.export(exports, "LucideHeadset", ()=>(0, _headsetJsDefault.default));
parcelHelpers.export(exports, "HeartCrack", ()=>(0, _heartCrackJsDefault.default));
parcelHelpers.export(exports, "HeartCrackIcon", ()=>(0, _heartCrackJsDefault.default));
parcelHelpers.export(exports, "LucideHeartCrack", ()=>(0, _heartCrackJsDefault.default));
parcelHelpers.export(exports, "HeartHandshake", ()=>(0, _heartHandshakeJsDefault.default));
parcelHelpers.export(exports, "HeartHandshakeIcon", ()=>(0, _heartHandshakeJsDefault.default));
parcelHelpers.export(exports, "LucideHeartHandshake", ()=>(0, _heartHandshakeJsDefault.default));
parcelHelpers.export(exports, "HeartMinus", ()=>(0, _heartMinusJsDefault.default));
parcelHelpers.export(exports, "HeartMinusIcon", ()=>(0, _heartMinusJsDefault.default));
parcelHelpers.export(exports, "LucideHeartMinus", ()=>(0, _heartMinusJsDefault.default));
parcelHelpers.export(exports, "HeartOff", ()=>(0, _heartOffJsDefault.default));
parcelHelpers.export(exports, "HeartOffIcon", ()=>(0, _heartOffJsDefault.default));
parcelHelpers.export(exports, "LucideHeartOff", ()=>(0, _heartOffJsDefault.default));
parcelHelpers.export(exports, "HeartPlus", ()=>(0, _heartPlusJsDefault.default));
parcelHelpers.export(exports, "HeartPlusIcon", ()=>(0, _heartPlusJsDefault.default));
parcelHelpers.export(exports, "LucideHeartPlus", ()=>(0, _heartPlusJsDefault.default));
parcelHelpers.export(exports, "HeartPulse", ()=>(0, _heartPulseJsDefault.default));
parcelHelpers.export(exports, "HeartPulseIcon", ()=>(0, _heartPulseJsDefault.default));
parcelHelpers.export(exports, "LucideHeartPulse", ()=>(0, _heartPulseJsDefault.default));
parcelHelpers.export(exports, "Heart", ()=>(0, _heartJsDefault.default));
parcelHelpers.export(exports, "HeartIcon", ()=>(0, _heartJsDefault.default));
parcelHelpers.export(exports, "LucideHeart", ()=>(0, _heartJsDefault.default));
parcelHelpers.export(exports, "Heater", ()=>(0, _heaterJsDefault.default));
parcelHelpers.export(exports, "HeaterIcon", ()=>(0, _heaterJsDefault.default));
parcelHelpers.export(exports, "LucideHeater", ()=>(0, _heaterJsDefault.default));
parcelHelpers.export(exports, "Hexagon", ()=>(0, _hexagonJsDefault.default));
parcelHelpers.export(exports, "HexagonIcon", ()=>(0, _hexagonJsDefault.default));
parcelHelpers.export(exports, "LucideHexagon", ()=>(0, _hexagonJsDefault.default));
parcelHelpers.export(exports, "Highlighter", ()=>(0, _highlighterJsDefault.default));
parcelHelpers.export(exports, "HighlighterIcon", ()=>(0, _highlighterJsDefault.default));
parcelHelpers.export(exports, "LucideHighlighter", ()=>(0, _highlighterJsDefault.default));
parcelHelpers.export(exports, "History", ()=>(0, _historyJsDefault.default));
parcelHelpers.export(exports, "HistoryIcon", ()=>(0, _historyJsDefault.default));
parcelHelpers.export(exports, "LucideHistory", ()=>(0, _historyJsDefault.default));
parcelHelpers.export(exports, "HopOff", ()=>(0, _hopOffJsDefault.default));
parcelHelpers.export(exports, "HopOffIcon", ()=>(0, _hopOffJsDefault.default));
parcelHelpers.export(exports, "LucideHopOff", ()=>(0, _hopOffJsDefault.default));
parcelHelpers.export(exports, "Hop", ()=>(0, _hopJsDefault.default));
parcelHelpers.export(exports, "HopIcon", ()=>(0, _hopJsDefault.default));
parcelHelpers.export(exports, "LucideHop", ()=>(0, _hopJsDefault.default));
parcelHelpers.export(exports, "Hospital", ()=>(0, _hospitalJsDefault.default));
parcelHelpers.export(exports, "HospitalIcon", ()=>(0, _hospitalJsDefault.default));
parcelHelpers.export(exports, "LucideHospital", ()=>(0, _hospitalJsDefault.default));
parcelHelpers.export(exports, "Hotel", ()=>(0, _hotelJsDefault.default));
parcelHelpers.export(exports, "HotelIcon", ()=>(0, _hotelJsDefault.default));
parcelHelpers.export(exports, "LucideHotel", ()=>(0, _hotelJsDefault.default));
parcelHelpers.export(exports, "Hourglass", ()=>(0, _hourglassJsDefault.default));
parcelHelpers.export(exports, "HourglassIcon", ()=>(0, _hourglassJsDefault.default));
parcelHelpers.export(exports, "LucideHourglass", ()=>(0, _hourglassJsDefault.default));
parcelHelpers.export(exports, "HousePlug", ()=>(0, _housePlugJsDefault.default));
parcelHelpers.export(exports, "HousePlugIcon", ()=>(0, _housePlugJsDefault.default));
parcelHelpers.export(exports, "LucideHousePlug", ()=>(0, _housePlugJsDefault.default));
parcelHelpers.export(exports, "HousePlus", ()=>(0, _housePlusJsDefault.default));
parcelHelpers.export(exports, "HousePlusIcon", ()=>(0, _housePlusJsDefault.default));
parcelHelpers.export(exports, "LucideHousePlus", ()=>(0, _housePlusJsDefault.default));
parcelHelpers.export(exports, "HouseWifi", ()=>(0, _houseWifiJsDefault.default));
parcelHelpers.export(exports, "HouseWifiIcon", ()=>(0, _houseWifiJsDefault.default));
parcelHelpers.export(exports, "LucideHouseWifi", ()=>(0, _houseWifiJsDefault.default));
parcelHelpers.export(exports, "IdCardLanyard", ()=>(0, _idCardLanyardJsDefault.default));
parcelHelpers.export(exports, "IdCardLanyardIcon", ()=>(0, _idCardLanyardJsDefault.default));
parcelHelpers.export(exports, "LucideIdCardLanyard", ()=>(0, _idCardLanyardJsDefault.default));
parcelHelpers.export(exports, "IdCard", ()=>(0, _idCardJsDefault.default));
parcelHelpers.export(exports, "IdCardIcon", ()=>(0, _idCardJsDefault.default));
parcelHelpers.export(exports, "LucideIdCard", ()=>(0, _idCardJsDefault.default));
parcelHelpers.export(exports, "ImageDown", ()=>(0, _imageDownJsDefault.default));
parcelHelpers.export(exports, "ImageDownIcon", ()=>(0, _imageDownJsDefault.default));
parcelHelpers.export(exports, "LucideImageDown", ()=>(0, _imageDownJsDefault.default));
parcelHelpers.export(exports, "ImageMinus", ()=>(0, _imageMinusJsDefault.default));
parcelHelpers.export(exports, "ImageMinusIcon", ()=>(0, _imageMinusJsDefault.default));
parcelHelpers.export(exports, "LucideImageMinus", ()=>(0, _imageMinusJsDefault.default));
parcelHelpers.export(exports, "ImageOff", ()=>(0, _imageOffJsDefault.default));
parcelHelpers.export(exports, "ImageOffIcon", ()=>(0, _imageOffJsDefault.default));
parcelHelpers.export(exports, "LucideImageOff", ()=>(0, _imageOffJsDefault.default));
parcelHelpers.export(exports, "ImagePlay", ()=>(0, _imagePlayJsDefault.default));
parcelHelpers.export(exports, "ImagePlayIcon", ()=>(0, _imagePlayJsDefault.default));
parcelHelpers.export(exports, "LucideImagePlay", ()=>(0, _imagePlayJsDefault.default));
parcelHelpers.export(exports, "ImagePlus", ()=>(0, _imagePlusJsDefault.default));
parcelHelpers.export(exports, "ImagePlusIcon", ()=>(0, _imagePlusJsDefault.default));
parcelHelpers.export(exports, "LucideImagePlus", ()=>(0, _imagePlusJsDefault.default));
parcelHelpers.export(exports, "ImageUp", ()=>(0, _imageUpJsDefault.default));
parcelHelpers.export(exports, "ImageUpIcon", ()=>(0, _imageUpJsDefault.default));
parcelHelpers.export(exports, "LucideImageUp", ()=>(0, _imageUpJsDefault.default));
parcelHelpers.export(exports, "ImageUpscale", ()=>(0, _imageUpscaleJsDefault.default));
parcelHelpers.export(exports, "ImageUpscaleIcon", ()=>(0, _imageUpscaleJsDefault.default));
parcelHelpers.export(exports, "LucideImageUpscale", ()=>(0, _imageUpscaleJsDefault.default));
parcelHelpers.export(exports, "Image", ()=>(0, _imageJsDefault.default));
parcelHelpers.export(exports, "ImageIcon", ()=>(0, _imageJsDefault.default));
parcelHelpers.export(exports, "LucideImage", ()=>(0, _imageJsDefault.default));
parcelHelpers.export(exports, "Images", ()=>(0, _imagesJsDefault.default));
parcelHelpers.export(exports, "ImagesIcon", ()=>(0, _imagesJsDefault.default));
parcelHelpers.export(exports, "LucideImages", ()=>(0, _imagesJsDefault.default));
parcelHelpers.export(exports, "Import", ()=>(0, _importJsDefault.default));
parcelHelpers.export(exports, "ImportIcon", ()=>(0, _importJsDefault.default));
parcelHelpers.export(exports, "LucideImport", ()=>(0, _importJsDefault.default));
parcelHelpers.export(exports, "Inbox", ()=>(0, _inboxJsDefault.default));
parcelHelpers.export(exports, "InboxIcon", ()=>(0, _inboxJsDefault.default));
parcelHelpers.export(exports, "LucideInbox", ()=>(0, _inboxJsDefault.default));
parcelHelpers.export(exports, "IndianRupee", ()=>(0, _indianRupeeJsDefault.default));
parcelHelpers.export(exports, "IndianRupeeIcon", ()=>(0, _indianRupeeJsDefault.default));
parcelHelpers.export(exports, "LucideIndianRupee", ()=>(0, _indianRupeeJsDefault.default));
parcelHelpers.export(exports, "Infinity", ()=>(0, _infinityJsDefault.default));
parcelHelpers.export(exports, "InfinityIcon", ()=>(0, _infinityJsDefault.default));
parcelHelpers.export(exports, "LucideInfinity", ()=>(0, _infinityJsDefault.default));
parcelHelpers.export(exports, "Info", ()=>(0, _infoJsDefault.default));
parcelHelpers.export(exports, "InfoIcon", ()=>(0, _infoJsDefault.default));
parcelHelpers.export(exports, "LucideInfo", ()=>(0, _infoJsDefault.default));
parcelHelpers.export(exports, "InspectionPanel", ()=>(0, _inspectionPanelJsDefault.default));
parcelHelpers.export(exports, "InspectionPanelIcon", ()=>(0, _inspectionPanelJsDefault.default));
parcelHelpers.export(exports, "LucideInspectionPanel", ()=>(0, _inspectionPanelJsDefault.default));
parcelHelpers.export(exports, "Instagram", ()=>(0, _instagramJsDefault.default));
parcelHelpers.export(exports, "InstagramIcon", ()=>(0, _instagramJsDefault.default));
parcelHelpers.export(exports, "LucideInstagram", ()=>(0, _instagramJsDefault.default));
parcelHelpers.export(exports, "Italic", ()=>(0, _italicJsDefault.default));
parcelHelpers.export(exports, "ItalicIcon", ()=>(0, _italicJsDefault.default));
parcelHelpers.export(exports, "LucideItalic", ()=>(0, _italicJsDefault.default));
parcelHelpers.export(exports, "IterationCcw", ()=>(0, _iterationCcwJsDefault.default));
parcelHelpers.export(exports, "IterationCcwIcon", ()=>(0, _iterationCcwJsDefault.default));
parcelHelpers.export(exports, "LucideIterationCcw", ()=>(0, _iterationCcwJsDefault.default));
parcelHelpers.export(exports, "IterationCw", ()=>(0, _iterationCwJsDefault.default));
parcelHelpers.export(exports, "IterationCwIcon", ()=>(0, _iterationCwJsDefault.default));
parcelHelpers.export(exports, "LucideIterationCw", ()=>(0, _iterationCwJsDefault.default));
parcelHelpers.export(exports, "JapaneseYen", ()=>(0, _japaneseYenJsDefault.default));
parcelHelpers.export(exports, "JapaneseYenIcon", ()=>(0, _japaneseYenJsDefault.default));
parcelHelpers.export(exports, "LucideJapaneseYen", ()=>(0, _japaneseYenJsDefault.default));
parcelHelpers.export(exports, "Joystick", ()=>(0, _joystickJsDefault.default));
parcelHelpers.export(exports, "JoystickIcon", ()=>(0, _joystickJsDefault.default));
parcelHelpers.export(exports, "LucideJoystick", ()=>(0, _joystickJsDefault.default));
parcelHelpers.export(exports, "Kanban", ()=>(0, _kanbanJsDefault.default));
parcelHelpers.export(exports, "KanbanIcon", ()=>(0, _kanbanJsDefault.default));
parcelHelpers.export(exports, "LucideKanban", ()=>(0, _kanbanJsDefault.default));
parcelHelpers.export(exports, "KeyRound", ()=>(0, _keyRoundJsDefault.default));
parcelHelpers.export(exports, "KeyRoundIcon", ()=>(0, _keyRoundJsDefault.default));
parcelHelpers.export(exports, "LucideKeyRound", ()=>(0, _keyRoundJsDefault.default));
parcelHelpers.export(exports, "KeySquare", ()=>(0, _keySquareJsDefault.default));
parcelHelpers.export(exports, "KeySquareIcon", ()=>(0, _keySquareJsDefault.default));
parcelHelpers.export(exports, "LucideKeySquare", ()=>(0, _keySquareJsDefault.default));
parcelHelpers.export(exports, "Key", ()=>(0, _keyJsDefault.default));
parcelHelpers.export(exports, "KeyIcon", ()=>(0, _keyJsDefault.default));
parcelHelpers.export(exports, "LucideKey", ()=>(0, _keyJsDefault.default));
parcelHelpers.export(exports, "KeyboardOff", ()=>(0, _keyboardOffJsDefault.default));
parcelHelpers.export(exports, "KeyboardOffIcon", ()=>(0, _keyboardOffJsDefault.default));
parcelHelpers.export(exports, "LucideKeyboardOff", ()=>(0, _keyboardOffJsDefault.default));
parcelHelpers.export(exports, "KeyboardMusic", ()=>(0, _keyboardMusicJsDefault.default));
parcelHelpers.export(exports, "KeyboardMusicIcon", ()=>(0, _keyboardMusicJsDefault.default));
parcelHelpers.export(exports, "LucideKeyboardMusic", ()=>(0, _keyboardMusicJsDefault.default));
parcelHelpers.export(exports, "Keyboard", ()=>(0, _keyboardJsDefault.default));
parcelHelpers.export(exports, "KeyboardIcon", ()=>(0, _keyboardJsDefault.default));
parcelHelpers.export(exports, "LucideKeyboard", ()=>(0, _keyboardJsDefault.default));
parcelHelpers.export(exports, "LampCeiling", ()=>(0, _lampCeilingJsDefault.default));
parcelHelpers.export(exports, "LampCeilingIcon", ()=>(0, _lampCeilingJsDefault.default));
parcelHelpers.export(exports, "LucideLampCeiling", ()=>(0, _lampCeilingJsDefault.default));
parcelHelpers.export(exports, "LampDesk", ()=>(0, _lampDeskJsDefault.default));
parcelHelpers.export(exports, "LampDeskIcon", ()=>(0, _lampDeskJsDefault.default));
parcelHelpers.export(exports, "LucideLampDesk", ()=>(0, _lampDeskJsDefault.default));
parcelHelpers.export(exports, "LampFloor", ()=>(0, _lampFloorJsDefault.default));
parcelHelpers.export(exports, "LampFloorIcon", ()=>(0, _lampFloorJsDefault.default));
parcelHelpers.export(exports, "LucideLampFloor", ()=>(0, _lampFloorJsDefault.default));
parcelHelpers.export(exports, "LampWallDown", ()=>(0, _lampWallDownJsDefault.default));
parcelHelpers.export(exports, "LampWallDownIcon", ()=>(0, _lampWallDownJsDefault.default));
parcelHelpers.export(exports, "LucideLampWallDown", ()=>(0, _lampWallDownJsDefault.default));
parcelHelpers.export(exports, "LampWallUp", ()=>(0, _lampWallUpJsDefault.default));
parcelHelpers.export(exports, "LampWallUpIcon", ()=>(0, _lampWallUpJsDefault.default));
parcelHelpers.export(exports, "LucideLampWallUp", ()=>(0, _lampWallUpJsDefault.default));
parcelHelpers.export(exports, "Lamp", ()=>(0, _lampJsDefault.default));
parcelHelpers.export(exports, "LampIcon", ()=>(0, _lampJsDefault.default));
parcelHelpers.export(exports, "LucideLamp", ()=>(0, _lampJsDefault.default));
parcelHelpers.export(exports, "LandPlot", ()=>(0, _landPlotJsDefault.default));
parcelHelpers.export(exports, "LandPlotIcon", ()=>(0, _landPlotJsDefault.default));
parcelHelpers.export(exports, "LucideLandPlot", ()=>(0, _landPlotJsDefault.default));
parcelHelpers.export(exports, "Landmark", ()=>(0, _landmarkJsDefault.default));
parcelHelpers.export(exports, "LandmarkIcon", ()=>(0, _landmarkJsDefault.default));
parcelHelpers.export(exports, "LucideLandmark", ()=>(0, _landmarkJsDefault.default));
parcelHelpers.export(exports, "Languages", ()=>(0, _languagesJsDefault.default));
parcelHelpers.export(exports, "LanguagesIcon", ()=>(0, _languagesJsDefault.default));
parcelHelpers.export(exports, "LucideLanguages", ()=>(0, _languagesJsDefault.default));
parcelHelpers.export(exports, "LaptopMinimalCheck", ()=>(0, _laptopMinimalCheckJsDefault.default));
parcelHelpers.export(exports, "LaptopMinimalCheckIcon", ()=>(0, _laptopMinimalCheckJsDefault.default));
parcelHelpers.export(exports, "LucideLaptopMinimalCheck", ()=>(0, _laptopMinimalCheckJsDefault.default));
parcelHelpers.export(exports, "Laptop", ()=>(0, _laptopJsDefault.default));
parcelHelpers.export(exports, "LaptopIcon", ()=>(0, _laptopJsDefault.default));
parcelHelpers.export(exports, "LucideLaptop", ()=>(0, _laptopJsDefault.default));
parcelHelpers.export(exports, "LassoSelect", ()=>(0, _lassoSelectJsDefault.default));
parcelHelpers.export(exports, "LassoSelectIcon", ()=>(0, _lassoSelectJsDefault.default));
parcelHelpers.export(exports, "LucideLassoSelect", ()=>(0, _lassoSelectJsDefault.default));
parcelHelpers.export(exports, "Lasso", ()=>(0, _lassoJsDefault.default));
parcelHelpers.export(exports, "LassoIcon", ()=>(0, _lassoJsDefault.default));
parcelHelpers.export(exports, "LucideLasso", ()=>(0, _lassoJsDefault.default));
parcelHelpers.export(exports, "Laugh", ()=>(0, _laughJsDefault.default));
parcelHelpers.export(exports, "LaughIcon", ()=>(0, _laughJsDefault.default));
parcelHelpers.export(exports, "LucideLaugh", ()=>(0, _laughJsDefault.default));
parcelHelpers.export(exports, "Layers2", ()=>(0, _layers2JsDefault.default));
parcelHelpers.export(exports, "Layers2Icon", ()=>(0, _layers2JsDefault.default));
parcelHelpers.export(exports, "LucideLayers2", ()=>(0, _layers2JsDefault.default));
parcelHelpers.export(exports, "LayoutDashboard", ()=>(0, _layoutDashboardJsDefault.default));
parcelHelpers.export(exports, "LayoutDashboardIcon", ()=>(0, _layoutDashboardJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutDashboard", ()=>(0, _layoutDashboardJsDefault.default));
parcelHelpers.export(exports, "LayoutGrid", ()=>(0, _layoutGridJsDefault.default));
parcelHelpers.export(exports, "LayoutGridIcon", ()=>(0, _layoutGridJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutGrid", ()=>(0, _layoutGridJsDefault.default));
parcelHelpers.export(exports, "LayoutList", ()=>(0, _layoutListJsDefault.default));
parcelHelpers.export(exports, "LayoutListIcon", ()=>(0, _layoutListJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutList", ()=>(0, _layoutListJsDefault.default));
parcelHelpers.export(exports, "LayoutPanelLeft", ()=>(0, _layoutPanelLeftJsDefault.default));
parcelHelpers.export(exports, "LayoutPanelLeftIcon", ()=>(0, _layoutPanelLeftJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutPanelLeft", ()=>(0, _layoutPanelLeftJsDefault.default));
parcelHelpers.export(exports, "LayoutPanelTop", ()=>(0, _layoutPanelTopJsDefault.default));
parcelHelpers.export(exports, "LayoutPanelTopIcon", ()=>(0, _layoutPanelTopJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutPanelTop", ()=>(0, _layoutPanelTopJsDefault.default));
parcelHelpers.export(exports, "LeafyGreen", ()=>(0, _leafyGreenJsDefault.default));
parcelHelpers.export(exports, "LeafyGreenIcon", ()=>(0, _leafyGreenJsDefault.default));
parcelHelpers.export(exports, "LucideLeafyGreen", ()=>(0, _leafyGreenJsDefault.default));
parcelHelpers.export(exports, "LayoutTemplate", ()=>(0, _layoutTemplateJsDefault.default));
parcelHelpers.export(exports, "LayoutTemplateIcon", ()=>(0, _layoutTemplateJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutTemplate", ()=>(0, _layoutTemplateJsDefault.default));
parcelHelpers.export(exports, "Leaf", ()=>(0, _leafJsDefault.default));
parcelHelpers.export(exports, "LeafIcon", ()=>(0, _leafJsDefault.default));
parcelHelpers.export(exports, "LucideLeaf", ()=>(0, _leafJsDefault.default));
parcelHelpers.export(exports, "Lectern", ()=>(0, _lecternJsDefault.default));
parcelHelpers.export(exports, "LecternIcon", ()=>(0, _lecternJsDefault.default));
parcelHelpers.export(exports, "LucideLectern", ()=>(0, _lecternJsDefault.default));
parcelHelpers.export(exports, "LetterText", ()=>(0, _letterTextJsDefault.default));
parcelHelpers.export(exports, "LetterTextIcon", ()=>(0, _letterTextJsDefault.default));
parcelHelpers.export(exports, "LucideLetterText", ()=>(0, _letterTextJsDefault.default));
parcelHelpers.export(exports, "LibraryBig", ()=>(0, _libraryBigJsDefault.default));
parcelHelpers.export(exports, "LibraryBigIcon", ()=>(0, _libraryBigJsDefault.default));
parcelHelpers.export(exports, "LucideLibraryBig", ()=>(0, _libraryBigJsDefault.default));
parcelHelpers.export(exports, "Library", ()=>(0, _libraryJsDefault.default));
parcelHelpers.export(exports, "LibraryIcon", ()=>(0, _libraryJsDefault.default));
parcelHelpers.export(exports, "LucideLibrary", ()=>(0, _libraryJsDefault.default));
parcelHelpers.export(exports, "LifeBuoy", ()=>(0, _lifeBuoyJsDefault.default));
parcelHelpers.export(exports, "LifeBuoyIcon", ()=>(0, _lifeBuoyJsDefault.default));
parcelHelpers.export(exports, "LucideLifeBuoy", ()=>(0, _lifeBuoyJsDefault.default));
parcelHelpers.export(exports, "Ligature", ()=>(0, _ligatureJsDefault.default));
parcelHelpers.export(exports, "LigatureIcon", ()=>(0, _ligatureJsDefault.default));
parcelHelpers.export(exports, "LucideLigature", ()=>(0, _ligatureJsDefault.default));
parcelHelpers.export(exports, "LightbulbOff", ()=>(0, _lightbulbOffJsDefault.default));
parcelHelpers.export(exports, "LightbulbOffIcon", ()=>(0, _lightbulbOffJsDefault.default));
parcelHelpers.export(exports, "LucideLightbulbOff", ()=>(0, _lightbulbOffJsDefault.default));
parcelHelpers.export(exports, "Lightbulb", ()=>(0, _lightbulbJsDefault.default));
parcelHelpers.export(exports, "LightbulbIcon", ()=>(0, _lightbulbJsDefault.default));
parcelHelpers.export(exports, "LucideLightbulb", ()=>(0, _lightbulbJsDefault.default));
parcelHelpers.export(exports, "Link2Off", ()=>(0, _link2OffJsDefault.default));
parcelHelpers.export(exports, "Link2OffIcon", ()=>(0, _link2OffJsDefault.default));
parcelHelpers.export(exports, "LucideLink2Off", ()=>(0, _link2OffJsDefault.default));
parcelHelpers.export(exports, "Link", ()=>(0, _linkJsDefault.default));
parcelHelpers.export(exports, "LinkIcon", ()=>(0, _linkJsDefault.default));
parcelHelpers.export(exports, "LucideLink", ()=>(0, _linkJsDefault.default));
parcelHelpers.export(exports, "Link2", ()=>(0, _link2JsDefault.default));
parcelHelpers.export(exports, "Link2Icon", ()=>(0, _link2JsDefault.default));
parcelHelpers.export(exports, "LucideLink2", ()=>(0, _link2JsDefault.default));
parcelHelpers.export(exports, "Linkedin", ()=>(0, _linkedinJsDefault.default));
parcelHelpers.export(exports, "LinkedinIcon", ()=>(0, _linkedinJsDefault.default));
parcelHelpers.export(exports, "LucideLinkedin", ()=>(0, _linkedinJsDefault.default));
parcelHelpers.export(exports, "ListCheck", ()=>(0, _listCheckJsDefault.default));
parcelHelpers.export(exports, "ListCheckIcon", ()=>(0, _listCheckJsDefault.default));
parcelHelpers.export(exports, "LucideListCheck", ()=>(0, _listCheckJsDefault.default));
parcelHelpers.export(exports, "ListChecks", ()=>(0, _listChecksJsDefault.default));
parcelHelpers.export(exports, "ListChecksIcon", ()=>(0, _listChecksJsDefault.default));
parcelHelpers.export(exports, "LucideListChecks", ()=>(0, _listChecksJsDefault.default));
parcelHelpers.export(exports, "ListCollapse", ()=>(0, _listCollapseJsDefault.default));
parcelHelpers.export(exports, "ListCollapseIcon", ()=>(0, _listCollapseJsDefault.default));
parcelHelpers.export(exports, "LucideListCollapse", ()=>(0, _listCollapseJsDefault.default));
parcelHelpers.export(exports, "ListEnd", ()=>(0, _listEndJsDefault.default));
parcelHelpers.export(exports, "ListEndIcon", ()=>(0, _listEndJsDefault.default));
parcelHelpers.export(exports, "LucideListEnd", ()=>(0, _listEndJsDefault.default));
parcelHelpers.export(exports, "ListFilterPlus", ()=>(0, _listFilterPlusJsDefault.default));
parcelHelpers.export(exports, "ListFilterPlusIcon", ()=>(0, _listFilterPlusJsDefault.default));
parcelHelpers.export(exports, "LucideListFilterPlus", ()=>(0, _listFilterPlusJsDefault.default));
parcelHelpers.export(exports, "ListFilter", ()=>(0, _listFilterJsDefault.default));
parcelHelpers.export(exports, "ListFilterIcon", ()=>(0, _listFilterJsDefault.default));
parcelHelpers.export(exports, "LucideListFilter", ()=>(0, _listFilterJsDefault.default));
parcelHelpers.export(exports, "ListMinus", ()=>(0, _listMinusJsDefault.default));
parcelHelpers.export(exports, "ListMinusIcon", ()=>(0, _listMinusJsDefault.default));
parcelHelpers.export(exports, "LucideListMinus", ()=>(0, _listMinusJsDefault.default));
parcelHelpers.export(exports, "ListMusic", ()=>(0, _listMusicJsDefault.default));
parcelHelpers.export(exports, "ListMusicIcon", ()=>(0, _listMusicJsDefault.default));
parcelHelpers.export(exports, "LucideListMusic", ()=>(0, _listMusicJsDefault.default));
parcelHelpers.export(exports, "ListOrdered", ()=>(0, _listOrderedJsDefault.default));
parcelHelpers.export(exports, "ListOrderedIcon", ()=>(0, _listOrderedJsDefault.default));
parcelHelpers.export(exports, "LucideListOrdered", ()=>(0, _listOrderedJsDefault.default));
parcelHelpers.export(exports, "ListPlus", ()=>(0, _listPlusJsDefault.default));
parcelHelpers.export(exports, "ListPlusIcon", ()=>(0, _listPlusJsDefault.default));
parcelHelpers.export(exports, "LucideListPlus", ()=>(0, _listPlusJsDefault.default));
parcelHelpers.export(exports, "ListRestart", ()=>(0, _listRestartJsDefault.default));
parcelHelpers.export(exports, "ListRestartIcon", ()=>(0, _listRestartJsDefault.default));
parcelHelpers.export(exports, "LucideListRestart", ()=>(0, _listRestartJsDefault.default));
parcelHelpers.export(exports, "ListTodo", ()=>(0, _listTodoJsDefault.default));
parcelHelpers.export(exports, "ListTodoIcon", ()=>(0, _listTodoJsDefault.default));
parcelHelpers.export(exports, "LucideListTodo", ()=>(0, _listTodoJsDefault.default));
parcelHelpers.export(exports, "ListTree", ()=>(0, _listTreeJsDefault.default));
parcelHelpers.export(exports, "ListTreeIcon", ()=>(0, _listTreeJsDefault.default));
parcelHelpers.export(exports, "LucideListTree", ()=>(0, _listTreeJsDefault.default));
parcelHelpers.export(exports, "ListStart", ()=>(0, _listStartJsDefault.default));
parcelHelpers.export(exports, "ListStartIcon", ()=>(0, _listStartJsDefault.default));
parcelHelpers.export(exports, "LucideListStart", ()=>(0, _listStartJsDefault.default));
parcelHelpers.export(exports, "ListVideo", ()=>(0, _listVideoJsDefault.default));
parcelHelpers.export(exports, "ListVideoIcon", ()=>(0, _listVideoJsDefault.default));
parcelHelpers.export(exports, "LucideListVideo", ()=>(0, _listVideoJsDefault.default));
parcelHelpers.export(exports, "ListX", ()=>(0, _listXJsDefault.default));
parcelHelpers.export(exports, "ListXIcon", ()=>(0, _listXJsDefault.default));
parcelHelpers.export(exports, "LucideListX", ()=>(0, _listXJsDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listJsDefault.default));
parcelHelpers.export(exports, "ListIcon", ()=>(0, _listJsDefault.default));
parcelHelpers.export(exports, "LucideList", ()=>(0, _listJsDefault.default));
parcelHelpers.export(exports, "LoaderPinwheel", ()=>(0, _loaderPinwheelJsDefault.default));
parcelHelpers.export(exports, "LoaderPinwheelIcon", ()=>(0, _loaderPinwheelJsDefault.default));
parcelHelpers.export(exports, "LucideLoaderPinwheel", ()=>(0, _loaderPinwheelJsDefault.default));
parcelHelpers.export(exports, "Loader", ()=>(0, _loaderJsDefault.default));
parcelHelpers.export(exports, "LoaderIcon", ()=>(0, _loaderJsDefault.default));
parcelHelpers.export(exports, "LucideLoader", ()=>(0, _loaderJsDefault.default));
parcelHelpers.export(exports, "LocateFixed", ()=>(0, _locateFixedJsDefault.default));
parcelHelpers.export(exports, "LocateFixedIcon", ()=>(0, _locateFixedJsDefault.default));
parcelHelpers.export(exports, "LucideLocateFixed", ()=>(0, _locateFixedJsDefault.default));
parcelHelpers.export(exports, "LocateOff", ()=>(0, _locateOffJsDefault.default));
parcelHelpers.export(exports, "LocateOffIcon", ()=>(0, _locateOffJsDefault.default));
parcelHelpers.export(exports, "LucideLocateOff", ()=>(0, _locateOffJsDefault.default));
parcelHelpers.export(exports, "Locate", ()=>(0, _locateJsDefault.default));
parcelHelpers.export(exports, "LocateIcon", ()=>(0, _locateJsDefault.default));
parcelHelpers.export(exports, "LucideLocate", ()=>(0, _locateJsDefault.default));
parcelHelpers.export(exports, "LocationEdit", ()=>(0, _locationEditJsDefault.default));
parcelHelpers.export(exports, "LocationEditIcon", ()=>(0, _locationEditJsDefault.default));
parcelHelpers.export(exports, "LucideLocationEdit", ()=>(0, _locationEditJsDefault.default));
parcelHelpers.export(exports, "LockKeyhole", ()=>(0, _lockKeyholeJsDefault.default));
parcelHelpers.export(exports, "LockKeyholeIcon", ()=>(0, _lockKeyholeJsDefault.default));
parcelHelpers.export(exports, "LucideLockKeyhole", ()=>(0, _lockKeyholeJsDefault.default));
parcelHelpers.export(exports, "Lock", ()=>(0, _lockJsDefault.default));
parcelHelpers.export(exports, "LockIcon", ()=>(0, _lockJsDefault.default));
parcelHelpers.export(exports, "LucideLock", ()=>(0, _lockJsDefault.default));
parcelHelpers.export(exports, "LogIn", ()=>(0, _logInJsDefault.default));
parcelHelpers.export(exports, "LogInIcon", ()=>(0, _logInJsDefault.default));
parcelHelpers.export(exports, "LucideLogIn", ()=>(0, _logInJsDefault.default));
parcelHelpers.export(exports, "LogOut", ()=>(0, _logOutJsDefault.default));
parcelHelpers.export(exports, "LogOutIcon", ()=>(0, _logOutJsDefault.default));
parcelHelpers.export(exports, "LucideLogOut", ()=>(0, _logOutJsDefault.default));
parcelHelpers.export(exports, "Logs", ()=>(0, _logsJsDefault.default));
parcelHelpers.export(exports, "LogsIcon", ()=>(0, _logsJsDefault.default));
parcelHelpers.export(exports, "LucideLogs", ()=>(0, _logsJsDefault.default));
parcelHelpers.export(exports, "Lollipop", ()=>(0, _lollipopJsDefault.default));
parcelHelpers.export(exports, "LollipopIcon", ()=>(0, _lollipopJsDefault.default));
parcelHelpers.export(exports, "LucideLollipop", ()=>(0, _lollipopJsDefault.default));
parcelHelpers.export(exports, "LucideLuggage", ()=>(0, _luggageJsDefault.default));
parcelHelpers.export(exports, "Luggage", ()=>(0, _luggageJsDefault.default));
parcelHelpers.export(exports, "LuggageIcon", ()=>(0, _luggageJsDefault.default));
parcelHelpers.export(exports, "LucideMagnet", ()=>(0, _magnetJsDefault.default));
parcelHelpers.export(exports, "Magnet", ()=>(0, _magnetJsDefault.default));
parcelHelpers.export(exports, "MagnetIcon", ()=>(0, _magnetJsDefault.default));
parcelHelpers.export(exports, "LucideMailCheck", ()=>(0, _mailCheckJsDefault.default));
parcelHelpers.export(exports, "MailCheck", ()=>(0, _mailCheckJsDefault.default));
parcelHelpers.export(exports, "MailCheckIcon", ()=>(0, _mailCheckJsDefault.default));
parcelHelpers.export(exports, "LucideMailOpen", ()=>(0, _mailOpenJsDefault.default));
parcelHelpers.export(exports, "MailOpen", ()=>(0, _mailOpenJsDefault.default));
parcelHelpers.export(exports, "MailOpenIcon", ()=>(0, _mailOpenJsDefault.default));
parcelHelpers.export(exports, "LucideMailQuestion", ()=>(0, _mailQuestionJsDefault.default));
parcelHelpers.export(exports, "MailQuestion", ()=>(0, _mailQuestionJsDefault.default));
parcelHelpers.export(exports, "MailQuestionIcon", ()=>(0, _mailQuestionJsDefault.default));
parcelHelpers.export(exports, "LucideMailPlus", ()=>(0, _mailPlusJsDefault.default));
parcelHelpers.export(exports, "MailPlus", ()=>(0, _mailPlusJsDefault.default));
parcelHelpers.export(exports, "MailPlusIcon", ()=>(0, _mailPlusJsDefault.default));
parcelHelpers.export(exports, "LucideMailMinus", ()=>(0, _mailMinusJsDefault.default));
parcelHelpers.export(exports, "MailMinus", ()=>(0, _mailMinusJsDefault.default));
parcelHelpers.export(exports, "MailMinusIcon", ()=>(0, _mailMinusJsDefault.default));
parcelHelpers.export(exports, "LucideMailSearch", ()=>(0, _mailSearchJsDefault.default));
parcelHelpers.export(exports, "MailSearch", ()=>(0, _mailSearchJsDefault.default));
parcelHelpers.export(exports, "MailSearchIcon", ()=>(0, _mailSearchJsDefault.default));
parcelHelpers.export(exports, "LucideMailWarning", ()=>(0, _mailWarningJsDefault.default));
parcelHelpers.export(exports, "MailWarning", ()=>(0, _mailWarningJsDefault.default));
parcelHelpers.export(exports, "MailWarningIcon", ()=>(0, _mailWarningJsDefault.default));
parcelHelpers.export(exports, "LucideMailX", ()=>(0, _mailXJsDefault.default));
parcelHelpers.export(exports, "MailX", ()=>(0, _mailXJsDefault.default));
parcelHelpers.export(exports, "MailXIcon", ()=>(0, _mailXJsDefault.default));
parcelHelpers.export(exports, "LucideMailbox", ()=>(0, _mailboxJsDefault.default));
parcelHelpers.export(exports, "Mailbox", ()=>(0, _mailboxJsDefault.default));
parcelHelpers.export(exports, "MailboxIcon", ()=>(0, _mailboxJsDefault.default));
parcelHelpers.export(exports, "LucideMail", ()=>(0, _mailJsDefault.default));
parcelHelpers.export(exports, "Mail", ()=>(0, _mailJsDefault.default));
parcelHelpers.export(exports, "MailIcon", ()=>(0, _mailJsDefault.default));
parcelHelpers.export(exports, "LucideMails", ()=>(0, _mailsJsDefault.default));
parcelHelpers.export(exports, "Mails", ()=>(0, _mailsJsDefault.default));
parcelHelpers.export(exports, "MailsIcon", ()=>(0, _mailsJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinCheckInside", ()=>(0, _mapPinCheckInsideJsDefault.default));
parcelHelpers.export(exports, "MapPinCheckInside", ()=>(0, _mapPinCheckInsideJsDefault.default));
parcelHelpers.export(exports, "MapPinCheckInsideIcon", ()=>(0, _mapPinCheckInsideJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinCheck", ()=>(0, _mapPinCheckJsDefault.default));
parcelHelpers.export(exports, "MapPinCheck", ()=>(0, _mapPinCheckJsDefault.default));
parcelHelpers.export(exports, "MapPinCheckIcon", ()=>(0, _mapPinCheckJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinHouse", ()=>(0, _mapPinHouseJsDefault.default));
parcelHelpers.export(exports, "MapPinHouse", ()=>(0, _mapPinHouseJsDefault.default));
parcelHelpers.export(exports, "MapPinHouseIcon", ()=>(0, _mapPinHouseJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinMinusInside", ()=>(0, _mapPinMinusInsideJsDefault.default));
parcelHelpers.export(exports, "MapPinMinusInside", ()=>(0, _mapPinMinusInsideJsDefault.default));
parcelHelpers.export(exports, "MapPinMinusInsideIcon", ()=>(0, _mapPinMinusInsideJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinMinus", ()=>(0, _mapPinMinusJsDefault.default));
parcelHelpers.export(exports, "MapPinMinus", ()=>(0, _mapPinMinusJsDefault.default));
parcelHelpers.export(exports, "MapPinMinusIcon", ()=>(0, _mapPinMinusJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinPlusInside", ()=>(0, _mapPinPlusInsideJsDefault.default));
parcelHelpers.export(exports, "MapPinPlusInside", ()=>(0, _mapPinPlusInsideJsDefault.default));
parcelHelpers.export(exports, "MapPinPlusInsideIcon", ()=>(0, _mapPinPlusInsideJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinOff", ()=>(0, _mapPinOffJsDefault.default));
parcelHelpers.export(exports, "MapPinOff", ()=>(0, _mapPinOffJsDefault.default));
parcelHelpers.export(exports, "MapPinOffIcon", ()=>(0, _mapPinOffJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinPlus", ()=>(0, _mapPinPlusJsDefault.default));
parcelHelpers.export(exports, "MapPinPlus", ()=>(0, _mapPinPlusJsDefault.default));
parcelHelpers.export(exports, "MapPinPlusIcon", ()=>(0, _mapPinPlusJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinXInside", ()=>(0, _mapPinXInsideJsDefault.default));
parcelHelpers.export(exports, "MapPinXInside", ()=>(0, _mapPinXInsideJsDefault.default));
parcelHelpers.export(exports, "MapPinXInsideIcon", ()=>(0, _mapPinXInsideJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinX", ()=>(0, _mapPinXJsDefault.default));
parcelHelpers.export(exports, "MapPinX", ()=>(0, _mapPinXJsDefault.default));
parcelHelpers.export(exports, "MapPinXIcon", ()=>(0, _mapPinXJsDefault.default));
parcelHelpers.export(exports, "LucideMapPin", ()=>(0, _mapPinJsDefault.default));
parcelHelpers.export(exports, "MapPin", ()=>(0, _mapPinJsDefault.default));
parcelHelpers.export(exports, "MapPinIcon", ()=>(0, _mapPinJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinned", ()=>(0, _mapPinnedJsDefault.default));
parcelHelpers.export(exports, "MapPinned", ()=>(0, _mapPinnedJsDefault.default));
parcelHelpers.export(exports, "MapPinnedIcon", ()=>(0, _mapPinnedJsDefault.default));
parcelHelpers.export(exports, "LucideMapPlus", ()=>(0, _mapPlusJsDefault.default));
parcelHelpers.export(exports, "MapPlus", ()=>(0, _mapPlusJsDefault.default));
parcelHelpers.export(exports, "MapPlusIcon", ()=>(0, _mapPlusJsDefault.default));
parcelHelpers.export(exports, "LucideMap", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "Map", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "MapIcon", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "LucideMartini", ()=>(0, _martiniJsDefault.default));
parcelHelpers.export(exports, "Martini", ()=>(0, _martiniJsDefault.default));
parcelHelpers.export(exports, "MartiniIcon", ()=>(0, _martiniJsDefault.default));
parcelHelpers.export(exports, "LucideMarsStroke", ()=>(0, _marsStrokeJsDefault.default));
parcelHelpers.export(exports, "MarsStroke", ()=>(0, _marsStrokeJsDefault.default));
parcelHelpers.export(exports, "MarsStrokeIcon", ()=>(0, _marsStrokeJsDefault.default));
parcelHelpers.export(exports, "LucideMars", ()=>(0, _marsJsDefault.default));
parcelHelpers.export(exports, "Mars", ()=>(0, _marsJsDefault.default));
parcelHelpers.export(exports, "MarsIcon", ()=>(0, _marsJsDefault.default));
parcelHelpers.export(exports, "LucideMaximize2", ()=>(0, _maximize2JsDefault.default));
parcelHelpers.export(exports, "Maximize2", ()=>(0, _maximize2JsDefault.default));
parcelHelpers.export(exports, "Maximize2Icon", ()=>(0, _maximize2JsDefault.default));
parcelHelpers.export(exports, "LucideMaximize", ()=>(0, _maximizeJsDefault.default));
parcelHelpers.export(exports, "Maximize", ()=>(0, _maximizeJsDefault.default));
parcelHelpers.export(exports, "MaximizeIcon", ()=>(0, _maximizeJsDefault.default));
parcelHelpers.export(exports, "LucideMedal", ()=>(0, _medalJsDefault.default));
parcelHelpers.export(exports, "Medal", ()=>(0, _medalJsDefault.default));
parcelHelpers.export(exports, "MedalIcon", ()=>(0, _medalJsDefault.default));
parcelHelpers.export(exports, "LucideMegaphoneOff", ()=>(0, _megaphoneOffJsDefault.default));
parcelHelpers.export(exports, "MegaphoneOff", ()=>(0, _megaphoneOffJsDefault.default));
parcelHelpers.export(exports, "MegaphoneOffIcon", ()=>(0, _megaphoneOffJsDefault.default));
parcelHelpers.export(exports, "LucideMegaphone", ()=>(0, _megaphoneJsDefault.default));
parcelHelpers.export(exports, "Megaphone", ()=>(0, _megaphoneJsDefault.default));
parcelHelpers.export(exports, "MegaphoneIcon", ()=>(0, _megaphoneJsDefault.default));
parcelHelpers.export(exports, "LucideMemoryStick", ()=>(0, _memoryStickJsDefault.default));
parcelHelpers.export(exports, "MemoryStick", ()=>(0, _memoryStickJsDefault.default));
parcelHelpers.export(exports, "MemoryStickIcon", ()=>(0, _memoryStickJsDefault.default));
parcelHelpers.export(exports, "LucideMeh", ()=>(0, _mehJsDefault.default));
parcelHelpers.export(exports, "Meh", ()=>(0, _mehJsDefault.default));
parcelHelpers.export(exports, "MehIcon", ()=>(0, _mehJsDefault.default));
parcelHelpers.export(exports, "LucideMenu", ()=>(0, _menuJsDefault.default));
parcelHelpers.export(exports, "Menu", ()=>(0, _menuJsDefault.default));
parcelHelpers.export(exports, "MenuIcon", ()=>(0, _menuJsDefault.default));
parcelHelpers.export(exports, "LucideMerge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "Merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "MergeIcon", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleCode", ()=>(0, _messageCircleCodeJsDefault.default));
parcelHelpers.export(exports, "MessageCircleCode", ()=>(0, _messageCircleCodeJsDefault.default));
parcelHelpers.export(exports, "MessageCircleCodeIcon", ()=>(0, _messageCircleCodeJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleDashed", ()=>(0, _messageCircleDashedJsDefault.default));
parcelHelpers.export(exports, "MessageCircleDashed", ()=>(0, _messageCircleDashedJsDefault.default));
parcelHelpers.export(exports, "MessageCircleDashedIcon", ()=>(0, _messageCircleDashedJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleHeart", ()=>(0, _messageCircleHeartJsDefault.default));
parcelHelpers.export(exports, "MessageCircleHeart", ()=>(0, _messageCircleHeartJsDefault.default));
parcelHelpers.export(exports, "MessageCircleHeartIcon", ()=>(0, _messageCircleHeartJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleMore", ()=>(0, _messageCircleMoreJsDefault.default));
parcelHelpers.export(exports, "MessageCircleMore", ()=>(0, _messageCircleMoreJsDefault.default));
parcelHelpers.export(exports, "MessageCircleMoreIcon", ()=>(0, _messageCircleMoreJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCirclePlus", ()=>(0, _messageCirclePlusJsDefault.default));
parcelHelpers.export(exports, "MessageCirclePlus", ()=>(0, _messageCirclePlusJsDefault.default));
parcelHelpers.export(exports, "MessageCirclePlusIcon", ()=>(0, _messageCirclePlusJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleOff", ()=>(0, _messageCircleOffJsDefault.default));
parcelHelpers.export(exports, "MessageCircleOff", ()=>(0, _messageCircleOffJsDefault.default));
parcelHelpers.export(exports, "MessageCircleOffIcon", ()=>(0, _messageCircleOffJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleQuestion", ()=>(0, _messageCircleQuestionJsDefault.default));
parcelHelpers.export(exports, "MessageCircleQuestion", ()=>(0, _messageCircleQuestionJsDefault.default));
parcelHelpers.export(exports, "MessageCircleQuestionIcon", ()=>(0, _messageCircleQuestionJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleReply", ()=>(0, _messageCircleReplyJsDefault.default));
parcelHelpers.export(exports, "MessageCircleReply", ()=>(0, _messageCircleReplyJsDefault.default));
parcelHelpers.export(exports, "MessageCircleReplyIcon", ()=>(0, _messageCircleReplyJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleWarning", ()=>(0, _messageCircleWarningJsDefault.default));
parcelHelpers.export(exports, "MessageCircleWarning", ()=>(0, _messageCircleWarningJsDefault.default));
parcelHelpers.export(exports, "MessageCircleWarningIcon", ()=>(0, _messageCircleWarningJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleX", ()=>(0, _messageCircleXJsDefault.default));
parcelHelpers.export(exports, "MessageCircleX", ()=>(0, _messageCircleXJsDefault.default));
parcelHelpers.export(exports, "MessageCircleXIcon", ()=>(0, _messageCircleXJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircle", ()=>(0, _messageCircleJsDefault.default));
parcelHelpers.export(exports, "MessageCircle", ()=>(0, _messageCircleJsDefault.default));
parcelHelpers.export(exports, "MessageCircleIcon", ()=>(0, _messageCircleJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareCode", ()=>(0, _messageSquareCodeJsDefault.default));
parcelHelpers.export(exports, "MessageSquareCode", ()=>(0, _messageSquareCodeJsDefault.default));
parcelHelpers.export(exports, "MessageSquareCodeIcon", ()=>(0, _messageSquareCodeJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareDashed", ()=>(0, _messageSquareDashedJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDashed", ()=>(0, _messageSquareDashedJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDashedIcon", ()=>(0, _messageSquareDashedJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareDiff", ()=>(0, _messageSquareDiffJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDiff", ()=>(0, _messageSquareDiffJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDiffIcon", ()=>(0, _messageSquareDiffJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareHeart", ()=>(0, _messageSquareHeartJsDefault.default));
parcelHelpers.export(exports, "MessageSquareHeart", ()=>(0, _messageSquareHeartJsDefault.default));
parcelHelpers.export(exports, "MessageSquareHeartIcon", ()=>(0, _messageSquareHeartJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareDot", ()=>(0, _messageSquareDotJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDot", ()=>(0, _messageSquareDotJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDotIcon", ()=>(0, _messageSquareDotJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareLock", ()=>(0, _messageSquareLockJsDefault.default));
parcelHelpers.export(exports, "MessageSquareLock", ()=>(0, _messageSquareLockJsDefault.default));
parcelHelpers.export(exports, "MessageSquareLockIcon", ()=>(0, _messageSquareLockJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareMore", ()=>(0, _messageSquareMoreJsDefault.default));
parcelHelpers.export(exports, "MessageSquareMore", ()=>(0, _messageSquareMoreJsDefault.default));
parcelHelpers.export(exports, "MessageSquareMoreIcon", ()=>(0, _messageSquareMoreJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareOff", ()=>(0, _messageSquareOffJsDefault.default));
parcelHelpers.export(exports, "MessageSquareOff", ()=>(0, _messageSquareOffJsDefault.default));
parcelHelpers.export(exports, "MessageSquareOffIcon", ()=>(0, _messageSquareOffJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquarePlus", ()=>(0, _messageSquarePlusJsDefault.default));
parcelHelpers.export(exports, "MessageSquarePlus", ()=>(0, _messageSquarePlusJsDefault.default));
parcelHelpers.export(exports, "MessageSquarePlusIcon", ()=>(0, _messageSquarePlusJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareQuote", ()=>(0, _messageSquareQuoteJsDefault.default));
parcelHelpers.export(exports, "MessageSquareQuote", ()=>(0, _messageSquareQuoteJsDefault.default));
parcelHelpers.export(exports, "MessageSquareQuoteIcon", ()=>(0, _messageSquareQuoteJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareReply", ()=>(0, _messageSquareReplyJsDefault.default));
parcelHelpers.export(exports, "MessageSquareReply", ()=>(0, _messageSquareReplyJsDefault.default));
parcelHelpers.export(exports, "MessageSquareReplyIcon", ()=>(0, _messageSquareReplyJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareShare", ()=>(0, _messageSquareShareJsDefault.default));
parcelHelpers.export(exports, "MessageSquareShare", ()=>(0, _messageSquareShareJsDefault.default));
parcelHelpers.export(exports, "MessageSquareShareIcon", ()=>(0, _messageSquareShareJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareText", ()=>(0, _messageSquareTextJsDefault.default));
parcelHelpers.export(exports, "MessageSquareText", ()=>(0, _messageSquareTextJsDefault.default));
parcelHelpers.export(exports, "MessageSquareTextIcon", ()=>(0, _messageSquareTextJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareWarning", ()=>(0, _messageSquareWarningJsDefault.default));
parcelHelpers.export(exports, "MessageSquareWarning", ()=>(0, _messageSquareWarningJsDefault.default));
parcelHelpers.export(exports, "MessageSquareWarningIcon", ()=>(0, _messageSquareWarningJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareX", ()=>(0, _messageSquareXJsDefault.default));
parcelHelpers.export(exports, "MessageSquareX", ()=>(0, _messageSquareXJsDefault.default));
parcelHelpers.export(exports, "MessageSquareXIcon", ()=>(0, _messageSquareXJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquare", ()=>(0, _messageSquareJsDefault.default));
parcelHelpers.export(exports, "MessageSquare", ()=>(0, _messageSquareJsDefault.default));
parcelHelpers.export(exports, "MessageSquareIcon", ()=>(0, _messageSquareJsDefault.default));
parcelHelpers.export(exports, "LucideMessagesSquare", ()=>(0, _messagesSquareJsDefault.default));
parcelHelpers.export(exports, "MessagesSquare", ()=>(0, _messagesSquareJsDefault.default));
parcelHelpers.export(exports, "MessagesSquareIcon", ()=>(0, _messagesSquareJsDefault.default));
parcelHelpers.export(exports, "LucideMicOff", ()=>(0, _micOffJsDefault.default));
parcelHelpers.export(exports, "MicOff", ()=>(0, _micOffJsDefault.default));
parcelHelpers.export(exports, "MicOffIcon", ()=>(0, _micOffJsDefault.default));
parcelHelpers.export(exports, "LucideMic", ()=>(0, _micJsDefault.default));
parcelHelpers.export(exports, "Mic", ()=>(0, _micJsDefault.default));
parcelHelpers.export(exports, "MicIcon", ()=>(0, _micJsDefault.default));
parcelHelpers.export(exports, "LucideMicrochip", ()=>(0, _microchipJsDefault.default));
parcelHelpers.export(exports, "Microchip", ()=>(0, _microchipJsDefault.default));
parcelHelpers.export(exports, "MicrochipIcon", ()=>(0, _microchipJsDefault.default));
parcelHelpers.export(exports, "LucideMicroscope", ()=>(0, _microscopeJsDefault.default));
parcelHelpers.export(exports, "Microscope", ()=>(0, _microscopeJsDefault.default));
parcelHelpers.export(exports, "MicroscopeIcon", ()=>(0, _microscopeJsDefault.default));
parcelHelpers.export(exports, "LucideMicrowave", ()=>(0, _microwaveJsDefault.default));
parcelHelpers.export(exports, "Microwave", ()=>(0, _microwaveJsDefault.default));
parcelHelpers.export(exports, "MicrowaveIcon", ()=>(0, _microwaveJsDefault.default));
parcelHelpers.export(exports, "LucideMilestone", ()=>(0, _milestoneJsDefault.default));
parcelHelpers.export(exports, "Milestone", ()=>(0, _milestoneJsDefault.default));
parcelHelpers.export(exports, "MilestoneIcon", ()=>(0, _milestoneJsDefault.default));
parcelHelpers.export(exports, "LucideMilkOff", ()=>(0, _milkOffJsDefault.default));
parcelHelpers.export(exports, "MilkOff", ()=>(0, _milkOffJsDefault.default));
parcelHelpers.export(exports, "MilkOffIcon", ()=>(0, _milkOffJsDefault.default));
parcelHelpers.export(exports, "LucideMilk", ()=>(0, _milkJsDefault.default));
parcelHelpers.export(exports, "Milk", ()=>(0, _milkJsDefault.default));
parcelHelpers.export(exports, "MilkIcon", ()=>(0, _milkJsDefault.default));
parcelHelpers.export(exports, "LucideMinimize2", ()=>(0, _minimize2JsDefault.default));
parcelHelpers.export(exports, "Minimize2", ()=>(0, _minimize2JsDefault.default));
parcelHelpers.export(exports, "Minimize2Icon", ()=>(0, _minimize2JsDefault.default));
parcelHelpers.export(exports, "LucideMinimize", ()=>(0, _minimizeJsDefault.default));
parcelHelpers.export(exports, "Minimize", ()=>(0, _minimizeJsDefault.default));
parcelHelpers.export(exports, "MinimizeIcon", ()=>(0, _minimizeJsDefault.default));
parcelHelpers.export(exports, "LucideMinus", ()=>(0, _minusJsDefault.default));
parcelHelpers.export(exports, "Minus", ()=>(0, _minusJsDefault.default));
parcelHelpers.export(exports, "MinusIcon", ()=>(0, _minusJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorCheck", ()=>(0, _monitorCheckJsDefault.default));
parcelHelpers.export(exports, "MonitorCheck", ()=>(0, _monitorCheckJsDefault.default));
parcelHelpers.export(exports, "MonitorCheckIcon", ()=>(0, _monitorCheckJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorCog", ()=>(0, _monitorCogJsDefault.default));
parcelHelpers.export(exports, "MonitorCog", ()=>(0, _monitorCogJsDefault.default));
parcelHelpers.export(exports, "MonitorCogIcon", ()=>(0, _monitorCogJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorDot", ()=>(0, _monitorDotJsDefault.default));
parcelHelpers.export(exports, "MonitorDot", ()=>(0, _monitorDotJsDefault.default));
parcelHelpers.export(exports, "MonitorDotIcon", ()=>(0, _monitorDotJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorDown", ()=>(0, _monitorDownJsDefault.default));
parcelHelpers.export(exports, "MonitorDown", ()=>(0, _monitorDownJsDefault.default));
parcelHelpers.export(exports, "MonitorDownIcon", ()=>(0, _monitorDownJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorOff", ()=>(0, _monitorOffJsDefault.default));
parcelHelpers.export(exports, "MonitorOff", ()=>(0, _monitorOffJsDefault.default));
parcelHelpers.export(exports, "MonitorOffIcon", ()=>(0, _monitorOffJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorPlay", ()=>(0, _monitorPlayJsDefault.default));
parcelHelpers.export(exports, "MonitorPlay", ()=>(0, _monitorPlayJsDefault.default));
parcelHelpers.export(exports, "MonitorPlayIcon", ()=>(0, _monitorPlayJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorSpeaker", ()=>(0, _monitorSpeakerJsDefault.default));
parcelHelpers.export(exports, "MonitorSpeaker", ()=>(0, _monitorSpeakerJsDefault.default));
parcelHelpers.export(exports, "MonitorSpeakerIcon", ()=>(0, _monitorSpeakerJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorPause", ()=>(0, _monitorPauseJsDefault.default));
parcelHelpers.export(exports, "MonitorPause", ()=>(0, _monitorPauseJsDefault.default));
parcelHelpers.export(exports, "MonitorPauseIcon", ()=>(0, _monitorPauseJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorSmartphone", ()=>(0, _monitorSmartphoneJsDefault.default));
parcelHelpers.export(exports, "MonitorSmartphone", ()=>(0, _monitorSmartphoneJsDefault.default));
parcelHelpers.export(exports, "MonitorSmartphoneIcon", ()=>(0, _monitorSmartphoneJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorStop", ()=>(0, _monitorStopJsDefault.default));
parcelHelpers.export(exports, "MonitorStop", ()=>(0, _monitorStopJsDefault.default));
parcelHelpers.export(exports, "MonitorStopIcon", ()=>(0, _monitorStopJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorUp", ()=>(0, _monitorUpJsDefault.default));
parcelHelpers.export(exports, "MonitorUp", ()=>(0, _monitorUpJsDefault.default));
parcelHelpers.export(exports, "MonitorUpIcon", ()=>(0, _monitorUpJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorX", ()=>(0, _monitorXJsDefault.default));
parcelHelpers.export(exports, "MonitorX", ()=>(0, _monitorXJsDefault.default));
parcelHelpers.export(exports, "MonitorXIcon", ()=>(0, _monitorXJsDefault.default));
parcelHelpers.export(exports, "LucideMonitor", ()=>(0, _monitorJsDefault.default));
parcelHelpers.export(exports, "Monitor", ()=>(0, _monitorJsDefault.default));
parcelHelpers.export(exports, "MonitorIcon", ()=>(0, _monitorJsDefault.default));
parcelHelpers.export(exports, "LucideMoonStar", ()=>(0, _moonStarJsDefault.default));
parcelHelpers.export(exports, "MoonStar", ()=>(0, _moonStarJsDefault.default));
parcelHelpers.export(exports, "MoonStarIcon", ()=>(0, _moonStarJsDefault.default));
parcelHelpers.export(exports, "LucideMoon", ()=>(0, _moonJsDefault.default));
parcelHelpers.export(exports, "Moon", ()=>(0, _moonJsDefault.default));
parcelHelpers.export(exports, "MoonIcon", ()=>(0, _moonJsDefault.default));
parcelHelpers.export(exports, "LucideMountainSnow", ()=>(0, _mountainSnowJsDefault.default));
parcelHelpers.export(exports, "MountainSnow", ()=>(0, _mountainSnowJsDefault.default));
parcelHelpers.export(exports, "MountainSnowIcon", ()=>(0, _mountainSnowJsDefault.default));
parcelHelpers.export(exports, "LucideMountain", ()=>(0, _mountainJsDefault.default));
parcelHelpers.export(exports, "Mountain", ()=>(0, _mountainJsDefault.default));
parcelHelpers.export(exports, "MountainIcon", ()=>(0, _mountainJsDefault.default));
parcelHelpers.export(exports, "LucideMouseOff", ()=>(0, _mouseOffJsDefault.default));
parcelHelpers.export(exports, "MouseOff", ()=>(0, _mouseOffJsDefault.default));
parcelHelpers.export(exports, "MouseOffIcon", ()=>(0, _mouseOffJsDefault.default));
parcelHelpers.export(exports, "LucideMousePointer2", ()=>(0, _mousePointer2JsDefault.default));
parcelHelpers.export(exports, "MousePointer2", ()=>(0, _mousePointer2JsDefault.default));
parcelHelpers.export(exports, "MousePointer2Icon", ()=>(0, _mousePointer2JsDefault.default));
parcelHelpers.export(exports, "LucideMousePointerBan", ()=>(0, _mousePointerBanJsDefault.default));
parcelHelpers.export(exports, "MousePointerBan", ()=>(0, _mousePointerBanJsDefault.default));
parcelHelpers.export(exports, "MousePointerBanIcon", ()=>(0, _mousePointerBanJsDefault.default));
parcelHelpers.export(exports, "LucideMousePointerClick", ()=>(0, _mousePointerClickJsDefault.default));
parcelHelpers.export(exports, "MousePointerClick", ()=>(0, _mousePointerClickJsDefault.default));
parcelHelpers.export(exports, "MousePointerClickIcon", ()=>(0, _mousePointerClickJsDefault.default));
parcelHelpers.export(exports, "LucideMousePointer", ()=>(0, _mousePointerJsDefault.default));
parcelHelpers.export(exports, "MousePointer", ()=>(0, _mousePointerJsDefault.default));
parcelHelpers.export(exports, "MousePointerIcon", ()=>(0, _mousePointerJsDefault.default));
parcelHelpers.export(exports, "LucideMouse", ()=>(0, _mouseJsDefault.default));
parcelHelpers.export(exports, "Mouse", ()=>(0, _mouseJsDefault.default));
parcelHelpers.export(exports, "MouseIcon", ()=>(0, _mouseJsDefault.default));
parcelHelpers.export(exports, "LucideMoveDiagonal2", ()=>(0, _moveDiagonal2JsDefault.default));
parcelHelpers.export(exports, "MoveDiagonal2", ()=>(0, _moveDiagonal2JsDefault.default));
parcelHelpers.export(exports, "MoveDiagonal2Icon", ()=>(0, _moveDiagonal2JsDefault.default));
parcelHelpers.export(exports, "LucideMoveDiagonal", ()=>(0, _moveDiagonalJsDefault.default));
parcelHelpers.export(exports, "MoveDiagonal", ()=>(0, _moveDiagonalJsDefault.default));
parcelHelpers.export(exports, "MoveDiagonalIcon", ()=>(0, _moveDiagonalJsDefault.default));
parcelHelpers.export(exports, "LucideMoveDownLeft", ()=>(0, _moveDownLeftJsDefault.default));
parcelHelpers.export(exports, "MoveDownLeft", ()=>(0, _moveDownLeftJsDefault.default));
parcelHelpers.export(exports, "MoveDownLeftIcon", ()=>(0, _moveDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideMoveDownRight", ()=>(0, _moveDownRightJsDefault.default));
parcelHelpers.export(exports, "MoveDownRight", ()=>(0, _moveDownRightJsDefault.default));
parcelHelpers.export(exports, "MoveDownRightIcon", ()=>(0, _moveDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideMoveDown", ()=>(0, _moveDownJsDefault.default));
parcelHelpers.export(exports, "MoveDown", ()=>(0, _moveDownJsDefault.default));
parcelHelpers.export(exports, "MoveDownIcon", ()=>(0, _moveDownJsDefault.default));
parcelHelpers.export(exports, "LucideMoveHorizontal", ()=>(0, _moveHorizontalJsDefault.default));
parcelHelpers.export(exports, "MoveHorizontal", ()=>(0, _moveHorizontalJsDefault.default));
parcelHelpers.export(exports, "MoveHorizontalIcon", ()=>(0, _moveHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideMoveLeft", ()=>(0, _moveLeftJsDefault.default));
parcelHelpers.export(exports, "MoveLeft", ()=>(0, _moveLeftJsDefault.default));
parcelHelpers.export(exports, "MoveLeftIcon", ()=>(0, _moveLeftJsDefault.default));
parcelHelpers.export(exports, "LucideMoveRight", ()=>(0, _moveRightJsDefault.default));
parcelHelpers.export(exports, "MoveRight", ()=>(0, _moveRightJsDefault.default));
parcelHelpers.export(exports, "MoveRightIcon", ()=>(0, _moveRightJsDefault.default));
parcelHelpers.export(exports, "LucideMoveUpRight", ()=>(0, _moveUpRightJsDefault.default));
parcelHelpers.export(exports, "MoveUpRight", ()=>(0, _moveUpRightJsDefault.default));
parcelHelpers.export(exports, "MoveUpRightIcon", ()=>(0, _moveUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideMoveUpLeft", ()=>(0, _moveUpLeftJsDefault.default));
parcelHelpers.export(exports, "MoveUpLeft", ()=>(0, _moveUpLeftJsDefault.default));
parcelHelpers.export(exports, "MoveUpLeftIcon", ()=>(0, _moveUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideMoveUp", ()=>(0, _moveUpJsDefault.default));
parcelHelpers.export(exports, "MoveUp", ()=>(0, _moveUpJsDefault.default));
parcelHelpers.export(exports, "MoveUpIcon", ()=>(0, _moveUpJsDefault.default));
parcelHelpers.export(exports, "LucideMoveVertical", ()=>(0, _moveVerticalJsDefault.default));
parcelHelpers.export(exports, "MoveVertical", ()=>(0, _moveVerticalJsDefault.default));
parcelHelpers.export(exports, "MoveVerticalIcon", ()=>(0, _moveVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideMove", ()=>(0, _moveJsDefault.default));
parcelHelpers.export(exports, "Move", ()=>(0, _moveJsDefault.default));
parcelHelpers.export(exports, "MoveIcon", ()=>(0, _moveJsDefault.default));
parcelHelpers.export(exports, "LucideMusic2", ()=>(0, _music2JsDefault.default));
parcelHelpers.export(exports, "Music2", ()=>(0, _music2JsDefault.default));
parcelHelpers.export(exports, "Music2Icon", ()=>(0, _music2JsDefault.default));
parcelHelpers.export(exports, "LucideMusic", ()=>(0, _musicJsDefault.default));
parcelHelpers.export(exports, "Music", ()=>(0, _musicJsDefault.default));
parcelHelpers.export(exports, "MusicIcon", ()=>(0, _musicJsDefault.default));
parcelHelpers.export(exports, "LucideMusic3", ()=>(0, _music3JsDefault.default));
parcelHelpers.export(exports, "Music3", ()=>(0, _music3JsDefault.default));
parcelHelpers.export(exports, "Music3Icon", ()=>(0, _music3JsDefault.default));
parcelHelpers.export(exports, "LucideMusic4", ()=>(0, _music4JsDefault.default));
parcelHelpers.export(exports, "Music4", ()=>(0, _music4JsDefault.default));
parcelHelpers.export(exports, "Music4Icon", ()=>(0, _music4JsDefault.default));
parcelHelpers.export(exports, "LucideNavigation2Off", ()=>(0, _navigation2OffJsDefault.default));
parcelHelpers.export(exports, "Navigation2Off", ()=>(0, _navigation2OffJsDefault.default));
parcelHelpers.export(exports, "Navigation2OffIcon", ()=>(0, _navigation2OffJsDefault.default));
parcelHelpers.export(exports, "LucideNavigation2", ()=>(0, _navigation2JsDefault.default));
parcelHelpers.export(exports, "Navigation2", ()=>(0, _navigation2JsDefault.default));
parcelHelpers.export(exports, "Navigation2Icon", ()=>(0, _navigation2JsDefault.default));
parcelHelpers.export(exports, "LucideNavigationOff", ()=>(0, _navigationOffJsDefault.default));
parcelHelpers.export(exports, "NavigationOff", ()=>(0, _navigationOffJsDefault.default));
parcelHelpers.export(exports, "NavigationOffIcon", ()=>(0, _navigationOffJsDefault.default));
parcelHelpers.export(exports, "LucideNavigation", ()=>(0, _navigationJsDefault.default));
parcelHelpers.export(exports, "Navigation", ()=>(0, _navigationJsDefault.default));
parcelHelpers.export(exports, "NavigationIcon", ()=>(0, _navigationJsDefault.default));
parcelHelpers.export(exports, "LucideNetwork", ()=>(0, _networkJsDefault.default));
parcelHelpers.export(exports, "Network", ()=>(0, _networkJsDefault.default));
parcelHelpers.export(exports, "NetworkIcon", ()=>(0, _networkJsDefault.default));
parcelHelpers.export(exports, "LucideNfc", ()=>(0, _nfcJsDefault.default));
parcelHelpers.export(exports, "Nfc", ()=>(0, _nfcJsDefault.default));
parcelHelpers.export(exports, "NfcIcon", ()=>(0, _nfcJsDefault.default));
parcelHelpers.export(exports, "LucideNewspaper", ()=>(0, _newspaperJsDefault.default));
parcelHelpers.export(exports, "Newspaper", ()=>(0, _newspaperJsDefault.default));
parcelHelpers.export(exports, "NewspaperIcon", ()=>(0, _newspaperJsDefault.default));
parcelHelpers.export(exports, "LucideNonBinary", ()=>(0, _nonBinaryJsDefault.default));
parcelHelpers.export(exports, "NonBinary", ()=>(0, _nonBinaryJsDefault.default));
parcelHelpers.export(exports, "NonBinaryIcon", ()=>(0, _nonBinaryJsDefault.default));
parcelHelpers.export(exports, "LucideNotebookPen", ()=>(0, _notebookPenJsDefault.default));
parcelHelpers.export(exports, "NotebookPen", ()=>(0, _notebookPenJsDefault.default));
parcelHelpers.export(exports, "NotebookPenIcon", ()=>(0, _notebookPenJsDefault.default));
parcelHelpers.export(exports, "LucideNotebookTabs", ()=>(0, _notebookTabsJsDefault.default));
parcelHelpers.export(exports, "NotebookTabs", ()=>(0, _notebookTabsJsDefault.default));
parcelHelpers.export(exports, "NotebookTabsIcon", ()=>(0, _notebookTabsJsDefault.default));
parcelHelpers.export(exports, "LucideNotebookText", ()=>(0, _notebookTextJsDefault.default));
parcelHelpers.export(exports, "NotebookText", ()=>(0, _notebookTextJsDefault.default));
parcelHelpers.export(exports, "NotebookTextIcon", ()=>(0, _notebookTextJsDefault.default));
parcelHelpers.export(exports, "LucideNotebook", ()=>(0, _notebookJsDefault.default));
parcelHelpers.export(exports, "Notebook", ()=>(0, _notebookJsDefault.default));
parcelHelpers.export(exports, "NotebookIcon", ()=>(0, _notebookJsDefault.default));
parcelHelpers.export(exports, "LucideNotepadTextDashed", ()=>(0, _notepadTextDashedJsDefault.default));
parcelHelpers.export(exports, "NotepadTextDashed", ()=>(0, _notepadTextDashedJsDefault.default));
parcelHelpers.export(exports, "NotepadTextDashedIcon", ()=>(0, _notepadTextDashedJsDefault.default));
parcelHelpers.export(exports, "LucideNotepadText", ()=>(0, _notepadTextJsDefault.default));
parcelHelpers.export(exports, "NotepadText", ()=>(0, _notepadTextJsDefault.default));
parcelHelpers.export(exports, "NotepadTextIcon", ()=>(0, _notepadTextJsDefault.default));
parcelHelpers.export(exports, "LucideNutOff", ()=>(0, _nutOffJsDefault.default));
parcelHelpers.export(exports, "NutOff", ()=>(0, _nutOffJsDefault.default));
parcelHelpers.export(exports, "NutOffIcon", ()=>(0, _nutOffJsDefault.default));
parcelHelpers.export(exports, "LucideNut", ()=>(0, _nutJsDefault.default));
parcelHelpers.export(exports, "Nut", ()=>(0, _nutJsDefault.default));
parcelHelpers.export(exports, "NutIcon", ()=>(0, _nutJsDefault.default));
parcelHelpers.export(exports, "LucideOctagonMinus", ()=>(0, _octagonMinusJsDefault.default));
parcelHelpers.export(exports, "OctagonMinus", ()=>(0, _octagonMinusJsDefault.default));
parcelHelpers.export(exports, "OctagonMinusIcon", ()=>(0, _octagonMinusJsDefault.default));
parcelHelpers.export(exports, "LucideOctagon", ()=>(0, _octagonJsDefault.default));
parcelHelpers.export(exports, "Octagon", ()=>(0, _octagonJsDefault.default));
parcelHelpers.export(exports, "OctagonIcon", ()=>(0, _octagonJsDefault.default));
parcelHelpers.export(exports, "LucideOmega", ()=>(0, _omegaJsDefault.default));
parcelHelpers.export(exports, "Omega", ()=>(0, _omegaJsDefault.default));
parcelHelpers.export(exports, "OmegaIcon", ()=>(0, _omegaJsDefault.default));
parcelHelpers.export(exports, "LucideOption", ()=>(0, _optionJsDefault.default));
parcelHelpers.export(exports, "Option", ()=>(0, _optionJsDefault.default));
parcelHelpers.export(exports, "OptionIcon", ()=>(0, _optionJsDefault.default));
parcelHelpers.export(exports, "LucideOrbit", ()=>(0, _orbitJsDefault.default));
parcelHelpers.export(exports, "Orbit", ()=>(0, _orbitJsDefault.default));
parcelHelpers.export(exports, "OrbitIcon", ()=>(0, _orbitJsDefault.default));
parcelHelpers.export(exports, "LucideOrigami", ()=>(0, _origamiJsDefault.default));
parcelHelpers.export(exports, "Origami", ()=>(0, _origamiJsDefault.default));
parcelHelpers.export(exports, "OrigamiIcon", ()=>(0, _origamiJsDefault.default));
parcelHelpers.export(exports, "LucidePackage2", ()=>(0, _package2JsDefault.default));
parcelHelpers.export(exports, "Package2", ()=>(0, _package2JsDefault.default));
parcelHelpers.export(exports, "Package2Icon", ()=>(0, _package2JsDefault.default));
parcelHelpers.export(exports, "LucidePackageCheck", ()=>(0, _packageCheckJsDefault.default));
parcelHelpers.export(exports, "PackageCheck", ()=>(0, _packageCheckJsDefault.default));
parcelHelpers.export(exports, "PackageCheckIcon", ()=>(0, _packageCheckJsDefault.default));
parcelHelpers.export(exports, "LucidePackageMinus", ()=>(0, _packageMinusJsDefault.default));
parcelHelpers.export(exports, "PackageMinus", ()=>(0, _packageMinusJsDefault.default));
parcelHelpers.export(exports, "PackageMinusIcon", ()=>(0, _packageMinusJsDefault.default));
parcelHelpers.export(exports, "LucidePackageOpen", ()=>(0, _packageOpenJsDefault.default));
parcelHelpers.export(exports, "PackageOpen", ()=>(0, _packageOpenJsDefault.default));
parcelHelpers.export(exports, "PackageOpenIcon", ()=>(0, _packageOpenJsDefault.default));
parcelHelpers.export(exports, "LucidePackageSearch", ()=>(0, _packageSearchJsDefault.default));
parcelHelpers.export(exports, "PackageSearch", ()=>(0, _packageSearchJsDefault.default));
parcelHelpers.export(exports, "PackageSearchIcon", ()=>(0, _packageSearchJsDefault.default));
parcelHelpers.export(exports, "LucidePackagePlus", ()=>(0, _packagePlusJsDefault.default));
parcelHelpers.export(exports, "PackagePlus", ()=>(0, _packagePlusJsDefault.default));
parcelHelpers.export(exports, "PackagePlusIcon", ()=>(0, _packagePlusJsDefault.default));
parcelHelpers.export(exports, "LucidePackageX", ()=>(0, _packageXJsDefault.default));
parcelHelpers.export(exports, "PackageX", ()=>(0, _packageXJsDefault.default));
parcelHelpers.export(exports, "PackageXIcon", ()=>(0, _packageXJsDefault.default));
parcelHelpers.export(exports, "LucidePackage", ()=>(0, _packageJsDefault.default));
parcelHelpers.export(exports, "Package", ()=>(0, _packageJsDefault.default));
parcelHelpers.export(exports, "PackageIcon", ()=>(0, _packageJsDefault.default));
parcelHelpers.export(exports, "LucidePaintBucket", ()=>(0, _paintBucketJsDefault.default));
parcelHelpers.export(exports, "PaintBucket", ()=>(0, _paintBucketJsDefault.default));
parcelHelpers.export(exports, "PaintBucketIcon", ()=>(0, _paintBucketJsDefault.default));
parcelHelpers.export(exports, "LucidePaintRoller", ()=>(0, _paintRollerJsDefault.default));
parcelHelpers.export(exports, "PaintRoller", ()=>(0, _paintRollerJsDefault.default));
parcelHelpers.export(exports, "PaintRollerIcon", ()=>(0, _paintRollerJsDefault.default));
parcelHelpers.export(exports, "LucidePaintbrush", ()=>(0, _paintbrushJsDefault.default));
parcelHelpers.export(exports, "Paintbrush", ()=>(0, _paintbrushJsDefault.default));
parcelHelpers.export(exports, "PaintbrushIcon", ()=>(0, _paintbrushJsDefault.default));
parcelHelpers.export(exports, "LucidePalette", ()=>(0, _paletteJsDefault.default));
parcelHelpers.export(exports, "Palette", ()=>(0, _paletteJsDefault.default));
parcelHelpers.export(exports, "PaletteIcon", ()=>(0, _paletteJsDefault.default));
parcelHelpers.export(exports, "LucidePanda", ()=>(0, _pandaJsDefault.default));
parcelHelpers.export(exports, "Panda", ()=>(0, _pandaJsDefault.default));
parcelHelpers.export(exports, "PandaIcon", ()=>(0, _pandaJsDefault.default));
parcelHelpers.export(exports, "LucidePanelBottomClose", ()=>(0, _panelBottomCloseJsDefault.default));
parcelHelpers.export(exports, "PanelBottomClose", ()=>(0, _panelBottomCloseJsDefault.default));
parcelHelpers.export(exports, "PanelBottomCloseIcon", ()=>(0, _panelBottomCloseJsDefault.default));
parcelHelpers.export(exports, "LucidePanelBottomOpen", ()=>(0, _panelBottomOpenJsDefault.default));
parcelHelpers.export(exports, "PanelBottomOpen", ()=>(0, _panelBottomOpenJsDefault.default));
parcelHelpers.export(exports, "PanelBottomOpenIcon", ()=>(0, _panelBottomOpenJsDefault.default));
parcelHelpers.export(exports, "LucidePanelBottom", ()=>(0, _panelBottomJsDefault.default));
parcelHelpers.export(exports, "PanelBottom", ()=>(0, _panelBottomJsDefault.default));
parcelHelpers.export(exports, "PanelBottomIcon", ()=>(0, _panelBottomJsDefault.default));
parcelHelpers.export(exports, "LucidePanelRightClose", ()=>(0, _panelRightCloseJsDefault.default));
parcelHelpers.export(exports, "PanelRightClose", ()=>(0, _panelRightCloseJsDefault.default));
parcelHelpers.export(exports, "PanelRightCloseIcon", ()=>(0, _panelRightCloseJsDefault.default));
parcelHelpers.export(exports, "LucidePanelRightOpen", ()=>(0, _panelRightOpenJsDefault.default));
parcelHelpers.export(exports, "PanelRightOpen", ()=>(0, _panelRightOpenJsDefault.default));
parcelHelpers.export(exports, "PanelRightOpenIcon", ()=>(0, _panelRightOpenJsDefault.default));
parcelHelpers.export(exports, "LucidePanelRight", ()=>(0, _panelRightJsDefault.default));
parcelHelpers.export(exports, "PanelRight", ()=>(0, _panelRightJsDefault.default));
parcelHelpers.export(exports, "PanelRightIcon", ()=>(0, _panelRightJsDefault.default));
parcelHelpers.export(exports, "LucidePanelTopClose", ()=>(0, _panelTopCloseJsDefault.default));
parcelHelpers.export(exports, "PanelTopClose", ()=>(0, _panelTopCloseJsDefault.default));
parcelHelpers.export(exports, "PanelTopCloseIcon", ()=>(0, _panelTopCloseJsDefault.default));
parcelHelpers.export(exports, "LucidePanelTopOpen", ()=>(0, _panelTopOpenJsDefault.default));
parcelHelpers.export(exports, "PanelTopOpen", ()=>(0, _panelTopOpenJsDefault.default));
parcelHelpers.export(exports, "PanelTopOpenIcon", ()=>(0, _panelTopOpenJsDefault.default));
parcelHelpers.export(exports, "LucidePanelTop", ()=>(0, _panelTopJsDefault.default));
parcelHelpers.export(exports, "PanelTop", ()=>(0, _panelTopJsDefault.default));
parcelHelpers.export(exports, "PanelTopIcon", ()=>(0, _panelTopJsDefault.default));
parcelHelpers.export(exports, "LucidePanelsLeftBottom", ()=>(0, _panelsLeftBottomJsDefault.default));
parcelHelpers.export(exports, "PanelsLeftBottom", ()=>(0, _panelsLeftBottomJsDefault.default));
parcelHelpers.export(exports, "PanelsLeftBottomIcon", ()=>(0, _panelsLeftBottomJsDefault.default));
parcelHelpers.export(exports, "LucidePanelsRightBottom", ()=>(0, _panelsRightBottomJsDefault.default));
parcelHelpers.export(exports, "PanelsRightBottom", ()=>(0, _panelsRightBottomJsDefault.default));
parcelHelpers.export(exports, "PanelsRightBottomIcon", ()=>(0, _panelsRightBottomJsDefault.default));
parcelHelpers.export(exports, "LucidePaperclip", ()=>(0, _paperclipJsDefault.default));
parcelHelpers.export(exports, "Paperclip", ()=>(0, _paperclipJsDefault.default));
parcelHelpers.export(exports, "PaperclipIcon", ()=>(0, _paperclipJsDefault.default));
parcelHelpers.export(exports, "LucideParentheses", ()=>(0, _parenthesesJsDefault.default));
parcelHelpers.export(exports, "Parentheses", ()=>(0, _parenthesesJsDefault.default));
parcelHelpers.export(exports, "ParenthesesIcon", ()=>(0, _parenthesesJsDefault.default));
parcelHelpers.export(exports, "LucideParkingMeter", ()=>(0, _parkingMeterJsDefault.default));
parcelHelpers.export(exports, "ParkingMeter", ()=>(0, _parkingMeterJsDefault.default));
parcelHelpers.export(exports, "ParkingMeterIcon", ()=>(0, _parkingMeterJsDefault.default));
parcelHelpers.export(exports, "LucidePartyPopper", ()=>(0, _partyPopperJsDefault.default));
parcelHelpers.export(exports, "PartyPopper", ()=>(0, _partyPopperJsDefault.default));
parcelHelpers.export(exports, "PartyPopperIcon", ()=>(0, _partyPopperJsDefault.default));
parcelHelpers.export(exports, "LucidePause", ()=>(0, _pauseJsDefault.default));
parcelHelpers.export(exports, "Pause", ()=>(0, _pauseJsDefault.default));
parcelHelpers.export(exports, "PauseIcon", ()=>(0, _pauseJsDefault.default));
parcelHelpers.export(exports, "LucidePawPrint", ()=>(0, _pawPrintJsDefault.default));
parcelHelpers.export(exports, "PawPrint", ()=>(0, _pawPrintJsDefault.default));
parcelHelpers.export(exports, "PawPrintIcon", ()=>(0, _pawPrintJsDefault.default));
parcelHelpers.export(exports, "LucidePcCase", ()=>(0, _pcCaseJsDefault.default));
parcelHelpers.export(exports, "PcCase", ()=>(0, _pcCaseJsDefault.default));
parcelHelpers.export(exports, "PcCaseIcon", ()=>(0, _pcCaseJsDefault.default));
parcelHelpers.export(exports, "LucidePenOff", ()=>(0, _penOffJsDefault.default));
parcelHelpers.export(exports, "PenOff", ()=>(0, _penOffJsDefault.default));
parcelHelpers.export(exports, "PenOffIcon", ()=>(0, _penOffJsDefault.default));
parcelHelpers.export(exports, "LucidePenTool", ()=>(0, _penToolJsDefault.default));
parcelHelpers.export(exports, "PenTool", ()=>(0, _penToolJsDefault.default));
parcelHelpers.export(exports, "PenToolIcon", ()=>(0, _penToolJsDefault.default));
parcelHelpers.export(exports, "LucidePencilLine", ()=>(0, _pencilLineJsDefault.default));
parcelHelpers.export(exports, "PencilLine", ()=>(0, _pencilLineJsDefault.default));
parcelHelpers.export(exports, "PencilLineIcon", ()=>(0, _pencilLineJsDefault.default));
parcelHelpers.export(exports, "LucidePencilOff", ()=>(0, _pencilOffJsDefault.default));
parcelHelpers.export(exports, "PencilOff", ()=>(0, _pencilOffJsDefault.default));
parcelHelpers.export(exports, "PencilOffIcon", ()=>(0, _pencilOffJsDefault.default));
parcelHelpers.export(exports, "LucidePencilRuler", ()=>(0, _pencilRulerJsDefault.default));
parcelHelpers.export(exports, "PencilRuler", ()=>(0, _pencilRulerJsDefault.default));
parcelHelpers.export(exports, "PencilRulerIcon", ()=>(0, _pencilRulerJsDefault.default));
parcelHelpers.export(exports, "LucidePencil", ()=>(0, _pencilJsDefault.default));
parcelHelpers.export(exports, "Pencil", ()=>(0, _pencilJsDefault.default));
parcelHelpers.export(exports, "PencilIcon", ()=>(0, _pencilJsDefault.default));
parcelHelpers.export(exports, "LucidePentagon", ()=>(0, _pentagonJsDefault.default));
parcelHelpers.export(exports, "Pentagon", ()=>(0, _pentagonJsDefault.default));
parcelHelpers.export(exports, "PentagonIcon", ()=>(0, _pentagonJsDefault.default));
parcelHelpers.export(exports, "LucidePercent", ()=>(0, _percentJsDefault.default));
parcelHelpers.export(exports, "Percent", ()=>(0, _percentJsDefault.default));
parcelHelpers.export(exports, "PercentIcon", ()=>(0, _percentJsDefault.default));
parcelHelpers.export(exports, "LucidePersonStanding", ()=>(0, _personStandingJsDefault.default));
parcelHelpers.export(exports, "PersonStanding", ()=>(0, _personStandingJsDefault.default));
parcelHelpers.export(exports, "PersonStandingIcon", ()=>(0, _personStandingJsDefault.default));
parcelHelpers.export(exports, "LucidePhilippinePeso", ()=>(0, _philippinePesoJsDefault.default));
parcelHelpers.export(exports, "PhilippinePeso", ()=>(0, _philippinePesoJsDefault.default));
parcelHelpers.export(exports, "PhilippinePesoIcon", ()=>(0, _philippinePesoJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneCall", ()=>(0, _phoneCallJsDefault.default));
parcelHelpers.export(exports, "PhoneCall", ()=>(0, _phoneCallJsDefault.default));
parcelHelpers.export(exports, "PhoneCallIcon", ()=>(0, _phoneCallJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneForwarded", ()=>(0, _phoneForwardedJsDefault.default));
parcelHelpers.export(exports, "PhoneForwarded", ()=>(0, _phoneForwardedJsDefault.default));
parcelHelpers.export(exports, "PhoneForwardedIcon", ()=>(0, _phoneForwardedJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneIncoming", ()=>(0, _phoneIncomingJsDefault.default));
parcelHelpers.export(exports, "PhoneIncoming", ()=>(0, _phoneIncomingJsDefault.default));
parcelHelpers.export(exports, "PhoneIncomingIcon", ()=>(0, _phoneIncomingJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneMissed", ()=>(0, _phoneMissedJsDefault.default));
parcelHelpers.export(exports, "PhoneMissed", ()=>(0, _phoneMissedJsDefault.default));
parcelHelpers.export(exports, "PhoneMissedIcon", ()=>(0, _phoneMissedJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneOff", ()=>(0, _phoneOffJsDefault.default));
parcelHelpers.export(exports, "PhoneOff", ()=>(0, _phoneOffJsDefault.default));
parcelHelpers.export(exports, "PhoneOffIcon", ()=>(0, _phoneOffJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneOutgoing", ()=>(0, _phoneOutgoingJsDefault.default));
parcelHelpers.export(exports, "PhoneOutgoing", ()=>(0, _phoneOutgoingJsDefault.default));
parcelHelpers.export(exports, "PhoneOutgoingIcon", ()=>(0, _phoneOutgoingJsDefault.default));
parcelHelpers.export(exports, "LucidePi", ()=>(0, _piJsDefault.default));
parcelHelpers.export(exports, "Pi", ()=>(0, _piJsDefault.default));
parcelHelpers.export(exports, "PiIcon", ()=>(0, _piJsDefault.default));
parcelHelpers.export(exports, "LucidePhone", ()=>(0, _phoneJsDefault.default));
parcelHelpers.export(exports, "Phone", ()=>(0, _phoneJsDefault.default));
parcelHelpers.export(exports, "PhoneIcon", ()=>(0, _phoneJsDefault.default));
parcelHelpers.export(exports, "LucidePickaxe", ()=>(0, _pickaxeJsDefault.default));
parcelHelpers.export(exports, "Pickaxe", ()=>(0, _pickaxeJsDefault.default));
parcelHelpers.export(exports, "PickaxeIcon", ()=>(0, _pickaxeJsDefault.default));
parcelHelpers.export(exports, "LucidePiano", ()=>(0, _pianoJsDefault.default));
parcelHelpers.export(exports, "Piano", ()=>(0, _pianoJsDefault.default));
parcelHelpers.export(exports, "PianoIcon", ()=>(0, _pianoJsDefault.default));
parcelHelpers.export(exports, "LucidePictureInPicture2", ()=>(0, _pictureInPicture2JsDefault.default));
parcelHelpers.export(exports, "PictureInPicture2", ()=>(0, _pictureInPicture2JsDefault.default));
parcelHelpers.export(exports, "PictureInPicture2Icon", ()=>(0, _pictureInPicture2JsDefault.default));
parcelHelpers.export(exports, "LucidePictureInPicture", ()=>(0, _pictureInPictureJsDefault.default));
parcelHelpers.export(exports, "PictureInPicture", ()=>(0, _pictureInPictureJsDefault.default));
parcelHelpers.export(exports, "PictureInPictureIcon", ()=>(0, _pictureInPictureJsDefault.default));
parcelHelpers.export(exports, "LucidePiggyBank", ()=>(0, _piggyBankJsDefault.default));
parcelHelpers.export(exports, "PiggyBank", ()=>(0, _piggyBankJsDefault.default));
parcelHelpers.export(exports, "PiggyBankIcon", ()=>(0, _piggyBankJsDefault.default));
parcelHelpers.export(exports, "LucidePilcrowLeft", ()=>(0, _pilcrowLeftJsDefault.default));
parcelHelpers.export(exports, "PilcrowLeft", ()=>(0, _pilcrowLeftJsDefault.default));
parcelHelpers.export(exports, "PilcrowLeftIcon", ()=>(0, _pilcrowLeftJsDefault.default));
parcelHelpers.export(exports, "LucidePilcrowRight", ()=>(0, _pilcrowRightJsDefault.default));
parcelHelpers.export(exports, "PilcrowRight", ()=>(0, _pilcrowRightJsDefault.default));
parcelHelpers.export(exports, "PilcrowRightIcon", ()=>(0, _pilcrowRightJsDefault.default));
parcelHelpers.export(exports, "LucidePilcrow", ()=>(0, _pilcrowJsDefault.default));
parcelHelpers.export(exports, "Pilcrow", ()=>(0, _pilcrowJsDefault.default));
parcelHelpers.export(exports, "PilcrowIcon", ()=>(0, _pilcrowJsDefault.default));
parcelHelpers.export(exports, "LucidePillBottle", ()=>(0, _pillBottleJsDefault.default));
parcelHelpers.export(exports, "PillBottle", ()=>(0, _pillBottleJsDefault.default));
parcelHelpers.export(exports, "PillBottleIcon", ()=>(0, _pillBottleJsDefault.default));
parcelHelpers.export(exports, "LucidePill", ()=>(0, _pillJsDefault.default));
parcelHelpers.export(exports, "Pill", ()=>(0, _pillJsDefault.default));
parcelHelpers.export(exports, "PillIcon", ()=>(0, _pillJsDefault.default));
parcelHelpers.export(exports, "LucidePinOff", ()=>(0, _pinOffJsDefault.default));
parcelHelpers.export(exports, "PinOff", ()=>(0, _pinOffJsDefault.default));
parcelHelpers.export(exports, "PinOffIcon", ()=>(0, _pinOffJsDefault.default));
parcelHelpers.export(exports, "LucidePin", ()=>(0, _pinJsDefault.default));
parcelHelpers.export(exports, "Pin", ()=>(0, _pinJsDefault.default));
parcelHelpers.export(exports, "PinIcon", ()=>(0, _pinJsDefault.default));
parcelHelpers.export(exports, "LucidePipette", ()=>(0, _pipetteJsDefault.default));
parcelHelpers.export(exports, "Pipette", ()=>(0, _pipetteJsDefault.default));
parcelHelpers.export(exports, "PipetteIcon", ()=>(0, _pipetteJsDefault.default));
parcelHelpers.export(exports, "LucidePizza", ()=>(0, _pizzaJsDefault.default));
parcelHelpers.export(exports, "Pizza", ()=>(0, _pizzaJsDefault.default));
parcelHelpers.export(exports, "PizzaIcon", ()=>(0, _pizzaJsDefault.default));
parcelHelpers.export(exports, "LucidePlaneLanding", ()=>(0, _planeLandingJsDefault.default));
parcelHelpers.export(exports, "PlaneLanding", ()=>(0, _planeLandingJsDefault.default));
parcelHelpers.export(exports, "PlaneLandingIcon", ()=>(0, _planeLandingJsDefault.default));
parcelHelpers.export(exports, "LucidePlaneTakeoff", ()=>(0, _planeTakeoffJsDefault.default));
parcelHelpers.export(exports, "PlaneTakeoff", ()=>(0, _planeTakeoffJsDefault.default));
parcelHelpers.export(exports, "PlaneTakeoffIcon", ()=>(0, _planeTakeoffJsDefault.default));
parcelHelpers.export(exports, "LucidePlane", ()=>(0, _planeJsDefault.default));
parcelHelpers.export(exports, "Plane", ()=>(0, _planeJsDefault.default));
parcelHelpers.export(exports, "PlaneIcon", ()=>(0, _planeJsDefault.default));
parcelHelpers.export(exports, "LucidePlay", ()=>(0, _playJsDefault.default));
parcelHelpers.export(exports, "Play", ()=>(0, _playJsDefault.default));
parcelHelpers.export(exports, "PlayIcon", ()=>(0, _playJsDefault.default));
parcelHelpers.export(exports, "LucidePlug2", ()=>(0, _plug2JsDefault.default));
parcelHelpers.export(exports, "Plug2", ()=>(0, _plug2JsDefault.default));
parcelHelpers.export(exports, "Plug2Icon", ()=>(0, _plug2JsDefault.default));
parcelHelpers.export(exports, "LucidePlus", ()=>(0, _plusJsDefault.default));
parcelHelpers.export(exports, "Plus", ()=>(0, _plusJsDefault.default));
parcelHelpers.export(exports, "PlusIcon", ()=>(0, _plusJsDefault.default));
parcelHelpers.export(exports, "LucidePlug", ()=>(0, _plugJsDefault.default));
parcelHelpers.export(exports, "Plug", ()=>(0, _plugJsDefault.default));
parcelHelpers.export(exports, "PlugIcon", ()=>(0, _plugJsDefault.default));
parcelHelpers.export(exports, "LucidePocketKnife", ()=>(0, _pocketKnifeJsDefault.default));
parcelHelpers.export(exports, "PocketKnife", ()=>(0, _pocketKnifeJsDefault.default));
parcelHelpers.export(exports, "PocketKnifeIcon", ()=>(0, _pocketKnifeJsDefault.default));
parcelHelpers.export(exports, "LucidePocket", ()=>(0, _pocketJsDefault.default));
parcelHelpers.export(exports, "Pocket", ()=>(0, _pocketJsDefault.default));
parcelHelpers.export(exports, "PocketIcon", ()=>(0, _pocketJsDefault.default));
parcelHelpers.export(exports, "LucidePointerOff", ()=>(0, _pointerOffJsDefault.default));
parcelHelpers.export(exports, "PointerOff", ()=>(0, _pointerOffJsDefault.default));
parcelHelpers.export(exports, "PointerOffIcon", ()=>(0, _pointerOffJsDefault.default));
parcelHelpers.export(exports, "LucidePodcast", ()=>(0, _podcastJsDefault.default));
parcelHelpers.export(exports, "Podcast", ()=>(0, _podcastJsDefault.default));
parcelHelpers.export(exports, "PodcastIcon", ()=>(0, _podcastJsDefault.default));
parcelHelpers.export(exports, "LucidePointer", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "Pointer", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "PointerIcon", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "LucidePopcorn", ()=>(0, _popcornJsDefault.default));
parcelHelpers.export(exports, "Popcorn", ()=>(0, _popcornJsDefault.default));
parcelHelpers.export(exports, "PopcornIcon", ()=>(0, _popcornJsDefault.default));
parcelHelpers.export(exports, "LucidePopsicle", ()=>(0, _popsicleJsDefault.default));
parcelHelpers.export(exports, "Popsicle", ()=>(0, _popsicleJsDefault.default));
parcelHelpers.export(exports, "PopsicleIcon", ()=>(0, _popsicleJsDefault.default));
parcelHelpers.export(exports, "LucidePoundSterling", ()=>(0, _poundSterlingJsDefault.default));
parcelHelpers.export(exports, "PoundSterling", ()=>(0, _poundSterlingJsDefault.default));
parcelHelpers.export(exports, "PoundSterlingIcon", ()=>(0, _poundSterlingJsDefault.default));
parcelHelpers.export(exports, "LucidePowerOff", ()=>(0, _powerOffJsDefault.default));
parcelHelpers.export(exports, "PowerOff", ()=>(0, _powerOffJsDefault.default));
parcelHelpers.export(exports, "PowerOffIcon", ()=>(0, _powerOffJsDefault.default));
parcelHelpers.export(exports, "LucidePower", ()=>(0, _powerJsDefault.default));
parcelHelpers.export(exports, "Power", ()=>(0, _powerJsDefault.default));
parcelHelpers.export(exports, "PowerIcon", ()=>(0, _powerJsDefault.default));
parcelHelpers.export(exports, "LucidePresentation", ()=>(0, _presentationJsDefault.default));
parcelHelpers.export(exports, "Presentation", ()=>(0, _presentationJsDefault.default));
parcelHelpers.export(exports, "PresentationIcon", ()=>(0, _presentationJsDefault.default));
parcelHelpers.export(exports, "LucidePrinterCheck", ()=>(0, _printerCheckJsDefault.default));
parcelHelpers.export(exports, "PrinterCheck", ()=>(0, _printerCheckJsDefault.default));
parcelHelpers.export(exports, "PrinterCheckIcon", ()=>(0, _printerCheckJsDefault.default));
parcelHelpers.export(exports, "LucideProjector", ()=>(0, _projectorJsDefault.default));
parcelHelpers.export(exports, "Projector", ()=>(0, _projectorJsDefault.default));
parcelHelpers.export(exports, "ProjectorIcon", ()=>(0, _projectorJsDefault.default));
parcelHelpers.export(exports, "LucidePrinter", ()=>(0, _printerJsDefault.default));
parcelHelpers.export(exports, "Printer", ()=>(0, _printerJsDefault.default));
parcelHelpers.export(exports, "PrinterIcon", ()=>(0, _printerJsDefault.default));
parcelHelpers.export(exports, "LucidePuzzle", ()=>(0, _puzzleJsDefault.default));
parcelHelpers.export(exports, "Puzzle", ()=>(0, _puzzleJsDefault.default));
parcelHelpers.export(exports, "PuzzleIcon", ()=>(0, _puzzleJsDefault.default));
parcelHelpers.export(exports, "LucideProportions", ()=>(0, _proportionsJsDefault.default));
parcelHelpers.export(exports, "Proportions", ()=>(0, _proportionsJsDefault.default));
parcelHelpers.export(exports, "ProportionsIcon", ()=>(0, _proportionsJsDefault.default));
parcelHelpers.export(exports, "LucidePyramid", ()=>(0, _pyramidJsDefault.default));
parcelHelpers.export(exports, "Pyramid", ()=>(0, _pyramidJsDefault.default));
parcelHelpers.export(exports, "PyramidIcon", ()=>(0, _pyramidJsDefault.default));
parcelHelpers.export(exports, "LucideQrCode", ()=>(0, _qrCodeJsDefault.default));
parcelHelpers.export(exports, "QrCode", ()=>(0, _qrCodeJsDefault.default));
parcelHelpers.export(exports, "QrCodeIcon", ()=>(0, _qrCodeJsDefault.default));
parcelHelpers.export(exports, "LucideQuote", ()=>(0, _quoteJsDefault.default));
parcelHelpers.export(exports, "Quote", ()=>(0, _quoteJsDefault.default));
parcelHelpers.export(exports, "QuoteIcon", ()=>(0, _quoteJsDefault.default));
parcelHelpers.export(exports, "LucideRabbit", ()=>(0, _rabbitJsDefault.default));
parcelHelpers.export(exports, "Rabbit", ()=>(0, _rabbitJsDefault.default));
parcelHelpers.export(exports, "RabbitIcon", ()=>(0, _rabbitJsDefault.default));
parcelHelpers.export(exports, "LucideRadar", ()=>(0, _radarJsDefault.default));
parcelHelpers.export(exports, "Radar", ()=>(0, _radarJsDefault.default));
parcelHelpers.export(exports, "RadarIcon", ()=>(0, _radarJsDefault.default));
parcelHelpers.export(exports, "LucideRadiation", ()=>(0, _radiationJsDefault.default));
parcelHelpers.export(exports, "Radiation", ()=>(0, _radiationJsDefault.default));
parcelHelpers.export(exports, "RadiationIcon", ()=>(0, _radiationJsDefault.default));
parcelHelpers.export(exports, "LucideRadical", ()=>(0, _radicalJsDefault.default));
parcelHelpers.export(exports, "Radical", ()=>(0, _radicalJsDefault.default));
parcelHelpers.export(exports, "RadicalIcon", ()=>(0, _radicalJsDefault.default));
parcelHelpers.export(exports, "LucideRadioReceiver", ()=>(0, _radioReceiverJsDefault.default));
parcelHelpers.export(exports, "RadioReceiver", ()=>(0, _radioReceiverJsDefault.default));
parcelHelpers.export(exports, "RadioReceiverIcon", ()=>(0, _radioReceiverJsDefault.default));
parcelHelpers.export(exports, "LucideRadioTower", ()=>(0, _radioTowerJsDefault.default));
parcelHelpers.export(exports, "RadioTower", ()=>(0, _radioTowerJsDefault.default));
parcelHelpers.export(exports, "RadioTowerIcon", ()=>(0, _radioTowerJsDefault.default));
parcelHelpers.export(exports, "LucideRadio", ()=>(0, _radioJsDefault.default));
parcelHelpers.export(exports, "Radio", ()=>(0, _radioJsDefault.default));
parcelHelpers.export(exports, "RadioIcon", ()=>(0, _radioJsDefault.default));
parcelHelpers.export(exports, "LucideRadius", ()=>(0, _radiusJsDefault.default));
parcelHelpers.export(exports, "Radius", ()=>(0, _radiusJsDefault.default));
parcelHelpers.export(exports, "RadiusIcon", ()=>(0, _radiusJsDefault.default));
parcelHelpers.export(exports, "LucideRailSymbol", ()=>(0, _railSymbolJsDefault.default));
parcelHelpers.export(exports, "RailSymbol", ()=>(0, _railSymbolJsDefault.default));
parcelHelpers.export(exports, "RailSymbolIcon", ()=>(0, _railSymbolJsDefault.default));
parcelHelpers.export(exports, "LucideRat", ()=>(0, _ratJsDefault.default));
parcelHelpers.export(exports, "Rat", ()=>(0, _ratJsDefault.default));
parcelHelpers.export(exports, "RatIcon", ()=>(0, _ratJsDefault.default));
parcelHelpers.export(exports, "LucideRatio", ()=>(0, _ratioJsDefault.default));
parcelHelpers.export(exports, "Ratio", ()=>(0, _ratioJsDefault.default));
parcelHelpers.export(exports, "RatioIcon", ()=>(0, _ratioJsDefault.default));
parcelHelpers.export(exports, "LucideRainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "Rainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "RainbowIcon", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptCent", ()=>(0, _receiptCentJsDefault.default));
parcelHelpers.export(exports, "ReceiptCent", ()=>(0, _receiptCentJsDefault.default));
parcelHelpers.export(exports, "ReceiptCentIcon", ()=>(0, _receiptCentJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptEuro", ()=>(0, _receiptEuroJsDefault.default));
parcelHelpers.export(exports, "ReceiptEuro", ()=>(0, _receiptEuroJsDefault.default));
parcelHelpers.export(exports, "ReceiptEuroIcon", ()=>(0, _receiptEuroJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptIndianRupee", ()=>(0, _receiptIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "ReceiptIndianRupee", ()=>(0, _receiptIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "ReceiptIndianRupeeIcon", ()=>(0, _receiptIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptPoundSterling", ()=>(0, _receiptPoundSterlingJsDefault.default));
parcelHelpers.export(exports, "ReceiptPoundSterling", ()=>(0, _receiptPoundSterlingJsDefault.default));
parcelHelpers.export(exports, "ReceiptPoundSterlingIcon", ()=>(0, _receiptPoundSterlingJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptJapaneseYen", ()=>(0, _receiptJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "ReceiptJapaneseYen", ()=>(0, _receiptJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "ReceiptJapaneseYenIcon", ()=>(0, _receiptJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptRussianRuble", ()=>(0, _receiptRussianRubleJsDefault.default));
parcelHelpers.export(exports, "ReceiptRussianRuble", ()=>(0, _receiptRussianRubleJsDefault.default));
parcelHelpers.export(exports, "ReceiptRussianRubleIcon", ()=>(0, _receiptRussianRubleJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptText", ()=>(0, _receiptTextJsDefault.default));
parcelHelpers.export(exports, "ReceiptText", ()=>(0, _receiptTextJsDefault.default));
parcelHelpers.export(exports, "ReceiptTextIcon", ()=>(0, _receiptTextJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptSwissFranc", ()=>(0, _receiptSwissFrancJsDefault.default));
parcelHelpers.export(exports, "ReceiptSwissFranc", ()=>(0, _receiptSwissFrancJsDefault.default));
parcelHelpers.export(exports, "ReceiptSwissFrancIcon", ()=>(0, _receiptSwissFrancJsDefault.default));
parcelHelpers.export(exports, "LucideReceipt", ()=>(0, _receiptJsDefault.default));
parcelHelpers.export(exports, "Receipt", ()=>(0, _receiptJsDefault.default));
parcelHelpers.export(exports, "ReceiptIcon", ()=>(0, _receiptJsDefault.default));
parcelHelpers.export(exports, "LucideRectangleCircle", ()=>(0, _rectangleCircleJsDefault.default));
parcelHelpers.export(exports, "RectangleCircle", ()=>(0, _rectangleCircleJsDefault.default));
parcelHelpers.export(exports, "RectangleCircleIcon", ()=>(0, _rectangleCircleJsDefault.default));
parcelHelpers.export(exports, "LucideRectangleHorizontal", ()=>(0, _rectangleHorizontalJsDefault.default));
parcelHelpers.export(exports, "RectangleHorizontal", ()=>(0, _rectangleHorizontalJsDefault.default));
parcelHelpers.export(exports, "RectangleHorizontalIcon", ()=>(0, _rectangleHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideRectangleVertical", ()=>(0, _rectangleVerticalJsDefault.default));
parcelHelpers.export(exports, "RectangleVertical", ()=>(0, _rectangleVerticalJsDefault.default));
parcelHelpers.export(exports, "RectangleVerticalIcon", ()=>(0, _rectangleVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideRectangleGoggles", ()=>(0, _rectangleGogglesJsDefault.default));
parcelHelpers.export(exports, "RectangleGoggles", ()=>(0, _rectangleGogglesJsDefault.default));
parcelHelpers.export(exports, "RectangleGogglesIcon", ()=>(0, _rectangleGogglesJsDefault.default));
parcelHelpers.export(exports, "LucideRecycle", ()=>(0, _recycleJsDefault.default));
parcelHelpers.export(exports, "Recycle", ()=>(0, _recycleJsDefault.default));
parcelHelpers.export(exports, "RecycleIcon", ()=>(0, _recycleJsDefault.default));
parcelHelpers.export(exports, "LucideRedo2", ()=>(0, _redo2JsDefault.default));
parcelHelpers.export(exports, "Redo2", ()=>(0, _redo2JsDefault.default));
parcelHelpers.export(exports, "Redo2Icon", ()=>(0, _redo2JsDefault.default));
parcelHelpers.export(exports, "LucideRedoDot", ()=>(0, _redoDotJsDefault.default));
parcelHelpers.export(exports, "RedoDot", ()=>(0, _redoDotJsDefault.default));
parcelHelpers.export(exports, "RedoDotIcon", ()=>(0, _redoDotJsDefault.default));
parcelHelpers.export(exports, "LucideRefreshCcwDot", ()=>(0, _refreshCcwDotJsDefault.default));
parcelHelpers.export(exports, "RefreshCcwDot", ()=>(0, _refreshCcwDotJsDefault.default));
parcelHelpers.export(exports, "RefreshCcwDotIcon", ()=>(0, _refreshCcwDotJsDefault.default));
parcelHelpers.export(exports, "LucideRedo", ()=>(0, _redoJsDefault.default));
parcelHelpers.export(exports, "Redo", ()=>(0, _redoJsDefault.default));
parcelHelpers.export(exports, "RedoIcon", ()=>(0, _redoJsDefault.default));
parcelHelpers.export(exports, "LucideRefreshCcw", ()=>(0, _refreshCcwJsDefault.default));
parcelHelpers.export(exports, "RefreshCcw", ()=>(0, _refreshCcwJsDefault.default));
parcelHelpers.export(exports, "RefreshCcwIcon", ()=>(0, _refreshCcwJsDefault.default));
parcelHelpers.export(exports, "LucideRefreshCwOff", ()=>(0, _refreshCwOffJsDefault.default));
parcelHelpers.export(exports, "RefreshCwOff", ()=>(0, _refreshCwOffJsDefault.default));
parcelHelpers.export(exports, "RefreshCwOffIcon", ()=>(0, _refreshCwOffJsDefault.default));
parcelHelpers.export(exports, "LucideRefreshCw", ()=>(0, _refreshCwJsDefault.default));
parcelHelpers.export(exports, "RefreshCw", ()=>(0, _refreshCwJsDefault.default));
parcelHelpers.export(exports, "RefreshCwIcon", ()=>(0, _refreshCwJsDefault.default));
parcelHelpers.export(exports, "LucideRefrigerator", ()=>(0, _refrigeratorJsDefault.default));
parcelHelpers.export(exports, "Refrigerator", ()=>(0, _refrigeratorJsDefault.default));
parcelHelpers.export(exports, "RefrigeratorIcon", ()=>(0, _refrigeratorJsDefault.default));
parcelHelpers.export(exports, "LucideRegex", ()=>(0, _regexJsDefault.default));
parcelHelpers.export(exports, "Regex", ()=>(0, _regexJsDefault.default));
parcelHelpers.export(exports, "RegexIcon", ()=>(0, _regexJsDefault.default));
parcelHelpers.export(exports, "LucideRemoveFormatting", ()=>(0, _removeFormattingJsDefault.default));
parcelHelpers.export(exports, "RemoveFormatting", ()=>(0, _removeFormattingJsDefault.default));
parcelHelpers.export(exports, "RemoveFormattingIcon", ()=>(0, _removeFormattingJsDefault.default));
parcelHelpers.export(exports, "LucideRepeat2", ()=>(0, _repeat2JsDefault.default));
parcelHelpers.export(exports, "Repeat2", ()=>(0, _repeat2JsDefault.default));
parcelHelpers.export(exports, "Repeat2Icon", ()=>(0, _repeat2JsDefault.default));
parcelHelpers.export(exports, "LucideRepeat1", ()=>(0, _repeat1JsDefault.default));
parcelHelpers.export(exports, "Repeat1", ()=>(0, _repeat1JsDefault.default));
parcelHelpers.export(exports, "Repeat1Icon", ()=>(0, _repeat1JsDefault.default));
parcelHelpers.export(exports, "LucideRepeat", ()=>(0, _repeatJsDefault.default));
parcelHelpers.export(exports, "Repeat", ()=>(0, _repeatJsDefault.default));
parcelHelpers.export(exports, "RepeatIcon", ()=>(0, _repeatJsDefault.default));
parcelHelpers.export(exports, "LucideReplaceAll", ()=>(0, _replaceAllJsDefault.default));
parcelHelpers.export(exports, "ReplaceAll", ()=>(0, _replaceAllJsDefault.default));
parcelHelpers.export(exports, "ReplaceAllIcon", ()=>(0, _replaceAllJsDefault.default));
parcelHelpers.export(exports, "LucideReplace", ()=>(0, _replaceJsDefault.default));
parcelHelpers.export(exports, "Replace", ()=>(0, _replaceJsDefault.default));
parcelHelpers.export(exports, "ReplaceIcon", ()=>(0, _replaceJsDefault.default));
parcelHelpers.export(exports, "LucideReplyAll", ()=>(0, _replyAllJsDefault.default));
parcelHelpers.export(exports, "ReplyAll", ()=>(0, _replyAllJsDefault.default));
parcelHelpers.export(exports, "ReplyAllIcon", ()=>(0, _replyAllJsDefault.default));
parcelHelpers.export(exports, "LucideReply", ()=>(0, _replyJsDefault.default));
parcelHelpers.export(exports, "Reply", ()=>(0, _replyJsDefault.default));
parcelHelpers.export(exports, "ReplyIcon", ()=>(0, _replyJsDefault.default));
parcelHelpers.export(exports, "LucideRewind", ()=>(0, _rewindJsDefault.default));
parcelHelpers.export(exports, "Rewind", ()=>(0, _rewindJsDefault.default));
parcelHelpers.export(exports, "RewindIcon", ()=>(0, _rewindJsDefault.default));
parcelHelpers.export(exports, "LucideRibbon", ()=>(0, _ribbonJsDefault.default));
parcelHelpers.export(exports, "Ribbon", ()=>(0, _ribbonJsDefault.default));
parcelHelpers.export(exports, "RibbonIcon", ()=>(0, _ribbonJsDefault.default));
parcelHelpers.export(exports, "LucideRocket", ()=>(0, _rocketJsDefault.default));
parcelHelpers.export(exports, "Rocket", ()=>(0, _rocketJsDefault.default));
parcelHelpers.export(exports, "RocketIcon", ()=>(0, _rocketJsDefault.default));
parcelHelpers.export(exports, "LucideRockingChair", ()=>(0, _rockingChairJsDefault.default));
parcelHelpers.export(exports, "RockingChair", ()=>(0, _rockingChairJsDefault.default));
parcelHelpers.export(exports, "RockingChairIcon", ()=>(0, _rockingChairJsDefault.default));
parcelHelpers.export(exports, "LucideRollerCoaster", ()=>(0, _rollerCoasterJsDefault.default));
parcelHelpers.export(exports, "RollerCoaster", ()=>(0, _rollerCoasterJsDefault.default));
parcelHelpers.export(exports, "RollerCoasterIcon", ()=>(0, _rollerCoasterJsDefault.default));
parcelHelpers.export(exports, "LucideRotateCcwKey", ()=>(0, _rotateCcwKeyJsDefault.default));
parcelHelpers.export(exports, "RotateCcwKey", ()=>(0, _rotateCcwKeyJsDefault.default));
parcelHelpers.export(exports, "RotateCcwKeyIcon", ()=>(0, _rotateCcwKeyJsDefault.default));
parcelHelpers.export(exports, "LucideRotateCcwSquare", ()=>(0, _rotateCcwSquareJsDefault.default));
parcelHelpers.export(exports, "RotateCcwSquare", ()=>(0, _rotateCcwSquareJsDefault.default));
parcelHelpers.export(exports, "RotateCcwSquareIcon", ()=>(0, _rotateCcwSquareJsDefault.default));
parcelHelpers.export(exports, "LucideRotateCcw", ()=>(0, _rotateCcwJsDefault.default));
parcelHelpers.export(exports, "RotateCcw", ()=>(0, _rotateCcwJsDefault.default));
parcelHelpers.export(exports, "RotateCcwIcon", ()=>(0, _rotateCcwJsDefault.default));
parcelHelpers.export(exports, "LucideRotateCwSquare", ()=>(0, _rotateCwSquareJsDefault.default));
parcelHelpers.export(exports, "RotateCwSquare", ()=>(0, _rotateCwSquareJsDefault.default));
parcelHelpers.export(exports, "RotateCwSquareIcon", ()=>(0, _rotateCwSquareJsDefault.default));
parcelHelpers.export(exports, "LucideRouteOff", ()=>(0, _routeOffJsDefault.default));
parcelHelpers.export(exports, "RouteOff", ()=>(0, _routeOffJsDefault.default));
parcelHelpers.export(exports, "RouteOffIcon", ()=>(0, _routeOffJsDefault.default));
parcelHelpers.export(exports, "LucideRoute", ()=>(0, _routeJsDefault.default));
parcelHelpers.export(exports, "Route", ()=>(0, _routeJsDefault.default));
parcelHelpers.export(exports, "RouteIcon", ()=>(0, _routeJsDefault.default));
parcelHelpers.export(exports, "LucideRotateCw", ()=>(0, _rotateCwJsDefault.default));
parcelHelpers.export(exports, "RotateCw", ()=>(0, _rotateCwJsDefault.default));
parcelHelpers.export(exports, "RotateCwIcon", ()=>(0, _rotateCwJsDefault.default));
parcelHelpers.export(exports, "LucideRouter", ()=>(0, _routerJsDefault.default));
parcelHelpers.export(exports, "Router", ()=>(0, _routerJsDefault.default));
parcelHelpers.export(exports, "RouterIcon", ()=>(0, _routerJsDefault.default));
parcelHelpers.export(exports, "LucideRows4", ()=>(0, _rows4JsDefault.default));
parcelHelpers.export(exports, "Rows4", ()=>(0, _rows4JsDefault.default));
parcelHelpers.export(exports, "Rows4Icon", ()=>(0, _rows4JsDefault.default));
parcelHelpers.export(exports, "LucideRss", ()=>(0, _rssJsDefault.default));
parcelHelpers.export(exports, "Rss", ()=>(0, _rssJsDefault.default));
parcelHelpers.export(exports, "RssIcon", ()=>(0, _rssJsDefault.default));
parcelHelpers.export(exports, "LucideRulerDimensionLine", ()=>(0, _rulerDimensionLineJsDefault.default));
parcelHelpers.export(exports, "RulerDimensionLine", ()=>(0, _rulerDimensionLineJsDefault.default));
parcelHelpers.export(exports, "RulerDimensionLineIcon", ()=>(0, _rulerDimensionLineJsDefault.default));
parcelHelpers.export(exports, "LucideRuler", ()=>(0, _rulerJsDefault.default));
parcelHelpers.export(exports, "Ruler", ()=>(0, _rulerJsDefault.default));
parcelHelpers.export(exports, "RulerIcon", ()=>(0, _rulerJsDefault.default));
parcelHelpers.export(exports, "LucideRussianRuble", ()=>(0, _russianRubleJsDefault.default));
parcelHelpers.export(exports, "RussianRuble", ()=>(0, _russianRubleJsDefault.default));
parcelHelpers.export(exports, "RussianRubleIcon", ()=>(0, _russianRubleJsDefault.default));
parcelHelpers.export(exports, "LucideSailboat", ()=>(0, _sailboatJsDefault.default));
parcelHelpers.export(exports, "Sailboat", ()=>(0, _sailboatJsDefault.default));
parcelHelpers.export(exports, "SailboatIcon", ()=>(0, _sailboatJsDefault.default));
parcelHelpers.export(exports, "LucideSalad", ()=>(0, _saladJsDefault.default));
parcelHelpers.export(exports, "Salad", ()=>(0, _saladJsDefault.default));
parcelHelpers.export(exports, "SaladIcon", ()=>(0, _saladJsDefault.default));
parcelHelpers.export(exports, "LucideSandwich", ()=>(0, _sandwichJsDefault.default));
parcelHelpers.export(exports, "Sandwich", ()=>(0, _sandwichJsDefault.default));
parcelHelpers.export(exports, "SandwichIcon", ()=>(0, _sandwichJsDefault.default));
parcelHelpers.export(exports, "LucideSatelliteDish", ()=>(0, _satelliteDishJsDefault.default));
parcelHelpers.export(exports, "SatelliteDish", ()=>(0, _satelliteDishJsDefault.default));
parcelHelpers.export(exports, "SatelliteDishIcon", ()=>(0, _satelliteDishJsDefault.default));
parcelHelpers.export(exports, "LucideSatellite", ()=>(0, _satelliteJsDefault.default));
parcelHelpers.export(exports, "Satellite", ()=>(0, _satelliteJsDefault.default));
parcelHelpers.export(exports, "SatelliteIcon", ()=>(0, _satelliteJsDefault.default));
parcelHelpers.export(exports, "LucideSaudiRiyal", ()=>(0, _saudiRiyalJsDefault.default));
parcelHelpers.export(exports, "SaudiRiyal", ()=>(0, _saudiRiyalJsDefault.default));
parcelHelpers.export(exports, "SaudiRiyalIcon", ()=>(0, _saudiRiyalJsDefault.default));
parcelHelpers.export(exports, "LucideSaveAll", ()=>(0, _saveAllJsDefault.default));
parcelHelpers.export(exports, "SaveAll", ()=>(0, _saveAllJsDefault.default));
parcelHelpers.export(exports, "SaveAllIcon", ()=>(0, _saveAllJsDefault.default));
parcelHelpers.export(exports, "LucideSaveOff", ()=>(0, _saveOffJsDefault.default));
parcelHelpers.export(exports, "SaveOff", ()=>(0, _saveOffJsDefault.default));
parcelHelpers.export(exports, "SaveOffIcon", ()=>(0, _saveOffJsDefault.default));
parcelHelpers.export(exports, "LucideSave", ()=>(0, _saveJsDefault.default));
parcelHelpers.export(exports, "Save", ()=>(0, _saveJsDefault.default));
parcelHelpers.export(exports, "SaveIcon", ()=>(0, _saveJsDefault.default));
parcelHelpers.export(exports, "LucideScale", ()=>(0, _scaleJsDefault.default));
parcelHelpers.export(exports, "Scale", ()=>(0, _scaleJsDefault.default));
parcelHelpers.export(exports, "ScaleIcon", ()=>(0, _scaleJsDefault.default));
parcelHelpers.export(exports, "LucideScaling", ()=>(0, _scalingJsDefault.default));
parcelHelpers.export(exports, "Scaling", ()=>(0, _scalingJsDefault.default));
parcelHelpers.export(exports, "ScalingIcon", ()=>(0, _scalingJsDefault.default));
parcelHelpers.export(exports, "LucideScanBarcode", ()=>(0, _scanBarcodeJsDefault.default));
parcelHelpers.export(exports, "ScanBarcode", ()=>(0, _scanBarcodeJsDefault.default));
parcelHelpers.export(exports, "ScanBarcodeIcon", ()=>(0, _scanBarcodeJsDefault.default));
parcelHelpers.export(exports, "LucideScanEye", ()=>(0, _scanEyeJsDefault.default));
parcelHelpers.export(exports, "ScanEye", ()=>(0, _scanEyeJsDefault.default));
parcelHelpers.export(exports, "ScanEyeIcon", ()=>(0, _scanEyeJsDefault.default));
parcelHelpers.export(exports, "LucideScanFace", ()=>(0, _scanFaceJsDefault.default));
parcelHelpers.export(exports, "ScanFace", ()=>(0, _scanFaceJsDefault.default));
parcelHelpers.export(exports, "ScanFaceIcon", ()=>(0, _scanFaceJsDefault.default));
parcelHelpers.export(exports, "LucideScanHeart", ()=>(0, _scanHeartJsDefault.default));
parcelHelpers.export(exports, "ScanHeart", ()=>(0, _scanHeartJsDefault.default));
parcelHelpers.export(exports, "ScanHeartIcon", ()=>(0, _scanHeartJsDefault.default));
parcelHelpers.export(exports, "LucideScanLine", ()=>(0, _scanLineJsDefault.default));
parcelHelpers.export(exports, "ScanLine", ()=>(0, _scanLineJsDefault.default));
parcelHelpers.export(exports, "ScanLineIcon", ()=>(0, _scanLineJsDefault.default));
parcelHelpers.export(exports, "LucideScanQrCode", ()=>(0, _scanQrCodeJsDefault.default));
parcelHelpers.export(exports, "ScanQrCode", ()=>(0, _scanQrCodeJsDefault.default));
parcelHelpers.export(exports, "ScanQrCodeIcon", ()=>(0, _scanQrCodeJsDefault.default));
parcelHelpers.export(exports, "LucideScanSearch", ()=>(0, _scanSearchJsDefault.default));
parcelHelpers.export(exports, "ScanSearch", ()=>(0, _scanSearchJsDefault.default));
parcelHelpers.export(exports, "ScanSearchIcon", ()=>(0, _scanSearchJsDefault.default));
parcelHelpers.export(exports, "LucideScanText", ()=>(0, _scanTextJsDefault.default));
parcelHelpers.export(exports, "ScanText", ()=>(0, _scanTextJsDefault.default));
parcelHelpers.export(exports, "ScanTextIcon", ()=>(0, _scanTextJsDefault.default));
parcelHelpers.export(exports, "LucideScan", ()=>(0, _scanJsDefault.default));
parcelHelpers.export(exports, "Scan", ()=>(0, _scanJsDefault.default));
parcelHelpers.export(exports, "ScanIcon", ()=>(0, _scanJsDefault.default));
parcelHelpers.export(exports, "LucideSchool", ()=>(0, _schoolJsDefault.default));
parcelHelpers.export(exports, "School", ()=>(0, _schoolJsDefault.default));
parcelHelpers.export(exports, "SchoolIcon", ()=>(0, _schoolJsDefault.default));
parcelHelpers.export(exports, "LucideScissorsLineDashed", ()=>(0, _scissorsLineDashedJsDefault.default));
parcelHelpers.export(exports, "ScissorsLineDashed", ()=>(0, _scissorsLineDashedJsDefault.default));
parcelHelpers.export(exports, "ScissorsLineDashedIcon", ()=>(0, _scissorsLineDashedJsDefault.default));
parcelHelpers.export(exports, "LucideScissors", ()=>(0, _scissorsJsDefault.default));
parcelHelpers.export(exports, "Scissors", ()=>(0, _scissorsJsDefault.default));
parcelHelpers.export(exports, "ScissorsIcon", ()=>(0, _scissorsJsDefault.default));
parcelHelpers.export(exports, "LucideScreenShareOff", ()=>(0, _screenShareOffJsDefault.default));
parcelHelpers.export(exports, "ScreenShareOff", ()=>(0, _screenShareOffJsDefault.default));
parcelHelpers.export(exports, "ScreenShareOffIcon", ()=>(0, _screenShareOffJsDefault.default));
parcelHelpers.export(exports, "LucideScreenShare", ()=>(0, _screenShareJsDefault.default));
parcelHelpers.export(exports, "ScreenShare", ()=>(0, _screenShareJsDefault.default));
parcelHelpers.export(exports, "ScreenShareIcon", ()=>(0, _screenShareJsDefault.default));
parcelHelpers.export(exports, "LucideScrollText", ()=>(0, _scrollTextJsDefault.default));
parcelHelpers.export(exports, "ScrollText", ()=>(0, _scrollTextJsDefault.default));
parcelHelpers.export(exports, "ScrollTextIcon", ()=>(0, _scrollTextJsDefault.default));
parcelHelpers.export(exports, "LucideScroll", ()=>(0, _scrollJsDefault.default));
parcelHelpers.export(exports, "Scroll", ()=>(0, _scrollJsDefault.default));
parcelHelpers.export(exports, "ScrollIcon", ()=>(0, _scrollJsDefault.default));
parcelHelpers.export(exports, "LucideSearchCheck", ()=>(0, _searchCheckJsDefault.default));
parcelHelpers.export(exports, "SearchCheck", ()=>(0, _searchCheckJsDefault.default));
parcelHelpers.export(exports, "SearchCheckIcon", ()=>(0, _searchCheckJsDefault.default));
parcelHelpers.export(exports, "LucideSearchCode", ()=>(0, _searchCodeJsDefault.default));
parcelHelpers.export(exports, "SearchCode", ()=>(0, _searchCodeJsDefault.default));
parcelHelpers.export(exports, "SearchCodeIcon", ()=>(0, _searchCodeJsDefault.default));
parcelHelpers.export(exports, "LucideSearchSlash", ()=>(0, _searchSlashJsDefault.default));
parcelHelpers.export(exports, "SearchSlash", ()=>(0, _searchSlashJsDefault.default));
parcelHelpers.export(exports, "SearchSlashIcon", ()=>(0, _searchSlashJsDefault.default));
parcelHelpers.export(exports, "LucideSearchX", ()=>(0, _searchXJsDefault.default));
parcelHelpers.export(exports, "SearchX", ()=>(0, _searchXJsDefault.default));
parcelHelpers.export(exports, "SearchXIcon", ()=>(0, _searchXJsDefault.default));
parcelHelpers.export(exports, "LucideSearch", ()=>(0, _searchJsDefault.default));
parcelHelpers.export(exports, "Search", ()=>(0, _searchJsDefault.default));
parcelHelpers.export(exports, "SearchIcon", ()=>(0, _searchJsDefault.default));
parcelHelpers.export(exports, "LucideSection", ()=>(0, _sectionJsDefault.default));
parcelHelpers.export(exports, "Section", ()=>(0, _sectionJsDefault.default));
parcelHelpers.export(exports, "SectionIcon", ()=>(0, _sectionJsDefault.default));
parcelHelpers.export(exports, "LucideSendToBack", ()=>(0, _sendToBackJsDefault.default));
parcelHelpers.export(exports, "SendToBack", ()=>(0, _sendToBackJsDefault.default));
parcelHelpers.export(exports, "SendToBackIcon", ()=>(0, _sendToBackJsDefault.default));
parcelHelpers.export(exports, "LucideSend", ()=>(0, _sendJsDefault.default));
parcelHelpers.export(exports, "Send", ()=>(0, _sendJsDefault.default));
parcelHelpers.export(exports, "SendIcon", ()=>(0, _sendJsDefault.default));
parcelHelpers.export(exports, "LucideSeparatorHorizontal", ()=>(0, _separatorHorizontalJsDefault.default));
parcelHelpers.export(exports, "SeparatorHorizontal", ()=>(0, _separatorHorizontalJsDefault.default));
parcelHelpers.export(exports, "SeparatorHorizontalIcon", ()=>(0, _separatorHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideSeparatorVertical", ()=>(0, _separatorVerticalJsDefault.default));
parcelHelpers.export(exports, "SeparatorVertical", ()=>(0, _separatorVerticalJsDefault.default));
parcelHelpers.export(exports, "SeparatorVerticalIcon", ()=>(0, _separatorVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideServerCog", ()=>(0, _serverCogJsDefault.default));
parcelHelpers.export(exports, "ServerCog", ()=>(0, _serverCogJsDefault.default));
parcelHelpers.export(exports, "ServerCogIcon", ()=>(0, _serverCogJsDefault.default));
parcelHelpers.export(exports, "LucideServerCrash", ()=>(0, _serverCrashJsDefault.default));
parcelHelpers.export(exports, "ServerCrash", ()=>(0, _serverCrashJsDefault.default));
parcelHelpers.export(exports, "ServerCrashIcon", ()=>(0, _serverCrashJsDefault.default));
parcelHelpers.export(exports, "LucideServer", ()=>(0, _serverJsDefault.default));
parcelHelpers.export(exports, "Server", ()=>(0, _serverJsDefault.default));
parcelHelpers.export(exports, "ServerIcon", ()=>(0, _serverJsDefault.default));
parcelHelpers.export(exports, "LucideSettings2", ()=>(0, _settings2JsDefault.default));
parcelHelpers.export(exports, "Settings2", ()=>(0, _settings2JsDefault.default));
parcelHelpers.export(exports, "Settings2Icon", ()=>(0, _settings2JsDefault.default));
parcelHelpers.export(exports, "LucideServerOff", ()=>(0, _serverOffJsDefault.default));
parcelHelpers.export(exports, "ServerOff", ()=>(0, _serverOffJsDefault.default));
parcelHelpers.export(exports, "ServerOffIcon", ()=>(0, _serverOffJsDefault.default));
parcelHelpers.export(exports, "LucideSettings", ()=>(0, _settingsJsDefault.default));
parcelHelpers.export(exports, "Settings", ()=>(0, _settingsJsDefault.default));
parcelHelpers.export(exports, "SettingsIcon", ()=>(0, _settingsJsDefault.default));
parcelHelpers.export(exports, "LucideShapes", ()=>(0, _shapesJsDefault.default));
parcelHelpers.export(exports, "Shapes", ()=>(0, _shapesJsDefault.default));
parcelHelpers.export(exports, "ShapesIcon", ()=>(0, _shapesJsDefault.default));
parcelHelpers.export(exports, "LucideShare2", ()=>(0, _share2JsDefault.default));
parcelHelpers.export(exports, "Share2", ()=>(0, _share2JsDefault.default));
parcelHelpers.export(exports, "Share2Icon", ()=>(0, _share2JsDefault.default));
parcelHelpers.export(exports, "LucideShell", ()=>(0, _shellJsDefault.default));
parcelHelpers.export(exports, "Shell", ()=>(0, _shellJsDefault.default));
parcelHelpers.export(exports, "ShellIcon", ()=>(0, _shellJsDefault.default));
parcelHelpers.export(exports, "LucideShare", ()=>(0, _shareJsDefault.default));
parcelHelpers.export(exports, "Share", ()=>(0, _shareJsDefault.default));
parcelHelpers.export(exports, "ShareIcon", ()=>(0, _shareJsDefault.default));
parcelHelpers.export(exports, "LucideSheet", ()=>(0, _sheetJsDefault.default));
parcelHelpers.export(exports, "Sheet", ()=>(0, _sheetJsDefault.default));
parcelHelpers.export(exports, "SheetIcon", ()=>(0, _sheetJsDefault.default));
parcelHelpers.export(exports, "LucideShieldBan", ()=>(0, _shieldBanJsDefault.default));
parcelHelpers.export(exports, "ShieldBan", ()=>(0, _shieldBanJsDefault.default));
parcelHelpers.export(exports, "ShieldBanIcon", ()=>(0, _shieldBanJsDefault.default));
parcelHelpers.export(exports, "LucideShieldAlert", ()=>(0, _shieldAlertJsDefault.default));
parcelHelpers.export(exports, "ShieldAlert", ()=>(0, _shieldAlertJsDefault.default));
parcelHelpers.export(exports, "ShieldAlertIcon", ()=>(0, _shieldAlertJsDefault.default));
parcelHelpers.export(exports, "LucideShieldCheck", ()=>(0, _shieldCheckJsDefault.default));
parcelHelpers.export(exports, "ShieldCheck", ()=>(0, _shieldCheckJsDefault.default));
parcelHelpers.export(exports, "ShieldCheckIcon", ()=>(0, _shieldCheckJsDefault.default));
parcelHelpers.export(exports, "LucideShieldEllipsis", ()=>(0, _shieldEllipsisJsDefault.default));
parcelHelpers.export(exports, "ShieldEllipsis", ()=>(0, _shieldEllipsisJsDefault.default));
parcelHelpers.export(exports, "ShieldEllipsisIcon", ()=>(0, _shieldEllipsisJsDefault.default));
parcelHelpers.export(exports, "LucideShieldHalf", ()=>(0, _shieldHalfJsDefault.default));
parcelHelpers.export(exports, "ShieldHalf", ()=>(0, _shieldHalfJsDefault.default));
parcelHelpers.export(exports, "ShieldHalfIcon", ()=>(0, _shieldHalfJsDefault.default));
parcelHelpers.export(exports, "LucideShieldMinus", ()=>(0, _shieldMinusJsDefault.default));
parcelHelpers.export(exports, "ShieldMinus", ()=>(0, _shieldMinusJsDefault.default));
parcelHelpers.export(exports, "ShieldMinusIcon", ()=>(0, _shieldMinusJsDefault.default));
parcelHelpers.export(exports, "LucideShieldOff", ()=>(0, _shieldOffJsDefault.default));
parcelHelpers.export(exports, "ShieldOff", ()=>(0, _shieldOffJsDefault.default));
parcelHelpers.export(exports, "ShieldOffIcon", ()=>(0, _shieldOffJsDefault.default));
parcelHelpers.export(exports, "LucideShieldPlus", ()=>(0, _shieldPlusJsDefault.default));
parcelHelpers.export(exports, "ShieldPlus", ()=>(0, _shieldPlusJsDefault.default));
parcelHelpers.export(exports, "ShieldPlusIcon", ()=>(0, _shieldPlusJsDefault.default));
parcelHelpers.export(exports, "LucideShieldQuestion", ()=>(0, _shieldQuestionJsDefault.default));
parcelHelpers.export(exports, "ShieldQuestion", ()=>(0, _shieldQuestionJsDefault.default));
parcelHelpers.export(exports, "ShieldQuestionIcon", ()=>(0, _shieldQuestionJsDefault.default));
parcelHelpers.export(exports, "LucideShieldUser", ()=>(0, _shieldUserJsDefault.default));
parcelHelpers.export(exports, "ShieldUser", ()=>(0, _shieldUserJsDefault.default));
parcelHelpers.export(exports, "ShieldUserIcon", ()=>(0, _shieldUserJsDefault.default));
parcelHelpers.export(exports, "LucideShield", ()=>(0, _shieldJsDefault.default));
parcelHelpers.export(exports, "Shield", ()=>(0, _shieldJsDefault.default));
parcelHelpers.export(exports, "ShieldIcon", ()=>(0, _shieldJsDefault.default));
parcelHelpers.export(exports, "LucideShipWheel", ()=>(0, _shipWheelJsDefault.default));
parcelHelpers.export(exports, "ShipWheel", ()=>(0, _shipWheelJsDefault.default));
parcelHelpers.export(exports, "ShipWheelIcon", ()=>(0, _shipWheelJsDefault.default));
parcelHelpers.export(exports, "LucideShip", ()=>(0, _shipJsDefault.default));
parcelHelpers.export(exports, "Ship", ()=>(0, _shipJsDefault.default));
parcelHelpers.export(exports, "ShipIcon", ()=>(0, _shipJsDefault.default));
parcelHelpers.export(exports, "LucideShirt", ()=>(0, _shirtJsDefault.default));
parcelHelpers.export(exports, "Shirt", ()=>(0, _shirtJsDefault.default));
parcelHelpers.export(exports, "ShirtIcon", ()=>(0, _shirtJsDefault.default));
parcelHelpers.export(exports, "LucideShoppingBag", ()=>(0, _shoppingBagJsDefault.default));
parcelHelpers.export(exports, "ShoppingBag", ()=>(0, _shoppingBagJsDefault.default));
parcelHelpers.export(exports, "ShoppingBagIcon", ()=>(0, _shoppingBagJsDefault.default));
parcelHelpers.export(exports, "LucideShoppingBasket", ()=>(0, _shoppingBasketJsDefault.default));
parcelHelpers.export(exports, "ShoppingBasket", ()=>(0, _shoppingBasketJsDefault.default));
parcelHelpers.export(exports, "ShoppingBasketIcon", ()=>(0, _shoppingBasketJsDefault.default));
parcelHelpers.export(exports, "LucideShoppingCart", ()=>(0, _shoppingCartJsDefault.default));
parcelHelpers.export(exports, "ShoppingCart", ()=>(0, _shoppingCartJsDefault.default));
parcelHelpers.export(exports, "ShoppingCartIcon", ()=>(0, _shoppingCartJsDefault.default));
parcelHelpers.export(exports, "LucideShovel", ()=>(0, _shovelJsDefault.default));
parcelHelpers.export(exports, "Shovel", ()=>(0, _shovelJsDefault.default));
parcelHelpers.export(exports, "ShovelIcon", ()=>(0, _shovelJsDefault.default));
parcelHelpers.export(exports, "LucideShowerHead", ()=>(0, _showerHeadJsDefault.default));
parcelHelpers.export(exports, "ShowerHead", ()=>(0, _showerHeadJsDefault.default));
parcelHelpers.export(exports, "ShowerHeadIcon", ()=>(0, _showerHeadJsDefault.default));
parcelHelpers.export(exports, "LucideShrimp", ()=>(0, _shrimpJsDefault.default));
parcelHelpers.export(exports, "Shrimp", ()=>(0, _shrimpJsDefault.default));
parcelHelpers.export(exports, "ShrimpIcon", ()=>(0, _shrimpJsDefault.default));
parcelHelpers.export(exports, "LucideShredder", ()=>(0, _shredderJsDefault.default));
parcelHelpers.export(exports, "Shredder", ()=>(0, _shredderJsDefault.default));
parcelHelpers.export(exports, "ShredderIcon", ()=>(0, _shredderJsDefault.default));
parcelHelpers.export(exports, "LucideShrink", ()=>(0, _shrinkJsDefault.default));
parcelHelpers.export(exports, "Shrink", ()=>(0, _shrinkJsDefault.default));
parcelHelpers.export(exports, "ShrinkIcon", ()=>(0, _shrinkJsDefault.default));
parcelHelpers.export(exports, "LucideShrub", ()=>(0, _shrubJsDefault.default));
parcelHelpers.export(exports, "Shrub", ()=>(0, _shrubJsDefault.default));
parcelHelpers.export(exports, "ShrubIcon", ()=>(0, _shrubJsDefault.default));
parcelHelpers.export(exports, "LucideShuffle", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "Shuffle", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "ShuffleIcon", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "LucideSigma", ()=>(0, _sigmaJsDefault.default));
parcelHelpers.export(exports, "Sigma", ()=>(0, _sigmaJsDefault.default));
parcelHelpers.export(exports, "SigmaIcon", ()=>(0, _sigmaJsDefault.default));
parcelHelpers.export(exports, "LucideSignalHigh", ()=>(0, _signalHighJsDefault.default));
parcelHelpers.export(exports, "SignalHigh", ()=>(0, _signalHighJsDefault.default));
parcelHelpers.export(exports, "SignalHighIcon", ()=>(0, _signalHighJsDefault.default));
parcelHelpers.export(exports, "LucideSignalLow", ()=>(0, _signalLowJsDefault.default));
parcelHelpers.export(exports, "SignalLow", ()=>(0, _signalLowJsDefault.default));
parcelHelpers.export(exports, "SignalLowIcon", ()=>(0, _signalLowJsDefault.default));
parcelHelpers.export(exports, "LucideSignalMedium", ()=>(0, _signalMediumJsDefault.default));
parcelHelpers.export(exports, "SignalMedium", ()=>(0, _signalMediumJsDefault.default));
parcelHelpers.export(exports, "SignalMediumIcon", ()=>(0, _signalMediumJsDefault.default));
parcelHelpers.export(exports, "LucideSignalZero", ()=>(0, _signalZeroJsDefault.default));
parcelHelpers.export(exports, "SignalZero", ()=>(0, _signalZeroJsDefault.default));
parcelHelpers.export(exports, "SignalZeroIcon", ()=>(0, _signalZeroJsDefault.default));
parcelHelpers.export(exports, "LucideSignal", ()=>(0, _signalJsDefault.default));
parcelHelpers.export(exports, "Signal", ()=>(0, _signalJsDefault.default));
parcelHelpers.export(exports, "SignalIcon", ()=>(0, _signalJsDefault.default));
parcelHelpers.export(exports, "LucideSignature", ()=>(0, _signatureJsDefault.default));
parcelHelpers.export(exports, "Signature", ()=>(0, _signatureJsDefault.default));
parcelHelpers.export(exports, "SignatureIcon", ()=>(0, _signatureJsDefault.default));
parcelHelpers.export(exports, "LucideSignpostBig", ()=>(0, _signpostBigJsDefault.default));
parcelHelpers.export(exports, "SignpostBig", ()=>(0, _signpostBigJsDefault.default));
parcelHelpers.export(exports, "SignpostBigIcon", ()=>(0, _signpostBigJsDefault.default));
parcelHelpers.export(exports, "LucideSignpost", ()=>(0, _signpostJsDefault.default));
parcelHelpers.export(exports, "Signpost", ()=>(0, _signpostJsDefault.default));
parcelHelpers.export(exports, "SignpostIcon", ()=>(0, _signpostJsDefault.default));
parcelHelpers.export(exports, "LucideSkipBack", ()=>(0, _skipBackJsDefault.default));
parcelHelpers.export(exports, "SkipBack", ()=>(0, _skipBackJsDefault.default));
parcelHelpers.export(exports, "SkipBackIcon", ()=>(0, _skipBackJsDefault.default));
parcelHelpers.export(exports, "LucideSiren", ()=>(0, _sirenJsDefault.default));
parcelHelpers.export(exports, "Siren", ()=>(0, _sirenJsDefault.default));
parcelHelpers.export(exports, "SirenIcon", ()=>(0, _sirenJsDefault.default));
parcelHelpers.export(exports, "LucideSkipForward", ()=>(0, _skipForwardJsDefault.default));
parcelHelpers.export(exports, "SkipForward", ()=>(0, _skipForwardJsDefault.default));
parcelHelpers.export(exports, "SkipForwardIcon", ()=>(0, _skipForwardJsDefault.default));
parcelHelpers.export(exports, "LucideSkull", ()=>(0, _skullJsDefault.default));
parcelHelpers.export(exports, "Skull", ()=>(0, _skullJsDefault.default));
parcelHelpers.export(exports, "SkullIcon", ()=>(0, _skullJsDefault.default));
parcelHelpers.export(exports, "LucideSlack", ()=>(0, _slackJsDefault.default));
parcelHelpers.export(exports, "Slack", ()=>(0, _slackJsDefault.default));
parcelHelpers.export(exports, "SlackIcon", ()=>(0, _slackJsDefault.default));
parcelHelpers.export(exports, "LucideSlash", ()=>(0, _slashJsDefault.default));
parcelHelpers.export(exports, "Slash", ()=>(0, _slashJsDefault.default));
parcelHelpers.export(exports, "SlashIcon", ()=>(0, _slashJsDefault.default));
parcelHelpers.export(exports, "LucideSlice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "Slice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "SliceIcon", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "LucideSlidersHorizontal", ()=>(0, _slidersHorizontalJsDefault.default));
parcelHelpers.export(exports, "SlidersHorizontal", ()=>(0, _slidersHorizontalJsDefault.default));
parcelHelpers.export(exports, "SlidersHorizontalIcon", ()=>(0, _slidersHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideSmartphoneCharging", ()=>(0, _smartphoneChargingJsDefault.default));
parcelHelpers.export(exports, "SmartphoneCharging", ()=>(0, _smartphoneChargingJsDefault.default));
parcelHelpers.export(exports, "SmartphoneChargingIcon", ()=>(0, _smartphoneChargingJsDefault.default));
parcelHelpers.export(exports, "LucideSmartphoneNfc", ()=>(0, _smartphoneNfcJsDefault.default));
parcelHelpers.export(exports, "SmartphoneNfc", ()=>(0, _smartphoneNfcJsDefault.default));
parcelHelpers.export(exports, "SmartphoneNfcIcon", ()=>(0, _smartphoneNfcJsDefault.default));
parcelHelpers.export(exports, "LucideSmartphone", ()=>(0, _smartphoneJsDefault.default));
parcelHelpers.export(exports, "Smartphone", ()=>(0, _smartphoneJsDefault.default));
parcelHelpers.export(exports, "SmartphoneIcon", ()=>(0, _smartphoneJsDefault.default));
parcelHelpers.export(exports, "LucideSnail", ()=>(0, _snailJsDefault.default));
parcelHelpers.export(exports, "Snail", ()=>(0, _snailJsDefault.default));
parcelHelpers.export(exports, "SnailIcon", ()=>(0, _snailJsDefault.default));
parcelHelpers.export(exports, "LucideSmile", ()=>(0, _smileJsDefault.default));
parcelHelpers.export(exports, "Smile", ()=>(0, _smileJsDefault.default));
parcelHelpers.export(exports, "SmileIcon", ()=>(0, _smileJsDefault.default));
parcelHelpers.export(exports, "LucideSmilePlus", ()=>(0, _smilePlusJsDefault.default));
parcelHelpers.export(exports, "SmilePlus", ()=>(0, _smilePlusJsDefault.default));
parcelHelpers.export(exports, "SmilePlusIcon", ()=>(0, _smilePlusJsDefault.default));
parcelHelpers.export(exports, "LucideSnowflake", ()=>(0, _snowflakeJsDefault.default));
parcelHelpers.export(exports, "Snowflake", ()=>(0, _snowflakeJsDefault.default));
parcelHelpers.export(exports, "SnowflakeIcon", ()=>(0, _snowflakeJsDefault.default));
parcelHelpers.export(exports, "LucideSoapDispenserDroplet", ()=>(0, _soapDispenserDropletJsDefault.default));
parcelHelpers.export(exports, "SoapDispenserDroplet", ()=>(0, _soapDispenserDropletJsDefault.default));
parcelHelpers.export(exports, "SoapDispenserDropletIcon", ()=>(0, _soapDispenserDropletJsDefault.default));
parcelHelpers.export(exports, "LucideSoup", ()=>(0, _soupJsDefault.default));
parcelHelpers.export(exports, "Soup", ()=>(0, _soupJsDefault.default));
parcelHelpers.export(exports, "SoupIcon", ()=>(0, _soupJsDefault.default));
parcelHelpers.export(exports, "LucideSofa", ()=>(0, _sofaJsDefault.default));
parcelHelpers.export(exports, "Sofa", ()=>(0, _sofaJsDefault.default));
parcelHelpers.export(exports, "SofaIcon", ()=>(0, _sofaJsDefault.default));
parcelHelpers.export(exports, "LucideSpace", ()=>(0, _spaceJsDefault.default));
parcelHelpers.export(exports, "Space", ()=>(0, _spaceJsDefault.default));
parcelHelpers.export(exports, "SpaceIcon", ()=>(0, _spaceJsDefault.default));
parcelHelpers.export(exports, "LucideSparkle", ()=>(0, _sparkleJsDefault.default));
parcelHelpers.export(exports, "Sparkle", ()=>(0, _sparkleJsDefault.default));
parcelHelpers.export(exports, "SparkleIcon", ()=>(0, _sparkleJsDefault.default));
parcelHelpers.export(exports, "LucideSpade", ()=>(0, _spadeJsDefault.default));
parcelHelpers.export(exports, "Spade", ()=>(0, _spadeJsDefault.default));
parcelHelpers.export(exports, "SpadeIcon", ()=>(0, _spadeJsDefault.default));
parcelHelpers.export(exports, "LucideSpeaker", ()=>(0, _speakerJsDefault.default));
parcelHelpers.export(exports, "Speaker", ()=>(0, _speakerJsDefault.default));
parcelHelpers.export(exports, "SpeakerIcon", ()=>(0, _speakerJsDefault.default));
parcelHelpers.export(exports, "LucideSpeech", ()=>(0, _speechJsDefault.default));
parcelHelpers.export(exports, "Speech", ()=>(0, _speechJsDefault.default));
parcelHelpers.export(exports, "SpeechIcon", ()=>(0, _speechJsDefault.default));
parcelHelpers.export(exports, "LucideSpellCheck2", ()=>(0, _spellCheck2JsDefault.default));
parcelHelpers.export(exports, "SpellCheck2", ()=>(0, _spellCheck2JsDefault.default));
parcelHelpers.export(exports, "SpellCheck2Icon", ()=>(0, _spellCheck2JsDefault.default));
parcelHelpers.export(exports, "LucideSpellCheck", ()=>(0, _spellCheckJsDefault.default));
parcelHelpers.export(exports, "SpellCheck", ()=>(0, _spellCheckJsDefault.default));
parcelHelpers.export(exports, "SpellCheckIcon", ()=>(0, _spellCheckJsDefault.default));
parcelHelpers.export(exports, "LucideSplinePointer", ()=>(0, _splinePointerJsDefault.default));
parcelHelpers.export(exports, "SplinePointer", ()=>(0, _splinePointerJsDefault.default));
parcelHelpers.export(exports, "SplinePointerIcon", ()=>(0, _splinePointerJsDefault.default));
parcelHelpers.export(exports, "LucideSpline", ()=>(0, _splineJsDefault.default));
parcelHelpers.export(exports, "Spline", ()=>(0, _splineJsDefault.default));
parcelHelpers.export(exports, "SplineIcon", ()=>(0, _splineJsDefault.default));
parcelHelpers.export(exports, "LucideSplit", ()=>(0, _splitJsDefault.default));
parcelHelpers.export(exports, "Split", ()=>(0, _splitJsDefault.default));
parcelHelpers.export(exports, "SplitIcon", ()=>(0, _splitJsDefault.default));
parcelHelpers.export(exports, "LucideSprayCan", ()=>(0, _sprayCanJsDefault.default));
parcelHelpers.export(exports, "SprayCan", ()=>(0, _sprayCanJsDefault.default));
parcelHelpers.export(exports, "SprayCanIcon", ()=>(0, _sprayCanJsDefault.default));
parcelHelpers.export(exports, "LucideSprout", ()=>(0, _sproutJsDefault.default));
parcelHelpers.export(exports, "Sprout", ()=>(0, _sproutJsDefault.default));
parcelHelpers.export(exports, "SproutIcon", ()=>(0, _sproutJsDefault.default));
parcelHelpers.export(exports, "LucideSquareDashedBottomCode", ()=>(0, _squareDashedBottomCodeJsDefault.default));
parcelHelpers.export(exports, "SquareDashedBottomCode", ()=>(0, _squareDashedBottomCodeJsDefault.default));
parcelHelpers.export(exports, "SquareDashedBottomCodeIcon", ()=>(0, _squareDashedBottomCodeJsDefault.default));
parcelHelpers.export(exports, "LucideSquareDashedBottom", ()=>(0, _squareDashedBottomJsDefault.default));
parcelHelpers.export(exports, "SquareDashedBottom", ()=>(0, _squareDashedBottomJsDefault.default));
parcelHelpers.export(exports, "SquareDashedBottomIcon", ()=>(0, _squareDashedBottomJsDefault.default));
parcelHelpers.export(exports, "LucideSquareDashedTopSolid", ()=>(0, _squareDashedTopSolidJsDefault.default));
parcelHelpers.export(exports, "SquareDashedTopSolid", ()=>(0, _squareDashedTopSolidJsDefault.default));
parcelHelpers.export(exports, "SquareDashedTopSolidIcon", ()=>(0, _squareDashedTopSolidJsDefault.default));
parcelHelpers.export(exports, "LucideSquareRadical", ()=>(0, _squareRadicalJsDefault.default));
parcelHelpers.export(exports, "SquareRadical", ()=>(0, _squareRadicalJsDefault.default));
parcelHelpers.export(exports, "SquareRadicalIcon", ()=>(0, _squareRadicalJsDefault.default));
parcelHelpers.export(exports, "LucideSquareRoundCorner", ()=>(0, _squareRoundCornerJsDefault.default));
parcelHelpers.export(exports, "SquareRoundCorner", ()=>(0, _squareRoundCornerJsDefault.default));
parcelHelpers.export(exports, "SquareRoundCornerIcon", ()=>(0, _squareRoundCornerJsDefault.default));
parcelHelpers.export(exports, "LucideSquareSquare", ()=>(0, _squareSquareJsDefault.default));
parcelHelpers.export(exports, "SquareSquare", ()=>(0, _squareSquareJsDefault.default));
parcelHelpers.export(exports, "SquareSquareIcon", ()=>(0, _squareSquareJsDefault.default));
parcelHelpers.export(exports, "LucideSquareStack", ()=>(0, _squareStackJsDefault.default));
parcelHelpers.export(exports, "SquareStack", ()=>(0, _squareStackJsDefault.default));
parcelHelpers.export(exports, "SquareStackIcon", ()=>(0, _squareStackJsDefault.default));
parcelHelpers.export(exports, "LucideSquare", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "Square", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "SquareIcon", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "LucideSquaresExclude", ()=>(0, _squaresExcludeJsDefault.default));
parcelHelpers.export(exports, "SquaresExclude", ()=>(0, _squaresExcludeJsDefault.default));
parcelHelpers.export(exports, "SquaresExcludeIcon", ()=>(0, _squaresExcludeJsDefault.default));
parcelHelpers.export(exports, "LucideSquaresIntersect", ()=>(0, _squaresIntersectJsDefault.default));
parcelHelpers.export(exports, "SquaresIntersect", ()=>(0, _squaresIntersectJsDefault.default));
parcelHelpers.export(exports, "SquaresIntersectIcon", ()=>(0, _squaresIntersectJsDefault.default));
parcelHelpers.export(exports, "LucideSquaresSubtract", ()=>(0, _squaresSubtractJsDefault.default));
parcelHelpers.export(exports, "SquaresSubtract", ()=>(0, _squaresSubtractJsDefault.default));
parcelHelpers.export(exports, "SquaresSubtractIcon", ()=>(0, _squaresSubtractJsDefault.default));
parcelHelpers.export(exports, "LucideSquaresUnite", ()=>(0, _squaresUniteJsDefault.default));
parcelHelpers.export(exports, "SquaresUnite", ()=>(0, _squaresUniteJsDefault.default));
parcelHelpers.export(exports, "SquaresUniteIcon", ()=>(0, _squaresUniteJsDefault.default));
parcelHelpers.export(exports, "LucideSquircle", ()=>(0, _squircleJsDefault.default));
parcelHelpers.export(exports, "Squircle", ()=>(0, _squircleJsDefault.default));
parcelHelpers.export(exports, "SquircleIcon", ()=>(0, _squircleJsDefault.default));
parcelHelpers.export(exports, "LucideSquirrel", ()=>(0, _squirrelJsDefault.default));
parcelHelpers.export(exports, "Squirrel", ()=>(0, _squirrelJsDefault.default));
parcelHelpers.export(exports, "SquirrelIcon", ()=>(0, _squirrelJsDefault.default));
parcelHelpers.export(exports, "LucideStamp", ()=>(0, _stampJsDefault.default));
parcelHelpers.export(exports, "Stamp", ()=>(0, _stampJsDefault.default));
parcelHelpers.export(exports, "StampIcon", ()=>(0, _stampJsDefault.default));
parcelHelpers.export(exports, "LucideStarOff", ()=>(0, _starOffJsDefault.default));
parcelHelpers.export(exports, "StarOff", ()=>(0, _starOffJsDefault.default));
parcelHelpers.export(exports, "StarOffIcon", ()=>(0, _starOffJsDefault.default));
parcelHelpers.export(exports, "LucideStarHalf", ()=>(0, _starHalfJsDefault.default));
parcelHelpers.export(exports, "StarHalf", ()=>(0, _starHalfJsDefault.default));
parcelHelpers.export(exports, "StarHalfIcon", ()=>(0, _starHalfJsDefault.default));
parcelHelpers.export(exports, "LucideStar", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "Star", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "StarIcon", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "LucideStepForward", ()=>(0, _stepForwardJsDefault.default));
parcelHelpers.export(exports, "StepForward", ()=>(0, _stepForwardJsDefault.default));
parcelHelpers.export(exports, "StepForwardIcon", ()=>(0, _stepForwardJsDefault.default));
parcelHelpers.export(exports, "LucideStepBack", ()=>(0, _stepBackJsDefault.default));
parcelHelpers.export(exports, "StepBack", ()=>(0, _stepBackJsDefault.default));
parcelHelpers.export(exports, "StepBackIcon", ()=>(0, _stepBackJsDefault.default));
parcelHelpers.export(exports, "LucideSticker", ()=>(0, _stickerJsDefault.default));
parcelHelpers.export(exports, "Sticker", ()=>(0, _stickerJsDefault.default));
parcelHelpers.export(exports, "StickerIcon", ()=>(0, _stickerJsDefault.default));
parcelHelpers.export(exports, "LucideStethoscope", ()=>(0, _stethoscopeJsDefault.default));
parcelHelpers.export(exports, "Stethoscope", ()=>(0, _stethoscopeJsDefault.default));
parcelHelpers.export(exports, "StethoscopeIcon", ()=>(0, _stethoscopeJsDefault.default));
parcelHelpers.export(exports, "LucideStore", ()=>(0, _storeJsDefault.default));
parcelHelpers.export(exports, "Store", ()=>(0, _storeJsDefault.default));
parcelHelpers.export(exports, "StoreIcon", ()=>(0, _storeJsDefault.default));
parcelHelpers.export(exports, "LucideStickyNote", ()=>(0, _stickyNoteJsDefault.default));
parcelHelpers.export(exports, "StickyNote", ()=>(0, _stickyNoteJsDefault.default));
parcelHelpers.export(exports, "StickyNoteIcon", ()=>(0, _stickyNoteJsDefault.default));
parcelHelpers.export(exports, "LucideStretchHorizontal", ()=>(0, _stretchHorizontalJsDefault.default));
parcelHelpers.export(exports, "StretchHorizontal", ()=>(0, _stretchHorizontalJsDefault.default));
parcelHelpers.export(exports, "StretchHorizontalIcon", ()=>(0, _stretchHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideStretchVertical", ()=>(0, _stretchVerticalJsDefault.default));
parcelHelpers.export(exports, "StretchVertical", ()=>(0, _stretchVerticalJsDefault.default));
parcelHelpers.export(exports, "StretchVerticalIcon", ()=>(0, _stretchVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideStrikethrough", ()=>(0, _strikethroughJsDefault.default));
parcelHelpers.export(exports, "Strikethrough", ()=>(0, _strikethroughJsDefault.default));
parcelHelpers.export(exports, "StrikethroughIcon", ()=>(0, _strikethroughJsDefault.default));
parcelHelpers.export(exports, "LucideSubscript", ()=>(0, _subscriptJsDefault.default));
parcelHelpers.export(exports, "Subscript", ()=>(0, _subscriptJsDefault.default));
parcelHelpers.export(exports, "SubscriptIcon", ()=>(0, _subscriptJsDefault.default));
parcelHelpers.export(exports, "LucideSunDim", ()=>(0, _sunDimJsDefault.default));
parcelHelpers.export(exports, "SunDim", ()=>(0, _sunDimJsDefault.default));
parcelHelpers.export(exports, "SunDimIcon", ()=>(0, _sunDimJsDefault.default));
parcelHelpers.export(exports, "LucideSunMedium", ()=>(0, _sunMediumJsDefault.default));
parcelHelpers.export(exports, "SunMedium", ()=>(0, _sunMediumJsDefault.default));
parcelHelpers.export(exports, "SunMediumIcon", ()=>(0, _sunMediumJsDefault.default));
parcelHelpers.export(exports, "LucideSunSnow", ()=>(0, _sunSnowJsDefault.default));
parcelHelpers.export(exports, "SunSnow", ()=>(0, _sunSnowJsDefault.default));
parcelHelpers.export(exports, "SunSnowIcon", ()=>(0, _sunSnowJsDefault.default));
parcelHelpers.export(exports, "LucideSunMoon", ()=>(0, _sunMoonJsDefault.default));
parcelHelpers.export(exports, "SunMoon", ()=>(0, _sunMoonJsDefault.default));
parcelHelpers.export(exports, "SunMoonIcon", ()=>(0, _sunMoonJsDefault.default));
parcelHelpers.export(exports, "LucideSun", ()=>(0, _sunJsDefault.default));
parcelHelpers.export(exports, "Sun", ()=>(0, _sunJsDefault.default));
parcelHelpers.export(exports, "SunIcon", ()=>(0, _sunJsDefault.default));
parcelHelpers.export(exports, "LucideSunset", ()=>(0, _sunsetJsDefault.default));
parcelHelpers.export(exports, "Sunset", ()=>(0, _sunsetJsDefault.default));
parcelHelpers.export(exports, "SunsetIcon", ()=>(0, _sunsetJsDefault.default));
parcelHelpers.export(exports, "LucideSunrise", ()=>(0, _sunriseJsDefault.default));
parcelHelpers.export(exports, "Sunrise", ()=>(0, _sunriseJsDefault.default));
parcelHelpers.export(exports, "SunriseIcon", ()=>(0, _sunriseJsDefault.default));
parcelHelpers.export(exports, "LucideSuperscript", ()=>(0, _superscriptJsDefault.default));
parcelHelpers.export(exports, "Superscript", ()=>(0, _superscriptJsDefault.default));
parcelHelpers.export(exports, "SuperscriptIcon", ()=>(0, _superscriptJsDefault.default));
parcelHelpers.export(exports, "LucideSwatchBook", ()=>(0, _swatchBookJsDefault.default));
parcelHelpers.export(exports, "SwatchBook", ()=>(0, _swatchBookJsDefault.default));
parcelHelpers.export(exports, "SwatchBookIcon", ()=>(0, _swatchBookJsDefault.default));
parcelHelpers.export(exports, "LucideSwissFranc", ()=>(0, _swissFrancJsDefault.default));
parcelHelpers.export(exports, "SwissFranc", ()=>(0, _swissFrancJsDefault.default));
parcelHelpers.export(exports, "SwissFrancIcon", ()=>(0, _swissFrancJsDefault.default));
parcelHelpers.export(exports, "LucideSwitchCamera", ()=>(0, _switchCameraJsDefault.default));
parcelHelpers.export(exports, "SwitchCamera", ()=>(0, _switchCameraJsDefault.default));
parcelHelpers.export(exports, "SwitchCameraIcon", ()=>(0, _switchCameraJsDefault.default));
parcelHelpers.export(exports, "LucideSwords", ()=>(0, _swordsJsDefault.default));
parcelHelpers.export(exports, "Swords", ()=>(0, _swordsJsDefault.default));
parcelHelpers.export(exports, "SwordsIcon", ()=>(0, _swordsJsDefault.default));
parcelHelpers.export(exports, "LucideSword", ()=>(0, _swordJsDefault.default));
parcelHelpers.export(exports, "Sword", ()=>(0, _swordJsDefault.default));
parcelHelpers.export(exports, "SwordIcon", ()=>(0, _swordJsDefault.default));
parcelHelpers.export(exports, "LucideSyringe", ()=>(0, _syringeJsDefault.default));
parcelHelpers.export(exports, "Syringe", ()=>(0, _syringeJsDefault.default));
parcelHelpers.export(exports, "SyringeIcon", ()=>(0, _syringeJsDefault.default));
parcelHelpers.export(exports, "LucideTable2", ()=>(0, _table2JsDefault.default));
parcelHelpers.export(exports, "Table2", ()=>(0, _table2JsDefault.default));
parcelHelpers.export(exports, "Table2Icon", ()=>(0, _table2JsDefault.default));
parcelHelpers.export(exports, "LucideTableCellsMerge", ()=>(0, _tableCellsMergeJsDefault.default));
parcelHelpers.export(exports, "TableCellsMerge", ()=>(0, _tableCellsMergeJsDefault.default));
parcelHelpers.export(exports, "TableCellsMergeIcon", ()=>(0, _tableCellsMergeJsDefault.default));
parcelHelpers.export(exports, "LucideTableCellsSplit", ()=>(0, _tableCellsSplitJsDefault.default));
parcelHelpers.export(exports, "TableCellsSplit", ()=>(0, _tableCellsSplitJsDefault.default));
parcelHelpers.export(exports, "TableCellsSplitIcon", ()=>(0, _tableCellsSplitJsDefault.default));
parcelHelpers.export(exports, "LucideTableColumnsSplit", ()=>(0, _tableColumnsSplitJsDefault.default));
parcelHelpers.export(exports, "TableColumnsSplit", ()=>(0, _tableColumnsSplitJsDefault.default));
parcelHelpers.export(exports, "TableColumnsSplitIcon", ()=>(0, _tableColumnsSplitJsDefault.default));
parcelHelpers.export(exports, "LucideTableOfContents", ()=>(0, _tableOfContentsJsDefault.default));
parcelHelpers.export(exports, "TableOfContents", ()=>(0, _tableOfContentsJsDefault.default));
parcelHelpers.export(exports, "TableOfContentsIcon", ()=>(0, _tableOfContentsJsDefault.default));
parcelHelpers.export(exports, "LucideTableProperties", ()=>(0, _tablePropertiesJsDefault.default));
parcelHelpers.export(exports, "TableProperties", ()=>(0, _tablePropertiesJsDefault.default));
parcelHelpers.export(exports, "TablePropertiesIcon", ()=>(0, _tablePropertiesJsDefault.default));
parcelHelpers.export(exports, "LucideTable", ()=>(0, _tableJsDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableJsDefault.default));
parcelHelpers.export(exports, "TableIcon", ()=>(0, _tableJsDefault.default));
parcelHelpers.export(exports, "LucideTableRowsSplit", ()=>(0, _tableRowsSplitJsDefault.default));
parcelHelpers.export(exports, "TableRowsSplit", ()=>(0, _tableRowsSplitJsDefault.default));
parcelHelpers.export(exports, "TableRowsSplitIcon", ()=>(0, _tableRowsSplitJsDefault.default));
parcelHelpers.export(exports, "LucideTablet", ()=>(0, _tabletJsDefault.default));
parcelHelpers.export(exports, "Tablet", ()=>(0, _tabletJsDefault.default));
parcelHelpers.export(exports, "TabletIcon", ()=>(0, _tabletJsDefault.default));
parcelHelpers.export(exports, "LucideTablets", ()=>(0, _tabletsJsDefault.default));
parcelHelpers.export(exports, "Tablets", ()=>(0, _tabletsJsDefault.default));
parcelHelpers.export(exports, "TabletsIcon", ()=>(0, _tabletsJsDefault.default));
parcelHelpers.export(exports, "LucideTabletSmartphone", ()=>(0, _tabletSmartphoneJsDefault.default));
parcelHelpers.export(exports, "TabletSmartphone", ()=>(0, _tabletSmartphoneJsDefault.default));
parcelHelpers.export(exports, "TabletSmartphoneIcon", ()=>(0, _tabletSmartphoneJsDefault.default));
parcelHelpers.export(exports, "LucideTally1", ()=>(0, _tally1JsDefault.default));
parcelHelpers.export(exports, "Tally1", ()=>(0, _tally1JsDefault.default));
parcelHelpers.export(exports, "Tally1Icon", ()=>(0, _tally1JsDefault.default));
parcelHelpers.export(exports, "LucideTag", ()=>(0, _tagJsDefault.default));
parcelHelpers.export(exports, "Tag", ()=>(0, _tagJsDefault.default));
parcelHelpers.export(exports, "TagIcon", ()=>(0, _tagJsDefault.default));
parcelHelpers.export(exports, "LucideTags", ()=>(0, _tagsJsDefault.default));
parcelHelpers.export(exports, "Tags", ()=>(0, _tagsJsDefault.default));
parcelHelpers.export(exports, "TagsIcon", ()=>(0, _tagsJsDefault.default));
parcelHelpers.export(exports, "LucideTally2", ()=>(0, _tally2JsDefault.default));
parcelHelpers.export(exports, "Tally2", ()=>(0, _tally2JsDefault.default));
parcelHelpers.export(exports, "Tally2Icon", ()=>(0, _tally2JsDefault.default));
parcelHelpers.export(exports, "LucideTally3", ()=>(0, _tally3JsDefault.default));
parcelHelpers.export(exports, "Tally3", ()=>(0, _tally3JsDefault.default));
parcelHelpers.export(exports, "Tally3Icon", ()=>(0, _tally3JsDefault.default));
parcelHelpers.export(exports, "LucideTally4", ()=>(0, _tally4JsDefault.default));
parcelHelpers.export(exports, "Tally4", ()=>(0, _tally4JsDefault.default));
parcelHelpers.export(exports, "Tally4Icon", ()=>(0, _tally4JsDefault.default));
parcelHelpers.export(exports, "LucideTangent", ()=>(0, _tangentJsDefault.default));
parcelHelpers.export(exports, "Tangent", ()=>(0, _tangentJsDefault.default));
parcelHelpers.export(exports, "TangentIcon", ()=>(0, _tangentJsDefault.default));
parcelHelpers.export(exports, "LucideTally5", ()=>(0, _tally5JsDefault.default));
parcelHelpers.export(exports, "Tally5", ()=>(0, _tally5JsDefault.default));
parcelHelpers.export(exports, "Tally5Icon", ()=>(0, _tally5JsDefault.default));
parcelHelpers.export(exports, "LucideTelescope", ()=>(0, _telescopeJsDefault.default));
parcelHelpers.export(exports, "Telescope", ()=>(0, _telescopeJsDefault.default));
parcelHelpers.export(exports, "TelescopeIcon", ()=>(0, _telescopeJsDefault.default));
parcelHelpers.export(exports, "LucideTentTree", ()=>(0, _tentTreeJsDefault.default));
parcelHelpers.export(exports, "TentTree", ()=>(0, _tentTreeJsDefault.default));
parcelHelpers.export(exports, "TentTreeIcon", ()=>(0, _tentTreeJsDefault.default));
parcelHelpers.export(exports, "LucideTarget", ()=>(0, _targetJsDefault.default));
parcelHelpers.export(exports, "Target", ()=>(0, _targetJsDefault.default));
parcelHelpers.export(exports, "TargetIcon", ()=>(0, _targetJsDefault.default));
parcelHelpers.export(exports, "LucideTent", ()=>(0, _tentJsDefault.default));
parcelHelpers.export(exports, "Tent", ()=>(0, _tentJsDefault.default));
parcelHelpers.export(exports, "TentIcon", ()=>(0, _tentJsDefault.default));
parcelHelpers.export(exports, "LucideTerminal", ()=>(0, _terminalJsDefault.default));
parcelHelpers.export(exports, "Terminal", ()=>(0, _terminalJsDefault.default));
parcelHelpers.export(exports, "TerminalIcon", ()=>(0, _terminalJsDefault.default));
parcelHelpers.export(exports, "LucideTestTube", ()=>(0, _testTubeJsDefault.default));
parcelHelpers.export(exports, "TestTube", ()=>(0, _testTubeJsDefault.default));
parcelHelpers.export(exports, "TestTubeIcon", ()=>(0, _testTubeJsDefault.default));
parcelHelpers.export(exports, "LucideTestTubes", ()=>(0, _testTubesJsDefault.default));
parcelHelpers.export(exports, "TestTubes", ()=>(0, _testTubesJsDefault.default));
parcelHelpers.export(exports, "TestTubesIcon", ()=>(0, _testTubesJsDefault.default));
parcelHelpers.export(exports, "LucideTextCursorInput", ()=>(0, _textCursorInputJsDefault.default));
parcelHelpers.export(exports, "TextCursorInput", ()=>(0, _textCursorInputJsDefault.default));
parcelHelpers.export(exports, "TextCursorInputIcon", ()=>(0, _textCursorInputJsDefault.default));
parcelHelpers.export(exports, "LucideTextCursor", ()=>(0, _textCursorJsDefault.default));
parcelHelpers.export(exports, "TextCursor", ()=>(0, _textCursorJsDefault.default));
parcelHelpers.export(exports, "TextCursorIcon", ()=>(0, _textCursorJsDefault.default));
parcelHelpers.export(exports, "LucideTextSearch", ()=>(0, _textSearchJsDefault.default));
parcelHelpers.export(exports, "TextSearch", ()=>(0, _textSearchJsDefault.default));
parcelHelpers.export(exports, "TextSearchIcon", ()=>(0, _textSearchJsDefault.default));
parcelHelpers.export(exports, "LucideTextQuote", ()=>(0, _textQuoteJsDefault.default));
parcelHelpers.export(exports, "TextQuote", ()=>(0, _textQuoteJsDefault.default));
parcelHelpers.export(exports, "TextQuoteIcon", ()=>(0, _textQuoteJsDefault.default));
parcelHelpers.export(exports, "LucideText", ()=>(0, _textJsDefault.default));
parcelHelpers.export(exports, "Text", ()=>(0, _textJsDefault.default));
parcelHelpers.export(exports, "TextIcon", ()=>(0, _textJsDefault.default));
parcelHelpers.export(exports, "LucideTheater", ()=>(0, _theaterJsDefault.default));
parcelHelpers.export(exports, "Theater", ()=>(0, _theaterJsDefault.default));
parcelHelpers.export(exports, "TheaterIcon", ()=>(0, _theaterJsDefault.default));
parcelHelpers.export(exports, "LucideThermometerSnowflake", ()=>(0, _thermometerSnowflakeJsDefault.default));
parcelHelpers.export(exports, "ThermometerSnowflake", ()=>(0, _thermometerSnowflakeJsDefault.default));
parcelHelpers.export(exports, "ThermometerSnowflakeIcon", ()=>(0, _thermometerSnowflakeJsDefault.default));
parcelHelpers.export(exports, "LucideThermometerSun", ()=>(0, _thermometerSunJsDefault.default));
parcelHelpers.export(exports, "ThermometerSun", ()=>(0, _thermometerSunJsDefault.default));
parcelHelpers.export(exports, "ThermometerSunIcon", ()=>(0, _thermometerSunJsDefault.default));
parcelHelpers.export(exports, "LucideThermometer", ()=>(0, _thermometerJsDefault.default));
parcelHelpers.export(exports, "Thermometer", ()=>(0, _thermometerJsDefault.default));
parcelHelpers.export(exports, "ThermometerIcon", ()=>(0, _thermometerJsDefault.default));
parcelHelpers.export(exports, "LucideThumbsUp", ()=>(0, _thumbsUpJsDefault.default));
parcelHelpers.export(exports, "ThumbsUp", ()=>(0, _thumbsUpJsDefault.default));
parcelHelpers.export(exports, "ThumbsUpIcon", ()=>(0, _thumbsUpJsDefault.default));
parcelHelpers.export(exports, "LucideTicketCheck", ()=>(0, _ticketCheckJsDefault.default));
parcelHelpers.export(exports, "TicketCheck", ()=>(0, _ticketCheckJsDefault.default));
parcelHelpers.export(exports, "TicketCheckIcon", ()=>(0, _ticketCheckJsDefault.default));
parcelHelpers.export(exports, "LucideThumbsDown", ()=>(0, _thumbsDownJsDefault.default));
parcelHelpers.export(exports, "ThumbsDown", ()=>(0, _thumbsDownJsDefault.default));
parcelHelpers.export(exports, "ThumbsDownIcon", ()=>(0, _thumbsDownJsDefault.default));
parcelHelpers.export(exports, "LucideTicketMinus", ()=>(0, _ticketMinusJsDefault.default));
parcelHelpers.export(exports, "TicketMinus", ()=>(0, _ticketMinusJsDefault.default));
parcelHelpers.export(exports, "TicketMinusIcon", ()=>(0, _ticketMinusJsDefault.default));
parcelHelpers.export(exports, "LucideTicketPercent", ()=>(0, _ticketPercentJsDefault.default));
parcelHelpers.export(exports, "TicketPercent", ()=>(0, _ticketPercentJsDefault.default));
parcelHelpers.export(exports, "TicketPercentIcon", ()=>(0, _ticketPercentJsDefault.default));
parcelHelpers.export(exports, "LucideTicketPlus", ()=>(0, _ticketPlusJsDefault.default));
parcelHelpers.export(exports, "TicketPlus", ()=>(0, _ticketPlusJsDefault.default));
parcelHelpers.export(exports, "TicketPlusIcon", ()=>(0, _ticketPlusJsDefault.default));
parcelHelpers.export(exports, "LucideTicketSlash", ()=>(0, _ticketSlashJsDefault.default));
parcelHelpers.export(exports, "TicketSlash", ()=>(0, _ticketSlashJsDefault.default));
parcelHelpers.export(exports, "TicketSlashIcon", ()=>(0, _ticketSlashJsDefault.default));
parcelHelpers.export(exports, "LucideTicketX", ()=>(0, _ticketXJsDefault.default));
parcelHelpers.export(exports, "TicketX", ()=>(0, _ticketXJsDefault.default));
parcelHelpers.export(exports, "TicketXIcon", ()=>(0, _ticketXJsDefault.default));
parcelHelpers.export(exports, "LucideTicket", ()=>(0, _ticketJsDefault.default));
parcelHelpers.export(exports, "Ticket", ()=>(0, _ticketJsDefault.default));
parcelHelpers.export(exports, "TicketIcon", ()=>(0, _ticketJsDefault.default));
parcelHelpers.export(exports, "LucideTicketsPlane", ()=>(0, _ticketsPlaneJsDefault.default));
parcelHelpers.export(exports, "TicketsPlane", ()=>(0, _ticketsPlaneJsDefault.default));
parcelHelpers.export(exports, "TicketsPlaneIcon", ()=>(0, _ticketsPlaneJsDefault.default));
parcelHelpers.export(exports, "LucideTickets", ()=>(0, _ticketsJsDefault.default));
parcelHelpers.export(exports, "Tickets", ()=>(0, _ticketsJsDefault.default));
parcelHelpers.export(exports, "TicketsIcon", ()=>(0, _ticketsJsDefault.default));
parcelHelpers.export(exports, "LucideTimerOff", ()=>(0, _timerOffJsDefault.default));
parcelHelpers.export(exports, "TimerOff", ()=>(0, _timerOffJsDefault.default));
parcelHelpers.export(exports, "TimerOffIcon", ()=>(0, _timerOffJsDefault.default));
parcelHelpers.export(exports, "LucideTimerReset", ()=>(0, _timerResetJsDefault.default));
parcelHelpers.export(exports, "TimerReset", ()=>(0, _timerResetJsDefault.default));
parcelHelpers.export(exports, "TimerResetIcon", ()=>(0, _timerResetJsDefault.default));
parcelHelpers.export(exports, "LucideTimer", ()=>(0, _timerJsDefault.default));
parcelHelpers.export(exports, "Timer", ()=>(0, _timerJsDefault.default));
parcelHelpers.export(exports, "TimerIcon", ()=>(0, _timerJsDefault.default));
parcelHelpers.export(exports, "LucideToggleLeft", ()=>(0, _toggleLeftJsDefault.default));
parcelHelpers.export(exports, "ToggleLeft", ()=>(0, _toggleLeftJsDefault.default));
parcelHelpers.export(exports, "ToggleLeftIcon", ()=>(0, _toggleLeftJsDefault.default));
parcelHelpers.export(exports, "LucideToggleRight", ()=>(0, _toggleRightJsDefault.default));
parcelHelpers.export(exports, "ToggleRight", ()=>(0, _toggleRightJsDefault.default));
parcelHelpers.export(exports, "ToggleRightIcon", ()=>(0, _toggleRightJsDefault.default));
parcelHelpers.export(exports, "LucideToilet", ()=>(0, _toiletJsDefault.default));
parcelHelpers.export(exports, "Toilet", ()=>(0, _toiletJsDefault.default));
parcelHelpers.export(exports, "ToiletIcon", ()=>(0, _toiletJsDefault.default));
parcelHelpers.export(exports, "LucideTornado", ()=>(0, _tornadoJsDefault.default));
parcelHelpers.export(exports, "Tornado", ()=>(0, _tornadoJsDefault.default));
parcelHelpers.export(exports, "TornadoIcon", ()=>(0, _tornadoJsDefault.default));
parcelHelpers.export(exports, "LucideTorus", ()=>(0, _torusJsDefault.default));
parcelHelpers.export(exports, "Torus", ()=>(0, _torusJsDefault.default));
parcelHelpers.export(exports, "TorusIcon", ()=>(0, _torusJsDefault.default));
parcelHelpers.export(exports, "LucideTouchpadOff", ()=>(0, _touchpadOffJsDefault.default));
parcelHelpers.export(exports, "TouchpadOff", ()=>(0, _touchpadOffJsDefault.default));
parcelHelpers.export(exports, "TouchpadOffIcon", ()=>(0, _touchpadOffJsDefault.default));
parcelHelpers.export(exports, "LucideTouchpad", ()=>(0, _touchpadJsDefault.default));
parcelHelpers.export(exports, "Touchpad", ()=>(0, _touchpadJsDefault.default));
parcelHelpers.export(exports, "TouchpadIcon", ()=>(0, _touchpadJsDefault.default));
parcelHelpers.export(exports, "LucideTowerControl", ()=>(0, _towerControlJsDefault.default));
parcelHelpers.export(exports, "TowerControl", ()=>(0, _towerControlJsDefault.default));
parcelHelpers.export(exports, "TowerControlIcon", ()=>(0, _towerControlJsDefault.default));
parcelHelpers.export(exports, "LucideToyBrick", ()=>(0, _toyBrickJsDefault.default));
parcelHelpers.export(exports, "ToyBrick", ()=>(0, _toyBrickJsDefault.default));
parcelHelpers.export(exports, "ToyBrickIcon", ()=>(0, _toyBrickJsDefault.default));
parcelHelpers.export(exports, "LucideTrafficCone", ()=>(0, _trafficConeJsDefault.default));
parcelHelpers.export(exports, "TrafficCone", ()=>(0, _trafficConeJsDefault.default));
parcelHelpers.export(exports, "TrafficConeIcon", ()=>(0, _trafficConeJsDefault.default));
parcelHelpers.export(exports, "LucideTractor", ()=>(0, _tractorJsDefault.default));
parcelHelpers.export(exports, "Tractor", ()=>(0, _tractorJsDefault.default));
parcelHelpers.export(exports, "TractorIcon", ()=>(0, _tractorJsDefault.default));
parcelHelpers.export(exports, "LucideTrainFront", ()=>(0, _trainFrontJsDefault.default));
parcelHelpers.export(exports, "TrainFront", ()=>(0, _trainFrontJsDefault.default));
parcelHelpers.export(exports, "TrainFrontIcon", ()=>(0, _trainFrontJsDefault.default));
parcelHelpers.export(exports, "LucideTrainFrontTunnel", ()=>(0, _trainFrontTunnelJsDefault.default));
parcelHelpers.export(exports, "TrainFrontTunnel", ()=>(0, _trainFrontTunnelJsDefault.default));
parcelHelpers.export(exports, "TrainFrontTunnelIcon", ()=>(0, _trainFrontTunnelJsDefault.default));
parcelHelpers.export(exports, "LucideTrainTrack", ()=>(0, _trainTrackJsDefault.default));
parcelHelpers.export(exports, "TrainTrack", ()=>(0, _trainTrackJsDefault.default));
parcelHelpers.export(exports, "TrainTrackIcon", ()=>(0, _trainTrackJsDefault.default));
parcelHelpers.export(exports, "LucideTrash2", ()=>(0, _trash2JsDefault.default));
parcelHelpers.export(exports, "Trash2", ()=>(0, _trash2JsDefault.default));
parcelHelpers.export(exports, "Trash2Icon", ()=>(0, _trash2JsDefault.default));
parcelHelpers.export(exports, "LucideTransgender", ()=>(0, _transgenderJsDefault.default));
parcelHelpers.export(exports, "Transgender", ()=>(0, _transgenderJsDefault.default));
parcelHelpers.export(exports, "TransgenderIcon", ()=>(0, _transgenderJsDefault.default));
parcelHelpers.export(exports, "LucideTrash", ()=>(0, _trashJsDefault.default));
parcelHelpers.export(exports, "Trash", ()=>(0, _trashJsDefault.default));
parcelHelpers.export(exports, "TrashIcon", ()=>(0, _trashJsDefault.default));
parcelHelpers.export(exports, "LucideTreeDeciduous", ()=>(0, _treeDeciduousJsDefault.default));
parcelHelpers.export(exports, "TreeDeciduous", ()=>(0, _treeDeciduousJsDefault.default));
parcelHelpers.export(exports, "TreeDeciduousIcon", ()=>(0, _treeDeciduousJsDefault.default));
parcelHelpers.export(exports, "LucideTreePine", ()=>(0, _treePineJsDefault.default));
parcelHelpers.export(exports, "TreePine", ()=>(0, _treePineJsDefault.default));
parcelHelpers.export(exports, "TreePineIcon", ()=>(0, _treePineJsDefault.default));
parcelHelpers.export(exports, "LucideTrees", ()=>(0, _treesJsDefault.default));
parcelHelpers.export(exports, "Trees", ()=>(0, _treesJsDefault.default));
parcelHelpers.export(exports, "TreesIcon", ()=>(0, _treesJsDefault.default));
parcelHelpers.export(exports, "LucideTrello", ()=>(0, _trelloJsDefault.default));
parcelHelpers.export(exports, "Trello", ()=>(0, _trelloJsDefault.default));
parcelHelpers.export(exports, "TrelloIcon", ()=>(0, _trelloJsDefault.default));
parcelHelpers.export(exports, "LucideTrendingDown", ()=>(0, _trendingDownJsDefault.default));
parcelHelpers.export(exports, "TrendingDown", ()=>(0, _trendingDownJsDefault.default));
parcelHelpers.export(exports, "TrendingDownIcon", ()=>(0, _trendingDownJsDefault.default));
parcelHelpers.export(exports, "LucideTrendingUpDown", ()=>(0, _trendingUpDownJsDefault.default));
parcelHelpers.export(exports, "TrendingUpDown", ()=>(0, _trendingUpDownJsDefault.default));
parcelHelpers.export(exports, "TrendingUpDownIcon", ()=>(0, _trendingUpDownJsDefault.default));
parcelHelpers.export(exports, "LucideTrendingUp", ()=>(0, _trendingUpJsDefault.default));
parcelHelpers.export(exports, "TrendingUp", ()=>(0, _trendingUpJsDefault.default));
parcelHelpers.export(exports, "TrendingUpIcon", ()=>(0, _trendingUpJsDefault.default));
parcelHelpers.export(exports, "LucideTriangleDashed", ()=>(0, _triangleDashedJsDefault.default));
parcelHelpers.export(exports, "TriangleDashed", ()=>(0, _triangleDashedJsDefault.default));
parcelHelpers.export(exports, "TriangleDashedIcon", ()=>(0, _triangleDashedJsDefault.default));
parcelHelpers.export(exports, "LucideTriangleRight", ()=>(0, _triangleRightJsDefault.default));
parcelHelpers.export(exports, "TriangleRight", ()=>(0, _triangleRightJsDefault.default));
parcelHelpers.export(exports, "TriangleRightIcon", ()=>(0, _triangleRightJsDefault.default));
parcelHelpers.export(exports, "LucideTriangle", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "Triangle", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "TriangleIcon", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "LucideTrophy", ()=>(0, _trophyJsDefault.default));
parcelHelpers.export(exports, "Trophy", ()=>(0, _trophyJsDefault.default));
parcelHelpers.export(exports, "TrophyIcon", ()=>(0, _trophyJsDefault.default));
parcelHelpers.export(exports, "LucideTruckElectric", ()=>(0, _truckElectricJsDefault.default));
parcelHelpers.export(exports, "TruckElectric", ()=>(0, _truckElectricJsDefault.default));
parcelHelpers.export(exports, "TruckElectricIcon", ()=>(0, _truckElectricJsDefault.default));
parcelHelpers.export(exports, "LucideTruck", ()=>(0, _truckJsDefault.default));
parcelHelpers.export(exports, "Truck", ()=>(0, _truckJsDefault.default));
parcelHelpers.export(exports, "TruckIcon", ()=>(0, _truckJsDefault.default));
parcelHelpers.export(exports, "LucideTurtle", ()=>(0, _turtleJsDefault.default));
parcelHelpers.export(exports, "Turtle", ()=>(0, _turtleJsDefault.default));
parcelHelpers.export(exports, "TurtleIcon", ()=>(0, _turtleJsDefault.default));
parcelHelpers.export(exports, "LucideTvMinimalPlay", ()=>(0, _tvMinimalPlayJsDefault.default));
parcelHelpers.export(exports, "TvMinimalPlay", ()=>(0, _tvMinimalPlayJsDefault.default));
parcelHelpers.export(exports, "TvMinimalPlayIcon", ()=>(0, _tvMinimalPlayJsDefault.default));
parcelHelpers.export(exports, "LucideTv", ()=>(0, _tvJsDefault.default));
parcelHelpers.export(exports, "Tv", ()=>(0, _tvJsDefault.default));
parcelHelpers.export(exports, "TvIcon", ()=>(0, _tvJsDefault.default));
parcelHelpers.export(exports, "LucideTwitch", ()=>(0, _twitchJsDefault.default));
parcelHelpers.export(exports, "Twitch", ()=>(0, _twitchJsDefault.default));
parcelHelpers.export(exports, "TwitchIcon", ()=>(0, _twitchJsDefault.default));
parcelHelpers.export(exports, "LucideTwitter", ()=>(0, _twitterJsDefault.default));
parcelHelpers.export(exports, "Twitter", ()=>(0, _twitterJsDefault.default));
parcelHelpers.export(exports, "TwitterIcon", ()=>(0, _twitterJsDefault.default));
parcelHelpers.export(exports, "LucideTypeOutline", ()=>(0, _typeOutlineJsDefault.default));
parcelHelpers.export(exports, "TypeOutline", ()=>(0, _typeOutlineJsDefault.default));
parcelHelpers.export(exports, "TypeOutlineIcon", ()=>(0, _typeOutlineJsDefault.default));
parcelHelpers.export(exports, "LucideType", ()=>(0, _typeJsDefault.default));
parcelHelpers.export(exports, "Type", ()=>(0, _typeJsDefault.default));
parcelHelpers.export(exports, "TypeIcon", ()=>(0, _typeJsDefault.default));
parcelHelpers.export(exports, "LucideUmbrellaOff", ()=>(0, _umbrellaOffJsDefault.default));
parcelHelpers.export(exports, "UmbrellaOff", ()=>(0, _umbrellaOffJsDefault.default));
parcelHelpers.export(exports, "UmbrellaOffIcon", ()=>(0, _umbrellaOffJsDefault.default));
parcelHelpers.export(exports, "LucideUmbrella", ()=>(0, _umbrellaJsDefault.default));
parcelHelpers.export(exports, "Umbrella", ()=>(0, _umbrellaJsDefault.default));
parcelHelpers.export(exports, "UmbrellaIcon", ()=>(0, _umbrellaJsDefault.default));
parcelHelpers.export(exports, "LucideUnderline", ()=>(0, _underlineJsDefault.default));
parcelHelpers.export(exports, "Underline", ()=>(0, _underlineJsDefault.default));
parcelHelpers.export(exports, "UnderlineIcon", ()=>(0, _underlineJsDefault.default));
parcelHelpers.export(exports, "LucideUndo2", ()=>(0, _undo2JsDefault.default));
parcelHelpers.export(exports, "Undo2", ()=>(0, _undo2JsDefault.default));
parcelHelpers.export(exports, "Undo2Icon", ()=>(0, _undo2JsDefault.default));
parcelHelpers.export(exports, "LucideUndoDot", ()=>(0, _undoDotJsDefault.default));
parcelHelpers.export(exports, "UndoDot", ()=>(0, _undoDotJsDefault.default));
parcelHelpers.export(exports, "UndoDotIcon", ()=>(0, _undoDotJsDefault.default));
parcelHelpers.export(exports, "LucideUndo", ()=>(0, _undoJsDefault.default));
parcelHelpers.export(exports, "Undo", ()=>(0, _undoJsDefault.default));
parcelHelpers.export(exports, "UndoIcon", ()=>(0, _undoJsDefault.default));
parcelHelpers.export(exports, "LucideUnfoldHorizontal", ()=>(0, _unfoldHorizontalJsDefault.default));
parcelHelpers.export(exports, "UnfoldHorizontal", ()=>(0, _unfoldHorizontalJsDefault.default));
parcelHelpers.export(exports, "UnfoldHorizontalIcon", ()=>(0, _unfoldHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideUnfoldVertical", ()=>(0, _unfoldVerticalJsDefault.default));
parcelHelpers.export(exports, "UnfoldVertical", ()=>(0, _unfoldVerticalJsDefault.default));
parcelHelpers.export(exports, "UnfoldVerticalIcon", ()=>(0, _unfoldVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideUngroup", ()=>(0, _ungroupJsDefault.default));
parcelHelpers.export(exports, "Ungroup", ()=>(0, _ungroupJsDefault.default));
parcelHelpers.export(exports, "UngroupIcon", ()=>(0, _ungroupJsDefault.default));
parcelHelpers.export(exports, "LucideUnlink2", ()=>(0, _unlink2JsDefault.default));
parcelHelpers.export(exports, "Unlink2", ()=>(0, _unlink2JsDefault.default));
parcelHelpers.export(exports, "Unlink2Icon", ()=>(0, _unlink2JsDefault.default));
parcelHelpers.export(exports, "LucideUnlink", ()=>(0, _unlinkJsDefault.default));
parcelHelpers.export(exports, "Unlink", ()=>(0, _unlinkJsDefault.default));
parcelHelpers.export(exports, "UnlinkIcon", ()=>(0, _unlinkJsDefault.default));
parcelHelpers.export(exports, "LucideUnplug", ()=>(0, _unplugJsDefault.default));
parcelHelpers.export(exports, "Unplug", ()=>(0, _unplugJsDefault.default));
parcelHelpers.export(exports, "UnplugIcon", ()=>(0, _unplugJsDefault.default));
parcelHelpers.export(exports, "LucideUpload", ()=>(0, _uploadJsDefault.default));
parcelHelpers.export(exports, "Upload", ()=>(0, _uploadJsDefault.default));
parcelHelpers.export(exports, "UploadIcon", ()=>(0, _uploadJsDefault.default));
parcelHelpers.export(exports, "LucideUsb", ()=>(0, _usbJsDefault.default));
parcelHelpers.export(exports, "Usb", ()=>(0, _usbJsDefault.default));
parcelHelpers.export(exports, "UsbIcon", ()=>(0, _usbJsDefault.default));
parcelHelpers.export(exports, "LucideUserCheck", ()=>(0, _userCheckJsDefault.default));
parcelHelpers.export(exports, "UserCheck", ()=>(0, _userCheckJsDefault.default));
parcelHelpers.export(exports, "UserCheckIcon", ()=>(0, _userCheckJsDefault.default));
parcelHelpers.export(exports, "LucideUserLock", ()=>(0, _userLockJsDefault.default));
parcelHelpers.export(exports, "UserLock", ()=>(0, _userLockJsDefault.default));
parcelHelpers.export(exports, "UserLockIcon", ()=>(0, _userLockJsDefault.default));
parcelHelpers.export(exports, "LucideUserCog", ()=>(0, _userCogJsDefault.default));
parcelHelpers.export(exports, "UserCog", ()=>(0, _userCogJsDefault.default));
parcelHelpers.export(exports, "UserCogIcon", ()=>(0, _userCogJsDefault.default));
parcelHelpers.export(exports, "LucideUserMinus", ()=>(0, _userMinusJsDefault.default));
parcelHelpers.export(exports, "UserMinus", ()=>(0, _userMinusJsDefault.default));
parcelHelpers.export(exports, "UserMinusIcon", ()=>(0, _userMinusJsDefault.default));
parcelHelpers.export(exports, "LucideUserPen", ()=>(0, _userPenJsDefault.default));
parcelHelpers.export(exports, "UserPen", ()=>(0, _userPenJsDefault.default));
parcelHelpers.export(exports, "UserPenIcon", ()=>(0, _userPenJsDefault.default));
parcelHelpers.export(exports, "LucideUserPlus", ()=>(0, _userPlusJsDefault.default));
parcelHelpers.export(exports, "UserPlus", ()=>(0, _userPlusJsDefault.default));
parcelHelpers.export(exports, "UserPlusIcon", ()=>(0, _userPlusJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundPen", ()=>(0, _userRoundPenJsDefault.default));
parcelHelpers.export(exports, "UserRoundPen", ()=>(0, _userRoundPenJsDefault.default));
parcelHelpers.export(exports, "UserRoundPenIcon", ()=>(0, _userRoundPenJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundSearch", ()=>(0, _userRoundSearchJsDefault.default));
parcelHelpers.export(exports, "UserRoundSearch", ()=>(0, _userRoundSearchJsDefault.default));
parcelHelpers.export(exports, "UserRoundSearchIcon", ()=>(0, _userRoundSearchJsDefault.default));
parcelHelpers.export(exports, "LucideUserSearch", ()=>(0, _userSearchJsDefault.default));
parcelHelpers.export(exports, "UserSearch", ()=>(0, _userSearchJsDefault.default));
parcelHelpers.export(exports, "UserSearchIcon", ()=>(0, _userSearchJsDefault.default));
parcelHelpers.export(exports, "LucideUserX", ()=>(0, _userXJsDefault.default));
parcelHelpers.export(exports, "UserX", ()=>(0, _userXJsDefault.default));
parcelHelpers.export(exports, "UserXIcon", ()=>(0, _userXJsDefault.default));
parcelHelpers.export(exports, "LucideUser", ()=>(0, _userJsDefault.default));
parcelHelpers.export(exports, "User", ()=>(0, _userJsDefault.default));
parcelHelpers.export(exports, "UserIcon", ()=>(0, _userJsDefault.default));
parcelHelpers.export(exports, "LucideUsers", ()=>(0, _usersJsDefault.default));
parcelHelpers.export(exports, "Users", ()=>(0, _usersJsDefault.default));
parcelHelpers.export(exports, "UsersIcon", ()=>(0, _usersJsDefault.default));
parcelHelpers.export(exports, "LucideUtilityPole", ()=>(0, _utilityPoleJsDefault.default));
parcelHelpers.export(exports, "UtilityPole", ()=>(0, _utilityPoleJsDefault.default));
parcelHelpers.export(exports, "UtilityPoleIcon", ()=>(0, _utilityPoleJsDefault.default));
parcelHelpers.export(exports, "LucideVariable", ()=>(0, _variableJsDefault.default));
parcelHelpers.export(exports, "Variable", ()=>(0, _variableJsDefault.default));
parcelHelpers.export(exports, "VariableIcon", ()=>(0, _variableJsDefault.default));
parcelHelpers.export(exports, "LucideVault", ()=>(0, _vaultJsDefault.default));
parcelHelpers.export(exports, "Vault", ()=>(0, _vaultJsDefault.default));
parcelHelpers.export(exports, "VaultIcon", ()=>(0, _vaultJsDefault.default));
parcelHelpers.export(exports, "LucideVegan", ()=>(0, _veganJsDefault.default));
parcelHelpers.export(exports, "Vegan", ()=>(0, _veganJsDefault.default));
parcelHelpers.export(exports, "VeganIcon", ()=>(0, _veganJsDefault.default));
parcelHelpers.export(exports, "LucideVenetianMask", ()=>(0, _venetianMaskJsDefault.default));
parcelHelpers.export(exports, "VenetianMask", ()=>(0, _venetianMaskJsDefault.default));
parcelHelpers.export(exports, "VenetianMaskIcon", ()=>(0, _venetianMaskJsDefault.default));
parcelHelpers.export(exports, "LucideVenusAndMars", ()=>(0, _venusAndMarsJsDefault.default));
parcelHelpers.export(exports, "VenusAndMars", ()=>(0, _venusAndMarsJsDefault.default));
parcelHelpers.export(exports, "VenusAndMarsIcon", ()=>(0, _venusAndMarsJsDefault.default));
parcelHelpers.export(exports, "LucideVenus", ()=>(0, _venusJsDefault.default));
parcelHelpers.export(exports, "Venus", ()=>(0, _venusJsDefault.default));
parcelHelpers.export(exports, "VenusIcon", ()=>(0, _venusJsDefault.default));
parcelHelpers.export(exports, "LucideVibrate", ()=>(0, _vibrateJsDefault.default));
parcelHelpers.export(exports, "Vibrate", ()=>(0, _vibrateJsDefault.default));
parcelHelpers.export(exports, "VibrateIcon", ()=>(0, _vibrateJsDefault.default));
parcelHelpers.export(exports, "LucideVibrateOff", ()=>(0, _vibrateOffJsDefault.default));
parcelHelpers.export(exports, "VibrateOff", ()=>(0, _vibrateOffJsDefault.default));
parcelHelpers.export(exports, "VibrateOffIcon", ()=>(0, _vibrateOffJsDefault.default));
parcelHelpers.export(exports, "LucideVideoOff", ()=>(0, _videoOffJsDefault.default));
parcelHelpers.export(exports, "VideoOff", ()=>(0, _videoOffJsDefault.default));
parcelHelpers.export(exports, "VideoOffIcon", ()=>(0, _videoOffJsDefault.default));
parcelHelpers.export(exports, "LucideVideo", ()=>(0, _videoJsDefault.default));
parcelHelpers.export(exports, "Video", ()=>(0, _videoJsDefault.default));
parcelHelpers.export(exports, "VideoIcon", ()=>(0, _videoJsDefault.default));
parcelHelpers.export(exports, "LucideVideotape", ()=>(0, _videotapeJsDefault.default));
parcelHelpers.export(exports, "Videotape", ()=>(0, _videotapeJsDefault.default));
parcelHelpers.export(exports, "VideotapeIcon", ()=>(0, _videotapeJsDefault.default));
parcelHelpers.export(exports, "LucideView", ()=>(0, _viewJsDefault.default));
parcelHelpers.export(exports, "View", ()=>(0, _viewJsDefault.default));
parcelHelpers.export(exports, "ViewIcon", ()=>(0, _viewJsDefault.default));
parcelHelpers.export(exports, "LucideVoicemail", ()=>(0, _voicemailJsDefault.default));
parcelHelpers.export(exports, "Voicemail", ()=>(0, _voicemailJsDefault.default));
parcelHelpers.export(exports, "VoicemailIcon", ()=>(0, _voicemailJsDefault.default));
parcelHelpers.export(exports, "LucideVolume1", ()=>(0, _volume1JsDefault.default));
parcelHelpers.export(exports, "Volume1", ()=>(0, _volume1JsDefault.default));
parcelHelpers.export(exports, "Volume1Icon", ()=>(0, _volume1JsDefault.default));
parcelHelpers.export(exports, "LucideVolume2", ()=>(0, _volume2JsDefault.default));
parcelHelpers.export(exports, "Volume2", ()=>(0, _volume2JsDefault.default));
parcelHelpers.export(exports, "Volume2Icon", ()=>(0, _volume2JsDefault.default));
parcelHelpers.export(exports, "LucideVolleyball", ()=>(0, _volleyballJsDefault.default));
parcelHelpers.export(exports, "Volleyball", ()=>(0, _volleyballJsDefault.default));
parcelHelpers.export(exports, "VolleyballIcon", ()=>(0, _volleyballJsDefault.default));
parcelHelpers.export(exports, "LucideVolumeOff", ()=>(0, _volumeOffJsDefault.default));
parcelHelpers.export(exports, "VolumeOff", ()=>(0, _volumeOffJsDefault.default));
parcelHelpers.export(exports, "VolumeOffIcon", ()=>(0, _volumeOffJsDefault.default));
parcelHelpers.export(exports, "LucideVolumeX", ()=>(0, _volumeXJsDefault.default));
parcelHelpers.export(exports, "VolumeX", ()=>(0, _volumeXJsDefault.default));
parcelHelpers.export(exports, "VolumeXIcon", ()=>(0, _volumeXJsDefault.default));
parcelHelpers.export(exports, "LucideVolume", ()=>(0, _volumeJsDefault.default));
parcelHelpers.export(exports, "Volume", ()=>(0, _volumeJsDefault.default));
parcelHelpers.export(exports, "VolumeIcon", ()=>(0, _volumeJsDefault.default));
parcelHelpers.export(exports, "LucideVote", ()=>(0, _voteJsDefault.default));
parcelHelpers.export(exports, "Vote", ()=>(0, _voteJsDefault.default));
parcelHelpers.export(exports, "VoteIcon", ()=>(0, _voteJsDefault.default));
parcelHelpers.export(exports, "LucideWalletCards", ()=>(0, _walletCardsJsDefault.default));
parcelHelpers.export(exports, "WalletCards", ()=>(0, _walletCardsJsDefault.default));
parcelHelpers.export(exports, "WalletCardsIcon", ()=>(0, _walletCardsJsDefault.default));
parcelHelpers.export(exports, "LucideWallet", ()=>(0, _walletJsDefault.default));
parcelHelpers.export(exports, "Wallet", ()=>(0, _walletJsDefault.default));
parcelHelpers.export(exports, "WalletIcon", ()=>(0, _walletJsDefault.default));
parcelHelpers.export(exports, "LucideWallpaper", ()=>(0, _wallpaperJsDefault.default));
parcelHelpers.export(exports, "Wallpaper", ()=>(0, _wallpaperJsDefault.default));
parcelHelpers.export(exports, "WallpaperIcon", ()=>(0, _wallpaperJsDefault.default));
parcelHelpers.export(exports, "LucideWarehouse", ()=>(0, _warehouseJsDefault.default));
parcelHelpers.export(exports, "Warehouse", ()=>(0, _warehouseJsDefault.default));
parcelHelpers.export(exports, "WarehouseIcon", ()=>(0, _warehouseJsDefault.default));
parcelHelpers.export(exports, "LucideWand", ()=>(0, _wandJsDefault.default));
parcelHelpers.export(exports, "Wand", ()=>(0, _wandJsDefault.default));
parcelHelpers.export(exports, "WandIcon", ()=>(0, _wandJsDefault.default));
parcelHelpers.export(exports, "LucideWashingMachine", ()=>(0, _washingMachineJsDefault.default));
parcelHelpers.export(exports, "WashingMachine", ()=>(0, _washingMachineJsDefault.default));
parcelHelpers.export(exports, "WashingMachineIcon", ()=>(0, _washingMachineJsDefault.default));
parcelHelpers.export(exports, "LucideWavesLadder", ()=>(0, _wavesLadderJsDefault.default));
parcelHelpers.export(exports, "WavesLadder", ()=>(0, _wavesLadderJsDefault.default));
parcelHelpers.export(exports, "WavesLadderIcon", ()=>(0, _wavesLadderJsDefault.default));
parcelHelpers.export(exports, "LucideWatch", ()=>(0, _watchJsDefault.default));
parcelHelpers.export(exports, "Watch", ()=>(0, _watchJsDefault.default));
parcelHelpers.export(exports, "WatchIcon", ()=>(0, _watchJsDefault.default));
parcelHelpers.export(exports, "LucideWaves", ()=>(0, _wavesJsDefault.default));
parcelHelpers.export(exports, "Waves", ()=>(0, _wavesJsDefault.default));
parcelHelpers.export(exports, "WavesIcon", ()=>(0, _wavesJsDefault.default));
parcelHelpers.export(exports, "LucideWaypoints", ()=>(0, _waypointsJsDefault.default));
parcelHelpers.export(exports, "Waypoints", ()=>(0, _waypointsJsDefault.default));
parcelHelpers.export(exports, "WaypointsIcon", ()=>(0, _waypointsJsDefault.default));
parcelHelpers.export(exports, "LucideWebcam", ()=>(0, _webcamJsDefault.default));
parcelHelpers.export(exports, "Webcam", ()=>(0, _webcamJsDefault.default));
parcelHelpers.export(exports, "WebcamIcon", ()=>(0, _webcamJsDefault.default));
parcelHelpers.export(exports, "LucideWebhookOff", ()=>(0, _webhookOffJsDefault.default));
parcelHelpers.export(exports, "WebhookOff", ()=>(0, _webhookOffJsDefault.default));
parcelHelpers.export(exports, "WebhookOffIcon", ()=>(0, _webhookOffJsDefault.default));
parcelHelpers.export(exports, "LucideWebhook", ()=>(0, _webhookJsDefault.default));
parcelHelpers.export(exports, "Webhook", ()=>(0, _webhookJsDefault.default));
parcelHelpers.export(exports, "WebhookIcon", ()=>(0, _webhookJsDefault.default));
parcelHelpers.export(exports, "LucideWeight", ()=>(0, _weightJsDefault.default));
parcelHelpers.export(exports, "Weight", ()=>(0, _weightJsDefault.default));
parcelHelpers.export(exports, "WeightIcon", ()=>(0, _weightJsDefault.default));
parcelHelpers.export(exports, "LucideWheatOff", ()=>(0, _wheatOffJsDefault.default));
parcelHelpers.export(exports, "WheatOff", ()=>(0, _wheatOffJsDefault.default));
parcelHelpers.export(exports, "WheatOffIcon", ()=>(0, _wheatOffJsDefault.default));
parcelHelpers.export(exports, "LucideWheat", ()=>(0, _wheatJsDefault.default));
parcelHelpers.export(exports, "Wheat", ()=>(0, _wheatJsDefault.default));
parcelHelpers.export(exports, "WheatIcon", ()=>(0, _wheatJsDefault.default));
parcelHelpers.export(exports, "LucideWifiHigh", ()=>(0, _wifiHighJsDefault.default));
parcelHelpers.export(exports, "WifiHigh", ()=>(0, _wifiHighJsDefault.default));
parcelHelpers.export(exports, "WifiHighIcon", ()=>(0, _wifiHighJsDefault.default));
parcelHelpers.export(exports, "LucideWholeWord", ()=>(0, _wholeWordJsDefault.default));
parcelHelpers.export(exports, "WholeWord", ()=>(0, _wholeWordJsDefault.default));
parcelHelpers.export(exports, "WholeWordIcon", ()=>(0, _wholeWordJsDefault.default));
parcelHelpers.export(exports, "LucideWifiLow", ()=>(0, _wifiLowJsDefault.default));
parcelHelpers.export(exports, "WifiLow", ()=>(0, _wifiLowJsDefault.default));
parcelHelpers.export(exports, "WifiLowIcon", ()=>(0, _wifiLowJsDefault.default));
parcelHelpers.export(exports, "LucideWifiOff", ()=>(0, _wifiOffJsDefault.default));
parcelHelpers.export(exports, "WifiOff", ()=>(0, _wifiOffJsDefault.default));
parcelHelpers.export(exports, "WifiOffIcon", ()=>(0, _wifiOffJsDefault.default));
parcelHelpers.export(exports, "LucideWifiPen", ()=>(0, _wifiPenJsDefault.default));
parcelHelpers.export(exports, "WifiPen", ()=>(0, _wifiPenJsDefault.default));
parcelHelpers.export(exports, "WifiPenIcon", ()=>(0, _wifiPenJsDefault.default));
parcelHelpers.export(exports, "LucideWifiZero", ()=>(0, _wifiZeroJsDefault.default));
parcelHelpers.export(exports, "WifiZero", ()=>(0, _wifiZeroJsDefault.default));
parcelHelpers.export(exports, "WifiZeroIcon", ()=>(0, _wifiZeroJsDefault.default));
parcelHelpers.export(exports, "LucideWifi", ()=>(0, _wifiJsDefault.default));
parcelHelpers.export(exports, "Wifi", ()=>(0, _wifiJsDefault.default));
parcelHelpers.export(exports, "WifiIcon", ()=>(0, _wifiJsDefault.default));
parcelHelpers.export(exports, "LucideWindArrowDown", ()=>(0, _windArrowDownJsDefault.default));
parcelHelpers.export(exports, "WindArrowDown", ()=>(0, _windArrowDownJsDefault.default));
parcelHelpers.export(exports, "WindArrowDownIcon", ()=>(0, _windArrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideWind", ()=>(0, _windJsDefault.default));
parcelHelpers.export(exports, "Wind", ()=>(0, _windJsDefault.default));
parcelHelpers.export(exports, "WindIcon", ()=>(0, _windJsDefault.default));
parcelHelpers.export(exports, "LucideWineOff", ()=>(0, _wineOffJsDefault.default));
parcelHelpers.export(exports, "WineOff", ()=>(0, _wineOffJsDefault.default));
parcelHelpers.export(exports, "WineOffIcon", ()=>(0, _wineOffJsDefault.default));
parcelHelpers.export(exports, "LucideWine", ()=>(0, _wineJsDefault.default));
parcelHelpers.export(exports, "Wine", ()=>(0, _wineJsDefault.default));
parcelHelpers.export(exports, "WineIcon", ()=>(0, _wineJsDefault.default));
parcelHelpers.export(exports, "LucideWorkflow", ()=>(0, _workflowJsDefault.default));
parcelHelpers.export(exports, "Workflow", ()=>(0, _workflowJsDefault.default));
parcelHelpers.export(exports, "WorkflowIcon", ()=>(0, _workflowJsDefault.default));
parcelHelpers.export(exports, "LucideWorm", ()=>(0, _wormJsDefault.default));
parcelHelpers.export(exports, "Worm", ()=>(0, _wormJsDefault.default));
parcelHelpers.export(exports, "WormIcon", ()=>(0, _wormJsDefault.default));
parcelHelpers.export(exports, "LucideWrapText", ()=>(0, _wrapTextJsDefault.default));
parcelHelpers.export(exports, "WrapText", ()=>(0, _wrapTextJsDefault.default));
parcelHelpers.export(exports, "WrapTextIcon", ()=>(0, _wrapTextJsDefault.default));
parcelHelpers.export(exports, "LucideWrench", ()=>(0, _wrenchJsDefault.default));
parcelHelpers.export(exports, "Wrench", ()=>(0, _wrenchJsDefault.default));
parcelHelpers.export(exports, "WrenchIcon", ()=>(0, _wrenchJsDefault.default));
parcelHelpers.export(exports, "LucideX", ()=>(0, _xJsDefault.default));
parcelHelpers.export(exports, "X", ()=>(0, _xJsDefault.default));
parcelHelpers.export(exports, "XIcon", ()=>(0, _xJsDefault.default));
parcelHelpers.export(exports, "LucideYoutube", ()=>(0, _youtubeJsDefault.default));
parcelHelpers.export(exports, "Youtube", ()=>(0, _youtubeJsDefault.default));
parcelHelpers.export(exports, "YoutubeIcon", ()=>(0, _youtubeJsDefault.default));
parcelHelpers.export(exports, "LucideZapOff", ()=>(0, _zapOffJsDefault.default));
parcelHelpers.export(exports, "ZapOff", ()=>(0, _zapOffJsDefault.default));
parcelHelpers.export(exports, "ZapOffIcon", ()=>(0, _zapOffJsDefault.default));
parcelHelpers.export(exports, "LucideZap", ()=>(0, _zapJsDefault.default));
parcelHelpers.export(exports, "Zap", ()=>(0, _zapJsDefault.default));
parcelHelpers.export(exports, "ZapIcon", ()=>(0, _zapJsDefault.default));
parcelHelpers.export(exports, "LucideZoomIn", ()=>(0, _zoomInJsDefault.default));
parcelHelpers.export(exports, "ZoomIn", ()=>(0, _zoomInJsDefault.default));
parcelHelpers.export(exports, "ZoomInIcon", ()=>(0, _zoomInJsDefault.default));
parcelHelpers.export(exports, "LucideZoomOut", ()=>(0, _zoomOutJsDefault.default));
parcelHelpers.export(exports, "ZoomOut", ()=>(0, _zoomOutJsDefault.default));
parcelHelpers.export(exports, "ZoomOutIcon", ()=>(0, _zoomOutJsDefault.default));
parcelHelpers.export(exports, "ArrowDown01", ()=>(0, _arrowDown01JsDefault.default));
parcelHelpers.export(exports, "ArrowDown01Icon", ()=>(0, _arrowDown01JsDefault.default));
parcelHelpers.export(exports, "LucideArrowDown01", ()=>(0, _arrowDown01JsDefault.default));
parcelHelpers.export(exports, "ArrowDown10", ()=>(0, _arrowDown10JsDefault.default));
parcelHelpers.export(exports, "ArrowDown10Icon", ()=>(0, _arrowDown10JsDefault.default));
parcelHelpers.export(exports, "LucideArrowDown10", ()=>(0, _arrowDown10JsDefault.default));
parcelHelpers.export(exports, "ArrowUp01", ()=>(0, _arrowUp01JsDefault.default));
parcelHelpers.export(exports, "ArrowUp01Icon", ()=>(0, _arrowUp01JsDefault.default));
parcelHelpers.export(exports, "LucideArrowUp01", ()=>(0, _arrowUp01JsDefault.default));
parcelHelpers.export(exports, "ArrowUp10", ()=>(0, _arrowUp10JsDefault.default));
parcelHelpers.export(exports, "ArrowUp10Icon", ()=>(0, _arrowUp10JsDefault.default));
parcelHelpers.export(exports, "LucideArrowUp10", ()=>(0, _arrowUp10JsDefault.default));
parcelHelpers.export(exports, "createLucideIcon", ()=>(0, _createLucideIconJsDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _iconJsDefault.default));
parcelHelpers.export(exports, "icons", ()=>_indexJs);
var _indexJs = require("./icons/index.js");
var _alarmClockCheckJs = require("./icons/alarm-clock-check.js");
var _alarmClockCheckJsDefault = parcelHelpers.interopDefault(_alarmClockCheckJs);
var _alarmClockMinusJs = require("./icons/alarm-clock-minus.js");
var _alarmClockMinusJsDefault = parcelHelpers.interopDefault(_alarmClockMinusJs);
var _alarmClockPlusJs = require("./icons/alarm-clock-plus.js");
var _alarmClockPlusJsDefault = parcelHelpers.interopDefault(_alarmClockPlusJs);
var _arrowDownAZJs = require("./icons/arrow-down-a-z.js");
var _arrowDownAZJsDefault = parcelHelpers.interopDefault(_arrowDownAZJs);
var _arrowDownWideNarrowJs = require("./icons/arrow-down-wide-narrow.js");
var _arrowDownWideNarrowJsDefault = parcelHelpers.interopDefault(_arrowDownWideNarrowJs);
var _arrowDownZAJs = require("./icons/arrow-down-z-a.js");
var _arrowDownZAJsDefault = parcelHelpers.interopDefault(_arrowDownZAJs);
var _arrowUpAZJs = require("./icons/arrow-up-a-z.js");
var _arrowUpAZJsDefault = parcelHelpers.interopDefault(_arrowUpAZJs);
var _arrowUpNarrowWideJs = require("./icons/arrow-up-narrow-wide.js");
var _arrowUpNarrowWideJsDefault = parcelHelpers.interopDefault(_arrowUpNarrowWideJs);
var _arrowUpZAJs = require("./icons/arrow-up-z-a.js");
var _arrowUpZAJsDefault = parcelHelpers.interopDefault(_arrowUpZAJs);
var _axis3DJs = require("./icons/axis-3d.js");
var _axis3DJsDefault = parcelHelpers.interopDefault(_axis3DJs);
var _badgeCheckJs = require("./icons/badge-check.js");
var _badgeCheckJsDefault = parcelHelpers.interopDefault(_badgeCheckJs);
var _betweenHorizontalEndJs = require("./icons/between-horizontal-end.js");
var _betweenHorizontalEndJsDefault = parcelHelpers.interopDefault(_betweenHorizontalEndJs);
var _betweenHorizontalStartJs = require("./icons/between-horizontal-start.js");
var _betweenHorizontalStartJsDefault = parcelHelpers.interopDefault(_betweenHorizontalStartJs);
var _bookDashedJs = require("./icons/book-dashed.js");
var _bookDashedJsDefault = parcelHelpers.interopDefault(_bookDashedJs);
var _bracesJs = require("./icons/braces.js");
var _bracesJsDefault = parcelHelpers.interopDefault(_bracesJs);
var _captionsJs = require("./icons/captions.js");
var _captionsJsDefault = parcelHelpers.interopDefault(_captionsJs);
var _chartAreaJs = require("./icons/chart-area.js");
var _chartAreaJsDefault = parcelHelpers.interopDefault(_chartAreaJs);
var _chartBarBigJs = require("./icons/chart-bar-big.js");
var _chartBarBigJsDefault = parcelHelpers.interopDefault(_chartBarBigJs);
var _chartBarJs = require("./icons/chart-bar.js");
var _chartBarJsDefault = parcelHelpers.interopDefault(_chartBarJs);
var _chartCandlestickJs = require("./icons/chart-candlestick.js");
var _chartCandlestickJsDefault = parcelHelpers.interopDefault(_chartCandlestickJs);
var _chartColumnBigJs = require("./icons/chart-column-big.js");
var _chartColumnBigJsDefault = parcelHelpers.interopDefault(_chartColumnBigJs);
var _chartColumnIncreasingJs = require("./icons/chart-column-increasing.js");
var _chartColumnIncreasingJsDefault = parcelHelpers.interopDefault(_chartColumnIncreasingJs);
var _chartLineJs = require("./icons/chart-line.js");
var _chartLineJsDefault = parcelHelpers.interopDefault(_chartLineJs);
var _chartNoAxesColumnIncreasingJs = require("./icons/chart-no-axes-column-increasing.js");
var _chartNoAxesColumnIncreasingJsDefault = parcelHelpers.interopDefault(_chartNoAxesColumnIncreasingJs);
var _chartColumnJs = require("./icons/chart-column.js");
var _chartColumnJsDefault = parcelHelpers.interopDefault(_chartColumnJs);
var _chartNoAxesColumnJs = require("./icons/chart-no-axes-column.js");
var _chartNoAxesColumnJsDefault = parcelHelpers.interopDefault(_chartNoAxesColumnJs);
var _chartNoAxesGanttJs = require("./icons/chart-no-axes-gantt.js");
var _chartNoAxesGanttJsDefault = parcelHelpers.interopDefault(_chartNoAxesGanttJs);
var _chartPieJs = require("./icons/chart-pie.js");
var _chartPieJsDefault = parcelHelpers.interopDefault(_chartPieJs);
var _chartScatterJs = require("./icons/chart-scatter.js");
var _chartScatterJsDefault = parcelHelpers.interopDefault(_chartScatterJs);
var _circleAlertJs = require("./icons/circle-alert.js");
var _circleAlertJsDefault = parcelHelpers.interopDefault(_circleAlertJs);
var _circleArrowDownJs = require("./icons/circle-arrow-down.js");
var _circleArrowDownJsDefault = parcelHelpers.interopDefault(_circleArrowDownJs);
var _circleArrowOutDownLeftJs = require("./icons/circle-arrow-out-down-left.js");
var _circleArrowOutDownLeftJsDefault = parcelHelpers.interopDefault(_circleArrowOutDownLeftJs);
var _circleArrowLeftJs = require("./icons/circle-arrow-left.js");
var _circleArrowLeftJsDefault = parcelHelpers.interopDefault(_circleArrowLeftJs);
var _circleArrowOutDownRightJs = require("./icons/circle-arrow-out-down-right.js");
var _circleArrowOutDownRightJsDefault = parcelHelpers.interopDefault(_circleArrowOutDownRightJs);
var _circleArrowOutUpLeftJs = require("./icons/circle-arrow-out-up-left.js");
var _circleArrowOutUpLeftJsDefault = parcelHelpers.interopDefault(_circleArrowOutUpLeftJs);
var _circleArrowOutUpRightJs = require("./icons/circle-arrow-out-up-right.js");
var _circleArrowOutUpRightJsDefault = parcelHelpers.interopDefault(_circleArrowOutUpRightJs);
var _circleArrowRightJs = require("./icons/circle-arrow-right.js");
var _circleArrowRightJsDefault = parcelHelpers.interopDefault(_circleArrowRightJs);
var _circleArrowUpJs = require("./icons/circle-arrow-up.js");
var _circleArrowUpJsDefault = parcelHelpers.interopDefault(_circleArrowUpJs);
var _circleCheckJs = require("./icons/circle-check.js");
var _circleCheckJsDefault = parcelHelpers.interopDefault(_circleCheckJs);
var _circleCheckBigJs = require("./icons/circle-check-big.js");
var _circleCheckBigJsDefault = parcelHelpers.interopDefault(_circleCheckBigJs);
var _circleChevronDownJs = require("./icons/circle-chevron-down.js");
var _circleChevronDownJsDefault = parcelHelpers.interopDefault(_circleChevronDownJs);
var _circleChevronLeftJs = require("./icons/circle-chevron-left.js");
var _circleChevronLeftJsDefault = parcelHelpers.interopDefault(_circleChevronLeftJs);
var _circleChevronRightJs = require("./icons/circle-chevron-right.js");
var _circleChevronRightJsDefault = parcelHelpers.interopDefault(_circleChevronRightJs);
var _circleChevronUpJs = require("./icons/circle-chevron-up.js");
var _circleChevronUpJsDefault = parcelHelpers.interopDefault(_circleChevronUpJs);
var _circleDivideJs = require("./icons/circle-divide.js");
var _circleDivideJsDefault = parcelHelpers.interopDefault(_circleDivideJs);
var _circleGaugeJs = require("./icons/circle-gauge.js");
var _circleGaugeJsDefault = parcelHelpers.interopDefault(_circleGaugeJs);
var _circleHelpJs = require("./icons/circle-help.js");
var _circleHelpJsDefault = parcelHelpers.interopDefault(_circleHelpJs);
var _circleMinusJs = require("./icons/circle-minus.js");
var _circleMinusJsDefault = parcelHelpers.interopDefault(_circleMinusJs);
var _circleParkingOffJs = require("./icons/circle-parking-off.js");
var _circleParkingOffJsDefault = parcelHelpers.interopDefault(_circleParkingOffJs);
var _circleParkingJs = require("./icons/circle-parking.js");
var _circleParkingJsDefault = parcelHelpers.interopDefault(_circleParkingJs);
var _circlePauseJs = require("./icons/circle-pause.js");
var _circlePauseJsDefault = parcelHelpers.interopDefault(_circlePauseJs);
var _circlePlayJs = require("./icons/circle-play.js");
var _circlePlayJsDefault = parcelHelpers.interopDefault(_circlePlayJs);
var _circlePercentJs = require("./icons/circle-percent.js");
var _circlePercentJsDefault = parcelHelpers.interopDefault(_circlePercentJs);
var _circlePowerJs = require("./icons/circle-power.js");
var _circlePowerJsDefault = parcelHelpers.interopDefault(_circlePowerJs);
var _circlePlusJs = require("./icons/circle-plus.js");
var _circlePlusJsDefault = parcelHelpers.interopDefault(_circlePlusJs);
var _circleSlash2Js = require("./icons/circle-slash-2.js");
var _circleSlash2JsDefault = parcelHelpers.interopDefault(_circleSlash2Js);
var _circleStopJs = require("./icons/circle-stop.js");
var _circleStopJsDefault = parcelHelpers.interopDefault(_circleStopJs);
var _circleUserRoundJs = require("./icons/circle-user-round.js");
var _circleUserRoundJsDefault = parcelHelpers.interopDefault(_circleUserRoundJs);
var _circleUserJs = require("./icons/circle-user.js");
var _circleUserJsDefault = parcelHelpers.interopDefault(_circleUserJs);
var _circleXJs = require("./icons/circle-x.js");
var _circleXJsDefault = parcelHelpers.interopDefault(_circleXJs);
var _clipboardPenLineJs = require("./icons/clipboard-pen-line.js");
var _clipboardPenLineJsDefault = parcelHelpers.interopDefault(_clipboardPenLineJs);
var _clipboardPenJs = require("./icons/clipboard-pen.js");
var _clipboardPenJsDefault = parcelHelpers.interopDefault(_clipboardPenJs);
var _cloudDownloadJs = require("./icons/cloud-download.js");
var _cloudDownloadJsDefault = parcelHelpers.interopDefault(_cloudDownloadJs);
var _cloudUploadJs = require("./icons/cloud-upload.js");
var _cloudUploadJsDefault = parcelHelpers.interopDefault(_cloudUploadJs);
var _codeXmlJs = require("./icons/code-xml.js");
var _codeXmlJsDefault = parcelHelpers.interopDefault(_codeXmlJs);
var _columns2Js = require("./icons/columns-2.js");
var _columns2JsDefault = parcelHelpers.interopDefault(_columns2Js);
var _columns3CogJs = require("./icons/columns-3-cog.js");
var _columns3CogJsDefault = parcelHelpers.interopDefault(_columns3CogJs);
var _columns3Js = require("./icons/columns-3.js");
var _columns3JsDefault = parcelHelpers.interopDefault(_columns3Js);
var _contactRoundJs = require("./icons/contact-round.js");
var _contactRoundJsDefault = parcelHelpers.interopDefault(_contactRoundJs);
var _diamondPercentJs = require("./icons/diamond-percent.js");
var _diamondPercentJsDefault = parcelHelpers.interopDefault(_diamondPercentJs);
var _earthJs = require("./icons/earth.js");
var _earthJsDefault = parcelHelpers.interopDefault(_earthJs);
var _ellipsisVerticalJs = require("./icons/ellipsis-vertical.js");
var _ellipsisVerticalJsDefault = parcelHelpers.interopDefault(_ellipsisVerticalJs);
var _ellipsisJs = require("./icons/ellipsis.js");
var _ellipsisJsDefault = parcelHelpers.interopDefault(_ellipsisJs);
var _fileAxis3DJs = require("./icons/file-axis-3d.js");
var _fileAxis3DJsDefault = parcelHelpers.interopDefault(_fileAxis3DJs);
var _fileChartColumnJs = require("./icons/file-chart-column.js");
var _fileChartColumnJsDefault = parcelHelpers.interopDefault(_fileChartColumnJs);
var _fileChartColumnIncreasingJs = require("./icons/file-chart-column-increasing.js");
var _fileChartColumnIncreasingJsDefault = parcelHelpers.interopDefault(_fileChartColumnIncreasingJs);
var _fileChartLineJs = require("./icons/file-chart-line.js");
var _fileChartLineJsDefault = parcelHelpers.interopDefault(_fileChartLineJs);
var _fileChartPieJs = require("./icons/file-chart-pie.js");
var _fileChartPieJsDefault = parcelHelpers.interopDefault(_fileChartPieJs);
var _fileCogJs = require("./icons/file-cog.js");
var _fileCogJsDefault = parcelHelpers.interopDefault(_fileCogJs);
var _filePenLineJs = require("./icons/file-pen-line.js");
var _filePenLineJsDefault = parcelHelpers.interopDefault(_filePenLineJs);
var _filePenJs = require("./icons/file-pen.js");
var _filePenJsDefault = parcelHelpers.interopDefault(_filePenJs);
var _folderCogJs = require("./icons/folder-cog.js");
var _folderCogJsDefault = parcelHelpers.interopDefault(_folderCogJs);
var _folderPenJs = require("./icons/folder-pen.js");
var _folderPenJsDefault = parcelHelpers.interopDefault(_folderPenJs);
var _funnelXJs = require("./icons/funnel-x.js");
var _funnelXJsDefault = parcelHelpers.interopDefault(_funnelXJs);
var _funnelJs = require("./icons/funnel.js");
var _funnelJsDefault = parcelHelpers.interopDefault(_funnelJs);
var _gitCommitHorizontalJs = require("./icons/git-commit-horizontal.js");
var _gitCommitHorizontalJsDefault = parcelHelpers.interopDefault(_gitCommitHorizontalJs);
var _grid2X2CheckJs = require("./icons/grid-2x2-check.js");
var _grid2X2CheckJsDefault = parcelHelpers.interopDefault(_grid2X2CheckJs);
var _grid2X2PlusJs = require("./icons/grid-2x2-plus.js");
var _grid2X2PlusJsDefault = parcelHelpers.interopDefault(_grid2X2PlusJs);
var _grid2X2XJs = require("./icons/grid-2x2-x.js");
var _grid2X2XJsDefault = parcelHelpers.interopDefault(_grid2X2XJs);
var _grid2X2Js = require("./icons/grid-2x2.js");
var _grid2X2JsDefault = parcelHelpers.interopDefault(_grid2X2Js);
var _grid3X3Js = require("./icons/grid-3x3.js");
var _grid3X3JsDefault = parcelHelpers.interopDefault(_grid3X3Js);
var _handHelpingJs = require("./icons/hand-helping.js");
var _handHelpingJsDefault = parcelHelpers.interopDefault(_handHelpingJs);
var _houseJs = require("./icons/house.js");
var _houseJsDefault = parcelHelpers.interopDefault(_houseJs);
var _iceCreamBowlJs = require("./icons/ice-cream-bowl.js");
var _iceCreamBowlJsDefault = parcelHelpers.interopDefault(_iceCreamBowlJs);
var _iceCreamConeJs = require("./icons/ice-cream-cone.js");
var _iceCreamConeJsDefault = parcelHelpers.interopDefault(_iceCreamConeJs);
var _indentDecreaseJs = require("./icons/indent-decrease.js");
var _indentDecreaseJsDefault = parcelHelpers.interopDefault(_indentDecreaseJs);
var _indentIncreaseJs = require("./icons/indent-increase.js");
var _indentIncreaseJsDefault = parcelHelpers.interopDefault(_indentIncreaseJs);
var _laptopMinimalJs = require("./icons/laptop-minimal.js");
var _laptopMinimalJsDefault = parcelHelpers.interopDefault(_laptopMinimalJs);
var _layersJs = require("./icons/layers.js");
var _layersJsDefault = parcelHelpers.interopDefault(_layersJs);
var _loaderCircleJs = require("./icons/loader-circle.js");
var _loaderCircleJsDefault = parcelHelpers.interopDefault(_loaderCircleJs);
var _lockKeyholeOpenJs = require("./icons/lock-keyhole-open.js");
var _lockKeyholeOpenJsDefault = parcelHelpers.interopDefault(_lockKeyholeOpenJs);
var _lockOpenJs = require("./icons/lock-open.js");
var _lockOpenJsDefault = parcelHelpers.interopDefault(_lockOpenJs);
var _micVocalJs = require("./icons/mic-vocal.js");
var _micVocalJsDefault = parcelHelpers.interopDefault(_micVocalJs);
var _move3DJs = require("./icons/move-3d.js");
var _move3DJsDefault = parcelHelpers.interopDefault(_move3DJs);
var _octagonAlertJs = require("./icons/octagon-alert.js");
var _octagonAlertJsDefault = parcelHelpers.interopDefault(_octagonAlertJs);
var _octagonPauseJs = require("./icons/octagon-pause.js");
var _octagonPauseJsDefault = parcelHelpers.interopDefault(_octagonPauseJs);
var _octagonXJs = require("./icons/octagon-x.js");
var _octagonXJsDefault = parcelHelpers.interopDefault(_octagonXJs);
var _paintbrushVerticalJs = require("./icons/paintbrush-vertical.js");
var _paintbrushVerticalJsDefault = parcelHelpers.interopDefault(_paintbrushVerticalJs);
var _panelBottomDashedJs = require("./icons/panel-bottom-dashed.js");
var _panelBottomDashedJsDefault = parcelHelpers.interopDefault(_panelBottomDashedJs);
var _panelLeftDashedJs = require("./icons/panel-left-dashed.js");
var _panelLeftDashedJsDefault = parcelHelpers.interopDefault(_panelLeftDashedJs);
var _panelLeftCloseJs = require("./icons/panel-left-close.js");
var _panelLeftCloseJsDefault = parcelHelpers.interopDefault(_panelLeftCloseJs);
var _panelLeftOpenJs = require("./icons/panel-left-open.js");
var _panelLeftOpenJsDefault = parcelHelpers.interopDefault(_panelLeftOpenJs);
var _panelLeftJs = require("./icons/panel-left.js");
var _panelLeftJsDefault = parcelHelpers.interopDefault(_panelLeftJs);
var _panelRightDashedJs = require("./icons/panel-right-dashed.js");
var _panelRightDashedJsDefault = parcelHelpers.interopDefault(_panelRightDashedJs);
var _panelTopDashedJs = require("./icons/panel-top-dashed.js");
var _panelTopDashedJsDefault = parcelHelpers.interopDefault(_panelTopDashedJs);
var _panelsTopLeftJs = require("./icons/panels-top-left.js");
var _panelsTopLeftJsDefault = parcelHelpers.interopDefault(_panelsTopLeftJs);
var _penLineJs = require("./icons/pen-line.js");
var _penLineJsDefault = parcelHelpers.interopDefault(_penLineJs);
var _penJs = require("./icons/pen.js");
var _penJsDefault = parcelHelpers.interopDefault(_penJs);
var _plugZapJs = require("./icons/plug-zap.js");
var _plugZapJsDefault = parcelHelpers.interopDefault(_plugZapJs);
var _rectangleEllipsisJs = require("./icons/rectangle-ellipsis.js");
var _rectangleEllipsisJsDefault = parcelHelpers.interopDefault(_rectangleEllipsisJs);
var _rotate3DJs = require("./icons/rotate-3d.js");
var _rotate3DJsDefault = parcelHelpers.interopDefault(_rotate3DJs);
var _rows2Js = require("./icons/rows-2.js");
var _rows2JsDefault = parcelHelpers.interopDefault(_rows2Js);
var _rows3Js = require("./icons/rows-3.js");
var _rows3JsDefault = parcelHelpers.interopDefault(_rows3Js);
var _scale3DJs = require("./icons/scale-3d.js");
var _scale3DJsDefault = parcelHelpers.interopDefault(_scale3DJs);
var _sendHorizontalJs = require("./icons/send-horizontal.js");
var _sendHorizontalJsDefault = parcelHelpers.interopDefault(_sendHorizontalJs);
var _shieldXJs = require("./icons/shield-x.js");
var _shieldXJsDefault = parcelHelpers.interopDefault(_shieldXJs);
var _slidersVerticalJs = require("./icons/sliders-vertical.js");
var _slidersVerticalJsDefault = parcelHelpers.interopDefault(_slidersVerticalJs);
var _sparklesJs = require("./icons/sparkles.js");
var _sparklesJsDefault = parcelHelpers.interopDefault(_sparklesJs);
var _squareActivityJs = require("./icons/square-activity.js");
var _squareActivityJsDefault = parcelHelpers.interopDefault(_squareActivityJs);
var _squareArrowDownLeftJs = require("./icons/square-arrow-down-left.js");
var _squareArrowDownLeftJsDefault = parcelHelpers.interopDefault(_squareArrowDownLeftJs);
var _squareArrowDownRightJs = require("./icons/square-arrow-down-right.js");
var _squareArrowDownRightJsDefault = parcelHelpers.interopDefault(_squareArrowDownRightJs);
var _squareArrowDownJs = require("./icons/square-arrow-down.js");
var _squareArrowDownJsDefault = parcelHelpers.interopDefault(_squareArrowDownJs);
var _squareArrowOutDownRightJs = require("./icons/square-arrow-out-down-right.js");
var _squareArrowOutDownRightJsDefault = parcelHelpers.interopDefault(_squareArrowOutDownRightJs);
var _squareArrowOutDownLeftJs = require("./icons/square-arrow-out-down-left.js");
var _squareArrowOutDownLeftJsDefault = parcelHelpers.interopDefault(_squareArrowOutDownLeftJs);
var _squareArrowLeftJs = require("./icons/square-arrow-left.js");
var _squareArrowLeftJsDefault = parcelHelpers.interopDefault(_squareArrowLeftJs);
var _squareArrowOutUpLeftJs = require("./icons/square-arrow-out-up-left.js");
var _squareArrowOutUpLeftJsDefault = parcelHelpers.interopDefault(_squareArrowOutUpLeftJs);
var _squareArrowOutUpRightJs = require("./icons/square-arrow-out-up-right.js");
var _squareArrowOutUpRightJsDefault = parcelHelpers.interopDefault(_squareArrowOutUpRightJs);
var _squareArrowRightJs = require("./icons/square-arrow-right.js");
var _squareArrowRightJsDefault = parcelHelpers.interopDefault(_squareArrowRightJs);
var _squareArrowUpLeftJs = require("./icons/square-arrow-up-left.js");
var _squareArrowUpLeftJsDefault = parcelHelpers.interopDefault(_squareArrowUpLeftJs);
var _squareArrowUpRightJs = require("./icons/square-arrow-up-right.js");
var _squareArrowUpRightJsDefault = parcelHelpers.interopDefault(_squareArrowUpRightJs);
var _squareArrowUpJs = require("./icons/square-arrow-up.js");
var _squareArrowUpJsDefault = parcelHelpers.interopDefault(_squareArrowUpJs);
var _squareAsteriskJs = require("./icons/square-asterisk.js");
var _squareAsteriskJsDefault = parcelHelpers.interopDefault(_squareAsteriskJs);
var _squareBottomDashedScissorsJs = require("./icons/square-bottom-dashed-scissors.js");
var _squareBottomDashedScissorsJsDefault = parcelHelpers.interopDefault(_squareBottomDashedScissorsJs);
var _squareChartGanttJs = require("./icons/square-chart-gantt.js");
var _squareChartGanttJsDefault = parcelHelpers.interopDefault(_squareChartGanttJs);
var _squareCheckBigJs = require("./icons/square-check-big.js");
var _squareCheckBigJsDefault = parcelHelpers.interopDefault(_squareCheckBigJs);
var _squareChevronDownJs = require("./icons/square-chevron-down.js");
var _squareChevronDownJsDefault = parcelHelpers.interopDefault(_squareChevronDownJs);
var _squareCheckJs = require("./icons/square-check.js");
var _squareCheckJsDefault = parcelHelpers.interopDefault(_squareCheckJs);
var _squareChevronLeftJs = require("./icons/square-chevron-left.js");
var _squareChevronLeftJsDefault = parcelHelpers.interopDefault(_squareChevronLeftJs);
var _squareChevronRightJs = require("./icons/square-chevron-right.js");
var _squareChevronRightJsDefault = parcelHelpers.interopDefault(_squareChevronRightJs);
var _squareCodeJs = require("./icons/square-code.js");
var _squareCodeJsDefault = parcelHelpers.interopDefault(_squareCodeJs);
var _squareChevronUpJs = require("./icons/square-chevron-up.js");
var _squareChevronUpJsDefault = parcelHelpers.interopDefault(_squareChevronUpJs);
var _squareDashedMousePointerJs = require("./icons/square-dashed-mouse-pointer.js");
var _squareDashedMousePointerJsDefault = parcelHelpers.interopDefault(_squareDashedMousePointerJs);
var _squareDashedJs = require("./icons/square-dashed.js");
var _squareDashedJsDefault = parcelHelpers.interopDefault(_squareDashedJs);
var _squareDashedKanbanJs = require("./icons/square-dashed-kanban.js");
var _squareDashedKanbanJsDefault = parcelHelpers.interopDefault(_squareDashedKanbanJs);
var _squareDivideJs = require("./icons/square-divide.js");
var _squareDivideJsDefault = parcelHelpers.interopDefault(_squareDivideJs);
var _squareDotJs = require("./icons/square-dot.js");
var _squareDotJsDefault = parcelHelpers.interopDefault(_squareDotJs);
var _squareEqualJs = require("./icons/square-equal.js");
var _squareEqualJsDefault = parcelHelpers.interopDefault(_squareEqualJs);
var _squareFunctionJs = require("./icons/square-function.js");
var _squareFunctionJsDefault = parcelHelpers.interopDefault(_squareFunctionJs);
var _squareKanbanJs = require("./icons/square-kanban.js");
var _squareKanbanJsDefault = parcelHelpers.interopDefault(_squareKanbanJs);
var _squareLibraryJs = require("./icons/square-library.js");
var _squareLibraryJsDefault = parcelHelpers.interopDefault(_squareLibraryJs);
var _squareMJs = require("./icons/square-m.js");
var _squareMJsDefault = parcelHelpers.interopDefault(_squareMJs);
var _squareMenuJs = require("./icons/square-menu.js");
var _squareMenuJsDefault = parcelHelpers.interopDefault(_squareMenuJs);
var _squareMinusJs = require("./icons/square-minus.js");
var _squareMinusJsDefault = parcelHelpers.interopDefault(_squareMinusJs);
var _squareMousePointerJs = require("./icons/square-mouse-pointer.js");
var _squareMousePointerJsDefault = parcelHelpers.interopDefault(_squareMousePointerJs);
var _squareParkingOffJs = require("./icons/square-parking-off.js");
var _squareParkingOffJsDefault = parcelHelpers.interopDefault(_squareParkingOffJs);
var _squareParkingJs = require("./icons/square-parking.js");
var _squareParkingJsDefault = parcelHelpers.interopDefault(_squareParkingJs);
var _squarePenJs = require("./icons/square-pen.js");
var _squarePenJsDefault = parcelHelpers.interopDefault(_squarePenJs);
var _squarePercentJs = require("./icons/square-percent.js");
var _squarePercentJsDefault = parcelHelpers.interopDefault(_squarePercentJs);
var _squarePiJs = require("./icons/square-pi.js");
var _squarePiJsDefault = parcelHelpers.interopDefault(_squarePiJs);
var _squarePlayJs = require("./icons/square-play.js");
var _squarePlayJsDefault = parcelHelpers.interopDefault(_squarePlayJs);
var _squarePilcrowJs = require("./icons/square-pilcrow.js");
var _squarePilcrowJsDefault = parcelHelpers.interopDefault(_squarePilcrowJs);
var _squarePlusJs = require("./icons/square-plus.js");
var _squarePlusJsDefault = parcelHelpers.interopDefault(_squarePlusJs);
var _squarePowerJs = require("./icons/square-power.js");
var _squarePowerJsDefault = parcelHelpers.interopDefault(_squarePowerJs);
var _squareScissorsJs = require("./icons/square-scissors.js");
var _squareScissorsJsDefault = parcelHelpers.interopDefault(_squareScissorsJs);
var _squareSigmaJs = require("./icons/square-sigma.js");
var _squareSigmaJsDefault = parcelHelpers.interopDefault(_squareSigmaJs);
var _squareSlashJs = require("./icons/square-slash.js");
var _squareSlashJsDefault = parcelHelpers.interopDefault(_squareSlashJs);
var _squareSplitHorizontalJs = require("./icons/square-split-horizontal.js");
var _squareSplitHorizontalJsDefault = parcelHelpers.interopDefault(_squareSplitHorizontalJs);
var _squareTerminalJs = require("./icons/square-terminal.js");
var _squareTerminalJsDefault = parcelHelpers.interopDefault(_squareTerminalJs);
var _squareSplitVerticalJs = require("./icons/square-split-vertical.js");
var _squareSplitVerticalJsDefault = parcelHelpers.interopDefault(_squareSplitVerticalJs);
var _squareUserRoundJs = require("./icons/square-user-round.js");
var _squareUserRoundJsDefault = parcelHelpers.interopDefault(_squareUserRoundJs);
var _squareUserJs = require("./icons/square-user.js");
var _squareUserJsDefault = parcelHelpers.interopDefault(_squareUserJs);
var _squareXJs = require("./icons/square-x.js");
var _squareXJsDefault = parcelHelpers.interopDefault(_squareXJs);
var _testTubeDiagonalJs = require("./icons/test-tube-diagonal.js");
var _testTubeDiagonalJsDefault = parcelHelpers.interopDefault(_testTubeDiagonalJs);
var _textSelectJs = require("./icons/text-select.js");
var _textSelectJsDefault = parcelHelpers.interopDefault(_textSelectJs);
var _tramFrontJs = require("./icons/tram-front.js");
var _tramFrontJsDefault = parcelHelpers.interopDefault(_tramFrontJs);
var _treePalmJs = require("./icons/tree-palm.js");
var _treePalmJsDefault = parcelHelpers.interopDefault(_treePalmJs);
var _triangleAlertJs = require("./icons/triangle-alert.js");
var _triangleAlertJsDefault = parcelHelpers.interopDefault(_triangleAlertJs);
var _tvMinimalJs = require("./icons/tv-minimal.js");
var _tvMinimalJsDefault = parcelHelpers.interopDefault(_tvMinimalJs);
var _universityJs = require("./icons/university.js");
var _universityJsDefault = parcelHelpers.interopDefault(_universityJs);
var _userRoundCheckJs = require("./icons/user-round-check.js");
var _userRoundCheckJsDefault = parcelHelpers.interopDefault(_userRoundCheckJs);
var _userRoundCogJs = require("./icons/user-round-cog.js");
var _userRoundCogJsDefault = parcelHelpers.interopDefault(_userRoundCogJs);
var _userRoundMinusJs = require("./icons/user-round-minus.js");
var _userRoundMinusJsDefault = parcelHelpers.interopDefault(_userRoundMinusJs);
var _userRoundPlusJs = require("./icons/user-round-plus.js");
var _userRoundPlusJsDefault = parcelHelpers.interopDefault(_userRoundPlusJs);
var _userRoundXJs = require("./icons/user-round-x.js");
var _userRoundXJsDefault = parcelHelpers.interopDefault(_userRoundXJs);
var _userRoundJs = require("./icons/user-round.js");
var _userRoundJsDefault = parcelHelpers.interopDefault(_userRoundJs);
var _usersRoundJs = require("./icons/users-round.js");
var _usersRoundJsDefault = parcelHelpers.interopDefault(_usersRoundJs);
var _utensilsCrossedJs = require("./icons/utensils-crossed.js");
var _utensilsCrossedJsDefault = parcelHelpers.interopDefault(_utensilsCrossedJs);
var _utensilsJs = require("./icons/utensils.js");
var _utensilsJsDefault = parcelHelpers.interopDefault(_utensilsJs);
var _walletMinimalJs = require("./icons/wallet-minimal.js");
var _walletMinimalJsDefault = parcelHelpers.interopDefault(_walletMinimalJs);
var _wandSparklesJs = require("./icons/wand-sparkles.js");
var _wandSparklesJsDefault = parcelHelpers.interopDefault(_wandSparklesJs);
var _aArrowDownJs = require("./icons/a-arrow-down.js");
var _aArrowDownJsDefault = parcelHelpers.interopDefault(_aArrowDownJs);
var _aArrowUpJs = require("./icons/a-arrow-up.js");
var _aArrowUpJsDefault = parcelHelpers.interopDefault(_aArrowUpJs);
var _aLargeSmallJs = require("./icons/a-large-small.js");
var _aLargeSmallJsDefault = parcelHelpers.interopDefault(_aLargeSmallJs);
var _accessibilityJs = require("./icons/accessibility.js");
var _accessibilityJsDefault = parcelHelpers.interopDefault(_accessibilityJs);
var _activityJs = require("./icons/activity.js");
var _activityJsDefault = parcelHelpers.interopDefault(_activityJs);
var _airVentJs = require("./icons/air-vent.js");
var _airVentJsDefault = parcelHelpers.interopDefault(_airVentJs);
var _airplayJs = require("./icons/airplay.js");
var _airplayJsDefault = parcelHelpers.interopDefault(_airplayJs);
var _alarmClockOffJs = require("./icons/alarm-clock-off.js");
var _alarmClockOffJsDefault = parcelHelpers.interopDefault(_alarmClockOffJs);
var _alarmClockJs = require("./icons/alarm-clock.js");
var _alarmClockJsDefault = parcelHelpers.interopDefault(_alarmClockJs);
var _alarmSmokeJs = require("./icons/alarm-smoke.js");
var _alarmSmokeJsDefault = parcelHelpers.interopDefault(_alarmSmokeJs);
var _alignCenterHorizontalJs = require("./icons/align-center-horizontal.js");
var _alignCenterHorizontalJsDefault = parcelHelpers.interopDefault(_alignCenterHorizontalJs);
var _albumJs = require("./icons/album.js");
var _albumJsDefault = parcelHelpers.interopDefault(_albumJs);
var _alignCenterVerticalJs = require("./icons/align-center-vertical.js");
var _alignCenterVerticalJsDefault = parcelHelpers.interopDefault(_alignCenterVerticalJs);
var _alignCenterJs = require("./icons/align-center.js");
var _alignCenterJsDefault = parcelHelpers.interopDefault(_alignCenterJs);
var _alignEndHorizontalJs = require("./icons/align-end-horizontal.js");
var _alignEndHorizontalJsDefault = parcelHelpers.interopDefault(_alignEndHorizontalJs);
var _alignEndVerticalJs = require("./icons/align-end-vertical.js");
var _alignEndVerticalJsDefault = parcelHelpers.interopDefault(_alignEndVerticalJs);
var _alignHorizontalDistributeCenterJs = require("./icons/align-horizontal-distribute-center.js");
var _alignHorizontalDistributeCenterJsDefault = parcelHelpers.interopDefault(_alignHorizontalDistributeCenterJs);
var _alignHorizontalDistributeEndJs = require("./icons/align-horizontal-distribute-end.js");
var _alignHorizontalDistributeEndJsDefault = parcelHelpers.interopDefault(_alignHorizontalDistributeEndJs);
var _alignHorizontalDistributeStartJs = require("./icons/align-horizontal-distribute-start.js");
var _alignHorizontalDistributeStartJsDefault = parcelHelpers.interopDefault(_alignHorizontalDistributeStartJs);
var _alignHorizontalJustifyCenterJs = require("./icons/align-horizontal-justify-center.js");
var _alignHorizontalJustifyCenterJsDefault = parcelHelpers.interopDefault(_alignHorizontalJustifyCenterJs);
var _alignHorizontalJustifyEndJs = require("./icons/align-horizontal-justify-end.js");
var _alignHorizontalJustifyEndJsDefault = parcelHelpers.interopDefault(_alignHorizontalJustifyEndJs);
var _alignHorizontalJustifyStartJs = require("./icons/align-horizontal-justify-start.js");
var _alignHorizontalJustifyStartJsDefault = parcelHelpers.interopDefault(_alignHorizontalJustifyStartJs);
var _alignHorizontalSpaceAroundJs = require("./icons/align-horizontal-space-around.js");
var _alignHorizontalSpaceAroundJsDefault = parcelHelpers.interopDefault(_alignHorizontalSpaceAroundJs);
var _alignHorizontalSpaceBetweenJs = require("./icons/align-horizontal-space-between.js");
var _alignHorizontalSpaceBetweenJsDefault = parcelHelpers.interopDefault(_alignHorizontalSpaceBetweenJs);
var _alignJustifyJs = require("./icons/align-justify.js");
var _alignJustifyJsDefault = parcelHelpers.interopDefault(_alignJustifyJs);
var _alignRightJs = require("./icons/align-right.js");
var _alignRightJsDefault = parcelHelpers.interopDefault(_alignRightJs);
var _alignLeftJs = require("./icons/align-left.js");
var _alignLeftJsDefault = parcelHelpers.interopDefault(_alignLeftJs);
var _alignStartHorizontalJs = require("./icons/align-start-horizontal.js");
var _alignStartHorizontalJsDefault = parcelHelpers.interopDefault(_alignStartHorizontalJs);
var _alignVerticalDistributeCenterJs = require("./icons/align-vertical-distribute-center.js");
var _alignVerticalDistributeCenterJsDefault = parcelHelpers.interopDefault(_alignVerticalDistributeCenterJs);
var _alignStartVerticalJs = require("./icons/align-start-vertical.js");
var _alignStartVerticalJsDefault = parcelHelpers.interopDefault(_alignStartVerticalJs);
var _alignVerticalDistributeStartJs = require("./icons/align-vertical-distribute-start.js");
var _alignVerticalDistributeStartJsDefault = parcelHelpers.interopDefault(_alignVerticalDistributeStartJs);
var _alignVerticalDistributeEndJs = require("./icons/align-vertical-distribute-end.js");
var _alignVerticalDistributeEndJsDefault = parcelHelpers.interopDefault(_alignVerticalDistributeEndJs);
var _alignVerticalJustifyCenterJs = require("./icons/align-vertical-justify-center.js");
var _alignVerticalJustifyCenterJsDefault = parcelHelpers.interopDefault(_alignVerticalJustifyCenterJs);
var _alignVerticalJustifyEndJs = require("./icons/align-vertical-justify-end.js");
var _alignVerticalJustifyEndJsDefault = parcelHelpers.interopDefault(_alignVerticalJustifyEndJs);
var _alignVerticalJustifyStartJs = require("./icons/align-vertical-justify-start.js");
var _alignVerticalJustifyStartJsDefault = parcelHelpers.interopDefault(_alignVerticalJustifyStartJs);
var _alignVerticalSpaceAroundJs = require("./icons/align-vertical-space-around.js");
var _alignVerticalSpaceAroundJsDefault = parcelHelpers.interopDefault(_alignVerticalSpaceAroundJs);
var _alignVerticalSpaceBetweenJs = require("./icons/align-vertical-space-between.js");
var _alignVerticalSpaceBetweenJsDefault = parcelHelpers.interopDefault(_alignVerticalSpaceBetweenJs);
var _ambulanceJs = require("./icons/ambulance.js");
var _ambulanceJsDefault = parcelHelpers.interopDefault(_ambulanceJs);
var _ampersandJs = require("./icons/ampersand.js");
var _ampersandJsDefault = parcelHelpers.interopDefault(_ampersandJs);
var _ampersandsJs = require("./icons/ampersands.js");
var _ampersandsJsDefault = parcelHelpers.interopDefault(_ampersandsJs);
var _amphoraJs = require("./icons/amphora.js");
var _amphoraJsDefault = parcelHelpers.interopDefault(_amphoraJs);
var _anchorJs = require("./icons/anchor.js");
var _anchorJsDefault = parcelHelpers.interopDefault(_anchorJs);
var _annoyedJs = require("./icons/annoyed.js");
var _annoyedJsDefault = parcelHelpers.interopDefault(_annoyedJs);
var _angryJs = require("./icons/angry.js");
var _angryJsDefault = parcelHelpers.interopDefault(_angryJs);
var _antennaJs = require("./icons/antenna.js");
var _antennaJsDefault = parcelHelpers.interopDefault(_antennaJs);
var _appWindowMacJs = require("./icons/app-window-mac.js");
var _appWindowMacJsDefault = parcelHelpers.interopDefault(_appWindowMacJs);
var _anvilJs = require("./icons/anvil.js");
var _anvilJsDefault = parcelHelpers.interopDefault(_anvilJs);
var _apertureJs = require("./icons/aperture.js");
var _apertureJsDefault = parcelHelpers.interopDefault(_apertureJs);
var _appWindowJs = require("./icons/app-window.js");
var _appWindowJsDefault = parcelHelpers.interopDefault(_appWindowJs);
var _appleJs = require("./icons/apple.js");
var _appleJsDefault = parcelHelpers.interopDefault(_appleJs);
var _archiveRestoreJs = require("./icons/archive-restore.js");
var _archiveRestoreJsDefault = parcelHelpers.interopDefault(_archiveRestoreJs);
var _archiveXJs = require("./icons/archive-x.js");
var _archiveXJsDefault = parcelHelpers.interopDefault(_archiveXJs);
var _archiveJs = require("./icons/archive.js");
var _archiveJsDefault = parcelHelpers.interopDefault(_archiveJs);
var _armchairJs = require("./icons/armchair.js");
var _armchairJsDefault = parcelHelpers.interopDefault(_armchairJs);
var _arrowBigDownDashJs = require("./icons/arrow-big-down-dash.js");
var _arrowBigDownDashJsDefault = parcelHelpers.interopDefault(_arrowBigDownDashJs);
var _arrowBigDownJs = require("./icons/arrow-big-down.js");
var _arrowBigDownJsDefault = parcelHelpers.interopDefault(_arrowBigDownJs);
var _arrowBigLeftDashJs = require("./icons/arrow-big-left-dash.js");
var _arrowBigLeftDashJsDefault = parcelHelpers.interopDefault(_arrowBigLeftDashJs);
var _arrowBigLeftJs = require("./icons/arrow-big-left.js");
var _arrowBigLeftJsDefault = parcelHelpers.interopDefault(_arrowBigLeftJs);
var _arrowBigRightJs = require("./icons/arrow-big-right.js");
var _arrowBigRightJsDefault = parcelHelpers.interopDefault(_arrowBigRightJs);
var _arrowBigUpDashJs = require("./icons/arrow-big-up-dash.js");
var _arrowBigUpDashJsDefault = parcelHelpers.interopDefault(_arrowBigUpDashJs);
var _arrowBigRightDashJs = require("./icons/arrow-big-right-dash.js");
var _arrowBigRightDashJsDefault = parcelHelpers.interopDefault(_arrowBigRightDashJs);
var _arrowBigUpJs = require("./icons/arrow-big-up.js");
var _arrowBigUpJsDefault = parcelHelpers.interopDefault(_arrowBigUpJs);
var _arrowDownFromLineJs = require("./icons/arrow-down-from-line.js");
var _arrowDownFromLineJsDefault = parcelHelpers.interopDefault(_arrowDownFromLineJs);
var _arrowDownLeftJs = require("./icons/arrow-down-left.js");
var _arrowDownLeftJsDefault = parcelHelpers.interopDefault(_arrowDownLeftJs);
var _arrowDownNarrowWideJs = require("./icons/arrow-down-narrow-wide.js");
var _arrowDownNarrowWideJsDefault = parcelHelpers.interopDefault(_arrowDownNarrowWideJs);
var _arrowDownRightJs = require("./icons/arrow-down-right.js");
var _arrowDownRightJsDefault = parcelHelpers.interopDefault(_arrowDownRightJs);
var _arrowDownToDotJs = require("./icons/arrow-down-to-dot.js");
var _arrowDownToDotJsDefault = parcelHelpers.interopDefault(_arrowDownToDotJs);
var _arrowDownToLineJs = require("./icons/arrow-down-to-line.js");
var _arrowDownToLineJsDefault = parcelHelpers.interopDefault(_arrowDownToLineJs);
var _arrowDownUpJs = require("./icons/arrow-down-up.js");
var _arrowDownUpJsDefault = parcelHelpers.interopDefault(_arrowDownUpJs);
var _arrowDownJs = require("./icons/arrow-down.js");
var _arrowDownJsDefault = parcelHelpers.interopDefault(_arrowDownJs);
var _arrowLeftFromLineJs = require("./icons/arrow-left-from-line.js");
var _arrowLeftFromLineJsDefault = parcelHelpers.interopDefault(_arrowLeftFromLineJs);
var _arrowLeftRightJs = require("./icons/arrow-left-right.js");
var _arrowLeftRightJsDefault = parcelHelpers.interopDefault(_arrowLeftRightJs);
var _arrowLeftToLineJs = require("./icons/arrow-left-to-line.js");
var _arrowLeftToLineJsDefault = parcelHelpers.interopDefault(_arrowLeftToLineJs);
var _arrowLeftJs = require("./icons/arrow-left.js");
var _arrowLeftJsDefault = parcelHelpers.interopDefault(_arrowLeftJs);
var _arrowRightFromLineJs = require("./icons/arrow-right-from-line.js");
var _arrowRightFromLineJsDefault = parcelHelpers.interopDefault(_arrowRightFromLineJs);
var _arrowRightLeftJs = require("./icons/arrow-right-left.js");
var _arrowRightLeftJsDefault = parcelHelpers.interopDefault(_arrowRightLeftJs);
var _arrowRightToLineJs = require("./icons/arrow-right-to-line.js");
var _arrowRightToLineJsDefault = parcelHelpers.interopDefault(_arrowRightToLineJs);
var _arrowRightJs = require("./icons/arrow-right.js");
var _arrowRightJsDefault = parcelHelpers.interopDefault(_arrowRightJs);
var _arrowUpDownJs = require("./icons/arrow-up-down.js");
var _arrowUpDownJsDefault = parcelHelpers.interopDefault(_arrowUpDownJs);
var _arrowUpFromDotJs = require("./icons/arrow-up-from-dot.js");
var _arrowUpFromDotJsDefault = parcelHelpers.interopDefault(_arrowUpFromDotJs);
var _arrowUpFromLineJs = require("./icons/arrow-up-from-line.js");
var _arrowUpFromLineJsDefault = parcelHelpers.interopDefault(_arrowUpFromLineJs);
var _arrowUpRightJs = require("./icons/arrow-up-right.js");
var _arrowUpRightJsDefault = parcelHelpers.interopDefault(_arrowUpRightJs);
var _arrowUpLeftJs = require("./icons/arrow-up-left.js");
var _arrowUpLeftJsDefault = parcelHelpers.interopDefault(_arrowUpLeftJs);
var _arrowUpToLineJs = require("./icons/arrow-up-to-line.js");
var _arrowUpToLineJsDefault = parcelHelpers.interopDefault(_arrowUpToLineJs);
var _arrowUpWideNarrowJs = require("./icons/arrow-up-wide-narrow.js");
var _arrowUpWideNarrowJsDefault = parcelHelpers.interopDefault(_arrowUpWideNarrowJs);
var _arrowUpJs = require("./icons/arrow-up.js");
var _arrowUpJsDefault = parcelHelpers.interopDefault(_arrowUpJs);
var _arrowsUpFromLineJs = require("./icons/arrows-up-from-line.js");
var _arrowsUpFromLineJsDefault = parcelHelpers.interopDefault(_arrowsUpFromLineJs);
var _asteriskJs = require("./icons/asterisk.js");
var _asteriskJsDefault = parcelHelpers.interopDefault(_asteriskJs);
var _atSignJs = require("./icons/at-sign.js");
var _atSignJsDefault = parcelHelpers.interopDefault(_atSignJs);
var _atomJs = require("./icons/atom.js");
var _atomJsDefault = parcelHelpers.interopDefault(_atomJs);
var _audioLinesJs = require("./icons/audio-lines.js");
var _audioLinesJsDefault = parcelHelpers.interopDefault(_audioLinesJs);
var _audioWaveformJs = require("./icons/audio-waveform.js");
var _audioWaveformJsDefault = parcelHelpers.interopDefault(_audioWaveformJs);
var _awardJs = require("./icons/award.js");
var _awardJsDefault = parcelHelpers.interopDefault(_awardJs);
var _axeJs = require("./icons/axe.js");
var _axeJsDefault = parcelHelpers.interopDefault(_axeJs);
var _babyJs = require("./icons/baby.js");
var _babyJsDefault = parcelHelpers.interopDefault(_babyJs);
var _backpackJs = require("./icons/backpack.js");
var _backpackJsDefault = parcelHelpers.interopDefault(_backpackJs);
var _badgeAlertJs = require("./icons/badge-alert.js");
var _badgeAlertJsDefault = parcelHelpers.interopDefault(_badgeAlertJs);
var _badgeCentJs = require("./icons/badge-cent.js");
var _badgeCentJsDefault = parcelHelpers.interopDefault(_badgeCentJs);
var _badgeDollarSignJs = require("./icons/badge-dollar-sign.js");
var _badgeDollarSignJsDefault = parcelHelpers.interopDefault(_badgeDollarSignJs);
var _badgeEuroJs = require("./icons/badge-euro.js");
var _badgeEuroJsDefault = parcelHelpers.interopDefault(_badgeEuroJs);
var _badgeHelpJs = require("./icons/badge-help.js");
var _badgeHelpJsDefault = parcelHelpers.interopDefault(_badgeHelpJs);
var _badgeIndianRupeeJs = require("./icons/badge-indian-rupee.js");
var _badgeIndianRupeeJsDefault = parcelHelpers.interopDefault(_badgeIndianRupeeJs);
var _badgeMinusJs = require("./icons/badge-minus.js");
var _badgeMinusJsDefault = parcelHelpers.interopDefault(_badgeMinusJs);
var _badgeJapaneseYenJs = require("./icons/badge-japanese-yen.js");
var _badgeJapaneseYenJsDefault = parcelHelpers.interopDefault(_badgeJapaneseYenJs);
var _badgeInfoJs = require("./icons/badge-info.js");
var _badgeInfoJsDefault = parcelHelpers.interopDefault(_badgeInfoJs);
var _badgePercentJs = require("./icons/badge-percent.js");
var _badgePercentJsDefault = parcelHelpers.interopDefault(_badgePercentJs);
var _badgePlusJs = require("./icons/badge-plus.js");
var _badgePlusJsDefault = parcelHelpers.interopDefault(_badgePlusJs);
var _badgeRussianRubleJs = require("./icons/badge-russian-ruble.js");
var _badgeRussianRubleJsDefault = parcelHelpers.interopDefault(_badgeRussianRubleJs);
var _badgePoundSterlingJs = require("./icons/badge-pound-sterling.js");
var _badgePoundSterlingJsDefault = parcelHelpers.interopDefault(_badgePoundSterlingJs);
var _badgeSwissFrancJs = require("./icons/badge-swiss-franc.js");
var _badgeSwissFrancJsDefault = parcelHelpers.interopDefault(_badgeSwissFrancJs);
var _badgeXJs = require("./icons/badge-x.js");
var _badgeXJsDefault = parcelHelpers.interopDefault(_badgeXJs);
var _badgeJs = require("./icons/badge.js");
var _badgeJsDefault = parcelHelpers.interopDefault(_badgeJs);
var _baggageClaimJs = require("./icons/baggage-claim.js");
var _baggageClaimJsDefault = parcelHelpers.interopDefault(_baggageClaimJs);
var _banJs = require("./icons/ban.js");
var _banJsDefault = parcelHelpers.interopDefault(_banJs);
var _bananaJs = require("./icons/banana.js");
var _bananaJsDefault = parcelHelpers.interopDefault(_bananaJs);
var _bandageJs = require("./icons/bandage.js");
var _bandageJsDefault = parcelHelpers.interopDefault(_bandageJs);
var _banknoteArrowDownJs = require("./icons/banknote-arrow-down.js");
var _banknoteArrowDownJsDefault = parcelHelpers.interopDefault(_banknoteArrowDownJs);
var _banknoteArrowUpJs = require("./icons/banknote-arrow-up.js");
var _banknoteArrowUpJsDefault = parcelHelpers.interopDefault(_banknoteArrowUpJs);
var _banknoteXJs = require("./icons/banknote-x.js");
var _banknoteXJsDefault = parcelHelpers.interopDefault(_banknoteXJs);
var _banknoteJs = require("./icons/banknote.js");
var _banknoteJsDefault = parcelHelpers.interopDefault(_banknoteJs);
var _barcodeJs = require("./icons/barcode.js");
var _barcodeJsDefault = parcelHelpers.interopDefault(_barcodeJs);
var _baselineJs = require("./icons/baseline.js");
var _baselineJsDefault = parcelHelpers.interopDefault(_baselineJs);
var _bathJs = require("./icons/bath.js");
var _bathJsDefault = parcelHelpers.interopDefault(_bathJs);
var _batteryChargingJs = require("./icons/battery-charging.js");
var _batteryChargingJsDefault = parcelHelpers.interopDefault(_batteryChargingJs);
var _batteryFullJs = require("./icons/battery-full.js");
var _batteryFullJsDefault = parcelHelpers.interopDefault(_batteryFullJs);
var _batteryLowJs = require("./icons/battery-low.js");
var _batteryLowJsDefault = parcelHelpers.interopDefault(_batteryLowJs);
var _batteryMediumJs = require("./icons/battery-medium.js");
var _batteryMediumJsDefault = parcelHelpers.interopDefault(_batteryMediumJs);
var _batteryPlusJs = require("./icons/battery-plus.js");
var _batteryPlusJsDefault = parcelHelpers.interopDefault(_batteryPlusJs);
var _batteryWarningJs = require("./icons/battery-warning.js");
var _batteryWarningJsDefault = parcelHelpers.interopDefault(_batteryWarningJs);
var _batteryJs = require("./icons/battery.js");
var _batteryJsDefault = parcelHelpers.interopDefault(_batteryJs);
var _beakerJs = require("./icons/beaker.js");
var _beakerJsDefault = parcelHelpers.interopDefault(_beakerJs);
var _beanOffJs = require("./icons/bean-off.js");
var _beanOffJsDefault = parcelHelpers.interopDefault(_beanOffJs);
var _bedDoubleJs = require("./icons/bed-double.js");
var _bedDoubleJsDefault = parcelHelpers.interopDefault(_bedDoubleJs);
var _bedSingleJs = require("./icons/bed-single.js");
var _bedSingleJsDefault = parcelHelpers.interopDefault(_bedSingleJs);
var _beanJs = require("./icons/bean.js");
var _beanJsDefault = parcelHelpers.interopDefault(_beanJs);
var _bedJs = require("./icons/bed.js");
var _bedJsDefault = parcelHelpers.interopDefault(_bedJs);
var _beefJs = require("./icons/beef.js");
var _beefJsDefault = parcelHelpers.interopDefault(_beefJs);
var _beerOffJs = require("./icons/beer-off.js");
var _beerOffJsDefault = parcelHelpers.interopDefault(_beerOffJs);
var _beerJs = require("./icons/beer.js");
var _beerJsDefault = parcelHelpers.interopDefault(_beerJs);
var _bellDotJs = require("./icons/bell-dot.js");
var _bellDotJsDefault = parcelHelpers.interopDefault(_bellDotJs);
var _bellElectricJs = require("./icons/bell-electric.js");
var _bellElectricJsDefault = parcelHelpers.interopDefault(_bellElectricJs);
var _bellOffJs = require("./icons/bell-off.js");
var _bellOffJsDefault = parcelHelpers.interopDefault(_bellOffJs);
var _bellMinusJs = require("./icons/bell-minus.js");
var _bellMinusJsDefault = parcelHelpers.interopDefault(_bellMinusJs);
var _bellPlusJs = require("./icons/bell-plus.js");
var _bellPlusJsDefault = parcelHelpers.interopDefault(_bellPlusJs);
var _bellRingJs = require("./icons/bell-ring.js");
var _bellRingJsDefault = parcelHelpers.interopDefault(_bellRingJs);
var _bellJs = require("./icons/bell.js");
var _bellJsDefault = parcelHelpers.interopDefault(_bellJs);
var _betweenVerticalEndJs = require("./icons/between-vertical-end.js");
var _betweenVerticalEndJsDefault = parcelHelpers.interopDefault(_betweenVerticalEndJs);
var _betweenVerticalStartJs = require("./icons/between-vertical-start.js");
var _betweenVerticalStartJsDefault = parcelHelpers.interopDefault(_betweenVerticalStartJs);
var _bicepsFlexedJs = require("./icons/biceps-flexed.js");
var _bicepsFlexedJsDefault = parcelHelpers.interopDefault(_bicepsFlexedJs);
var _bikeJs = require("./icons/bike.js");
var _bikeJsDefault = parcelHelpers.interopDefault(_bikeJs);
var _binaryJs = require("./icons/binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _binocularsJs = require("./icons/binoculars.js");
var _binocularsJsDefault = parcelHelpers.interopDefault(_binocularsJs);
var _biohazardJs = require("./icons/biohazard.js");
var _biohazardJsDefault = parcelHelpers.interopDefault(_biohazardJs);
var _birdJs = require("./icons/bird.js");
var _birdJsDefault = parcelHelpers.interopDefault(_birdJs);
var _bitcoinJs = require("./icons/bitcoin.js");
var _bitcoinJsDefault = parcelHelpers.interopDefault(_bitcoinJs);
var _blendJs = require("./icons/blend.js");
var _blendJsDefault = parcelHelpers.interopDefault(_blendJs);
var _blindsJs = require("./icons/blinds.js");
var _blindsJsDefault = parcelHelpers.interopDefault(_blindsJs);
var _blocksJs = require("./icons/blocks.js");
var _blocksJsDefault = parcelHelpers.interopDefault(_blocksJs);
var _bluetoothConnectedJs = require("./icons/bluetooth-connected.js");
var _bluetoothConnectedJsDefault = parcelHelpers.interopDefault(_bluetoothConnectedJs);
var _bluetoothOffJs = require("./icons/bluetooth-off.js");
var _bluetoothOffJsDefault = parcelHelpers.interopDefault(_bluetoothOffJs);
var _bluetoothSearchingJs = require("./icons/bluetooth-searching.js");
var _bluetoothSearchingJsDefault = parcelHelpers.interopDefault(_bluetoothSearchingJs);
var _bluetoothJs = require("./icons/bluetooth.js");
var _bluetoothJsDefault = parcelHelpers.interopDefault(_bluetoothJs);
var _boldJs = require("./icons/bold.js");
var _boldJsDefault = parcelHelpers.interopDefault(_boldJs);
var _boltJs = require("./icons/bolt.js");
var _boltJsDefault = parcelHelpers.interopDefault(_boltJs);
var _bombJs = require("./icons/bomb.js");
var _bombJsDefault = parcelHelpers.interopDefault(_bombJs);
var _boneJs = require("./icons/bone.js");
var _boneJsDefault = parcelHelpers.interopDefault(_boneJs);
var _bookAJs = require("./icons/book-a.js");
var _bookAJsDefault = parcelHelpers.interopDefault(_bookAJs);
var _bookAlertJs = require("./icons/book-alert.js");
var _bookAlertJsDefault = parcelHelpers.interopDefault(_bookAlertJs);
var _bookAudioJs = require("./icons/book-audio.js");
var _bookAudioJsDefault = parcelHelpers.interopDefault(_bookAudioJs);
var _bookCheckJs = require("./icons/book-check.js");
var _bookCheckJsDefault = parcelHelpers.interopDefault(_bookCheckJs);
var _bookCopyJs = require("./icons/book-copy.js");
var _bookCopyJsDefault = parcelHelpers.interopDefault(_bookCopyJs);
var _bookDownJs = require("./icons/book-down.js");
var _bookDownJsDefault = parcelHelpers.interopDefault(_bookDownJs);
var _bookHeadphonesJs = require("./icons/book-headphones.js");
var _bookHeadphonesJsDefault = parcelHelpers.interopDefault(_bookHeadphonesJs);
var _bookHeartJs = require("./icons/book-heart.js");
var _bookHeartJsDefault = parcelHelpers.interopDefault(_bookHeartJs);
var _bookImageJs = require("./icons/book-image.js");
var _bookImageJsDefault = parcelHelpers.interopDefault(_bookImageJs);
var _bookKeyJs = require("./icons/book-key.js");
var _bookKeyJsDefault = parcelHelpers.interopDefault(_bookKeyJs);
var _bookLockJs = require("./icons/book-lock.js");
var _bookLockJsDefault = parcelHelpers.interopDefault(_bookLockJs);
var _bookMarkedJs = require("./icons/book-marked.js");
var _bookMarkedJsDefault = parcelHelpers.interopDefault(_bookMarkedJs);
var _bookMinusJs = require("./icons/book-minus.js");
var _bookMinusJsDefault = parcelHelpers.interopDefault(_bookMinusJs);
var _bookOpenCheckJs = require("./icons/book-open-check.js");
var _bookOpenCheckJsDefault = parcelHelpers.interopDefault(_bookOpenCheckJs);
var _bookOpenTextJs = require("./icons/book-open-text.js");
var _bookOpenTextJsDefault = parcelHelpers.interopDefault(_bookOpenTextJs);
var _bookOpenJs = require("./icons/book-open.js");
var _bookOpenJsDefault = parcelHelpers.interopDefault(_bookOpenJs);
var _bookPlusJs = require("./icons/book-plus.js");
var _bookPlusJsDefault = parcelHelpers.interopDefault(_bookPlusJs);
var _bookTextJs = require("./icons/book-text.js");
var _bookTextJsDefault = parcelHelpers.interopDefault(_bookTextJs);
var _bookUp2Js = require("./icons/book-up-2.js");
var _bookUp2JsDefault = parcelHelpers.interopDefault(_bookUp2Js);
var _bookTypeJs = require("./icons/book-type.js");
var _bookTypeJsDefault = parcelHelpers.interopDefault(_bookTypeJs);
var _bookUpJs = require("./icons/book-up.js");
var _bookUpJsDefault = parcelHelpers.interopDefault(_bookUpJs);
var _bookUserJs = require("./icons/book-user.js");
var _bookUserJsDefault = parcelHelpers.interopDefault(_bookUserJs);
var _bookXJs = require("./icons/book-x.js");
var _bookXJsDefault = parcelHelpers.interopDefault(_bookXJs);
var _bookJs = require("./icons/book.js");
var _bookJsDefault = parcelHelpers.interopDefault(_bookJs);
var _bookmarkMinusJs = require("./icons/bookmark-minus.js");
var _bookmarkMinusJsDefault = parcelHelpers.interopDefault(_bookmarkMinusJs);
var _bookmarkCheckJs = require("./icons/bookmark-check.js");
var _bookmarkCheckJsDefault = parcelHelpers.interopDefault(_bookmarkCheckJs);
var _bookmarkPlusJs = require("./icons/bookmark-plus.js");
var _bookmarkPlusJsDefault = parcelHelpers.interopDefault(_bookmarkPlusJs);
var _bookmarkXJs = require("./icons/bookmark-x.js");
var _bookmarkXJsDefault = parcelHelpers.interopDefault(_bookmarkXJs);
var _bookmarkJs = require("./icons/bookmark.js");
var _bookmarkJsDefault = parcelHelpers.interopDefault(_bookmarkJs);
var _boomBoxJs = require("./icons/boom-box.js");
var _boomBoxJsDefault = parcelHelpers.interopDefault(_boomBoxJs);
var _botMessageSquareJs = require("./icons/bot-message-square.js");
var _botMessageSquareJsDefault = parcelHelpers.interopDefault(_botMessageSquareJs);
var _botOffJs = require("./icons/bot-off.js");
var _botOffJsDefault = parcelHelpers.interopDefault(_botOffJs);
var _botJs = require("./icons/bot.js");
var _botJsDefault = parcelHelpers.interopDefault(_botJs);
var _bowArrowJs = require("./icons/bow-arrow.js");
var _bowArrowJsDefault = parcelHelpers.interopDefault(_bowArrowJs);
var _boxJs = require("./icons/box.js");
var _boxJsDefault = parcelHelpers.interopDefault(_boxJs);
var _boxesJs = require("./icons/boxes.js");
var _boxesJsDefault = parcelHelpers.interopDefault(_boxesJs);
var _bracketsJs = require("./icons/brackets.js");
var _bracketsJsDefault = parcelHelpers.interopDefault(_bracketsJs);
var _brainCircuitJs = require("./icons/brain-circuit.js");
var _brainCircuitJsDefault = parcelHelpers.interopDefault(_brainCircuitJs);
var _brainCogJs = require("./icons/brain-cog.js");
var _brainCogJsDefault = parcelHelpers.interopDefault(_brainCogJs);
var _brainJs = require("./icons/brain.js");
var _brainJsDefault = parcelHelpers.interopDefault(_brainJs);
var _brickWallJs = require("./icons/brick-wall.js");
var _brickWallJsDefault = parcelHelpers.interopDefault(_brickWallJs);
var _brickWallFireJs = require("./icons/brick-wall-fire.js");
var _brickWallFireJsDefault = parcelHelpers.interopDefault(_brickWallFireJs);
var _briefcaseBusinessJs = require("./icons/briefcase-business.js");
var _briefcaseBusinessJsDefault = parcelHelpers.interopDefault(_briefcaseBusinessJs);
var _briefcaseConveyorBeltJs = require("./icons/briefcase-conveyor-belt.js");
var _briefcaseConveyorBeltJsDefault = parcelHelpers.interopDefault(_briefcaseConveyorBeltJs);
var _briefcaseMedicalJs = require("./icons/briefcase-medical.js");
var _briefcaseMedicalJsDefault = parcelHelpers.interopDefault(_briefcaseMedicalJs);
var _briefcaseJs = require("./icons/briefcase.js");
var _briefcaseJsDefault = parcelHelpers.interopDefault(_briefcaseJs);
var _bringToFrontJs = require("./icons/bring-to-front.js");
var _bringToFrontJsDefault = parcelHelpers.interopDefault(_bringToFrontJs);
var _brushCleaningJs = require("./icons/brush-cleaning.js");
var _brushCleaningJsDefault = parcelHelpers.interopDefault(_brushCleaningJs);
var _brushJs = require("./icons/brush.js");
var _brushJsDefault = parcelHelpers.interopDefault(_brushJs);
var _bubblesJs = require("./icons/bubbles.js");
var _bubblesJsDefault = parcelHelpers.interopDefault(_bubblesJs);
var _bugOffJs = require("./icons/bug-off.js");
var _bugOffJsDefault = parcelHelpers.interopDefault(_bugOffJs);
var _bugPlayJs = require("./icons/bug-play.js");
var _bugPlayJsDefault = parcelHelpers.interopDefault(_bugPlayJs);
var _bugJs = require("./icons/bug.js");
var _bugJsDefault = parcelHelpers.interopDefault(_bugJs);
var _building2Js = require("./icons/building-2.js");
var _building2JsDefault = parcelHelpers.interopDefault(_building2Js);
var _buildingJs = require("./icons/building.js");
var _buildingJsDefault = parcelHelpers.interopDefault(_buildingJs);
var _busFrontJs = require("./icons/bus-front.js");
var _busFrontJsDefault = parcelHelpers.interopDefault(_busFrontJs);
var _busJs = require("./icons/bus.js");
var _busJsDefault = parcelHelpers.interopDefault(_busJs);
var _cableCarJs = require("./icons/cable-car.js");
var _cableCarJsDefault = parcelHelpers.interopDefault(_cableCarJs);
var _cableJs = require("./icons/cable.js");
var _cableJsDefault = parcelHelpers.interopDefault(_cableJs);
var _cakeSliceJs = require("./icons/cake-slice.js");
var _cakeSliceJsDefault = parcelHelpers.interopDefault(_cakeSliceJs);
var _cakeJs = require("./icons/cake.js");
var _cakeJsDefault = parcelHelpers.interopDefault(_cakeJs);
var _calculatorJs = require("./icons/calculator.js");
var _calculatorJsDefault = parcelHelpers.interopDefault(_calculatorJs);
var _calendar1Js = require("./icons/calendar-1.js");
var _calendar1JsDefault = parcelHelpers.interopDefault(_calendar1Js);
var _calendarArrowDownJs = require("./icons/calendar-arrow-down.js");
var _calendarArrowDownJsDefault = parcelHelpers.interopDefault(_calendarArrowDownJs);
var _calendarArrowUpJs = require("./icons/calendar-arrow-up.js");
var _calendarArrowUpJsDefault = parcelHelpers.interopDefault(_calendarArrowUpJs);
var _calendarCheck2Js = require("./icons/calendar-check-2.js");
var _calendarCheck2JsDefault = parcelHelpers.interopDefault(_calendarCheck2Js);
var _calendarCheckJs = require("./icons/calendar-check.js");
var _calendarCheckJsDefault = parcelHelpers.interopDefault(_calendarCheckJs);
var _calendarClockJs = require("./icons/calendar-clock.js");
var _calendarClockJsDefault = parcelHelpers.interopDefault(_calendarClockJs);
var _calendarDaysJs = require("./icons/calendar-days.js");
var _calendarDaysJsDefault = parcelHelpers.interopDefault(_calendarDaysJs);
var _calendarCogJs = require("./icons/calendar-cog.js");
var _calendarCogJsDefault = parcelHelpers.interopDefault(_calendarCogJs);
var _calendarFoldJs = require("./icons/calendar-fold.js");
var _calendarFoldJsDefault = parcelHelpers.interopDefault(_calendarFoldJs);
var _calendarHeartJs = require("./icons/calendar-heart.js");
var _calendarHeartJsDefault = parcelHelpers.interopDefault(_calendarHeartJs);
var _calendarMinus2Js = require("./icons/calendar-minus-2.js");
var _calendarMinus2JsDefault = parcelHelpers.interopDefault(_calendarMinus2Js);
var _calendarMinusJs = require("./icons/calendar-minus.js");
var _calendarMinusJsDefault = parcelHelpers.interopDefault(_calendarMinusJs);
var _calendarOffJs = require("./icons/calendar-off.js");
var _calendarOffJsDefault = parcelHelpers.interopDefault(_calendarOffJs);
var _calendarPlus2Js = require("./icons/calendar-plus-2.js");
var _calendarPlus2JsDefault = parcelHelpers.interopDefault(_calendarPlus2Js);
var _calendarPlusJs = require("./icons/calendar-plus.js");
var _calendarPlusJsDefault = parcelHelpers.interopDefault(_calendarPlusJs);
var _calendarRangeJs = require("./icons/calendar-range.js");
var _calendarRangeJsDefault = parcelHelpers.interopDefault(_calendarRangeJs);
var _calendarSearchJs = require("./icons/calendar-search.js");
var _calendarSearchJsDefault = parcelHelpers.interopDefault(_calendarSearchJs);
var _calendarX2Js = require("./icons/calendar-x-2.js");
var _calendarX2JsDefault = parcelHelpers.interopDefault(_calendarX2Js);
var _calendarSyncJs = require("./icons/calendar-sync.js");
var _calendarSyncJsDefault = parcelHelpers.interopDefault(_calendarSyncJs);
var _calendarXJs = require("./icons/calendar-x.js");
var _calendarXJsDefault = parcelHelpers.interopDefault(_calendarXJs);
var _calendarJs = require("./icons/calendar.js");
var _calendarJsDefault = parcelHelpers.interopDefault(_calendarJs);
var _cameraOffJs = require("./icons/camera-off.js");
var _cameraOffJsDefault = parcelHelpers.interopDefault(_cameraOffJs);
var _cameraJs = require("./icons/camera.js");
var _cameraJsDefault = parcelHelpers.interopDefault(_cameraJs);
var _candyCaneJs = require("./icons/candy-cane.js");
var _candyCaneJsDefault = parcelHelpers.interopDefault(_candyCaneJs);
var _candyOffJs = require("./icons/candy-off.js");
var _candyOffJsDefault = parcelHelpers.interopDefault(_candyOffJs);
var _cannabisJs = require("./icons/cannabis.js");
var _cannabisJsDefault = parcelHelpers.interopDefault(_cannabisJs);
var _candyJs = require("./icons/candy.js");
var _candyJsDefault = parcelHelpers.interopDefault(_candyJs);
var _captionsOffJs = require("./icons/captions-off.js");
var _captionsOffJsDefault = parcelHelpers.interopDefault(_captionsOffJs);
var _carFrontJs = require("./icons/car-front.js");
var _carFrontJsDefault = parcelHelpers.interopDefault(_carFrontJs);
var _carJs = require("./icons/car.js");
var _carJsDefault = parcelHelpers.interopDefault(_carJs);
var _carTaxiFrontJs = require("./icons/car-taxi-front.js");
var _carTaxiFrontJsDefault = parcelHelpers.interopDefault(_carTaxiFrontJs);
var _caravanJs = require("./icons/caravan.js");
var _caravanJsDefault = parcelHelpers.interopDefault(_caravanJs);
var _cardSimJs = require("./icons/card-sim.js");
var _cardSimJsDefault = parcelHelpers.interopDefault(_cardSimJs);
var _carrotJs = require("./icons/carrot.js");
var _carrotJsDefault = parcelHelpers.interopDefault(_carrotJs);
var _caseLowerJs = require("./icons/case-lower.js");
var _caseLowerJsDefault = parcelHelpers.interopDefault(_caseLowerJs);
var _caseSensitiveJs = require("./icons/case-sensitive.js");
var _caseSensitiveJsDefault = parcelHelpers.interopDefault(_caseSensitiveJs);
var _caseUpperJs = require("./icons/case-upper.js");
var _caseUpperJsDefault = parcelHelpers.interopDefault(_caseUpperJs);
var _cassetteTapeJs = require("./icons/cassette-tape.js");
var _cassetteTapeJsDefault = parcelHelpers.interopDefault(_cassetteTapeJs);
var _castJs = require("./icons/cast.js");
var _castJsDefault = parcelHelpers.interopDefault(_castJs);
var _castleJs = require("./icons/castle.js");
var _castleJsDefault = parcelHelpers.interopDefault(_castleJs);
var _catJs = require("./icons/cat.js");
var _catJsDefault = parcelHelpers.interopDefault(_catJs);
var _cctvJs = require("./icons/cctv.js");
var _cctvJsDefault = parcelHelpers.interopDefault(_cctvJs);
var _chartBarDecreasingJs = require("./icons/chart-bar-decreasing.js");
var _chartBarDecreasingJsDefault = parcelHelpers.interopDefault(_chartBarDecreasingJs);
var _chartBarIncreasingJs = require("./icons/chart-bar-increasing.js");
var _chartBarIncreasingJsDefault = parcelHelpers.interopDefault(_chartBarIncreasingJs);
var _chartBarStackedJs = require("./icons/chart-bar-stacked.js");
var _chartBarStackedJsDefault = parcelHelpers.interopDefault(_chartBarStackedJs);
var _chartColumnDecreasingJs = require("./icons/chart-column-decreasing.js");
var _chartColumnDecreasingJsDefault = parcelHelpers.interopDefault(_chartColumnDecreasingJs);
var _chartColumnStackedJs = require("./icons/chart-column-stacked.js");
var _chartColumnStackedJsDefault = parcelHelpers.interopDefault(_chartColumnStackedJs);
var _chartGanttJs = require("./icons/chart-gantt.js");
var _chartGanttJsDefault = parcelHelpers.interopDefault(_chartGanttJs);
var _chartNetworkJs = require("./icons/chart-network.js");
var _chartNetworkJsDefault = parcelHelpers.interopDefault(_chartNetworkJs);
var _chartNoAxesColumnDecreasingJs = require("./icons/chart-no-axes-column-decreasing.js");
var _chartNoAxesColumnDecreasingJsDefault = parcelHelpers.interopDefault(_chartNoAxesColumnDecreasingJs);
var _chartNoAxesCombinedJs = require("./icons/chart-no-axes-combined.js");
var _chartNoAxesCombinedJsDefault = parcelHelpers.interopDefault(_chartNoAxesCombinedJs);
var _chartSplineJs = require("./icons/chart-spline.js");
var _chartSplineJsDefault = parcelHelpers.interopDefault(_chartSplineJs);
var _checkCheckJs = require("./icons/check-check.js");
var _checkCheckJsDefault = parcelHelpers.interopDefault(_checkCheckJs);
var _checkLineJs = require("./icons/check-line.js");
var _checkLineJsDefault = parcelHelpers.interopDefault(_checkLineJs);
var _checkJs = require("./icons/check.js");
var _checkJsDefault = parcelHelpers.interopDefault(_checkJs);
var _chefHatJs = require("./icons/chef-hat.js");
var _chefHatJsDefault = parcelHelpers.interopDefault(_chefHatJs);
var _cherryJs = require("./icons/cherry.js");
var _cherryJsDefault = parcelHelpers.interopDefault(_cherryJs);
var _chevronDownJs = require("./icons/chevron-down.js");
var _chevronDownJsDefault = parcelHelpers.interopDefault(_chevronDownJs);
var _chevronFirstJs = require("./icons/chevron-first.js");
var _chevronFirstJsDefault = parcelHelpers.interopDefault(_chevronFirstJs);
var _chevronLastJs = require("./icons/chevron-last.js");
var _chevronLastJsDefault = parcelHelpers.interopDefault(_chevronLastJs);
var _chevronLeftJs = require("./icons/chevron-left.js");
var _chevronLeftJsDefault = parcelHelpers.interopDefault(_chevronLeftJs);
var _chevronRightJs = require("./icons/chevron-right.js");
var _chevronRightJsDefault = parcelHelpers.interopDefault(_chevronRightJs);
var _chevronUpJs = require("./icons/chevron-up.js");
var _chevronUpJsDefault = parcelHelpers.interopDefault(_chevronUpJs);
var _chevronsDownUpJs = require("./icons/chevrons-down-up.js");
var _chevronsDownUpJsDefault = parcelHelpers.interopDefault(_chevronsDownUpJs);
var _chevronsDownJs = require("./icons/chevrons-down.js");
var _chevronsDownJsDefault = parcelHelpers.interopDefault(_chevronsDownJs);
var _chevronsLeftRightEllipsisJs = require("./icons/chevrons-left-right-ellipsis.js");
var _chevronsLeftRightEllipsisJsDefault = parcelHelpers.interopDefault(_chevronsLeftRightEllipsisJs);
var _chevronsLeftRightJs = require("./icons/chevrons-left-right.js");
var _chevronsLeftRightJsDefault = parcelHelpers.interopDefault(_chevronsLeftRightJs);
var _chevronsLeftJs = require("./icons/chevrons-left.js");
var _chevronsLeftJsDefault = parcelHelpers.interopDefault(_chevronsLeftJs);
var _chevronsRightLeftJs = require("./icons/chevrons-right-left.js");
var _chevronsRightLeftJsDefault = parcelHelpers.interopDefault(_chevronsRightLeftJs);
var _chevronsRightJs = require("./icons/chevrons-right.js");
var _chevronsRightJsDefault = parcelHelpers.interopDefault(_chevronsRightJs);
var _chevronsUpDownJs = require("./icons/chevrons-up-down.js");
var _chevronsUpDownJsDefault = parcelHelpers.interopDefault(_chevronsUpDownJs);
var _chevronsUpJs = require("./icons/chevrons-up.js");
var _chevronsUpJsDefault = parcelHelpers.interopDefault(_chevronsUpJs);
var _chromeJs = require("./icons/chrome.js");
var _chromeJsDefault = parcelHelpers.interopDefault(_chromeJs);
var _churchJs = require("./icons/church.js");
var _churchJsDefault = parcelHelpers.interopDefault(_churchJs);
var _cigaretteJs = require("./icons/cigarette.js");
var _cigaretteJsDefault = parcelHelpers.interopDefault(_cigaretteJs);
var _cigaretteOffJs = require("./icons/cigarette-off.js");
var _cigaretteOffJsDefault = parcelHelpers.interopDefault(_cigaretteOffJs);
var _circleDashedJs = require("./icons/circle-dashed.js");
var _circleDashedJsDefault = parcelHelpers.interopDefault(_circleDashedJs);
var _circleDollarSignJs = require("./icons/circle-dollar-sign.js");
var _circleDollarSignJsDefault = parcelHelpers.interopDefault(_circleDollarSignJs);
var _circleDotDashedJs = require("./icons/circle-dot-dashed.js");
var _circleDotDashedJsDefault = parcelHelpers.interopDefault(_circleDotDashedJs);
var _circleDotJs = require("./icons/circle-dot.js");
var _circleDotJsDefault = parcelHelpers.interopDefault(_circleDotJs);
var _circleEllipsisJs = require("./icons/circle-ellipsis.js");
var _circleEllipsisJsDefault = parcelHelpers.interopDefault(_circleEllipsisJs);
var _circleEqualJs = require("./icons/circle-equal.js");
var _circleEqualJsDefault = parcelHelpers.interopDefault(_circleEqualJs);
var _circleFadingArrowUpJs = require("./icons/circle-fading-arrow-up.js");
var _circleFadingArrowUpJsDefault = parcelHelpers.interopDefault(_circleFadingArrowUpJs);
var _circleFadingPlusJs = require("./icons/circle-fading-plus.js");
var _circleFadingPlusJsDefault = parcelHelpers.interopDefault(_circleFadingPlusJs);
var _circleOffJs = require("./icons/circle-off.js");
var _circleOffJsDefault = parcelHelpers.interopDefault(_circleOffJs);
var _circlePoundSterlingJs = require("./icons/circle-pound-sterling.js");
var _circlePoundSterlingJsDefault = parcelHelpers.interopDefault(_circlePoundSterlingJs);
var _circleSlashJs = require("./icons/circle-slash.js");
var _circleSlashJsDefault = parcelHelpers.interopDefault(_circleSlashJs);
var _circleSmallJs = require("./icons/circle-small.js");
var _circleSmallJsDefault = parcelHelpers.interopDefault(_circleSmallJs);
var _circleJs = require("./icons/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _circuitBoardJs = require("./icons/circuit-board.js");
var _circuitBoardJsDefault = parcelHelpers.interopDefault(_circuitBoardJs);
var _citrusJs = require("./icons/citrus.js");
var _citrusJsDefault = parcelHelpers.interopDefault(_citrusJs);
var _clapperboardJs = require("./icons/clapperboard.js");
var _clapperboardJsDefault = parcelHelpers.interopDefault(_clapperboardJs);
var _clipboardCheckJs = require("./icons/clipboard-check.js");
var _clipboardCheckJsDefault = parcelHelpers.interopDefault(_clipboardCheckJs);
var _clipboardCopyJs = require("./icons/clipboard-copy.js");
var _clipboardCopyJsDefault = parcelHelpers.interopDefault(_clipboardCopyJs);
var _clipboardListJs = require("./icons/clipboard-list.js");
var _clipboardListJsDefault = parcelHelpers.interopDefault(_clipboardListJs);
var _clipboardMinusJs = require("./icons/clipboard-minus.js");
var _clipboardMinusJsDefault = parcelHelpers.interopDefault(_clipboardMinusJs);
var _clipboardPasteJs = require("./icons/clipboard-paste.js");
var _clipboardPasteJsDefault = parcelHelpers.interopDefault(_clipboardPasteJs);
var _clipboardPlusJs = require("./icons/clipboard-plus.js");
var _clipboardPlusJsDefault = parcelHelpers.interopDefault(_clipboardPlusJs);
var _clipboardTypeJs = require("./icons/clipboard-type.js");
var _clipboardTypeJsDefault = parcelHelpers.interopDefault(_clipboardTypeJs);
var _clipboardXJs = require("./icons/clipboard-x.js");
var _clipboardXJsDefault = parcelHelpers.interopDefault(_clipboardXJs);
var _clipboardJs = require("./icons/clipboard.js");
var _clipboardJsDefault = parcelHelpers.interopDefault(_clipboardJs);
var _clock1Js = require("./icons/clock-1.js");
var _clock1JsDefault = parcelHelpers.interopDefault(_clock1Js);
var _clock10Js = require("./icons/clock-10.js");
var _clock10JsDefault = parcelHelpers.interopDefault(_clock10Js);
var _clock11Js = require("./icons/clock-11.js");
var _clock11JsDefault = parcelHelpers.interopDefault(_clock11Js);
var _clock12Js = require("./icons/clock-12.js");
var _clock12JsDefault = parcelHelpers.interopDefault(_clock12Js);
var _clock2Js = require("./icons/clock-2.js");
var _clock2JsDefault = parcelHelpers.interopDefault(_clock2Js);
var _clock4Js = require("./icons/clock-4.js");
var _clock4JsDefault = parcelHelpers.interopDefault(_clock4Js);
var _clock3Js = require("./icons/clock-3.js");
var _clock3JsDefault = parcelHelpers.interopDefault(_clock3Js);
var _clock5Js = require("./icons/clock-5.js");
var _clock5JsDefault = parcelHelpers.interopDefault(_clock5Js);
var _clock6Js = require("./icons/clock-6.js");
var _clock6JsDefault = parcelHelpers.interopDefault(_clock6Js);
var _clock7Js = require("./icons/clock-7.js");
var _clock7JsDefault = parcelHelpers.interopDefault(_clock7Js);
var _clock8Js = require("./icons/clock-8.js");
var _clock8JsDefault = parcelHelpers.interopDefault(_clock8Js);
var _clockAlertJs = require("./icons/clock-alert.js");
var _clockAlertJsDefault = parcelHelpers.interopDefault(_clockAlertJs);
var _clock9Js = require("./icons/clock-9.js");
var _clock9JsDefault = parcelHelpers.interopDefault(_clock9Js);
var _clockArrowDownJs = require("./icons/clock-arrow-down.js");
var _clockArrowDownJsDefault = parcelHelpers.interopDefault(_clockArrowDownJs);
var _clockArrowUpJs = require("./icons/clock-arrow-up.js");
var _clockArrowUpJsDefault = parcelHelpers.interopDefault(_clockArrowUpJs);
var _clockFadingJs = require("./icons/clock-fading.js");
var _clockFadingJsDefault = parcelHelpers.interopDefault(_clockFadingJs);
var _clockPlusJs = require("./icons/clock-plus.js");
var _clockPlusJsDefault = parcelHelpers.interopDefault(_clockPlusJs);
var _clockJs = require("./icons/clock.js");
var _clockJsDefault = parcelHelpers.interopDefault(_clockJs);
var _cloudAlertJs = require("./icons/cloud-alert.js");
var _cloudAlertJsDefault = parcelHelpers.interopDefault(_cloudAlertJs);
var _cloudCheckJs = require("./icons/cloud-check.js");
var _cloudCheckJsDefault = parcelHelpers.interopDefault(_cloudCheckJs);
var _cloudCogJs = require("./icons/cloud-cog.js");
var _cloudCogJsDefault = parcelHelpers.interopDefault(_cloudCogJs);
var _cloudDrizzleJs = require("./icons/cloud-drizzle.js");
var _cloudDrizzleJsDefault = parcelHelpers.interopDefault(_cloudDrizzleJs);
var _cloudFogJs = require("./icons/cloud-fog.js");
var _cloudFogJsDefault = parcelHelpers.interopDefault(_cloudFogJs);
var _cloudHailJs = require("./icons/cloud-hail.js");
var _cloudHailJsDefault = parcelHelpers.interopDefault(_cloudHailJs);
var _cloudMoonRainJs = require("./icons/cloud-moon-rain.js");
var _cloudMoonRainJsDefault = parcelHelpers.interopDefault(_cloudMoonRainJs);
var _cloudLightningJs = require("./icons/cloud-lightning.js");
var _cloudLightningJsDefault = parcelHelpers.interopDefault(_cloudLightningJs);
var _cloudMoonJs = require("./icons/cloud-moon.js");
var _cloudMoonJsDefault = parcelHelpers.interopDefault(_cloudMoonJs);
var _cloudOffJs = require("./icons/cloud-off.js");
var _cloudOffJsDefault = parcelHelpers.interopDefault(_cloudOffJs);
var _cloudRainWindJs = require("./icons/cloud-rain-wind.js");
var _cloudRainWindJsDefault = parcelHelpers.interopDefault(_cloudRainWindJs);
var _cloudRainJs = require("./icons/cloud-rain.js");
var _cloudRainJsDefault = parcelHelpers.interopDefault(_cloudRainJs);
var _cloudSnowJs = require("./icons/cloud-snow.js");
var _cloudSnowJsDefault = parcelHelpers.interopDefault(_cloudSnowJs);
var _cloudSunRainJs = require("./icons/cloud-sun-rain.js");
var _cloudSunRainJsDefault = parcelHelpers.interopDefault(_cloudSunRainJs);
var _cloudSunJs = require("./icons/cloud-sun.js");
var _cloudSunJsDefault = parcelHelpers.interopDefault(_cloudSunJs);
var _cloudJs = require("./icons/cloud.js");
var _cloudJsDefault = parcelHelpers.interopDefault(_cloudJs);
var _cloudyJs = require("./icons/cloudy.js");
var _cloudyJsDefault = parcelHelpers.interopDefault(_cloudyJs);
var _cloverJs = require("./icons/clover.js");
var _cloverJsDefault = parcelHelpers.interopDefault(_cloverJs);
var _clubJs = require("./icons/club.js");
var _clubJsDefault = parcelHelpers.interopDefault(_clubJs);
var _codeJs = require("./icons/code.js");
var _codeJsDefault = parcelHelpers.interopDefault(_codeJs);
var _codepenJs = require("./icons/codepen.js");
var _codepenJsDefault = parcelHelpers.interopDefault(_codepenJs);
var _codesandboxJs = require("./icons/codesandbox.js");
var _codesandboxJsDefault = parcelHelpers.interopDefault(_codesandboxJs);
var _coffeeJs = require("./icons/coffee.js");
var _coffeeJsDefault = parcelHelpers.interopDefault(_coffeeJs);
var _cogJs = require("./icons/cog.js");
var _cogJsDefault = parcelHelpers.interopDefault(_cogJs);
var _coinsJs = require("./icons/coins.js");
var _coinsJsDefault = parcelHelpers.interopDefault(_coinsJs);
var _columns4Js = require("./icons/columns-4.js");
var _columns4JsDefault = parcelHelpers.interopDefault(_columns4Js);
var _combineJs = require("./icons/combine.js");
var _combineJsDefault = parcelHelpers.interopDefault(_combineJs);
var _commandJs = require("./icons/command.js");
var _commandJsDefault = parcelHelpers.interopDefault(_commandJs);
var _compassJs = require("./icons/compass.js");
var _compassJsDefault = parcelHelpers.interopDefault(_compassJs);
var _componentJs = require("./icons/component.js");
var _componentJsDefault = parcelHelpers.interopDefault(_componentJs);
var _conciergeBellJs = require("./icons/concierge-bell.js");
var _conciergeBellJsDefault = parcelHelpers.interopDefault(_conciergeBellJs);
var _computerJs = require("./icons/computer.js");
var _computerJsDefault = parcelHelpers.interopDefault(_computerJs);
var _coneJs = require("./icons/cone.js");
var _coneJsDefault = parcelHelpers.interopDefault(_coneJs);
var _constructionJs = require("./icons/construction.js");
var _constructionJsDefault = parcelHelpers.interopDefault(_constructionJs);
var _contactJs = require("./icons/contact.js");
var _contactJsDefault = parcelHelpers.interopDefault(_contactJs);
var _containerJs = require("./icons/container.js");
var _containerJsDefault = parcelHelpers.interopDefault(_containerJs);
var _contrastJs = require("./icons/contrast.js");
var _contrastJsDefault = parcelHelpers.interopDefault(_contrastJs);
var _cookieJs = require("./icons/cookie.js");
var _cookieJsDefault = parcelHelpers.interopDefault(_cookieJs);
var _cookingPotJs = require("./icons/cooking-pot.js");
var _cookingPotJsDefault = parcelHelpers.interopDefault(_cookingPotJs);
var _copyCheckJs = require("./icons/copy-check.js");
var _copyCheckJsDefault = parcelHelpers.interopDefault(_copyCheckJs);
var _copyMinusJs = require("./icons/copy-minus.js");
var _copyMinusJsDefault = parcelHelpers.interopDefault(_copyMinusJs);
var _copyPlusJs = require("./icons/copy-plus.js");
var _copyPlusJsDefault = parcelHelpers.interopDefault(_copyPlusJs);
var _copySlashJs = require("./icons/copy-slash.js");
var _copySlashJsDefault = parcelHelpers.interopDefault(_copySlashJs);
var _copyXJs = require("./icons/copy-x.js");
var _copyXJsDefault = parcelHelpers.interopDefault(_copyXJs);
var _copyJs = require("./icons/copy.js");
var _copyJsDefault = parcelHelpers.interopDefault(_copyJs);
var _copyrightJs = require("./icons/copyright.js");
var _copyrightJsDefault = parcelHelpers.interopDefault(_copyrightJs);
var _copyleftJs = require("./icons/copyleft.js");
var _copyleftJsDefault = parcelHelpers.interopDefault(_copyleftJs);
var _cornerDownLeftJs = require("./icons/corner-down-left.js");
var _cornerDownLeftJsDefault = parcelHelpers.interopDefault(_cornerDownLeftJs);
var _cornerDownRightJs = require("./icons/corner-down-right.js");
var _cornerDownRightJsDefault = parcelHelpers.interopDefault(_cornerDownRightJs);
var _cornerLeftDownJs = require("./icons/corner-left-down.js");
var _cornerLeftDownJsDefault = parcelHelpers.interopDefault(_cornerLeftDownJs);
var _cornerLeftUpJs = require("./icons/corner-left-up.js");
var _cornerLeftUpJsDefault = parcelHelpers.interopDefault(_cornerLeftUpJs);
var _cornerRightUpJs = require("./icons/corner-right-up.js");
var _cornerRightUpJsDefault = parcelHelpers.interopDefault(_cornerRightUpJs);
var _cornerUpLeftJs = require("./icons/corner-up-left.js");
var _cornerUpLeftJsDefault = parcelHelpers.interopDefault(_cornerUpLeftJs);
var _cornerRightDownJs = require("./icons/corner-right-down.js");
var _cornerRightDownJsDefault = parcelHelpers.interopDefault(_cornerRightDownJs);
var _cornerUpRightJs = require("./icons/corner-up-right.js");
var _cornerUpRightJsDefault = parcelHelpers.interopDefault(_cornerUpRightJs);
var _creativeCommonsJs = require("./icons/creative-commons.js");
var _creativeCommonsJsDefault = parcelHelpers.interopDefault(_creativeCommonsJs);
var _cpuJs = require("./icons/cpu.js");
var _cpuJsDefault = parcelHelpers.interopDefault(_cpuJs);
var _croissantJs = require("./icons/croissant.js");
var _croissantJsDefault = parcelHelpers.interopDefault(_croissantJs);
var _creditCardJs = require("./icons/credit-card.js");
var _creditCardJsDefault = parcelHelpers.interopDefault(_creditCardJs);
var _cropJs = require("./icons/crop.js");
var _cropJsDefault = parcelHelpers.interopDefault(_cropJs);
var _crossJs = require("./icons/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _crosshairJs = require("./icons/crosshair.js");
var _crosshairJsDefault = parcelHelpers.interopDefault(_crosshairJs);
var _crownJs = require("./icons/crown.js");
var _crownJsDefault = parcelHelpers.interopDefault(_crownJs);
var _cuboidJs = require("./icons/cuboid.js");
var _cuboidJsDefault = parcelHelpers.interopDefault(_cuboidJs);
var _cupSodaJs = require("./icons/cup-soda.js");
var _cupSodaJsDefault = parcelHelpers.interopDefault(_cupSodaJs);
var _currencyJs = require("./icons/currency.js");
var _currencyJsDefault = parcelHelpers.interopDefault(_currencyJs);
var _cylinderJs = require("./icons/cylinder.js");
var _cylinderJsDefault = parcelHelpers.interopDefault(_cylinderJs);
var _damJs = require("./icons/dam.js");
var _damJsDefault = parcelHelpers.interopDefault(_damJs);
var _databaseBackupJs = require("./icons/database-backup.js");
var _databaseBackupJsDefault = parcelHelpers.interopDefault(_databaseBackupJs);
var _databaseZapJs = require("./icons/database-zap.js");
var _databaseZapJsDefault = parcelHelpers.interopDefault(_databaseZapJs);
var _databaseJs = require("./icons/database.js");
var _databaseJsDefault = parcelHelpers.interopDefault(_databaseJs);
var _decimalsArrowLeftJs = require("./icons/decimals-arrow-left.js");
var _decimalsArrowLeftJsDefault = parcelHelpers.interopDefault(_decimalsArrowLeftJs);
var _decimalsArrowRightJs = require("./icons/decimals-arrow-right.js");
var _decimalsArrowRightJsDefault = parcelHelpers.interopDefault(_decimalsArrowRightJs);
var _deleteJs = require("./icons/delete.js");
var _deleteJsDefault = parcelHelpers.interopDefault(_deleteJs);
var _dessertJs = require("./icons/dessert.js");
var _dessertJsDefault = parcelHelpers.interopDefault(_dessertJs);
var _diameterJs = require("./icons/diameter.js");
var _diameterJsDefault = parcelHelpers.interopDefault(_diameterJs);
var _diamondMinusJs = require("./icons/diamond-minus.js");
var _diamondMinusJsDefault = parcelHelpers.interopDefault(_diamondMinusJs);
var _diamondJs = require("./icons/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _diamondPlusJs = require("./icons/diamond-plus.js");
var _diamondPlusJsDefault = parcelHelpers.interopDefault(_diamondPlusJs);
var _dice1Js = require("./icons/dice-1.js");
var _dice1JsDefault = parcelHelpers.interopDefault(_dice1Js);
var _dice2Js = require("./icons/dice-2.js");
var _dice2JsDefault = parcelHelpers.interopDefault(_dice2Js);
var _dice3Js = require("./icons/dice-3.js");
var _dice3JsDefault = parcelHelpers.interopDefault(_dice3Js);
var _dice4Js = require("./icons/dice-4.js");
var _dice4JsDefault = parcelHelpers.interopDefault(_dice4Js);
var _dice5Js = require("./icons/dice-5.js");
var _dice5JsDefault = parcelHelpers.interopDefault(_dice5Js);
var _dice6Js = require("./icons/dice-6.js");
var _dice6JsDefault = parcelHelpers.interopDefault(_dice6Js);
var _dicesJs = require("./icons/dices.js");
var _dicesJsDefault = parcelHelpers.interopDefault(_dicesJs);
var _diffJs = require("./icons/diff.js");
var _diffJsDefault = parcelHelpers.interopDefault(_diffJs);
var _disc2Js = require("./icons/disc-2.js");
var _disc2JsDefault = parcelHelpers.interopDefault(_disc2Js);
var _disc3Js = require("./icons/disc-3.js");
var _disc3JsDefault = parcelHelpers.interopDefault(_disc3Js);
var _discAlbumJs = require("./icons/disc-album.js");
var _discAlbumJsDefault = parcelHelpers.interopDefault(_discAlbumJs);
var _divideJs = require("./icons/divide.js");
var _divideJsDefault = parcelHelpers.interopDefault(_divideJs);
var _discJs = require("./icons/disc.js");
var _discJsDefault = parcelHelpers.interopDefault(_discJs);
var _dnaOffJs = require("./icons/dna-off.js");
var _dnaOffJsDefault = parcelHelpers.interopDefault(_dnaOffJs);
var _dnaJs = require("./icons/dna.js");
var _dnaJsDefault = parcelHelpers.interopDefault(_dnaJs);
var _dockJs = require("./icons/dock.js");
var _dockJsDefault = parcelHelpers.interopDefault(_dockJs);
var _dogJs = require("./icons/dog.js");
var _dogJsDefault = parcelHelpers.interopDefault(_dogJs);
var _dollarSignJs = require("./icons/dollar-sign.js");
var _dollarSignJsDefault = parcelHelpers.interopDefault(_dollarSignJs);
var _donutJs = require("./icons/donut.js");
var _donutJsDefault = parcelHelpers.interopDefault(_donutJs);
var _doorClosedLockedJs = require("./icons/door-closed-locked.js");
var _doorClosedLockedJsDefault = parcelHelpers.interopDefault(_doorClosedLockedJs);
var _doorClosedJs = require("./icons/door-closed.js");
var _doorClosedJsDefault = parcelHelpers.interopDefault(_doorClosedJs);
var _doorOpenJs = require("./icons/door-open.js");
var _doorOpenJsDefault = parcelHelpers.interopDefault(_doorOpenJs);
var _dotJs = require("./icons/dot.js");
var _dotJsDefault = parcelHelpers.interopDefault(_dotJs);
var _downloadJs = require("./icons/download.js");
var _downloadJsDefault = parcelHelpers.interopDefault(_downloadJs);
var _draftingCompassJs = require("./icons/drafting-compass.js");
var _draftingCompassJsDefault = parcelHelpers.interopDefault(_draftingCompassJs);
var _dramaJs = require("./icons/drama.js");
var _dramaJsDefault = parcelHelpers.interopDefault(_dramaJs);
var _dribbbleJs = require("./icons/dribbble.js");
var _dribbbleJsDefault = parcelHelpers.interopDefault(_dribbbleJs);
var _dropletOffJs = require("./icons/droplet-off.js");
var _dropletOffJsDefault = parcelHelpers.interopDefault(_dropletOffJs);
var _dropletJs = require("./icons/droplet.js");
var _dropletJsDefault = parcelHelpers.interopDefault(_dropletJs);
var _drillJs = require("./icons/drill.js");
var _drillJsDefault = parcelHelpers.interopDefault(_drillJs);
var _dropletsJs = require("./icons/droplets.js");
var _dropletsJsDefault = parcelHelpers.interopDefault(_dropletsJs);
var _drumJs = require("./icons/drum.js");
var _drumJsDefault = parcelHelpers.interopDefault(_drumJs);
var _drumstickJs = require("./icons/drumstick.js");
var _drumstickJsDefault = parcelHelpers.interopDefault(_drumstickJs);
var _dumbbellJs = require("./icons/dumbbell.js");
var _dumbbellJsDefault = parcelHelpers.interopDefault(_dumbbellJs);
var _earOffJs = require("./icons/ear-off.js");
var _earOffJsDefault = parcelHelpers.interopDefault(_earOffJs);
var _earJs = require("./icons/ear.js");
var _earJsDefault = parcelHelpers.interopDefault(_earJs);
var _earthLockJs = require("./icons/earth-lock.js");
var _earthLockJsDefault = parcelHelpers.interopDefault(_earthLockJs);
var _eclipseJs = require("./icons/eclipse.js");
var _eclipseJsDefault = parcelHelpers.interopDefault(_eclipseJs);
var _eggFriedJs = require("./icons/egg-fried.js");
var _eggFriedJsDefault = parcelHelpers.interopDefault(_eggFriedJs);
var _eggOffJs = require("./icons/egg-off.js");
var _eggOffJsDefault = parcelHelpers.interopDefault(_eggOffJs);
var _eggJs = require("./icons/egg.js");
var _eggJsDefault = parcelHelpers.interopDefault(_eggJs);
var _equalApproximatelyJs = require("./icons/equal-approximately.js");
var _equalApproximatelyJsDefault = parcelHelpers.interopDefault(_equalApproximatelyJs);
var _equalNotJs = require("./icons/equal-not.js");
var _equalNotJsDefault = parcelHelpers.interopDefault(_equalNotJs);
var _equalJs = require("./icons/equal.js");
var _equalJsDefault = parcelHelpers.interopDefault(_equalJs);
var _eraserJs = require("./icons/eraser.js");
var _eraserJsDefault = parcelHelpers.interopDefault(_eraserJs);
var _ethernetPortJs = require("./icons/ethernet-port.js");
var _ethernetPortJsDefault = parcelHelpers.interopDefault(_ethernetPortJs);
var _euroJs = require("./icons/euro.js");
var _euroJsDefault = parcelHelpers.interopDefault(_euroJs);
var _expandJs = require("./icons/expand.js");
var _expandJsDefault = parcelHelpers.interopDefault(_expandJs);
var _externalLinkJs = require("./icons/external-link.js");
var _externalLinkJsDefault = parcelHelpers.interopDefault(_externalLinkJs);
var _eyeOffJs = require("./icons/eye-off.js");
var _eyeOffJsDefault = parcelHelpers.interopDefault(_eyeOffJs);
var _eyeClosedJs = require("./icons/eye-closed.js");
var _eyeClosedJsDefault = parcelHelpers.interopDefault(_eyeClosedJs);
var _eyeJs = require("./icons/eye.js");
var _eyeJsDefault = parcelHelpers.interopDefault(_eyeJs);
var _factoryJs = require("./icons/factory.js");
var _factoryJsDefault = parcelHelpers.interopDefault(_factoryJs);
var _facebookJs = require("./icons/facebook.js");
var _facebookJsDefault = parcelHelpers.interopDefault(_facebookJs);
var _fanJs = require("./icons/fan.js");
var _fanJsDefault = parcelHelpers.interopDefault(_fanJs);
var _fastForwardJs = require("./icons/fast-forward.js");
var _fastForwardJsDefault = parcelHelpers.interopDefault(_fastForwardJs);
var _featherJs = require("./icons/feather.js");
var _featherJsDefault = parcelHelpers.interopDefault(_featherJs);
var _fenceJs = require("./icons/fence.js");
var _fenceJsDefault = parcelHelpers.interopDefault(_fenceJs);
var _figmaJs = require("./icons/figma.js");
var _figmaJsDefault = parcelHelpers.interopDefault(_figmaJs);
var _ferrisWheelJs = require("./icons/ferris-wheel.js");
var _ferrisWheelJsDefault = parcelHelpers.interopDefault(_ferrisWheelJs);
var _fileArchiveJs = require("./icons/file-archive.js");
var _fileArchiveJsDefault = parcelHelpers.interopDefault(_fileArchiveJs);
var _fileAudio2Js = require("./icons/file-audio-2.js");
var _fileAudio2JsDefault = parcelHelpers.interopDefault(_fileAudio2Js);
var _fileAudioJs = require("./icons/file-audio.js");
var _fileAudioJsDefault = parcelHelpers.interopDefault(_fileAudioJs);
var _fileBadge2Js = require("./icons/file-badge-2.js");
var _fileBadge2JsDefault = parcelHelpers.interopDefault(_fileBadge2Js);
var _fileBadgeJs = require("./icons/file-badge.js");
var _fileBadgeJsDefault = parcelHelpers.interopDefault(_fileBadgeJs);
var _fileBoxJs = require("./icons/file-box.js");
var _fileBoxJsDefault = parcelHelpers.interopDefault(_fileBoxJs);
var _fileCheck2Js = require("./icons/file-check-2.js");
var _fileCheck2JsDefault = parcelHelpers.interopDefault(_fileCheck2Js);
var _fileCheckJs = require("./icons/file-check.js");
var _fileCheckJsDefault = parcelHelpers.interopDefault(_fileCheckJs);
var _fileClockJs = require("./icons/file-clock.js");
var _fileClockJsDefault = parcelHelpers.interopDefault(_fileClockJs);
var _fileCode2Js = require("./icons/file-code-2.js");
var _fileCode2JsDefault = parcelHelpers.interopDefault(_fileCode2Js);
var _fileCodeJs = require("./icons/file-code.js");
var _fileCodeJsDefault = parcelHelpers.interopDefault(_fileCodeJs);
var _fileDiffJs = require("./icons/file-diff.js");
var _fileDiffJsDefault = parcelHelpers.interopDefault(_fileDiffJs);
var _fileDigitJs = require("./icons/file-digit.js");
var _fileDigitJsDefault = parcelHelpers.interopDefault(_fileDigitJs);
var _fileDownJs = require("./icons/file-down.js");
var _fileDownJsDefault = parcelHelpers.interopDefault(_fileDownJs);
var _fileHeartJs = require("./icons/file-heart.js");
var _fileHeartJsDefault = parcelHelpers.interopDefault(_fileHeartJs);
var _fileImageJs = require("./icons/file-image.js");
var _fileImageJsDefault = parcelHelpers.interopDefault(_fileImageJs);
var _fileInputJs = require("./icons/file-input.js");
var _fileInputJsDefault = parcelHelpers.interopDefault(_fileInputJs);
var _fileJson2Js = require("./icons/file-json-2.js");
var _fileJson2JsDefault = parcelHelpers.interopDefault(_fileJson2Js);
var _fileJsonJs = require("./icons/file-json.js");
var _fileJsonJsDefault = parcelHelpers.interopDefault(_fileJsonJs);
var _fileKey2Js = require("./icons/file-key-2.js");
var _fileKey2JsDefault = parcelHelpers.interopDefault(_fileKey2Js);
var _fileKeyJs = require("./icons/file-key.js");
var _fileKeyJsDefault = parcelHelpers.interopDefault(_fileKeyJs);
var _fileLock2Js = require("./icons/file-lock-2.js");
var _fileLock2JsDefault = parcelHelpers.interopDefault(_fileLock2Js);
var _fileLockJs = require("./icons/file-lock.js");
var _fileLockJsDefault = parcelHelpers.interopDefault(_fileLockJs);
var _fileMinus2Js = require("./icons/file-minus-2.js");
var _fileMinus2JsDefault = parcelHelpers.interopDefault(_fileMinus2Js);
var _fileMinusJs = require("./icons/file-minus.js");
var _fileMinusJsDefault = parcelHelpers.interopDefault(_fileMinusJs);
var _fileMusicJs = require("./icons/file-music.js");
var _fileMusicJsDefault = parcelHelpers.interopDefault(_fileMusicJs);
var _fileOutputJs = require("./icons/file-output.js");
var _fileOutputJsDefault = parcelHelpers.interopDefault(_fileOutputJs);
var _filePlus2Js = require("./icons/file-plus-2.js");
var _filePlus2JsDefault = parcelHelpers.interopDefault(_filePlus2Js);
var _filePlusJs = require("./icons/file-plus.js");
var _filePlusJsDefault = parcelHelpers.interopDefault(_filePlusJs);
var _fileQuestionJs = require("./icons/file-question.js");
var _fileQuestionJsDefault = parcelHelpers.interopDefault(_fileQuestionJs);
var _fileScanJs = require("./icons/file-scan.js");
var _fileScanJsDefault = parcelHelpers.interopDefault(_fileScanJs);
var _fileSearch2Js = require("./icons/file-search-2.js");
var _fileSearch2JsDefault = parcelHelpers.interopDefault(_fileSearch2Js);
var _fileSearchJs = require("./icons/file-search.js");
var _fileSearchJsDefault = parcelHelpers.interopDefault(_fileSearchJs);
var _fileSlidersJs = require("./icons/file-sliders.js");
var _fileSlidersJsDefault = parcelHelpers.interopDefault(_fileSlidersJs);
var _fileSpreadsheetJs = require("./icons/file-spreadsheet.js");
var _fileSpreadsheetJsDefault = parcelHelpers.interopDefault(_fileSpreadsheetJs);
var _fileStackJs = require("./icons/file-stack.js");
var _fileStackJsDefault = parcelHelpers.interopDefault(_fileStackJs);
var _fileSymlinkJs = require("./icons/file-symlink.js");
var _fileSymlinkJsDefault = parcelHelpers.interopDefault(_fileSymlinkJs);
var _fileTerminalJs = require("./icons/file-terminal.js");
var _fileTerminalJsDefault = parcelHelpers.interopDefault(_fileTerminalJs);
var _fileTextJs = require("./icons/file-text.js");
var _fileTextJsDefault = parcelHelpers.interopDefault(_fileTextJs);
var _fileType2Js = require("./icons/file-type-2.js");
var _fileType2JsDefault = parcelHelpers.interopDefault(_fileType2Js);
var _fileUpJs = require("./icons/file-up.js");
var _fileUpJsDefault = parcelHelpers.interopDefault(_fileUpJs);
var _fileTypeJs = require("./icons/file-type.js");
var _fileTypeJsDefault = parcelHelpers.interopDefault(_fileTypeJs);
var _fileUserJs = require("./icons/file-user.js");
var _fileUserJsDefault = parcelHelpers.interopDefault(_fileUserJs);
var _fileVideo2Js = require("./icons/file-video-2.js");
var _fileVideo2JsDefault = parcelHelpers.interopDefault(_fileVideo2Js);
var _fileVideoJs = require("./icons/file-video.js");
var _fileVideoJsDefault = parcelHelpers.interopDefault(_fileVideoJs);
var _fileVolume2Js = require("./icons/file-volume-2.js");
var _fileVolume2JsDefault = parcelHelpers.interopDefault(_fileVolume2Js);
var _fileVolumeJs = require("./icons/file-volume.js");
var _fileVolumeJsDefault = parcelHelpers.interopDefault(_fileVolumeJs);
var _fileWarningJs = require("./icons/file-warning.js");
var _fileWarningJsDefault = parcelHelpers.interopDefault(_fileWarningJs);
var _fileXJs = require("./icons/file-x.js");
var _fileXJsDefault = parcelHelpers.interopDefault(_fileXJs);
var _fileX2Js = require("./icons/file-x-2.js");
var _fileX2JsDefault = parcelHelpers.interopDefault(_fileX2Js);
var _filesJs = require("./icons/files.js");
var _filesJsDefault = parcelHelpers.interopDefault(_filesJs);
var _fileJs = require("./icons/file.js");
var _fileJsDefault = parcelHelpers.interopDefault(_fileJs);
var _filmJs = require("./icons/film.js");
var _filmJsDefault = parcelHelpers.interopDefault(_filmJs);
var _fingerprintJs = require("./icons/fingerprint.js");
var _fingerprintJsDefault = parcelHelpers.interopDefault(_fingerprintJs);
var _fireExtinguisherJs = require("./icons/fire-extinguisher.js");
var _fireExtinguisherJsDefault = parcelHelpers.interopDefault(_fireExtinguisherJs);
var _fishOffJs = require("./icons/fish-off.js");
var _fishOffJsDefault = parcelHelpers.interopDefault(_fishOffJs);
var _fishSymbolJs = require("./icons/fish-symbol.js");
var _fishSymbolJsDefault = parcelHelpers.interopDefault(_fishSymbolJs);
var _fishJs = require("./icons/fish.js");
var _fishJsDefault = parcelHelpers.interopDefault(_fishJs);
var _flagOffJs = require("./icons/flag-off.js");
var _flagOffJsDefault = parcelHelpers.interopDefault(_flagOffJs);
var _flagTriangleLeftJs = require("./icons/flag-triangle-left.js");
var _flagTriangleLeftJsDefault = parcelHelpers.interopDefault(_flagTriangleLeftJs);
var _flagTriangleRightJs = require("./icons/flag-triangle-right.js");
var _flagTriangleRightJsDefault = parcelHelpers.interopDefault(_flagTriangleRightJs);
var _flagJs = require("./icons/flag.js");
var _flagJsDefault = parcelHelpers.interopDefault(_flagJs);
var _flameKindlingJs = require("./icons/flame-kindling.js");
var _flameKindlingJsDefault = parcelHelpers.interopDefault(_flameKindlingJs);
var _flameJs = require("./icons/flame.js");
var _flameJsDefault = parcelHelpers.interopDefault(_flameJs);
var _flashlightJs = require("./icons/flashlight.js");
var _flashlightJsDefault = parcelHelpers.interopDefault(_flashlightJs);
var _flaskConicalOffJs = require("./icons/flask-conical-off.js");
var _flaskConicalOffJsDefault = parcelHelpers.interopDefault(_flaskConicalOffJs);
var _flashlightOffJs = require("./icons/flashlight-off.js");
var _flashlightOffJsDefault = parcelHelpers.interopDefault(_flashlightOffJs);
var _flaskConicalJs = require("./icons/flask-conical.js");
var _flaskConicalJsDefault = parcelHelpers.interopDefault(_flaskConicalJs);
var _flaskRoundJs = require("./icons/flask-round.js");
var _flaskRoundJsDefault = parcelHelpers.interopDefault(_flaskRoundJs);
var _flipHorizontal2Js = require("./icons/flip-horizontal-2.js");
var _flipHorizontal2JsDefault = parcelHelpers.interopDefault(_flipHorizontal2Js);
var _flipHorizontalJs = require("./icons/flip-horizontal.js");
var _flipHorizontalJsDefault = parcelHelpers.interopDefault(_flipHorizontalJs);
var _flipVertical2Js = require("./icons/flip-vertical-2.js");
var _flipVertical2JsDefault = parcelHelpers.interopDefault(_flipVertical2Js);
var _flipVerticalJs = require("./icons/flip-vertical.js");
var _flipVerticalJsDefault = parcelHelpers.interopDefault(_flipVerticalJs);
var _flower2Js = require("./icons/flower-2.js");
var _flower2JsDefault = parcelHelpers.interopDefault(_flower2Js);
var _flowerJs = require("./icons/flower.js");
var _flowerJsDefault = parcelHelpers.interopDefault(_flowerJs);
var _focusJs = require("./icons/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _foldHorizontalJs = require("./icons/fold-horizontal.js");
var _foldHorizontalJsDefault = parcelHelpers.interopDefault(_foldHorizontalJs);
var _foldVerticalJs = require("./icons/fold-vertical.js");
var _foldVerticalJsDefault = parcelHelpers.interopDefault(_foldVerticalJs);
var _folderArchiveJs = require("./icons/folder-archive.js");
var _folderArchiveJsDefault = parcelHelpers.interopDefault(_folderArchiveJs);
var _folderCheckJs = require("./icons/folder-check.js");
var _folderCheckJsDefault = parcelHelpers.interopDefault(_folderCheckJs);
var _folderClockJs = require("./icons/folder-clock.js");
var _folderClockJsDefault = parcelHelpers.interopDefault(_folderClockJs);
var _folderClosedJs = require("./icons/folder-closed.js");
var _folderClosedJsDefault = parcelHelpers.interopDefault(_folderClosedJs);
var _folderCodeJs = require("./icons/folder-code.js");
var _folderCodeJsDefault = parcelHelpers.interopDefault(_folderCodeJs);
var _folderDotJs = require("./icons/folder-dot.js");
var _folderDotJsDefault = parcelHelpers.interopDefault(_folderDotJs);
var _folderDownJs = require("./icons/folder-down.js");
var _folderDownJsDefault = parcelHelpers.interopDefault(_folderDownJs);
var _folderGit2Js = require("./icons/folder-git-2.js");
var _folderGit2JsDefault = parcelHelpers.interopDefault(_folderGit2Js);
var _folderGitJs = require("./icons/folder-git.js");
var _folderGitJsDefault = parcelHelpers.interopDefault(_folderGitJs);
var _folderHeartJs = require("./icons/folder-heart.js");
var _folderHeartJsDefault = parcelHelpers.interopDefault(_folderHeartJs);
var _folderInputJs = require("./icons/folder-input.js");
var _folderInputJsDefault = parcelHelpers.interopDefault(_folderInputJs);
var _folderKanbanJs = require("./icons/folder-kanban.js");
var _folderKanbanJsDefault = parcelHelpers.interopDefault(_folderKanbanJs);
var _folderKeyJs = require("./icons/folder-key.js");
var _folderKeyJsDefault = parcelHelpers.interopDefault(_folderKeyJs);
var _folderLockJs = require("./icons/folder-lock.js");
var _folderLockJsDefault = parcelHelpers.interopDefault(_folderLockJs);
var _folderMinusJs = require("./icons/folder-minus.js");
var _folderMinusJsDefault = parcelHelpers.interopDefault(_folderMinusJs);
var _folderOpenDotJs = require("./icons/folder-open-dot.js");
var _folderOpenDotJsDefault = parcelHelpers.interopDefault(_folderOpenDotJs);
var _folderOpenJs = require("./icons/folder-open.js");
var _folderOpenJsDefault = parcelHelpers.interopDefault(_folderOpenJs);
var _folderOutputJs = require("./icons/folder-output.js");
var _folderOutputJsDefault = parcelHelpers.interopDefault(_folderOutputJs);
var _folderPlusJs = require("./icons/folder-plus.js");
var _folderPlusJsDefault = parcelHelpers.interopDefault(_folderPlusJs);
var _folderRootJs = require("./icons/folder-root.js");
var _folderRootJsDefault = parcelHelpers.interopDefault(_folderRootJs);
var _folderSearch2Js = require("./icons/folder-search-2.js");
var _folderSearch2JsDefault = parcelHelpers.interopDefault(_folderSearch2Js);
var _folderSearchJs = require("./icons/folder-search.js");
var _folderSearchJsDefault = parcelHelpers.interopDefault(_folderSearchJs);
var _folderSymlinkJs = require("./icons/folder-symlink.js");
var _folderSymlinkJsDefault = parcelHelpers.interopDefault(_folderSymlinkJs);
var _folderSyncJs = require("./icons/folder-sync.js");
var _folderSyncJsDefault = parcelHelpers.interopDefault(_folderSyncJs);
var _folderTreeJs = require("./icons/folder-tree.js");
var _folderTreeJsDefault = parcelHelpers.interopDefault(_folderTreeJs);
var _folderUpJs = require("./icons/folder-up.js");
var _folderUpJsDefault = parcelHelpers.interopDefault(_folderUpJs);
var _folderXJs = require("./icons/folder-x.js");
var _folderXJsDefault = parcelHelpers.interopDefault(_folderXJs);
var _folderJs = require("./icons/folder.js");
var _folderJsDefault = parcelHelpers.interopDefault(_folderJs);
var _foldersJs = require("./icons/folders.js");
var _foldersJsDefault = parcelHelpers.interopDefault(_foldersJs);
var _footprintsJs = require("./icons/footprints.js");
var _footprintsJsDefault = parcelHelpers.interopDefault(_footprintsJs);
var _forkliftJs = require("./icons/forklift.js");
var _forkliftJsDefault = parcelHelpers.interopDefault(_forkliftJs);
var _forwardJs = require("./icons/forward.js");
var _forwardJsDefault = parcelHelpers.interopDefault(_forwardJs);
var _frameJs = require("./icons/frame.js");
var _frameJsDefault = parcelHelpers.interopDefault(_frameJs);
var _framerJs = require("./icons/framer.js");
var _framerJsDefault = parcelHelpers.interopDefault(_framerJs);
var _fuelJs = require("./icons/fuel.js");
var _fuelJsDefault = parcelHelpers.interopDefault(_fuelJs);
var _fullscreenJs = require("./icons/fullscreen.js");
var _fullscreenJsDefault = parcelHelpers.interopDefault(_fullscreenJs);
var _frownJs = require("./icons/frown.js");
var _frownJsDefault = parcelHelpers.interopDefault(_frownJs);
var _funnelPlusJs = require("./icons/funnel-plus.js");
var _funnelPlusJsDefault = parcelHelpers.interopDefault(_funnelPlusJs);
var _galleryHorizontalEndJs = require("./icons/gallery-horizontal-end.js");
var _galleryHorizontalEndJsDefault = parcelHelpers.interopDefault(_galleryHorizontalEndJs);
var _galleryHorizontalJs = require("./icons/gallery-horizontal.js");
var _galleryHorizontalJsDefault = parcelHelpers.interopDefault(_galleryHorizontalJs);
var _galleryThumbnailsJs = require("./icons/gallery-thumbnails.js");
var _galleryThumbnailsJsDefault = parcelHelpers.interopDefault(_galleryThumbnailsJs);
var _galleryVerticalEndJs = require("./icons/gallery-vertical-end.js");
var _galleryVerticalEndJsDefault = parcelHelpers.interopDefault(_galleryVerticalEndJs);
var _galleryVerticalJs = require("./icons/gallery-vertical.js");
var _galleryVerticalJsDefault = parcelHelpers.interopDefault(_galleryVerticalJs);
var _gamepad2Js = require("./icons/gamepad-2.js");
var _gamepad2JsDefault = parcelHelpers.interopDefault(_gamepad2Js);
var _gamepadJs = require("./icons/gamepad.js");
var _gamepadJsDefault = parcelHelpers.interopDefault(_gamepadJs);
var _gaugeJs = require("./icons/gauge.js");
var _gaugeJsDefault = parcelHelpers.interopDefault(_gaugeJs);
var _gavelJs = require("./icons/gavel.js");
var _gavelJsDefault = parcelHelpers.interopDefault(_gavelJs);
var _gemJs = require("./icons/gem.js");
var _gemJsDefault = parcelHelpers.interopDefault(_gemJs);
var _giftJs = require("./icons/gift.js");
var _giftJsDefault = parcelHelpers.interopDefault(_giftJs);
var _ghostJs = require("./icons/ghost.js");
var _ghostJsDefault = parcelHelpers.interopDefault(_ghostJs);
var _gitBranchPlusJs = require("./icons/git-branch-plus.js");
var _gitBranchPlusJsDefault = parcelHelpers.interopDefault(_gitBranchPlusJs);
var _gitBranchJs = require("./icons/git-branch.js");
var _gitBranchJsDefault = parcelHelpers.interopDefault(_gitBranchJs);
var _gitCommitVerticalJs = require("./icons/git-commit-vertical.js");
var _gitCommitVerticalJsDefault = parcelHelpers.interopDefault(_gitCommitVerticalJs);
var _gitCompareArrowsJs = require("./icons/git-compare-arrows.js");
var _gitCompareArrowsJsDefault = parcelHelpers.interopDefault(_gitCompareArrowsJs);
var _gitCompareJs = require("./icons/git-compare.js");
var _gitCompareJsDefault = parcelHelpers.interopDefault(_gitCompareJs);
var _gitForkJs = require("./icons/git-fork.js");
var _gitForkJsDefault = parcelHelpers.interopDefault(_gitForkJs);
var _gitGraphJs = require("./icons/git-graph.js");
var _gitGraphJsDefault = parcelHelpers.interopDefault(_gitGraphJs);
var _gitMergeJs = require("./icons/git-merge.js");
var _gitMergeJsDefault = parcelHelpers.interopDefault(_gitMergeJs);
var _gitPullRequestArrowJs = require("./icons/git-pull-request-arrow.js");
var _gitPullRequestArrowJsDefault = parcelHelpers.interopDefault(_gitPullRequestArrowJs);
var _gitPullRequestClosedJs = require("./icons/git-pull-request-closed.js");
var _gitPullRequestClosedJsDefault = parcelHelpers.interopDefault(_gitPullRequestClosedJs);
var _gitPullRequestCreateArrowJs = require("./icons/git-pull-request-create-arrow.js");
var _gitPullRequestCreateArrowJsDefault = parcelHelpers.interopDefault(_gitPullRequestCreateArrowJs);
var _gitPullRequestCreateJs = require("./icons/git-pull-request-create.js");
var _gitPullRequestCreateJsDefault = parcelHelpers.interopDefault(_gitPullRequestCreateJs);
var _gitPullRequestDraftJs = require("./icons/git-pull-request-draft.js");
var _gitPullRequestDraftJsDefault = parcelHelpers.interopDefault(_gitPullRequestDraftJs);
var _gitPullRequestJs = require("./icons/git-pull-request.js");
var _gitPullRequestJsDefault = parcelHelpers.interopDefault(_gitPullRequestJs);
var _githubJs = require("./icons/github.js");
var _githubJsDefault = parcelHelpers.interopDefault(_githubJs);
var _gitlabJs = require("./icons/gitlab.js");
var _gitlabJsDefault = parcelHelpers.interopDefault(_gitlabJs);
var _glassWaterJs = require("./icons/glass-water.js");
var _glassWaterJsDefault = parcelHelpers.interopDefault(_glassWaterJs);
var _glassesJs = require("./icons/glasses.js");
var _glassesJsDefault = parcelHelpers.interopDefault(_glassesJs);
var _globeLockJs = require("./icons/globe-lock.js");
var _globeLockJsDefault = parcelHelpers.interopDefault(_globeLockJs);
var _globeJs = require("./icons/globe.js");
var _globeJsDefault = parcelHelpers.interopDefault(_globeJs);
var _goalJs = require("./icons/goal.js");
var _goalJsDefault = parcelHelpers.interopDefault(_goalJs);
var _gpuJs = require("./icons/gpu.js");
var _gpuJsDefault = parcelHelpers.interopDefault(_gpuJs);
var _grabJs = require("./icons/grab.js");
var _grabJsDefault = parcelHelpers.interopDefault(_grabJs);
var _graduationCapJs = require("./icons/graduation-cap.js");
var _graduationCapJsDefault = parcelHelpers.interopDefault(_graduationCapJs);
var _grapeJs = require("./icons/grape.js");
var _grapeJsDefault = parcelHelpers.interopDefault(_grapeJs);
var _grid3X2Js = require("./icons/grid-3x2.js");
var _grid3X2JsDefault = parcelHelpers.interopDefault(_grid3X2Js);
var _gripHorizontalJs = require("./icons/grip-horizontal.js");
var _gripHorizontalJsDefault = parcelHelpers.interopDefault(_gripHorizontalJs);
var _gripVerticalJs = require("./icons/grip-vertical.js");
var _gripVerticalJsDefault = parcelHelpers.interopDefault(_gripVerticalJs);
var _gripJs = require("./icons/grip.js");
var _gripJsDefault = parcelHelpers.interopDefault(_gripJs);
var _groupJs = require("./icons/group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _guitarJs = require("./icons/guitar.js");
var _guitarJsDefault = parcelHelpers.interopDefault(_guitarJs);
var _hamJs = require("./icons/ham.js");
var _hamJsDefault = parcelHelpers.interopDefault(_hamJs);
var _hamburgerJs = require("./icons/hamburger.js");
var _hamburgerJsDefault = parcelHelpers.interopDefault(_hamburgerJs);
var _hammerJs = require("./icons/hammer.js");
var _hammerJsDefault = parcelHelpers.interopDefault(_hammerJs);
var _handCoinsJs = require("./icons/hand-coins.js");
var _handCoinsJsDefault = parcelHelpers.interopDefault(_handCoinsJs);
var _handHeartJs = require("./icons/hand-heart.js");
var _handHeartJsDefault = parcelHelpers.interopDefault(_handHeartJs);
var _handMetalJs = require("./icons/hand-metal.js");
var _handMetalJsDefault = parcelHelpers.interopDefault(_handMetalJs);
var _handPlatterJs = require("./icons/hand-platter.js");
var _handPlatterJsDefault = parcelHelpers.interopDefault(_handPlatterJs);
var _handJs = require("./icons/hand.js");
var _handJsDefault = parcelHelpers.interopDefault(_handJs);
var _handshakeJs = require("./icons/handshake.js");
var _handshakeJsDefault = parcelHelpers.interopDefault(_handshakeJs);
var _hardDriveDownloadJs = require("./icons/hard-drive-download.js");
var _hardDriveDownloadJsDefault = parcelHelpers.interopDefault(_hardDriveDownloadJs);
var _hardDriveUploadJs = require("./icons/hard-drive-upload.js");
var _hardDriveUploadJsDefault = parcelHelpers.interopDefault(_hardDriveUploadJs);
var _hardDriveJs = require("./icons/hard-drive.js");
var _hardDriveJsDefault = parcelHelpers.interopDefault(_hardDriveJs);
var _hashJs = require("./icons/hash.js");
var _hashJsDefault = parcelHelpers.interopDefault(_hashJs);
var _hardHatJs = require("./icons/hard-hat.js");
var _hardHatJsDefault = parcelHelpers.interopDefault(_hardHatJs);
var _hazeJs = require("./icons/haze.js");
var _hazeJsDefault = parcelHelpers.interopDefault(_hazeJs);
var _hdmiPortJs = require("./icons/hdmi-port.js");
var _hdmiPortJsDefault = parcelHelpers.interopDefault(_hdmiPortJs);
var _heading1Js = require("./icons/heading-1.js");
var _heading1JsDefault = parcelHelpers.interopDefault(_heading1Js);
var _heading2Js = require("./icons/heading-2.js");
var _heading2JsDefault = parcelHelpers.interopDefault(_heading2Js);
var _heading3Js = require("./icons/heading-3.js");
var _heading3JsDefault = parcelHelpers.interopDefault(_heading3Js);
var _heading4Js = require("./icons/heading-4.js");
var _heading4JsDefault = parcelHelpers.interopDefault(_heading4Js);
var _heading5Js = require("./icons/heading-5.js");
var _heading5JsDefault = parcelHelpers.interopDefault(_heading5Js);
var _heading6Js = require("./icons/heading-6.js");
var _heading6JsDefault = parcelHelpers.interopDefault(_heading6Js);
var _headingJs = require("./icons/heading.js");
var _headingJsDefault = parcelHelpers.interopDefault(_headingJs);
var _headphoneOffJs = require("./icons/headphone-off.js");
var _headphoneOffJsDefault = parcelHelpers.interopDefault(_headphoneOffJs);
var _headphonesJs = require("./icons/headphones.js");
var _headphonesJsDefault = parcelHelpers.interopDefault(_headphonesJs);
var _headsetJs = require("./icons/headset.js");
var _headsetJsDefault = parcelHelpers.interopDefault(_headsetJs);
var _heartCrackJs = require("./icons/heart-crack.js");
var _heartCrackJsDefault = parcelHelpers.interopDefault(_heartCrackJs);
var _heartHandshakeJs = require("./icons/heart-handshake.js");
var _heartHandshakeJsDefault = parcelHelpers.interopDefault(_heartHandshakeJs);
var _heartMinusJs = require("./icons/heart-minus.js");
var _heartMinusJsDefault = parcelHelpers.interopDefault(_heartMinusJs);
var _heartOffJs = require("./icons/heart-off.js");
var _heartOffJsDefault = parcelHelpers.interopDefault(_heartOffJs);
var _heartPlusJs = require("./icons/heart-plus.js");
var _heartPlusJsDefault = parcelHelpers.interopDefault(_heartPlusJs);
var _heartPulseJs = require("./icons/heart-pulse.js");
var _heartPulseJsDefault = parcelHelpers.interopDefault(_heartPulseJs);
var _heartJs = require("./icons/heart.js");
var _heartJsDefault = parcelHelpers.interopDefault(_heartJs);
var _heaterJs = require("./icons/heater.js");
var _heaterJsDefault = parcelHelpers.interopDefault(_heaterJs);
var _hexagonJs = require("./icons/hexagon.js");
var _hexagonJsDefault = parcelHelpers.interopDefault(_hexagonJs);
var _highlighterJs = require("./icons/highlighter.js");
var _highlighterJsDefault = parcelHelpers.interopDefault(_highlighterJs);
var _historyJs = require("./icons/history.js");
var _historyJsDefault = parcelHelpers.interopDefault(_historyJs);
var _hopOffJs = require("./icons/hop-off.js");
var _hopOffJsDefault = parcelHelpers.interopDefault(_hopOffJs);
var _hopJs = require("./icons/hop.js");
var _hopJsDefault = parcelHelpers.interopDefault(_hopJs);
var _hospitalJs = require("./icons/hospital.js");
var _hospitalJsDefault = parcelHelpers.interopDefault(_hospitalJs);
var _hotelJs = require("./icons/hotel.js");
var _hotelJsDefault = parcelHelpers.interopDefault(_hotelJs);
var _hourglassJs = require("./icons/hourglass.js");
var _hourglassJsDefault = parcelHelpers.interopDefault(_hourglassJs);
var _housePlugJs = require("./icons/house-plug.js");
var _housePlugJsDefault = parcelHelpers.interopDefault(_housePlugJs);
var _housePlusJs = require("./icons/house-plus.js");
var _housePlusJsDefault = parcelHelpers.interopDefault(_housePlusJs);
var _houseWifiJs = require("./icons/house-wifi.js");
var _houseWifiJsDefault = parcelHelpers.interopDefault(_houseWifiJs);
var _idCardLanyardJs = require("./icons/id-card-lanyard.js");
var _idCardLanyardJsDefault = parcelHelpers.interopDefault(_idCardLanyardJs);
var _idCardJs = require("./icons/id-card.js");
var _idCardJsDefault = parcelHelpers.interopDefault(_idCardJs);
var _imageDownJs = require("./icons/image-down.js");
var _imageDownJsDefault = parcelHelpers.interopDefault(_imageDownJs);
var _imageMinusJs = require("./icons/image-minus.js");
var _imageMinusJsDefault = parcelHelpers.interopDefault(_imageMinusJs);
var _imageOffJs = require("./icons/image-off.js");
var _imageOffJsDefault = parcelHelpers.interopDefault(_imageOffJs);
var _imagePlayJs = require("./icons/image-play.js");
var _imagePlayJsDefault = parcelHelpers.interopDefault(_imagePlayJs);
var _imagePlusJs = require("./icons/image-plus.js");
var _imagePlusJsDefault = parcelHelpers.interopDefault(_imagePlusJs);
var _imageUpJs = require("./icons/image-up.js");
var _imageUpJsDefault = parcelHelpers.interopDefault(_imageUpJs);
var _imageUpscaleJs = require("./icons/image-upscale.js");
var _imageUpscaleJsDefault = parcelHelpers.interopDefault(_imageUpscaleJs);
var _imageJs = require("./icons/image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs);
var _imagesJs = require("./icons/images.js");
var _imagesJsDefault = parcelHelpers.interopDefault(_imagesJs);
var _importJs = require("./icons/import.js");
var _importJsDefault = parcelHelpers.interopDefault(_importJs);
var _inboxJs = require("./icons/inbox.js");
var _inboxJsDefault = parcelHelpers.interopDefault(_inboxJs);
var _indianRupeeJs = require("./icons/indian-rupee.js");
var _indianRupeeJsDefault = parcelHelpers.interopDefault(_indianRupeeJs);
var _infinityJs = require("./icons/infinity.js");
var _infinityJsDefault = parcelHelpers.interopDefault(_infinityJs);
var _infoJs = require("./icons/info.js");
var _infoJsDefault = parcelHelpers.interopDefault(_infoJs);
var _inspectionPanelJs = require("./icons/inspection-panel.js");
var _inspectionPanelJsDefault = parcelHelpers.interopDefault(_inspectionPanelJs);
var _instagramJs = require("./icons/instagram.js");
var _instagramJsDefault = parcelHelpers.interopDefault(_instagramJs);
var _italicJs = require("./icons/italic.js");
var _italicJsDefault = parcelHelpers.interopDefault(_italicJs);
var _iterationCcwJs = require("./icons/iteration-ccw.js");
var _iterationCcwJsDefault = parcelHelpers.interopDefault(_iterationCcwJs);
var _iterationCwJs = require("./icons/iteration-cw.js");
var _iterationCwJsDefault = parcelHelpers.interopDefault(_iterationCwJs);
var _japaneseYenJs = require("./icons/japanese-yen.js");
var _japaneseYenJsDefault = parcelHelpers.interopDefault(_japaneseYenJs);
var _joystickJs = require("./icons/joystick.js");
var _joystickJsDefault = parcelHelpers.interopDefault(_joystickJs);
var _kanbanJs = require("./icons/kanban.js");
var _kanbanJsDefault = parcelHelpers.interopDefault(_kanbanJs);
var _keyRoundJs = require("./icons/key-round.js");
var _keyRoundJsDefault = parcelHelpers.interopDefault(_keyRoundJs);
var _keySquareJs = require("./icons/key-square.js");
var _keySquareJsDefault = parcelHelpers.interopDefault(_keySquareJs);
var _keyJs = require("./icons/key.js");
var _keyJsDefault = parcelHelpers.interopDefault(_keyJs);
var _keyboardOffJs = require("./icons/keyboard-off.js");
var _keyboardOffJsDefault = parcelHelpers.interopDefault(_keyboardOffJs);
var _keyboardMusicJs = require("./icons/keyboard-music.js");
var _keyboardMusicJsDefault = parcelHelpers.interopDefault(_keyboardMusicJs);
var _keyboardJs = require("./icons/keyboard.js");
var _keyboardJsDefault = parcelHelpers.interopDefault(_keyboardJs);
var _lampCeilingJs = require("./icons/lamp-ceiling.js");
var _lampCeilingJsDefault = parcelHelpers.interopDefault(_lampCeilingJs);
var _lampDeskJs = require("./icons/lamp-desk.js");
var _lampDeskJsDefault = parcelHelpers.interopDefault(_lampDeskJs);
var _lampFloorJs = require("./icons/lamp-floor.js");
var _lampFloorJsDefault = parcelHelpers.interopDefault(_lampFloorJs);
var _lampWallDownJs = require("./icons/lamp-wall-down.js");
var _lampWallDownJsDefault = parcelHelpers.interopDefault(_lampWallDownJs);
var _lampWallUpJs = require("./icons/lamp-wall-up.js");
var _lampWallUpJsDefault = parcelHelpers.interopDefault(_lampWallUpJs);
var _lampJs = require("./icons/lamp.js");
var _lampJsDefault = parcelHelpers.interopDefault(_lampJs);
var _landPlotJs = require("./icons/land-plot.js");
var _landPlotJsDefault = parcelHelpers.interopDefault(_landPlotJs);
var _landmarkJs = require("./icons/landmark.js");
var _landmarkJsDefault = parcelHelpers.interopDefault(_landmarkJs);
var _languagesJs = require("./icons/languages.js");
var _languagesJsDefault = parcelHelpers.interopDefault(_languagesJs);
var _laptopMinimalCheckJs = require("./icons/laptop-minimal-check.js");
var _laptopMinimalCheckJsDefault = parcelHelpers.interopDefault(_laptopMinimalCheckJs);
var _laptopJs = require("./icons/laptop.js");
var _laptopJsDefault = parcelHelpers.interopDefault(_laptopJs);
var _lassoSelectJs = require("./icons/lasso-select.js");
var _lassoSelectJsDefault = parcelHelpers.interopDefault(_lassoSelectJs);
var _lassoJs = require("./icons/lasso.js");
var _lassoJsDefault = parcelHelpers.interopDefault(_lassoJs);
var _laughJs = require("./icons/laugh.js");
var _laughJsDefault = parcelHelpers.interopDefault(_laughJs);
var _layers2Js = require("./icons/layers-2.js");
var _layers2JsDefault = parcelHelpers.interopDefault(_layers2Js);
var _layoutDashboardJs = require("./icons/layout-dashboard.js");
var _layoutDashboardJsDefault = parcelHelpers.interopDefault(_layoutDashboardJs);
var _layoutGridJs = require("./icons/layout-grid.js");
var _layoutGridJsDefault = parcelHelpers.interopDefault(_layoutGridJs);
var _layoutListJs = require("./icons/layout-list.js");
var _layoutListJsDefault = parcelHelpers.interopDefault(_layoutListJs);
var _layoutPanelLeftJs = require("./icons/layout-panel-left.js");
var _layoutPanelLeftJsDefault = parcelHelpers.interopDefault(_layoutPanelLeftJs);
var _layoutPanelTopJs = require("./icons/layout-panel-top.js");
var _layoutPanelTopJsDefault = parcelHelpers.interopDefault(_layoutPanelTopJs);
var _leafyGreenJs = require("./icons/leafy-green.js");
var _leafyGreenJsDefault = parcelHelpers.interopDefault(_leafyGreenJs);
var _layoutTemplateJs = require("./icons/layout-template.js");
var _layoutTemplateJsDefault = parcelHelpers.interopDefault(_layoutTemplateJs);
var _leafJs = require("./icons/leaf.js");
var _leafJsDefault = parcelHelpers.interopDefault(_leafJs);
var _lecternJs = require("./icons/lectern.js");
var _lecternJsDefault = parcelHelpers.interopDefault(_lecternJs);
var _letterTextJs = require("./icons/letter-text.js");
var _letterTextJsDefault = parcelHelpers.interopDefault(_letterTextJs);
var _libraryBigJs = require("./icons/library-big.js");
var _libraryBigJsDefault = parcelHelpers.interopDefault(_libraryBigJs);
var _libraryJs = require("./icons/library.js");
var _libraryJsDefault = parcelHelpers.interopDefault(_libraryJs);
var _lifeBuoyJs = require("./icons/life-buoy.js");
var _lifeBuoyJsDefault = parcelHelpers.interopDefault(_lifeBuoyJs);
var _ligatureJs = require("./icons/ligature.js");
var _ligatureJsDefault = parcelHelpers.interopDefault(_ligatureJs);
var _lightbulbOffJs = require("./icons/lightbulb-off.js");
var _lightbulbOffJsDefault = parcelHelpers.interopDefault(_lightbulbOffJs);
var _lightbulbJs = require("./icons/lightbulb.js");
var _lightbulbJsDefault = parcelHelpers.interopDefault(_lightbulbJs);
var _link2OffJs = require("./icons/link-2-off.js");
var _link2OffJsDefault = parcelHelpers.interopDefault(_link2OffJs);
var _linkJs = require("./icons/link.js");
var _linkJsDefault = parcelHelpers.interopDefault(_linkJs);
var _link2Js = require("./icons/link-2.js");
var _link2JsDefault = parcelHelpers.interopDefault(_link2Js);
var _linkedinJs = require("./icons/linkedin.js");
var _linkedinJsDefault = parcelHelpers.interopDefault(_linkedinJs);
var _listCheckJs = require("./icons/list-check.js");
var _listCheckJsDefault = parcelHelpers.interopDefault(_listCheckJs);
var _listChecksJs = require("./icons/list-checks.js");
var _listChecksJsDefault = parcelHelpers.interopDefault(_listChecksJs);
var _listCollapseJs = require("./icons/list-collapse.js");
var _listCollapseJsDefault = parcelHelpers.interopDefault(_listCollapseJs);
var _listEndJs = require("./icons/list-end.js");
var _listEndJsDefault = parcelHelpers.interopDefault(_listEndJs);
var _listFilterPlusJs = require("./icons/list-filter-plus.js");
var _listFilterPlusJsDefault = parcelHelpers.interopDefault(_listFilterPlusJs);
var _listFilterJs = require("./icons/list-filter.js");
var _listFilterJsDefault = parcelHelpers.interopDefault(_listFilterJs);
var _listMinusJs = require("./icons/list-minus.js");
var _listMinusJsDefault = parcelHelpers.interopDefault(_listMinusJs);
var _listMusicJs = require("./icons/list-music.js");
var _listMusicJsDefault = parcelHelpers.interopDefault(_listMusicJs);
var _listOrderedJs = require("./icons/list-ordered.js");
var _listOrderedJsDefault = parcelHelpers.interopDefault(_listOrderedJs);
var _listPlusJs = require("./icons/list-plus.js");
var _listPlusJsDefault = parcelHelpers.interopDefault(_listPlusJs);
var _listRestartJs = require("./icons/list-restart.js");
var _listRestartJsDefault = parcelHelpers.interopDefault(_listRestartJs);
var _listTodoJs = require("./icons/list-todo.js");
var _listTodoJsDefault = parcelHelpers.interopDefault(_listTodoJs);
var _listTreeJs = require("./icons/list-tree.js");
var _listTreeJsDefault = parcelHelpers.interopDefault(_listTreeJs);
var _listStartJs = require("./icons/list-start.js");
var _listStartJsDefault = parcelHelpers.interopDefault(_listStartJs);
var _listVideoJs = require("./icons/list-video.js");
var _listVideoJsDefault = parcelHelpers.interopDefault(_listVideoJs);
var _listXJs = require("./icons/list-x.js");
var _listXJsDefault = parcelHelpers.interopDefault(_listXJs);
var _listJs = require("./icons/list.js");
var _listJsDefault = parcelHelpers.interopDefault(_listJs);
var _loaderPinwheelJs = require("./icons/loader-pinwheel.js");
var _loaderPinwheelJsDefault = parcelHelpers.interopDefault(_loaderPinwheelJs);
var _loaderJs = require("./icons/loader.js");
var _loaderJsDefault = parcelHelpers.interopDefault(_loaderJs);
var _locateFixedJs = require("./icons/locate-fixed.js");
var _locateFixedJsDefault = parcelHelpers.interopDefault(_locateFixedJs);
var _locateOffJs = require("./icons/locate-off.js");
var _locateOffJsDefault = parcelHelpers.interopDefault(_locateOffJs);
var _locateJs = require("./icons/locate.js");
var _locateJsDefault = parcelHelpers.interopDefault(_locateJs);
var _locationEditJs = require("./icons/location-edit.js");
var _locationEditJsDefault = parcelHelpers.interopDefault(_locationEditJs);
var _lockKeyholeJs = require("./icons/lock-keyhole.js");
var _lockKeyholeJsDefault = parcelHelpers.interopDefault(_lockKeyholeJs);
var _lockJs = require("./icons/lock.js");
var _lockJsDefault = parcelHelpers.interopDefault(_lockJs);
var _logInJs = require("./icons/log-in.js");
var _logInJsDefault = parcelHelpers.interopDefault(_logInJs);
var _logOutJs = require("./icons/log-out.js");
var _logOutJsDefault = parcelHelpers.interopDefault(_logOutJs);
var _logsJs = require("./icons/logs.js");
var _logsJsDefault = parcelHelpers.interopDefault(_logsJs);
var _lollipopJs = require("./icons/lollipop.js");
var _lollipopJsDefault = parcelHelpers.interopDefault(_lollipopJs);
var _luggageJs = require("./icons/luggage.js");
var _luggageJsDefault = parcelHelpers.interopDefault(_luggageJs);
var _magnetJs = require("./icons/magnet.js");
var _magnetJsDefault = parcelHelpers.interopDefault(_magnetJs);
var _mailCheckJs = require("./icons/mail-check.js");
var _mailCheckJsDefault = parcelHelpers.interopDefault(_mailCheckJs);
var _mailOpenJs = require("./icons/mail-open.js");
var _mailOpenJsDefault = parcelHelpers.interopDefault(_mailOpenJs);
var _mailQuestionJs = require("./icons/mail-question.js");
var _mailQuestionJsDefault = parcelHelpers.interopDefault(_mailQuestionJs);
var _mailPlusJs = require("./icons/mail-plus.js");
var _mailPlusJsDefault = parcelHelpers.interopDefault(_mailPlusJs);
var _mailMinusJs = require("./icons/mail-minus.js");
var _mailMinusJsDefault = parcelHelpers.interopDefault(_mailMinusJs);
var _mailSearchJs = require("./icons/mail-search.js");
var _mailSearchJsDefault = parcelHelpers.interopDefault(_mailSearchJs);
var _mailWarningJs = require("./icons/mail-warning.js");
var _mailWarningJsDefault = parcelHelpers.interopDefault(_mailWarningJs);
var _mailXJs = require("./icons/mail-x.js");
var _mailXJsDefault = parcelHelpers.interopDefault(_mailXJs);
var _mailboxJs = require("./icons/mailbox.js");
var _mailboxJsDefault = parcelHelpers.interopDefault(_mailboxJs);
var _mailJs = require("./icons/mail.js");
var _mailJsDefault = parcelHelpers.interopDefault(_mailJs);
var _mailsJs = require("./icons/mails.js");
var _mailsJsDefault = parcelHelpers.interopDefault(_mailsJs);
var _mapPinCheckInsideJs = require("./icons/map-pin-check-inside.js");
var _mapPinCheckInsideJsDefault = parcelHelpers.interopDefault(_mapPinCheckInsideJs);
var _mapPinCheckJs = require("./icons/map-pin-check.js");
var _mapPinCheckJsDefault = parcelHelpers.interopDefault(_mapPinCheckJs);
var _mapPinHouseJs = require("./icons/map-pin-house.js");
var _mapPinHouseJsDefault = parcelHelpers.interopDefault(_mapPinHouseJs);
var _mapPinMinusInsideJs = require("./icons/map-pin-minus-inside.js");
var _mapPinMinusInsideJsDefault = parcelHelpers.interopDefault(_mapPinMinusInsideJs);
var _mapPinMinusJs = require("./icons/map-pin-minus.js");
var _mapPinMinusJsDefault = parcelHelpers.interopDefault(_mapPinMinusJs);
var _mapPinPlusInsideJs = require("./icons/map-pin-plus-inside.js");
var _mapPinPlusInsideJsDefault = parcelHelpers.interopDefault(_mapPinPlusInsideJs);
var _mapPinOffJs = require("./icons/map-pin-off.js");
var _mapPinOffJsDefault = parcelHelpers.interopDefault(_mapPinOffJs);
var _mapPinPlusJs = require("./icons/map-pin-plus.js");
var _mapPinPlusJsDefault = parcelHelpers.interopDefault(_mapPinPlusJs);
var _mapPinXInsideJs = require("./icons/map-pin-x-inside.js");
var _mapPinXInsideJsDefault = parcelHelpers.interopDefault(_mapPinXInsideJs);
var _mapPinXJs = require("./icons/map-pin-x.js");
var _mapPinXJsDefault = parcelHelpers.interopDefault(_mapPinXJs);
var _mapPinJs = require("./icons/map-pin.js");
var _mapPinJsDefault = parcelHelpers.interopDefault(_mapPinJs);
var _mapPinnedJs = require("./icons/map-pinned.js");
var _mapPinnedJsDefault = parcelHelpers.interopDefault(_mapPinnedJs);
var _mapPlusJs = require("./icons/map-plus.js");
var _mapPlusJsDefault = parcelHelpers.interopDefault(_mapPlusJs);
var _mapJs = require("./icons/map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _martiniJs = require("./icons/martini.js");
var _martiniJsDefault = parcelHelpers.interopDefault(_martiniJs);
var _marsStrokeJs = require("./icons/mars-stroke.js");
var _marsStrokeJsDefault = parcelHelpers.interopDefault(_marsStrokeJs);
var _marsJs = require("./icons/mars.js");
var _marsJsDefault = parcelHelpers.interopDefault(_marsJs);
var _maximize2Js = require("./icons/maximize-2.js");
var _maximize2JsDefault = parcelHelpers.interopDefault(_maximize2Js);
var _maximizeJs = require("./icons/maximize.js");
var _maximizeJsDefault = parcelHelpers.interopDefault(_maximizeJs);
var _medalJs = require("./icons/medal.js");
var _medalJsDefault = parcelHelpers.interopDefault(_medalJs);
var _megaphoneOffJs = require("./icons/megaphone-off.js");
var _megaphoneOffJsDefault = parcelHelpers.interopDefault(_megaphoneOffJs);
var _megaphoneJs = require("./icons/megaphone.js");
var _megaphoneJsDefault = parcelHelpers.interopDefault(_megaphoneJs);
var _memoryStickJs = require("./icons/memory-stick.js");
var _memoryStickJsDefault = parcelHelpers.interopDefault(_memoryStickJs);
var _mehJs = require("./icons/meh.js");
var _mehJsDefault = parcelHelpers.interopDefault(_mehJs);
var _menuJs = require("./icons/menu.js");
var _menuJsDefault = parcelHelpers.interopDefault(_menuJs);
var _mergeJs = require("./icons/merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _messageCircleCodeJs = require("./icons/message-circle-code.js");
var _messageCircleCodeJsDefault = parcelHelpers.interopDefault(_messageCircleCodeJs);
var _messageCircleDashedJs = require("./icons/message-circle-dashed.js");
var _messageCircleDashedJsDefault = parcelHelpers.interopDefault(_messageCircleDashedJs);
var _messageCircleHeartJs = require("./icons/message-circle-heart.js");
var _messageCircleHeartJsDefault = parcelHelpers.interopDefault(_messageCircleHeartJs);
var _messageCircleMoreJs = require("./icons/message-circle-more.js");
var _messageCircleMoreJsDefault = parcelHelpers.interopDefault(_messageCircleMoreJs);
var _messageCirclePlusJs = require("./icons/message-circle-plus.js");
var _messageCirclePlusJsDefault = parcelHelpers.interopDefault(_messageCirclePlusJs);
var _messageCircleOffJs = require("./icons/message-circle-off.js");
var _messageCircleOffJsDefault = parcelHelpers.interopDefault(_messageCircleOffJs);
var _messageCircleQuestionJs = require("./icons/message-circle-question.js");
var _messageCircleQuestionJsDefault = parcelHelpers.interopDefault(_messageCircleQuestionJs);
var _messageCircleReplyJs = require("./icons/message-circle-reply.js");
var _messageCircleReplyJsDefault = parcelHelpers.interopDefault(_messageCircleReplyJs);
var _messageCircleWarningJs = require("./icons/message-circle-warning.js");
var _messageCircleWarningJsDefault = parcelHelpers.interopDefault(_messageCircleWarningJs);
var _messageCircleXJs = require("./icons/message-circle-x.js");
var _messageCircleXJsDefault = parcelHelpers.interopDefault(_messageCircleXJs);
var _messageCircleJs = require("./icons/message-circle.js");
var _messageCircleJsDefault = parcelHelpers.interopDefault(_messageCircleJs);
var _messageSquareCodeJs = require("./icons/message-square-code.js");
var _messageSquareCodeJsDefault = parcelHelpers.interopDefault(_messageSquareCodeJs);
var _messageSquareDashedJs = require("./icons/message-square-dashed.js");
var _messageSquareDashedJsDefault = parcelHelpers.interopDefault(_messageSquareDashedJs);
var _messageSquareDiffJs = require("./icons/message-square-diff.js");
var _messageSquareDiffJsDefault = parcelHelpers.interopDefault(_messageSquareDiffJs);
var _messageSquareHeartJs = require("./icons/message-square-heart.js");
var _messageSquareHeartJsDefault = parcelHelpers.interopDefault(_messageSquareHeartJs);
var _messageSquareDotJs = require("./icons/message-square-dot.js");
var _messageSquareDotJsDefault = parcelHelpers.interopDefault(_messageSquareDotJs);
var _messageSquareLockJs = require("./icons/message-square-lock.js");
var _messageSquareLockJsDefault = parcelHelpers.interopDefault(_messageSquareLockJs);
var _messageSquareMoreJs = require("./icons/message-square-more.js");
var _messageSquareMoreJsDefault = parcelHelpers.interopDefault(_messageSquareMoreJs);
var _messageSquareOffJs = require("./icons/message-square-off.js");
var _messageSquareOffJsDefault = parcelHelpers.interopDefault(_messageSquareOffJs);
var _messageSquarePlusJs = require("./icons/message-square-plus.js");
var _messageSquarePlusJsDefault = parcelHelpers.interopDefault(_messageSquarePlusJs);
var _messageSquareQuoteJs = require("./icons/message-square-quote.js");
var _messageSquareQuoteJsDefault = parcelHelpers.interopDefault(_messageSquareQuoteJs);
var _messageSquareReplyJs = require("./icons/message-square-reply.js");
var _messageSquareReplyJsDefault = parcelHelpers.interopDefault(_messageSquareReplyJs);
var _messageSquareShareJs = require("./icons/message-square-share.js");
var _messageSquareShareJsDefault = parcelHelpers.interopDefault(_messageSquareShareJs);
var _messageSquareTextJs = require("./icons/message-square-text.js");
var _messageSquareTextJsDefault = parcelHelpers.interopDefault(_messageSquareTextJs);
var _messageSquareWarningJs = require("./icons/message-square-warning.js");
var _messageSquareWarningJsDefault = parcelHelpers.interopDefault(_messageSquareWarningJs);
var _messageSquareXJs = require("./icons/message-square-x.js");
var _messageSquareXJsDefault = parcelHelpers.interopDefault(_messageSquareXJs);
var _messageSquareJs = require("./icons/message-square.js");
var _messageSquareJsDefault = parcelHelpers.interopDefault(_messageSquareJs);
var _messagesSquareJs = require("./icons/messages-square.js");
var _messagesSquareJsDefault = parcelHelpers.interopDefault(_messagesSquareJs);
var _micOffJs = require("./icons/mic-off.js");
var _micOffJsDefault = parcelHelpers.interopDefault(_micOffJs);
var _micJs = require("./icons/mic.js");
var _micJsDefault = parcelHelpers.interopDefault(_micJs);
var _microchipJs = require("./icons/microchip.js");
var _microchipJsDefault = parcelHelpers.interopDefault(_microchipJs);
var _microscopeJs = require("./icons/microscope.js");
var _microscopeJsDefault = parcelHelpers.interopDefault(_microscopeJs);
var _microwaveJs = require("./icons/microwave.js");
var _microwaveJsDefault = parcelHelpers.interopDefault(_microwaveJs);
var _milestoneJs = require("./icons/milestone.js");
var _milestoneJsDefault = parcelHelpers.interopDefault(_milestoneJs);
var _milkOffJs = require("./icons/milk-off.js");
var _milkOffJsDefault = parcelHelpers.interopDefault(_milkOffJs);
var _milkJs = require("./icons/milk.js");
var _milkJsDefault = parcelHelpers.interopDefault(_milkJs);
var _minimize2Js = require("./icons/minimize-2.js");
var _minimize2JsDefault = parcelHelpers.interopDefault(_minimize2Js);
var _minimizeJs = require("./icons/minimize.js");
var _minimizeJsDefault = parcelHelpers.interopDefault(_minimizeJs);
var _minusJs = require("./icons/minus.js");
var _minusJsDefault = parcelHelpers.interopDefault(_minusJs);
var _monitorCheckJs = require("./icons/monitor-check.js");
var _monitorCheckJsDefault = parcelHelpers.interopDefault(_monitorCheckJs);
var _monitorCogJs = require("./icons/monitor-cog.js");
var _monitorCogJsDefault = parcelHelpers.interopDefault(_monitorCogJs);
var _monitorDotJs = require("./icons/monitor-dot.js");
var _monitorDotJsDefault = parcelHelpers.interopDefault(_monitorDotJs);
var _monitorDownJs = require("./icons/monitor-down.js");
var _monitorDownJsDefault = parcelHelpers.interopDefault(_monitorDownJs);
var _monitorOffJs = require("./icons/monitor-off.js");
var _monitorOffJsDefault = parcelHelpers.interopDefault(_monitorOffJs);
var _monitorPlayJs = require("./icons/monitor-play.js");
var _monitorPlayJsDefault = parcelHelpers.interopDefault(_monitorPlayJs);
var _monitorSpeakerJs = require("./icons/monitor-speaker.js");
var _monitorSpeakerJsDefault = parcelHelpers.interopDefault(_monitorSpeakerJs);
var _monitorPauseJs = require("./icons/monitor-pause.js");
var _monitorPauseJsDefault = parcelHelpers.interopDefault(_monitorPauseJs);
var _monitorSmartphoneJs = require("./icons/monitor-smartphone.js");
var _monitorSmartphoneJsDefault = parcelHelpers.interopDefault(_monitorSmartphoneJs);
var _monitorStopJs = require("./icons/monitor-stop.js");
var _monitorStopJsDefault = parcelHelpers.interopDefault(_monitorStopJs);
var _monitorUpJs = require("./icons/monitor-up.js");
var _monitorUpJsDefault = parcelHelpers.interopDefault(_monitorUpJs);
var _monitorXJs = require("./icons/monitor-x.js");
var _monitorXJsDefault = parcelHelpers.interopDefault(_monitorXJs);
var _monitorJs = require("./icons/monitor.js");
var _monitorJsDefault = parcelHelpers.interopDefault(_monitorJs);
var _moonStarJs = require("./icons/moon-star.js");
var _moonStarJsDefault = parcelHelpers.interopDefault(_moonStarJs);
var _moonJs = require("./icons/moon.js");
var _moonJsDefault = parcelHelpers.interopDefault(_moonJs);
var _mountainSnowJs = require("./icons/mountain-snow.js");
var _mountainSnowJsDefault = parcelHelpers.interopDefault(_mountainSnowJs);
var _mountainJs = require("./icons/mountain.js");
var _mountainJsDefault = parcelHelpers.interopDefault(_mountainJs);
var _mouseOffJs = require("./icons/mouse-off.js");
var _mouseOffJsDefault = parcelHelpers.interopDefault(_mouseOffJs);
var _mousePointer2Js = require("./icons/mouse-pointer-2.js");
var _mousePointer2JsDefault = parcelHelpers.interopDefault(_mousePointer2Js);
var _mousePointerBanJs = require("./icons/mouse-pointer-ban.js");
var _mousePointerBanJsDefault = parcelHelpers.interopDefault(_mousePointerBanJs);
var _mousePointerClickJs = require("./icons/mouse-pointer-click.js");
var _mousePointerClickJsDefault = parcelHelpers.interopDefault(_mousePointerClickJs);
var _mousePointerJs = require("./icons/mouse-pointer.js");
var _mousePointerJsDefault = parcelHelpers.interopDefault(_mousePointerJs);
var _mouseJs = require("./icons/mouse.js");
var _mouseJsDefault = parcelHelpers.interopDefault(_mouseJs);
var _moveDiagonal2Js = require("./icons/move-diagonal-2.js");
var _moveDiagonal2JsDefault = parcelHelpers.interopDefault(_moveDiagonal2Js);
var _moveDiagonalJs = require("./icons/move-diagonal.js");
var _moveDiagonalJsDefault = parcelHelpers.interopDefault(_moveDiagonalJs);
var _moveDownLeftJs = require("./icons/move-down-left.js");
var _moveDownLeftJsDefault = parcelHelpers.interopDefault(_moveDownLeftJs);
var _moveDownRightJs = require("./icons/move-down-right.js");
var _moveDownRightJsDefault = parcelHelpers.interopDefault(_moveDownRightJs);
var _moveDownJs = require("./icons/move-down.js");
var _moveDownJsDefault = parcelHelpers.interopDefault(_moveDownJs);
var _moveHorizontalJs = require("./icons/move-horizontal.js");
var _moveHorizontalJsDefault = parcelHelpers.interopDefault(_moveHorizontalJs);
var _moveLeftJs = require("./icons/move-left.js");
var _moveLeftJsDefault = parcelHelpers.interopDefault(_moveLeftJs);
var _moveRightJs = require("./icons/move-right.js");
var _moveRightJsDefault = parcelHelpers.interopDefault(_moveRightJs);
var _moveUpRightJs = require("./icons/move-up-right.js");
var _moveUpRightJsDefault = parcelHelpers.interopDefault(_moveUpRightJs);
var _moveUpLeftJs = require("./icons/move-up-left.js");
var _moveUpLeftJsDefault = parcelHelpers.interopDefault(_moveUpLeftJs);
var _moveUpJs = require("./icons/move-up.js");
var _moveUpJsDefault = parcelHelpers.interopDefault(_moveUpJs);
var _moveVerticalJs = require("./icons/move-vertical.js");
var _moveVerticalJsDefault = parcelHelpers.interopDefault(_moveVerticalJs);
var _moveJs = require("./icons/move.js");
var _moveJsDefault = parcelHelpers.interopDefault(_moveJs);
var _music2Js = require("./icons/music-2.js");
var _music2JsDefault = parcelHelpers.interopDefault(_music2Js);
var _musicJs = require("./icons/music.js");
var _musicJsDefault = parcelHelpers.interopDefault(_musicJs);
var _music3Js = require("./icons/music-3.js");
var _music3JsDefault = parcelHelpers.interopDefault(_music3Js);
var _music4Js = require("./icons/music-4.js");
var _music4JsDefault = parcelHelpers.interopDefault(_music4Js);
var _navigation2OffJs = require("./icons/navigation-2-off.js");
var _navigation2OffJsDefault = parcelHelpers.interopDefault(_navigation2OffJs);
var _navigation2Js = require("./icons/navigation-2.js");
var _navigation2JsDefault = parcelHelpers.interopDefault(_navigation2Js);
var _navigationOffJs = require("./icons/navigation-off.js");
var _navigationOffJsDefault = parcelHelpers.interopDefault(_navigationOffJs);
var _navigationJs = require("./icons/navigation.js");
var _navigationJsDefault = parcelHelpers.interopDefault(_navigationJs);
var _networkJs = require("./icons/network.js");
var _networkJsDefault = parcelHelpers.interopDefault(_networkJs);
var _nfcJs = require("./icons/nfc.js");
var _nfcJsDefault = parcelHelpers.interopDefault(_nfcJs);
var _newspaperJs = require("./icons/newspaper.js");
var _newspaperJsDefault = parcelHelpers.interopDefault(_newspaperJs);
var _nonBinaryJs = require("./icons/non-binary.js");
var _nonBinaryJsDefault = parcelHelpers.interopDefault(_nonBinaryJs);
var _notebookPenJs = require("./icons/notebook-pen.js");
var _notebookPenJsDefault = parcelHelpers.interopDefault(_notebookPenJs);
var _notebookTabsJs = require("./icons/notebook-tabs.js");
var _notebookTabsJsDefault = parcelHelpers.interopDefault(_notebookTabsJs);
var _notebookTextJs = require("./icons/notebook-text.js");
var _notebookTextJsDefault = parcelHelpers.interopDefault(_notebookTextJs);
var _notebookJs = require("./icons/notebook.js");
var _notebookJsDefault = parcelHelpers.interopDefault(_notebookJs);
var _notepadTextDashedJs = require("./icons/notepad-text-dashed.js");
var _notepadTextDashedJsDefault = parcelHelpers.interopDefault(_notepadTextDashedJs);
var _notepadTextJs = require("./icons/notepad-text.js");
var _notepadTextJsDefault = parcelHelpers.interopDefault(_notepadTextJs);
var _nutOffJs = require("./icons/nut-off.js");
var _nutOffJsDefault = parcelHelpers.interopDefault(_nutOffJs);
var _nutJs = require("./icons/nut.js");
var _nutJsDefault = parcelHelpers.interopDefault(_nutJs);
var _octagonMinusJs = require("./icons/octagon-minus.js");
var _octagonMinusJsDefault = parcelHelpers.interopDefault(_octagonMinusJs);
var _octagonJs = require("./icons/octagon.js");
var _octagonJsDefault = parcelHelpers.interopDefault(_octagonJs);
var _omegaJs = require("./icons/omega.js");
var _omegaJsDefault = parcelHelpers.interopDefault(_omegaJs);
var _optionJs = require("./icons/option.js");
var _optionJsDefault = parcelHelpers.interopDefault(_optionJs);
var _orbitJs = require("./icons/orbit.js");
var _orbitJsDefault = parcelHelpers.interopDefault(_orbitJs);
var _origamiJs = require("./icons/origami.js");
var _origamiJsDefault = parcelHelpers.interopDefault(_origamiJs);
var _package2Js = require("./icons/package-2.js");
var _package2JsDefault = parcelHelpers.interopDefault(_package2Js);
var _packageCheckJs = require("./icons/package-check.js");
var _packageCheckJsDefault = parcelHelpers.interopDefault(_packageCheckJs);
var _packageMinusJs = require("./icons/package-minus.js");
var _packageMinusJsDefault = parcelHelpers.interopDefault(_packageMinusJs);
var _packageOpenJs = require("./icons/package-open.js");
var _packageOpenJsDefault = parcelHelpers.interopDefault(_packageOpenJs);
var _packageSearchJs = require("./icons/package-search.js");
var _packageSearchJsDefault = parcelHelpers.interopDefault(_packageSearchJs);
var _packagePlusJs = require("./icons/package-plus.js");
var _packagePlusJsDefault = parcelHelpers.interopDefault(_packagePlusJs);
var _packageXJs = require("./icons/package-x.js");
var _packageXJsDefault = parcelHelpers.interopDefault(_packageXJs);
var _packageJs = require("./icons/package.js");
var _packageJsDefault = parcelHelpers.interopDefault(_packageJs);
var _paintBucketJs = require("./icons/paint-bucket.js");
var _paintBucketJsDefault = parcelHelpers.interopDefault(_paintBucketJs);
var _paintRollerJs = require("./icons/paint-roller.js");
var _paintRollerJsDefault = parcelHelpers.interopDefault(_paintRollerJs);
var _paintbrushJs = require("./icons/paintbrush.js");
var _paintbrushJsDefault = parcelHelpers.interopDefault(_paintbrushJs);
var _paletteJs = require("./icons/palette.js");
var _paletteJsDefault = parcelHelpers.interopDefault(_paletteJs);
var _pandaJs = require("./icons/panda.js");
var _pandaJsDefault = parcelHelpers.interopDefault(_pandaJs);
var _panelBottomCloseJs = require("./icons/panel-bottom-close.js");
var _panelBottomCloseJsDefault = parcelHelpers.interopDefault(_panelBottomCloseJs);
var _panelBottomOpenJs = require("./icons/panel-bottom-open.js");
var _panelBottomOpenJsDefault = parcelHelpers.interopDefault(_panelBottomOpenJs);
var _panelBottomJs = require("./icons/panel-bottom.js");
var _panelBottomJsDefault = parcelHelpers.interopDefault(_panelBottomJs);
var _panelRightCloseJs = require("./icons/panel-right-close.js");
var _panelRightCloseJsDefault = parcelHelpers.interopDefault(_panelRightCloseJs);
var _panelRightOpenJs = require("./icons/panel-right-open.js");
var _panelRightOpenJsDefault = parcelHelpers.interopDefault(_panelRightOpenJs);
var _panelRightJs = require("./icons/panel-right.js");
var _panelRightJsDefault = parcelHelpers.interopDefault(_panelRightJs);
var _panelTopCloseJs = require("./icons/panel-top-close.js");
var _panelTopCloseJsDefault = parcelHelpers.interopDefault(_panelTopCloseJs);
var _panelTopOpenJs = require("./icons/panel-top-open.js");
var _panelTopOpenJsDefault = parcelHelpers.interopDefault(_panelTopOpenJs);
var _panelTopJs = require("./icons/panel-top.js");
var _panelTopJsDefault = parcelHelpers.interopDefault(_panelTopJs);
var _panelsLeftBottomJs = require("./icons/panels-left-bottom.js");
var _panelsLeftBottomJsDefault = parcelHelpers.interopDefault(_panelsLeftBottomJs);
var _panelsRightBottomJs = require("./icons/panels-right-bottom.js");
var _panelsRightBottomJsDefault = parcelHelpers.interopDefault(_panelsRightBottomJs);
var _paperclipJs = require("./icons/paperclip.js");
var _paperclipJsDefault = parcelHelpers.interopDefault(_paperclipJs);
var _parenthesesJs = require("./icons/parentheses.js");
var _parenthesesJsDefault = parcelHelpers.interopDefault(_parenthesesJs);
var _parkingMeterJs = require("./icons/parking-meter.js");
var _parkingMeterJsDefault = parcelHelpers.interopDefault(_parkingMeterJs);
var _partyPopperJs = require("./icons/party-popper.js");
var _partyPopperJsDefault = parcelHelpers.interopDefault(_partyPopperJs);
var _pauseJs = require("./icons/pause.js");
var _pauseJsDefault = parcelHelpers.interopDefault(_pauseJs);
var _pawPrintJs = require("./icons/paw-print.js");
var _pawPrintJsDefault = parcelHelpers.interopDefault(_pawPrintJs);
var _pcCaseJs = require("./icons/pc-case.js");
var _pcCaseJsDefault = parcelHelpers.interopDefault(_pcCaseJs);
var _penOffJs = require("./icons/pen-off.js");
var _penOffJsDefault = parcelHelpers.interopDefault(_penOffJs);
var _penToolJs = require("./icons/pen-tool.js");
var _penToolJsDefault = parcelHelpers.interopDefault(_penToolJs);
var _pencilLineJs = require("./icons/pencil-line.js");
var _pencilLineJsDefault = parcelHelpers.interopDefault(_pencilLineJs);
var _pencilOffJs = require("./icons/pencil-off.js");
var _pencilOffJsDefault = parcelHelpers.interopDefault(_pencilOffJs);
var _pencilRulerJs = require("./icons/pencil-ruler.js");
var _pencilRulerJsDefault = parcelHelpers.interopDefault(_pencilRulerJs);
var _pencilJs = require("./icons/pencil.js");
var _pencilJsDefault = parcelHelpers.interopDefault(_pencilJs);
var _pentagonJs = require("./icons/pentagon.js");
var _pentagonJsDefault = parcelHelpers.interopDefault(_pentagonJs);
var _percentJs = require("./icons/percent.js");
var _percentJsDefault = parcelHelpers.interopDefault(_percentJs);
var _personStandingJs = require("./icons/person-standing.js");
var _personStandingJsDefault = parcelHelpers.interopDefault(_personStandingJs);
var _philippinePesoJs = require("./icons/philippine-peso.js");
var _philippinePesoJsDefault = parcelHelpers.interopDefault(_philippinePesoJs);
var _phoneCallJs = require("./icons/phone-call.js");
var _phoneCallJsDefault = parcelHelpers.interopDefault(_phoneCallJs);
var _phoneForwardedJs = require("./icons/phone-forwarded.js");
var _phoneForwardedJsDefault = parcelHelpers.interopDefault(_phoneForwardedJs);
var _phoneIncomingJs = require("./icons/phone-incoming.js");
var _phoneIncomingJsDefault = parcelHelpers.interopDefault(_phoneIncomingJs);
var _phoneMissedJs = require("./icons/phone-missed.js");
var _phoneMissedJsDefault = parcelHelpers.interopDefault(_phoneMissedJs);
var _phoneOffJs = require("./icons/phone-off.js");
var _phoneOffJsDefault = parcelHelpers.interopDefault(_phoneOffJs);
var _phoneOutgoingJs = require("./icons/phone-outgoing.js");
var _phoneOutgoingJsDefault = parcelHelpers.interopDefault(_phoneOutgoingJs);
var _piJs = require("./icons/pi.js");
var _piJsDefault = parcelHelpers.interopDefault(_piJs);
var _phoneJs = require("./icons/phone.js");
var _phoneJsDefault = parcelHelpers.interopDefault(_phoneJs);
var _pickaxeJs = require("./icons/pickaxe.js");
var _pickaxeJsDefault = parcelHelpers.interopDefault(_pickaxeJs);
var _pianoJs = require("./icons/piano.js");
var _pianoJsDefault = parcelHelpers.interopDefault(_pianoJs);
var _pictureInPicture2Js = require("./icons/picture-in-picture-2.js");
var _pictureInPicture2JsDefault = parcelHelpers.interopDefault(_pictureInPicture2Js);
var _pictureInPictureJs = require("./icons/picture-in-picture.js");
var _pictureInPictureJsDefault = parcelHelpers.interopDefault(_pictureInPictureJs);
var _piggyBankJs = require("./icons/piggy-bank.js");
var _piggyBankJsDefault = parcelHelpers.interopDefault(_piggyBankJs);
var _pilcrowLeftJs = require("./icons/pilcrow-left.js");
var _pilcrowLeftJsDefault = parcelHelpers.interopDefault(_pilcrowLeftJs);
var _pilcrowRightJs = require("./icons/pilcrow-right.js");
var _pilcrowRightJsDefault = parcelHelpers.interopDefault(_pilcrowRightJs);
var _pilcrowJs = require("./icons/pilcrow.js");
var _pilcrowJsDefault = parcelHelpers.interopDefault(_pilcrowJs);
var _pillBottleJs = require("./icons/pill-bottle.js");
var _pillBottleJsDefault = parcelHelpers.interopDefault(_pillBottleJs);
var _pillJs = require("./icons/pill.js");
var _pillJsDefault = parcelHelpers.interopDefault(_pillJs);
var _pinOffJs = require("./icons/pin-off.js");
var _pinOffJsDefault = parcelHelpers.interopDefault(_pinOffJs);
var _pinJs = require("./icons/pin.js");
var _pinJsDefault = parcelHelpers.interopDefault(_pinJs);
var _pipetteJs = require("./icons/pipette.js");
var _pipetteJsDefault = parcelHelpers.interopDefault(_pipetteJs);
var _pizzaJs = require("./icons/pizza.js");
var _pizzaJsDefault = parcelHelpers.interopDefault(_pizzaJs);
var _planeLandingJs = require("./icons/plane-landing.js");
var _planeLandingJsDefault = parcelHelpers.interopDefault(_planeLandingJs);
var _planeTakeoffJs = require("./icons/plane-takeoff.js");
var _planeTakeoffJsDefault = parcelHelpers.interopDefault(_planeTakeoffJs);
var _planeJs = require("./icons/plane.js");
var _planeJsDefault = parcelHelpers.interopDefault(_planeJs);
var _playJs = require("./icons/play.js");
var _playJsDefault = parcelHelpers.interopDefault(_playJs);
var _plug2Js = require("./icons/plug-2.js");
var _plug2JsDefault = parcelHelpers.interopDefault(_plug2Js);
var _plusJs = require("./icons/plus.js");
var _plusJsDefault = parcelHelpers.interopDefault(_plusJs);
var _plugJs = require("./icons/plug.js");
var _plugJsDefault = parcelHelpers.interopDefault(_plugJs);
var _pocketKnifeJs = require("./icons/pocket-knife.js");
var _pocketKnifeJsDefault = parcelHelpers.interopDefault(_pocketKnifeJs);
var _pocketJs = require("./icons/pocket.js");
var _pocketJsDefault = parcelHelpers.interopDefault(_pocketJs);
var _pointerOffJs = require("./icons/pointer-off.js");
var _pointerOffJsDefault = parcelHelpers.interopDefault(_pointerOffJs);
var _podcastJs = require("./icons/podcast.js");
var _podcastJsDefault = parcelHelpers.interopDefault(_podcastJs);
var _pointerJs = require("./icons/pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _popcornJs = require("./icons/popcorn.js");
var _popcornJsDefault = parcelHelpers.interopDefault(_popcornJs);
var _popsicleJs = require("./icons/popsicle.js");
var _popsicleJsDefault = parcelHelpers.interopDefault(_popsicleJs);
var _poundSterlingJs = require("./icons/pound-sterling.js");
var _poundSterlingJsDefault = parcelHelpers.interopDefault(_poundSterlingJs);
var _powerOffJs = require("./icons/power-off.js");
var _powerOffJsDefault = parcelHelpers.interopDefault(_powerOffJs);
var _powerJs = require("./icons/power.js");
var _powerJsDefault = parcelHelpers.interopDefault(_powerJs);
var _presentationJs = require("./icons/presentation.js");
var _presentationJsDefault = parcelHelpers.interopDefault(_presentationJs);
var _printerCheckJs = require("./icons/printer-check.js");
var _printerCheckJsDefault = parcelHelpers.interopDefault(_printerCheckJs);
var _projectorJs = require("./icons/projector.js");
var _projectorJsDefault = parcelHelpers.interopDefault(_projectorJs);
var _printerJs = require("./icons/printer.js");
var _printerJsDefault = parcelHelpers.interopDefault(_printerJs);
var _puzzleJs = require("./icons/puzzle.js");
var _puzzleJsDefault = parcelHelpers.interopDefault(_puzzleJs);
var _proportionsJs = require("./icons/proportions.js");
var _proportionsJsDefault = parcelHelpers.interopDefault(_proportionsJs);
var _pyramidJs = require("./icons/pyramid.js");
var _pyramidJsDefault = parcelHelpers.interopDefault(_pyramidJs);
var _qrCodeJs = require("./icons/qr-code.js");
var _qrCodeJsDefault = parcelHelpers.interopDefault(_qrCodeJs);
var _quoteJs = require("./icons/quote.js");
var _quoteJsDefault = parcelHelpers.interopDefault(_quoteJs);
var _rabbitJs = require("./icons/rabbit.js");
var _rabbitJsDefault = parcelHelpers.interopDefault(_rabbitJs);
var _radarJs = require("./icons/radar.js");
var _radarJsDefault = parcelHelpers.interopDefault(_radarJs);
var _radiationJs = require("./icons/radiation.js");
var _radiationJsDefault = parcelHelpers.interopDefault(_radiationJs);
var _radicalJs = require("./icons/radical.js");
var _radicalJsDefault = parcelHelpers.interopDefault(_radicalJs);
var _radioReceiverJs = require("./icons/radio-receiver.js");
var _radioReceiverJsDefault = parcelHelpers.interopDefault(_radioReceiverJs);
var _radioTowerJs = require("./icons/radio-tower.js");
var _radioTowerJsDefault = parcelHelpers.interopDefault(_radioTowerJs);
var _radioJs = require("./icons/radio.js");
var _radioJsDefault = parcelHelpers.interopDefault(_radioJs);
var _radiusJs = require("./icons/radius.js");
var _radiusJsDefault = parcelHelpers.interopDefault(_radiusJs);
var _railSymbolJs = require("./icons/rail-symbol.js");
var _railSymbolJsDefault = parcelHelpers.interopDefault(_railSymbolJs);
var _ratJs = require("./icons/rat.js");
var _ratJsDefault = parcelHelpers.interopDefault(_ratJs);
var _ratioJs = require("./icons/ratio.js");
var _ratioJsDefault = parcelHelpers.interopDefault(_ratioJs);
var _rainbowJs = require("./icons/rainbow.js");
var _rainbowJsDefault = parcelHelpers.interopDefault(_rainbowJs);
var _receiptCentJs = require("./icons/receipt-cent.js");
var _receiptCentJsDefault = parcelHelpers.interopDefault(_receiptCentJs);
var _receiptEuroJs = require("./icons/receipt-euro.js");
var _receiptEuroJsDefault = parcelHelpers.interopDefault(_receiptEuroJs);
var _receiptIndianRupeeJs = require("./icons/receipt-indian-rupee.js");
var _receiptIndianRupeeJsDefault = parcelHelpers.interopDefault(_receiptIndianRupeeJs);
var _receiptPoundSterlingJs = require("./icons/receipt-pound-sterling.js");
var _receiptPoundSterlingJsDefault = parcelHelpers.interopDefault(_receiptPoundSterlingJs);
var _receiptJapaneseYenJs = require("./icons/receipt-japanese-yen.js");
var _receiptJapaneseYenJsDefault = parcelHelpers.interopDefault(_receiptJapaneseYenJs);
var _receiptRussianRubleJs = require("./icons/receipt-russian-ruble.js");
var _receiptRussianRubleJsDefault = parcelHelpers.interopDefault(_receiptRussianRubleJs);
var _receiptTextJs = require("./icons/receipt-text.js");
var _receiptTextJsDefault = parcelHelpers.interopDefault(_receiptTextJs);
var _receiptSwissFrancJs = require("./icons/receipt-swiss-franc.js");
var _receiptSwissFrancJsDefault = parcelHelpers.interopDefault(_receiptSwissFrancJs);
var _receiptJs = require("./icons/receipt.js");
var _receiptJsDefault = parcelHelpers.interopDefault(_receiptJs);
var _rectangleCircleJs = require("./icons/rectangle-circle.js");
var _rectangleCircleJsDefault = parcelHelpers.interopDefault(_rectangleCircleJs);
var _rectangleHorizontalJs = require("./icons/rectangle-horizontal.js");
var _rectangleHorizontalJsDefault = parcelHelpers.interopDefault(_rectangleHorizontalJs);
var _rectangleVerticalJs = require("./icons/rectangle-vertical.js");
var _rectangleVerticalJsDefault = parcelHelpers.interopDefault(_rectangleVerticalJs);
var _rectangleGogglesJs = require("./icons/rectangle-goggles.js");
var _rectangleGogglesJsDefault = parcelHelpers.interopDefault(_rectangleGogglesJs);
var _recycleJs = require("./icons/recycle.js");
var _recycleJsDefault = parcelHelpers.interopDefault(_recycleJs);
var _redo2Js = require("./icons/redo-2.js");
var _redo2JsDefault = parcelHelpers.interopDefault(_redo2Js);
var _redoDotJs = require("./icons/redo-dot.js");
var _redoDotJsDefault = parcelHelpers.interopDefault(_redoDotJs);
var _refreshCcwDotJs = require("./icons/refresh-ccw-dot.js");
var _refreshCcwDotJsDefault = parcelHelpers.interopDefault(_refreshCcwDotJs);
var _redoJs = require("./icons/redo.js");
var _redoJsDefault = parcelHelpers.interopDefault(_redoJs);
var _refreshCcwJs = require("./icons/refresh-ccw.js");
var _refreshCcwJsDefault = parcelHelpers.interopDefault(_refreshCcwJs);
var _refreshCwOffJs = require("./icons/refresh-cw-off.js");
var _refreshCwOffJsDefault = parcelHelpers.interopDefault(_refreshCwOffJs);
var _refreshCwJs = require("./icons/refresh-cw.js");
var _refreshCwJsDefault = parcelHelpers.interopDefault(_refreshCwJs);
var _refrigeratorJs = require("./icons/refrigerator.js");
var _refrigeratorJsDefault = parcelHelpers.interopDefault(_refrigeratorJs);
var _regexJs = require("./icons/regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
var _removeFormattingJs = require("./icons/remove-formatting.js");
var _removeFormattingJsDefault = parcelHelpers.interopDefault(_removeFormattingJs);
var _repeat2Js = require("./icons/repeat-2.js");
var _repeat2JsDefault = parcelHelpers.interopDefault(_repeat2Js);
var _repeat1Js = require("./icons/repeat-1.js");
var _repeat1JsDefault = parcelHelpers.interopDefault(_repeat1Js);
var _repeatJs = require("./icons/repeat.js");
var _repeatJsDefault = parcelHelpers.interopDefault(_repeatJs);
var _replaceAllJs = require("./icons/replace-all.js");
var _replaceAllJsDefault = parcelHelpers.interopDefault(_replaceAllJs);
var _replaceJs = require("./icons/replace.js");
var _replaceJsDefault = parcelHelpers.interopDefault(_replaceJs);
var _replyAllJs = require("./icons/reply-all.js");
var _replyAllJsDefault = parcelHelpers.interopDefault(_replyAllJs);
var _replyJs = require("./icons/reply.js");
var _replyJsDefault = parcelHelpers.interopDefault(_replyJs);
var _rewindJs = require("./icons/rewind.js");
var _rewindJsDefault = parcelHelpers.interopDefault(_rewindJs);
var _ribbonJs = require("./icons/ribbon.js");
var _ribbonJsDefault = parcelHelpers.interopDefault(_ribbonJs);
var _rocketJs = require("./icons/rocket.js");
var _rocketJsDefault = parcelHelpers.interopDefault(_rocketJs);
var _rockingChairJs = require("./icons/rocking-chair.js");
var _rockingChairJsDefault = parcelHelpers.interopDefault(_rockingChairJs);
var _rollerCoasterJs = require("./icons/roller-coaster.js");
var _rollerCoasterJsDefault = parcelHelpers.interopDefault(_rollerCoasterJs);
var _rotateCcwKeyJs = require("./icons/rotate-ccw-key.js");
var _rotateCcwKeyJsDefault = parcelHelpers.interopDefault(_rotateCcwKeyJs);
var _rotateCcwSquareJs = require("./icons/rotate-ccw-square.js");
var _rotateCcwSquareJsDefault = parcelHelpers.interopDefault(_rotateCcwSquareJs);
var _rotateCcwJs = require("./icons/rotate-ccw.js");
var _rotateCcwJsDefault = parcelHelpers.interopDefault(_rotateCcwJs);
var _rotateCwSquareJs = require("./icons/rotate-cw-square.js");
var _rotateCwSquareJsDefault = parcelHelpers.interopDefault(_rotateCwSquareJs);
var _routeOffJs = require("./icons/route-off.js");
var _routeOffJsDefault = parcelHelpers.interopDefault(_routeOffJs);
var _routeJs = require("./icons/route.js");
var _routeJsDefault = parcelHelpers.interopDefault(_routeJs);
var _rotateCwJs = require("./icons/rotate-cw.js");
var _rotateCwJsDefault = parcelHelpers.interopDefault(_rotateCwJs);
var _routerJs = require("./icons/router.js");
var _routerJsDefault = parcelHelpers.interopDefault(_routerJs);
var _rows4Js = require("./icons/rows-4.js");
var _rows4JsDefault = parcelHelpers.interopDefault(_rows4Js);
var _rssJs = require("./icons/rss.js");
var _rssJsDefault = parcelHelpers.interopDefault(_rssJs);
var _rulerDimensionLineJs = require("./icons/ruler-dimension-line.js");
var _rulerDimensionLineJsDefault = parcelHelpers.interopDefault(_rulerDimensionLineJs);
var _rulerJs = require("./icons/ruler.js");
var _rulerJsDefault = parcelHelpers.interopDefault(_rulerJs);
var _russianRubleJs = require("./icons/russian-ruble.js");
var _russianRubleJsDefault = parcelHelpers.interopDefault(_russianRubleJs);
var _sailboatJs = require("./icons/sailboat.js");
var _sailboatJsDefault = parcelHelpers.interopDefault(_sailboatJs);
var _saladJs = require("./icons/salad.js");
var _saladJsDefault = parcelHelpers.interopDefault(_saladJs);
var _sandwichJs = require("./icons/sandwich.js");
var _sandwichJsDefault = parcelHelpers.interopDefault(_sandwichJs);
var _satelliteDishJs = require("./icons/satellite-dish.js");
var _satelliteDishJsDefault = parcelHelpers.interopDefault(_satelliteDishJs);
var _satelliteJs = require("./icons/satellite.js");
var _satelliteJsDefault = parcelHelpers.interopDefault(_satelliteJs);
var _saudiRiyalJs = require("./icons/saudi-riyal.js");
var _saudiRiyalJsDefault = parcelHelpers.interopDefault(_saudiRiyalJs);
var _saveAllJs = require("./icons/save-all.js");
var _saveAllJsDefault = parcelHelpers.interopDefault(_saveAllJs);
var _saveOffJs = require("./icons/save-off.js");
var _saveOffJsDefault = parcelHelpers.interopDefault(_saveOffJs);
var _saveJs = require("./icons/save.js");
var _saveJsDefault = parcelHelpers.interopDefault(_saveJs);
var _scaleJs = require("./icons/scale.js");
var _scaleJsDefault = parcelHelpers.interopDefault(_scaleJs);
var _scalingJs = require("./icons/scaling.js");
var _scalingJsDefault = parcelHelpers.interopDefault(_scalingJs);
var _scanBarcodeJs = require("./icons/scan-barcode.js");
var _scanBarcodeJsDefault = parcelHelpers.interopDefault(_scanBarcodeJs);
var _scanEyeJs = require("./icons/scan-eye.js");
var _scanEyeJsDefault = parcelHelpers.interopDefault(_scanEyeJs);
var _scanFaceJs = require("./icons/scan-face.js");
var _scanFaceJsDefault = parcelHelpers.interopDefault(_scanFaceJs);
var _scanHeartJs = require("./icons/scan-heart.js");
var _scanHeartJsDefault = parcelHelpers.interopDefault(_scanHeartJs);
var _scanLineJs = require("./icons/scan-line.js");
var _scanLineJsDefault = parcelHelpers.interopDefault(_scanLineJs);
var _scanQrCodeJs = require("./icons/scan-qr-code.js");
var _scanQrCodeJsDefault = parcelHelpers.interopDefault(_scanQrCodeJs);
var _scanSearchJs = require("./icons/scan-search.js");
var _scanSearchJsDefault = parcelHelpers.interopDefault(_scanSearchJs);
var _scanTextJs = require("./icons/scan-text.js");
var _scanTextJsDefault = parcelHelpers.interopDefault(_scanTextJs);
var _scanJs = require("./icons/scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _schoolJs = require("./icons/school.js");
var _schoolJsDefault = parcelHelpers.interopDefault(_schoolJs);
var _scissorsLineDashedJs = require("./icons/scissors-line-dashed.js");
var _scissorsLineDashedJsDefault = parcelHelpers.interopDefault(_scissorsLineDashedJs);
var _scissorsJs = require("./icons/scissors.js");
var _scissorsJsDefault = parcelHelpers.interopDefault(_scissorsJs);
var _screenShareOffJs = require("./icons/screen-share-off.js");
var _screenShareOffJsDefault = parcelHelpers.interopDefault(_screenShareOffJs);
var _screenShareJs = require("./icons/screen-share.js");
var _screenShareJsDefault = parcelHelpers.interopDefault(_screenShareJs);
var _scrollTextJs = require("./icons/scroll-text.js");
var _scrollTextJsDefault = parcelHelpers.interopDefault(_scrollTextJs);
var _scrollJs = require("./icons/scroll.js");
var _scrollJsDefault = parcelHelpers.interopDefault(_scrollJs);
var _searchCheckJs = require("./icons/search-check.js");
var _searchCheckJsDefault = parcelHelpers.interopDefault(_searchCheckJs);
var _searchCodeJs = require("./icons/search-code.js");
var _searchCodeJsDefault = parcelHelpers.interopDefault(_searchCodeJs);
var _searchSlashJs = require("./icons/search-slash.js");
var _searchSlashJsDefault = parcelHelpers.interopDefault(_searchSlashJs);
var _searchXJs = require("./icons/search-x.js");
var _searchXJsDefault = parcelHelpers.interopDefault(_searchXJs);
var _searchJs = require("./icons/search.js");
var _searchJsDefault = parcelHelpers.interopDefault(_searchJs);
var _sectionJs = require("./icons/section.js");
var _sectionJsDefault = parcelHelpers.interopDefault(_sectionJs);
var _sendToBackJs = require("./icons/send-to-back.js");
var _sendToBackJsDefault = parcelHelpers.interopDefault(_sendToBackJs);
var _sendJs = require("./icons/send.js");
var _sendJsDefault = parcelHelpers.interopDefault(_sendJs);
var _separatorHorizontalJs = require("./icons/separator-horizontal.js");
var _separatorHorizontalJsDefault = parcelHelpers.interopDefault(_separatorHorizontalJs);
var _separatorVerticalJs = require("./icons/separator-vertical.js");
var _separatorVerticalJsDefault = parcelHelpers.interopDefault(_separatorVerticalJs);
var _serverCogJs = require("./icons/server-cog.js");
var _serverCogJsDefault = parcelHelpers.interopDefault(_serverCogJs);
var _serverCrashJs = require("./icons/server-crash.js");
var _serverCrashJsDefault = parcelHelpers.interopDefault(_serverCrashJs);
var _serverJs = require("./icons/server.js");
var _serverJsDefault = parcelHelpers.interopDefault(_serverJs);
var _settings2Js = require("./icons/settings-2.js");
var _settings2JsDefault = parcelHelpers.interopDefault(_settings2Js);
var _serverOffJs = require("./icons/server-off.js");
var _serverOffJsDefault = parcelHelpers.interopDefault(_serverOffJs);
var _settingsJs = require("./icons/settings.js");
var _settingsJsDefault = parcelHelpers.interopDefault(_settingsJs);
var _shapesJs = require("./icons/shapes.js");
var _shapesJsDefault = parcelHelpers.interopDefault(_shapesJs);
var _share2Js = require("./icons/share-2.js");
var _share2JsDefault = parcelHelpers.interopDefault(_share2Js);
var _shellJs = require("./icons/shell.js");
var _shellJsDefault = parcelHelpers.interopDefault(_shellJs);
var _shareJs = require("./icons/share.js");
var _shareJsDefault = parcelHelpers.interopDefault(_shareJs);
var _sheetJs = require("./icons/sheet.js");
var _sheetJsDefault = parcelHelpers.interopDefault(_sheetJs);
var _shieldBanJs = require("./icons/shield-ban.js");
var _shieldBanJsDefault = parcelHelpers.interopDefault(_shieldBanJs);
var _shieldAlertJs = require("./icons/shield-alert.js");
var _shieldAlertJsDefault = parcelHelpers.interopDefault(_shieldAlertJs);
var _shieldCheckJs = require("./icons/shield-check.js");
var _shieldCheckJsDefault = parcelHelpers.interopDefault(_shieldCheckJs);
var _shieldEllipsisJs = require("./icons/shield-ellipsis.js");
var _shieldEllipsisJsDefault = parcelHelpers.interopDefault(_shieldEllipsisJs);
var _shieldHalfJs = require("./icons/shield-half.js");
var _shieldHalfJsDefault = parcelHelpers.interopDefault(_shieldHalfJs);
var _shieldMinusJs = require("./icons/shield-minus.js");
var _shieldMinusJsDefault = parcelHelpers.interopDefault(_shieldMinusJs);
var _shieldOffJs = require("./icons/shield-off.js");
var _shieldOffJsDefault = parcelHelpers.interopDefault(_shieldOffJs);
var _shieldPlusJs = require("./icons/shield-plus.js");
var _shieldPlusJsDefault = parcelHelpers.interopDefault(_shieldPlusJs);
var _shieldQuestionJs = require("./icons/shield-question.js");
var _shieldQuestionJsDefault = parcelHelpers.interopDefault(_shieldQuestionJs);
var _shieldUserJs = require("./icons/shield-user.js");
var _shieldUserJsDefault = parcelHelpers.interopDefault(_shieldUserJs);
var _shieldJs = require("./icons/shield.js");
var _shieldJsDefault = parcelHelpers.interopDefault(_shieldJs);
var _shipWheelJs = require("./icons/ship-wheel.js");
var _shipWheelJsDefault = parcelHelpers.interopDefault(_shipWheelJs);
var _shipJs = require("./icons/ship.js");
var _shipJsDefault = parcelHelpers.interopDefault(_shipJs);
var _shirtJs = require("./icons/shirt.js");
var _shirtJsDefault = parcelHelpers.interopDefault(_shirtJs);
var _shoppingBagJs = require("./icons/shopping-bag.js");
var _shoppingBagJsDefault = parcelHelpers.interopDefault(_shoppingBagJs);
var _shoppingBasketJs = require("./icons/shopping-basket.js");
var _shoppingBasketJsDefault = parcelHelpers.interopDefault(_shoppingBasketJs);
var _shoppingCartJs = require("./icons/shopping-cart.js");
var _shoppingCartJsDefault = parcelHelpers.interopDefault(_shoppingCartJs);
var _shovelJs = require("./icons/shovel.js");
var _shovelJsDefault = parcelHelpers.interopDefault(_shovelJs);
var _showerHeadJs = require("./icons/shower-head.js");
var _showerHeadJsDefault = parcelHelpers.interopDefault(_showerHeadJs);
var _shrimpJs = require("./icons/shrimp.js");
var _shrimpJsDefault = parcelHelpers.interopDefault(_shrimpJs);
var _shredderJs = require("./icons/shredder.js");
var _shredderJsDefault = parcelHelpers.interopDefault(_shredderJs);
var _shrinkJs = require("./icons/shrink.js");
var _shrinkJsDefault = parcelHelpers.interopDefault(_shrinkJs);
var _shrubJs = require("./icons/shrub.js");
var _shrubJsDefault = parcelHelpers.interopDefault(_shrubJs);
var _shuffleJs = require("./icons/shuffle.js");
var _shuffleJsDefault = parcelHelpers.interopDefault(_shuffleJs);
var _sigmaJs = require("./icons/sigma.js");
var _sigmaJsDefault = parcelHelpers.interopDefault(_sigmaJs);
var _signalHighJs = require("./icons/signal-high.js");
var _signalHighJsDefault = parcelHelpers.interopDefault(_signalHighJs);
var _signalLowJs = require("./icons/signal-low.js");
var _signalLowJsDefault = parcelHelpers.interopDefault(_signalLowJs);
var _signalMediumJs = require("./icons/signal-medium.js");
var _signalMediumJsDefault = parcelHelpers.interopDefault(_signalMediumJs);
var _signalZeroJs = require("./icons/signal-zero.js");
var _signalZeroJsDefault = parcelHelpers.interopDefault(_signalZeroJs);
var _signalJs = require("./icons/signal.js");
var _signalJsDefault = parcelHelpers.interopDefault(_signalJs);
var _signatureJs = require("./icons/signature.js");
var _signatureJsDefault = parcelHelpers.interopDefault(_signatureJs);
var _signpostBigJs = require("./icons/signpost-big.js");
var _signpostBigJsDefault = parcelHelpers.interopDefault(_signpostBigJs);
var _signpostJs = require("./icons/signpost.js");
var _signpostJsDefault = parcelHelpers.interopDefault(_signpostJs);
var _skipBackJs = require("./icons/skip-back.js");
var _skipBackJsDefault = parcelHelpers.interopDefault(_skipBackJs);
var _sirenJs = require("./icons/siren.js");
var _sirenJsDefault = parcelHelpers.interopDefault(_sirenJs);
var _skipForwardJs = require("./icons/skip-forward.js");
var _skipForwardJsDefault = parcelHelpers.interopDefault(_skipForwardJs);
var _skullJs = require("./icons/skull.js");
var _skullJsDefault = parcelHelpers.interopDefault(_skullJs);
var _slackJs = require("./icons/slack.js");
var _slackJsDefault = parcelHelpers.interopDefault(_slackJs);
var _slashJs = require("./icons/slash.js");
var _slashJsDefault = parcelHelpers.interopDefault(_slashJs);
var _sliceJs = require("./icons/slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _slidersHorizontalJs = require("./icons/sliders-horizontal.js");
var _slidersHorizontalJsDefault = parcelHelpers.interopDefault(_slidersHorizontalJs);
var _smartphoneChargingJs = require("./icons/smartphone-charging.js");
var _smartphoneChargingJsDefault = parcelHelpers.interopDefault(_smartphoneChargingJs);
var _smartphoneNfcJs = require("./icons/smartphone-nfc.js");
var _smartphoneNfcJsDefault = parcelHelpers.interopDefault(_smartphoneNfcJs);
var _smartphoneJs = require("./icons/smartphone.js");
var _smartphoneJsDefault = parcelHelpers.interopDefault(_smartphoneJs);
var _snailJs = require("./icons/snail.js");
var _snailJsDefault = parcelHelpers.interopDefault(_snailJs);
var _smileJs = require("./icons/smile.js");
var _smileJsDefault = parcelHelpers.interopDefault(_smileJs);
var _smilePlusJs = require("./icons/smile-plus.js");
var _smilePlusJsDefault = parcelHelpers.interopDefault(_smilePlusJs);
var _snowflakeJs = require("./icons/snowflake.js");
var _snowflakeJsDefault = parcelHelpers.interopDefault(_snowflakeJs);
var _soapDispenserDropletJs = require("./icons/soap-dispenser-droplet.js");
var _soapDispenserDropletJsDefault = parcelHelpers.interopDefault(_soapDispenserDropletJs);
var _soupJs = require("./icons/soup.js");
var _soupJsDefault = parcelHelpers.interopDefault(_soupJs);
var _sofaJs = require("./icons/sofa.js");
var _sofaJsDefault = parcelHelpers.interopDefault(_sofaJs);
var _spaceJs = require("./icons/space.js");
var _spaceJsDefault = parcelHelpers.interopDefault(_spaceJs);
var _sparkleJs = require("./icons/sparkle.js");
var _sparkleJsDefault = parcelHelpers.interopDefault(_sparkleJs);
var _spadeJs = require("./icons/spade.js");
var _spadeJsDefault = parcelHelpers.interopDefault(_spadeJs);
var _speakerJs = require("./icons/speaker.js");
var _speakerJsDefault = parcelHelpers.interopDefault(_speakerJs);
var _speechJs = require("./icons/speech.js");
var _speechJsDefault = parcelHelpers.interopDefault(_speechJs);
var _spellCheck2Js = require("./icons/spell-check-2.js");
var _spellCheck2JsDefault = parcelHelpers.interopDefault(_spellCheck2Js);
var _spellCheckJs = require("./icons/spell-check.js");
var _spellCheckJsDefault = parcelHelpers.interopDefault(_spellCheckJs);
var _splinePointerJs = require("./icons/spline-pointer.js");
var _splinePointerJsDefault = parcelHelpers.interopDefault(_splinePointerJs);
var _splineJs = require("./icons/spline.js");
var _splineJsDefault = parcelHelpers.interopDefault(_splineJs);
var _splitJs = require("./icons/split.js");
var _splitJsDefault = parcelHelpers.interopDefault(_splitJs);
var _sprayCanJs = require("./icons/spray-can.js");
var _sprayCanJsDefault = parcelHelpers.interopDefault(_sprayCanJs);
var _sproutJs = require("./icons/sprout.js");
var _sproutJsDefault = parcelHelpers.interopDefault(_sproutJs);
var _squareDashedBottomCodeJs = require("./icons/square-dashed-bottom-code.js");
var _squareDashedBottomCodeJsDefault = parcelHelpers.interopDefault(_squareDashedBottomCodeJs);
var _squareDashedBottomJs = require("./icons/square-dashed-bottom.js");
var _squareDashedBottomJsDefault = parcelHelpers.interopDefault(_squareDashedBottomJs);
var _squareDashedTopSolidJs = require("./icons/square-dashed-top-solid.js");
var _squareDashedTopSolidJsDefault = parcelHelpers.interopDefault(_squareDashedTopSolidJs);
var _squareRadicalJs = require("./icons/square-radical.js");
var _squareRadicalJsDefault = parcelHelpers.interopDefault(_squareRadicalJs);
var _squareRoundCornerJs = require("./icons/square-round-corner.js");
var _squareRoundCornerJsDefault = parcelHelpers.interopDefault(_squareRoundCornerJs);
var _squareSquareJs = require("./icons/square-square.js");
var _squareSquareJsDefault = parcelHelpers.interopDefault(_squareSquareJs);
var _squareStackJs = require("./icons/square-stack.js");
var _squareStackJsDefault = parcelHelpers.interopDefault(_squareStackJs);
var _squareJs = require("./icons/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _squaresExcludeJs = require("./icons/squares-exclude.js");
var _squaresExcludeJsDefault = parcelHelpers.interopDefault(_squaresExcludeJs);
var _squaresIntersectJs = require("./icons/squares-intersect.js");
var _squaresIntersectJsDefault = parcelHelpers.interopDefault(_squaresIntersectJs);
var _squaresSubtractJs = require("./icons/squares-subtract.js");
var _squaresSubtractJsDefault = parcelHelpers.interopDefault(_squaresSubtractJs);
var _squaresUniteJs = require("./icons/squares-unite.js");
var _squaresUniteJsDefault = parcelHelpers.interopDefault(_squaresUniteJs);
var _squircleJs = require("./icons/squircle.js");
var _squircleJsDefault = parcelHelpers.interopDefault(_squircleJs);
var _squirrelJs = require("./icons/squirrel.js");
var _squirrelJsDefault = parcelHelpers.interopDefault(_squirrelJs);
var _stampJs = require("./icons/stamp.js");
var _stampJsDefault = parcelHelpers.interopDefault(_stampJs);
var _starOffJs = require("./icons/star-off.js");
var _starOffJsDefault = parcelHelpers.interopDefault(_starOffJs);
var _starHalfJs = require("./icons/star-half.js");
var _starHalfJsDefault = parcelHelpers.interopDefault(_starHalfJs);
var _starJs = require("./icons/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _stepForwardJs = require("./icons/step-forward.js");
var _stepForwardJsDefault = parcelHelpers.interopDefault(_stepForwardJs);
var _stepBackJs = require("./icons/step-back.js");
var _stepBackJsDefault = parcelHelpers.interopDefault(_stepBackJs);
var _stickerJs = require("./icons/sticker.js");
var _stickerJsDefault = parcelHelpers.interopDefault(_stickerJs);
var _stethoscopeJs = require("./icons/stethoscope.js");
var _stethoscopeJsDefault = parcelHelpers.interopDefault(_stethoscopeJs);
var _storeJs = require("./icons/store.js");
var _storeJsDefault = parcelHelpers.interopDefault(_storeJs);
var _stickyNoteJs = require("./icons/sticky-note.js");
var _stickyNoteJsDefault = parcelHelpers.interopDefault(_stickyNoteJs);
var _stretchHorizontalJs = require("./icons/stretch-horizontal.js");
var _stretchHorizontalJsDefault = parcelHelpers.interopDefault(_stretchHorizontalJs);
var _stretchVerticalJs = require("./icons/stretch-vertical.js");
var _stretchVerticalJsDefault = parcelHelpers.interopDefault(_stretchVerticalJs);
var _strikethroughJs = require("./icons/strikethrough.js");
var _strikethroughJsDefault = parcelHelpers.interopDefault(_strikethroughJs);
var _subscriptJs = require("./icons/subscript.js");
var _subscriptJsDefault = parcelHelpers.interopDefault(_subscriptJs);
var _sunDimJs = require("./icons/sun-dim.js");
var _sunDimJsDefault = parcelHelpers.interopDefault(_sunDimJs);
var _sunMediumJs = require("./icons/sun-medium.js");
var _sunMediumJsDefault = parcelHelpers.interopDefault(_sunMediumJs);
var _sunSnowJs = require("./icons/sun-snow.js");
var _sunSnowJsDefault = parcelHelpers.interopDefault(_sunSnowJs);
var _sunMoonJs = require("./icons/sun-moon.js");
var _sunMoonJsDefault = parcelHelpers.interopDefault(_sunMoonJs);
var _sunJs = require("./icons/sun.js");
var _sunJsDefault = parcelHelpers.interopDefault(_sunJs);
var _sunsetJs = require("./icons/sunset.js");
var _sunsetJsDefault = parcelHelpers.interopDefault(_sunsetJs);
var _sunriseJs = require("./icons/sunrise.js");
var _sunriseJsDefault = parcelHelpers.interopDefault(_sunriseJs);
var _superscriptJs = require("./icons/superscript.js");
var _superscriptJsDefault = parcelHelpers.interopDefault(_superscriptJs);
var _swatchBookJs = require("./icons/swatch-book.js");
var _swatchBookJsDefault = parcelHelpers.interopDefault(_swatchBookJs);
var _swissFrancJs = require("./icons/swiss-franc.js");
var _swissFrancJsDefault = parcelHelpers.interopDefault(_swissFrancJs);
var _switchCameraJs = require("./icons/switch-camera.js");
var _switchCameraJsDefault = parcelHelpers.interopDefault(_switchCameraJs);
var _swordsJs = require("./icons/swords.js");
var _swordsJsDefault = parcelHelpers.interopDefault(_swordsJs);
var _swordJs = require("./icons/sword.js");
var _swordJsDefault = parcelHelpers.interopDefault(_swordJs);
var _syringeJs = require("./icons/syringe.js");
var _syringeJsDefault = parcelHelpers.interopDefault(_syringeJs);
var _table2Js = require("./icons/table-2.js");
var _table2JsDefault = parcelHelpers.interopDefault(_table2Js);
var _tableCellsMergeJs = require("./icons/table-cells-merge.js");
var _tableCellsMergeJsDefault = parcelHelpers.interopDefault(_tableCellsMergeJs);
var _tableCellsSplitJs = require("./icons/table-cells-split.js");
var _tableCellsSplitJsDefault = parcelHelpers.interopDefault(_tableCellsSplitJs);
var _tableColumnsSplitJs = require("./icons/table-columns-split.js");
var _tableColumnsSplitJsDefault = parcelHelpers.interopDefault(_tableColumnsSplitJs);
var _tableOfContentsJs = require("./icons/table-of-contents.js");
var _tableOfContentsJsDefault = parcelHelpers.interopDefault(_tableOfContentsJs);
var _tablePropertiesJs = require("./icons/table-properties.js");
var _tablePropertiesJsDefault = parcelHelpers.interopDefault(_tablePropertiesJs);
var _tableJs = require("./icons/table.js");
var _tableJsDefault = parcelHelpers.interopDefault(_tableJs);
var _tableRowsSplitJs = require("./icons/table-rows-split.js");
var _tableRowsSplitJsDefault = parcelHelpers.interopDefault(_tableRowsSplitJs);
var _tabletJs = require("./icons/tablet.js");
var _tabletJsDefault = parcelHelpers.interopDefault(_tabletJs);
var _tabletsJs = require("./icons/tablets.js");
var _tabletsJsDefault = parcelHelpers.interopDefault(_tabletsJs);
var _tabletSmartphoneJs = require("./icons/tablet-smartphone.js");
var _tabletSmartphoneJsDefault = parcelHelpers.interopDefault(_tabletSmartphoneJs);
var _tally1Js = require("./icons/tally-1.js");
var _tally1JsDefault = parcelHelpers.interopDefault(_tally1Js);
var _tagJs = require("./icons/tag.js");
var _tagJsDefault = parcelHelpers.interopDefault(_tagJs);
var _tagsJs = require("./icons/tags.js");
var _tagsJsDefault = parcelHelpers.interopDefault(_tagsJs);
var _tally2Js = require("./icons/tally-2.js");
var _tally2JsDefault = parcelHelpers.interopDefault(_tally2Js);
var _tally3Js = require("./icons/tally-3.js");
var _tally3JsDefault = parcelHelpers.interopDefault(_tally3Js);
var _tally4Js = require("./icons/tally-4.js");
var _tally4JsDefault = parcelHelpers.interopDefault(_tally4Js);
var _tangentJs = require("./icons/tangent.js");
var _tangentJsDefault = parcelHelpers.interopDefault(_tangentJs);
var _tally5Js = require("./icons/tally-5.js");
var _tally5JsDefault = parcelHelpers.interopDefault(_tally5Js);
var _telescopeJs = require("./icons/telescope.js");
var _telescopeJsDefault = parcelHelpers.interopDefault(_telescopeJs);
var _tentTreeJs = require("./icons/tent-tree.js");
var _tentTreeJsDefault = parcelHelpers.interopDefault(_tentTreeJs);
var _targetJs = require("./icons/target.js");
var _targetJsDefault = parcelHelpers.interopDefault(_targetJs);
var _tentJs = require("./icons/tent.js");
var _tentJsDefault = parcelHelpers.interopDefault(_tentJs);
var _terminalJs = require("./icons/terminal.js");
var _terminalJsDefault = parcelHelpers.interopDefault(_terminalJs);
var _testTubeJs = require("./icons/test-tube.js");
var _testTubeJsDefault = parcelHelpers.interopDefault(_testTubeJs);
var _testTubesJs = require("./icons/test-tubes.js");
var _testTubesJsDefault = parcelHelpers.interopDefault(_testTubesJs);
var _textCursorInputJs = require("./icons/text-cursor-input.js");
var _textCursorInputJsDefault = parcelHelpers.interopDefault(_textCursorInputJs);
var _textCursorJs = require("./icons/text-cursor.js");
var _textCursorJsDefault = parcelHelpers.interopDefault(_textCursorJs);
var _textSearchJs = require("./icons/text-search.js");
var _textSearchJsDefault = parcelHelpers.interopDefault(_textSearchJs);
var _textQuoteJs = require("./icons/text-quote.js");
var _textQuoteJsDefault = parcelHelpers.interopDefault(_textQuoteJs);
var _textJs = require("./icons/text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _theaterJs = require("./icons/theater.js");
var _theaterJsDefault = parcelHelpers.interopDefault(_theaterJs);
var _thermometerSnowflakeJs = require("./icons/thermometer-snowflake.js");
var _thermometerSnowflakeJsDefault = parcelHelpers.interopDefault(_thermometerSnowflakeJs);
var _thermometerSunJs = require("./icons/thermometer-sun.js");
var _thermometerSunJsDefault = parcelHelpers.interopDefault(_thermometerSunJs);
var _thermometerJs = require("./icons/thermometer.js");
var _thermometerJsDefault = parcelHelpers.interopDefault(_thermometerJs);
var _thumbsUpJs = require("./icons/thumbs-up.js");
var _thumbsUpJsDefault = parcelHelpers.interopDefault(_thumbsUpJs);
var _ticketCheckJs = require("./icons/ticket-check.js");
var _ticketCheckJsDefault = parcelHelpers.interopDefault(_ticketCheckJs);
var _thumbsDownJs = require("./icons/thumbs-down.js");
var _thumbsDownJsDefault = parcelHelpers.interopDefault(_thumbsDownJs);
var _ticketMinusJs = require("./icons/ticket-minus.js");
var _ticketMinusJsDefault = parcelHelpers.interopDefault(_ticketMinusJs);
var _ticketPercentJs = require("./icons/ticket-percent.js");
var _ticketPercentJsDefault = parcelHelpers.interopDefault(_ticketPercentJs);
var _ticketPlusJs = require("./icons/ticket-plus.js");
var _ticketPlusJsDefault = parcelHelpers.interopDefault(_ticketPlusJs);
var _ticketSlashJs = require("./icons/ticket-slash.js");
var _ticketSlashJsDefault = parcelHelpers.interopDefault(_ticketSlashJs);
var _ticketXJs = require("./icons/ticket-x.js");
var _ticketXJsDefault = parcelHelpers.interopDefault(_ticketXJs);
var _ticketJs = require("./icons/ticket.js");
var _ticketJsDefault = parcelHelpers.interopDefault(_ticketJs);
var _ticketsPlaneJs = require("./icons/tickets-plane.js");
var _ticketsPlaneJsDefault = parcelHelpers.interopDefault(_ticketsPlaneJs);
var _ticketsJs = require("./icons/tickets.js");
var _ticketsJsDefault = parcelHelpers.interopDefault(_ticketsJs);
var _timerOffJs = require("./icons/timer-off.js");
var _timerOffJsDefault = parcelHelpers.interopDefault(_timerOffJs);
var _timerResetJs = require("./icons/timer-reset.js");
var _timerResetJsDefault = parcelHelpers.interopDefault(_timerResetJs);
var _timerJs = require("./icons/timer.js");
var _timerJsDefault = parcelHelpers.interopDefault(_timerJs);
var _toggleLeftJs = require("./icons/toggle-left.js");
var _toggleLeftJsDefault = parcelHelpers.interopDefault(_toggleLeftJs);
var _toggleRightJs = require("./icons/toggle-right.js");
var _toggleRightJsDefault = parcelHelpers.interopDefault(_toggleRightJs);
var _toiletJs = require("./icons/toilet.js");
var _toiletJsDefault = parcelHelpers.interopDefault(_toiletJs);
var _tornadoJs = require("./icons/tornado.js");
var _tornadoJsDefault = parcelHelpers.interopDefault(_tornadoJs);
var _torusJs = require("./icons/torus.js");
var _torusJsDefault = parcelHelpers.interopDefault(_torusJs);
var _touchpadOffJs = require("./icons/touchpad-off.js");
var _touchpadOffJsDefault = parcelHelpers.interopDefault(_touchpadOffJs);
var _touchpadJs = require("./icons/touchpad.js");
var _touchpadJsDefault = parcelHelpers.interopDefault(_touchpadJs);
var _towerControlJs = require("./icons/tower-control.js");
var _towerControlJsDefault = parcelHelpers.interopDefault(_towerControlJs);
var _toyBrickJs = require("./icons/toy-brick.js");
var _toyBrickJsDefault = parcelHelpers.interopDefault(_toyBrickJs);
var _trafficConeJs = require("./icons/traffic-cone.js");
var _trafficConeJsDefault = parcelHelpers.interopDefault(_trafficConeJs);
var _tractorJs = require("./icons/tractor.js");
var _tractorJsDefault = parcelHelpers.interopDefault(_tractorJs);
var _trainFrontJs = require("./icons/train-front.js");
var _trainFrontJsDefault = parcelHelpers.interopDefault(_trainFrontJs);
var _trainFrontTunnelJs = require("./icons/train-front-tunnel.js");
var _trainFrontTunnelJsDefault = parcelHelpers.interopDefault(_trainFrontTunnelJs);
var _trainTrackJs = require("./icons/train-track.js");
var _trainTrackJsDefault = parcelHelpers.interopDefault(_trainTrackJs);
var _trash2Js = require("./icons/trash-2.js");
var _trash2JsDefault = parcelHelpers.interopDefault(_trash2Js);
var _transgenderJs = require("./icons/transgender.js");
var _transgenderJsDefault = parcelHelpers.interopDefault(_transgenderJs);
var _trashJs = require("./icons/trash.js");
var _trashJsDefault = parcelHelpers.interopDefault(_trashJs);
var _treeDeciduousJs = require("./icons/tree-deciduous.js");
var _treeDeciduousJsDefault = parcelHelpers.interopDefault(_treeDeciduousJs);
var _treePineJs = require("./icons/tree-pine.js");
var _treePineJsDefault = parcelHelpers.interopDefault(_treePineJs);
var _treesJs = require("./icons/trees.js");
var _treesJsDefault = parcelHelpers.interopDefault(_treesJs);
var _trelloJs = require("./icons/trello.js");
var _trelloJsDefault = parcelHelpers.interopDefault(_trelloJs);
var _trendingDownJs = require("./icons/trending-down.js");
var _trendingDownJsDefault = parcelHelpers.interopDefault(_trendingDownJs);
var _trendingUpDownJs = require("./icons/trending-up-down.js");
var _trendingUpDownJsDefault = parcelHelpers.interopDefault(_trendingUpDownJs);
var _trendingUpJs = require("./icons/trending-up.js");
var _trendingUpJsDefault = parcelHelpers.interopDefault(_trendingUpJs);
var _triangleDashedJs = require("./icons/triangle-dashed.js");
var _triangleDashedJsDefault = parcelHelpers.interopDefault(_triangleDashedJs);
var _triangleRightJs = require("./icons/triangle-right.js");
var _triangleRightJsDefault = parcelHelpers.interopDefault(_triangleRightJs);
var _triangleJs = require("./icons/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _trophyJs = require("./icons/trophy.js");
var _trophyJsDefault = parcelHelpers.interopDefault(_trophyJs);
var _truckElectricJs = require("./icons/truck-electric.js");
var _truckElectricJsDefault = parcelHelpers.interopDefault(_truckElectricJs);
var _truckJs = require("./icons/truck.js");
var _truckJsDefault = parcelHelpers.interopDefault(_truckJs);
var _turtleJs = require("./icons/turtle.js");
var _turtleJsDefault = parcelHelpers.interopDefault(_turtleJs);
var _tvMinimalPlayJs = require("./icons/tv-minimal-play.js");
var _tvMinimalPlayJsDefault = parcelHelpers.interopDefault(_tvMinimalPlayJs);
var _tvJs = require("./icons/tv.js");
var _tvJsDefault = parcelHelpers.interopDefault(_tvJs);
var _twitchJs = require("./icons/twitch.js");
var _twitchJsDefault = parcelHelpers.interopDefault(_twitchJs);
var _twitterJs = require("./icons/twitter.js");
var _twitterJsDefault = parcelHelpers.interopDefault(_twitterJs);
var _typeOutlineJs = require("./icons/type-outline.js");
var _typeOutlineJsDefault = parcelHelpers.interopDefault(_typeOutlineJs);
var _typeJs = require("./icons/type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
var _umbrellaOffJs = require("./icons/umbrella-off.js");
var _umbrellaOffJsDefault = parcelHelpers.interopDefault(_umbrellaOffJs);
var _umbrellaJs = require("./icons/umbrella.js");
var _umbrellaJsDefault = parcelHelpers.interopDefault(_umbrellaJs);
var _underlineJs = require("./icons/underline.js");
var _underlineJsDefault = parcelHelpers.interopDefault(_underlineJs);
var _undo2Js = require("./icons/undo-2.js");
var _undo2JsDefault = parcelHelpers.interopDefault(_undo2Js);
var _undoDotJs = require("./icons/undo-dot.js");
var _undoDotJsDefault = parcelHelpers.interopDefault(_undoDotJs);
var _undoJs = require("./icons/undo.js");
var _undoJsDefault = parcelHelpers.interopDefault(_undoJs);
var _unfoldHorizontalJs = require("./icons/unfold-horizontal.js");
var _unfoldHorizontalJsDefault = parcelHelpers.interopDefault(_unfoldHorizontalJs);
var _unfoldVerticalJs = require("./icons/unfold-vertical.js");
var _unfoldVerticalJsDefault = parcelHelpers.interopDefault(_unfoldVerticalJs);
var _ungroupJs = require("./icons/ungroup.js");
var _ungroupJsDefault = parcelHelpers.interopDefault(_ungroupJs);
var _unlink2Js = require("./icons/unlink-2.js");
var _unlink2JsDefault = parcelHelpers.interopDefault(_unlink2Js);
var _unlinkJs = require("./icons/unlink.js");
var _unlinkJsDefault = parcelHelpers.interopDefault(_unlinkJs);
var _unplugJs = require("./icons/unplug.js");
var _unplugJsDefault = parcelHelpers.interopDefault(_unplugJs);
var _uploadJs = require("./icons/upload.js");
var _uploadJsDefault = parcelHelpers.interopDefault(_uploadJs);
var _usbJs = require("./icons/usb.js");
var _usbJsDefault = parcelHelpers.interopDefault(_usbJs);
var _userCheckJs = require("./icons/user-check.js");
var _userCheckJsDefault = parcelHelpers.interopDefault(_userCheckJs);
var _userLockJs = require("./icons/user-lock.js");
var _userLockJsDefault = parcelHelpers.interopDefault(_userLockJs);
var _userCogJs = require("./icons/user-cog.js");
var _userCogJsDefault = parcelHelpers.interopDefault(_userCogJs);
var _userMinusJs = require("./icons/user-minus.js");
var _userMinusJsDefault = parcelHelpers.interopDefault(_userMinusJs);
var _userPenJs = require("./icons/user-pen.js");
var _userPenJsDefault = parcelHelpers.interopDefault(_userPenJs);
var _userPlusJs = require("./icons/user-plus.js");
var _userPlusJsDefault = parcelHelpers.interopDefault(_userPlusJs);
var _userRoundPenJs = require("./icons/user-round-pen.js");
var _userRoundPenJsDefault = parcelHelpers.interopDefault(_userRoundPenJs);
var _userRoundSearchJs = require("./icons/user-round-search.js");
var _userRoundSearchJsDefault = parcelHelpers.interopDefault(_userRoundSearchJs);
var _userSearchJs = require("./icons/user-search.js");
var _userSearchJsDefault = parcelHelpers.interopDefault(_userSearchJs);
var _userXJs = require("./icons/user-x.js");
var _userXJsDefault = parcelHelpers.interopDefault(_userXJs);
var _userJs = require("./icons/user.js");
var _userJsDefault = parcelHelpers.interopDefault(_userJs);
var _usersJs = require("./icons/users.js");
var _usersJsDefault = parcelHelpers.interopDefault(_usersJs);
var _utilityPoleJs = require("./icons/utility-pole.js");
var _utilityPoleJsDefault = parcelHelpers.interopDefault(_utilityPoleJs);
var _variableJs = require("./icons/variable.js");
var _variableJsDefault = parcelHelpers.interopDefault(_variableJs);
var _vaultJs = require("./icons/vault.js");
var _vaultJsDefault = parcelHelpers.interopDefault(_vaultJs);
var _veganJs = require("./icons/vegan.js");
var _veganJsDefault = parcelHelpers.interopDefault(_veganJs);
var _venetianMaskJs = require("./icons/venetian-mask.js");
var _venetianMaskJsDefault = parcelHelpers.interopDefault(_venetianMaskJs);
var _venusAndMarsJs = require("./icons/venus-and-mars.js");
var _venusAndMarsJsDefault = parcelHelpers.interopDefault(_venusAndMarsJs);
var _venusJs = require("./icons/venus.js");
var _venusJsDefault = parcelHelpers.interopDefault(_venusJs);
var _vibrateJs = require("./icons/vibrate.js");
var _vibrateJsDefault = parcelHelpers.interopDefault(_vibrateJs);
var _vibrateOffJs = require("./icons/vibrate-off.js");
var _vibrateOffJsDefault = parcelHelpers.interopDefault(_vibrateOffJs);
var _videoOffJs = require("./icons/video-off.js");
var _videoOffJsDefault = parcelHelpers.interopDefault(_videoOffJs);
var _videoJs = require("./icons/video.js");
var _videoJsDefault = parcelHelpers.interopDefault(_videoJs);
var _videotapeJs = require("./icons/videotape.js");
var _videotapeJsDefault = parcelHelpers.interopDefault(_videotapeJs);
var _viewJs = require("./icons/view.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _voicemailJs = require("./icons/voicemail.js");
var _voicemailJsDefault = parcelHelpers.interopDefault(_voicemailJs);
var _volume1Js = require("./icons/volume-1.js");
var _volume1JsDefault = parcelHelpers.interopDefault(_volume1Js);
var _volume2Js = require("./icons/volume-2.js");
var _volume2JsDefault = parcelHelpers.interopDefault(_volume2Js);
var _volleyballJs = require("./icons/volleyball.js");
var _volleyballJsDefault = parcelHelpers.interopDefault(_volleyballJs);
var _volumeOffJs = require("./icons/volume-off.js");
var _volumeOffJsDefault = parcelHelpers.interopDefault(_volumeOffJs);
var _volumeXJs = require("./icons/volume-x.js");
var _volumeXJsDefault = parcelHelpers.interopDefault(_volumeXJs);
var _volumeJs = require("./icons/volume.js");
var _volumeJsDefault = parcelHelpers.interopDefault(_volumeJs);
var _voteJs = require("./icons/vote.js");
var _voteJsDefault = parcelHelpers.interopDefault(_voteJs);
var _walletCardsJs = require("./icons/wallet-cards.js");
var _walletCardsJsDefault = parcelHelpers.interopDefault(_walletCardsJs);
var _walletJs = require("./icons/wallet.js");
var _walletJsDefault = parcelHelpers.interopDefault(_walletJs);
var _wallpaperJs = require("./icons/wallpaper.js");
var _wallpaperJsDefault = parcelHelpers.interopDefault(_wallpaperJs);
var _warehouseJs = require("./icons/warehouse.js");
var _warehouseJsDefault = parcelHelpers.interopDefault(_warehouseJs);
var _wandJs = require("./icons/wand.js");
var _wandJsDefault = parcelHelpers.interopDefault(_wandJs);
var _washingMachineJs = require("./icons/washing-machine.js");
var _washingMachineJsDefault = parcelHelpers.interopDefault(_washingMachineJs);
var _wavesLadderJs = require("./icons/waves-ladder.js");
var _wavesLadderJsDefault = parcelHelpers.interopDefault(_wavesLadderJs);
var _watchJs = require("./icons/watch.js");
var _watchJsDefault = parcelHelpers.interopDefault(_watchJs);
var _wavesJs = require("./icons/waves.js");
var _wavesJsDefault = parcelHelpers.interopDefault(_wavesJs);
var _waypointsJs = require("./icons/waypoints.js");
var _waypointsJsDefault = parcelHelpers.interopDefault(_waypointsJs);
var _webcamJs = require("./icons/webcam.js");
var _webcamJsDefault = parcelHelpers.interopDefault(_webcamJs);
var _webhookOffJs = require("./icons/webhook-off.js");
var _webhookOffJsDefault = parcelHelpers.interopDefault(_webhookOffJs);
var _webhookJs = require("./icons/webhook.js");
var _webhookJsDefault = parcelHelpers.interopDefault(_webhookJs);
var _weightJs = require("./icons/weight.js");
var _weightJsDefault = parcelHelpers.interopDefault(_weightJs);
var _wheatOffJs = require("./icons/wheat-off.js");
var _wheatOffJsDefault = parcelHelpers.interopDefault(_wheatOffJs);
var _wheatJs = require("./icons/wheat.js");
var _wheatJsDefault = parcelHelpers.interopDefault(_wheatJs);
var _wifiHighJs = require("./icons/wifi-high.js");
var _wifiHighJsDefault = parcelHelpers.interopDefault(_wifiHighJs);
var _wholeWordJs = require("./icons/whole-word.js");
var _wholeWordJsDefault = parcelHelpers.interopDefault(_wholeWordJs);
var _wifiLowJs = require("./icons/wifi-low.js");
var _wifiLowJsDefault = parcelHelpers.interopDefault(_wifiLowJs);
var _wifiOffJs = require("./icons/wifi-off.js");
var _wifiOffJsDefault = parcelHelpers.interopDefault(_wifiOffJs);
var _wifiPenJs = require("./icons/wifi-pen.js");
var _wifiPenJsDefault = parcelHelpers.interopDefault(_wifiPenJs);
var _wifiZeroJs = require("./icons/wifi-zero.js");
var _wifiZeroJsDefault = parcelHelpers.interopDefault(_wifiZeroJs);
var _wifiJs = require("./icons/wifi.js");
var _wifiJsDefault = parcelHelpers.interopDefault(_wifiJs);
var _windArrowDownJs = require("./icons/wind-arrow-down.js");
var _windArrowDownJsDefault = parcelHelpers.interopDefault(_windArrowDownJs);
var _windJs = require("./icons/wind.js");
var _windJsDefault = parcelHelpers.interopDefault(_windJs);
var _wineOffJs = require("./icons/wine-off.js");
var _wineOffJsDefault = parcelHelpers.interopDefault(_wineOffJs);
var _wineJs = require("./icons/wine.js");
var _wineJsDefault = parcelHelpers.interopDefault(_wineJs);
var _workflowJs = require("./icons/workflow.js");
var _workflowJsDefault = parcelHelpers.interopDefault(_workflowJs);
var _wormJs = require("./icons/worm.js");
var _wormJsDefault = parcelHelpers.interopDefault(_wormJs);
var _wrapTextJs = require("./icons/wrap-text.js");
var _wrapTextJsDefault = parcelHelpers.interopDefault(_wrapTextJs);
var _wrenchJs = require("./icons/wrench.js");
var _wrenchJsDefault = parcelHelpers.interopDefault(_wrenchJs);
var _xJs = require("./icons/x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _youtubeJs = require("./icons/youtube.js");
var _youtubeJsDefault = parcelHelpers.interopDefault(_youtubeJs);
var _zapOffJs = require("./icons/zap-off.js");
var _zapOffJsDefault = parcelHelpers.interopDefault(_zapOffJs);
var _zapJs = require("./icons/zap.js");
var _zapJsDefault = parcelHelpers.interopDefault(_zapJs);
var _zoomInJs = require("./icons/zoom-in.js");
var _zoomInJsDefault = parcelHelpers.interopDefault(_zoomInJs);
var _zoomOutJs = require("./icons/zoom-out.js");
var _zoomOutJsDefault = parcelHelpers.interopDefault(_zoomOutJs);
var _arrowDown01Js = require("./icons/arrow-down-0-1.js");
var _arrowDown01JsDefault = parcelHelpers.interopDefault(_arrowDown01Js);
var _arrowDown10Js = require("./icons/arrow-down-1-0.js");
var _arrowDown10JsDefault = parcelHelpers.interopDefault(_arrowDown10Js);
var _arrowUp01Js = require("./icons/arrow-up-0-1.js");
var _arrowUp01JsDefault = parcelHelpers.interopDefault(_arrowUp01Js);
var _arrowUp10Js = require("./icons/arrow-up-1-0.js");
var _arrowUp10JsDefault = parcelHelpers.interopDefault(_arrowUp10Js);
var _createLucideIconJs = require("./createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
var _iconJs = require("./Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);

},{"./icons/index.js":false,"./icons/alarm-clock-check.js":false,"./icons/alarm-clock-minus.js":false,"./icons/alarm-clock-plus.js":false,"./icons/arrow-down-a-z.js":false,"./icons/arrow-down-wide-narrow.js":false,"./icons/arrow-down-z-a.js":false,"./icons/arrow-up-a-z.js":false,"./icons/arrow-up-narrow-wide.js":false,"./icons/arrow-up-z-a.js":false,"./icons/axis-3d.js":false,"./icons/badge-check.js":false,"./icons/between-horizontal-end.js":false,"./icons/between-horizontal-start.js":false,"./icons/book-dashed.js":false,"./icons/braces.js":false,"./icons/captions.js":false,"./icons/chart-area.js":false,"./icons/chart-bar-big.js":false,"./icons/chart-bar.js":false,"./icons/chart-candlestick.js":false,"./icons/chart-column-big.js":false,"./icons/chart-column-increasing.js":false,"./icons/chart-line.js":false,"./icons/chart-no-axes-column-increasing.js":false,"./icons/chart-column.js":false,"./icons/chart-no-axes-column.js":false,"./icons/chart-no-axes-gantt.js":false,"./icons/chart-pie.js":false,"./icons/chart-scatter.js":false,"./icons/circle-alert.js":false,"./icons/circle-arrow-down.js":false,"./icons/circle-arrow-out-down-left.js":false,"./icons/circle-arrow-left.js":false,"./icons/circle-arrow-out-down-right.js":false,"./icons/circle-arrow-out-up-left.js":false,"./icons/circle-arrow-out-up-right.js":false,"./icons/circle-arrow-right.js":false,"./icons/circle-arrow-up.js":false,"./icons/circle-check.js":false,"./icons/circle-check-big.js":false,"./icons/circle-chevron-down.js":false,"./icons/circle-chevron-left.js":false,"./icons/circle-chevron-right.js":false,"./icons/circle-chevron-up.js":false,"./icons/circle-divide.js":false,"./icons/circle-gauge.js":false,"./icons/circle-help.js":false,"./icons/circle-minus.js":false,"./icons/circle-parking-off.js":false,"./icons/circle-parking.js":false,"./icons/circle-pause.js":false,"./icons/circle-play.js":false,"./icons/circle-percent.js":false,"./icons/circle-power.js":false,"./icons/circle-plus.js":false,"./icons/circle-slash-2.js":false,"./icons/circle-stop.js":false,"./icons/circle-user-round.js":false,"./icons/circle-user.js":false,"./icons/circle-x.js":false,"./icons/clipboard-pen-line.js":false,"./icons/clipboard-pen.js":false,"./icons/cloud-download.js":false,"./icons/cloud-upload.js":false,"./icons/code-xml.js":false,"./icons/columns-2.js":false,"./icons/columns-3-cog.js":false,"./icons/columns-3.js":false,"./icons/contact-round.js":false,"./icons/diamond-percent.js":false,"./icons/earth.js":false,"./icons/ellipsis-vertical.js":false,"./icons/ellipsis.js":false,"./icons/file-axis-3d.js":false,"./icons/file-chart-column.js":false,"./icons/file-chart-column-increasing.js":false,"./icons/file-chart-line.js":false,"./icons/file-chart-pie.js":false,"./icons/file-cog.js":false,"./icons/file-pen-line.js":false,"./icons/file-pen.js":false,"./icons/folder-cog.js":false,"./icons/folder-pen.js":false,"./icons/funnel-x.js":false,"./icons/funnel.js":false,"./icons/git-commit-horizontal.js":false,"./icons/grid-2x2-check.js":false,"./icons/grid-2x2-plus.js":false,"./icons/grid-2x2-x.js":false,"./icons/grid-2x2.js":false,"./icons/grid-3x3.js":false,"./icons/hand-helping.js":false,"./icons/house.js":false,"./icons/ice-cream-bowl.js":false,"./icons/ice-cream-cone.js":false,"./icons/indent-decrease.js":false,"./icons/indent-increase.js":false,"./icons/laptop-minimal.js":false,"./icons/layers.js":false,"./icons/loader-circle.js":false,"./icons/lock-keyhole-open.js":false,"./icons/lock-open.js":false,"./icons/mic-vocal.js":false,"./icons/move-3d.js":false,"./icons/octagon-alert.js":false,"./icons/octagon-pause.js":false,"./icons/octagon-x.js":false,"./icons/paintbrush-vertical.js":false,"./icons/panel-bottom-dashed.js":false,"./icons/panel-left-dashed.js":false,"./icons/panel-left-close.js":false,"./icons/panel-left-open.js":false,"./icons/panel-left.js":false,"./icons/panel-right-dashed.js":false,"./icons/panel-top-dashed.js":false,"./icons/panels-top-left.js":false,"./icons/pen-line.js":false,"./icons/pen.js":false,"./icons/plug-zap.js":false,"./icons/rectangle-ellipsis.js":false,"./icons/rotate-3d.js":false,"./icons/rows-2.js":false,"./icons/rows-3.js":false,"./icons/scale-3d.js":false,"./icons/send-horizontal.js":false,"./icons/shield-x.js":false,"./icons/sliders-vertical.js":false,"./icons/sparkles.js":false,"./icons/square-activity.js":false,"./icons/square-arrow-down-left.js":false,"./icons/square-arrow-down-right.js":false,"./icons/square-arrow-down.js":false,"./icons/square-arrow-out-down-right.js":false,"./icons/square-arrow-out-down-left.js":false,"./icons/square-arrow-left.js":false,"./icons/square-arrow-out-up-left.js":false,"./icons/square-arrow-out-up-right.js":false,"./icons/square-arrow-right.js":false,"./icons/square-arrow-up-left.js":false,"./icons/square-arrow-up-right.js":false,"./icons/square-arrow-up.js":false,"./icons/square-asterisk.js":false,"./icons/square-bottom-dashed-scissors.js":false,"./icons/square-chart-gantt.js":false,"./icons/square-check-big.js":false,"./icons/square-chevron-down.js":false,"./icons/square-check.js":false,"./icons/square-chevron-left.js":false,"./icons/square-chevron-right.js":false,"./icons/square-code.js":false,"./icons/square-chevron-up.js":false,"./icons/square-dashed-mouse-pointer.js":false,"./icons/square-dashed.js":false,"./icons/square-dashed-kanban.js":false,"./icons/square-divide.js":false,"./icons/square-dot.js":false,"./icons/square-equal.js":false,"./icons/square-function.js":false,"./icons/square-kanban.js":false,"./icons/square-library.js":false,"./icons/square-m.js":false,"./icons/square-menu.js":false,"./icons/square-minus.js":false,"./icons/square-mouse-pointer.js":false,"./icons/square-parking-off.js":false,"./icons/square-parking.js":false,"./icons/square-pen.js":false,"./icons/square-percent.js":false,"./icons/square-pi.js":false,"./icons/square-play.js":false,"./icons/square-pilcrow.js":false,"./icons/square-plus.js":false,"./icons/square-power.js":false,"./icons/square-scissors.js":false,"./icons/square-sigma.js":false,"./icons/square-slash.js":false,"./icons/square-split-horizontal.js":false,"./icons/square-terminal.js":false,"./icons/square-split-vertical.js":false,"./icons/square-user-round.js":false,"./icons/square-user.js":false,"./icons/square-x.js":false,"./icons/test-tube-diagonal.js":false,"./icons/text-select.js":false,"./icons/tram-front.js":false,"./icons/tree-palm.js":false,"./icons/triangle-alert.js":false,"./icons/tv-minimal.js":false,"./icons/university.js":false,"./icons/user-round-check.js":false,"./icons/user-round-cog.js":false,"./icons/user-round-minus.js":false,"./icons/user-round-plus.js":false,"./icons/user-round-x.js":false,"./icons/user-round.js":false,"./icons/users-round.js":false,"./icons/utensils-crossed.js":false,"./icons/utensils.js":false,"./icons/wallet-minimal.js":false,"./icons/wand-sparkles.js":false,"./icons/a-arrow-down.js":false,"./icons/a-arrow-up.js":false,"./icons/a-large-small.js":false,"./icons/accessibility.js":false,"./icons/activity.js":false,"./icons/air-vent.js":false,"./icons/airplay.js":false,"./icons/alarm-clock-off.js":false,"./icons/alarm-clock.js":false,"./icons/alarm-smoke.js":false,"./icons/align-center-horizontal.js":false,"./icons/album.js":false,"./icons/align-center-vertical.js":false,"./icons/align-center.js":false,"./icons/align-end-horizontal.js":false,"./icons/align-end-vertical.js":false,"./icons/align-horizontal-distribute-center.js":false,"./icons/align-horizontal-distribute-end.js":false,"./icons/align-horizontal-distribute-start.js":false,"./icons/align-horizontal-justify-center.js":false,"./icons/align-horizontal-justify-end.js":false,"./icons/align-horizontal-justify-start.js":false,"./icons/align-horizontal-space-around.js":false,"./icons/align-horizontal-space-between.js":false,"./icons/align-justify.js":false,"./icons/align-right.js":false,"./icons/align-left.js":false,"./icons/align-start-horizontal.js":false,"./icons/align-vertical-distribute-center.js":false,"./icons/align-start-vertical.js":false,"./icons/align-vertical-distribute-start.js":false,"./icons/align-vertical-distribute-end.js":false,"./icons/align-vertical-justify-center.js":false,"./icons/align-vertical-justify-end.js":false,"./icons/align-vertical-justify-start.js":false,"./icons/align-vertical-space-around.js":false,"./icons/align-vertical-space-between.js":false,"./icons/ambulance.js":false,"./icons/ampersand.js":false,"./icons/ampersands.js":false,"./icons/amphora.js":false,"./icons/anchor.js":false,"./icons/annoyed.js":false,"./icons/angry.js":false,"./icons/antenna.js":false,"./icons/app-window-mac.js":false,"./icons/anvil.js":false,"./icons/aperture.js":false,"./icons/app-window.js":false,"./icons/apple.js":false,"./icons/archive-restore.js":false,"./icons/archive-x.js":false,"./icons/archive.js":false,"./icons/armchair.js":false,"./icons/arrow-big-down-dash.js":false,"./icons/arrow-big-down.js":false,"./icons/arrow-big-left-dash.js":false,"./icons/arrow-big-left.js":false,"./icons/arrow-big-right.js":false,"./icons/arrow-big-up-dash.js":false,"./icons/arrow-big-right-dash.js":false,"./icons/arrow-big-up.js":false,"./icons/arrow-down-from-line.js":false,"./icons/arrow-down-left.js":false,"./icons/arrow-down-narrow-wide.js":false,"./icons/arrow-down-right.js":false,"./icons/arrow-down-to-dot.js":false,"./icons/arrow-down-to-line.js":false,"./icons/arrow-down-up.js":false,"./icons/arrow-down.js":false,"./icons/arrow-left-from-line.js":false,"./icons/arrow-left-right.js":false,"./icons/arrow-left-to-line.js":false,"./icons/arrow-left.js":false,"./icons/arrow-right-from-line.js":false,"./icons/arrow-right-left.js":false,"./icons/arrow-right-to-line.js":false,"./icons/arrow-right.js":false,"./icons/arrow-up-down.js":false,"./icons/arrow-up-from-dot.js":false,"./icons/arrow-up-from-line.js":false,"./icons/arrow-up-right.js":false,"./icons/arrow-up-left.js":false,"./icons/arrow-up-to-line.js":false,"./icons/arrow-up-wide-narrow.js":false,"./icons/arrow-up.js":false,"./icons/arrows-up-from-line.js":false,"./icons/asterisk.js":false,"./icons/at-sign.js":false,"./icons/atom.js":false,"./icons/audio-lines.js":false,"./icons/audio-waveform.js":false,"./icons/award.js":false,"./icons/axe.js":false,"./icons/baby.js":false,"./icons/backpack.js":false,"./icons/badge-alert.js":false,"./icons/badge-cent.js":false,"./icons/badge-dollar-sign.js":false,"./icons/badge-euro.js":false,"./icons/badge-help.js":false,"./icons/badge-indian-rupee.js":false,"./icons/badge-minus.js":false,"./icons/badge-japanese-yen.js":false,"./icons/badge-info.js":false,"./icons/badge-percent.js":false,"./icons/badge-plus.js":false,"./icons/badge-russian-ruble.js":false,"./icons/badge-pound-sterling.js":false,"./icons/badge-swiss-franc.js":false,"./icons/badge-x.js":false,"./icons/badge.js":false,"./icons/baggage-claim.js":false,"./icons/ban.js":false,"./icons/banana.js":false,"./icons/bandage.js":false,"./icons/banknote-arrow-down.js":false,"./icons/banknote-arrow-up.js":false,"./icons/banknote-x.js":false,"./icons/banknote.js":false,"./icons/barcode.js":false,"./icons/baseline.js":false,"./icons/bath.js":false,"./icons/battery-charging.js":false,"./icons/battery-full.js":false,"./icons/battery-low.js":false,"./icons/battery-medium.js":false,"./icons/battery-plus.js":false,"./icons/battery-warning.js":false,"./icons/battery.js":false,"./icons/beaker.js":false,"./icons/bean-off.js":false,"./icons/bed-double.js":false,"./icons/bed-single.js":false,"./icons/bean.js":false,"./icons/bed.js":false,"./icons/beef.js":false,"./icons/beer-off.js":false,"./icons/beer.js":false,"./icons/bell-dot.js":false,"./icons/bell-electric.js":false,"./icons/bell-off.js":false,"./icons/bell-minus.js":false,"./icons/bell-plus.js":false,"./icons/bell-ring.js":false,"./icons/bell.js":false,"./icons/between-vertical-end.js":false,"./icons/between-vertical-start.js":false,"./icons/biceps-flexed.js":false,"./icons/bike.js":false,"./icons/binary.js":false,"./icons/binoculars.js":false,"./icons/biohazard.js":false,"./icons/bird.js":false,"./icons/bitcoin.js":false,"./icons/blend.js":false,"./icons/blinds.js":false,"./icons/blocks.js":false,"./icons/bluetooth-connected.js":false,"./icons/bluetooth-off.js":false,"./icons/bluetooth-searching.js":false,"./icons/bluetooth.js":false,"./icons/bold.js":false,"./icons/bolt.js":false,"./icons/bomb.js":false,"./icons/bone.js":false,"./icons/book-a.js":false,"./icons/book-alert.js":false,"./icons/book-audio.js":false,"./icons/book-check.js":false,"./icons/book-copy.js":false,"./icons/book-down.js":false,"./icons/book-headphones.js":false,"./icons/book-heart.js":false,"./icons/book-image.js":false,"./icons/book-key.js":false,"./icons/book-lock.js":false,"./icons/book-marked.js":false,"./icons/book-minus.js":false,"./icons/book-open-check.js":false,"./icons/book-open-text.js":false,"./icons/book-open.js":false,"./icons/book-plus.js":false,"./icons/book-text.js":false,"./icons/book-up-2.js":false,"./icons/book-type.js":false,"./icons/book-up.js":false,"./icons/book-user.js":false,"./icons/book-x.js":false,"./icons/book.js":false,"./icons/bookmark-minus.js":false,"./icons/bookmark-check.js":false,"./icons/bookmark-plus.js":false,"./icons/bookmark-x.js":false,"./icons/bookmark.js":false,"./icons/boom-box.js":false,"./icons/bot-message-square.js":false,"./icons/bot-off.js":false,"./icons/bot.js":false,"./icons/bow-arrow.js":false,"./icons/box.js":false,"./icons/boxes.js":false,"./icons/brackets.js":false,"./icons/brain-circuit.js":false,"./icons/brain-cog.js":false,"./icons/brain.js":false,"./icons/brick-wall.js":false,"./icons/brick-wall-fire.js":false,"./icons/briefcase-business.js":false,"./icons/briefcase-conveyor-belt.js":false,"./icons/briefcase-medical.js":false,"./icons/briefcase.js":false,"./icons/bring-to-front.js":false,"./icons/brush-cleaning.js":false,"./icons/brush.js":false,"./icons/bubbles.js":false,"./icons/bug-off.js":false,"./icons/bug-play.js":false,"./icons/bug.js":false,"./icons/building-2.js":false,"./icons/building.js":false,"./icons/bus-front.js":false,"./icons/bus.js":false,"./icons/cable-car.js":false,"./icons/cable.js":false,"./icons/cake-slice.js":false,"./icons/cake.js":false,"./icons/calculator.js":false,"./icons/calendar-1.js":false,"./icons/calendar-arrow-down.js":false,"./icons/calendar-arrow-up.js":false,"./icons/calendar-check-2.js":false,"./icons/calendar-check.js":false,"./icons/calendar-clock.js":false,"./icons/calendar-days.js":false,"./icons/calendar-cog.js":false,"./icons/calendar-fold.js":false,"./icons/calendar-heart.js":false,"./icons/calendar-minus-2.js":false,"./icons/calendar-minus.js":false,"./icons/calendar-off.js":false,"./icons/calendar-plus-2.js":false,"./icons/calendar-plus.js":false,"./icons/calendar-range.js":false,"./icons/calendar-search.js":false,"./icons/calendar-x-2.js":false,"./icons/calendar-sync.js":false,"./icons/calendar-x.js":false,"./icons/calendar.js":false,"./icons/camera-off.js":false,"./icons/camera.js":false,"./icons/candy-cane.js":false,"./icons/candy-off.js":false,"./icons/cannabis.js":false,"./icons/candy.js":false,"./icons/captions-off.js":false,"./icons/car-front.js":false,"./icons/car.js":false,"./icons/car-taxi-front.js":false,"./icons/caravan.js":false,"./icons/card-sim.js":false,"./icons/carrot.js":false,"./icons/case-lower.js":false,"./icons/case-sensitive.js":false,"./icons/case-upper.js":false,"./icons/cassette-tape.js":false,"./icons/cast.js":false,"./icons/castle.js":false,"./icons/cat.js":false,"./icons/cctv.js":false,"./icons/chart-bar-decreasing.js":false,"./icons/chart-bar-increasing.js":false,"./icons/chart-bar-stacked.js":false,"./icons/chart-column-decreasing.js":false,"./icons/chart-column-stacked.js":false,"./icons/chart-gantt.js":false,"./icons/chart-network.js":false,"./icons/chart-no-axes-column-decreasing.js":false,"./icons/chart-no-axes-combined.js":false,"./icons/chart-spline.js":false,"./icons/check-check.js":false,"./icons/check-line.js":false,"./icons/check.js":false,"./icons/chef-hat.js":false,"./icons/cherry.js":false,"./icons/chevron-down.js":false,"./icons/chevron-first.js":false,"./icons/chevron-last.js":false,"./icons/chevron-left.js":"ekoIq","./icons/chevron-right.js":"bTPZb","./icons/chevron-up.js":false,"./icons/chevrons-down-up.js":false,"./icons/chevrons-down.js":false,"./icons/chevrons-left-right-ellipsis.js":false,"./icons/chevrons-left-right.js":false,"./icons/chevrons-left.js":false,"./icons/chevrons-right-left.js":false,"./icons/chevrons-right.js":false,"./icons/chevrons-up-down.js":false,"./icons/chevrons-up.js":false,"./icons/chrome.js":false,"./icons/church.js":false,"./icons/cigarette.js":false,"./icons/cigarette-off.js":false,"./icons/circle-dashed.js":false,"./icons/circle-dollar-sign.js":false,"./icons/circle-dot-dashed.js":false,"./icons/circle-dot.js":false,"./icons/circle-ellipsis.js":false,"./icons/circle-equal.js":false,"./icons/circle-fading-arrow-up.js":false,"./icons/circle-fading-plus.js":false,"./icons/circle-off.js":false,"./icons/circle-pound-sterling.js":false,"./icons/circle-slash.js":false,"./icons/circle-small.js":false,"./icons/circle.js":false,"./icons/circuit-board.js":false,"./icons/citrus.js":false,"./icons/clapperboard.js":false,"./icons/clipboard-check.js":false,"./icons/clipboard-copy.js":false,"./icons/clipboard-list.js":false,"./icons/clipboard-minus.js":false,"./icons/clipboard-paste.js":false,"./icons/clipboard-plus.js":false,"./icons/clipboard-type.js":false,"./icons/clipboard-x.js":false,"./icons/clipboard.js":false,"./icons/clock-1.js":false,"./icons/clock-10.js":false,"./icons/clock-11.js":false,"./icons/clock-12.js":false,"./icons/clock-2.js":false,"./icons/clock-4.js":false,"./icons/clock-3.js":false,"./icons/clock-5.js":false,"./icons/clock-6.js":false,"./icons/clock-7.js":false,"./icons/clock-8.js":false,"./icons/clock-alert.js":false,"./icons/clock-9.js":false,"./icons/clock-arrow-down.js":false,"./icons/clock-arrow-up.js":false,"./icons/clock-fading.js":false,"./icons/clock-plus.js":false,"./icons/clock.js":false,"./icons/cloud-alert.js":false,"./icons/cloud-check.js":false,"./icons/cloud-cog.js":false,"./icons/cloud-drizzle.js":false,"./icons/cloud-fog.js":false,"./icons/cloud-hail.js":false,"./icons/cloud-moon-rain.js":false,"./icons/cloud-lightning.js":false,"./icons/cloud-moon.js":false,"./icons/cloud-off.js":false,"./icons/cloud-rain-wind.js":false,"./icons/cloud-rain.js":false,"./icons/cloud-snow.js":false,"./icons/cloud-sun-rain.js":false,"./icons/cloud-sun.js":false,"./icons/cloud.js":false,"./icons/cloudy.js":false,"./icons/clover.js":false,"./icons/club.js":false,"./icons/code.js":false,"./icons/codepen.js":false,"./icons/codesandbox.js":false,"./icons/coffee.js":false,"./icons/cog.js":false,"./icons/coins.js":false,"./icons/columns-4.js":false,"./icons/combine.js":false,"./icons/command.js":false,"./icons/compass.js":false,"./icons/component.js":false,"./icons/concierge-bell.js":false,"./icons/computer.js":false,"./icons/cone.js":false,"./icons/construction.js":false,"./icons/contact.js":false,"./icons/container.js":false,"./icons/contrast.js":false,"./icons/cookie.js":false,"./icons/cooking-pot.js":false,"./icons/copy-check.js":false,"./icons/copy-minus.js":false,"./icons/copy-plus.js":false,"./icons/copy-slash.js":false,"./icons/copy-x.js":false,"./icons/copy.js":false,"./icons/copyright.js":false,"./icons/copyleft.js":false,"./icons/corner-down-left.js":false,"./icons/corner-down-right.js":false,"./icons/corner-left-down.js":false,"./icons/corner-left-up.js":false,"./icons/corner-right-up.js":false,"./icons/corner-up-left.js":false,"./icons/corner-right-down.js":false,"./icons/corner-up-right.js":false,"./icons/creative-commons.js":false,"./icons/cpu.js":false,"./icons/croissant.js":false,"./icons/credit-card.js":false,"./icons/crop.js":false,"./icons/cross.js":false,"./icons/crosshair.js":false,"./icons/crown.js":false,"./icons/cuboid.js":false,"./icons/cup-soda.js":false,"./icons/currency.js":false,"./icons/cylinder.js":false,"./icons/dam.js":false,"./icons/database-backup.js":false,"./icons/database-zap.js":false,"./icons/database.js":false,"./icons/decimals-arrow-left.js":false,"./icons/decimals-arrow-right.js":false,"./icons/delete.js":false,"./icons/dessert.js":false,"./icons/diameter.js":false,"./icons/diamond-minus.js":false,"./icons/diamond.js":false,"./icons/diamond-plus.js":false,"./icons/dice-1.js":false,"./icons/dice-2.js":false,"./icons/dice-3.js":false,"./icons/dice-4.js":false,"./icons/dice-5.js":false,"./icons/dice-6.js":false,"./icons/dices.js":false,"./icons/diff.js":false,"./icons/disc-2.js":false,"./icons/disc-3.js":false,"./icons/disc-album.js":false,"./icons/divide.js":false,"./icons/disc.js":false,"./icons/dna-off.js":false,"./icons/dna.js":false,"./icons/dock.js":false,"./icons/dog.js":false,"./icons/dollar-sign.js":false,"./icons/donut.js":false,"./icons/door-closed-locked.js":false,"./icons/door-closed.js":false,"./icons/door-open.js":false,"./icons/dot.js":false,"./icons/download.js":false,"./icons/drafting-compass.js":false,"./icons/drama.js":false,"./icons/dribbble.js":false,"./icons/droplet-off.js":false,"./icons/droplet.js":false,"./icons/drill.js":false,"./icons/droplets.js":false,"./icons/drum.js":false,"./icons/drumstick.js":false,"./icons/dumbbell.js":false,"./icons/ear-off.js":false,"./icons/ear.js":false,"./icons/earth-lock.js":false,"./icons/eclipse.js":false,"./icons/egg-fried.js":false,"./icons/egg-off.js":false,"./icons/egg.js":false,"./icons/equal-approximately.js":false,"./icons/equal-not.js":false,"./icons/equal.js":false,"./icons/eraser.js":false,"./icons/ethernet-port.js":false,"./icons/euro.js":false,"./icons/expand.js":false,"./icons/external-link.js":false,"./icons/eye-off.js":false,"./icons/eye-closed.js":false,"./icons/eye.js":false,"./icons/factory.js":false,"./icons/facebook.js":false,"./icons/fan.js":false,"./icons/fast-forward.js":false,"./icons/feather.js":false,"./icons/fence.js":false,"./icons/figma.js":false,"./icons/ferris-wheel.js":false,"./icons/file-archive.js":false,"./icons/file-audio-2.js":false,"./icons/file-audio.js":false,"./icons/file-badge-2.js":false,"./icons/file-badge.js":false,"./icons/file-box.js":false,"./icons/file-check-2.js":false,"./icons/file-check.js":false,"./icons/file-clock.js":false,"./icons/file-code-2.js":false,"./icons/file-code.js":false,"./icons/file-diff.js":false,"./icons/file-digit.js":false,"./icons/file-down.js":false,"./icons/file-heart.js":false,"./icons/file-image.js":false,"./icons/file-input.js":false,"./icons/file-json-2.js":false,"./icons/file-json.js":false,"./icons/file-key-2.js":false,"./icons/file-key.js":false,"./icons/file-lock-2.js":false,"./icons/file-lock.js":false,"./icons/file-minus-2.js":false,"./icons/file-minus.js":false,"./icons/file-music.js":false,"./icons/file-output.js":false,"./icons/file-plus-2.js":false,"./icons/file-plus.js":false,"./icons/file-question.js":false,"./icons/file-scan.js":false,"./icons/file-search-2.js":false,"./icons/file-search.js":false,"./icons/file-sliders.js":false,"./icons/file-spreadsheet.js":false,"./icons/file-stack.js":false,"./icons/file-symlink.js":false,"./icons/file-terminal.js":false,"./icons/file-text.js":false,"./icons/file-type-2.js":false,"./icons/file-up.js":false,"./icons/file-type.js":false,"./icons/file-user.js":false,"./icons/file-video-2.js":false,"./icons/file-video.js":false,"./icons/file-volume-2.js":false,"./icons/file-volume.js":false,"./icons/file-warning.js":false,"./icons/file-x.js":false,"./icons/file-x-2.js":false,"./icons/files.js":false,"./icons/file.js":false,"./icons/film.js":false,"./icons/fingerprint.js":false,"./icons/fire-extinguisher.js":false,"./icons/fish-off.js":false,"./icons/fish-symbol.js":false,"./icons/fish.js":false,"./icons/flag-off.js":false,"./icons/flag-triangle-left.js":false,"./icons/flag-triangle-right.js":false,"./icons/flag.js":false,"./icons/flame-kindling.js":false,"./icons/flame.js":false,"./icons/flashlight.js":false,"./icons/flask-conical-off.js":false,"./icons/flashlight-off.js":false,"./icons/flask-conical.js":false,"./icons/flask-round.js":false,"./icons/flip-horizontal-2.js":false,"./icons/flip-horizontal.js":false,"./icons/flip-vertical-2.js":false,"./icons/flip-vertical.js":false,"./icons/flower-2.js":false,"./icons/flower.js":false,"./icons/focus.js":false,"./icons/fold-horizontal.js":false,"./icons/fold-vertical.js":false,"./icons/folder-archive.js":false,"./icons/folder-check.js":false,"./icons/folder-clock.js":false,"./icons/folder-closed.js":false,"./icons/folder-code.js":false,"./icons/folder-dot.js":false,"./icons/folder-down.js":false,"./icons/folder-git-2.js":false,"./icons/folder-git.js":false,"./icons/folder-heart.js":false,"./icons/folder-input.js":false,"./icons/folder-kanban.js":false,"./icons/folder-key.js":false,"./icons/folder-lock.js":false,"./icons/folder-minus.js":false,"./icons/folder-open-dot.js":false,"./icons/folder-open.js":false,"./icons/folder-output.js":false,"./icons/folder-plus.js":false,"./icons/folder-root.js":false,"./icons/folder-search-2.js":false,"./icons/folder-search.js":false,"./icons/folder-symlink.js":false,"./icons/folder-sync.js":false,"./icons/folder-tree.js":false,"./icons/folder-up.js":false,"./icons/folder-x.js":false,"./icons/folder.js":false,"./icons/folders.js":false,"./icons/footprints.js":false,"./icons/forklift.js":false,"./icons/forward.js":false,"./icons/frame.js":false,"./icons/framer.js":false,"./icons/fuel.js":false,"./icons/fullscreen.js":false,"./icons/frown.js":false,"./icons/funnel-plus.js":false,"./icons/gallery-horizontal-end.js":false,"./icons/gallery-horizontal.js":false,"./icons/gallery-thumbnails.js":false,"./icons/gallery-vertical-end.js":false,"./icons/gallery-vertical.js":false,"./icons/gamepad-2.js":false,"./icons/gamepad.js":false,"./icons/gauge.js":false,"./icons/gavel.js":false,"./icons/gem.js":false,"./icons/gift.js":false,"./icons/ghost.js":false,"./icons/git-branch-plus.js":false,"./icons/git-branch.js":false,"./icons/git-commit-vertical.js":false,"./icons/git-compare-arrows.js":false,"./icons/git-compare.js":false,"./icons/git-fork.js":false,"./icons/git-graph.js":false,"./icons/git-merge.js":false,"./icons/git-pull-request-arrow.js":false,"./icons/git-pull-request-closed.js":false,"./icons/git-pull-request-create-arrow.js":false,"./icons/git-pull-request-create.js":false,"./icons/git-pull-request-draft.js":false,"./icons/git-pull-request.js":false,"./icons/github.js":false,"./icons/gitlab.js":false,"./icons/glass-water.js":false,"./icons/glasses.js":false,"./icons/globe-lock.js":false,"./icons/globe.js":false,"./icons/goal.js":false,"./icons/gpu.js":false,"./icons/grab.js":false,"./icons/graduation-cap.js":false,"./icons/grape.js":false,"./icons/grid-3x2.js":false,"./icons/grip-horizontal.js":false,"./icons/grip-vertical.js":false,"./icons/grip.js":false,"./icons/group.js":false,"./icons/guitar.js":false,"./icons/ham.js":false,"./icons/hamburger.js":false,"./icons/hammer.js":false,"./icons/hand-coins.js":false,"./icons/hand-heart.js":false,"./icons/hand-metal.js":false,"./icons/hand-platter.js":false,"./icons/hand.js":false,"./icons/handshake.js":false,"./icons/hard-drive-download.js":false,"./icons/hard-drive-upload.js":false,"./icons/hard-drive.js":false,"./icons/hash.js":false,"./icons/hard-hat.js":false,"./icons/haze.js":false,"./icons/hdmi-port.js":false,"./icons/heading-1.js":false,"./icons/heading-2.js":false,"./icons/heading-3.js":false,"./icons/heading-4.js":false,"./icons/heading-5.js":false,"./icons/heading-6.js":false,"./icons/heading.js":false,"./icons/headphone-off.js":false,"./icons/headphones.js":false,"./icons/headset.js":false,"./icons/heart-crack.js":false,"./icons/heart-handshake.js":false,"./icons/heart-minus.js":false,"./icons/heart-off.js":false,"./icons/heart-plus.js":false,"./icons/heart-pulse.js":false,"./icons/heart.js":false,"./icons/heater.js":false,"./icons/hexagon.js":false,"./icons/highlighter.js":false,"./icons/history.js":false,"./icons/hop-off.js":false,"./icons/hop.js":false,"./icons/hospital.js":false,"./icons/hotel.js":false,"./icons/hourglass.js":false,"./icons/house-plug.js":false,"./icons/house-plus.js":false,"./icons/house-wifi.js":false,"./icons/id-card-lanyard.js":false,"./icons/id-card.js":false,"./icons/image-down.js":false,"./icons/image-minus.js":false,"./icons/image-off.js":false,"./icons/image-play.js":false,"./icons/image-plus.js":false,"./icons/image-up.js":false,"./icons/image-upscale.js":false,"./icons/image.js":false,"./icons/images.js":false,"./icons/import.js":false,"./icons/inbox.js":false,"./icons/indian-rupee.js":false,"./icons/infinity.js":false,"./icons/info.js":"2fWe7","./icons/inspection-panel.js":false,"./icons/instagram.js":false,"./icons/italic.js":false,"./icons/iteration-ccw.js":false,"./icons/iteration-cw.js":false,"./icons/japanese-yen.js":false,"./icons/joystick.js":false,"./icons/kanban.js":false,"./icons/key-round.js":false,"./icons/key-square.js":false,"./icons/key.js":false,"./icons/keyboard-off.js":false,"./icons/keyboard-music.js":false,"./icons/keyboard.js":false,"./icons/lamp-ceiling.js":false,"./icons/lamp-desk.js":false,"./icons/lamp-floor.js":false,"./icons/lamp-wall-down.js":false,"./icons/lamp-wall-up.js":false,"./icons/lamp.js":false,"./icons/land-plot.js":false,"./icons/landmark.js":false,"./icons/languages.js":false,"./icons/laptop-minimal-check.js":false,"./icons/laptop.js":false,"./icons/lasso-select.js":false,"./icons/lasso.js":false,"./icons/laugh.js":false,"./icons/layers-2.js":false,"./icons/layout-dashboard.js":false,"./icons/layout-grid.js":false,"./icons/layout-list.js":false,"./icons/layout-panel-left.js":false,"./icons/layout-panel-top.js":false,"./icons/leafy-green.js":false,"./icons/layout-template.js":false,"./icons/leaf.js":false,"./icons/lectern.js":false,"./icons/letter-text.js":false,"./icons/library-big.js":false,"./icons/library.js":false,"./icons/life-buoy.js":false,"./icons/ligature.js":false,"./icons/lightbulb-off.js":false,"./icons/lightbulb.js":false,"./icons/link-2-off.js":false,"./icons/link.js":false,"./icons/link-2.js":false,"./icons/linkedin.js":false,"./icons/list-check.js":false,"./icons/list-checks.js":false,"./icons/list-collapse.js":false,"./icons/list-end.js":false,"./icons/list-filter-plus.js":false,"./icons/list-filter.js":false,"./icons/list-minus.js":false,"./icons/list-music.js":false,"./icons/list-ordered.js":false,"./icons/list-plus.js":false,"./icons/list-restart.js":false,"./icons/list-todo.js":false,"./icons/list-tree.js":false,"./icons/list-start.js":false,"./icons/list-video.js":false,"./icons/list-x.js":false,"./icons/list.js":false,"./icons/loader-pinwheel.js":false,"./icons/loader.js":false,"./icons/locate-fixed.js":false,"./icons/locate-off.js":false,"./icons/locate.js":false,"./icons/location-edit.js":false,"./icons/lock-keyhole.js":false,"./icons/lock.js":false,"./icons/log-in.js":false,"./icons/log-out.js":false,"./icons/logs.js":false,"./icons/lollipop.js":false,"./icons/luggage.js":false,"./icons/magnet.js":false,"./icons/mail-check.js":false,"./icons/mail-open.js":false,"./icons/mail-question.js":false,"./icons/mail-plus.js":false,"./icons/mail-minus.js":false,"./icons/mail-search.js":false,"./icons/mail-warning.js":false,"./icons/mail-x.js":false,"./icons/mailbox.js":false,"./icons/mail.js":false,"./icons/mails.js":false,"./icons/map-pin-check-inside.js":false,"./icons/map-pin-check.js":false,"./icons/map-pin-house.js":false,"./icons/map-pin-minus-inside.js":false,"./icons/map-pin-minus.js":false,"./icons/map-pin-plus-inside.js":false,"./icons/map-pin-off.js":false,"./icons/map-pin-plus.js":false,"./icons/map-pin-x-inside.js":false,"./icons/map-pin-x.js":false,"./icons/map-pin.js":false,"./icons/map-pinned.js":false,"./icons/map-plus.js":false,"./icons/map.js":false,"./icons/martini.js":false,"./icons/mars-stroke.js":false,"./icons/mars.js":false,"./icons/maximize-2.js":false,"./icons/maximize.js":false,"./icons/medal.js":false,"./icons/megaphone-off.js":false,"./icons/megaphone.js":false,"./icons/memory-stick.js":false,"./icons/meh.js":false,"./icons/menu.js":false,"./icons/merge.js":false,"./icons/message-circle-code.js":false,"./icons/message-circle-dashed.js":false,"./icons/message-circle-heart.js":false,"./icons/message-circle-more.js":false,"./icons/message-circle-plus.js":false,"./icons/message-circle-off.js":false,"./icons/message-circle-question.js":false,"./icons/message-circle-reply.js":false,"./icons/message-circle-warning.js":false,"./icons/message-circle-x.js":false,"./icons/message-circle.js":false,"./icons/message-square-code.js":false,"./icons/message-square-dashed.js":false,"./icons/message-square-diff.js":false,"./icons/message-square-heart.js":false,"./icons/message-square-dot.js":false,"./icons/message-square-lock.js":false,"./icons/message-square-more.js":false,"./icons/message-square-off.js":false,"./icons/message-square-plus.js":false,"./icons/message-square-quote.js":false,"./icons/message-square-reply.js":false,"./icons/message-square-share.js":false,"./icons/message-square-text.js":false,"./icons/message-square-warning.js":false,"./icons/message-square-x.js":false,"./icons/message-square.js":false,"./icons/messages-square.js":false,"./icons/mic-off.js":false,"./icons/mic.js":false,"./icons/microchip.js":false,"./icons/microscope.js":false,"./icons/microwave.js":false,"./icons/milestone.js":false,"./icons/milk-off.js":false,"./icons/milk.js":false,"./icons/minimize-2.js":false,"./icons/minimize.js":false,"./icons/minus.js":false,"./icons/monitor-check.js":false,"./icons/monitor-cog.js":false,"./icons/monitor-dot.js":false,"./icons/monitor-down.js":false,"./icons/monitor-off.js":false,"./icons/monitor-play.js":false,"./icons/monitor-speaker.js":false,"./icons/monitor-pause.js":false,"./icons/monitor-smartphone.js":false,"./icons/monitor-stop.js":false,"./icons/monitor-up.js":false,"./icons/monitor-x.js":false,"./icons/monitor.js":false,"./icons/moon-star.js":false,"./icons/moon.js":false,"./icons/mountain-snow.js":false,"./icons/mountain.js":false,"./icons/mouse-off.js":false,"./icons/mouse-pointer-2.js":false,"./icons/mouse-pointer-ban.js":false,"./icons/mouse-pointer-click.js":false,"./icons/mouse-pointer.js":false,"./icons/mouse.js":false,"./icons/move-diagonal-2.js":false,"./icons/move-diagonal.js":false,"./icons/move-down-left.js":false,"./icons/move-down-right.js":false,"./icons/move-down.js":false,"./icons/move-horizontal.js":false,"./icons/move-left.js":false,"./icons/move-right.js":false,"./icons/move-up-right.js":false,"./icons/move-up-left.js":false,"./icons/move-up.js":false,"./icons/move-vertical.js":false,"./icons/move.js":false,"./icons/music-2.js":false,"./icons/music.js":false,"./icons/music-3.js":false,"./icons/music-4.js":false,"./icons/navigation-2-off.js":false,"./icons/navigation-2.js":false,"./icons/navigation-off.js":false,"./icons/navigation.js":false,"./icons/network.js":false,"./icons/nfc.js":false,"./icons/newspaper.js":false,"./icons/non-binary.js":false,"./icons/notebook-pen.js":false,"./icons/notebook-tabs.js":false,"./icons/notebook-text.js":false,"./icons/notebook.js":false,"./icons/notepad-text-dashed.js":false,"./icons/notepad-text.js":false,"./icons/nut-off.js":false,"./icons/nut.js":false,"./icons/octagon-minus.js":false,"./icons/octagon.js":false,"./icons/omega.js":false,"./icons/option.js":false,"./icons/orbit.js":false,"./icons/origami.js":false,"./icons/package-2.js":false,"./icons/package-check.js":false,"./icons/package-minus.js":false,"./icons/package-open.js":false,"./icons/package-search.js":false,"./icons/package-plus.js":false,"./icons/package-x.js":false,"./icons/package.js":false,"./icons/paint-bucket.js":false,"./icons/paint-roller.js":false,"./icons/paintbrush.js":false,"./icons/palette.js":false,"./icons/panda.js":false,"./icons/panel-bottom-close.js":false,"./icons/panel-bottom-open.js":false,"./icons/panel-bottom.js":false,"./icons/panel-right-close.js":false,"./icons/panel-right-open.js":false,"./icons/panel-right.js":false,"./icons/panel-top-close.js":false,"./icons/panel-top-open.js":false,"./icons/panel-top.js":false,"./icons/panels-left-bottom.js":false,"./icons/panels-right-bottom.js":false,"./icons/paperclip.js":false,"./icons/parentheses.js":false,"./icons/parking-meter.js":false,"./icons/party-popper.js":false,"./icons/pause.js":false,"./icons/paw-print.js":false,"./icons/pc-case.js":false,"./icons/pen-off.js":false,"./icons/pen-tool.js":false,"./icons/pencil-line.js":false,"./icons/pencil-off.js":false,"./icons/pencil-ruler.js":false,"./icons/pencil.js":false,"./icons/pentagon.js":false,"./icons/percent.js":false,"./icons/person-standing.js":false,"./icons/philippine-peso.js":false,"./icons/phone-call.js":false,"./icons/phone-forwarded.js":false,"./icons/phone-incoming.js":false,"./icons/phone-missed.js":false,"./icons/phone-off.js":false,"./icons/phone-outgoing.js":false,"./icons/pi.js":false,"./icons/phone.js":false,"./icons/pickaxe.js":false,"./icons/piano.js":false,"./icons/picture-in-picture-2.js":false,"./icons/picture-in-picture.js":false,"./icons/piggy-bank.js":false,"./icons/pilcrow-left.js":false,"./icons/pilcrow-right.js":false,"./icons/pilcrow.js":false,"./icons/pill-bottle.js":false,"./icons/pill.js":false,"./icons/pin-off.js":false,"./icons/pin.js":false,"./icons/pipette.js":false,"./icons/pizza.js":false,"./icons/plane-landing.js":false,"./icons/plane-takeoff.js":false,"./icons/plane.js":false,"./icons/play.js":"7RxAX","./icons/plug-2.js":false,"./icons/plus.js":false,"./icons/plug.js":false,"./icons/pocket-knife.js":false,"./icons/pocket.js":false,"./icons/pointer-off.js":false,"./icons/podcast.js":false,"./icons/pointer.js":false,"./icons/popcorn.js":false,"./icons/popsicle.js":false,"./icons/pound-sterling.js":false,"./icons/power-off.js":false,"./icons/power.js":false,"./icons/presentation.js":false,"./icons/printer-check.js":false,"./icons/projector.js":false,"./icons/printer.js":false,"./icons/puzzle.js":false,"./icons/proportions.js":false,"./icons/pyramid.js":false,"./icons/qr-code.js":false,"./icons/quote.js":false,"./icons/rabbit.js":false,"./icons/radar.js":false,"./icons/radiation.js":false,"./icons/radical.js":false,"./icons/radio-receiver.js":false,"./icons/radio-tower.js":false,"./icons/radio.js":false,"./icons/radius.js":false,"./icons/rail-symbol.js":false,"./icons/rat.js":false,"./icons/ratio.js":false,"./icons/rainbow.js":false,"./icons/receipt-cent.js":false,"./icons/receipt-euro.js":false,"./icons/receipt-indian-rupee.js":false,"./icons/receipt-pound-sterling.js":false,"./icons/receipt-japanese-yen.js":false,"./icons/receipt-russian-ruble.js":false,"./icons/receipt-text.js":false,"./icons/receipt-swiss-franc.js":false,"./icons/receipt.js":false,"./icons/rectangle-circle.js":false,"./icons/rectangle-horizontal.js":false,"./icons/rectangle-vertical.js":false,"./icons/rectangle-goggles.js":false,"./icons/recycle.js":false,"./icons/redo-2.js":false,"./icons/redo-dot.js":false,"./icons/refresh-ccw-dot.js":false,"./icons/redo.js":false,"./icons/refresh-ccw.js":false,"./icons/refresh-cw-off.js":false,"./icons/refresh-cw.js":false,"./icons/refrigerator.js":false,"./icons/regex.js":false,"./icons/remove-formatting.js":false,"./icons/repeat-2.js":false,"./icons/repeat-1.js":false,"./icons/repeat.js":false,"./icons/replace-all.js":false,"./icons/replace.js":false,"./icons/reply-all.js":false,"./icons/reply.js":false,"./icons/rewind.js":false,"./icons/ribbon.js":false,"./icons/rocket.js":false,"./icons/rocking-chair.js":false,"./icons/roller-coaster.js":false,"./icons/rotate-ccw-key.js":false,"./icons/rotate-ccw-square.js":false,"./icons/rotate-ccw.js":false,"./icons/rotate-cw-square.js":false,"./icons/route-off.js":false,"./icons/route.js":false,"./icons/rotate-cw.js":false,"./icons/router.js":false,"./icons/rows-4.js":false,"./icons/rss.js":false,"./icons/ruler-dimension-line.js":false,"./icons/ruler.js":false,"./icons/russian-ruble.js":false,"./icons/sailboat.js":false,"./icons/salad.js":false,"./icons/sandwich.js":false,"./icons/satellite-dish.js":false,"./icons/satellite.js":false,"./icons/saudi-riyal.js":false,"./icons/save-all.js":false,"./icons/save-off.js":false,"./icons/save.js":false,"./icons/scale.js":false,"./icons/scaling.js":false,"./icons/scan-barcode.js":false,"./icons/scan-eye.js":false,"./icons/scan-face.js":false,"./icons/scan-heart.js":false,"./icons/scan-line.js":false,"./icons/scan-qr-code.js":false,"./icons/scan-search.js":false,"./icons/scan-text.js":false,"./icons/scan.js":false,"./icons/school.js":false,"./icons/scissors-line-dashed.js":false,"./icons/scissors.js":false,"./icons/screen-share-off.js":false,"./icons/screen-share.js":false,"./icons/scroll-text.js":false,"./icons/scroll.js":false,"./icons/search-check.js":false,"./icons/search-code.js":false,"./icons/search-slash.js":false,"./icons/search-x.js":false,"./icons/search.js":false,"./icons/section.js":false,"./icons/send-to-back.js":false,"./icons/send.js":false,"./icons/separator-horizontal.js":false,"./icons/separator-vertical.js":false,"./icons/server-cog.js":false,"./icons/server-crash.js":false,"./icons/server.js":false,"./icons/settings-2.js":false,"./icons/server-off.js":false,"./icons/settings.js":false,"./icons/shapes.js":false,"./icons/share-2.js":false,"./icons/shell.js":false,"./icons/share.js":false,"./icons/sheet.js":false,"./icons/shield-ban.js":false,"./icons/shield-alert.js":false,"./icons/shield-check.js":false,"./icons/shield-ellipsis.js":false,"./icons/shield-half.js":false,"./icons/shield-minus.js":false,"./icons/shield-off.js":false,"./icons/shield-plus.js":false,"./icons/shield-question.js":false,"./icons/shield-user.js":false,"./icons/shield.js":false,"./icons/ship-wheel.js":false,"./icons/ship.js":false,"./icons/shirt.js":false,"./icons/shopping-bag.js":false,"./icons/shopping-basket.js":false,"./icons/shopping-cart.js":false,"./icons/shovel.js":false,"./icons/shower-head.js":false,"./icons/shrimp.js":false,"./icons/shredder.js":false,"./icons/shrink.js":false,"./icons/shrub.js":false,"./icons/shuffle.js":false,"./icons/sigma.js":false,"./icons/signal-high.js":false,"./icons/signal-low.js":false,"./icons/signal-medium.js":false,"./icons/signal-zero.js":false,"./icons/signal.js":false,"./icons/signature.js":false,"./icons/signpost-big.js":false,"./icons/signpost.js":false,"./icons/skip-back.js":false,"./icons/siren.js":false,"./icons/skip-forward.js":false,"./icons/skull.js":false,"./icons/slack.js":false,"./icons/slash.js":false,"./icons/slice.js":false,"./icons/sliders-horizontal.js":false,"./icons/smartphone-charging.js":false,"./icons/smartphone-nfc.js":false,"./icons/smartphone.js":false,"./icons/snail.js":false,"./icons/smile.js":false,"./icons/smile-plus.js":false,"./icons/snowflake.js":false,"./icons/soap-dispenser-droplet.js":false,"./icons/soup.js":false,"./icons/sofa.js":false,"./icons/space.js":false,"./icons/sparkle.js":false,"./icons/spade.js":false,"./icons/speaker.js":false,"./icons/speech.js":false,"./icons/spell-check-2.js":false,"./icons/spell-check.js":false,"./icons/spline-pointer.js":false,"./icons/spline.js":false,"./icons/split.js":false,"./icons/spray-can.js":false,"./icons/sprout.js":false,"./icons/square-dashed-bottom-code.js":false,"./icons/square-dashed-bottom.js":false,"./icons/square-dashed-top-solid.js":false,"./icons/square-radical.js":false,"./icons/square-round-corner.js":false,"./icons/square-square.js":false,"./icons/square-stack.js":false,"./icons/square.js":false,"./icons/squares-exclude.js":false,"./icons/squares-intersect.js":false,"./icons/squares-subtract.js":false,"./icons/squares-unite.js":false,"./icons/squircle.js":false,"./icons/squirrel.js":false,"./icons/stamp.js":false,"./icons/star-off.js":false,"./icons/star-half.js":false,"./icons/star.js":false,"./icons/step-forward.js":false,"./icons/step-back.js":false,"./icons/sticker.js":false,"./icons/stethoscope.js":false,"./icons/store.js":false,"./icons/sticky-note.js":false,"./icons/stretch-horizontal.js":false,"./icons/stretch-vertical.js":false,"./icons/strikethrough.js":false,"./icons/subscript.js":false,"./icons/sun-dim.js":false,"./icons/sun-medium.js":false,"./icons/sun-snow.js":false,"./icons/sun-moon.js":false,"./icons/sun.js":false,"./icons/sunset.js":false,"./icons/sunrise.js":false,"./icons/superscript.js":false,"./icons/swatch-book.js":false,"./icons/swiss-franc.js":false,"./icons/switch-camera.js":false,"./icons/swords.js":false,"./icons/sword.js":false,"./icons/syringe.js":false,"./icons/table-2.js":false,"./icons/table-cells-merge.js":false,"./icons/table-cells-split.js":false,"./icons/table-columns-split.js":false,"./icons/table-of-contents.js":false,"./icons/table-properties.js":false,"./icons/table.js":false,"./icons/table-rows-split.js":false,"./icons/tablet.js":false,"./icons/tablets.js":false,"./icons/tablet-smartphone.js":false,"./icons/tally-1.js":false,"./icons/tag.js":false,"./icons/tags.js":false,"./icons/tally-2.js":false,"./icons/tally-3.js":false,"./icons/tally-4.js":false,"./icons/tangent.js":false,"./icons/tally-5.js":false,"./icons/telescope.js":false,"./icons/tent-tree.js":false,"./icons/target.js":false,"./icons/tent.js":false,"./icons/terminal.js":false,"./icons/test-tube.js":false,"./icons/test-tubes.js":false,"./icons/text-cursor-input.js":false,"./icons/text-cursor.js":false,"./icons/text-search.js":false,"./icons/text-quote.js":false,"./icons/text.js":false,"./icons/theater.js":false,"./icons/thermometer-snowflake.js":false,"./icons/thermometer-sun.js":false,"./icons/thermometer.js":false,"./icons/thumbs-up.js":false,"./icons/ticket-check.js":false,"./icons/thumbs-down.js":false,"./icons/ticket-minus.js":false,"./icons/ticket-percent.js":false,"./icons/ticket-plus.js":false,"./icons/ticket-slash.js":false,"./icons/ticket-x.js":false,"./icons/ticket.js":false,"./icons/tickets-plane.js":false,"./icons/tickets.js":false,"./icons/timer-off.js":false,"./icons/timer-reset.js":false,"./icons/timer.js":false,"./icons/toggle-left.js":false,"./icons/toggle-right.js":false,"./icons/toilet.js":false,"./icons/tornado.js":false,"./icons/torus.js":false,"./icons/touchpad-off.js":false,"./icons/touchpad.js":false,"./icons/tower-control.js":false,"./icons/toy-brick.js":false,"./icons/traffic-cone.js":false,"./icons/tractor.js":false,"./icons/train-front.js":false,"./icons/train-front-tunnel.js":false,"./icons/train-track.js":false,"./icons/trash-2.js":false,"./icons/transgender.js":false,"./icons/trash.js":false,"./icons/tree-deciduous.js":false,"./icons/tree-pine.js":false,"./icons/trees.js":false,"./icons/trello.js":false,"./icons/trending-down.js":false,"./icons/trending-up-down.js":false,"./icons/trending-up.js":false,"./icons/triangle-dashed.js":false,"./icons/triangle-right.js":false,"./icons/triangle.js":false,"./icons/trophy.js":false,"./icons/truck-electric.js":false,"./icons/truck.js":false,"./icons/turtle.js":false,"./icons/tv-minimal-play.js":false,"./icons/tv.js":false,"./icons/twitch.js":false,"./icons/twitter.js":false,"./icons/type-outline.js":false,"./icons/type.js":false,"./icons/umbrella-off.js":false,"./icons/umbrella.js":false,"./icons/underline.js":false,"./icons/undo-2.js":false,"./icons/undo-dot.js":false,"./icons/undo.js":false,"./icons/unfold-horizontal.js":false,"./icons/unfold-vertical.js":false,"./icons/ungroup.js":false,"./icons/unlink-2.js":false,"./icons/unlink.js":false,"./icons/unplug.js":false,"./icons/upload.js":false,"./icons/usb.js":false,"./icons/user-check.js":false,"./icons/user-lock.js":false,"./icons/user-cog.js":false,"./icons/user-minus.js":false,"./icons/user-pen.js":false,"./icons/user-plus.js":false,"./icons/user-round-pen.js":false,"./icons/user-round-search.js":false,"./icons/user-search.js":false,"./icons/user-x.js":false,"./icons/user.js":false,"./icons/users.js":false,"./icons/utility-pole.js":false,"./icons/variable.js":false,"./icons/vault.js":false,"./icons/vegan.js":false,"./icons/venetian-mask.js":false,"./icons/venus-and-mars.js":false,"./icons/venus.js":false,"./icons/vibrate.js":false,"./icons/vibrate-off.js":false,"./icons/video-off.js":false,"./icons/video.js":false,"./icons/videotape.js":false,"./icons/view.js":false,"./icons/voicemail.js":false,"./icons/volume-1.js":false,"./icons/volume-2.js":false,"./icons/volleyball.js":false,"./icons/volume-off.js":false,"./icons/volume-x.js":false,"./icons/volume.js":false,"./icons/vote.js":false,"./icons/wallet-cards.js":false,"./icons/wallet.js":false,"./icons/wallpaper.js":false,"./icons/warehouse.js":false,"./icons/wand.js":false,"./icons/washing-machine.js":false,"./icons/waves-ladder.js":false,"./icons/watch.js":false,"./icons/waves.js":false,"./icons/waypoints.js":false,"./icons/webcam.js":false,"./icons/webhook-off.js":false,"./icons/webhook.js":false,"./icons/weight.js":false,"./icons/wheat-off.js":false,"./icons/wheat.js":false,"./icons/wifi-high.js":false,"./icons/whole-word.js":false,"./icons/wifi-low.js":false,"./icons/wifi-off.js":false,"./icons/wifi-pen.js":false,"./icons/wifi-zero.js":false,"./icons/wifi.js":false,"./icons/wind-arrow-down.js":false,"./icons/wind.js":false,"./icons/wine-off.js":false,"./icons/wine.js":false,"./icons/workflow.js":false,"./icons/worm.js":false,"./icons/wrap-text.js":false,"./icons/wrench.js":false,"./icons/x.js":false,"./icons/youtube.js":false,"./icons/zap-off.js":false,"./icons/zap.js":false,"./icons/zoom-in.js":false,"./icons/zoom-out.js":false,"./icons/arrow-down-0-1.js":false,"./icons/arrow-down-1-0.js":false,"./icons/arrow-up-0-1.js":false,"./icons/arrow-up-1-0.js":false,"./createLucideIcon.js":false,"./Icon.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ekoIq":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronLeft);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const ChevronLeft = (0, _createLucideIconJsDefault.default)("chevron-left", __iconNode);

},{"../createLucideIcon.js":"idSjn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"idSjn":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLucideIcon);
var _react = require("react");
var _utilsJs = require("./shared/src/utils.js");
var _iconJs = require("./Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
const createLucideIcon = (iconName, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ className, ...props }, ref)=>(0, _react.createElement)((0, _iconJsDefault.default), {
            ref,
            iconNode,
            className: (0, _utilsJs.mergeClasses)(`lucide-${(0, _utilsJs.toKebabCase)((0, _utilsJs.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, _utilsJs.toPascalCase)(iconName);
    return Component;
};

},{"react":"bmhQu","./shared/src/utils.js":"fhZ4w","./Icon.js":"aO86U","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fhZ4w":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasA11yProp", ()=>hasA11yProp);
parcelHelpers.export(exports, "mergeClasses", ()=>mergeClasses);
parcelHelpers.export(exports, "toCamelCase", ()=>toCamelCase);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
parcelHelpers.export(exports, "toPascalCase", ()=>toPascalCase);
const toKebabCase = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const toPascalCase = (string)=>{
    const camelCase = toCamelCase(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const hasA11yProp = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aO86U":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
var _defaultAttributesJs = require("./defaultAttributes.js");
var _defaultAttributesJsDefault = parcelHelpers.interopDefault(_defaultAttributesJs);
var _utilsJs = require("./shared/src/utils.js");
const Icon = (0, _react.forwardRef)(({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, iconNode, ...rest }, ref)=>(0, _react.createElement)("svg", {
        ref,
        ...(0, _defaultAttributesJsDefault.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, _utilsJs.mergeClasses)("lucide", className),
        ...!children && !(0, _utilsJs.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));

},{"react":"bmhQu","./defaultAttributes.js":"730OY","./shared/src/utils.js":"fhZ4w","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"730OY":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bTPZb":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronRight);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const ChevronRight = (0, _createLucideIconJsDefault.default)("chevron-right", __iconNode);

},{"../createLucideIcon.js":"idSjn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2fWe7":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Info);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const Info = (0, _createLucideIconJsDefault.default)("info", __iconNode);

},{"../createLucideIcon.js":"idSjn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7RxAX":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Play);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "polygon",
        {
            points: "6 3 20 12 6 21 6 3",
            key: "1oa8hb"
        }
    ]
];
const Play = (0, _createLucideIconJsDefault.default)("play", __iconNode);

},{"../createLucideIcon.js":"idSjn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"boGVy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _random = require("../utils/random");
var _randomDefault = parcelHelpers.interopDefault(_random);
var _useVideoBackGround = require("../hooks/useVideoBackGround");
var _useVideoBackGroundDefault = parcelHelpers.interopDefault(_useVideoBackGround);
const VideoBackground = ({ movieId })=>{
    const [videoResponse, setVideoResponse] = (0, _react.useState)([]);
    (0, _useVideoBackGroundDefault.default)(setVideoResponse, movieId);
    // console.log("videoResponse", movieId, videoResponse);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                className: "w-screen  aspect-video",
                src: `https://www.youtube.com/embed/${videoResponse[(0, _randomDefault.default)(videoResponse.length)]?.key}?autoplay=1&mute=1&controls=0;`,
                title: "YouTube video player",
                referrerPolicy: "strict-origin-when-cross-origin",
                autoFocus: true
            })
        })
    });
};
exports.default = VideoBackground;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../utils/random":"bYmEC","../hooks/useVideoBackGround":"bGdBP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bYmEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>randomItem);
function randomItem(range) {
    return Math.floor(Math.random() * range);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bGdBP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _constants = require("../utils/constants");
var _videosFilter = require("../utils/videosFilter");
var _videosFilterDefault = parcelHelpers.interopDefault(_videosFilter);
const useVideoBackGround = (setVideoResponse, movieId)=>{
    (0, _react.useEffect)(()=>{
        fetch(`https://api.themoviedb.org/3/movie/${movieId}/videos`, (0, _constants.TMDB_API_OPTIONS)).then((res)=>res.json()).then((res)=>{
            let filteredRes = (0, _videosFilterDefault.default)(res.results, "YouTube", [
                // "Teaser",
                "Trailer"
            ]);
            filteredRes.length == 0 ? setVideoResponse(res.results) : setVideoResponse(filteredRes);
        });
    }, []);
};
exports.default = useVideoBackGround;

},{"react":"bmhQu","../utils/constants":"fZCF6","../utils/videosFilter":"lgB4V","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lgB4V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>videoFilter);
function videoFilter(listOfVideos, site, type) {
    return listOfVideos.filter((i)=>i.site == site && type.includes(i.type));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4TSm5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _movieList = require("./MovieList");
var _movieListDefault = parcelHelpers.interopDefault(_movieList);
const MovieLists = ()=>{
    const movies = (0, _reactRedux.useSelector)((store)=>store?.movies);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "bg-black w-screen  text-white lg:-mt-56 md:-mt-30 -mt-10  ",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movieListDefault.default), {
                title: "Now Playing",
                movies: movies?.nowplaying
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movieListDefault.default), {
                title: "Popular",
                movies: movies?.popularMovies
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movieListDefault.default), {
                title: "Top Rated",
                movies: movies?.topRated
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movieListDefault.default), {
                title: "Upcoming",
                movies: movies?.upcoming
            })
        ]
    });
};
exports.default = MovieLists;

},{"react/jsx-runtime":"gonF6","react-redux":"aRDHF","./MovieList":"8ap5G","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8ap5G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MovieList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _constants = require("../utils/constants");
var _lucideReact = require("lucide-react");
function MovieList({ title, movies }) {
    const scrollRef = (0, _react.useRef)(null);
    const scrollLeft = ()=>{
        if (scrollRef.current) scrollRef.current.scrollBy({
            left: -500,
            behavior: "smooth"
        });
    };
    const scrollRight = ()=>{
        if (scrollRef.current) scrollRef.current.scrollBy({
            left: 1000,
            behavior: "smooth"
        });
    };
    if (!movies) return;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-screen px-5 relative",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                        className: "items-center align-middle flex space-x-2 md:text-2xl  text-lg py-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRightIcon), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex space-x-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: scrollLeft,
                                className: "p-1 bg-gray-700 rounded-full hidden sm:hidden md:flex hover:cursor-pointer hover:bg-gray-500",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: scrollRight,
                                className: "p-1 bg-gray-700 rounded-full hidden sm:hidden md:flex hover:cursor-pointer  hover:bg-gray-500",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: scrollRef,
                className: "flex overflow-x-scroll w-screen scroll-smooth no-scrollbar",
                children: movies.map((i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "p-2 rounded-2xl lg:w-1/7 md:w-1/5 sm:w-1/3 w-1/3 hover:scale-105 duration-300 hover:cursor-pointer",
                        src: (0, _constants.TMDB_IMG_CDN) + i.poster_path,
                        alt: "movieTitle"
                    }, i.id))
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../utils/constants":"fZCF6","lucide-react":"3eiFh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1LLH6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _constants = require("../utils/constants");
var _movies = require("../store/slice/movies");
var _react = require("react");
const usePopularMovies = ()=>{
    const dispatchAction = (0, _reactRedux.useDispatch)();
    const isPresent = (0, _reactRedux.useSelector)((store)=>store.movies.popularMovies);
    const getMovies = (url)=>{
        fetch(url, (0, _constants.TMDB_API_OPTIONS)).then((res)=>res.json()).then((json)=>{
            dispatchAction((0, _movies.addPopularMovies)(json.results));
        }).catch((err)=>console.error(err));
    };
    (0, _react.useEffect)(()=>{
        if (!isPresent) getMovies("https://api.themoviedb.org/3/movie/popular?language=en-US&page=1");
    }, []);
};
exports.default = usePopularMovies;

},{"react-redux":"aRDHF","../utils/constants":"fZCF6","../store/slice/movies":"5TvjQ","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lKoOw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _constants = require("../utils/constants");
var _movies = require("../store/slice/movies");
var _react = require("react");
const useUpcomingMovies = ()=>{
    const dispatchAction = (0, _reactRedux.useDispatch)();
    const isPresent = (0, _reactRedux.useSelector)((store)=>store.movies.upcoming);
    const getMovies = (url)=>{
        fetch(url, (0, _constants.TMDB_API_OPTIONS)).then((res)=>res.json()).then((json)=>{
            dispatchAction((0, _movies.addUpcomingMovies)(json.results));
        }).catch((err)=>console.error(err));
    };
    (0, _react.useEffect)(()=>{
        if (!isPresent) getMovies("https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1");
    }, []);
};
exports.default = useUpcomingMovies;

},{"react-redux":"aRDHF","../utils/constants":"fZCF6","../store/slice/movies":"5TvjQ","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Krfw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _constants = require("../utils/constants");
var _movies = require("../store/slice/movies");
var _react = require("react");
const useTopRatedMovies = ()=>{
    const dispatchAction = (0, _reactRedux.useDispatch)();
    const isPresent = (0, _reactRedux.useSelector)((store)=>store.movies.upcoming);
    const getMovies = (url)=>{
        fetch(url, (0, _constants.TMDB_API_OPTIONS)).then((res)=>res.json()).then((json)=>{
            dispatchAction((0, _movies.addTopRatedMovies)(json.results));
        }).catch((err)=>console.error(err));
    };
    (0, _react.useEffect)(()=>{
        if (!isPresent) getMovies("https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1");
    }, []);
};
exports.default = useTopRatedMovies;

},{"react-redux":"aRDHF","../utils/constants":"fZCF6","../store/slice/movies":"5TvjQ","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Inds":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _gptMovieSuggestion = require("./GptMovieSuggestion");
var _gptMovieSuggestionDefault = parcelHelpers.interopDefault(_gptMovieSuggestion);
var _gptSearchBar = require("./GptSearchBar");
var _gptSearchBarDefault = parcelHelpers.interopDefault(_gptSearchBar);
const GptSearch = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "fixed -z-10 bg-black ",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: " opacity-50 h-screen object-cover lg:h-auto ",
                    src: "https://assets.nflxext.com/ffe/siteui/vlv3/6863f6e8-d419-414d-b5b9-7ef657e67ce4/web/IN-en-20250602-TRIFECTA-perspective_27a3fdfa-126f-4148-b153-55d60b51be6a_small.jpg",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gptSearchBarDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gptMovieSuggestionDefault.default), {})
                ]
            })
        ]
    });
};
exports.default = GptSearch;

},{"react/jsx-runtime":"gonF6","./GptMovieSuggestion":"9fbey","./GptSearchBar":"3Q8k9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9fbey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _movieList = require("./MovieList");
var _movieListDefault = parcelHelpers.interopDefault(_movieList);
const GptMovieSuggestion = ()=>{
    const aiRecommendedMovies = (0, _reactRedux.useSelector)((store)=>store.movies.aiRecommended);
    if (!aiRecommendedMovies) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    // console.log(aiRecommendedMovies);
    const { movieNames, movieResults } = aiRecommendedMovies;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-white mt-10 py-6 w-screen bg-black/80 bg-gradient-to-t to-transparent",
        children: movieNames.map((item, index)=>{
            return movieResults[index].length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movieListDefault.default), {
                title: movieNames[index],
                movies: movieResults[index]
            }, movieNames[index]) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
        })
    });
};
exports.default = GptMovieSuggestion;

},{"react/jsx-runtime":"gonF6","react-redux":"aRDHF","./MovieList":"8ap5G","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Q8k9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _constants = require("../utils/constants");
var _react = require("react");
var _spinner = require("./helper/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _aiRecommendedMovies = require("../utils/aiRecommendedMovies");
const GptSearchBar = ()=>{
    const queryAiValue = (0, _react.useRef)(null);
    const languageSelected = (0, _reactRedux.useSelector)((store)=>store.feature.language);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)("");
    const dispatchAction = (0, _reactRedux.useDispatch)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex justify-center w-screen md:pt-[10%] pt-[40%] md:text-lg ",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                    className: " w-screen flex items-center z-50 md:w-1/2 bg-black space-x-4 py-4 px-6 ",
                    onSubmit: (e)=>e.preventDefault(),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "text",
                            placeholder: (0, _constants.language)?.[languageSelected]?.placeholder,
                            className: "rounded bg-amber-50   py-2 px-2 w-full",
                            ref: queryAiValue,
                            maxLength: 100,
                            minLength: 10,
                            required: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "bg-red-700 text-white  rounded py-2 px-6  cursor-pointer",
                            onClick: ()=>{
                                setLoading(true);
                                setError("");
                                (0, _aiRecommendedMovies.handleAiSearch)(queryAiValue.current?.value, dispatchAction, setError, setLoading);
                            },
                            children: loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}) : (0, _constants.language)?.[languageSelected]?.search
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-red-600 flex justify-center items-center align-middle w-screen -mt-1.5 ",
                children: error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-screen md:w-1/2 bg-black text-md px-6",
                    children: error
                })
            })
        ]
    });
};
exports.default = GptSearchBar;

},{"react/jsx-runtime":"gonF6","react-redux":"aRDHF","../utils/constants":"fZCF6","react":"bmhQu","./helper/Spinner":"fDGWh","../utils/aiRecommendedMovies":"3MwPa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3MwPa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleAiSearch", ()=>handleAiSearch);
var _gemini = require("../config/gemini");
var _geminiDefault = parcelHelpers.interopDefault(_gemini);
var _movies = require("../store/slice/movies");
var _constants = require("./constants");
const searchMovie = async (name)=>{
    let data = await fetch("https://api.themoviedb.org/3/search/movie?query=" + name + "&include_adult=true&language=en-US&page=1", (0, _constants.TMDB_API_OPTIONS));
    data = await data.json();
    // console.log("searchMovie",data);
    return data.results;
};
const handleAiSearch = async (searchText, dispatchAction, setError, setLoading)=>{
    if (searchText.length > 9) {
        const finalAIQuery = "Act as an movie recommendation system(responds with 5 movie name seprated by comma), which returns only name of 5 movies present in netflix in response, seprated by comma (example of response expected :'Sholay, Golmaal, Don, Gadar, Koi mil gaya').If query doesn't contain any information regarding movie recommendation return empty spaces.If the prompt doesn't align with guidelines in taht case return with empty spaces. Give some movie names for the query: " + searchText;
        try {
            const response = await (0, _geminiDefault.default).models.generateContent({
                model: "gemini-2.0-flash",
                contents: finalAIQuery
            });
            if (response?.text?.trim().length) {
                let movies = response.text?.trim().split(",");
                let moviePromises = movies.map((movie)=>searchMovie(movie));
                let movieResults = await Promise.all(moviePromises);
                dispatchAction((0, _movies.addAiRecommended)({
                    movieNames: movies,
                    movieResults
                }));
            } else setError("No movie found, please improve the prompt.");
            setLoading(false);
        } catch (e) {
            console.log(e);
        }
    } else {
        setError("Input should have atleast 10 chars.");
        setLoading(false);
    }
};

},{"../config/gemini":"9XArj","../store/slice/movies":"5TvjQ","./constants":"fZCF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9XArj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _genai = require("@google/genai");
const geminiAI = new (0, _genai.GoogleGenAI)({
    apiKey: "AIzaSyB07FZtvXLAxsGRRbzgEJTrqx3HxKPrI-Q"
});
exports.default = geminiAI;

},{"@google/genai":"aRNyc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aRNyc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActivityHandling", ()=>ActivityHandling);
parcelHelpers.export(exports, "AdapterSize", ()=>AdapterSize);
parcelHelpers.export(exports, "AuthType", ()=>AuthType);
parcelHelpers.export(exports, "Behavior", ()=>Behavior);
parcelHelpers.export(exports, "BlockedReason", ()=>BlockedReason);
parcelHelpers.export(exports, "Caches", ()=>Caches);
parcelHelpers.export(exports, "Chat", ()=>Chat);
parcelHelpers.export(exports, "Chats", ()=>Chats);
parcelHelpers.export(exports, "ComputeTokensResponse", ()=>ComputeTokensResponse);
parcelHelpers.export(exports, "ControlReferenceImage", ()=>ControlReferenceImage);
parcelHelpers.export(exports, "ControlReferenceType", ()=>ControlReferenceType);
parcelHelpers.export(exports, "CountTokensResponse", ()=>CountTokensResponse);
parcelHelpers.export(exports, "CreateFileResponse", ()=>CreateFileResponse);
parcelHelpers.export(exports, "DeleteCachedContentResponse", ()=>DeleteCachedContentResponse);
parcelHelpers.export(exports, "DeleteFileResponse", ()=>DeleteFileResponse);
parcelHelpers.export(exports, "DeleteModelResponse", ()=>DeleteModelResponse);
parcelHelpers.export(exports, "DynamicRetrievalConfigMode", ()=>DynamicRetrievalConfigMode);
parcelHelpers.export(exports, "EditImageResponse", ()=>EditImageResponse);
parcelHelpers.export(exports, "EditMode", ()=>EditMode);
parcelHelpers.export(exports, "EmbedContentResponse", ()=>EmbedContentResponse);
parcelHelpers.export(exports, "EndSensitivity", ()=>EndSensitivity);
parcelHelpers.export(exports, "FeatureSelectionPreference", ()=>FeatureSelectionPreference);
parcelHelpers.export(exports, "FileSource", ()=>FileSource);
parcelHelpers.export(exports, "FileState", ()=>FileState);
parcelHelpers.export(exports, "Files", ()=>Files);
parcelHelpers.export(exports, "FinishReason", ()=>FinishReason);
parcelHelpers.export(exports, "FunctionCallingConfigMode", ()=>FunctionCallingConfigMode);
parcelHelpers.export(exports, "FunctionResponse", ()=>FunctionResponse);
parcelHelpers.export(exports, "FunctionResponseScheduling", ()=>FunctionResponseScheduling);
parcelHelpers.export(exports, "GenerateContentResponse", ()=>GenerateContentResponse);
parcelHelpers.export(exports, "GenerateContentResponsePromptFeedback", ()=>GenerateContentResponsePromptFeedback);
parcelHelpers.export(exports, "GenerateContentResponseUsageMetadata", ()=>GenerateContentResponseUsageMetadata);
parcelHelpers.export(exports, "GenerateImagesResponse", ()=>GenerateImagesResponse);
parcelHelpers.export(exports, "GenerateVideosResponse", ()=>GenerateVideosResponse);
parcelHelpers.export(exports, "GoogleGenAI", ()=>GoogleGenAI);
parcelHelpers.export(exports, "HarmBlockMethod", ()=>HarmBlockMethod);
parcelHelpers.export(exports, "HarmBlockThreshold", ()=>HarmBlockThreshold);
parcelHelpers.export(exports, "HarmCategory", ()=>HarmCategory);
parcelHelpers.export(exports, "HarmProbability", ()=>HarmProbability);
parcelHelpers.export(exports, "HarmSeverity", ()=>HarmSeverity);
parcelHelpers.export(exports, "HttpResponse", ()=>HttpResponse);
parcelHelpers.export(exports, "ImagePromptLanguage", ()=>ImagePromptLanguage);
parcelHelpers.export(exports, "JobState", ()=>JobState);
parcelHelpers.export(exports, "Language", ()=>Language);
parcelHelpers.export(exports, "ListCachedContentsResponse", ()=>ListCachedContentsResponse);
parcelHelpers.export(exports, "ListFilesResponse", ()=>ListFilesResponse);
parcelHelpers.export(exports, "ListModelsResponse", ()=>ListModelsResponse);
parcelHelpers.export(exports, "ListTuningJobsResponse", ()=>ListTuningJobsResponse);
parcelHelpers.export(exports, "Live", ()=>Live);
parcelHelpers.export(exports, "LiveClientToolResponse", ()=>LiveClientToolResponse);
parcelHelpers.export(exports, "LiveMusicPlaybackControl", ()=>LiveMusicPlaybackControl);
parcelHelpers.export(exports, "LiveMusicServerMessage", ()=>LiveMusicServerMessage);
parcelHelpers.export(exports, "LiveSendToolResponseParameters", ()=>LiveSendToolResponseParameters);
parcelHelpers.export(exports, "LiveServerMessage", ()=>LiveServerMessage);
parcelHelpers.export(exports, "MaskReferenceImage", ()=>MaskReferenceImage);
parcelHelpers.export(exports, "MaskReferenceMode", ()=>MaskReferenceMode);
parcelHelpers.export(exports, "MediaModality", ()=>MediaModality);
parcelHelpers.export(exports, "MediaResolution", ()=>MediaResolution);
parcelHelpers.export(exports, "Modality", ()=>Modality);
parcelHelpers.export(exports, "Mode", ()=>Mode);
parcelHelpers.export(exports, "Models", ()=>Models);
parcelHelpers.export(exports, "Operations", ()=>Operations);
parcelHelpers.export(exports, "Outcome", ()=>Outcome);
parcelHelpers.export(exports, "PagedItem", ()=>PagedItem);
parcelHelpers.export(exports, "Pager", ()=>Pager);
parcelHelpers.export(exports, "PersonGeneration", ()=>PersonGeneration);
parcelHelpers.export(exports, "RawReferenceImage", ()=>RawReferenceImage);
parcelHelpers.export(exports, "ReplayResponse", ()=>ReplayResponse);
parcelHelpers.export(exports, "SafetyFilterLevel", ()=>SafetyFilterLevel);
parcelHelpers.export(exports, "Scale", ()=>Scale);
parcelHelpers.export(exports, "Session", ()=>Session);
parcelHelpers.export(exports, "StartSensitivity", ()=>StartSensitivity);
parcelHelpers.export(exports, "StyleReferenceImage", ()=>StyleReferenceImage);
parcelHelpers.export(exports, "SubjectReferenceImage", ()=>SubjectReferenceImage);
parcelHelpers.export(exports, "SubjectReferenceType", ()=>SubjectReferenceType);
parcelHelpers.export(exports, "Tokens", ()=>Tokens);
parcelHelpers.export(exports, "TrafficType", ()=>TrafficType);
parcelHelpers.export(exports, "TurnCoverage", ()=>TurnCoverage);
parcelHelpers.export(exports, "Type", ()=>Type);
parcelHelpers.export(exports, "UpscaleImageResponse", ()=>UpscaleImageResponse);
parcelHelpers.export(exports, "UrlRetrievalStatus", ()=>UrlRetrievalStatus);
parcelHelpers.export(exports, "createModelContent", ()=>createModelContent);
parcelHelpers.export(exports, "createPartFromBase64", ()=>createPartFromBase64);
parcelHelpers.export(exports, "createPartFromCodeExecutionResult", ()=>createPartFromCodeExecutionResult);
parcelHelpers.export(exports, "createPartFromExecutableCode", ()=>createPartFromExecutableCode);
parcelHelpers.export(exports, "createPartFromFunctionCall", ()=>createPartFromFunctionCall);
parcelHelpers.export(exports, "createPartFromFunctionResponse", ()=>createPartFromFunctionResponse);
parcelHelpers.export(exports, "createPartFromText", ()=>createPartFromText);
parcelHelpers.export(exports, "createPartFromUri", ()=>createPartFromUri);
parcelHelpers.export(exports, "createUserContent", ()=>createUserContent);
parcelHelpers.export(exports, "mcpToTool", ()=>mcpToTool);
parcelHelpers.export(exports, "setDefaultBaseUrls", ()=>setDefaultBaseUrls);
var _zod = require("zod");
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ let _defaultBaseGeminiUrl = undefined;
let _defaultBaseVertexUrl = undefined;
/**
 * Overrides the base URLs for the Gemini API and Vertex AI API.
 *
 * @remarks This function should be called before initializing the SDK. If the
 * base URLs are set after initializing the SDK, the base URLs will not be
 * updated. Base URLs provided in the HttpOptions will also take precedence over
 * URLs set here.
 *
 * @example
 * ```ts
 * import {GoogleGenAI, setDefaultBaseUrls} from '@google/genai';
 * // Override the base URL for the Gemini API.
 * setDefaultBaseUrls({geminiUrl:'https://gemini.google.com'});
 *
 * // Override the base URL for the Vertex AI API.
 * setDefaultBaseUrls({vertexUrl: 'https://vertexai.googleapis.com'});
 *
 * const ai = new GoogleGenAI({apiKey: 'GEMINI_API_KEY'});
 * ```
 */ function setDefaultBaseUrls(baseUrlParams) {
    _defaultBaseGeminiUrl = baseUrlParams.geminiUrl;
    _defaultBaseVertexUrl = baseUrlParams.vertexUrl;
}
/**
 * Returns the default base URLs for the Gemini API and Vertex AI API.
 */ function getDefaultBaseUrls() {
    return {
        geminiUrl: _defaultBaseGeminiUrl,
        vertexUrl: _defaultBaseVertexUrl
    };
}
/**
 * Returns the default base URL based on the following priority:
 *   1. Base URLs set via HttpOptions.
 *   2. Base URLs set via the latest call to setDefaultBaseUrls.
 *   3. Base URLs set via environment variables.
 */ function getBaseUrl(options, vertexBaseUrlFromEnv, geminiBaseUrlFromEnv) {
    var _a, _b, _c;
    if (!((_a = options.httpOptions) === null || _a === void 0 ? void 0 : _a.baseUrl)) {
        const defaultBaseUrls = getDefaultBaseUrls();
        if (options.vertexai) return (_b = defaultBaseUrls.vertexUrl) !== null && _b !== void 0 ? _b : vertexBaseUrlFromEnv;
        else return (_c = defaultBaseUrls.geminiUrl) !== null && _c !== void 0 ? _c : geminiBaseUrlFromEnv;
    }
    return options.httpOptions.baseUrl;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class BaseModule {
}
function formatMap(templateString, valueMap) {
    // Use a regular expression to find all placeholders in the template string
    const regex = /\{([^}]+)\}/g;
    // Replace each placeholder with its corresponding value from the valueMap
    return templateString.replace(regex, (match, key)=>{
        if (Object.prototype.hasOwnProperty.call(valueMap, key)) {
            const value = valueMap[key];
            // Convert the value to a string if it's not a string already
            return value !== undefined && value !== null ? String(value) : '';
        } else // Handle missing keys
        throw new Error(`Key '${key}' not found in valueMap.`);
    });
}
function setValueByPath(data, keys, value) {
    for(let i = 0; i < keys.length - 1; i++){
        const key = keys[i];
        if (key.endsWith('[]')) {
            const keyName = key.slice(0, -2);
            if (!(keyName in data)) {
                if (Array.isArray(value)) data[keyName] = Array.from({
                    length: value.length
                }, ()=>({}));
                else throw new Error(`Value must be a list given an array path ${key}`);
            }
            if (Array.isArray(data[keyName])) {
                const arrayData = data[keyName];
                if (Array.isArray(value)) for(let j = 0; j < arrayData.length; j++){
                    const entry = arrayData[j];
                    setValueByPath(entry, keys.slice(i + 1), value[j]);
                }
                else for (const d of arrayData)setValueByPath(d, keys.slice(i + 1), value);
            }
            return;
        } else if (key.endsWith('[0]')) {
            const keyName = key.slice(0, -3);
            if (!(keyName in data)) data[keyName] = [
                {}
            ];
            const arrayData = data[keyName];
            setValueByPath(arrayData[0], keys.slice(i + 1), value);
            return;
        }
        if (!data[key] || typeof data[key] !== 'object') data[key] = {};
        data = data[key];
    }
    const keyToSet = keys[keys.length - 1];
    const existingData = data[keyToSet];
    if (existingData !== undefined) {
        if (!value || typeof value === 'object' && Object.keys(value).length === 0) return;
        if (value === existingData) return;
        if (typeof existingData === 'object' && typeof value === 'object' && existingData !== null && value !== null) Object.assign(existingData, value);
        else throw new Error(`Cannot set value for an existing key. Key: ${keyToSet}`);
    } else data[keyToSet] = value;
}
function getValueByPath(data, keys) {
    try {
        if (keys.length === 1 && keys[0] === '_self') return data;
        for(let i = 0; i < keys.length; i++){
            if (typeof data !== 'object' || data === null) return undefined;
            const key = keys[i];
            if (key.endsWith('[]')) {
                const keyName = key.slice(0, -2);
                if (keyName in data) {
                    const arrayData = data[keyName];
                    if (!Array.isArray(arrayData)) return undefined;
                    return arrayData.map((d)=>getValueByPath(d, keys.slice(i + 1)));
                } else return undefined;
            } else data = data[key];
        }
        return data;
    } catch (error) {
        if (error instanceof TypeError) return undefined;
        throw error;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /** Required. Outcome of the code execution. */ var Outcome;
(function(Outcome) {
    /**
     * Unspecified status. This value should not be used.
     */ Outcome["OUTCOME_UNSPECIFIED"] = "OUTCOME_UNSPECIFIED";
    /**
     * Code execution completed successfully.
     */ Outcome["OUTCOME_OK"] = "OUTCOME_OK";
    /**
     * Code execution finished but with a failure. `stderr` should contain the reason.
     */ Outcome["OUTCOME_FAILED"] = "OUTCOME_FAILED";
    /**
     * Code execution ran for too long, and was cancelled. There may or may not be a partial output present.
     */ Outcome["OUTCOME_DEADLINE_EXCEEDED"] = "OUTCOME_DEADLINE_EXCEEDED";
})(Outcome || (Outcome = {}));
/** Required. Programming language of the `code`. */ var Language;
(function(Language) {
    /**
     * Unspecified language. This value should not be used.
     */ Language["LANGUAGE_UNSPECIFIED"] = "LANGUAGE_UNSPECIFIED";
    /**
     * Python >= 3.10, with numpy and simpy available.
     */ Language["PYTHON"] = "PYTHON";
})(Language || (Language = {}));
/** Optional. The type of the data. */ var Type;
(function(Type) {
    /**
     * Not specified, should not be used.
     */ Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    /**
     * OpenAPI string type
     */ Type["STRING"] = "STRING";
    /**
     * OpenAPI number type
     */ Type["NUMBER"] = "NUMBER";
    /**
     * OpenAPI integer type
     */ Type["INTEGER"] = "INTEGER";
    /**
     * OpenAPI boolean type
     */ Type["BOOLEAN"] = "BOOLEAN";
    /**
     * OpenAPI array type
     */ Type["ARRAY"] = "ARRAY";
    /**
     * OpenAPI object type
     */ Type["OBJECT"] = "OBJECT";
    /**
     * Null type
     */ Type["NULL"] = "NULL";
})(Type || (Type = {}));
/** Required. Harm category. */ var HarmCategory;
(function(HarmCategory) {
    /**
     * The harm category is unspecified.
     */ HarmCategory["HARM_CATEGORY_UNSPECIFIED"] = "HARM_CATEGORY_UNSPECIFIED";
    /**
     * The harm category is hate speech.
     */ HarmCategory["HARM_CATEGORY_HATE_SPEECH"] = "HARM_CATEGORY_HATE_SPEECH";
    /**
     * The harm category is dangerous content.
     */ HarmCategory["HARM_CATEGORY_DANGEROUS_CONTENT"] = "HARM_CATEGORY_DANGEROUS_CONTENT";
    /**
     * The harm category is harassment.
     */ HarmCategory["HARM_CATEGORY_HARASSMENT"] = "HARM_CATEGORY_HARASSMENT";
    /**
     * The harm category is sexually explicit content.
     */ HarmCategory["HARM_CATEGORY_SEXUALLY_EXPLICIT"] = "HARM_CATEGORY_SEXUALLY_EXPLICIT";
    /**
     * Deprecated: Election filter is not longer supported. The harm category is civic integrity.
     */ HarmCategory["HARM_CATEGORY_CIVIC_INTEGRITY"] = "HARM_CATEGORY_CIVIC_INTEGRITY";
})(HarmCategory || (HarmCategory = {}));
/** Optional. Specify if the threshold is used for probability or severity score. If not specified, the threshold is used for probability score. */ var HarmBlockMethod;
(function(HarmBlockMethod) {
    /**
     * The harm block method is unspecified.
     */ HarmBlockMethod["HARM_BLOCK_METHOD_UNSPECIFIED"] = "HARM_BLOCK_METHOD_UNSPECIFIED";
    /**
     * The harm block method uses both probability and severity scores.
     */ HarmBlockMethod["SEVERITY"] = "SEVERITY";
    /**
     * The harm block method uses the probability score.
     */ HarmBlockMethod["PROBABILITY"] = "PROBABILITY";
})(HarmBlockMethod || (HarmBlockMethod = {}));
/** Required. The harm block threshold. */ var HarmBlockThreshold;
(function(HarmBlockThreshold) {
    /**
     * Unspecified harm block threshold.
     */ HarmBlockThreshold["HARM_BLOCK_THRESHOLD_UNSPECIFIED"] = "HARM_BLOCK_THRESHOLD_UNSPECIFIED";
    /**
     * Block low threshold and above (i.e. block more).
     */ HarmBlockThreshold["BLOCK_LOW_AND_ABOVE"] = "BLOCK_LOW_AND_ABOVE";
    /**
     * Block medium threshold and above.
     */ HarmBlockThreshold["BLOCK_MEDIUM_AND_ABOVE"] = "BLOCK_MEDIUM_AND_ABOVE";
    /**
     * Block only high threshold (i.e. block less).
     */ HarmBlockThreshold["BLOCK_ONLY_HIGH"] = "BLOCK_ONLY_HIGH";
    /**
     * Block none.
     */ HarmBlockThreshold["BLOCK_NONE"] = "BLOCK_NONE";
    /**
     * Turn off the safety filter.
     */ HarmBlockThreshold["OFF"] = "OFF";
})(HarmBlockThreshold || (HarmBlockThreshold = {}));
/** The mode of the predictor to be used in dynamic retrieval. */ var Mode;
(function(Mode) {
    /**
     * Always trigger retrieval.
     */ Mode["MODE_UNSPECIFIED"] = "MODE_UNSPECIFIED";
    /**
     * Run retrieval only when system decides it is necessary.
     */ Mode["MODE_DYNAMIC"] = "MODE_DYNAMIC";
})(Mode || (Mode = {}));
/** Type of auth scheme. */ var AuthType;
(function(AuthType) {
    AuthType["AUTH_TYPE_UNSPECIFIED"] = "AUTH_TYPE_UNSPECIFIED";
    /**
     * No Auth.
     */ AuthType["NO_AUTH"] = "NO_AUTH";
    /**
     * API Key Auth.
     */ AuthType["API_KEY_AUTH"] = "API_KEY_AUTH";
    /**
     * HTTP Basic Auth.
     */ AuthType["HTTP_BASIC_AUTH"] = "HTTP_BASIC_AUTH";
    /**
     * Google Service Account Auth.
     */ AuthType["GOOGLE_SERVICE_ACCOUNT_AUTH"] = "GOOGLE_SERVICE_ACCOUNT_AUTH";
    /**
     * OAuth auth.
     */ AuthType["OAUTH"] = "OAUTH";
    /**
     * OpenID Connect (OIDC) Auth.
     */ AuthType["OIDC_AUTH"] = "OIDC_AUTH";
})(AuthType || (AuthType = {}));
/** Output only. The reason why the model stopped generating tokens.

  If empty, the model has not stopped generating the tokens.
   */ var FinishReason;
(function(FinishReason) {
    /**
     * The finish reason is unspecified.
     */ FinishReason["FINISH_REASON_UNSPECIFIED"] = "FINISH_REASON_UNSPECIFIED";
    /**
     * Token generation reached a natural stopping point or a configured stop sequence.
     */ FinishReason["STOP"] = "STOP";
    /**
     * Token generation reached the configured maximum output tokens.
     */ FinishReason["MAX_TOKENS"] = "MAX_TOKENS";
    /**
     * Token generation stopped because the content potentially contains safety violations. NOTE: When streaming, [content][] is empty if content filters blocks the output.
     */ FinishReason["SAFETY"] = "SAFETY";
    /**
     * The token generation stopped because of potential recitation.
     */ FinishReason["RECITATION"] = "RECITATION";
    /**
     * The token generation stopped because of using an unsupported language.
     */ FinishReason["LANGUAGE"] = "LANGUAGE";
    /**
     * All other reasons that stopped the token generation.
     */ FinishReason["OTHER"] = "OTHER";
    /**
     * Token generation stopped because the content contains forbidden terms.
     */ FinishReason["BLOCKLIST"] = "BLOCKLIST";
    /**
     * Token generation stopped for potentially containing prohibited content.
     */ FinishReason["PROHIBITED_CONTENT"] = "PROHIBITED_CONTENT";
    /**
     * Token generation stopped because the content potentially contains Sensitive Personally Identifiable Information (SPII).
     */ FinishReason["SPII"] = "SPII";
    /**
     * The function call generated by the model is invalid.
     */ FinishReason["MALFORMED_FUNCTION_CALL"] = "MALFORMED_FUNCTION_CALL";
    /**
     * Token generation stopped because generated images have safety violations.
     */ FinishReason["IMAGE_SAFETY"] = "IMAGE_SAFETY";
    /**
     * The tool call generated by the model is invalid.
     */ FinishReason["UNEXPECTED_TOOL_CALL"] = "UNEXPECTED_TOOL_CALL";
})(FinishReason || (FinishReason = {}));
/** Output only. Harm probability levels in the content. */ var HarmProbability;
(function(HarmProbability) {
    /**
     * Harm probability unspecified.
     */ HarmProbability["HARM_PROBABILITY_UNSPECIFIED"] = "HARM_PROBABILITY_UNSPECIFIED";
    /**
     * Negligible level of harm.
     */ HarmProbability["NEGLIGIBLE"] = "NEGLIGIBLE";
    /**
     * Low level of harm.
     */ HarmProbability["LOW"] = "LOW";
    /**
     * Medium level of harm.
     */ HarmProbability["MEDIUM"] = "MEDIUM";
    /**
     * High level of harm.
     */ HarmProbability["HIGH"] = "HIGH";
})(HarmProbability || (HarmProbability = {}));
/** Output only. Harm severity levels in the content. */ var HarmSeverity;
(function(HarmSeverity) {
    /**
     * Harm severity unspecified.
     */ HarmSeverity["HARM_SEVERITY_UNSPECIFIED"] = "HARM_SEVERITY_UNSPECIFIED";
    /**
     * Negligible level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_NEGLIGIBLE"] = "HARM_SEVERITY_NEGLIGIBLE";
    /**
     * Low level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_LOW"] = "HARM_SEVERITY_LOW";
    /**
     * Medium level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_MEDIUM"] = "HARM_SEVERITY_MEDIUM";
    /**
     * High level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_HIGH"] = "HARM_SEVERITY_HIGH";
})(HarmSeverity || (HarmSeverity = {}));
/** Output only. Blocked reason. */ var BlockedReason;
(function(BlockedReason) {
    /**
     * Unspecified blocked reason.
     */ BlockedReason["BLOCKED_REASON_UNSPECIFIED"] = "BLOCKED_REASON_UNSPECIFIED";
    /**
     * Candidates blocked due to safety.
     */ BlockedReason["SAFETY"] = "SAFETY";
    /**
     * Candidates blocked due to other reason.
     */ BlockedReason["OTHER"] = "OTHER";
    /**
     * Candidates blocked due to the terms which are included from the terminology blocklist.
     */ BlockedReason["BLOCKLIST"] = "BLOCKLIST";
    /**
     * Candidates blocked due to prohibited content.
     */ BlockedReason["PROHIBITED_CONTENT"] = "PROHIBITED_CONTENT";
})(BlockedReason || (BlockedReason = {}));
/** Output only. Traffic type. This shows whether a request consumes Pay-As-You-Go or Provisioned Throughput quota. */ var TrafficType;
(function(TrafficType) {
    /**
     * Unspecified request traffic type.
     */ TrafficType["TRAFFIC_TYPE_UNSPECIFIED"] = "TRAFFIC_TYPE_UNSPECIFIED";
    /**
     * Type for Pay-As-You-Go traffic.
     */ TrafficType["ON_DEMAND"] = "ON_DEMAND";
    /**
     * Type for Provisioned Throughput traffic.
     */ TrafficType["PROVISIONED_THROUGHPUT"] = "PROVISIONED_THROUGHPUT";
})(TrafficType || (TrafficType = {}));
/** Server content modalities. */ var Modality;
(function(Modality) {
    /**
     * The modality is unspecified.
     */ Modality["MODALITY_UNSPECIFIED"] = "MODALITY_UNSPECIFIED";
    /**
     * Indicates the model should return text
     */ Modality["TEXT"] = "TEXT";
    /**
     * Indicates the model should return images.
     */ Modality["IMAGE"] = "IMAGE";
    /**
     * Indicates the model should return audio.
     */ Modality["AUDIO"] = "AUDIO";
})(Modality || (Modality = {}));
/** The media resolution to use. */ var MediaResolution;
(function(MediaResolution) {
    /**
     * Media resolution has not been set
     */ MediaResolution["MEDIA_RESOLUTION_UNSPECIFIED"] = "MEDIA_RESOLUTION_UNSPECIFIED";
    /**
     * Media resolution set to low (64 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_LOW"] = "MEDIA_RESOLUTION_LOW";
    /**
     * Media resolution set to medium (256 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_MEDIUM"] = "MEDIA_RESOLUTION_MEDIUM";
    /**
     * Media resolution set to high (zoomed reframing with 256 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_HIGH"] = "MEDIA_RESOLUTION_HIGH";
})(MediaResolution || (MediaResolution = {}));
/** Output only. The detailed state of the job. */ var JobState;
(function(JobState) {
    /**
     * The job state is unspecified.
     */ JobState["JOB_STATE_UNSPECIFIED"] = "JOB_STATE_UNSPECIFIED";
    /**
     * The job has been just created or resumed and processing has not yet begun.
     */ JobState["JOB_STATE_QUEUED"] = "JOB_STATE_QUEUED";
    /**
     * The service is preparing to run the job.
     */ JobState["JOB_STATE_PENDING"] = "JOB_STATE_PENDING";
    /**
     * The job is in progress.
     */ JobState["JOB_STATE_RUNNING"] = "JOB_STATE_RUNNING";
    /**
     * The job completed successfully.
     */ JobState["JOB_STATE_SUCCEEDED"] = "JOB_STATE_SUCCEEDED";
    /**
     * The job failed.
     */ JobState["JOB_STATE_FAILED"] = "JOB_STATE_FAILED";
    /**
     * The job is being cancelled. From this state the job may only go to either `JOB_STATE_SUCCEEDED`, `JOB_STATE_FAILED` or `JOB_STATE_CANCELLED`.
     */ JobState["JOB_STATE_CANCELLING"] = "JOB_STATE_CANCELLING";
    /**
     * The job has been cancelled.
     */ JobState["JOB_STATE_CANCELLED"] = "JOB_STATE_CANCELLED";
    /**
     * The job has been stopped, and can be resumed.
     */ JobState["JOB_STATE_PAUSED"] = "JOB_STATE_PAUSED";
    /**
     * The job has expired.
     */ JobState["JOB_STATE_EXPIRED"] = "JOB_STATE_EXPIRED";
    /**
     * The job is being updated. Only jobs in the `RUNNING` state can be updated. After updating, the job goes back to the `RUNNING` state.
     */ JobState["JOB_STATE_UPDATING"] = "JOB_STATE_UPDATING";
    /**
     * The job is partially succeeded, some results may be missing due to errors.
     */ JobState["JOB_STATE_PARTIALLY_SUCCEEDED"] = "JOB_STATE_PARTIALLY_SUCCEEDED";
})(JobState || (JobState = {}));
/** Optional. Adapter size for tuning. */ var AdapterSize;
(function(AdapterSize) {
    /**
     * Adapter size is unspecified.
     */ AdapterSize["ADAPTER_SIZE_UNSPECIFIED"] = "ADAPTER_SIZE_UNSPECIFIED";
    /**
     * Adapter size 1.
     */ AdapterSize["ADAPTER_SIZE_ONE"] = "ADAPTER_SIZE_ONE";
    /**
     * Adapter size 2.
     */ AdapterSize["ADAPTER_SIZE_TWO"] = "ADAPTER_SIZE_TWO";
    /**
     * Adapter size 4.
     */ AdapterSize["ADAPTER_SIZE_FOUR"] = "ADAPTER_SIZE_FOUR";
    /**
     * Adapter size 8.
     */ AdapterSize["ADAPTER_SIZE_EIGHT"] = "ADAPTER_SIZE_EIGHT";
    /**
     * Adapter size 16.
     */ AdapterSize["ADAPTER_SIZE_SIXTEEN"] = "ADAPTER_SIZE_SIXTEEN";
    /**
     * Adapter size 32.
     */ AdapterSize["ADAPTER_SIZE_THIRTY_TWO"] = "ADAPTER_SIZE_THIRTY_TWO";
})(AdapterSize || (AdapterSize = {}));
/** Options for feature selection preference. */ var FeatureSelectionPreference;
(function(FeatureSelectionPreference) {
    FeatureSelectionPreference["FEATURE_SELECTION_PREFERENCE_UNSPECIFIED"] = "FEATURE_SELECTION_PREFERENCE_UNSPECIFIED";
    FeatureSelectionPreference["PRIORITIZE_QUALITY"] = "PRIORITIZE_QUALITY";
    FeatureSelectionPreference["BALANCED"] = "BALANCED";
    FeatureSelectionPreference["PRIORITIZE_COST"] = "PRIORITIZE_COST";
})(FeatureSelectionPreference || (FeatureSelectionPreference = {}));
/** Defines the function behavior. Defaults to `BLOCKING`. */ var Behavior;
(function(Behavior) {
    /**
     * This value is unused.
     */ Behavior["UNSPECIFIED"] = "UNSPECIFIED";
    /**
     * If set, the system will wait to receive the function response before continuing the conversation.
     */ Behavior["BLOCKING"] = "BLOCKING";
    /**
     * If set, the system will not wait to receive the function response. Instead, it will attempt to handle function responses as they become available while maintaining the conversation between the user and the model.
     */ Behavior["NON_BLOCKING"] = "NON_BLOCKING";
})(Behavior || (Behavior = {}));
/** Config for the dynamic retrieval config mode. */ var DynamicRetrievalConfigMode;
(function(DynamicRetrievalConfigMode) {
    /**
     * Always trigger retrieval.
     */ DynamicRetrievalConfigMode["MODE_UNSPECIFIED"] = "MODE_UNSPECIFIED";
    /**
     * Run retrieval only when system decides it is necessary.
     */ DynamicRetrievalConfigMode["MODE_DYNAMIC"] = "MODE_DYNAMIC";
})(DynamicRetrievalConfigMode || (DynamicRetrievalConfigMode = {}));
/** Config for the function calling config mode. */ var FunctionCallingConfigMode;
(function(FunctionCallingConfigMode) {
    /**
     * The function calling config mode is unspecified. Should not be used.
     */ FunctionCallingConfigMode["MODE_UNSPECIFIED"] = "MODE_UNSPECIFIED";
    /**
     * Default model behavior, model decides to predict either function calls or natural language response.
     */ FunctionCallingConfigMode["AUTO"] = "AUTO";
    /**
     * Model is constrained to always predicting function calls only. If "allowed_function_names" are set, the predicted function calls will be limited to any one of "allowed_function_names", else the predicted function calls will be any one of the provided "function_declarations".
     */ FunctionCallingConfigMode["ANY"] = "ANY";
    /**
     * Model will not predict any function calls. Model behavior is same as when not passing any function declarations.
     */ FunctionCallingConfigMode["NONE"] = "NONE";
})(FunctionCallingConfigMode || (FunctionCallingConfigMode = {}));
/** Status of the url retrieval. */ var UrlRetrievalStatus;
(function(UrlRetrievalStatus) {
    /**
     * Default value. This value is unused
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_UNSPECIFIED"] = "URL_RETRIEVAL_STATUS_UNSPECIFIED";
    /**
     * Url retrieval is successful.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_SUCCESS"] = "URL_RETRIEVAL_STATUS_SUCCESS";
    /**
     * Url retrieval is failed due to error.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_ERROR"] = "URL_RETRIEVAL_STATUS_ERROR";
})(UrlRetrievalStatus || (UrlRetrievalStatus = {}));
/** Enum that controls the safety filter level for objectionable content. */ var SafetyFilterLevel;
(function(SafetyFilterLevel) {
    SafetyFilterLevel["BLOCK_LOW_AND_ABOVE"] = "BLOCK_LOW_AND_ABOVE";
    SafetyFilterLevel["BLOCK_MEDIUM_AND_ABOVE"] = "BLOCK_MEDIUM_AND_ABOVE";
    SafetyFilterLevel["BLOCK_ONLY_HIGH"] = "BLOCK_ONLY_HIGH";
    SafetyFilterLevel["BLOCK_NONE"] = "BLOCK_NONE";
})(SafetyFilterLevel || (SafetyFilterLevel = {}));
/** Enum that controls the generation of people. */ var PersonGeneration;
(function(PersonGeneration) {
    PersonGeneration["DONT_ALLOW"] = "DONT_ALLOW";
    PersonGeneration["ALLOW_ADULT"] = "ALLOW_ADULT";
    PersonGeneration["ALLOW_ALL"] = "ALLOW_ALL";
})(PersonGeneration || (PersonGeneration = {}));
/** Enum that specifies the language of the text in the prompt. */ var ImagePromptLanguage;
(function(ImagePromptLanguage) {
    ImagePromptLanguage["auto"] = "auto";
    ImagePromptLanguage["en"] = "en";
    ImagePromptLanguage["ja"] = "ja";
    ImagePromptLanguage["ko"] = "ko";
    ImagePromptLanguage["hi"] = "hi";
})(ImagePromptLanguage || (ImagePromptLanguage = {}));
/** Enum representing the mask mode of a mask reference image. */ var MaskReferenceMode;
(function(MaskReferenceMode) {
    MaskReferenceMode["MASK_MODE_DEFAULT"] = "MASK_MODE_DEFAULT";
    MaskReferenceMode["MASK_MODE_USER_PROVIDED"] = "MASK_MODE_USER_PROVIDED";
    MaskReferenceMode["MASK_MODE_BACKGROUND"] = "MASK_MODE_BACKGROUND";
    MaskReferenceMode["MASK_MODE_FOREGROUND"] = "MASK_MODE_FOREGROUND";
    MaskReferenceMode["MASK_MODE_SEMANTIC"] = "MASK_MODE_SEMANTIC";
})(MaskReferenceMode || (MaskReferenceMode = {}));
/** Enum representing the control type of a control reference image. */ var ControlReferenceType;
(function(ControlReferenceType) {
    ControlReferenceType["CONTROL_TYPE_DEFAULT"] = "CONTROL_TYPE_DEFAULT";
    ControlReferenceType["CONTROL_TYPE_CANNY"] = "CONTROL_TYPE_CANNY";
    ControlReferenceType["CONTROL_TYPE_SCRIBBLE"] = "CONTROL_TYPE_SCRIBBLE";
    ControlReferenceType["CONTROL_TYPE_FACE_MESH"] = "CONTROL_TYPE_FACE_MESH";
})(ControlReferenceType || (ControlReferenceType = {}));
/** Enum representing the subject type of a subject reference image. */ var SubjectReferenceType;
(function(SubjectReferenceType) {
    SubjectReferenceType["SUBJECT_TYPE_DEFAULT"] = "SUBJECT_TYPE_DEFAULT";
    SubjectReferenceType["SUBJECT_TYPE_PERSON"] = "SUBJECT_TYPE_PERSON";
    SubjectReferenceType["SUBJECT_TYPE_ANIMAL"] = "SUBJECT_TYPE_ANIMAL";
    SubjectReferenceType["SUBJECT_TYPE_PRODUCT"] = "SUBJECT_TYPE_PRODUCT";
})(SubjectReferenceType || (SubjectReferenceType = {}));
/** Enum representing the Imagen 3 Edit mode. */ var EditMode;
(function(EditMode) {
    EditMode["EDIT_MODE_DEFAULT"] = "EDIT_MODE_DEFAULT";
    EditMode["EDIT_MODE_INPAINT_REMOVAL"] = "EDIT_MODE_INPAINT_REMOVAL";
    EditMode["EDIT_MODE_INPAINT_INSERTION"] = "EDIT_MODE_INPAINT_INSERTION";
    EditMode["EDIT_MODE_OUTPAINT"] = "EDIT_MODE_OUTPAINT";
    EditMode["EDIT_MODE_CONTROLLED_EDITING"] = "EDIT_MODE_CONTROLLED_EDITING";
    EditMode["EDIT_MODE_STYLE"] = "EDIT_MODE_STYLE";
    EditMode["EDIT_MODE_BGSWAP"] = "EDIT_MODE_BGSWAP";
    EditMode["EDIT_MODE_PRODUCT_IMAGE"] = "EDIT_MODE_PRODUCT_IMAGE";
})(EditMode || (EditMode = {}));
/** State for the lifecycle of a File. */ var FileState;
(function(FileState) {
    FileState["STATE_UNSPECIFIED"] = "STATE_UNSPECIFIED";
    FileState["PROCESSING"] = "PROCESSING";
    FileState["ACTIVE"] = "ACTIVE";
    FileState["FAILED"] = "FAILED";
})(FileState || (FileState = {}));
/** Source of the File. */ var FileSource;
(function(FileSource) {
    FileSource["SOURCE_UNSPECIFIED"] = "SOURCE_UNSPECIFIED";
    FileSource["UPLOADED"] = "UPLOADED";
    FileSource["GENERATED"] = "GENERATED";
})(FileSource || (FileSource = {}));
/** Server content modalities. */ var MediaModality;
(function(MediaModality) {
    /**
     * The modality is unspecified.
     */ MediaModality["MODALITY_UNSPECIFIED"] = "MODALITY_UNSPECIFIED";
    /**
     * Plain text.
     */ MediaModality["TEXT"] = "TEXT";
    /**
     * Images.
     */ MediaModality["IMAGE"] = "IMAGE";
    /**
     * Video.
     */ MediaModality["VIDEO"] = "VIDEO";
    /**
     * Audio.
     */ MediaModality["AUDIO"] = "AUDIO";
    /**
     * Document, e.g. PDF.
     */ MediaModality["DOCUMENT"] = "DOCUMENT";
})(MediaModality || (MediaModality = {}));
/** Start of speech sensitivity. */ var StartSensitivity;
(function(StartSensitivity) {
    /**
     * The default is START_SENSITIVITY_LOW.
     */ StartSensitivity["START_SENSITIVITY_UNSPECIFIED"] = "START_SENSITIVITY_UNSPECIFIED";
    /**
     * Automatic detection will detect the start of speech more often.
     */ StartSensitivity["START_SENSITIVITY_HIGH"] = "START_SENSITIVITY_HIGH";
    /**
     * Automatic detection will detect the start of speech less often.
     */ StartSensitivity["START_SENSITIVITY_LOW"] = "START_SENSITIVITY_LOW";
})(StartSensitivity || (StartSensitivity = {}));
/** End of speech sensitivity. */ var EndSensitivity;
(function(EndSensitivity) {
    /**
     * The default is END_SENSITIVITY_LOW.
     */ EndSensitivity["END_SENSITIVITY_UNSPECIFIED"] = "END_SENSITIVITY_UNSPECIFIED";
    /**
     * Automatic detection ends speech more often.
     */ EndSensitivity["END_SENSITIVITY_HIGH"] = "END_SENSITIVITY_HIGH";
    /**
     * Automatic detection ends speech less often.
     */ EndSensitivity["END_SENSITIVITY_LOW"] = "END_SENSITIVITY_LOW";
})(EndSensitivity || (EndSensitivity = {}));
/** The different ways of handling user activity. */ var ActivityHandling;
(function(ActivityHandling) {
    /**
     * If unspecified, the default behavior is `START_OF_ACTIVITY_INTERRUPTS`.
     */ ActivityHandling["ACTIVITY_HANDLING_UNSPECIFIED"] = "ACTIVITY_HANDLING_UNSPECIFIED";
    /**
     * If true, start of activity will interrupt the model's response (also called "barge in"). The model's current response will be cut-off in the moment of the interruption. This is the default behavior.
     */ ActivityHandling["START_OF_ACTIVITY_INTERRUPTS"] = "START_OF_ACTIVITY_INTERRUPTS";
    /**
     * The model's response will not be interrupted.
     */ ActivityHandling["NO_INTERRUPTION"] = "NO_INTERRUPTION";
})(ActivityHandling || (ActivityHandling = {}));
/** Options about which input is included in the user's turn. */ var TurnCoverage;
(function(TurnCoverage) {
    /**
     * If unspecified, the default behavior is `TURN_INCLUDES_ONLY_ACTIVITY`.
     */ TurnCoverage["TURN_COVERAGE_UNSPECIFIED"] = "TURN_COVERAGE_UNSPECIFIED";
    /**
     * The users turn only includes activity since the last turn, excluding inactivity (e.g. silence on the audio stream). This is the default behavior.
     */ TurnCoverage["TURN_INCLUDES_ONLY_ACTIVITY"] = "TURN_INCLUDES_ONLY_ACTIVITY";
    /**
     * The users turn includes all realtime input since the last turn, including inactivity (e.g. silence on the audio stream).
     */ TurnCoverage["TURN_INCLUDES_ALL_INPUT"] = "TURN_INCLUDES_ALL_INPUT";
})(TurnCoverage || (TurnCoverage = {}));
/** Specifies how the response should be scheduled in the conversation. */ var FunctionResponseScheduling;
(function(FunctionResponseScheduling) {
    /**
     * This value is unused.
     */ FunctionResponseScheduling["SCHEDULING_UNSPECIFIED"] = "SCHEDULING_UNSPECIFIED";
    /**
     * Only add the result to the conversation context, do not interrupt or trigger generation.
     */ FunctionResponseScheduling["SILENT"] = "SILENT";
    /**
     * Add the result to the conversation context, and prompt to generate output without interrupting ongoing generation.
     */ FunctionResponseScheduling["WHEN_IDLE"] = "WHEN_IDLE";
    /**
     * Add the result to the conversation context, interrupt ongoing generation and prompt to generate output.
     */ FunctionResponseScheduling["INTERRUPT"] = "INTERRUPT";
})(FunctionResponseScheduling || (FunctionResponseScheduling = {}));
/** Scale of the generated music. */ var Scale;
(function(Scale) {
    /**
     * Default value. This value is unused.
     */ Scale["SCALE_UNSPECIFIED"] = "SCALE_UNSPECIFIED";
    /**
     * C major or A minor.
     */ Scale["C_MAJOR_A_MINOR"] = "C_MAJOR_A_MINOR";
    /**
     * Db major or Bb minor.
     */ Scale["D_FLAT_MAJOR_B_FLAT_MINOR"] = "D_FLAT_MAJOR_B_FLAT_MINOR";
    /**
     * D major or B minor.
     */ Scale["D_MAJOR_B_MINOR"] = "D_MAJOR_B_MINOR";
    /**
     * Eb major or C minor
     */ Scale["E_FLAT_MAJOR_C_MINOR"] = "E_FLAT_MAJOR_C_MINOR";
    /**
     * E major or Db minor.
     */ Scale["E_MAJOR_D_FLAT_MINOR"] = "E_MAJOR_D_FLAT_MINOR";
    /**
     * F major or D minor.
     */ Scale["F_MAJOR_D_MINOR"] = "F_MAJOR_D_MINOR";
    /**
     * Gb major or Eb minor.
     */ Scale["G_FLAT_MAJOR_E_FLAT_MINOR"] = "G_FLAT_MAJOR_E_FLAT_MINOR";
    /**
     * G major or E minor.
     */ Scale["G_MAJOR_E_MINOR"] = "G_MAJOR_E_MINOR";
    /**
     * Ab major or F minor.
     */ Scale["A_FLAT_MAJOR_F_MINOR"] = "A_FLAT_MAJOR_F_MINOR";
    /**
     * A major or Gb minor.
     */ Scale["A_MAJOR_G_FLAT_MINOR"] = "A_MAJOR_G_FLAT_MINOR";
    /**
     * Bb major or G minor.
     */ Scale["B_FLAT_MAJOR_G_MINOR"] = "B_FLAT_MAJOR_G_MINOR";
    /**
     * B major or Ab minor.
     */ Scale["B_MAJOR_A_FLAT_MINOR"] = "B_MAJOR_A_FLAT_MINOR";
})(Scale || (Scale = {}));
/** The playback control signal to apply to the music generation. */ var LiveMusicPlaybackControl;
(function(LiveMusicPlaybackControl) {
    /**
     * This value is unused.
     */ LiveMusicPlaybackControl["PLAYBACK_CONTROL_UNSPECIFIED"] = "PLAYBACK_CONTROL_UNSPECIFIED";
    /**
     * Start generating the music.
     */ LiveMusicPlaybackControl["PLAY"] = "PLAY";
    /**
     * Hold the music generation. Use PLAY to resume from the current position.
     */ LiveMusicPlaybackControl["PAUSE"] = "PAUSE";
    /**
     * Stop the music generation and reset the context (prompts retained).
        Use PLAY to restart the music generation.
     */ LiveMusicPlaybackControl["STOP"] = "STOP";
    /**
     * Reset the context of the music generation without stopping it.
        Retains the current prompts and config.
     */ LiveMusicPlaybackControl["RESET_CONTEXT"] = "RESET_CONTEXT";
})(LiveMusicPlaybackControl || (LiveMusicPlaybackControl = {}));
/** A function response. */ class FunctionResponse {
}
/**
 * Creates a `Part` object from a `URI` string.
 */ function createPartFromUri(uri, mimeType) {
    return {
        fileData: {
            fileUri: uri,
            mimeType: mimeType
        }
    };
}
/**
 * Creates a `Part` object from a `text` string.
 */ function createPartFromText(text) {
    return {
        text: text
    };
}
/**
 * Creates a `Part` object from a `FunctionCall` object.
 */ function createPartFromFunctionCall(name, args) {
    return {
        functionCall: {
            name: name,
            args: args
        }
    };
}
/**
 * Creates a `Part` object from a `FunctionResponse` object.
 */ function createPartFromFunctionResponse(id, name, response) {
    return {
        functionResponse: {
            id: id,
            name: name,
            response: response
        }
    };
}
/**
 * Creates a `Part` object from a `base64` encoded `string`.
 */ function createPartFromBase64(data, mimeType) {
    return {
        inlineData: {
            data: data,
            mimeType: mimeType
        }
    };
}
/**
 * Creates a `Part` object from the `outcome` and `output` of a `CodeExecutionResult` object.
 */ function createPartFromCodeExecutionResult(outcome, output) {
    return {
        codeExecutionResult: {
            outcome: outcome,
            output: output
        }
    };
}
/**
 * Creates a `Part` object from the `code` and `language` of an `ExecutableCode` object.
 */ function createPartFromExecutableCode(code, language) {
    return {
        executableCode: {
            code: code,
            language: language
        }
    };
}
function _isPart(obj) {
    if (typeof obj === 'object' && obj !== null) return 'fileData' in obj || 'text' in obj || 'functionCall' in obj || 'functionResponse' in obj || 'inlineData' in obj || 'videoMetadata' in obj || 'codeExecutionResult' in obj || 'executableCode' in obj;
    return false;
}
function _toParts(partOrString) {
    const parts = [];
    if (typeof partOrString === 'string') parts.push(createPartFromText(partOrString));
    else if (_isPart(partOrString)) parts.push(partOrString);
    else if (Array.isArray(partOrString)) {
        if (partOrString.length === 0) throw new Error('partOrString cannot be an empty array');
        for (const part of partOrString){
            if (typeof part === 'string') parts.push(createPartFromText(part));
            else if (_isPart(part)) parts.push(part);
            else throw new Error('element in PartUnion must be a Part object or string');
        }
    } else throw new Error('partOrString must be a Part object, string, or array');
    return parts;
}
/**
 * Creates a `Content` object with a user role from a `PartListUnion` object or `string`.
 */ function createUserContent(partOrString) {
    return {
        role: 'user',
        parts: _toParts(partOrString)
    };
}
/**
 * Creates a `Content` object with a model role from a `PartListUnion` object or `string`.
 */ function createModelContent(partOrString) {
    return {
        role: 'model',
        parts: _toParts(partOrString)
    };
}
/** Content filter results for a prompt sent in the request. */ class GenerateContentResponsePromptFeedback {
}
/** Usage metadata about response(s). */ class GenerateContentResponseUsageMetadata {
}
/** Response message for PredictionService.GenerateContent. */ class GenerateContentResponse {
    /**
     * Returns the concatenation of all text parts from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the text from the first
     * one will be returned.
     * If there are non-text parts in the response, the concatenation of all text
     * parts will be returned, and a warning will be logged.
     * If there are thought parts in the response, the concatenation of all text
     * parts excluding the thought parts will be returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'Why is the sky blue?',
     * });
     *
     * console.debug(response.text);
     * ```
     */ get text() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning text from the first one.');
        let text = '';
        let anyTextPartText = false;
        const nonTextParts = [];
        for (const part of (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) !== null && _h !== void 0 ? _h : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'text' && fieldName !== 'thought' && (fieldValue !== null || fieldValue !== undefined)) nonTextParts.push(fieldName);
            if (typeof part.text === 'string') {
                if (typeof part.thought === 'boolean' && part.thought) continue;
                anyTextPartText = true;
                text += part.text;
            }
        }
        if (nonTextParts.length > 0) console.warn(`there are non-text parts ${nonTextParts} in the response, returning concatenation of all text parts. Please refer to the non text parts for a full response from model.`);
        // part.text === '' is different from part.text is null
        return anyTextPartText ? text : undefined;
    }
    /**
     * Returns the concatenation of all inline data parts from the first candidate
     * in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the inline data from the
     * first one will be returned. If there are non-inline data parts in the
     * response, the concatenation of all inline data parts will be returned, and
     * a warning will be logged.
     */ get data() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning data from the first one.');
        let data = '';
        const nonDataParts = [];
        for (const part of (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) !== null && _h !== void 0 ? _h : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'inlineData' && (fieldValue !== null || fieldValue !== undefined)) nonDataParts.push(fieldName);
            if (part.inlineData && typeof part.inlineData.data === 'string') data += atob(part.inlineData.data);
        }
        if (nonDataParts.length > 0) console.warn(`there are non-data parts ${nonDataParts} in the response, returning concatenation of all data parts. Please refer to the non data parts for a full response from model.`);
        return data.length > 0 ? btoa(data) : undefined;
    }
    /**
     * Returns the function calls from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the function calls from
     * the first one will be returned.
     * If there are no function calls in the response, undefined will be returned.
     *
     * @example
     * ```ts
     * const controlLightFunctionDeclaration: FunctionDeclaration = {
     *   name: 'controlLight',
     *   parameters: {
     *   type: Type.OBJECT,
     *   description: 'Set the brightness and color temperature of a room light.',
     *   properties: {
     *     brightness: {
     *       type: Type.NUMBER,
     *       description:
     *         'Light level from 0 to 100. Zero is off and 100 is full brightness.',
     *     },
     *     colorTemperature: {
     *       type: Type.STRING,
     *       description:
     *         'Color temperature of the light fixture which can be `daylight`, `cool` or `warm`.',
     *     },
     *   },
     *   required: ['brightness', 'colorTemperature'],
     *  };
     *  const response = await ai.models.generateContent({
     *     model: 'gemini-2.0-flash',
     *     contents: 'Dim the lights so the room feels cozy and warm.',
     *     config: {
     *       tools: [{functionDeclarations: [controlLightFunctionDeclaration]}],
     *       toolConfig: {
     *         functionCallingConfig: {
     *           mode: FunctionCallingConfigMode.ANY,
     *           allowedFunctionNames: ['controlLight'],
     *         },
     *       },
     *     },
     *   });
     *  console.debug(JSON.stringify(response.functionCalls));
     * ```
     */ get functionCalls() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning function calls from the first one.');
        const functionCalls = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.functionCall).map((part)=>part.functionCall).filter((functionCall)=>functionCall !== undefined);
        if ((functionCalls === null || functionCalls === void 0 ? void 0 : functionCalls.length) === 0) return undefined;
        return functionCalls;
    }
    /**
     * Returns the first executable code from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the executable code from
     * the first one will be returned.
     * If there are no executable code in the response, undefined will be
     * returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'What is the sum of the first 50 prime numbers? Generate and run code for the calculation, and make sure you get all 50.'
     *   config: {
     *     tools: [{codeExecution: {}}],
     *   },
     * });
     *
     * console.debug(response.executableCode);
     * ```
     */ get executableCode() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning executable code from the first one.');
        const executableCode = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.executableCode).map((part)=>part.executableCode).filter((executableCode)=>executableCode !== undefined);
        if ((executableCode === null || executableCode === void 0 ? void 0 : executableCode.length) === 0) return undefined;
        return (_j = executableCode === null || executableCode === void 0 ? void 0 : executableCode[0]) === null || _j === void 0 ? void 0 : _j.code;
    }
    /**
     * Returns the first code execution result from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the code execution result from
     * the first one will be returned.
     * If there are no code execution result in the response, undefined will be returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'What is the sum of the first 50 prime numbers? Generate and run code for the calculation, and make sure you get all 50.'
     *   config: {
     *     tools: [{codeExecution: {}}],
     *   },
     * });
     *
     * console.debug(response.codeExecutionResult);
     * ```
     */ get codeExecutionResult() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning code execution result from the first one.');
        const codeExecutionResult = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.codeExecutionResult).map((part)=>part.codeExecutionResult).filter((codeExecutionResult)=>codeExecutionResult !== undefined);
        if ((codeExecutionResult === null || codeExecutionResult === void 0 ? void 0 : codeExecutionResult.length) === 0) return undefined;
        return (_j = codeExecutionResult === null || codeExecutionResult === void 0 ? void 0 : codeExecutionResult[0]) === null || _j === void 0 ? void 0 : _j.output;
    }
}
/** Response for the embed_content method. */ class EmbedContentResponse {
}
/** The output images response. */ class GenerateImagesResponse {
}
/** Response for the request to edit an image. */ class EditImageResponse {
}
class UpscaleImageResponse {
}
class ListModelsResponse {
}
class DeleteModelResponse {
}
/** Response for counting tokens. */ class CountTokensResponse {
}
/** Response for computing tokens. */ class ComputeTokensResponse {
}
/** Response with generated videos. */ class GenerateVideosResponse {
}
/** Response for the list tuning jobs method. */ class ListTuningJobsResponse {
}
/** Empty response for caches.delete method. */ class DeleteCachedContentResponse {
}
class ListCachedContentsResponse {
}
/** Response for the list files method. */ class ListFilesResponse {
}
/** A wrapper class for the http response. */ class HttpResponse {
    constructor(response){
        // Process the headers.
        const headers = {};
        for (const pair of response.headers.entries())headers[pair[0]] = pair[1];
        this.headers = headers;
        // Keep the original response.
        this.responseInternal = response;
    }
    json() {
        return this.responseInternal.json();
    }
}
/** Response for the create file method. */ class CreateFileResponse {
}
/** Response for the delete file method. */ class DeleteFileResponse {
}
/** Represents a single response in a replay. */ class ReplayResponse {
}
/** A raw reference image.

  A raw reference image represents the base image to edit, provided by the user.
  It can optionally be provided in addition to a mask reference image or
  a style reference image.
   */ class RawReferenceImage {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_RAW',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId
        };
        return referenceImageAPI;
    }
}
/** A mask reference image.

  This encapsulates either a mask image provided by the user and configs for
  the user provided mask, or only config parameters for the model to generate
  a mask.

  A mask image is an image whose non-zero values indicate where to edit the base
  image. If the user provides a mask image, the mask must be in the same
  dimensions as the raw image.
   */ class MaskReferenceImage {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_MASK',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            maskImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A control reference image.

  The image of the control reference image is either a control image provided
  by the user, or a regular image which the backend will use to generate a
  control image of. In the case of the latter, the
  enable_control_image_computation field in the config should be set to True.

  A control image is an image that represents a sketch image of areas for the
  model to fill in based on the prompt.
   */ class ControlReferenceImage {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_CONTROL',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            controlImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A style reference image.

  This encapsulates a style reference image provided by the user, and
  additionally optional config parameters for the style reference image.

  A raw reference image can also be provided as a destination for the style to
  be applied to.
   */ class StyleReferenceImage {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_STYLE',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            styleImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A subject reference image.

  This encapsulates a subject reference image provided by the user, and
  additionally optional config parameters for the subject reference image.

  A raw reference image can also be provided as a destination for the subject to
  be applied to.
   */ class SubjectReferenceImage {
    /* Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_SUBJECT',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            subjectImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** Response message for API call. */ class LiveServerMessage {
    /**
     * Returns the concatenation of all text parts from the server content if present.
     *
     * @remarks
     * If there are non-text parts in the response, the concatenation of all text
     * parts will be returned, and a warning will be logged.
     */ get text() {
        var _a, _b, _c;
        let text = '';
        let anyTextPartFound = false;
        const nonTextParts = [];
        for (const part of (_c = (_b = (_a = this.serverContent) === null || _a === void 0 ? void 0 : _a.modelTurn) === null || _b === void 0 ? void 0 : _b.parts) !== null && _c !== void 0 ? _c : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'text' && fieldName !== 'thought' && fieldValue !== null) nonTextParts.push(fieldName);
            if (typeof part.text === 'string') {
                if (typeof part.thought === 'boolean' && part.thought) continue;
                anyTextPartFound = true;
                text += part.text;
            }
        }
        if (nonTextParts.length > 0) console.warn(`there are non-text parts ${nonTextParts} in the response, returning concatenation of all text parts. Please refer to the non text parts for a full response from model.`);
        // part.text === '' is different from part.text is null
        return anyTextPartFound ? text : undefined;
    }
    /**
     * Returns the concatenation of all inline data parts from the server content if present.
     *
     * @remarks
     * If there are non-inline data parts in the
     * response, the concatenation of all inline data parts will be returned, and
     * a warning will be logged.
     */ get data() {
        var _a, _b, _c;
        let data = '';
        const nonDataParts = [];
        for (const part of (_c = (_b = (_a = this.serverContent) === null || _a === void 0 ? void 0 : _a.modelTurn) === null || _b === void 0 ? void 0 : _b.parts) !== null && _c !== void 0 ? _c : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'inlineData' && fieldValue !== null) nonDataParts.push(fieldName);
            if (part.inlineData && typeof part.inlineData.data === 'string') data += atob(part.inlineData.data);
        }
        if (nonDataParts.length > 0) console.warn(`there are non-data parts ${nonDataParts} in the response, returning concatenation of all data parts. Please refer to the non data parts for a full response from model.`);
        return data.length > 0 ? btoa(data) : undefined;
    }
}
/** Client generated response to a `ToolCall` received from the server.

  Individual `FunctionResponse` objects are matched to the respective
  `FunctionCall` objects by the `id` field.

  Note that in the unary and server-streaming GenerateContent APIs function
  calling happens by exchanging the `Content` parts, while in the bidi
  GenerateContent APIs function calling happens over this dedicated set of
  messages.
   */ class LiveClientToolResponse {
}
/** Parameters for sending tool responses to the live API. */ class LiveSendToolResponseParameters {
    constructor(){
        /** Tool responses to send to the session. */ this.functionResponses = [];
    }
}
/** Response message for the LiveMusicClientMessage call. */ class LiveMusicServerMessage {
    /**
     * Returns the first audio chunk from the server content, if present.
     *
     * @remarks
     * If there are no audio chunks in the response, undefined will be returned.
     */ get audioChunk() {
        if (this.serverContent && this.serverContent.audioChunks && this.serverContent.audioChunks.length > 0) return this.serverContent.audioChunks[0];
        return undefined;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function tModel(apiClient, model) {
    if (!model || typeof model !== 'string') throw new Error('model is required and must be a string');
    if (apiClient.isVertexAI()) {
        if (model.startsWith('publishers/') || model.startsWith('projects/') || model.startsWith('models/')) return model;
        else if (model.indexOf('/') >= 0) {
            const parts = model.split('/', 2);
            return `publishers/${parts[0]}/models/${parts[1]}`;
        } else return `publishers/google/models/${model}`;
    } else {
        if (model.startsWith('models/') || model.startsWith('tunedModels/')) return model;
        else return `models/${model}`;
    }
}
function tCachesModel(apiClient, model) {
    const transformedModel = tModel(apiClient, model);
    if (!transformedModel) return '';
    if (transformedModel.startsWith('publishers/') && apiClient.isVertexAI()) // vertex caches only support model name start with projects.
    return `projects/${apiClient.getProject()}/locations/${apiClient.getLocation()}/${transformedModel}`;
    else if (transformedModel.startsWith('models/') && apiClient.isVertexAI()) return `projects/${apiClient.getProject()}/locations/${apiClient.getLocation()}/publishers/google/${transformedModel}`;
    else return transformedModel;
}
function tBlobs(apiClient, blobs) {
    if (Array.isArray(blobs)) return blobs.map((blob)=>tBlob(apiClient, blob));
    else return [
        tBlob(apiClient, blobs)
    ];
}
function tBlob(apiClient, blob) {
    if (typeof blob === 'object' && blob !== null) return blob;
    throw new Error(`Could not parse input as Blob. Unsupported blob type: ${typeof blob}`);
}
function tImageBlob(apiClient, blob) {
    const transformedBlob = tBlob(apiClient, blob);
    if (transformedBlob.mimeType && transformedBlob.mimeType.startsWith('image/')) return transformedBlob;
    throw new Error(`Unsupported mime type: ${transformedBlob.mimeType}`);
}
function tAudioBlob(apiClient, blob) {
    const transformedBlob = tBlob(apiClient, blob);
    if (transformedBlob.mimeType && transformedBlob.mimeType.startsWith('audio/')) return transformedBlob;
    throw new Error(`Unsupported mime type: ${transformedBlob.mimeType}`);
}
function tPart(apiClient, origin) {
    if (origin === null || origin === undefined) throw new Error('PartUnion is required');
    if (typeof origin === 'object') return origin;
    if (typeof origin === 'string') return {
        text: origin
    };
    throw new Error(`Unsupported part type: ${typeof origin}`);
}
function tParts(apiClient, origin) {
    if (origin === null || origin === undefined || Array.isArray(origin) && origin.length === 0) throw new Error('PartListUnion is required');
    if (Array.isArray(origin)) return origin.map((item)=>tPart(apiClient, item));
    return [
        tPart(apiClient, origin)
    ];
}
function _isContent(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'parts' in origin && Array.isArray(origin.parts);
}
function _isFunctionCallPart(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'functionCall' in origin;
}
function _isFunctionResponsePart(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'functionResponse' in origin;
}
function tContent(apiClient, origin) {
    if (origin === null || origin === undefined) throw new Error('ContentUnion is required');
    if (_isContent(origin)) // _isContent is a utility function that checks if the
    // origin is a Content.
    return origin;
    return {
        role: 'user',
        parts: tParts(apiClient, origin)
    };
}
function tContentsForEmbed(apiClient, origin) {
    if (!origin) return [];
    if (apiClient.isVertexAI() && Array.isArray(origin)) return origin.flatMap((item)=>{
        const content = tContent(apiClient, item);
        if (content.parts && content.parts.length > 0 && content.parts[0].text !== undefined) return [
            content.parts[0].text
        ];
        return [];
    });
    else if (apiClient.isVertexAI()) {
        const content = tContent(apiClient, origin);
        if (content.parts && content.parts.length > 0 && content.parts[0].text !== undefined) return [
            content.parts[0].text
        ];
        return [];
    }
    if (Array.isArray(origin)) return origin.map((item)=>tContent(apiClient, item));
    return [
        tContent(apiClient, origin)
    ];
}
function tContents(apiClient, origin) {
    if (origin === null || origin === undefined || Array.isArray(origin) && origin.length === 0) throw new Error('contents are required');
    if (!Array.isArray(origin)) {
        // If it's not an array, it's a single content or a single PartUnion.
        if (_isFunctionCallPart(origin) || _isFunctionResponsePart(origin)) throw new Error('To specify functionCall or functionResponse parts, please wrap them in a Content object, specifying the role for them');
        return [
            tContent(apiClient, origin)
        ];
    }
    const result = [];
    const accumulatedParts = [];
    const isContentArray = _isContent(origin[0]);
    for (const item of origin){
        const isContent = _isContent(item);
        if (isContent != isContentArray) throw new Error('Mixing Content and Parts is not supported, please group the parts into a the appropriate Content objects and specify the roles for them');
        if (isContent) // `isContent` contains the result of _isContent, which is a utility
        // function that checks if the item is a Content.
        result.push(item);
        else if (_isFunctionCallPart(item) || _isFunctionResponsePart(item)) throw new Error('To specify functionCall or functionResponse parts, please wrap them, and any other parts, in Content objects as appropriate, specifying the role for them');
        else accumulatedParts.push(item);
    }
    if (!isContentArray) result.push({
        role: 'user',
        parts: tParts(apiClient, accumulatedParts)
    });
    return result;
}
// The fields that are supported by JSONSchema. Must be kept in sync with the
// JSONSchema interface above.
const supportedJsonSchemaFields = new Set([
    'type',
    'format',
    'title',
    'description',
    'default',
    'items',
    'minItems',
    'maxItems',
    'enum',
    'properties',
    'required',
    'minProperties',
    'maxProperties',
    'minimum',
    'maximum',
    'minLength',
    'maxLength',
    'pattern',
    'anyOf',
    'propertyOrdering'
]);
const jsonSchemaTypeValidator = (0, _zod.z).enum([
    'string',
    'number',
    'integer',
    'object',
    'array',
    'boolean',
    'null'
]);
// Handles all types and arrays of all types.
const schemaTypeUnion = (0, _zod.z).union([
    jsonSchemaTypeValidator,
    (0, _zod.z).array(jsonSchemaTypeValidator)
]);
/**
 * Creates a zod validator for JSONSchema.
 *
 * @param strictMode Whether to enable strict mode, default to true. When
 * strict mode is enabled, the zod validator will throw error if there
 * are unrecognized fields in the input data. If strict mode is
 * disabled, the zod validator will ignore the unrecognized fields, only
 * populate the fields that are listed in the JSONSchema. Regardless of
 * the mode the type mismatch will always result in an error, for example
 * items field should be a single JSONSchema, but for tuple type it would
 * be an array of JSONSchema, this will always result in an error.
 * @return The zod validator for JSONSchema.
 */ function createJsonSchemaValidator(strictMode = true) {
    const jsonSchemaValidator = (0, _zod.z).lazy(()=>{
        // Define the base object shape *inside* the z.lazy callback
        const baseShape = (0, _zod.z).object({
            // --- Type ---
            type: schemaTypeUnion.optional(),
            // --- Annotations ---
            format: (0, _zod.z).string().optional(),
            title: (0, _zod.z).string().optional(),
            description: (0, _zod.z).string().optional(),
            default: (0, _zod.z).unknown().optional(),
            // --- Array Validations ---
            items: jsonSchemaValidator.optional(),
            minItems: (0, _zod.z).coerce.string().optional(),
            maxItems: (0, _zod.z).coerce.string().optional(),
            // --- Generic Validations ---
            enum: (0, _zod.z).array((0, _zod.z).unknown()).optional(),
            // --- Object Validations ---
            properties: (0, _zod.z).record((0, _zod.z).string(), jsonSchemaValidator).optional(),
            required: (0, _zod.z).array((0, _zod.z).string()).optional(),
            minProperties: (0, _zod.z).coerce.string().optional(),
            maxProperties: (0, _zod.z).coerce.string().optional(),
            propertyOrdering: (0, _zod.z).array((0, _zod.z).string()).optional(),
            // --- Numeric Validations ---
            minimum: (0, _zod.z).number().optional(),
            maximum: (0, _zod.z).number().optional(),
            // --- String Validations ---
            minLength: (0, _zod.z).coerce.string().optional(),
            maxLength: (0, _zod.z).coerce.string().optional(),
            pattern: (0, _zod.z).string().optional(),
            // --- Schema Composition ---
            anyOf: (0, _zod.z).array(jsonSchemaValidator).optional(),
            // --- Additional Properties --- This field is not included in the
            // JSONSchema, will not be communicated to the model, it is here purely
            // for enabling the zod validation strict mode.
            additionalProperties: (0, _zod.z).boolean().optional()
        });
        // Conditionally apply .strict() based on the flag
        return strictMode ? baseShape.strict() : baseShape;
    });
    return jsonSchemaValidator;
}
/*
Handle type field:
The resulted type field in JSONSchema form zod_to_json_schema can be either
an array consist of primitive types or a single primitive type.
This is due to the optimization of zod_to_json_schema, when the types in the
union are primitive types without any additional specifications,
zod_to_json_schema will squash the types into an array instead of put them
in anyOf fields. Otherwise, it will put the types in anyOf fields.
See the following link for more details:
https://github.com/zodjs/zod-to-json-schema/blob/main/src/index.ts#L101
The logic here is trying to undo that optimization, flattening the array of
types to anyOf fields.
                                 type field
                                      |
                            ___________________________
                           /                           \
                          /                              \
                         /                                \
                       Array                              Type.*
                /                  \                       |
      Include null.              Not included null     type = Type.*.
      [null, Type.*, Type.*]     multiple types.
      [null, Type.*]             [Type.*, Type.*]
            /                                \
      remove null                             \
      add nullable = true                      \
       /                    \                   \
    [Type.*]           [Type.*, Type.*]          \
 only one type left     multiple types left       \
 add type = Type.*.           \                  /
                               \                /
                         not populate the type field in final result
                           and make the types into anyOf fields
                          anyOf:[{type: 'Type.*'}, {type: 'Type.*'}];
*/ function flattenTypeArrayToAnyOf(typeList, resultingSchema) {
    if (typeList.includes('null')) resultingSchema['nullable'] = true;
    const listWithoutNull = typeList.filter((type)=>type !== 'null');
    if (listWithoutNull.length === 1) resultingSchema['type'] = Object.values(Type).includes(listWithoutNull[0].toUpperCase()) ? listWithoutNull[0].toUpperCase() : Type.TYPE_UNSPECIFIED;
    else {
        resultingSchema['anyOf'] = [];
        for (const i of listWithoutNull)resultingSchema['anyOf'].push({
            'type': Object.values(Type).includes(i.toUpperCase()) ? i.toUpperCase() : Type.TYPE_UNSPECIFIED
        });
    }
}
function processJsonSchema(_jsonSchema) {
    const genAISchema = {};
    const schemaFieldNames = [
        'items'
    ];
    const listSchemaFieldNames = [
        'anyOf'
    ];
    const dictSchemaFieldNames = [
        'properties'
    ];
    if (_jsonSchema['type'] && _jsonSchema['anyOf']) throw new Error('type and anyOf cannot be both populated.');
    /*
    This is to handle the nullable array or object. The _jsonSchema will
    be in the format of {anyOf: [{type: 'null'}, {type: 'object'}]}. The
    logic is to check if anyOf has 2 elements and one of the element is null,
    if so, the anyOf field is unnecessary, so we need to get rid of the anyOf
    field and make the schema nullable. Then use the other element as the new
    _jsonSchema for processing. This is because the backend doesn't have a null
    type.
    This has to be checked before we process any other fields.
    For example:
      const objectNullable = z.object({
        nullableArray: z.array(z.string()).nullable(),
      });
    Will have the raw _jsonSchema as:
    {
      type: 'OBJECT',
      properties: {
          nullableArray: {
             anyOf: [
                {type: 'null'},
                {
                  type: 'array',
                  items: {type: 'string'},
                },
              ],
          }
      },
      required: [ 'nullableArray' ],
    }
    Will result in following schema compatible with Gemini API:
      {
        type: 'OBJECT',
        properties: {
           nullableArray: {
              nullable: true,
              type: 'ARRAY',
              items: {type: 'string'},
           }
        },
        required: [ 'nullableArray' ],
      }
    */ const incomingAnyOf = _jsonSchema['anyOf'];
    if (incomingAnyOf != null && incomingAnyOf.length == 2) {
        if (incomingAnyOf[0]['type'] === 'null') {
            genAISchema['nullable'] = true;
            _jsonSchema = incomingAnyOf[1];
        } else if (incomingAnyOf[1]['type'] === 'null') {
            genAISchema['nullable'] = true;
            _jsonSchema = incomingAnyOf[0];
        }
    }
    if (_jsonSchema['type'] instanceof Array) flattenTypeArrayToAnyOf(_jsonSchema['type'], genAISchema);
    for (const [fieldName, fieldValue] of Object.entries(_jsonSchema)){
        // Skip if the fieldvalue is undefined or null.
        if (fieldValue == null) continue;
        if (fieldName == 'type') {
            if (fieldValue === 'null') throw new Error('type: null can not be the only possible type for the field.');
            if (fieldValue instanceof Array) continue;
            genAISchema['type'] = Object.values(Type).includes(fieldValue.toUpperCase()) ? fieldValue.toUpperCase() : Type.TYPE_UNSPECIFIED;
        } else if (schemaFieldNames.includes(fieldName)) genAISchema[fieldName] = processJsonSchema(fieldValue);
        else if (listSchemaFieldNames.includes(fieldName)) {
            const listSchemaFieldValue = [];
            for (const item of fieldValue){
                if (item['type'] == 'null') {
                    genAISchema['nullable'] = true;
                    continue;
                }
                listSchemaFieldValue.push(processJsonSchema(item));
            }
            genAISchema[fieldName] = listSchemaFieldValue;
        } else if (dictSchemaFieldNames.includes(fieldName)) {
            const dictSchemaFieldValue = {};
            for (const [key, value] of Object.entries(fieldValue))dictSchemaFieldValue[key] = processJsonSchema(value);
            genAISchema[fieldName] = dictSchemaFieldValue;
        } else {
            // additionalProperties is not included in JSONSchema, skipping it.
            if (fieldName === 'additionalProperties') continue;
            genAISchema[fieldName] = fieldValue;
        }
    }
    return genAISchema;
}
// we take the unknown in the schema field because we want enable user to pass
// the output of major schema declaration tools without casting. Tools such as
// zodToJsonSchema, typebox, zodToJsonSchema function can return JsonSchema7Type
// or object, see details in
// https://github.com/StefanTerdell/zod-to-json-schema/blob/70525efe555cd226691e093d171370a3b10921d1/src/zodToJsonSchema.ts#L7
// typebox can return unknown, see details in
// https://github.com/sinclairzx81/typebox/blob/5a5431439f7d5ca6b494d0d18fbfd7b1a356d67c/src/type/create/type.ts#L35
function tSchema(apiClient, schema) {
    if (Object.keys(schema).includes('$schema')) {
        delete schema['$schema'];
        const validatedJsonSchema = createJsonSchemaValidator().parse(schema);
        return processJsonSchema(validatedJsonSchema);
    } else return processJsonSchema(schema);
}
function tSpeechConfig(apiClient, speechConfig) {
    if (typeof speechConfig === 'object') return speechConfig;
    else if (typeof speechConfig === 'string') return {
        voiceConfig: {
            prebuiltVoiceConfig: {
                voiceName: speechConfig
            }
        }
    };
    else throw new Error(`Unsupported speechConfig type: ${typeof speechConfig}`);
}
function tLiveSpeechConfig(apiClient, speechConfig) {
    if ('multiSpeakerVoiceConfig' in speechConfig) throw new Error('multiSpeakerVoiceConfig is not supported in the live API.');
    return speechConfig;
}
function tTool(apiClient, tool) {
    if (tool.functionDeclarations) for (const functionDeclaration of tool.functionDeclarations){
        if (functionDeclaration.parameters) functionDeclaration.parameters = tSchema(apiClient, functionDeclaration.parameters);
        if (functionDeclaration.response) functionDeclaration.response = tSchema(apiClient, functionDeclaration.response);
    }
    return tool;
}
function tTools(apiClient, tools) {
    // Check if the incoming type is defined.
    if (tools === undefined || tools === null) throw new Error('tools is required');
    if (!Array.isArray(tools)) throw new Error('tools is required and must be an array of Tools');
    const result = [];
    for (const tool of tools)result.push(tool);
    return result;
}
/**
 * Prepends resource name with project, location, resource_prefix if needed.
 *
 * @param client The API client.
 * @param resourceName The resource name.
 * @param resourcePrefix The resource prefix.
 * @param splitsAfterPrefix The number of splits after the prefix.
 * @returns The completed resource name.
 *
 * Examples:
 *
 * ```
 * resource_name = '123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = True
 * client.project = 'bar'
 * client.location = 'us-west1'
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns: 'projects/bar/locations/us-west1/cachedContents/123'
 * ```
 *
 * ```
 * resource_name = 'projects/foo/locations/us-central1/cachedContents/123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = True
 * client.project = 'bar'
 * client.location = 'us-west1'
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns: 'projects/foo/locations/us-central1/cachedContents/123'
 * ```
 *
 * ```
 * resource_name = '123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = False
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns 'cachedContents/123'
 * ```
 *
 * ```
 * resource_name = 'some/wrong/cachedContents/resource/name/123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = False
 * # client.vertexai = True
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * -> 'some/wrong/resource/name/123'
 * ```
 */ function resourceName(client, resourceName1, resourcePrefix, splitsAfterPrefix = 1) {
    const shouldAppendPrefix = !resourceName1.startsWith(`${resourcePrefix}/`) && resourceName1.split('/').length === splitsAfterPrefix;
    if (client.isVertexAI()) {
        if (resourceName1.startsWith('projects/')) return resourceName1;
        else if (resourceName1.startsWith('locations/')) return `projects/${client.getProject()}/${resourceName1}`;
        else if (resourceName1.startsWith(`${resourcePrefix}/`)) return `projects/${client.getProject()}/locations/${client.getLocation()}/${resourceName1}`;
        else if (shouldAppendPrefix) return `projects/${client.getProject()}/locations/${client.getLocation()}/${resourcePrefix}/${resourceName1}`;
        else return resourceName1;
    }
    if (shouldAppendPrefix) return `${resourcePrefix}/${resourceName1}`;
    return resourceName1;
}
function tCachedContentName(apiClient, name) {
    if (typeof name !== 'string') throw new Error('name must be a string');
    return resourceName(apiClient, name, 'cachedContents');
}
function tTuningJobStatus(apiClient, status) {
    switch(status){
        case 'STATE_UNSPECIFIED':
            return 'JOB_STATE_UNSPECIFIED';
        case 'CREATING':
            return 'JOB_STATE_RUNNING';
        case 'ACTIVE':
            return 'JOB_STATE_SUCCEEDED';
        case 'FAILED':
            return 'JOB_STATE_FAILED';
        default:
            return status;
    }
}
function tBytes(apiClient, fromImageBytes) {
    if (typeof fromImageBytes !== 'string') throw new Error('fromImageBytes must be a string');
    // TODO(b/389133914): Remove dummy bytes converter.
    return fromImageBytes;
}
function _isFile(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'name' in origin;
}
function isGeneratedVideo(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'video' in origin;
}
function isVideo(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'uri' in origin;
}
function tFileName(apiClient, fromName) {
    var _a;
    let name;
    if (_isFile(fromName)) name = fromName.name;
    if (isVideo(fromName)) {
        name = fromName.uri;
        if (name === undefined) return undefined;
    }
    if (isGeneratedVideo(fromName)) {
        name = (_a = fromName.video) === null || _a === void 0 ? void 0 : _a.uri;
        if (name === undefined) return undefined;
    }
    if (typeof fromName === 'string') name = fromName;
    if (name === undefined) throw new Error('Could not extract file name from the provided input.');
    if (name.startsWith('https://')) {
        const suffix = name.split('files/')[1];
        const match = suffix.match(/[a-z0-9]+/);
        if (match === null) throw new Error(`Could not extract file name from URI ${name}`);
        name = match[0];
    } else if (name.startsWith('files/')) name = name.split('files/')[1];
    return name;
}
function tModelsUrl(apiClient, baseModels) {
    let res;
    if (apiClient.isVertexAI()) res = baseModels ? 'publishers/google/models' : 'models';
    else res = baseModels ? 'models' : 'tunedModels';
    return res;
}
function tExtractModels(apiClient, response) {
    for (const key of [
        'models',
        'tunedModels',
        'publisherModels'
    ]){
        if (hasField(response, key)) return response[key];
    }
    return [];
}
function hasField(data, fieldName) {
    return data !== null && typeof data === 'object' && fieldName in data;
}
function mcpToGeminiTool(mcpTool, config = {}) {
    const mcpToolSchema = mcpTool;
    const functionDeclaration = {
        name: mcpToolSchema['name'],
        description: mcpToolSchema['description'],
        parameters: processJsonSchema(filterToJsonSchema(mcpToolSchema['inputSchema']))
    };
    if (config.behavior) functionDeclaration['behavior'] = config.behavior;
    const geminiTool = {
        functionDeclarations: [
            functionDeclaration
        ]
    };
    return geminiTool;
}
/**
 * Converts a list of MCP tools to a single Gemini tool with a list of function
 * declarations.
 */ function mcpToolsToGeminiTool(mcpTools, config = {}) {
    const functionDeclarations = [];
    const toolNames = new Set();
    for (const mcpTool of mcpTools){
        const mcpToolName = mcpTool.name;
        if (toolNames.has(mcpToolName)) throw new Error(`Duplicate function name ${mcpToolName} found in MCP tools. Please ensure function names are unique.`);
        toolNames.add(mcpToolName);
        const geminiTool = mcpToGeminiTool(mcpTool, config);
        if (geminiTool.functionDeclarations) functionDeclarations.push(...geminiTool.functionDeclarations);
    }
    return {
        functionDeclarations: functionDeclarations
    };
}
// Filters the list schema field to only include fields that are supported by
// JSONSchema.
function filterListSchemaField(fieldValue) {
    const listSchemaFieldValue = [];
    for (const listFieldValue of fieldValue)listSchemaFieldValue.push(filterToJsonSchema(listFieldValue));
    return listSchemaFieldValue;
}
// Filters the dict schema field to only include fields that are supported by
// JSONSchema.
function filterDictSchemaField(fieldValue) {
    const dictSchemaFieldValue = {};
    for (const [key, value] of Object.entries(fieldValue)){
        const valueRecord = value;
        dictSchemaFieldValue[key] = filterToJsonSchema(valueRecord);
    }
    return dictSchemaFieldValue;
}
// Filters the schema to only include fields that are supported by JSONSchema.
function filterToJsonSchema(schema) {
    const schemaFieldNames = new Set([
        'items'
    ]); // 'additional_properties' to come
    const listSchemaFieldNames = new Set([
        'anyOf'
    ]); // 'one_of', 'all_of', 'not' to come
    const dictSchemaFieldNames = new Set([
        'properties'
    ]); // 'defs' to come
    const filteredSchema = {};
    for (const [fieldName, fieldValue] of Object.entries(schema)){
        if (schemaFieldNames.has(fieldName)) filteredSchema[fieldName] = filterToJsonSchema(fieldValue);
        else if (listSchemaFieldNames.has(fieldName)) filteredSchema[fieldName] = filterListSchemaField(fieldValue);
        else if (dictSchemaFieldNames.has(fieldName)) filteredSchema[fieldName] = filterDictSchemaField(fieldValue);
        else if (fieldName === 'type') {
            const typeValue = fieldValue.toUpperCase();
            filteredSchema[fieldName] = Object.values(Type).includes(typeValue) ? typeValue : Type.TYPE_UNSPECIFIED;
        } else if (supportedJsonSchemaFields.has(fieldName)) filteredSchema[fieldName] = fieldValue;
    }
    return filteredSchema;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function videoMetadataToMldev$3(apiClient, fromObject) {
    const toObject = {};
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function blobToMldev$3(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function fileDataToMldev$3(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function partToMldev$3(apiClient, fromObject) {
    const toObject = {};
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], videoMetadataToMldev$3(apiClient, fromVideoMetadata));
    const fromThought = getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) setValueByPath(toObject, [
        'inlineData'
    ], blobToMldev$3(apiClient, fromInlineData));
    const fromFileData = getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) setValueByPath(toObject, [
        'fileData'
    ], fileDataToMldev$3(apiClient, fromFileData));
    const fromThoughtSignature = getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromCodeExecutionResult = getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionCall = getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function contentToMldev$3(apiClient, fromObject) {
    const toObject = {};
    const fromParts = getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return partToMldev$3(apiClient, item);
        });
        setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function functionDeclarationToMldev$3(apiClient, fromObject) {
    const toObject = {};
    const fromBehavior = getValueByPath(fromObject, [
        'behavior'
    ]);
    if (fromBehavior != null) setValueByPath(toObject, [
        'behavior'
    ], fromBehavior);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromResponse = getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) setValueByPath(toObject, [
        'response'
    ], fromResponse);
    return toObject;
}
function intervalToMldev$3(apiClient, fromObject) {
    const toObject = {};
    const fromStartTime = getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function googleSearchToMldev$3(apiClient, fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) setValueByPath(toObject, [
        'timeRangeFilter'
    ], intervalToMldev$3(apiClient, fromTimeRangeFilter));
    return toObject;
}
function dynamicRetrievalConfigToMldev$3(apiClient, fromObject) {
    const toObject = {};
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function googleSearchRetrievalToMldev$3(apiClient, fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], dynamicRetrievalConfigToMldev$3(apiClient, fromDynamicRetrievalConfig));
    return toObject;
}
function urlContextToMldev$3() {
    const toObject = {};
    return toObject;
}
function toolToMldev$3(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return functionDeclarationToMldev$3(apiClient, item);
        });
        setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    if (getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromGoogleSearch = getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) setValueByPath(toObject, [
        'googleSearch'
    ], googleSearchToMldev$3(apiClient, fromGoogleSearch));
    const fromGoogleSearchRetrieval = getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], googleSearchRetrievalToMldev$3(apiClient, fromGoogleSearchRetrieval));
    if (getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'googleMaps'
    ]) !== undefined) throw new Error('googleMaps parameter is not supported in Gemini API.');
    const fromUrlContext = getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) setValueByPath(toObject, [
        'urlContext'
    ], urlContextToMldev$3());
    const fromCodeExecution = getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function functionCallingConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromAllowedFunctionNames = getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    return toObject;
}
function latLngToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromLatitude = getValueByPath(fromObject, [
        'latitude'
    ]);
    if (fromLatitude != null) setValueByPath(toObject, [
        'latitude'
    ], fromLatitude);
    const fromLongitude = getValueByPath(fromObject, [
        'longitude'
    ]);
    if (fromLongitude != null) setValueByPath(toObject, [
        'longitude'
    ], fromLongitude);
    return toObject;
}
function retrievalConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromLatLng = getValueByPath(fromObject, [
        'latLng'
    ]);
    if (fromLatLng != null) setValueByPath(toObject, [
        'latLng'
    ], latLngToMldev$1(apiClient, fromLatLng));
    const fromLanguageCode = getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function toolConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionCallingConfig = getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) setValueByPath(toObject, [
        'functionCallingConfig'
    ], functionCallingConfigToMldev$1(apiClient, fromFunctionCallingConfig));
    const fromRetrievalConfig = getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) setValueByPath(toObject, [
        'retrievalConfig'
    ], retrievalConfigToMldev$1(apiClient, fromRetrievalConfig));
    return toObject;
}
function createCachedContentConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromTtl = getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromContents = getValueByPath(fromObject, [
        'contents'
    ]);
    if (parentObject !== undefined && fromContents != null) {
        let transformedList = tContents(apiClient, fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return contentToMldev$3(apiClient, item);
        });
        setValueByPath(parentObject, [
            'contents'
        ], transformedList);
    }
    const fromSystemInstruction = getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) setValueByPath(parentObject, [
        'systemInstruction'
    ], contentToMldev$3(apiClient, tContent(apiClient, fromSystemInstruction)));
    const fromTools = getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return toolToMldev$3(apiClient, item);
        });
        setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) setValueByPath(parentObject, [
        'toolConfig'
    ], toolConfigToMldev$1(apiClient, fromToolConfig));
    if (getValueByPath(fromObject, [
        'kmsKeyName'
    ]) !== undefined) throw new Error('kmsKeyName parameter is not supported in Gemini API.');
    return toObject;
}
function createCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        'model'
    ], tCachesModel(apiClient, fromModel));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], createCachedContentConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function getCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], tCachedContentName(apiClient, fromName));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function deleteCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], tCachedContentName(apiClient, fromName));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function updateCachedContentConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromTtl = getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    return toObject;
}
function updateCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], tCachedContentName(apiClient, fromName));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], updateCachedContentConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function listCachedContentsConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function listCachedContentsParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], listCachedContentsConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function videoMetadataToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function blobToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function fileDataToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromFileUri = getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function partToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], videoMetadataToVertex$2(apiClient, fromVideoMetadata));
    const fromThought = getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) setValueByPath(toObject, [
        'inlineData'
    ], blobToVertex$2(apiClient, fromInlineData));
    const fromFileData = getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) setValueByPath(toObject, [
        'fileData'
    ], fileDataToVertex$2(apiClient, fromFileData));
    const fromThoughtSignature = getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromCodeExecutionResult = getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionCall = getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function contentToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromParts = getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return partToVertex$2(apiClient, item);
        });
        setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function functionDeclarationToVertex$2(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromResponse = getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) setValueByPath(toObject, [
        'response'
    ], fromResponse);
    return toObject;
}
function intervalToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromStartTime = getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function googleSearchToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) setValueByPath(toObject, [
        'timeRangeFilter'
    ], intervalToVertex$2(apiClient, fromTimeRangeFilter));
    return toObject;
}
function dynamicRetrievalConfigToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function googleSearchRetrievalToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], dynamicRetrievalConfigToVertex$2(apiClient, fromDynamicRetrievalConfig));
    return toObject;
}
function enterpriseWebSearchToVertex$2() {
    const toObject = {};
    return toObject;
}
function apiKeyConfigToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromApiKeyString = getValueByPath(fromObject, [
        'apiKeyString'
    ]);
    if (fromApiKeyString != null) setValueByPath(toObject, [
        'apiKeyString'
    ], fromApiKeyString);
    return toObject;
}
function authConfigToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromApiKeyConfig = getValueByPath(fromObject, [
        'apiKeyConfig'
    ]);
    if (fromApiKeyConfig != null) setValueByPath(toObject, [
        'apiKeyConfig'
    ], apiKeyConfigToVertex$2(apiClient, fromApiKeyConfig));
    const fromAuthType = getValueByPath(fromObject, [
        'authType'
    ]);
    if (fromAuthType != null) setValueByPath(toObject, [
        'authType'
    ], fromAuthType);
    const fromGoogleServiceAccountConfig = getValueByPath(fromObject, [
        'googleServiceAccountConfig'
    ]);
    if (fromGoogleServiceAccountConfig != null) setValueByPath(toObject, [
        'googleServiceAccountConfig'
    ], fromGoogleServiceAccountConfig);
    const fromHttpBasicAuthConfig = getValueByPath(fromObject, [
        'httpBasicAuthConfig'
    ]);
    if (fromHttpBasicAuthConfig != null) setValueByPath(toObject, [
        'httpBasicAuthConfig'
    ], fromHttpBasicAuthConfig);
    const fromOauthConfig = getValueByPath(fromObject, [
        'oauthConfig'
    ]);
    if (fromOauthConfig != null) setValueByPath(toObject, [
        'oauthConfig'
    ], fromOauthConfig);
    const fromOidcConfig = getValueByPath(fromObject, [
        'oidcConfig'
    ]);
    if (fromOidcConfig != null) setValueByPath(toObject, [
        'oidcConfig'
    ], fromOidcConfig);
    return toObject;
}
function googleMapsToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromAuthConfig = getValueByPath(fromObject, [
        'authConfig'
    ]);
    if (fromAuthConfig != null) setValueByPath(toObject, [
        'authConfig'
    ], authConfigToVertex$2(apiClient, fromAuthConfig));
    return toObject;
}
function urlContextToVertex$2() {
    const toObject = {};
    return toObject;
}
function toolToVertex$2(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return functionDeclarationToVertex$2(apiClient, item);
        });
        setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromRetrieval = getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromGoogleSearch = getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) setValueByPath(toObject, [
        'googleSearch'
    ], googleSearchToVertex$2(apiClient, fromGoogleSearch));
    const fromGoogleSearchRetrieval = getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], googleSearchRetrievalToVertex$2(apiClient, fromGoogleSearchRetrieval));
    const fromEnterpriseWebSearch = getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], enterpriseWebSearchToVertex$2());
    const fromGoogleMaps = getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) setValueByPath(toObject, [
        'googleMaps'
    ], googleMapsToVertex$2(apiClient, fromGoogleMaps));
    const fromUrlContext = getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) setValueByPath(toObject, [
        'urlContext'
    ], urlContextToVertex$2());
    const fromCodeExecution = getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function functionCallingConfigToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromAllowedFunctionNames = getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    return toObject;
}
function latLngToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromLatitude = getValueByPath(fromObject, [
        'latitude'
    ]);
    if (fromLatitude != null) setValueByPath(toObject, [
        'latitude'
    ], fromLatitude);
    const fromLongitude = getValueByPath(fromObject, [
        'longitude'
    ]);
    if (fromLongitude != null) setValueByPath(toObject, [
        'longitude'
    ], fromLongitude);
    return toObject;
}
function retrievalConfigToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromLatLng = getValueByPath(fromObject, [
        'latLng'
    ]);
    if (fromLatLng != null) setValueByPath(toObject, [
        'latLng'
    ], latLngToVertex$1(apiClient, fromLatLng));
    const fromLanguageCode = getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function toolConfigToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionCallingConfig = getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) setValueByPath(toObject, [
        'functionCallingConfig'
    ], functionCallingConfigToVertex$1(apiClient, fromFunctionCallingConfig));
    const fromRetrievalConfig = getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) setValueByPath(toObject, [
        'retrievalConfig'
    ], retrievalConfigToVertex$1(apiClient, fromRetrievalConfig));
    return toObject;
}
function createCachedContentConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromTtl = getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromContents = getValueByPath(fromObject, [
        'contents'
    ]);
    if (parentObject !== undefined && fromContents != null) {
        let transformedList = tContents(apiClient, fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return contentToVertex$2(apiClient, item);
        });
        setValueByPath(parentObject, [
            'contents'
        ], transformedList);
    }
    const fromSystemInstruction = getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) setValueByPath(parentObject, [
        'systemInstruction'
    ], contentToVertex$2(apiClient, tContent(apiClient, fromSystemInstruction)));
    const fromTools = getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return toolToVertex$2(apiClient, item);
        });
        setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) setValueByPath(parentObject, [
        'toolConfig'
    ], toolConfigToVertex$1(apiClient, fromToolConfig));
    const fromKmsKeyName = getValueByPath(fromObject, [
        'kmsKeyName'
    ]);
    if (parentObject !== undefined && fromKmsKeyName != null) setValueByPath(parentObject, [
        'encryption_spec',
        'kmsKeyName'
    ], fromKmsKeyName);
    return toObject;
}
function createCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        'model'
    ], tCachesModel(apiClient, fromModel));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], createCachedContentConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function getCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], tCachedContentName(apiClient, fromName));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function deleteCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], tCachedContentName(apiClient, fromName));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function updateCachedContentConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromTtl = getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    return toObject;
}
function updateCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], tCachedContentName(apiClient, fromName));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], updateCachedContentConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function listCachedContentsConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function listCachedContentsParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], listCachedContentsConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function cachedContentFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromCreateTime = getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromExpireTime = getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (fromExpireTime != null) setValueByPath(toObject, [
        'expireTime'
    ], fromExpireTime);
    const fromUsageMetadata = getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function deleteCachedContentResponseFromMldev() {
    const toObject = {};
    return toObject;
}
function listCachedContentsResponseFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromNextPageToken = getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromCachedContents = getValueByPath(fromObject, [
        'cachedContents'
    ]);
    if (fromCachedContents != null) {
        let transformedList = fromCachedContents;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return cachedContentFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'cachedContents'
        ], transformedList);
    }
    return toObject;
}
function cachedContentFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromCreateTime = getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromExpireTime = getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (fromExpireTime != null) setValueByPath(toObject, [
        'expireTime'
    ], fromExpireTime);
    const fromUsageMetadata = getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function deleteCachedContentResponseFromVertex() {
    const toObject = {};
    return toObject;
}
function listCachedContentsResponseFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromNextPageToken = getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromCachedContents = getValueByPath(fromObject, [
        'cachedContents'
    ]);
    if (fromCachedContents != null) {
        let transformedList = fromCachedContents;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return cachedContentFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'cachedContents'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Pagers for the GenAI List APIs.
 */ var PagedItem;
(function(PagedItem) {
    PagedItem["PAGED_ITEM_BATCH_JOBS"] = "batchJobs";
    PagedItem["PAGED_ITEM_MODELS"] = "models";
    PagedItem["PAGED_ITEM_TUNING_JOBS"] = "tuningJobs";
    PagedItem["PAGED_ITEM_FILES"] = "files";
    PagedItem["PAGED_ITEM_CACHED_CONTENTS"] = "cachedContents";
})(PagedItem || (PagedItem = {}));
/**
 * Pager class for iterating through paginated results.
 */ class Pager {
    constructor(name, request, response, params){
        this.pageInternal = [];
        this.paramsInternal = {};
        this.requestInternal = request;
        this.init(name, response, params);
    }
    init(name, response, params) {
        var _a, _b;
        this.nameInternal = name;
        this.pageInternal = response[this.nameInternal] || [];
        this.idxInternal = 0;
        let requestParams = {
            config: {}
        };
        if (!params) requestParams = {
            config: {}
        };
        else if (typeof params === 'object') requestParams = Object.assign({}, params);
        else requestParams = params;
        if (requestParams['config']) requestParams['config']['pageToken'] = response['nextPageToken'];
        this.paramsInternal = requestParams;
        this.pageInternalSize = (_b = (_a = requestParams['config']) === null || _a === void 0 ? void 0 : _a['pageSize']) !== null && _b !== void 0 ? _b : this.pageInternal.length;
    }
    initNextPage(response) {
        this.init(this.nameInternal, response, this.paramsInternal);
    }
    /**
     * Returns the current page, which is a list of items.
     *
     * @remarks
     * The first page is retrieved when the pager is created. The returned list of
     * items could be a subset of the entire list.
     */ get page() {
        return this.pageInternal;
    }
    /**
     * Returns the type of paged item (for example, ``batch_jobs``).
     */ get name() {
        return this.nameInternal;
    }
    /**
     * Returns the length of the page fetched each time by this pager.
     *
     * @remarks
     * The number of items in the page is less than or equal to the page length.
     */ get pageSize() {
        return this.pageInternalSize;
    }
    /**
     * Returns the parameters when making the API request for the next page.
     *
     * @remarks
     * Parameters contain a set of optional configs that can be
     * used to customize the API request. For example, the `pageToken` parameter
     * contains the token to request the next page.
     */ get params() {
        return this.paramsInternal;
    }
    /**
     * Returns the total number of items in the current page.
     */ get pageLength() {
        return this.pageInternal.length;
    }
    /**
     * Returns the item at the given index.
     */ getItem(index) {
        return this.pageInternal[index];
    }
    /**
     * Returns an async iterator that support iterating through all items
     * retrieved from the API.
     *
     * @remarks
     * The iterator will automatically fetch the next page if there are more items
     * to fetch from the API.
     *
     * @example
     *
     * ```ts
     * const pager = await ai.files.list({config: {pageSize: 10}});
     * for await (const file of pager) {
     *   console.log(file.name);
     * }
     * ```
     */ [Symbol.asyncIterator]() {
        return {
            next: async ()=>{
                if (this.idxInternal >= this.pageLength) {
                    if (this.hasNextPage()) await this.nextPage();
                    else return {
                        value: undefined,
                        done: true
                    };
                }
                const item = this.getItem(this.idxInternal);
                this.idxInternal += 1;
                return {
                    value: item,
                    done: false
                };
            },
            return: async ()=>{
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     * Fetches the next page of items. This makes a new API request.
     *
     * @throws {Error} If there are no more pages to fetch.
     *
     * @example
     *
     * ```ts
     * const pager = await ai.files.list({config: {pageSize: 10}});
     * let page = pager.page;
     * while (true) {
     *   for (const file of page) {
     *     console.log(file.name);
     *   }
     *   if (!pager.hasNextPage()) {
     *     break;
     *   }
     *   page = await pager.nextPage();
     * }
     * ```
     */ async nextPage() {
        if (!this.hasNextPage()) throw new Error('No more pages to fetch.');
        const response = await this.requestInternal(this.params);
        this.initNextPage(response);
        return this.page;
    }
    /**
     * Returns true if there are more pages to fetch from the API.
     */ hasNextPage() {
        var _a;
        if (((_a = this.params['config']) === null || _a === void 0 ? void 0 : _a['pageToken']) !== undefined) return true;
        return false;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class Caches extends BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists cached content configurations.
         *
         * @param params - The parameters for the list request.
         * @return The paginated results of the list of cached contents.
         *
         * @example
         * ```ts
         * const cachedContents = await ai.caches.list({config: {'pageSize': 2}});
         * for await (const cachedContent of cachedContents) {
         *   console.log(cachedContent);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new Pager(PagedItem.PAGED_ITEM_CACHED_CONTENTS, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
    }
    /**
     * Creates a cached contents resource.
     *
     * @remarks
     * Context caching is only supported for specific models. See [Gemini
     * Developer API reference](https://ai.google.dev/gemini-api/docs/caching?lang=node/context-cac)
     * and [Vertex AI reference](https://cloud.google.com/vertex-ai/generative-ai/docs/context-cache/context-cache-overview#supported_models)
     * for more information.
     *
     * @param params - The parameters for the create request.
     * @return The created cached content.
     *
     * @example
     * ```ts
     * const contents = ...; // Initialize the content to cache.
     * const response = await ai.caches.create({
     *   model: 'gemini-2.0-flash-001',
     *   config: {
     *    'contents': contents,
     *    'displayName': 'test cache',
     *    'systemInstruction': 'What is the sum of the two pdfs?',
     *    'ttl': '86400s',
     *  }
     * });
     * ```
     */ async create(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = createCachedContentParametersToVertex(this.apiClient, params);
            path = formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = cachedContentFromVertex(this.apiClient, apiResponse);
                return resp;
            });
        } else {
            const body = createCachedContentParametersToMldev(this.apiClient, params);
            path = formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = cachedContentFromMldev(this.apiClient, apiResponse);
                return resp;
            });
        }
    }
    /**
     * Gets cached content configurations.
     *
     * @param params - The parameters for the get request.
     * @return The cached content.
     *
     * @example
     * ```ts
     * await ai.caches.get({name: '...'}); // The server-generated resource name.
     * ```
     */ async get(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = getCachedContentParametersToVertex(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = cachedContentFromVertex(this.apiClient, apiResponse);
                return resp;
            });
        } else {
            const body = getCachedContentParametersToMldev(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = cachedContentFromMldev(this.apiClient, apiResponse);
                return resp;
            });
        }
    }
    /**
     * Deletes cached content.
     *
     * @param params - The parameters for the delete request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.caches.delete({name: '...'}); // The server-generated resource name.
     * ```
     */ async delete(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = deleteCachedContentParametersToVertex(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then(()=>{
                const resp = deleteCachedContentResponseFromVertex();
                const typedResp = new DeleteCachedContentResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = deleteCachedContentParametersToMldev(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then(()=>{
                const resp = deleteCachedContentResponseFromMldev();
                const typedResp = new DeleteCachedContentResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Updates cached content configurations.
     *
     * @param params - The parameters for the update request.
     * @return The updated cached content.
     *
     * @example
     * ```ts
     * const response = await ai.caches.update({
     *   name: '...',  // The server-generated resource name.
     *   config: {'ttl': '7600s'}
     * });
     * ```
     */ async update(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = updateCachedContentParametersToVertex(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = cachedContentFromVertex(this.apiClient, apiResponse);
                return resp;
            });
        } else {
            const body = updateCachedContentParametersToMldev(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = cachedContentFromMldev(this.apiClient, apiResponse);
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = listCachedContentsParametersToVertex(this.apiClient, params);
            path = formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = listCachedContentsResponseFromVertex(this.apiClient, apiResponse);
                const typedResp = new ListCachedContentsResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = listCachedContentsParametersToMldev(this.apiClient, params);
            path = formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = listCachedContentsResponseFromMldev(this.apiClient, apiResponse);
                const typedResp = new ListCachedContentsResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
typeof SuppressedError === "function" && SuppressedError;
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Returns true if the response is valid, false otherwise.
 */ function isValidResponse(response) {
    var _a;
    if (response.candidates == undefined || response.candidates.length === 0) return false;
    const content = (_a = response.candidates[0]) === null || _a === void 0 ? void 0 : _a.content;
    if (content === undefined) return false;
    return isValidContent(content);
}
function isValidContent(content) {
    if (content.parts === undefined || content.parts.length === 0) return false;
    for (const part of content.parts){
        if (part === undefined || Object.keys(part).length === 0) return false;
        if (!part.thought && part.text !== undefined && part.text === '') return false;
    }
    return true;
}
/**
 * Validates the history contains the correct roles.
 *
 * @throws Error if the history does not start with a user turn.
 * @throws Error if the history contains an invalid role.
 */ function validateHistory(history) {
    // Empty history is valid.
    if (history.length === 0) return;
    for (const content of history){
        if (content.role !== 'user' && content.role !== 'model') throw new Error(`Role must be user or model, but got ${content.role}.`);
    }
}
/**
 * Extracts the curated (valid) history from a comprehensive history.
 *
 * @remarks
 * The model may sometimes generate invalid or empty contents(e.g., due to safty
 * filters or recitation). Extracting valid turns from the history
 * ensures that subsequent requests could be accpeted by the model.
 */ function extractCuratedHistory(comprehensiveHistory) {
    if (comprehensiveHistory === undefined || comprehensiveHistory.length === 0) return [];
    const curatedHistory = [];
    const length = comprehensiveHistory.length;
    let i = 0;
    while(i < length)if (comprehensiveHistory[i].role === 'user') {
        curatedHistory.push(comprehensiveHistory[i]);
        i++;
    } else {
        const modelOutput = [];
        let isValid = true;
        while(i < length && comprehensiveHistory[i].role === 'model'){
            modelOutput.push(comprehensiveHistory[i]);
            if (isValid && !isValidContent(comprehensiveHistory[i])) isValid = false;
            i++;
        }
        if (isValid) curatedHistory.push(...modelOutput);
        else // Remove the last user input when model content is invalid.
        curatedHistory.pop();
    }
    return curatedHistory;
}
/**
 * A utility class to create a chat session.
 */ class Chats {
    constructor(modelsModule, apiClient){
        this.modelsModule = modelsModule;
        this.apiClient = apiClient;
    }
    /**
     * Creates a new chat session.
     *
     * @remarks
     * The config in the params will be used for all requests within the chat
     * session unless overridden by a per-request `config` in
     * @see {@link types.SendMessageParameters#config}.
     *
     * @param params - Parameters for creating a chat session.
     * @returns A new chat session.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({
     *   model: 'gemini-2.0-flash'
     *   config: {
     *     temperature: 0.5,
     *     maxOutputTokens: 1024,
     *   }
     * });
     * ```
     */ create(params) {
        return new Chat(this.apiClient, this.modelsModule, params.model, params.config, // Deep copy the history to avoid mutating the history outside of the
        // chat session.
        structuredClone(params.history));
    }
}
/**
 * Chat session that enables sending messages to the model with previous
 * conversation context.
 *
 * @remarks
 * The session maintains all the turns between user and model.
 */ class Chat {
    constructor(apiClient, modelsModule, model, config = {}, history = []){
        this.apiClient = apiClient;
        this.modelsModule = modelsModule;
        this.model = model;
        this.config = config;
        this.history = history;
        // A promise to represent the current state of the message being sent to the
        // model.
        this.sendPromise = Promise.resolve();
        validateHistory(history);
    }
    /**
     * Sends a message to the model and returns the response.
     *
     * @remarks
     * This method will wait for the previous message to be processed before
     * sending the next message.
     *
     * @see {@link Chat#sendMessageStream} for streaming method.
     * @param params - parameters for sending messages within a chat session.
     * @returns The model's response.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({model: 'gemini-2.0-flash'});
     * const response = await chat.sendMessage({
     *   message: 'Why is the sky blue?'
     * });
     * console.log(response.text);
     * ```
     */ async sendMessage(params) {
        var _a;
        await this.sendPromise;
        const inputContent = tContent(this.apiClient, params.message);
        const responsePromise = this.modelsModule.generateContent({
            model: this.model,
            contents: this.getHistory(true).concat(inputContent),
            config: (_a = params.config) !== null && _a !== void 0 ? _a : this.config
        });
        this.sendPromise = (async ()=>{
            var _a, _b, _c;
            const response = await responsePromise;
            const outputContent = (_b = (_a = response.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content;
            // Because the AFC input contains the entire curated chat history in
            // addition to the new user input, we need to truncate the AFC history
            // to deduplicate the existing chat history.
            const fullAutomaticFunctionCallingHistory = response.automaticFunctionCallingHistory;
            const index = this.getHistory(true).length;
            let automaticFunctionCallingHistory = [];
            if (fullAutomaticFunctionCallingHistory != null) automaticFunctionCallingHistory = (_c = fullAutomaticFunctionCallingHistory.slice(index)) !== null && _c !== void 0 ? _c : [];
            const modelOutput = outputContent ? [
                outputContent
            ] : [];
            this.recordHistory(inputContent, modelOutput, automaticFunctionCallingHistory);
            return;
        })();
        await this.sendPromise.catch(()=>{
            // Resets sendPromise to avoid subsequent calls failing
            this.sendPromise = Promise.resolve();
        });
        return responsePromise;
    }
    /**
     * Sends a message to the model and returns the response in chunks.
     *
     * @remarks
     * This method will wait for the previous message to be processed before
     * sending the next message.
     *
     * @see {@link Chat#sendMessage} for non-streaming method.
     * @param params - parameters for sending the message.
     * @return The model's response.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({model: 'gemini-2.0-flash'});
     * const response = await chat.sendMessageStream({
     *   message: 'Why is the sky blue?'
     * });
     * for await (const chunk of response) {
     *   console.log(chunk.text);
     * }
     * ```
     */ async sendMessageStream(params) {
        var _a;
        await this.sendPromise;
        const inputContent = tContent(this.apiClient, params.message);
        const streamResponse = this.modelsModule.generateContentStream({
            model: this.model,
            contents: this.getHistory(true).concat(inputContent),
            config: (_a = params.config) !== null && _a !== void 0 ? _a : this.config
        });
        // Resolve the internal tracking of send completion promise - `sendPromise`
        // for both success and failure response. The actual failure is still
        // propagated by the `await streamResponse`.
        this.sendPromise = streamResponse.then(()=>undefined).catch(()=>undefined);
        const response = await streamResponse;
        const result = this.processStreamResponse(response, inputContent);
        return result;
    }
    /**
     * Returns the chat history.
     *
     * @remarks
     * The history is a list of contents alternating between user and model.
     *
     * There are two types of history:
     * - The `curated history` contains only the valid turns between user and
     * model, which will be included in the subsequent requests sent to the model.
     * - The `comprehensive history` contains all turns, including invalid or
     *   empty model outputs, providing a complete record of the history.
     *
     * The history is updated after receiving the response from the model,
     * for streaming response, it means receiving the last chunk of the response.
     *
     * The `comprehensive history` is returned by default. To get the `curated
     * history`, set the `curated` parameter to `true`.
     *
     * @param curated - whether to return the curated history or the comprehensive
     *     history.
     * @return History contents alternating between user and model for the entire
     *     chat session.
     */ getHistory(curated = false) {
        const history = curated ? extractCuratedHistory(this.history) : this.history;
        // Deep copy the history to avoid mutating the history outside of the
        // chat session.
        return structuredClone(history);
    }
    processStreamResponse(streamResponse, inputContent) {
        var _a, _b;
        return __asyncGenerator(this, arguments, function* processStreamResponse_1() {
            var _c, e_1, _d, _e;
            const outputContent = [];
            try {
                for(var _f = true, streamResponse_1 = __asyncValues(streamResponse), streamResponse_1_1; streamResponse_1_1 = yield __await(streamResponse_1.next()), _c = streamResponse_1_1.done, !_c; _f = true){
                    _e = streamResponse_1_1.value;
                    _f = false;
                    const chunk = _e;
                    if (isValidResponse(chunk)) {
                        const content = (_b = (_a = chunk.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content;
                        if (content !== undefined) outputContent.push(content);
                    }
                    yield yield __await(chunk);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (!_f && !_c && (_d = streamResponse_1.return)) yield __await(_d.call(streamResponse_1));
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            this.recordHistory(inputContent, outputContent);
        });
    }
    recordHistory(userInput, modelOutput, automaticFunctionCallingHistory) {
        let outputContents = [];
        if (modelOutput.length > 0 && modelOutput.every((content)=>content.role !== undefined)) outputContents = modelOutput;
        else // Appends an empty content when model returns empty response, so that the
        // history is always alternating between user and model.
        outputContents.push({
            role: 'model',
            parts: []
        });
        if (automaticFunctionCallingHistory && automaticFunctionCallingHistory.length > 0) this.history.push(...extractCuratedHistory(automaticFunctionCallingHistory));
        else this.history.push(userInput);
        this.history.push(...outputContents);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function listFilesConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function listFilesParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], listFilesConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function fileStatusToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromDetails = getValueByPath(fromObject, [
        'details'
    ]);
    if (fromDetails != null) setValueByPath(toObject, [
        'details'
    ], fromDetails);
    const fromMessage = getValueByPath(fromObject, [
        'message'
    ]);
    if (fromMessage != null) setValueByPath(toObject, [
        'message'
    ], fromMessage);
    const fromCode = getValueByPath(fromObject, [
        'code'
    ]);
    if (fromCode != null) setValueByPath(toObject, [
        'code'
    ], fromCode);
    return toObject;
}
function fileToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    const fromSizeBytes = getValueByPath(fromObject, [
        'sizeBytes'
    ]);
    if (fromSizeBytes != null) setValueByPath(toObject, [
        'sizeBytes'
    ], fromSizeBytes);
    const fromCreateTime = getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromExpirationTime = getValueByPath(fromObject, [
        'expirationTime'
    ]);
    if (fromExpirationTime != null) setValueByPath(toObject, [
        'expirationTime'
    ], fromExpirationTime);
    const fromUpdateTime = getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromSha256Hash = getValueByPath(fromObject, [
        'sha256Hash'
    ]);
    if (fromSha256Hash != null) setValueByPath(toObject, [
        'sha256Hash'
    ], fromSha256Hash);
    const fromUri = getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromDownloadUri = getValueByPath(fromObject, [
        'downloadUri'
    ]);
    if (fromDownloadUri != null) setValueByPath(toObject, [
        'downloadUri'
    ], fromDownloadUri);
    const fromState = getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) setValueByPath(toObject, [
        'state'
    ], fromState);
    const fromSource = getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) setValueByPath(toObject, [
        'source'
    ], fromSource);
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    const fromError = getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) setValueByPath(toObject, [
        'error'
    ], fileStatusToMldev(apiClient, fromError));
    return toObject;
}
function createFileParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromFile = getValueByPath(fromObject, [
        'file'
    ]);
    if (fromFile != null) setValueByPath(toObject, [
        'file'
    ], fileToMldev(apiClient, fromFile));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function getFileParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        '_url',
        'file'
    ], tFileName(apiClient, fromName));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function deleteFileParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        '_url',
        'file'
    ], tFileName(apiClient, fromName));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function fileStatusFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromDetails = getValueByPath(fromObject, [
        'details'
    ]);
    if (fromDetails != null) setValueByPath(toObject, [
        'details'
    ], fromDetails);
    const fromMessage = getValueByPath(fromObject, [
        'message'
    ]);
    if (fromMessage != null) setValueByPath(toObject, [
        'message'
    ], fromMessage);
    const fromCode = getValueByPath(fromObject, [
        'code'
    ]);
    if (fromCode != null) setValueByPath(toObject, [
        'code'
    ], fromCode);
    return toObject;
}
function fileFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    const fromSizeBytes = getValueByPath(fromObject, [
        'sizeBytes'
    ]);
    if (fromSizeBytes != null) setValueByPath(toObject, [
        'sizeBytes'
    ], fromSizeBytes);
    const fromCreateTime = getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromExpirationTime = getValueByPath(fromObject, [
        'expirationTime'
    ]);
    if (fromExpirationTime != null) setValueByPath(toObject, [
        'expirationTime'
    ], fromExpirationTime);
    const fromUpdateTime = getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromSha256Hash = getValueByPath(fromObject, [
        'sha256Hash'
    ]);
    if (fromSha256Hash != null) setValueByPath(toObject, [
        'sha256Hash'
    ], fromSha256Hash);
    const fromUri = getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromDownloadUri = getValueByPath(fromObject, [
        'downloadUri'
    ]);
    if (fromDownloadUri != null) setValueByPath(toObject, [
        'downloadUri'
    ], fromDownloadUri);
    const fromState = getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) setValueByPath(toObject, [
        'state'
    ], fromState);
    const fromSource = getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) setValueByPath(toObject, [
        'source'
    ], fromSource);
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    const fromError = getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) setValueByPath(toObject, [
        'error'
    ], fileStatusFromMldev(apiClient, fromError));
    return toObject;
}
function listFilesResponseFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromNextPageToken = getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromFiles = getValueByPath(fromObject, [
        'files'
    ]);
    if (fromFiles != null) {
        let transformedList = fromFiles;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return fileFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'files'
        ], transformedList);
    }
    return toObject;
}
function createFileResponseFromMldev() {
    const toObject = {};
    return toObject;
}
function deleteFileResponseFromMldev() {
    const toObject = {};
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class Files extends BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists all current project files from the service.
         *
         * @param params - The parameters for the list request
         * @return The paginated results of the list of files
         *
         * @example
         * The following code prints the names of all files from the service, the
         * size of each page is 10.
         *
         * ```ts
         * const listResponse = await ai.files.list({config: {'pageSize': 10}});
         * for await (const file of listResponse) {
         *   console.log(file.name);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new Pager(PagedItem.PAGED_ITEM_FILES, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
    }
    /**
     * Uploads a file asynchronously to the Gemini API.
     * This method is not available in Vertex AI.
     * Supported upload sources:
     * - Node.js: File path (string) or Blob object.
     * - Browser: Blob object (e.g., File).
     *
     * @remarks
     * The `mimeType` can be specified in the `config` parameter. If omitted:
     *  - For file path (string) inputs, the `mimeType` will be inferred from the
     *     file extension.
     *  - For Blob object inputs, the `mimeType` will be set to the Blob's `type`
     *     property.
     * Somex eamples for file extension to mimeType mapping:
     * .txt -> text/plain
     * .json -> application/json
     * .jpg  -> image/jpeg
     * .png -> image/png
     * .mp3 -> audio/mpeg
     * .mp4 -> video/mp4
     *
     * This section can contain multiple paragraphs and code examples.
     *
     * @param params - Optional parameters specified in the
     *        `types.UploadFileParameters` interface.
     *         @see {@link types.UploadFileParameters#config} for the optional
     *         config in the parameters.
     * @return A promise that resolves to a `types.File` object.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     * the `mimeType` can be provided in the `params.config` parameter.
     * @throws An error occurs if a suitable upload location cannot be established.
     *
     * @example
     * The following code uploads a file to Gemini API.
     *
     * ```ts
     * const file = await ai.files.upload({file: 'file.txt', config: {
     *   mimeType: 'text/plain',
     * }});
     * console.log(file.name);
     * ```
     */ async upload(params) {
        if (this.apiClient.isVertexAI()) throw new Error('Vertex AI does not support uploading files. You can share files through a GCS bucket.');
        return this.apiClient.uploadFile(params.file, params.config).then((response)=>{
            const file = fileFromMldev(this.apiClient, response);
            return file;
        });
    }
    /**
     * Downloads a remotely stored file asynchronously to a location specified in
     * the `params` object. This method only works on Node environment, to
     * download files in the browser, use a browser compliant method like an <a>
     * tag.
     *
     * @param params - The parameters for the download request.
     *
     * @example
     * The following code downloads an example file named "files/mehozpxf877d" as
     * "file.txt".
     *
     * ```ts
     * await ai.files.download({file: file.name, downloadPath: 'file.txt'});
     * ```
     */ async download(params) {
        await this.apiClient.downloadFile(params);
    }
    async listInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = listFilesParametersToMldev(this.apiClient, params);
            path = formatMap('files', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = listFilesResponseFromMldev(this.apiClient, apiResponse);
                const typedResp = new ListFilesResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async createInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = createFileParametersToMldev(this.apiClient, params);
            path = formatMap('upload/v1beta/files', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then(()=>{
                const resp = createFileResponseFromMldev();
                const typedResp = new CreateFileResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Retrieves the file information from the service.
     *
     * @param params - The parameters for the get request
     * @return The Promise that resolves to the types.File object requested.
     *
     * @example
     * ```ts
     * const config: GetFileParameters = {
     *   name: fileName,
     * };
     * file = await ai.files.get(config);
     * console.log(file.name);
     * ```
     */ async get(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = getFileParametersToMldev(this.apiClient, params);
            path = formatMap('files/{file}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = fileFromMldev(this.apiClient, apiResponse);
                return resp;
            });
        }
    }
    /**
     * Deletes a remotely stored file.
     *
     * @param params - The parameters for the delete request.
     * @return The DeleteFileResponse, the response for the delete method.
     *
     * @example
     * The following code deletes an example file named "files/mehozpxf877d".
     *
     * ```ts
     * await ai.files.delete({name: file.name});
     * ```
     */ async delete(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = deleteFileParametersToMldev(this.apiClient, params);
            path = formatMap('files/{file}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then(()=>{
                const resp = deleteFileResponseFromMldev();
                const typedResp = new DeleteFileResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function prebuiltVoiceConfigToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromVoiceName = getValueByPath(fromObject, [
        'voiceName'
    ]);
    if (fromVoiceName != null) setValueByPath(toObject, [
        'voiceName'
    ], fromVoiceName);
    return toObject;
}
function prebuiltVoiceConfigToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromVoiceName = getValueByPath(fromObject, [
        'voiceName'
    ]);
    if (fromVoiceName != null) setValueByPath(toObject, [
        'voiceName'
    ], fromVoiceName);
    return toObject;
}
function voiceConfigToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromPrebuiltVoiceConfig = getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], prebuiltVoiceConfigToMldev$2(apiClient, fromPrebuiltVoiceConfig));
    return toObject;
}
function voiceConfigToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromPrebuiltVoiceConfig = getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], prebuiltVoiceConfigToVertex$1(apiClient, fromPrebuiltVoiceConfig));
    return toObject;
}
function speakerVoiceConfigToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromSpeaker = getValueByPath(fromObject, [
        'speaker'
    ]);
    if (fromSpeaker != null) setValueByPath(toObject, [
        'speaker'
    ], fromSpeaker);
    const fromVoiceConfig = getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) setValueByPath(toObject, [
        'voiceConfig'
    ], voiceConfigToMldev$2(apiClient, fromVoiceConfig));
    return toObject;
}
function multiSpeakerVoiceConfigToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromSpeakerVoiceConfigs = getValueByPath(fromObject, [
        'speakerVoiceConfigs'
    ]);
    if (fromSpeakerVoiceConfigs != null) {
        let transformedList = fromSpeakerVoiceConfigs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return speakerVoiceConfigToMldev$2(apiClient, item);
        });
        setValueByPath(toObject, [
            'speakerVoiceConfigs'
        ], transformedList);
    }
    return toObject;
}
function speechConfigToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromVoiceConfig = getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) setValueByPath(toObject, [
        'voiceConfig'
    ], voiceConfigToMldev$2(apiClient, fromVoiceConfig));
    const fromMultiSpeakerVoiceConfig = getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]);
    if (fromMultiSpeakerVoiceConfig != null) setValueByPath(toObject, [
        'multiSpeakerVoiceConfig'
    ], multiSpeakerVoiceConfigToMldev$2(apiClient, fromMultiSpeakerVoiceConfig));
    const fromLanguageCode = getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function speechConfigToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromVoiceConfig = getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) setValueByPath(toObject, [
        'voiceConfig'
    ], voiceConfigToVertex$1(apiClient, fromVoiceConfig));
    if (getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]) !== undefined) throw new Error('multiSpeakerVoiceConfig parameter is not supported in Vertex AI.');
    const fromLanguageCode = getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function videoMetadataToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function videoMetadataToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function blobToMldev$2(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function blobToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function fileDataToMldev$2(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function fileDataToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromFileUri = getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function partToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], videoMetadataToMldev$2(apiClient, fromVideoMetadata));
    const fromThought = getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) setValueByPath(toObject, [
        'inlineData'
    ], blobToMldev$2(apiClient, fromInlineData));
    const fromFileData = getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) setValueByPath(toObject, [
        'fileData'
    ], fileDataToMldev$2(apiClient, fromFileData));
    const fromThoughtSignature = getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromCodeExecutionResult = getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionCall = getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function partToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], videoMetadataToVertex$1(apiClient, fromVideoMetadata));
    const fromThought = getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) setValueByPath(toObject, [
        'inlineData'
    ], blobToVertex$1(apiClient, fromInlineData));
    const fromFileData = getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) setValueByPath(toObject, [
        'fileData'
    ], fileDataToVertex$1(apiClient, fromFileData));
    const fromThoughtSignature = getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromCodeExecutionResult = getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionCall = getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function contentToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromParts = getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return partToMldev$2(apiClient, item);
        });
        setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function contentToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromParts = getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return partToVertex$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function functionDeclarationToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromBehavior = getValueByPath(fromObject, [
        'behavior'
    ]);
    if (fromBehavior != null) setValueByPath(toObject, [
        'behavior'
    ], fromBehavior);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromResponse = getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) setValueByPath(toObject, [
        'response'
    ], fromResponse);
    return toObject;
}
function functionDeclarationToVertex$1(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromResponse = getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) setValueByPath(toObject, [
        'response'
    ], fromResponse);
    return toObject;
}
function intervalToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromStartTime = getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function intervalToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromStartTime = getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function googleSearchToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) setValueByPath(toObject, [
        'timeRangeFilter'
    ], intervalToMldev$2(apiClient, fromTimeRangeFilter));
    return toObject;
}
function googleSearchToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) setValueByPath(toObject, [
        'timeRangeFilter'
    ], intervalToVertex$1(apiClient, fromTimeRangeFilter));
    return toObject;
}
function dynamicRetrievalConfigToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function dynamicRetrievalConfigToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function googleSearchRetrievalToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], dynamicRetrievalConfigToMldev$2(apiClient, fromDynamicRetrievalConfig));
    return toObject;
}
function googleSearchRetrievalToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], dynamicRetrievalConfigToVertex$1(apiClient, fromDynamicRetrievalConfig));
    return toObject;
}
function enterpriseWebSearchToVertex$1() {
    const toObject = {};
    return toObject;
}
function apiKeyConfigToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromApiKeyString = getValueByPath(fromObject, [
        'apiKeyString'
    ]);
    if (fromApiKeyString != null) setValueByPath(toObject, [
        'apiKeyString'
    ], fromApiKeyString);
    return toObject;
}
function authConfigToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromApiKeyConfig = getValueByPath(fromObject, [
        'apiKeyConfig'
    ]);
    if (fromApiKeyConfig != null) setValueByPath(toObject, [
        'apiKeyConfig'
    ], apiKeyConfigToVertex$1(apiClient, fromApiKeyConfig));
    const fromAuthType = getValueByPath(fromObject, [
        'authType'
    ]);
    if (fromAuthType != null) setValueByPath(toObject, [
        'authType'
    ], fromAuthType);
    const fromGoogleServiceAccountConfig = getValueByPath(fromObject, [
        'googleServiceAccountConfig'
    ]);
    if (fromGoogleServiceAccountConfig != null) setValueByPath(toObject, [
        'googleServiceAccountConfig'
    ], fromGoogleServiceAccountConfig);
    const fromHttpBasicAuthConfig = getValueByPath(fromObject, [
        'httpBasicAuthConfig'
    ]);
    if (fromHttpBasicAuthConfig != null) setValueByPath(toObject, [
        'httpBasicAuthConfig'
    ], fromHttpBasicAuthConfig);
    const fromOauthConfig = getValueByPath(fromObject, [
        'oauthConfig'
    ]);
    if (fromOauthConfig != null) setValueByPath(toObject, [
        'oauthConfig'
    ], fromOauthConfig);
    const fromOidcConfig = getValueByPath(fromObject, [
        'oidcConfig'
    ]);
    if (fromOidcConfig != null) setValueByPath(toObject, [
        'oidcConfig'
    ], fromOidcConfig);
    return toObject;
}
function googleMapsToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromAuthConfig = getValueByPath(fromObject, [
        'authConfig'
    ]);
    if (fromAuthConfig != null) setValueByPath(toObject, [
        'authConfig'
    ], authConfigToVertex$1(apiClient, fromAuthConfig));
    return toObject;
}
function urlContextToMldev$2() {
    const toObject = {};
    return toObject;
}
function urlContextToVertex$1() {
    const toObject = {};
    return toObject;
}
function toolToMldev$2(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return functionDeclarationToMldev$2(apiClient, item);
        });
        setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    if (getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromGoogleSearch = getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) setValueByPath(toObject, [
        'googleSearch'
    ], googleSearchToMldev$2(apiClient, fromGoogleSearch));
    const fromGoogleSearchRetrieval = getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], googleSearchRetrievalToMldev$2(apiClient, fromGoogleSearchRetrieval));
    if (getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'googleMaps'
    ]) !== undefined) throw new Error('googleMaps parameter is not supported in Gemini API.');
    const fromUrlContext = getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) setValueByPath(toObject, [
        'urlContext'
    ], urlContextToMldev$2());
    const fromCodeExecution = getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function toolToVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return functionDeclarationToVertex$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromRetrieval = getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromGoogleSearch = getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) setValueByPath(toObject, [
        'googleSearch'
    ], googleSearchToVertex$1(apiClient, fromGoogleSearch));
    const fromGoogleSearchRetrieval = getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], googleSearchRetrievalToVertex$1(apiClient, fromGoogleSearchRetrieval));
    const fromEnterpriseWebSearch = getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], enterpriseWebSearchToVertex$1());
    const fromGoogleMaps = getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) setValueByPath(toObject, [
        'googleMaps'
    ], googleMapsToVertex$1(apiClient, fromGoogleMaps));
    const fromUrlContext = getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) setValueByPath(toObject, [
        'urlContext'
    ], urlContextToVertex$1());
    const fromCodeExecution = getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function sessionResumptionConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromHandle = getValueByPath(fromObject, [
        'handle'
    ]);
    if (fromHandle != null) setValueByPath(toObject, [
        'handle'
    ], fromHandle);
    if (getValueByPath(fromObject, [
        'transparent'
    ]) !== undefined) throw new Error('transparent parameter is not supported in Gemini API.');
    return toObject;
}
function sessionResumptionConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromHandle = getValueByPath(fromObject, [
        'handle'
    ]);
    if (fromHandle != null) setValueByPath(toObject, [
        'handle'
    ], fromHandle);
    const fromTransparent = getValueByPath(fromObject, [
        'transparent'
    ]);
    if (fromTransparent != null) setValueByPath(toObject, [
        'transparent'
    ], fromTransparent);
    return toObject;
}
function audioTranscriptionConfigToMldev$1() {
    const toObject = {};
    return toObject;
}
function audioTranscriptionConfigToVertex() {
    const toObject = {};
    return toObject;
}
function automaticActivityDetectionToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromDisabled = getValueByPath(fromObject, [
        'disabled'
    ]);
    if (fromDisabled != null) setValueByPath(toObject, [
        'disabled'
    ], fromDisabled);
    const fromStartOfSpeechSensitivity = getValueByPath(fromObject, [
        'startOfSpeechSensitivity'
    ]);
    if (fromStartOfSpeechSensitivity != null) setValueByPath(toObject, [
        'startOfSpeechSensitivity'
    ], fromStartOfSpeechSensitivity);
    const fromEndOfSpeechSensitivity = getValueByPath(fromObject, [
        'endOfSpeechSensitivity'
    ]);
    if (fromEndOfSpeechSensitivity != null) setValueByPath(toObject, [
        'endOfSpeechSensitivity'
    ], fromEndOfSpeechSensitivity);
    const fromPrefixPaddingMs = getValueByPath(fromObject, [
        'prefixPaddingMs'
    ]);
    if (fromPrefixPaddingMs != null) setValueByPath(toObject, [
        'prefixPaddingMs'
    ], fromPrefixPaddingMs);
    const fromSilenceDurationMs = getValueByPath(fromObject, [
        'silenceDurationMs'
    ]);
    if (fromSilenceDurationMs != null) setValueByPath(toObject, [
        'silenceDurationMs'
    ], fromSilenceDurationMs);
    return toObject;
}
function automaticActivityDetectionToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromDisabled = getValueByPath(fromObject, [
        'disabled'
    ]);
    if (fromDisabled != null) setValueByPath(toObject, [
        'disabled'
    ], fromDisabled);
    const fromStartOfSpeechSensitivity = getValueByPath(fromObject, [
        'startOfSpeechSensitivity'
    ]);
    if (fromStartOfSpeechSensitivity != null) setValueByPath(toObject, [
        'startOfSpeechSensitivity'
    ], fromStartOfSpeechSensitivity);
    const fromEndOfSpeechSensitivity = getValueByPath(fromObject, [
        'endOfSpeechSensitivity'
    ]);
    if (fromEndOfSpeechSensitivity != null) setValueByPath(toObject, [
        'endOfSpeechSensitivity'
    ], fromEndOfSpeechSensitivity);
    const fromPrefixPaddingMs = getValueByPath(fromObject, [
        'prefixPaddingMs'
    ]);
    if (fromPrefixPaddingMs != null) setValueByPath(toObject, [
        'prefixPaddingMs'
    ], fromPrefixPaddingMs);
    const fromSilenceDurationMs = getValueByPath(fromObject, [
        'silenceDurationMs'
    ]);
    if (fromSilenceDurationMs != null) setValueByPath(toObject, [
        'silenceDurationMs'
    ], fromSilenceDurationMs);
    return toObject;
}
function realtimeInputConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromAutomaticActivityDetection = getValueByPath(fromObject, [
        'automaticActivityDetection'
    ]);
    if (fromAutomaticActivityDetection != null) setValueByPath(toObject, [
        'automaticActivityDetection'
    ], automaticActivityDetectionToMldev$1(apiClient, fromAutomaticActivityDetection));
    const fromActivityHandling = getValueByPath(fromObject, [
        'activityHandling'
    ]);
    if (fromActivityHandling != null) setValueByPath(toObject, [
        'activityHandling'
    ], fromActivityHandling);
    const fromTurnCoverage = getValueByPath(fromObject, [
        'turnCoverage'
    ]);
    if (fromTurnCoverage != null) setValueByPath(toObject, [
        'turnCoverage'
    ], fromTurnCoverage);
    return toObject;
}
function realtimeInputConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromAutomaticActivityDetection = getValueByPath(fromObject, [
        'automaticActivityDetection'
    ]);
    if (fromAutomaticActivityDetection != null) setValueByPath(toObject, [
        'automaticActivityDetection'
    ], automaticActivityDetectionToVertex(apiClient, fromAutomaticActivityDetection));
    const fromActivityHandling = getValueByPath(fromObject, [
        'activityHandling'
    ]);
    if (fromActivityHandling != null) setValueByPath(toObject, [
        'activityHandling'
    ], fromActivityHandling);
    const fromTurnCoverage = getValueByPath(fromObject, [
        'turnCoverage'
    ]);
    if (fromTurnCoverage != null) setValueByPath(toObject, [
        'turnCoverage'
    ], fromTurnCoverage);
    return toObject;
}
function slidingWindowToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromTargetTokens = getValueByPath(fromObject, [
        'targetTokens'
    ]);
    if (fromTargetTokens != null) setValueByPath(toObject, [
        'targetTokens'
    ], fromTargetTokens);
    return toObject;
}
function slidingWindowToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromTargetTokens = getValueByPath(fromObject, [
        'targetTokens'
    ]);
    if (fromTargetTokens != null) setValueByPath(toObject, [
        'targetTokens'
    ], fromTargetTokens);
    return toObject;
}
function contextWindowCompressionConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromTriggerTokens = getValueByPath(fromObject, [
        'triggerTokens'
    ]);
    if (fromTriggerTokens != null) setValueByPath(toObject, [
        'triggerTokens'
    ], fromTriggerTokens);
    const fromSlidingWindow = getValueByPath(fromObject, [
        'slidingWindow'
    ]);
    if (fromSlidingWindow != null) setValueByPath(toObject, [
        'slidingWindow'
    ], slidingWindowToMldev$1(apiClient, fromSlidingWindow));
    return toObject;
}
function contextWindowCompressionConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromTriggerTokens = getValueByPath(fromObject, [
        'triggerTokens'
    ]);
    if (fromTriggerTokens != null) setValueByPath(toObject, [
        'triggerTokens'
    ], fromTriggerTokens);
    const fromSlidingWindow = getValueByPath(fromObject, [
        'slidingWindow'
    ]);
    if (fromSlidingWindow != null) setValueByPath(toObject, [
        'slidingWindow'
    ], slidingWindowToVertex(apiClient, fromSlidingWindow));
    return toObject;
}
function proactivityConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromProactiveAudio = getValueByPath(fromObject, [
        'proactiveAudio'
    ]);
    if (fromProactiveAudio != null) setValueByPath(toObject, [
        'proactiveAudio'
    ], fromProactiveAudio);
    return toObject;
}
function proactivityConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromProactiveAudio = getValueByPath(fromObject, [
        'proactiveAudio'
    ]);
    if (fromProactiveAudio != null) setValueByPath(toObject, [
        'proactiveAudio'
    ], fromProactiveAudio);
    return toObject;
}
function liveConnectConfigToMldev$1(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], fromGenerationConfig);
    const fromResponseModalities = getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], speechConfigToMldev$2(apiClient, tLiveSpeechConfig(apiClient, fromSpeechConfig)));
    const fromEnableAffectiveDialog = getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], contentToMldev$2(apiClient, tContent(apiClient, fromSystemInstruction)));
    const fromTools = getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = tTools(apiClient, fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return toolToMldev$2(apiClient, tTool(apiClient, item));
        });
        setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], sessionResumptionConfigToMldev$1(apiClient, fromSessionResumption));
    const fromInputAudioTranscription = getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], audioTranscriptionConfigToMldev$1());
    const fromOutputAudioTranscription = getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], audioTranscriptionConfigToMldev$1());
    const fromRealtimeInputConfig = getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], realtimeInputConfigToMldev$1(apiClient, fromRealtimeInputConfig));
    const fromContextWindowCompression = getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], contextWindowCompressionConfigToMldev$1(apiClient, fromContextWindowCompression));
    const fromProactivity = getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], proactivityConfigToMldev$1(apiClient, fromProactivity));
    return toObject;
}
function liveConnectConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], fromGenerationConfig);
    const fromResponseModalities = getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], speechConfigToVertex$1(apiClient, tLiveSpeechConfig(apiClient, fromSpeechConfig)));
    const fromEnableAffectiveDialog = getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], contentToVertex$1(apiClient, tContent(apiClient, fromSystemInstruction)));
    const fromTools = getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = tTools(apiClient, fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return toolToVertex$1(apiClient, tTool(apiClient, item));
        });
        setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], sessionResumptionConfigToVertex(apiClient, fromSessionResumption));
    const fromInputAudioTranscription = getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], audioTranscriptionConfigToVertex());
    const fromOutputAudioTranscription = getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], audioTranscriptionConfigToVertex());
    const fromRealtimeInputConfig = getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], realtimeInputConfigToVertex(apiClient, fromRealtimeInputConfig));
    const fromContextWindowCompression = getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], contextWindowCompressionConfigToVertex(apiClient, fromContextWindowCompression));
    const fromProactivity = getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], proactivityConfigToVertex(apiClient, fromProactivity));
    return toObject;
}
function liveConnectParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        'setup',
        'model'
    ], tModel(apiClient, fromModel));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], liveConnectConfigToMldev$1(apiClient, fromConfig, toObject));
    return toObject;
}
function liveConnectParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        'setup',
        'model'
    ], tModel(apiClient, fromModel));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], liveConnectConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function activityStartToMldev() {
    const toObject = {};
    return toObject;
}
function activityStartToVertex() {
    const toObject = {};
    return toObject;
}
function activityEndToMldev() {
    const toObject = {};
    return toObject;
}
function activityEndToVertex() {
    const toObject = {};
    return toObject;
}
function liveSendRealtimeInputParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromMedia = getValueByPath(fromObject, [
        'media'
    ]);
    if (fromMedia != null) setValueByPath(toObject, [
        'mediaChunks'
    ], tBlobs(apiClient, fromMedia));
    const fromAudio = getValueByPath(fromObject, [
        'audio'
    ]);
    if (fromAudio != null) setValueByPath(toObject, [
        'audio'
    ], tAudioBlob(apiClient, fromAudio));
    const fromAudioStreamEnd = getValueByPath(fromObject, [
        'audioStreamEnd'
    ]);
    if (fromAudioStreamEnd != null) setValueByPath(toObject, [
        'audioStreamEnd'
    ], fromAudioStreamEnd);
    const fromVideo = getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) setValueByPath(toObject, [
        'video'
    ], tImageBlob(apiClient, fromVideo));
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromActivityStart = getValueByPath(fromObject, [
        'activityStart'
    ]);
    if (fromActivityStart != null) setValueByPath(toObject, [
        'activityStart'
    ], activityStartToMldev());
    const fromActivityEnd = getValueByPath(fromObject, [
        'activityEnd'
    ]);
    if (fromActivityEnd != null) setValueByPath(toObject, [
        'activityEnd'
    ], activityEndToMldev());
    return toObject;
}
function liveSendRealtimeInputParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromMedia = getValueByPath(fromObject, [
        'media'
    ]);
    if (fromMedia != null) setValueByPath(toObject, [
        'mediaChunks'
    ], tBlobs(apiClient, fromMedia));
    if (getValueByPath(fromObject, [
        'audio'
    ]) !== undefined) throw new Error('audio parameter is not supported in Vertex AI.');
    const fromAudioStreamEnd = getValueByPath(fromObject, [
        'audioStreamEnd'
    ]);
    if (fromAudioStreamEnd != null) setValueByPath(toObject, [
        'audioStreamEnd'
    ], fromAudioStreamEnd);
    if (getValueByPath(fromObject, [
        'video'
    ]) !== undefined) throw new Error('video parameter is not supported in Vertex AI.');
    if (getValueByPath(fromObject, [
        'text'
    ]) !== undefined) throw new Error('text parameter is not supported in Vertex AI.');
    const fromActivityStart = getValueByPath(fromObject, [
        'activityStart'
    ]);
    if (fromActivityStart != null) setValueByPath(toObject, [
        'activityStart'
    ], activityStartToVertex());
    const fromActivityEnd = getValueByPath(fromObject, [
        'activityEnd'
    ]);
    if (fromActivityEnd != null) setValueByPath(toObject, [
        'activityEnd'
    ], activityEndToVertex());
    return toObject;
}
function weightedPromptToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromWeight = getValueByPath(fromObject, [
        'weight'
    ]);
    if (fromWeight != null) setValueByPath(toObject, [
        'weight'
    ], fromWeight);
    return toObject;
}
function liveMusicSetWeightedPromptsParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromWeightedPrompts = getValueByPath(fromObject, [
        'weightedPrompts'
    ]);
    if (fromWeightedPrompts != null) {
        let transformedList = fromWeightedPrompts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return weightedPromptToMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'weightedPrompts'
        ], transformedList);
    }
    return toObject;
}
function liveMusicGenerationConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromTemperature = getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopK = getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromSeed = getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromGuidance = getValueByPath(fromObject, [
        'guidance'
    ]);
    if (fromGuidance != null) setValueByPath(toObject, [
        'guidance'
    ], fromGuidance);
    const fromBpm = getValueByPath(fromObject, [
        'bpm'
    ]);
    if (fromBpm != null) setValueByPath(toObject, [
        'bpm'
    ], fromBpm);
    const fromDensity = getValueByPath(fromObject, [
        'density'
    ]);
    if (fromDensity != null) setValueByPath(toObject, [
        'density'
    ], fromDensity);
    const fromBrightness = getValueByPath(fromObject, [
        'brightness'
    ]);
    if (fromBrightness != null) setValueByPath(toObject, [
        'brightness'
    ], fromBrightness);
    const fromScale = getValueByPath(fromObject, [
        'scale'
    ]);
    if (fromScale != null) setValueByPath(toObject, [
        'scale'
    ], fromScale);
    const fromMuteBass = getValueByPath(fromObject, [
        'muteBass'
    ]);
    if (fromMuteBass != null) setValueByPath(toObject, [
        'muteBass'
    ], fromMuteBass);
    const fromMuteDrums = getValueByPath(fromObject, [
        'muteDrums'
    ]);
    if (fromMuteDrums != null) setValueByPath(toObject, [
        'muteDrums'
    ], fromMuteDrums);
    const fromOnlyBassAndDrums = getValueByPath(fromObject, [
        'onlyBassAndDrums'
    ]);
    if (fromOnlyBassAndDrums != null) setValueByPath(toObject, [
        'onlyBassAndDrums'
    ], fromOnlyBassAndDrums);
    return toObject;
}
function liveMusicSetConfigParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromMusicGenerationConfig = getValueByPath(fromObject, [
        'musicGenerationConfig'
    ]);
    if (fromMusicGenerationConfig != null) setValueByPath(toObject, [
        'musicGenerationConfig'
    ], liveMusicGenerationConfigToMldev(apiClient, fromMusicGenerationConfig));
    return toObject;
}
function liveMusicClientSetupToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        'model'
    ], fromModel);
    return toObject;
}
function liveMusicClientContentToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromWeightedPrompts = getValueByPath(fromObject, [
        'weightedPrompts'
    ]);
    if (fromWeightedPrompts != null) {
        let transformedList = fromWeightedPrompts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return weightedPromptToMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'weightedPrompts'
        ], transformedList);
    }
    return toObject;
}
function liveMusicClientMessageToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromSetup = getValueByPath(fromObject, [
        'setup'
    ]);
    if (fromSetup != null) setValueByPath(toObject, [
        'setup'
    ], liveMusicClientSetupToMldev(apiClient, fromSetup));
    const fromClientContent = getValueByPath(fromObject, [
        'clientContent'
    ]);
    if (fromClientContent != null) setValueByPath(toObject, [
        'clientContent'
    ], liveMusicClientContentToMldev(apiClient, fromClientContent));
    const fromMusicGenerationConfig = getValueByPath(fromObject, [
        'musicGenerationConfig'
    ]);
    if (fromMusicGenerationConfig != null) setValueByPath(toObject, [
        'musicGenerationConfig'
    ], liveMusicGenerationConfigToMldev(apiClient, fromMusicGenerationConfig));
    const fromPlaybackControl = getValueByPath(fromObject, [
        'playbackControl'
    ]);
    if (fromPlaybackControl != null) setValueByPath(toObject, [
        'playbackControl'
    ], fromPlaybackControl);
    return toObject;
}
function liveServerSetupCompleteFromMldev() {
    const toObject = {};
    return toObject;
}
function liveServerSetupCompleteFromVertex() {
    const toObject = {};
    return toObject;
}
function videoMetadataFromMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function videoMetadataFromVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function blobFromMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function blobFromVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function fileDataFromMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromFileUri = getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function fileDataFromVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromFileUri = getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function partFromMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], videoMetadataFromMldev$1(apiClient, fromVideoMetadata));
    const fromThought = getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) setValueByPath(toObject, [
        'inlineData'
    ], blobFromMldev$1(apiClient, fromInlineData));
    const fromFileData = getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) setValueByPath(toObject, [
        'fileData'
    ], fileDataFromMldev$1(apiClient, fromFileData));
    const fromThoughtSignature = getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromCodeExecutionResult = getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionCall = getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function partFromVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], videoMetadataFromVertex$1(apiClient, fromVideoMetadata));
    const fromThought = getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) setValueByPath(toObject, [
        'inlineData'
    ], blobFromVertex$1(apiClient, fromInlineData));
    const fromFileData = getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) setValueByPath(toObject, [
        'fileData'
    ], fileDataFromVertex$1(apiClient, fromFileData));
    const fromThoughtSignature = getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromCodeExecutionResult = getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionCall = getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function contentFromMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromParts = getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return partFromMldev$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function contentFromVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromParts = getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return partFromVertex$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function transcriptionFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromFinished = getValueByPath(fromObject, [
        'finished'
    ]);
    if (fromFinished != null) setValueByPath(toObject, [
        'finished'
    ], fromFinished);
    return toObject;
}
function transcriptionFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromFinished = getValueByPath(fromObject, [
        'finished'
    ]);
    if (fromFinished != null) setValueByPath(toObject, [
        'finished'
    ], fromFinished);
    return toObject;
}
function urlMetadataFromMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromRetrievedUrl = getValueByPath(fromObject, [
        'retrievedUrl'
    ]);
    if (fromRetrievedUrl != null) setValueByPath(toObject, [
        'retrievedUrl'
    ], fromRetrievedUrl);
    const fromUrlRetrievalStatus = getValueByPath(fromObject, [
        'urlRetrievalStatus'
    ]);
    if (fromUrlRetrievalStatus != null) setValueByPath(toObject, [
        'urlRetrievalStatus'
    ], fromUrlRetrievalStatus);
    return toObject;
}
function urlContextMetadataFromMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromUrlMetadata = getValueByPath(fromObject, [
        'urlMetadata'
    ]);
    if (fromUrlMetadata != null) {
        let transformedList = fromUrlMetadata;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return urlMetadataFromMldev$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'urlMetadata'
        ], transformedList);
    }
    return toObject;
}
function liveServerContentFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModelTurn = getValueByPath(fromObject, [
        'modelTurn'
    ]);
    if (fromModelTurn != null) setValueByPath(toObject, [
        'modelTurn'
    ], contentFromMldev$1(apiClient, fromModelTurn));
    const fromTurnComplete = getValueByPath(fromObject, [
        'turnComplete'
    ]);
    if (fromTurnComplete != null) setValueByPath(toObject, [
        'turnComplete'
    ], fromTurnComplete);
    const fromInterrupted = getValueByPath(fromObject, [
        'interrupted'
    ]);
    if (fromInterrupted != null) setValueByPath(toObject, [
        'interrupted'
    ], fromInterrupted);
    const fromGroundingMetadata = getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromGenerationComplete = getValueByPath(fromObject, [
        'generationComplete'
    ]);
    if (fromGenerationComplete != null) setValueByPath(toObject, [
        'generationComplete'
    ], fromGenerationComplete);
    const fromInputTranscription = getValueByPath(fromObject, [
        'inputTranscription'
    ]);
    if (fromInputTranscription != null) setValueByPath(toObject, [
        'inputTranscription'
    ], transcriptionFromMldev(apiClient, fromInputTranscription));
    const fromOutputTranscription = getValueByPath(fromObject, [
        'outputTranscription'
    ]);
    if (fromOutputTranscription != null) setValueByPath(toObject, [
        'outputTranscription'
    ], transcriptionFromMldev(apiClient, fromOutputTranscription));
    const fromUrlContextMetadata = getValueByPath(fromObject, [
        'urlContextMetadata'
    ]);
    if (fromUrlContextMetadata != null) setValueByPath(toObject, [
        'urlContextMetadata'
    ], urlContextMetadataFromMldev$1(apiClient, fromUrlContextMetadata));
    return toObject;
}
function liveServerContentFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModelTurn = getValueByPath(fromObject, [
        'modelTurn'
    ]);
    if (fromModelTurn != null) setValueByPath(toObject, [
        'modelTurn'
    ], contentFromVertex$1(apiClient, fromModelTurn));
    const fromTurnComplete = getValueByPath(fromObject, [
        'turnComplete'
    ]);
    if (fromTurnComplete != null) setValueByPath(toObject, [
        'turnComplete'
    ], fromTurnComplete);
    const fromInterrupted = getValueByPath(fromObject, [
        'interrupted'
    ]);
    if (fromInterrupted != null) setValueByPath(toObject, [
        'interrupted'
    ], fromInterrupted);
    const fromGroundingMetadata = getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromGenerationComplete = getValueByPath(fromObject, [
        'generationComplete'
    ]);
    if (fromGenerationComplete != null) setValueByPath(toObject, [
        'generationComplete'
    ], fromGenerationComplete);
    const fromInputTranscription = getValueByPath(fromObject, [
        'inputTranscription'
    ]);
    if (fromInputTranscription != null) setValueByPath(toObject, [
        'inputTranscription'
    ], transcriptionFromVertex(apiClient, fromInputTranscription));
    const fromOutputTranscription = getValueByPath(fromObject, [
        'outputTranscription'
    ]);
    if (fromOutputTranscription != null) setValueByPath(toObject, [
        'outputTranscription'
    ], transcriptionFromVertex(apiClient, fromOutputTranscription));
    return toObject;
}
function functionCallFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromId = getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function functionCallFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromArgs = getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
function liveServerToolCallFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionCalls = getValueByPath(fromObject, [
        'functionCalls'
    ]);
    if (fromFunctionCalls != null) {
        let transformedList = fromFunctionCalls;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return functionCallFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'functionCalls'
        ], transformedList);
    }
    return toObject;
}
function liveServerToolCallFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionCalls = getValueByPath(fromObject, [
        'functionCalls'
    ]);
    if (fromFunctionCalls != null) {
        let transformedList = fromFunctionCalls;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return functionCallFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'functionCalls'
        ], transformedList);
    }
    return toObject;
}
function liveServerToolCallCancellationFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromIds = getValueByPath(fromObject, [
        'ids'
    ]);
    if (fromIds != null) setValueByPath(toObject, [
        'ids'
    ], fromIds);
    return toObject;
}
function liveServerToolCallCancellationFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromIds = getValueByPath(fromObject, [
        'ids'
    ]);
    if (fromIds != null) setValueByPath(toObject, [
        'ids'
    ], fromIds);
    return toObject;
}
function modalityTokenCountFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModality = getValueByPath(fromObject, [
        'modality'
    ]);
    if (fromModality != null) setValueByPath(toObject, [
        'modality'
    ], fromModality);
    const fromTokenCount = getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    return toObject;
}
function modalityTokenCountFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModality = getValueByPath(fromObject, [
        'modality'
    ]);
    if (fromModality != null) setValueByPath(toObject, [
        'modality'
    ], fromModality);
    const fromTokenCount = getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    return toObject;
}
function usageMetadataFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromPromptTokenCount = getValueByPath(fromObject, [
        'promptTokenCount'
    ]);
    if (fromPromptTokenCount != null) setValueByPath(toObject, [
        'promptTokenCount'
    ], fromPromptTokenCount);
    const fromCachedContentTokenCount = getValueByPath(fromObject, [
        'cachedContentTokenCount'
    ]);
    if (fromCachedContentTokenCount != null) setValueByPath(toObject, [
        'cachedContentTokenCount'
    ], fromCachedContentTokenCount);
    const fromResponseTokenCount = getValueByPath(fromObject, [
        'responseTokenCount'
    ]);
    if (fromResponseTokenCount != null) setValueByPath(toObject, [
        'responseTokenCount'
    ], fromResponseTokenCount);
    const fromToolUsePromptTokenCount = getValueByPath(fromObject, [
        'toolUsePromptTokenCount'
    ]);
    if (fromToolUsePromptTokenCount != null) setValueByPath(toObject, [
        'toolUsePromptTokenCount'
    ], fromToolUsePromptTokenCount);
    const fromThoughtsTokenCount = getValueByPath(fromObject, [
        'thoughtsTokenCount'
    ]);
    if (fromThoughtsTokenCount != null) setValueByPath(toObject, [
        'thoughtsTokenCount'
    ], fromThoughtsTokenCount);
    const fromTotalTokenCount = getValueByPath(fromObject, [
        'totalTokenCount'
    ]);
    if (fromTotalTokenCount != null) setValueByPath(toObject, [
        'totalTokenCount'
    ], fromTotalTokenCount);
    const fromPromptTokensDetails = getValueByPath(fromObject, [
        'promptTokensDetails'
    ]);
    if (fromPromptTokensDetails != null) {
        let transformedList = fromPromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return modalityTokenCountFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'promptTokensDetails'
        ], transformedList);
    }
    const fromCacheTokensDetails = getValueByPath(fromObject, [
        'cacheTokensDetails'
    ]);
    if (fromCacheTokensDetails != null) {
        let transformedList = fromCacheTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return modalityTokenCountFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'cacheTokensDetails'
        ], transformedList);
    }
    const fromResponseTokensDetails = getValueByPath(fromObject, [
        'responseTokensDetails'
    ]);
    if (fromResponseTokensDetails != null) {
        let transformedList = fromResponseTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return modalityTokenCountFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'responseTokensDetails'
        ], transformedList);
    }
    const fromToolUsePromptTokensDetails = getValueByPath(fromObject, [
        'toolUsePromptTokensDetails'
    ]);
    if (fromToolUsePromptTokensDetails != null) {
        let transformedList = fromToolUsePromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return modalityTokenCountFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'toolUsePromptTokensDetails'
        ], transformedList);
    }
    return toObject;
}
function usageMetadataFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromPromptTokenCount = getValueByPath(fromObject, [
        'promptTokenCount'
    ]);
    if (fromPromptTokenCount != null) setValueByPath(toObject, [
        'promptTokenCount'
    ], fromPromptTokenCount);
    const fromCachedContentTokenCount = getValueByPath(fromObject, [
        'cachedContentTokenCount'
    ]);
    if (fromCachedContentTokenCount != null) setValueByPath(toObject, [
        'cachedContentTokenCount'
    ], fromCachedContentTokenCount);
    const fromResponseTokenCount = getValueByPath(fromObject, [
        'candidatesTokenCount'
    ]);
    if (fromResponseTokenCount != null) setValueByPath(toObject, [
        'responseTokenCount'
    ], fromResponseTokenCount);
    const fromToolUsePromptTokenCount = getValueByPath(fromObject, [
        'toolUsePromptTokenCount'
    ]);
    if (fromToolUsePromptTokenCount != null) setValueByPath(toObject, [
        'toolUsePromptTokenCount'
    ], fromToolUsePromptTokenCount);
    const fromThoughtsTokenCount = getValueByPath(fromObject, [
        'thoughtsTokenCount'
    ]);
    if (fromThoughtsTokenCount != null) setValueByPath(toObject, [
        'thoughtsTokenCount'
    ], fromThoughtsTokenCount);
    const fromTotalTokenCount = getValueByPath(fromObject, [
        'totalTokenCount'
    ]);
    if (fromTotalTokenCount != null) setValueByPath(toObject, [
        'totalTokenCount'
    ], fromTotalTokenCount);
    const fromPromptTokensDetails = getValueByPath(fromObject, [
        'promptTokensDetails'
    ]);
    if (fromPromptTokensDetails != null) {
        let transformedList = fromPromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return modalityTokenCountFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'promptTokensDetails'
        ], transformedList);
    }
    const fromCacheTokensDetails = getValueByPath(fromObject, [
        'cacheTokensDetails'
    ]);
    if (fromCacheTokensDetails != null) {
        let transformedList = fromCacheTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return modalityTokenCountFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'cacheTokensDetails'
        ], transformedList);
    }
    const fromResponseTokensDetails = getValueByPath(fromObject, [
        'candidatesTokensDetails'
    ]);
    if (fromResponseTokensDetails != null) {
        let transformedList = fromResponseTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return modalityTokenCountFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'responseTokensDetails'
        ], transformedList);
    }
    const fromToolUsePromptTokensDetails = getValueByPath(fromObject, [
        'toolUsePromptTokensDetails'
    ]);
    if (fromToolUsePromptTokensDetails != null) {
        let transformedList = fromToolUsePromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return modalityTokenCountFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'toolUsePromptTokensDetails'
        ], transformedList);
    }
    const fromTrafficType = getValueByPath(fromObject, [
        'trafficType'
    ]);
    if (fromTrafficType != null) setValueByPath(toObject, [
        'trafficType'
    ], fromTrafficType);
    return toObject;
}
function liveServerGoAwayFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromTimeLeft = getValueByPath(fromObject, [
        'timeLeft'
    ]);
    if (fromTimeLeft != null) setValueByPath(toObject, [
        'timeLeft'
    ], fromTimeLeft);
    return toObject;
}
function liveServerGoAwayFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromTimeLeft = getValueByPath(fromObject, [
        'timeLeft'
    ]);
    if (fromTimeLeft != null) setValueByPath(toObject, [
        'timeLeft'
    ], fromTimeLeft);
    return toObject;
}
function liveServerSessionResumptionUpdateFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromNewHandle = getValueByPath(fromObject, [
        'newHandle'
    ]);
    if (fromNewHandle != null) setValueByPath(toObject, [
        'newHandle'
    ], fromNewHandle);
    const fromResumable = getValueByPath(fromObject, [
        'resumable'
    ]);
    if (fromResumable != null) setValueByPath(toObject, [
        'resumable'
    ], fromResumable);
    const fromLastConsumedClientMessageIndex = getValueByPath(fromObject, [
        'lastConsumedClientMessageIndex'
    ]);
    if (fromLastConsumedClientMessageIndex != null) setValueByPath(toObject, [
        'lastConsumedClientMessageIndex'
    ], fromLastConsumedClientMessageIndex);
    return toObject;
}
function liveServerSessionResumptionUpdateFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromNewHandle = getValueByPath(fromObject, [
        'newHandle'
    ]);
    if (fromNewHandle != null) setValueByPath(toObject, [
        'newHandle'
    ], fromNewHandle);
    const fromResumable = getValueByPath(fromObject, [
        'resumable'
    ]);
    if (fromResumable != null) setValueByPath(toObject, [
        'resumable'
    ], fromResumable);
    const fromLastConsumedClientMessageIndex = getValueByPath(fromObject, [
        'lastConsumedClientMessageIndex'
    ]);
    if (fromLastConsumedClientMessageIndex != null) setValueByPath(toObject, [
        'lastConsumedClientMessageIndex'
    ], fromLastConsumedClientMessageIndex);
    return toObject;
}
function liveServerMessageFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromSetupComplete = getValueByPath(fromObject, [
        'setupComplete'
    ]);
    if (fromSetupComplete != null) setValueByPath(toObject, [
        'setupComplete'
    ], liveServerSetupCompleteFromMldev());
    const fromServerContent = getValueByPath(fromObject, [
        'serverContent'
    ]);
    if (fromServerContent != null) setValueByPath(toObject, [
        'serverContent'
    ], liveServerContentFromMldev(apiClient, fromServerContent));
    const fromToolCall = getValueByPath(fromObject, [
        'toolCall'
    ]);
    if (fromToolCall != null) setValueByPath(toObject, [
        'toolCall'
    ], liveServerToolCallFromMldev(apiClient, fromToolCall));
    const fromToolCallCancellation = getValueByPath(fromObject, [
        'toolCallCancellation'
    ]);
    if (fromToolCallCancellation != null) setValueByPath(toObject, [
        'toolCallCancellation'
    ], liveServerToolCallCancellationFromMldev(apiClient, fromToolCallCancellation));
    const fromUsageMetadata = getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) setValueByPath(toObject, [
        'usageMetadata'
    ], usageMetadataFromMldev(apiClient, fromUsageMetadata));
    const fromGoAway = getValueByPath(fromObject, [
        'goAway'
    ]);
    if (fromGoAway != null) setValueByPath(toObject, [
        'goAway'
    ], liveServerGoAwayFromMldev(apiClient, fromGoAway));
    const fromSessionResumptionUpdate = getValueByPath(fromObject, [
        'sessionResumptionUpdate'
    ]);
    if (fromSessionResumptionUpdate != null) setValueByPath(toObject, [
        'sessionResumptionUpdate'
    ], liveServerSessionResumptionUpdateFromMldev(apiClient, fromSessionResumptionUpdate));
    return toObject;
}
function liveServerMessageFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromSetupComplete = getValueByPath(fromObject, [
        'setupComplete'
    ]);
    if (fromSetupComplete != null) setValueByPath(toObject, [
        'setupComplete'
    ], liveServerSetupCompleteFromVertex());
    const fromServerContent = getValueByPath(fromObject, [
        'serverContent'
    ]);
    if (fromServerContent != null) setValueByPath(toObject, [
        'serverContent'
    ], liveServerContentFromVertex(apiClient, fromServerContent));
    const fromToolCall = getValueByPath(fromObject, [
        'toolCall'
    ]);
    if (fromToolCall != null) setValueByPath(toObject, [
        'toolCall'
    ], liveServerToolCallFromVertex(apiClient, fromToolCall));
    const fromToolCallCancellation = getValueByPath(fromObject, [
        'toolCallCancellation'
    ]);
    if (fromToolCallCancellation != null) setValueByPath(toObject, [
        'toolCallCancellation'
    ], liveServerToolCallCancellationFromVertex(apiClient, fromToolCallCancellation));
    const fromUsageMetadata = getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) setValueByPath(toObject, [
        'usageMetadata'
    ], usageMetadataFromVertex(apiClient, fromUsageMetadata));
    const fromGoAway = getValueByPath(fromObject, [
        'goAway'
    ]);
    if (fromGoAway != null) setValueByPath(toObject, [
        'goAway'
    ], liveServerGoAwayFromVertex(apiClient, fromGoAway));
    const fromSessionResumptionUpdate = getValueByPath(fromObject, [
        'sessionResumptionUpdate'
    ]);
    if (fromSessionResumptionUpdate != null) setValueByPath(toObject, [
        'sessionResumptionUpdate'
    ], liveServerSessionResumptionUpdateFromVertex(apiClient, fromSessionResumptionUpdate));
    return toObject;
}
function liveMusicServerSetupCompleteFromMldev() {
    const toObject = {};
    return toObject;
}
function weightedPromptFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromWeight = getValueByPath(fromObject, [
        'weight'
    ]);
    if (fromWeight != null) setValueByPath(toObject, [
        'weight'
    ], fromWeight);
    return toObject;
}
function liveMusicClientContentFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromWeightedPrompts = getValueByPath(fromObject, [
        'weightedPrompts'
    ]);
    if (fromWeightedPrompts != null) {
        let transformedList = fromWeightedPrompts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return weightedPromptFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'weightedPrompts'
        ], transformedList);
    }
    return toObject;
}
function liveMusicGenerationConfigFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromTemperature = getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopK = getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromSeed = getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromGuidance = getValueByPath(fromObject, [
        'guidance'
    ]);
    if (fromGuidance != null) setValueByPath(toObject, [
        'guidance'
    ], fromGuidance);
    const fromBpm = getValueByPath(fromObject, [
        'bpm'
    ]);
    if (fromBpm != null) setValueByPath(toObject, [
        'bpm'
    ], fromBpm);
    const fromDensity = getValueByPath(fromObject, [
        'density'
    ]);
    if (fromDensity != null) setValueByPath(toObject, [
        'density'
    ], fromDensity);
    const fromBrightness = getValueByPath(fromObject, [
        'brightness'
    ]);
    if (fromBrightness != null) setValueByPath(toObject, [
        'brightness'
    ], fromBrightness);
    const fromScale = getValueByPath(fromObject, [
        'scale'
    ]);
    if (fromScale != null) setValueByPath(toObject, [
        'scale'
    ], fromScale);
    const fromMuteBass = getValueByPath(fromObject, [
        'muteBass'
    ]);
    if (fromMuteBass != null) setValueByPath(toObject, [
        'muteBass'
    ], fromMuteBass);
    const fromMuteDrums = getValueByPath(fromObject, [
        'muteDrums'
    ]);
    if (fromMuteDrums != null) setValueByPath(toObject, [
        'muteDrums'
    ], fromMuteDrums);
    const fromOnlyBassAndDrums = getValueByPath(fromObject, [
        'onlyBassAndDrums'
    ]);
    if (fromOnlyBassAndDrums != null) setValueByPath(toObject, [
        'onlyBassAndDrums'
    ], fromOnlyBassAndDrums);
    return toObject;
}
function liveMusicSourceMetadataFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromClientContent = getValueByPath(fromObject, [
        'clientContent'
    ]);
    if (fromClientContent != null) setValueByPath(toObject, [
        'clientContent'
    ], liveMusicClientContentFromMldev(apiClient, fromClientContent));
    const fromMusicGenerationConfig = getValueByPath(fromObject, [
        'musicGenerationConfig'
    ]);
    if (fromMusicGenerationConfig != null) setValueByPath(toObject, [
        'musicGenerationConfig'
    ], liveMusicGenerationConfigFromMldev(apiClient, fromMusicGenerationConfig));
    return toObject;
}
function audioChunkFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    const fromSourceMetadata = getValueByPath(fromObject, [
        'sourceMetadata'
    ]);
    if (fromSourceMetadata != null) setValueByPath(toObject, [
        'sourceMetadata'
    ], liveMusicSourceMetadataFromMldev(apiClient, fromSourceMetadata));
    return toObject;
}
function liveMusicServerContentFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromAudioChunks = getValueByPath(fromObject, [
        'audioChunks'
    ]);
    if (fromAudioChunks != null) {
        let transformedList = fromAudioChunks;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return audioChunkFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'audioChunks'
        ], transformedList);
    }
    return toObject;
}
function liveMusicFilteredPromptFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromFilteredReason = getValueByPath(fromObject, [
        'filteredReason'
    ]);
    if (fromFilteredReason != null) setValueByPath(toObject, [
        'filteredReason'
    ], fromFilteredReason);
    return toObject;
}
function liveMusicServerMessageFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromSetupComplete = getValueByPath(fromObject, [
        'setupComplete'
    ]);
    if (fromSetupComplete != null) setValueByPath(toObject, [
        'setupComplete'
    ], liveMusicServerSetupCompleteFromMldev());
    const fromServerContent = getValueByPath(fromObject, [
        'serverContent'
    ]);
    if (fromServerContent != null) setValueByPath(toObject, [
        'serverContent'
    ], liveMusicServerContentFromMldev(apiClient, fromServerContent));
    const fromFilteredPrompt = getValueByPath(fromObject, [
        'filteredPrompt'
    ]);
    if (fromFilteredPrompt != null) setValueByPath(toObject, [
        'filteredPrompt'
    ], liveMusicFilteredPromptFromMldev(apiClient, fromFilteredPrompt));
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function videoMetadataToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function blobToMldev$1(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function fileDataToMldev$1(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function partToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], videoMetadataToMldev$1(apiClient, fromVideoMetadata));
    const fromThought = getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) setValueByPath(toObject, [
        'inlineData'
    ], blobToMldev$1(apiClient, fromInlineData));
    const fromFileData = getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) setValueByPath(toObject, [
        'fileData'
    ], fileDataToMldev$1(apiClient, fromFileData));
    const fromThoughtSignature = getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromCodeExecutionResult = getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionCall = getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function contentToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromParts = getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return partToMldev$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function schemaToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromAnyOf = getValueByPath(fromObject, [
        'anyOf'
    ]);
    if (fromAnyOf != null) setValueByPath(toObject, [
        'anyOf'
    ], fromAnyOf);
    const fromDefault = getValueByPath(fromObject, [
        'default'
    ]);
    if (fromDefault != null) setValueByPath(toObject, [
        'default'
    ], fromDefault);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromEnum = getValueByPath(fromObject, [
        'enum'
    ]);
    if (fromEnum != null) setValueByPath(toObject, [
        'enum'
    ], fromEnum);
    const fromExample = getValueByPath(fromObject, [
        'example'
    ]);
    if (fromExample != null) setValueByPath(toObject, [
        'example'
    ], fromExample);
    const fromFormat = getValueByPath(fromObject, [
        'format'
    ]);
    if (fromFormat != null) setValueByPath(toObject, [
        'format'
    ], fromFormat);
    const fromItems = getValueByPath(fromObject, [
        'items'
    ]);
    if (fromItems != null) setValueByPath(toObject, [
        'items'
    ], fromItems);
    const fromMaxItems = getValueByPath(fromObject, [
        'maxItems'
    ]);
    if (fromMaxItems != null) setValueByPath(toObject, [
        'maxItems'
    ], fromMaxItems);
    const fromMaxLength = getValueByPath(fromObject, [
        'maxLength'
    ]);
    if (fromMaxLength != null) setValueByPath(toObject, [
        'maxLength'
    ], fromMaxLength);
    const fromMaxProperties = getValueByPath(fromObject, [
        'maxProperties'
    ]);
    if (fromMaxProperties != null) setValueByPath(toObject, [
        'maxProperties'
    ], fromMaxProperties);
    const fromMaximum = getValueByPath(fromObject, [
        'maximum'
    ]);
    if (fromMaximum != null) setValueByPath(toObject, [
        'maximum'
    ], fromMaximum);
    const fromMinItems = getValueByPath(fromObject, [
        'minItems'
    ]);
    if (fromMinItems != null) setValueByPath(toObject, [
        'minItems'
    ], fromMinItems);
    const fromMinLength = getValueByPath(fromObject, [
        'minLength'
    ]);
    if (fromMinLength != null) setValueByPath(toObject, [
        'minLength'
    ], fromMinLength);
    const fromMinProperties = getValueByPath(fromObject, [
        'minProperties'
    ]);
    if (fromMinProperties != null) setValueByPath(toObject, [
        'minProperties'
    ], fromMinProperties);
    const fromMinimum = getValueByPath(fromObject, [
        'minimum'
    ]);
    if (fromMinimum != null) setValueByPath(toObject, [
        'minimum'
    ], fromMinimum);
    const fromNullable = getValueByPath(fromObject, [
        'nullable'
    ]);
    if (fromNullable != null) setValueByPath(toObject, [
        'nullable'
    ], fromNullable);
    const fromPattern = getValueByPath(fromObject, [
        'pattern'
    ]);
    if (fromPattern != null) setValueByPath(toObject, [
        'pattern'
    ], fromPattern);
    const fromProperties = getValueByPath(fromObject, [
        'properties'
    ]);
    if (fromProperties != null) setValueByPath(toObject, [
        'properties'
    ], fromProperties);
    const fromPropertyOrdering = getValueByPath(fromObject, [
        'propertyOrdering'
    ]);
    if (fromPropertyOrdering != null) setValueByPath(toObject, [
        'propertyOrdering'
    ], fromPropertyOrdering);
    const fromRequired = getValueByPath(fromObject, [
        'required'
    ]);
    if (fromRequired != null) setValueByPath(toObject, [
        'required'
    ], fromRequired);
    const fromTitle = getValueByPath(fromObject, [
        'title'
    ]);
    if (fromTitle != null) setValueByPath(toObject, [
        'title'
    ], fromTitle);
    const fromType = getValueByPath(fromObject, [
        'type'
    ]);
    if (fromType != null) setValueByPath(toObject, [
        'type'
    ], fromType);
    return toObject;
}
function safetySettingToMldev(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'method'
    ]) !== undefined) throw new Error('method parameter is not supported in Gemini API.');
    const fromCategory = getValueByPath(fromObject, [
        'category'
    ]);
    if (fromCategory != null) setValueByPath(toObject, [
        'category'
    ], fromCategory);
    const fromThreshold = getValueByPath(fromObject, [
        'threshold'
    ]);
    if (fromThreshold != null) setValueByPath(toObject, [
        'threshold'
    ], fromThreshold);
    return toObject;
}
function functionDeclarationToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromBehavior = getValueByPath(fromObject, [
        'behavior'
    ]);
    if (fromBehavior != null) setValueByPath(toObject, [
        'behavior'
    ], fromBehavior);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromResponse = getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) setValueByPath(toObject, [
        'response'
    ], fromResponse);
    return toObject;
}
function intervalToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromStartTime = getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function googleSearchToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) setValueByPath(toObject, [
        'timeRangeFilter'
    ], intervalToMldev$1(apiClient, fromTimeRangeFilter));
    return toObject;
}
function dynamicRetrievalConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function googleSearchRetrievalToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], dynamicRetrievalConfigToMldev$1(apiClient, fromDynamicRetrievalConfig));
    return toObject;
}
function urlContextToMldev$1() {
    const toObject = {};
    return toObject;
}
function toolToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return functionDeclarationToMldev$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    if (getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromGoogleSearch = getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) setValueByPath(toObject, [
        'googleSearch'
    ], googleSearchToMldev$1(apiClient, fromGoogleSearch));
    const fromGoogleSearchRetrieval = getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], googleSearchRetrievalToMldev$1(apiClient, fromGoogleSearchRetrieval));
    if (getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'googleMaps'
    ]) !== undefined) throw new Error('googleMaps parameter is not supported in Gemini API.');
    const fromUrlContext = getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) setValueByPath(toObject, [
        'urlContext'
    ], urlContextToMldev$1());
    const fromCodeExecution = getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function functionCallingConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromAllowedFunctionNames = getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    return toObject;
}
function latLngToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromLatitude = getValueByPath(fromObject, [
        'latitude'
    ]);
    if (fromLatitude != null) setValueByPath(toObject, [
        'latitude'
    ], fromLatitude);
    const fromLongitude = getValueByPath(fromObject, [
        'longitude'
    ]);
    if (fromLongitude != null) setValueByPath(toObject, [
        'longitude'
    ], fromLongitude);
    return toObject;
}
function retrievalConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromLatLng = getValueByPath(fromObject, [
        'latLng'
    ]);
    if (fromLatLng != null) setValueByPath(toObject, [
        'latLng'
    ], latLngToMldev(apiClient, fromLatLng));
    const fromLanguageCode = getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function toolConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionCallingConfig = getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) setValueByPath(toObject, [
        'functionCallingConfig'
    ], functionCallingConfigToMldev(apiClient, fromFunctionCallingConfig));
    const fromRetrievalConfig = getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) setValueByPath(toObject, [
        'retrievalConfig'
    ], retrievalConfigToMldev(apiClient, fromRetrievalConfig));
    return toObject;
}
function prebuiltVoiceConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromVoiceName = getValueByPath(fromObject, [
        'voiceName'
    ]);
    if (fromVoiceName != null) setValueByPath(toObject, [
        'voiceName'
    ], fromVoiceName);
    return toObject;
}
function voiceConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromPrebuiltVoiceConfig = getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], prebuiltVoiceConfigToMldev$1(apiClient, fromPrebuiltVoiceConfig));
    return toObject;
}
function speakerVoiceConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromSpeaker = getValueByPath(fromObject, [
        'speaker'
    ]);
    if (fromSpeaker != null) setValueByPath(toObject, [
        'speaker'
    ], fromSpeaker);
    const fromVoiceConfig = getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) setValueByPath(toObject, [
        'voiceConfig'
    ], voiceConfigToMldev$1(apiClient, fromVoiceConfig));
    return toObject;
}
function multiSpeakerVoiceConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromSpeakerVoiceConfigs = getValueByPath(fromObject, [
        'speakerVoiceConfigs'
    ]);
    if (fromSpeakerVoiceConfigs != null) {
        let transformedList = fromSpeakerVoiceConfigs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return speakerVoiceConfigToMldev$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'speakerVoiceConfigs'
        ], transformedList);
    }
    return toObject;
}
function speechConfigToMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromVoiceConfig = getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) setValueByPath(toObject, [
        'voiceConfig'
    ], voiceConfigToMldev$1(apiClient, fromVoiceConfig));
    const fromMultiSpeakerVoiceConfig = getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]);
    if (fromMultiSpeakerVoiceConfig != null) setValueByPath(toObject, [
        'multiSpeakerVoiceConfig'
    ], multiSpeakerVoiceConfigToMldev$1(apiClient, fromMultiSpeakerVoiceConfig));
    const fromLanguageCode = getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function thinkingConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromIncludeThoughts = getValueByPath(fromObject, [
        'includeThoughts'
    ]);
    if (fromIncludeThoughts != null) setValueByPath(toObject, [
        'includeThoughts'
    ], fromIncludeThoughts);
    const fromThinkingBudget = getValueByPath(fromObject, [
        'thinkingBudget'
    ]);
    if (fromThinkingBudget != null) setValueByPath(toObject, [
        'thinkingBudget'
    ], fromThinkingBudget);
    return toObject;
}
function generateContentConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromSystemInstruction = getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) setValueByPath(parentObject, [
        'systemInstruction'
    ], contentToMldev$1(apiClient, tContent(apiClient, fromSystemInstruction)));
    const fromTemperature = getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopP = getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromCandidateCount = getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromMaxOutputTokens = getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromStopSequences = getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromResponseLogprobs = getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromLogprobs = getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromPresencePenalty = getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromFrequencyPenalty = getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromSeed = getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromResponseMimeType = getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseSchema = getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) setValueByPath(toObject, [
        'responseSchema'
    ], schemaToMldev(apiClient, tSchema(apiClient, fromResponseSchema)));
    if (getValueByPath(fromObject, [
        'routingConfig'
    ]) !== undefined) throw new Error('routingConfig parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]) !== undefined) throw new Error('modelSelectionConfig parameter is not supported in Gemini API.');
    const fromSafetySettings = getValueByPath(fromObject, [
        'safetySettings'
    ]);
    if (parentObject !== undefined && fromSafetySettings != null) {
        let transformedList = fromSafetySettings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return safetySettingToMldev(apiClient, item);
        });
        setValueByPath(parentObject, [
            'safetySettings'
        ], transformedList);
    }
    const fromTools = getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = tTools(apiClient, fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return toolToMldev$1(apiClient, tTool(apiClient, item));
        });
        setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) setValueByPath(parentObject, [
        'toolConfig'
    ], toolConfigToMldev(apiClient, fromToolConfig));
    if (getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    const fromCachedContent = getValueByPath(fromObject, [
        'cachedContent'
    ]);
    if (parentObject !== undefined && fromCachedContent != null) setValueByPath(parentObject, [
        'cachedContent'
    ], tCachedContentName(apiClient, fromCachedContent));
    const fromResponseModalities = getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromMediaResolution = getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromSpeechConfig = getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) setValueByPath(toObject, [
        'speechConfig'
    ], speechConfigToMldev$1(apiClient, tSpeechConfig(apiClient, fromSpeechConfig)));
    if (getValueByPath(fromObject, [
        'audioTimestamp'
    ]) !== undefined) throw new Error('audioTimestamp parameter is not supported in Gemini API.');
    const fromThinkingConfig = getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) setValueByPath(toObject, [
        'thinkingConfig'
    ], thinkingConfigToMldev(apiClient, fromThinkingConfig));
    return toObject;
}
function generateContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromContents = getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = tContents(apiClient, fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return contentToMldev$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'generationConfig'
    ], generateContentConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function embedContentConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromTaskType = getValueByPath(fromObject, [
        'taskType'
    ]);
    if (parentObject !== undefined && fromTaskType != null) setValueByPath(parentObject, [
        'requests[]',
        'taskType'
    ], fromTaskType);
    const fromTitle = getValueByPath(fromObject, [
        'title'
    ]);
    if (parentObject !== undefined && fromTitle != null) setValueByPath(parentObject, [
        'requests[]',
        'title'
    ], fromTitle);
    const fromOutputDimensionality = getValueByPath(fromObject, [
        'outputDimensionality'
    ]);
    if (parentObject !== undefined && fromOutputDimensionality != null) setValueByPath(parentObject, [
        'requests[]',
        'outputDimensionality'
    ], fromOutputDimensionality);
    if (getValueByPath(fromObject, [
        'mimeType'
    ]) !== undefined) throw new Error('mimeType parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'autoTruncate'
    ]) !== undefined) throw new Error('autoTruncate parameter is not supported in Gemini API.');
    return toObject;
}
function embedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromContents = getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) setValueByPath(toObject, [
        'requests[]',
        'content'
    ], tContentsForEmbed(apiClient, fromContents));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], embedContentConfigToMldev(apiClient, fromConfig, toObject));
    const fromModelForEmbedContent = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModelForEmbedContent !== undefined) setValueByPath(toObject, [
        'requests[]',
        'model'
    ], tModel(apiClient, fromModelForEmbedContent));
    return toObject;
}
function generateImagesConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'outputGcsUri'
    ]) !== undefined) throw new Error('outputGcsUri parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'negativePrompt'
    ]) !== undefined) throw new Error('negativePrompt parameter is not supported in Gemini API.');
    const fromNumberOfImages = getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    if (getValueByPath(fromObject, [
        'seed'
    ]) !== undefined) throw new Error('seed parameter is not supported in Gemini API.');
    const fromSafetyFilterLevel = getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    if (getValueByPath(fromObject, [
        'addWatermark'
    ]) !== undefined) throw new Error('addWatermark parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'enhancePrompt'
    ]) !== undefined) throw new Error('enhancePrompt parameter is not supported in Gemini API.');
    return toObject;
}
function generateImagesParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromPrompt = getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], generateImagesConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function getModelParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], tModel(apiClient, fromModel));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function listModelsConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    const fromQueryBase = getValueByPath(fromObject, [
        'queryBase'
    ]);
    if (parentObject !== undefined && fromQueryBase != null) setValueByPath(parentObject, [
        '_url',
        'models_url'
    ], tModelsUrl(apiClient, fromQueryBase));
    return toObject;
}
function listModelsParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], listModelsConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function updateModelConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    const fromDefaultCheckpointId = getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (parentObject !== undefined && fromDefaultCheckpointId != null) setValueByPath(parentObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    return toObject;
}
function updateModelParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], tModel(apiClient, fromModel));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], updateModelConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function deleteModelParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], tModel(apiClient, fromModel));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function countTokensConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'systemInstruction'
    ]) !== undefined) throw new Error('systemInstruction parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'tools'
    ]) !== undefined) throw new Error('tools parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'generationConfig'
    ]) !== undefined) throw new Error('generationConfig parameter is not supported in Gemini API.');
    return toObject;
}
function countTokensParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromContents = getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = tContents(apiClient, fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return contentToMldev$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], countTokensConfigToMldev(apiClient, fromConfig));
    return toObject;
}
function imageToMldev(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'gcsUri'
    ]) !== undefined) throw new Error('gcsUri parameter is not supported in Gemini API.');
    const fromImageBytes = getValueByPath(fromObject, [
        'imageBytes'
    ]);
    if (fromImageBytes != null) setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], tBytes(apiClient, fromImageBytes));
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function generateVideosConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromNumberOfVideos = getValueByPath(fromObject, [
        'numberOfVideos'
    ]);
    if (parentObject !== undefined && fromNumberOfVideos != null) setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfVideos);
    if (getValueByPath(fromObject, [
        'outputGcsUri'
    ]) !== undefined) throw new Error('outputGcsUri parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'fps'
    ]) !== undefined) throw new Error('fps parameter is not supported in Gemini API.');
    const fromDurationSeconds = getValueByPath(fromObject, [
        'durationSeconds'
    ]);
    if (parentObject !== undefined && fromDurationSeconds != null) setValueByPath(parentObject, [
        'parameters',
        'durationSeconds'
    ], fromDurationSeconds);
    if (getValueByPath(fromObject, [
        'seed'
    ]) !== undefined) throw new Error('seed parameter is not supported in Gemini API.');
    const fromAspectRatio = getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    if (getValueByPath(fromObject, [
        'resolution'
    ]) !== undefined) throw new Error('resolution parameter is not supported in Gemini API.');
    const fromPersonGeneration = getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    if (getValueByPath(fromObject, [
        'pubsubTopic'
    ]) !== undefined) throw new Error('pubsubTopic parameter is not supported in Gemini API.');
    const fromNegativePrompt = getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromEnhancePrompt = getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    if (getValueByPath(fromObject, [
        'generateAudio'
    ]) !== undefined) throw new Error('generateAudio parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'lastFrame'
    ]) !== undefined) throw new Error('lastFrame parameter is not supported in Gemini API.');
    return toObject;
}
function generateVideosParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromPrompt = getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], imageToMldev(apiClient, fromImage));
    if (getValueByPath(fromObject, [
        'video'
    ]) !== undefined) throw new Error('video parameter is not supported in Gemini API.');
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], generateVideosConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function videoMetadataToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function blobToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function fileDataToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromFileUri = getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function partToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], videoMetadataToVertex(apiClient, fromVideoMetadata));
    const fromThought = getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) setValueByPath(toObject, [
        'inlineData'
    ], blobToVertex(apiClient, fromInlineData));
    const fromFileData = getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) setValueByPath(toObject, [
        'fileData'
    ], fileDataToVertex(apiClient, fromFileData));
    const fromThoughtSignature = getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromCodeExecutionResult = getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionCall = getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function contentToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromParts = getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return partToVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function schemaToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromAnyOf = getValueByPath(fromObject, [
        'anyOf'
    ]);
    if (fromAnyOf != null) setValueByPath(toObject, [
        'anyOf'
    ], fromAnyOf);
    const fromDefault = getValueByPath(fromObject, [
        'default'
    ]);
    if (fromDefault != null) setValueByPath(toObject, [
        'default'
    ], fromDefault);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromEnum = getValueByPath(fromObject, [
        'enum'
    ]);
    if (fromEnum != null) setValueByPath(toObject, [
        'enum'
    ], fromEnum);
    const fromExample = getValueByPath(fromObject, [
        'example'
    ]);
    if (fromExample != null) setValueByPath(toObject, [
        'example'
    ], fromExample);
    const fromFormat = getValueByPath(fromObject, [
        'format'
    ]);
    if (fromFormat != null) setValueByPath(toObject, [
        'format'
    ], fromFormat);
    const fromItems = getValueByPath(fromObject, [
        'items'
    ]);
    if (fromItems != null) setValueByPath(toObject, [
        'items'
    ], fromItems);
    const fromMaxItems = getValueByPath(fromObject, [
        'maxItems'
    ]);
    if (fromMaxItems != null) setValueByPath(toObject, [
        'maxItems'
    ], fromMaxItems);
    const fromMaxLength = getValueByPath(fromObject, [
        'maxLength'
    ]);
    if (fromMaxLength != null) setValueByPath(toObject, [
        'maxLength'
    ], fromMaxLength);
    const fromMaxProperties = getValueByPath(fromObject, [
        'maxProperties'
    ]);
    if (fromMaxProperties != null) setValueByPath(toObject, [
        'maxProperties'
    ], fromMaxProperties);
    const fromMaximum = getValueByPath(fromObject, [
        'maximum'
    ]);
    if (fromMaximum != null) setValueByPath(toObject, [
        'maximum'
    ], fromMaximum);
    const fromMinItems = getValueByPath(fromObject, [
        'minItems'
    ]);
    if (fromMinItems != null) setValueByPath(toObject, [
        'minItems'
    ], fromMinItems);
    const fromMinLength = getValueByPath(fromObject, [
        'minLength'
    ]);
    if (fromMinLength != null) setValueByPath(toObject, [
        'minLength'
    ], fromMinLength);
    const fromMinProperties = getValueByPath(fromObject, [
        'minProperties'
    ]);
    if (fromMinProperties != null) setValueByPath(toObject, [
        'minProperties'
    ], fromMinProperties);
    const fromMinimum = getValueByPath(fromObject, [
        'minimum'
    ]);
    if (fromMinimum != null) setValueByPath(toObject, [
        'minimum'
    ], fromMinimum);
    const fromNullable = getValueByPath(fromObject, [
        'nullable'
    ]);
    if (fromNullable != null) setValueByPath(toObject, [
        'nullable'
    ], fromNullable);
    const fromPattern = getValueByPath(fromObject, [
        'pattern'
    ]);
    if (fromPattern != null) setValueByPath(toObject, [
        'pattern'
    ], fromPattern);
    const fromProperties = getValueByPath(fromObject, [
        'properties'
    ]);
    if (fromProperties != null) setValueByPath(toObject, [
        'properties'
    ], fromProperties);
    const fromPropertyOrdering = getValueByPath(fromObject, [
        'propertyOrdering'
    ]);
    if (fromPropertyOrdering != null) setValueByPath(toObject, [
        'propertyOrdering'
    ], fromPropertyOrdering);
    const fromRequired = getValueByPath(fromObject, [
        'required'
    ]);
    if (fromRequired != null) setValueByPath(toObject, [
        'required'
    ], fromRequired);
    const fromTitle = getValueByPath(fromObject, [
        'title'
    ]);
    if (fromTitle != null) setValueByPath(toObject, [
        'title'
    ], fromTitle);
    const fromType = getValueByPath(fromObject, [
        'type'
    ]);
    if (fromType != null) setValueByPath(toObject, [
        'type'
    ], fromType);
    return toObject;
}
function modelSelectionConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromFeatureSelectionPreference = getValueByPath(fromObject, [
        'featureSelectionPreference'
    ]);
    if (fromFeatureSelectionPreference != null) setValueByPath(toObject, [
        'featureSelectionPreference'
    ], fromFeatureSelectionPreference);
    return toObject;
}
function safetySettingToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromMethod = getValueByPath(fromObject, [
        'method'
    ]);
    if (fromMethod != null) setValueByPath(toObject, [
        'method'
    ], fromMethod);
    const fromCategory = getValueByPath(fromObject, [
        'category'
    ]);
    if (fromCategory != null) setValueByPath(toObject, [
        'category'
    ], fromCategory);
    const fromThreshold = getValueByPath(fromObject, [
        'threshold'
    ]);
    if (fromThreshold != null) setValueByPath(toObject, [
        'threshold'
    ], fromThreshold);
    return toObject;
}
function functionDeclarationToVertex(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromResponse = getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) setValueByPath(toObject, [
        'response'
    ], fromResponse);
    return toObject;
}
function intervalToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromStartTime = getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function googleSearchToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) setValueByPath(toObject, [
        'timeRangeFilter'
    ], intervalToVertex(apiClient, fromTimeRangeFilter));
    return toObject;
}
function dynamicRetrievalConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function googleSearchRetrievalToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], dynamicRetrievalConfigToVertex(apiClient, fromDynamicRetrievalConfig));
    return toObject;
}
function enterpriseWebSearchToVertex() {
    const toObject = {};
    return toObject;
}
function apiKeyConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromApiKeyString = getValueByPath(fromObject, [
        'apiKeyString'
    ]);
    if (fromApiKeyString != null) setValueByPath(toObject, [
        'apiKeyString'
    ], fromApiKeyString);
    return toObject;
}
function authConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromApiKeyConfig = getValueByPath(fromObject, [
        'apiKeyConfig'
    ]);
    if (fromApiKeyConfig != null) setValueByPath(toObject, [
        'apiKeyConfig'
    ], apiKeyConfigToVertex(apiClient, fromApiKeyConfig));
    const fromAuthType = getValueByPath(fromObject, [
        'authType'
    ]);
    if (fromAuthType != null) setValueByPath(toObject, [
        'authType'
    ], fromAuthType);
    const fromGoogleServiceAccountConfig = getValueByPath(fromObject, [
        'googleServiceAccountConfig'
    ]);
    if (fromGoogleServiceAccountConfig != null) setValueByPath(toObject, [
        'googleServiceAccountConfig'
    ], fromGoogleServiceAccountConfig);
    const fromHttpBasicAuthConfig = getValueByPath(fromObject, [
        'httpBasicAuthConfig'
    ]);
    if (fromHttpBasicAuthConfig != null) setValueByPath(toObject, [
        'httpBasicAuthConfig'
    ], fromHttpBasicAuthConfig);
    const fromOauthConfig = getValueByPath(fromObject, [
        'oauthConfig'
    ]);
    if (fromOauthConfig != null) setValueByPath(toObject, [
        'oauthConfig'
    ], fromOauthConfig);
    const fromOidcConfig = getValueByPath(fromObject, [
        'oidcConfig'
    ]);
    if (fromOidcConfig != null) setValueByPath(toObject, [
        'oidcConfig'
    ], fromOidcConfig);
    return toObject;
}
function googleMapsToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromAuthConfig = getValueByPath(fromObject, [
        'authConfig'
    ]);
    if (fromAuthConfig != null) setValueByPath(toObject, [
        'authConfig'
    ], authConfigToVertex(apiClient, fromAuthConfig));
    return toObject;
}
function urlContextToVertex() {
    const toObject = {};
    return toObject;
}
function toolToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return functionDeclarationToVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromRetrieval = getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromGoogleSearch = getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) setValueByPath(toObject, [
        'googleSearch'
    ], googleSearchToVertex(apiClient, fromGoogleSearch));
    const fromGoogleSearchRetrieval = getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], googleSearchRetrievalToVertex(apiClient, fromGoogleSearchRetrieval));
    const fromEnterpriseWebSearch = getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], enterpriseWebSearchToVertex());
    const fromGoogleMaps = getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) setValueByPath(toObject, [
        'googleMaps'
    ], googleMapsToVertex(apiClient, fromGoogleMaps));
    const fromUrlContext = getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) setValueByPath(toObject, [
        'urlContext'
    ], urlContextToVertex());
    const fromCodeExecution = getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function functionCallingConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromAllowedFunctionNames = getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    return toObject;
}
function latLngToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromLatitude = getValueByPath(fromObject, [
        'latitude'
    ]);
    if (fromLatitude != null) setValueByPath(toObject, [
        'latitude'
    ], fromLatitude);
    const fromLongitude = getValueByPath(fromObject, [
        'longitude'
    ]);
    if (fromLongitude != null) setValueByPath(toObject, [
        'longitude'
    ], fromLongitude);
    return toObject;
}
function retrievalConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromLatLng = getValueByPath(fromObject, [
        'latLng'
    ]);
    if (fromLatLng != null) setValueByPath(toObject, [
        'latLng'
    ], latLngToVertex(apiClient, fromLatLng));
    const fromLanguageCode = getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function toolConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionCallingConfig = getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) setValueByPath(toObject, [
        'functionCallingConfig'
    ], functionCallingConfigToVertex(apiClient, fromFunctionCallingConfig));
    const fromRetrievalConfig = getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) setValueByPath(toObject, [
        'retrievalConfig'
    ], retrievalConfigToVertex(apiClient, fromRetrievalConfig));
    return toObject;
}
function prebuiltVoiceConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromVoiceName = getValueByPath(fromObject, [
        'voiceName'
    ]);
    if (fromVoiceName != null) setValueByPath(toObject, [
        'voiceName'
    ], fromVoiceName);
    return toObject;
}
function voiceConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromPrebuiltVoiceConfig = getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], prebuiltVoiceConfigToVertex(apiClient, fromPrebuiltVoiceConfig));
    return toObject;
}
function speechConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromVoiceConfig = getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) setValueByPath(toObject, [
        'voiceConfig'
    ], voiceConfigToVertex(apiClient, fromVoiceConfig));
    if (getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]) !== undefined) throw new Error('multiSpeakerVoiceConfig parameter is not supported in Vertex AI.');
    const fromLanguageCode = getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function thinkingConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromIncludeThoughts = getValueByPath(fromObject, [
        'includeThoughts'
    ]);
    if (fromIncludeThoughts != null) setValueByPath(toObject, [
        'includeThoughts'
    ], fromIncludeThoughts);
    const fromThinkingBudget = getValueByPath(fromObject, [
        'thinkingBudget'
    ]);
    if (fromThinkingBudget != null) setValueByPath(toObject, [
        'thinkingBudget'
    ], fromThinkingBudget);
    return toObject;
}
function generateContentConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromSystemInstruction = getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) setValueByPath(parentObject, [
        'systemInstruction'
    ], contentToVertex(apiClient, tContent(apiClient, fromSystemInstruction)));
    const fromTemperature = getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopP = getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromCandidateCount = getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromMaxOutputTokens = getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromStopSequences = getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromResponseLogprobs = getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromLogprobs = getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromPresencePenalty = getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromFrequencyPenalty = getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromSeed = getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromResponseMimeType = getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseSchema = getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) setValueByPath(toObject, [
        'responseSchema'
    ], schemaToVertex(apiClient, tSchema(apiClient, fromResponseSchema)));
    const fromRoutingConfig = getValueByPath(fromObject, [
        'routingConfig'
    ]);
    if (fromRoutingConfig != null) setValueByPath(toObject, [
        'routingConfig'
    ], fromRoutingConfig);
    const fromModelSelectionConfig = getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]);
    if (fromModelSelectionConfig != null) setValueByPath(toObject, [
        'modelConfig'
    ], modelSelectionConfigToVertex(apiClient, fromModelSelectionConfig));
    const fromSafetySettings = getValueByPath(fromObject, [
        'safetySettings'
    ]);
    if (parentObject !== undefined && fromSafetySettings != null) {
        let transformedList = fromSafetySettings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return safetySettingToVertex(apiClient, item);
        });
        setValueByPath(parentObject, [
            'safetySettings'
        ], transformedList);
    }
    const fromTools = getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = tTools(apiClient, fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return toolToVertex(apiClient, tTool(apiClient, item));
        });
        setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) setValueByPath(parentObject, [
        'toolConfig'
    ], toolConfigToVertex(apiClient, fromToolConfig));
    const fromLabels = getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromCachedContent = getValueByPath(fromObject, [
        'cachedContent'
    ]);
    if (parentObject !== undefined && fromCachedContent != null) setValueByPath(parentObject, [
        'cachedContent'
    ], tCachedContentName(apiClient, fromCachedContent));
    const fromResponseModalities = getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromMediaResolution = getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromSpeechConfig = getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) setValueByPath(toObject, [
        'speechConfig'
    ], speechConfigToVertex(apiClient, tSpeechConfig(apiClient, fromSpeechConfig)));
    const fromAudioTimestamp = getValueByPath(fromObject, [
        'audioTimestamp'
    ]);
    if (fromAudioTimestamp != null) setValueByPath(toObject, [
        'audioTimestamp'
    ], fromAudioTimestamp);
    const fromThinkingConfig = getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) setValueByPath(toObject, [
        'thinkingConfig'
    ], thinkingConfigToVertex(apiClient, fromThinkingConfig));
    return toObject;
}
function generateContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromContents = getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = tContents(apiClient, fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return contentToVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'generationConfig'
    ], generateContentConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function embedContentConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromTaskType = getValueByPath(fromObject, [
        'taskType'
    ]);
    if (parentObject !== undefined && fromTaskType != null) setValueByPath(parentObject, [
        'instances[]',
        'task_type'
    ], fromTaskType);
    const fromTitle = getValueByPath(fromObject, [
        'title'
    ]);
    if (parentObject !== undefined && fromTitle != null) setValueByPath(parentObject, [
        'instances[]',
        'title'
    ], fromTitle);
    const fromOutputDimensionality = getValueByPath(fromObject, [
        'outputDimensionality'
    ]);
    if (parentObject !== undefined && fromOutputDimensionality != null) setValueByPath(parentObject, [
        'parameters',
        'outputDimensionality'
    ], fromOutputDimensionality);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (parentObject !== undefined && fromMimeType != null) setValueByPath(parentObject, [
        'instances[]',
        'mimeType'
    ], fromMimeType);
    const fromAutoTruncate = getValueByPath(fromObject, [
        'autoTruncate'
    ]);
    if (parentObject !== undefined && fromAutoTruncate != null) setValueByPath(parentObject, [
        'parameters',
        'autoTruncate'
    ], fromAutoTruncate);
    return toObject;
}
function embedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromContents = getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) setValueByPath(toObject, [
        'instances[]',
        'content'
    ], tContentsForEmbed(apiClient, fromContents));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], embedContentConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function generateImagesConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromOutputGcsUri = getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromNegativePrompt = getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromNumberOfImages = getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    const fromSeed = getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromSafetyFilterLevel = getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromAddWatermark = getValueByPath(fromObject, [
        'addWatermark'
    ]);
    if (parentObject !== undefined && fromAddWatermark != null) setValueByPath(parentObject, [
        'parameters',
        'addWatermark'
    ], fromAddWatermark);
    const fromEnhancePrompt = getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    return toObject;
}
function generateImagesParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromPrompt = getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], generateImagesConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function imageToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromGcsUri = getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromImageBytes = getValueByPath(fromObject, [
        'imageBytes'
    ]);
    if (fromImageBytes != null) setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], tBytes(apiClient, fromImageBytes));
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function maskReferenceConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromMaskMode = getValueByPath(fromObject, [
        'maskMode'
    ]);
    if (fromMaskMode != null) setValueByPath(toObject, [
        'maskMode'
    ], fromMaskMode);
    const fromSegmentationClasses = getValueByPath(fromObject, [
        'segmentationClasses'
    ]);
    if (fromSegmentationClasses != null) setValueByPath(toObject, [
        'maskClasses'
    ], fromSegmentationClasses);
    const fromMaskDilation = getValueByPath(fromObject, [
        'maskDilation'
    ]);
    if (fromMaskDilation != null) setValueByPath(toObject, [
        'dilation'
    ], fromMaskDilation);
    return toObject;
}
function controlReferenceConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromControlType = getValueByPath(fromObject, [
        'controlType'
    ]);
    if (fromControlType != null) setValueByPath(toObject, [
        'controlType'
    ], fromControlType);
    const fromEnableControlImageComputation = getValueByPath(fromObject, [
        'enableControlImageComputation'
    ]);
    if (fromEnableControlImageComputation != null) setValueByPath(toObject, [
        'computeControl'
    ], fromEnableControlImageComputation);
    return toObject;
}
function styleReferenceConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromStyleDescription = getValueByPath(fromObject, [
        'styleDescription'
    ]);
    if (fromStyleDescription != null) setValueByPath(toObject, [
        'styleDescription'
    ], fromStyleDescription);
    return toObject;
}
function subjectReferenceConfigToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromSubjectType = getValueByPath(fromObject, [
        'subjectType'
    ]);
    if (fromSubjectType != null) setValueByPath(toObject, [
        'subjectType'
    ], fromSubjectType);
    const fromSubjectDescription = getValueByPath(fromObject, [
        'subjectDescription'
    ]);
    if (fromSubjectDescription != null) setValueByPath(toObject, [
        'subjectDescription'
    ], fromSubjectDescription);
    return toObject;
}
function referenceImageAPIInternalToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromReferenceImage = getValueByPath(fromObject, [
        'referenceImage'
    ]);
    if (fromReferenceImage != null) setValueByPath(toObject, [
        'referenceImage'
    ], imageToVertex(apiClient, fromReferenceImage));
    const fromReferenceId = getValueByPath(fromObject, [
        'referenceId'
    ]);
    if (fromReferenceId != null) setValueByPath(toObject, [
        'referenceId'
    ], fromReferenceId);
    const fromReferenceType = getValueByPath(fromObject, [
        'referenceType'
    ]);
    if (fromReferenceType != null) setValueByPath(toObject, [
        'referenceType'
    ], fromReferenceType);
    const fromMaskImageConfig = getValueByPath(fromObject, [
        'maskImageConfig'
    ]);
    if (fromMaskImageConfig != null) setValueByPath(toObject, [
        'maskImageConfig'
    ], maskReferenceConfigToVertex(apiClient, fromMaskImageConfig));
    const fromControlImageConfig = getValueByPath(fromObject, [
        'controlImageConfig'
    ]);
    if (fromControlImageConfig != null) setValueByPath(toObject, [
        'controlImageConfig'
    ], controlReferenceConfigToVertex(apiClient, fromControlImageConfig));
    const fromStyleImageConfig = getValueByPath(fromObject, [
        'styleImageConfig'
    ]);
    if (fromStyleImageConfig != null) setValueByPath(toObject, [
        'styleImageConfig'
    ], styleReferenceConfigToVertex(apiClient, fromStyleImageConfig));
    const fromSubjectImageConfig = getValueByPath(fromObject, [
        'subjectImageConfig'
    ]);
    if (fromSubjectImageConfig != null) setValueByPath(toObject, [
        'subjectImageConfig'
    ], subjectReferenceConfigToVertex(apiClient, fromSubjectImageConfig));
    return toObject;
}
function editImageConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromOutputGcsUri = getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromNegativePrompt = getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromNumberOfImages = getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    const fromSeed = getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromSafetyFilterLevel = getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromEditMode = getValueByPath(fromObject, [
        'editMode'
    ]);
    if (parentObject !== undefined && fromEditMode != null) setValueByPath(parentObject, [
        'parameters',
        'editMode'
    ], fromEditMode);
    const fromBaseSteps = getValueByPath(fromObject, [
        'baseSteps'
    ]);
    if (parentObject !== undefined && fromBaseSteps != null) setValueByPath(parentObject, [
        'parameters',
        'editConfig',
        'baseSteps'
    ], fromBaseSteps);
    return toObject;
}
function editImageParametersInternalToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromPrompt = getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromReferenceImages = getValueByPath(fromObject, [
        'referenceImages'
    ]);
    if (fromReferenceImages != null) {
        let transformedList = fromReferenceImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return referenceImageAPIInternalToVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'instances[0]',
            'referenceImages'
        ], transformedList);
    }
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], editImageConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function upscaleImageAPIConfigInternalToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromIncludeRaiReason = getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromOutputMimeType = getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromNumberOfImages = getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (parentObject !== undefined && fromMode != null) setValueByPath(parentObject, [
        'parameters',
        'mode'
    ], fromMode);
    return toObject;
}
function upscaleImageAPIParametersInternalToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromImage = getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], imageToVertex(apiClient, fromImage));
    const fromUpscaleFactor = getValueByPath(fromObject, [
        'upscaleFactor'
    ]);
    if (fromUpscaleFactor != null) setValueByPath(toObject, [
        'parameters',
        'upscaleConfig',
        'upscaleFactor'
    ], fromUpscaleFactor);
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], upscaleImageAPIConfigInternalToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function getModelParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], tModel(apiClient, fromModel));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function listModelsConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    const fromQueryBase = getValueByPath(fromObject, [
        'queryBase'
    ]);
    if (parentObject !== undefined && fromQueryBase != null) setValueByPath(parentObject, [
        '_url',
        'models_url'
    ], tModelsUrl(apiClient, fromQueryBase));
    return toObject;
}
function listModelsParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], listModelsConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function updateModelConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    const fromDefaultCheckpointId = getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (parentObject !== undefined && fromDefaultCheckpointId != null) setValueByPath(parentObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    return toObject;
}
function updateModelParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], updateModelConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function deleteModelParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], tModel(apiClient, fromModel));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function countTokensConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromSystemInstruction = getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) setValueByPath(parentObject, [
        'systemInstruction'
    ], contentToVertex(apiClient, tContent(apiClient, fromSystemInstruction)));
    const fromTools = getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return toolToVertex(apiClient, item);
        });
        setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromGenerationConfig = getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) setValueByPath(parentObject, [
        'generationConfig'
    ], fromGenerationConfig);
    return toObject;
}
function countTokensParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromContents = getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = tContents(apiClient, fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return contentToVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], countTokensConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function computeTokensParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromContents = getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = tContents(apiClient, fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return contentToVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function videoToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromUri = getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) setValueByPath(toObject, [
        'gcsUri'
    ], fromUri);
    const fromVideoBytes = getValueByPath(fromObject, [
        'videoBytes'
    ]);
    if (fromVideoBytes != null) setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], tBytes(apiClient, fromVideoBytes));
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function generateVideosConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromNumberOfVideos = getValueByPath(fromObject, [
        'numberOfVideos'
    ]);
    if (parentObject !== undefined && fromNumberOfVideos != null) setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfVideos);
    const fromOutputGcsUri = getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (parentObject !== undefined && fromFps != null) setValueByPath(parentObject, [
        'parameters',
        'fps'
    ], fromFps);
    const fromDurationSeconds = getValueByPath(fromObject, [
        'durationSeconds'
    ]);
    if (parentObject !== undefined && fromDurationSeconds != null) setValueByPath(parentObject, [
        'parameters',
        'durationSeconds'
    ], fromDurationSeconds);
    const fromSeed = getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromAspectRatio = getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromResolution = getValueByPath(fromObject, [
        'resolution'
    ]);
    if (parentObject !== undefined && fromResolution != null) setValueByPath(parentObject, [
        'parameters',
        'resolution'
    ], fromResolution);
    const fromPersonGeneration = getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromPubsubTopic = getValueByPath(fromObject, [
        'pubsubTopic'
    ]);
    if (parentObject !== undefined && fromPubsubTopic != null) setValueByPath(parentObject, [
        'parameters',
        'pubsubTopic'
    ], fromPubsubTopic);
    const fromNegativePrompt = getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromEnhancePrompt = getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    const fromGenerateAudio = getValueByPath(fromObject, [
        'generateAudio'
    ]);
    if (parentObject !== undefined && fromGenerateAudio != null) setValueByPath(parentObject, [
        'parameters',
        'generateAudio'
    ], fromGenerateAudio);
    const fromLastFrame = getValueByPath(fromObject, [
        'lastFrame'
    ]);
    if (parentObject !== undefined && fromLastFrame != null) setValueByPath(parentObject, [
        'instances[0]',
        'lastFrame'
    ], imageToVertex(apiClient, fromLastFrame));
    return toObject;
}
function generateVideosParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        '_url',
        'model'
    ], tModel(apiClient, fromModel));
    const fromPrompt = getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], imageToVertex(apiClient, fromImage));
    const fromVideo = getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) setValueByPath(toObject, [
        'instances[0]',
        'video'
    ], videoToVertex(apiClient, fromVideo));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], generateVideosConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function videoMetadataFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function blobFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function fileDataFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromFileUri = getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function partFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], videoMetadataFromMldev(apiClient, fromVideoMetadata));
    const fromThought = getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) setValueByPath(toObject, [
        'inlineData'
    ], blobFromMldev(apiClient, fromInlineData));
    const fromFileData = getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) setValueByPath(toObject, [
        'fileData'
    ], fileDataFromMldev(apiClient, fromFileData));
    const fromThoughtSignature = getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromCodeExecutionResult = getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionCall = getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function contentFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromParts = getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return partFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function citationMetadataFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromCitations = getValueByPath(fromObject, [
        'citationSources'
    ]);
    if (fromCitations != null) setValueByPath(toObject, [
        'citations'
    ], fromCitations);
    return toObject;
}
function urlMetadataFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromRetrievedUrl = getValueByPath(fromObject, [
        'retrievedUrl'
    ]);
    if (fromRetrievedUrl != null) setValueByPath(toObject, [
        'retrievedUrl'
    ], fromRetrievedUrl);
    const fromUrlRetrievalStatus = getValueByPath(fromObject, [
        'urlRetrievalStatus'
    ]);
    if (fromUrlRetrievalStatus != null) setValueByPath(toObject, [
        'urlRetrievalStatus'
    ], fromUrlRetrievalStatus);
    return toObject;
}
function urlContextMetadataFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromUrlMetadata = getValueByPath(fromObject, [
        'urlMetadata'
    ]);
    if (fromUrlMetadata != null) {
        let transformedList = fromUrlMetadata;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return urlMetadataFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'urlMetadata'
        ], transformedList);
    }
    return toObject;
}
function candidateFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromContent = getValueByPath(fromObject, [
        'content'
    ]);
    if (fromContent != null) setValueByPath(toObject, [
        'content'
    ], contentFromMldev(apiClient, fromContent));
    const fromCitationMetadata = getValueByPath(fromObject, [
        'citationMetadata'
    ]);
    if (fromCitationMetadata != null) setValueByPath(toObject, [
        'citationMetadata'
    ], citationMetadataFromMldev(apiClient, fromCitationMetadata));
    const fromTokenCount = getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    const fromFinishReason = getValueByPath(fromObject, [
        'finishReason'
    ]);
    if (fromFinishReason != null) setValueByPath(toObject, [
        'finishReason'
    ], fromFinishReason);
    const fromUrlContextMetadata = getValueByPath(fromObject, [
        'urlContextMetadata'
    ]);
    if (fromUrlContextMetadata != null) setValueByPath(toObject, [
        'urlContextMetadata'
    ], urlContextMetadataFromMldev(apiClient, fromUrlContextMetadata));
    const fromAvgLogprobs = getValueByPath(fromObject, [
        'avgLogprobs'
    ]);
    if (fromAvgLogprobs != null) setValueByPath(toObject, [
        'avgLogprobs'
    ], fromAvgLogprobs);
    const fromGroundingMetadata = getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromIndex = getValueByPath(fromObject, [
        'index'
    ]);
    if (fromIndex != null) setValueByPath(toObject, [
        'index'
    ], fromIndex);
    const fromLogprobsResult = getValueByPath(fromObject, [
        'logprobsResult'
    ]);
    if (fromLogprobsResult != null) setValueByPath(toObject, [
        'logprobsResult'
    ], fromLogprobsResult);
    const fromSafetyRatings = getValueByPath(fromObject, [
        'safetyRatings'
    ]);
    if (fromSafetyRatings != null) setValueByPath(toObject, [
        'safetyRatings'
    ], fromSafetyRatings);
    return toObject;
}
function generateContentResponseFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromCandidates = getValueByPath(fromObject, [
        'candidates'
    ]);
    if (fromCandidates != null) {
        let transformedList = fromCandidates;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return candidateFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'candidates'
        ], transformedList);
    }
    const fromModelVersion = getValueByPath(fromObject, [
        'modelVersion'
    ]);
    if (fromModelVersion != null) setValueByPath(toObject, [
        'modelVersion'
    ], fromModelVersion);
    const fromPromptFeedback = getValueByPath(fromObject, [
        'promptFeedback'
    ]);
    if (fromPromptFeedback != null) setValueByPath(toObject, [
        'promptFeedback'
    ], fromPromptFeedback);
    const fromUsageMetadata = getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function contentEmbeddingFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromValues = getValueByPath(fromObject, [
        'values'
    ]);
    if (fromValues != null) setValueByPath(toObject, [
        'values'
    ], fromValues);
    return toObject;
}
function embedContentMetadataFromMldev() {
    const toObject = {};
    return toObject;
}
function embedContentResponseFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromEmbeddings = getValueByPath(fromObject, [
        'embeddings'
    ]);
    if (fromEmbeddings != null) {
        let transformedList = fromEmbeddings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return contentEmbeddingFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'embeddings'
        ], transformedList);
    }
    const fromMetadata = getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) setValueByPath(toObject, [
        'metadata'
    ], embedContentMetadataFromMldev());
    return toObject;
}
function imageFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromImageBytes = getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromImageBytes != null) setValueByPath(toObject, [
        'imageBytes'
    ], tBytes(apiClient, fromImageBytes));
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function safetyAttributesFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromCategories = getValueByPath(fromObject, [
        'safetyAttributes',
        'categories'
    ]);
    if (fromCategories != null) setValueByPath(toObject, [
        'categories'
    ], fromCategories);
    const fromScores = getValueByPath(fromObject, [
        'safetyAttributes',
        'scores'
    ]);
    if (fromScores != null) setValueByPath(toObject, [
        'scores'
    ], fromScores);
    const fromContentType = getValueByPath(fromObject, [
        'contentType'
    ]);
    if (fromContentType != null) setValueByPath(toObject, [
        'contentType'
    ], fromContentType);
    return toObject;
}
function generatedImageFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromImage = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromImage != null) setValueByPath(toObject, [
        'image'
    ], imageFromMldev(apiClient, fromImage));
    const fromRaiFilteredReason = getValueByPath(fromObject, [
        'raiFilteredReason'
    ]);
    if (fromRaiFilteredReason != null) setValueByPath(toObject, [
        'raiFilteredReason'
    ], fromRaiFilteredReason);
    const fromSafetyAttributes = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromSafetyAttributes != null) setValueByPath(toObject, [
        'safetyAttributes'
    ], safetyAttributesFromMldev(apiClient, fromSafetyAttributes));
    return toObject;
}
function generateImagesResponseFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromGeneratedImages = getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return generatedImageFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    const fromPositivePromptSafetyAttributes = getValueByPath(fromObject, [
        'positivePromptSafetyAttributes'
    ]);
    if (fromPositivePromptSafetyAttributes != null) setValueByPath(toObject, [
        'positivePromptSafetyAttributes'
    ], safetyAttributesFromMldev(apiClient, fromPositivePromptSafetyAttributes));
    return toObject;
}
function tunedModelInfoFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromBaseModel = getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromCreateTime = getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    return toObject;
}
function modelFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromVersion = getValueByPath(fromObject, [
        'version'
    ]);
    if (fromVersion != null) setValueByPath(toObject, [
        'version'
    ], fromVersion);
    const fromTunedModelInfo = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModelInfo != null) setValueByPath(toObject, [
        'tunedModelInfo'
    ], tunedModelInfoFromMldev(apiClient, fromTunedModelInfo));
    const fromInputTokenLimit = getValueByPath(fromObject, [
        'inputTokenLimit'
    ]);
    if (fromInputTokenLimit != null) setValueByPath(toObject, [
        'inputTokenLimit'
    ], fromInputTokenLimit);
    const fromOutputTokenLimit = getValueByPath(fromObject, [
        'outputTokenLimit'
    ]);
    if (fromOutputTokenLimit != null) setValueByPath(toObject, [
        'outputTokenLimit'
    ], fromOutputTokenLimit);
    const fromSupportedActions = getValueByPath(fromObject, [
        'supportedGenerationMethods'
    ]);
    if (fromSupportedActions != null) setValueByPath(toObject, [
        'supportedActions'
    ], fromSupportedActions);
    return toObject;
}
function listModelsResponseFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromNextPageToken = getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromModels = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromModels != null) {
        let transformedList = tExtractModels(apiClient, fromModels);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return modelFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'models'
        ], transformedList);
    }
    return toObject;
}
function deleteModelResponseFromMldev() {
    const toObject = {};
    return toObject;
}
function countTokensResponseFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromTotalTokens = getValueByPath(fromObject, [
        'totalTokens'
    ]);
    if (fromTotalTokens != null) setValueByPath(toObject, [
        'totalTokens'
    ], fromTotalTokens);
    const fromCachedContentTokenCount = getValueByPath(fromObject, [
        'cachedContentTokenCount'
    ]);
    if (fromCachedContentTokenCount != null) setValueByPath(toObject, [
        'cachedContentTokenCount'
    ], fromCachedContentTokenCount);
    return toObject;
}
function videoFromMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromUri = getValueByPath(fromObject, [
        'video',
        'uri'
    ]);
    if (fromUri != null) setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = getValueByPath(fromObject, [
        'video',
        'encodedVideo'
    ]);
    if (fromVideoBytes != null) setValueByPath(toObject, [
        'videoBytes'
    ], tBytes(apiClient, fromVideoBytes));
    const fromMimeType = getValueByPath(fromObject, [
        'encoding'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function generatedVideoFromMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromVideo = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) setValueByPath(toObject, [
        'video'
    ], videoFromMldev$1(apiClient, fromVideo));
    return toObject;
}
function generateVideosResponseFromMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromGeneratedVideos = getValueByPath(fromObject, [
        'generatedSamples'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return generatedVideoFromMldev$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function generateVideosOperationFromMldev$1(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = getValueByPath(fromObject, [
        'response',
        'generateVideoResponse'
    ]);
    if (fromResponse != null) setValueByPath(toObject, [
        'response'
    ], generateVideosResponseFromMldev$1(apiClient, fromResponse));
    return toObject;
}
function videoMetadataFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function blobFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function fileDataFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromFileUri = getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function partFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], videoMetadataFromVertex(apiClient, fromVideoMetadata));
    const fromThought = getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) setValueByPath(toObject, [
        'inlineData'
    ], blobFromVertex(apiClient, fromInlineData));
    const fromFileData = getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) setValueByPath(toObject, [
        'fileData'
    ], fileDataFromVertex(apiClient, fromFileData));
    const fromThoughtSignature = getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromCodeExecutionResult = getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionCall = getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function contentFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromParts = getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return partFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function citationMetadataFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromCitations = getValueByPath(fromObject, [
        'citations'
    ]);
    if (fromCitations != null) setValueByPath(toObject, [
        'citations'
    ], fromCitations);
    return toObject;
}
function urlMetadataFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromRetrievedUrl = getValueByPath(fromObject, [
        'retrievedUrl'
    ]);
    if (fromRetrievedUrl != null) setValueByPath(toObject, [
        'retrievedUrl'
    ], fromRetrievedUrl);
    const fromUrlRetrievalStatus = getValueByPath(fromObject, [
        'urlRetrievalStatus'
    ]);
    if (fromUrlRetrievalStatus != null) setValueByPath(toObject, [
        'urlRetrievalStatus'
    ], fromUrlRetrievalStatus);
    return toObject;
}
function urlContextMetadataFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromUrlMetadata = getValueByPath(fromObject, [
        'urlMetadata'
    ]);
    if (fromUrlMetadata != null) {
        let transformedList = fromUrlMetadata;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return urlMetadataFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'urlMetadata'
        ], transformedList);
    }
    return toObject;
}
function candidateFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromContent = getValueByPath(fromObject, [
        'content'
    ]);
    if (fromContent != null) setValueByPath(toObject, [
        'content'
    ], contentFromVertex(apiClient, fromContent));
    const fromCitationMetadata = getValueByPath(fromObject, [
        'citationMetadata'
    ]);
    if (fromCitationMetadata != null) setValueByPath(toObject, [
        'citationMetadata'
    ], citationMetadataFromVertex(apiClient, fromCitationMetadata));
    const fromFinishMessage = getValueByPath(fromObject, [
        'finishMessage'
    ]);
    if (fromFinishMessage != null) setValueByPath(toObject, [
        'finishMessage'
    ], fromFinishMessage);
    const fromFinishReason = getValueByPath(fromObject, [
        'finishReason'
    ]);
    if (fromFinishReason != null) setValueByPath(toObject, [
        'finishReason'
    ], fromFinishReason);
    const fromUrlContextMetadata = getValueByPath(fromObject, [
        'urlContextMetadata'
    ]);
    if (fromUrlContextMetadata != null) setValueByPath(toObject, [
        'urlContextMetadata'
    ], urlContextMetadataFromVertex(apiClient, fromUrlContextMetadata));
    const fromAvgLogprobs = getValueByPath(fromObject, [
        'avgLogprobs'
    ]);
    if (fromAvgLogprobs != null) setValueByPath(toObject, [
        'avgLogprobs'
    ], fromAvgLogprobs);
    const fromGroundingMetadata = getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromIndex = getValueByPath(fromObject, [
        'index'
    ]);
    if (fromIndex != null) setValueByPath(toObject, [
        'index'
    ], fromIndex);
    const fromLogprobsResult = getValueByPath(fromObject, [
        'logprobsResult'
    ]);
    if (fromLogprobsResult != null) setValueByPath(toObject, [
        'logprobsResult'
    ], fromLogprobsResult);
    const fromSafetyRatings = getValueByPath(fromObject, [
        'safetyRatings'
    ]);
    if (fromSafetyRatings != null) setValueByPath(toObject, [
        'safetyRatings'
    ], fromSafetyRatings);
    return toObject;
}
function generateContentResponseFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromCandidates = getValueByPath(fromObject, [
        'candidates'
    ]);
    if (fromCandidates != null) {
        let transformedList = fromCandidates;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return candidateFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'candidates'
        ], transformedList);
    }
    const fromCreateTime = getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromResponseId = getValueByPath(fromObject, [
        'responseId'
    ]);
    if (fromResponseId != null) setValueByPath(toObject, [
        'responseId'
    ], fromResponseId);
    const fromModelVersion = getValueByPath(fromObject, [
        'modelVersion'
    ]);
    if (fromModelVersion != null) setValueByPath(toObject, [
        'modelVersion'
    ], fromModelVersion);
    const fromPromptFeedback = getValueByPath(fromObject, [
        'promptFeedback'
    ]);
    if (fromPromptFeedback != null) setValueByPath(toObject, [
        'promptFeedback'
    ], fromPromptFeedback);
    const fromUsageMetadata = getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function contentEmbeddingStatisticsFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromTruncated = getValueByPath(fromObject, [
        'truncated'
    ]);
    if (fromTruncated != null) setValueByPath(toObject, [
        'truncated'
    ], fromTruncated);
    const fromTokenCount = getValueByPath(fromObject, [
        'token_count'
    ]);
    if (fromTokenCount != null) setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    return toObject;
}
function contentEmbeddingFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromValues = getValueByPath(fromObject, [
        'values'
    ]);
    if (fromValues != null) setValueByPath(toObject, [
        'values'
    ], fromValues);
    const fromStatistics = getValueByPath(fromObject, [
        'statistics'
    ]);
    if (fromStatistics != null) setValueByPath(toObject, [
        'statistics'
    ], contentEmbeddingStatisticsFromVertex(apiClient, fromStatistics));
    return toObject;
}
function embedContentMetadataFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromBillableCharacterCount = getValueByPath(fromObject, [
        'billableCharacterCount'
    ]);
    if (fromBillableCharacterCount != null) setValueByPath(toObject, [
        'billableCharacterCount'
    ], fromBillableCharacterCount);
    return toObject;
}
function embedContentResponseFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromEmbeddings = getValueByPath(fromObject, [
        'predictions[]',
        'embeddings'
    ]);
    if (fromEmbeddings != null) {
        let transformedList = fromEmbeddings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return contentEmbeddingFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'embeddings'
        ], transformedList);
    }
    const fromMetadata = getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) setValueByPath(toObject, [
        'metadata'
    ], embedContentMetadataFromVertex(apiClient, fromMetadata));
    return toObject;
}
function imageFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromGcsUri = getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromImageBytes = getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromImageBytes != null) setValueByPath(toObject, [
        'imageBytes'
    ], tBytes(apiClient, fromImageBytes));
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function safetyAttributesFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromCategories = getValueByPath(fromObject, [
        'safetyAttributes',
        'categories'
    ]);
    if (fromCategories != null) setValueByPath(toObject, [
        'categories'
    ], fromCategories);
    const fromScores = getValueByPath(fromObject, [
        'safetyAttributes',
        'scores'
    ]);
    if (fromScores != null) setValueByPath(toObject, [
        'scores'
    ], fromScores);
    const fromContentType = getValueByPath(fromObject, [
        'contentType'
    ]);
    if (fromContentType != null) setValueByPath(toObject, [
        'contentType'
    ], fromContentType);
    return toObject;
}
function generatedImageFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromImage = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromImage != null) setValueByPath(toObject, [
        'image'
    ], imageFromVertex(apiClient, fromImage));
    const fromRaiFilteredReason = getValueByPath(fromObject, [
        'raiFilteredReason'
    ]);
    if (fromRaiFilteredReason != null) setValueByPath(toObject, [
        'raiFilteredReason'
    ], fromRaiFilteredReason);
    const fromSafetyAttributes = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromSafetyAttributes != null) setValueByPath(toObject, [
        'safetyAttributes'
    ], safetyAttributesFromVertex(apiClient, fromSafetyAttributes));
    const fromEnhancedPrompt = getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromEnhancedPrompt != null) setValueByPath(toObject, [
        'enhancedPrompt'
    ], fromEnhancedPrompt);
    return toObject;
}
function generateImagesResponseFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromGeneratedImages = getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return generatedImageFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    const fromPositivePromptSafetyAttributes = getValueByPath(fromObject, [
        'positivePromptSafetyAttributes'
    ]);
    if (fromPositivePromptSafetyAttributes != null) setValueByPath(toObject, [
        'positivePromptSafetyAttributes'
    ], safetyAttributesFromVertex(apiClient, fromPositivePromptSafetyAttributes));
    return toObject;
}
function editImageResponseFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromGeneratedImages = getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return generatedImageFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    return toObject;
}
function upscaleImageResponseFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromGeneratedImages = getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return generatedImageFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    return toObject;
}
function endpointFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'endpoint'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDeployedModelId = getValueByPath(fromObject, [
        'deployedModelId'
    ]);
    if (fromDeployedModelId != null) setValueByPath(toObject, [
        'deployedModelId'
    ], fromDeployedModelId);
    return toObject;
}
function tunedModelInfoFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromBaseModel = getValueByPath(fromObject, [
        'labels',
        'google-vertex-llm-tuning-base-model-id'
    ]);
    if (fromBaseModel != null) setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromCreateTime = getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    return toObject;
}
function checkpointFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromCheckpointId = getValueByPath(fromObject, [
        'checkpointId'
    ]);
    if (fromCheckpointId != null) setValueByPath(toObject, [
        'checkpointId'
    ], fromCheckpointId);
    const fromEpoch = getValueByPath(fromObject, [
        'epoch'
    ]);
    if (fromEpoch != null) setValueByPath(toObject, [
        'epoch'
    ], fromEpoch);
    const fromStep = getValueByPath(fromObject, [
        'step'
    ]);
    if (fromStep != null) setValueByPath(toObject, [
        'step'
    ], fromStep);
    return toObject;
}
function modelFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromVersion = getValueByPath(fromObject, [
        'versionId'
    ]);
    if (fromVersion != null) setValueByPath(toObject, [
        'version'
    ], fromVersion);
    const fromEndpoints = getValueByPath(fromObject, [
        'deployedModels'
    ]);
    if (fromEndpoints != null) {
        let transformedList = fromEndpoints;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return endpointFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'endpoints'
        ], transformedList);
    }
    const fromLabels = getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) setValueByPath(toObject, [
        'labels'
    ], fromLabels);
    const fromTunedModelInfo = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModelInfo != null) setValueByPath(toObject, [
        'tunedModelInfo'
    ], tunedModelInfoFromVertex(apiClient, fromTunedModelInfo));
    const fromDefaultCheckpointId = getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (fromDefaultCheckpointId != null) setValueByPath(toObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    const fromCheckpoints = getValueByPath(fromObject, [
        'checkpoints'
    ]);
    if (fromCheckpoints != null) {
        let transformedList = fromCheckpoints;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return checkpointFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'checkpoints'
        ], transformedList);
    }
    return toObject;
}
function listModelsResponseFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromNextPageToken = getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromModels = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromModels != null) {
        let transformedList = tExtractModels(apiClient, fromModels);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return modelFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'models'
        ], transformedList);
    }
    return toObject;
}
function deleteModelResponseFromVertex() {
    const toObject = {};
    return toObject;
}
function countTokensResponseFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromTotalTokens = getValueByPath(fromObject, [
        'totalTokens'
    ]);
    if (fromTotalTokens != null) setValueByPath(toObject, [
        'totalTokens'
    ], fromTotalTokens);
    return toObject;
}
function computeTokensResponseFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromTokensInfo = getValueByPath(fromObject, [
        'tokensInfo'
    ]);
    if (fromTokensInfo != null) setValueByPath(toObject, [
        'tokensInfo'
    ], fromTokensInfo);
    return toObject;
}
function videoFromVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromUri = getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromUri != null) setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromVideoBytes != null) setValueByPath(toObject, [
        'videoBytes'
    ], tBytes(apiClient, fromVideoBytes));
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function generatedVideoFromVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromVideo = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) setValueByPath(toObject, [
        'video'
    ], videoFromVertex$1(apiClient, fromVideo));
    return toObject;
}
function generateVideosResponseFromVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromGeneratedVideos = getValueByPath(fromObject, [
        'videos'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return generatedVideoFromVertex$1(apiClient, item);
        });
        setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function generateVideosOperationFromVertex$1(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) setValueByPath(toObject, [
        'response'
    ], generateVideosResponseFromVertex$1(apiClient, fromResponse));
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const CONTENT_TYPE_HEADER = 'Content-Type';
const SERVER_TIMEOUT_HEADER = 'X-Server-Timeout';
const USER_AGENT_HEADER = 'User-Agent';
const GOOGLE_API_CLIENT_HEADER = 'x-goog-api-client';
const SDK_VERSION = '1.5.1'; // x-release-please-version
const LIBRARY_LABEL = `google-genai-sdk/${SDK_VERSION}`;
const VERTEX_AI_API_DEFAULT_VERSION = 'v1beta1';
const GOOGLE_AI_API_DEFAULT_VERSION = 'v1beta';
const responseLineRE = /^data: (.*)(?:\n\n|\r\r|\r\n\r\n)/;
/**
 * Client errors raised by the GenAI API.
 */ class ClientError extends Error {
    constructor(message, stackTrace){
        if (stackTrace) super(message, {
            cause: stackTrace
        });
        else super(message, {
            cause: new Error().stack
        });
        this.message = message;
        this.name = 'ClientError';
    }
}
/**
 * Server errors raised by the GenAI API.
 */ class ServerError extends Error {
    constructor(message, stackTrace){
        if (stackTrace) super(message, {
            cause: stackTrace
        });
        else super(message, {
            cause: new Error().stack
        });
        this.message = message;
        this.name = 'ServerError';
    }
}
/**
 * The ApiClient class is used to send requests to the Gemini API or Vertex AI
 * endpoints.
 */ class ApiClient {
    constructor(opts){
        var _a, _b;
        this.clientOptions = Object.assign(Object.assign({}, opts), {
            project: opts.project,
            location: opts.location,
            apiKey: opts.apiKey,
            vertexai: opts.vertexai
        });
        const initHttpOptions = {};
        if (this.clientOptions.vertexai) {
            initHttpOptions.apiVersion = (_a = this.clientOptions.apiVersion) !== null && _a !== void 0 ? _a : VERTEX_AI_API_DEFAULT_VERSION;
            initHttpOptions.baseUrl = this.baseUrlFromProjectLocation();
            this.normalizeAuthParameters();
        } else {
            // Gemini API
            initHttpOptions.apiVersion = (_b = this.clientOptions.apiVersion) !== null && _b !== void 0 ? _b : GOOGLE_AI_API_DEFAULT_VERSION;
            initHttpOptions.baseUrl = `https://generativelanguage.googleapis.com/`;
        }
        initHttpOptions.headers = this.getDefaultHeaders();
        this.clientOptions.httpOptions = initHttpOptions;
        if (opts.httpOptions) this.clientOptions.httpOptions = this.patchHttpOptions(initHttpOptions, opts.httpOptions);
    }
    /**
     * Determines the base URL for Vertex AI based on project and location.
     * Uses the global endpoint if location is 'global' or if project/location
     * are not specified (implying API key usage).
     * @private
     */ baseUrlFromProjectLocation() {
        if (this.clientOptions.project && this.clientOptions.location && this.clientOptions.location !== 'global') // Regional endpoint
        return `https://${this.clientOptions.location}-aiplatform.googleapis.com/`;
        // Global endpoint (covers 'global' location and API key usage)
        return `https://aiplatform.googleapis.com/`;
    }
    /**
     * Normalizes authentication parameters for Vertex AI.
     * If project and location are provided, API key is cleared.
     * If project and location are not provided (implying API key usage),
     * project and location are cleared.
     * @private
     */ normalizeAuthParameters() {
        if (this.clientOptions.project && this.clientOptions.location) {
            // Using project/location for auth, clear potential API key
            this.clientOptions.apiKey = undefined;
            return;
        }
        // Using API key for auth (or no auth provided yet), clear project/location
        this.clientOptions.project = undefined;
        this.clientOptions.location = undefined;
    }
    isVertexAI() {
        var _a;
        return (_a = this.clientOptions.vertexai) !== null && _a !== void 0 ? _a : false;
    }
    getProject() {
        return this.clientOptions.project;
    }
    getLocation() {
        return this.clientOptions.location;
    }
    getApiVersion() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.apiVersion !== undefined) return this.clientOptions.httpOptions.apiVersion;
        throw new Error('API version is not set.');
    }
    getBaseUrl() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.baseUrl !== undefined) return this.clientOptions.httpOptions.baseUrl;
        throw new Error('Base URL is not set.');
    }
    getRequestUrl() {
        return this.getRequestUrlInternal(this.clientOptions.httpOptions);
    }
    getHeaders() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.headers !== undefined) return this.clientOptions.httpOptions.headers;
        else throw new Error('Headers are not set.');
    }
    getRequestUrlInternal(httpOptions) {
        if (!httpOptions || httpOptions.baseUrl === undefined || httpOptions.apiVersion === undefined) throw new Error('HTTP options are not correctly set.');
        const baseUrl = httpOptions.baseUrl.endsWith('/') ? httpOptions.baseUrl.slice(0, -1) : httpOptions.baseUrl;
        const urlElement = [
            baseUrl
        ];
        if (httpOptions.apiVersion && httpOptions.apiVersion !== '') urlElement.push(httpOptions.apiVersion);
        return urlElement.join('/');
    }
    getBaseResourcePath() {
        return `projects/${this.clientOptions.project}/locations/${this.clientOptions.location}`;
    }
    getApiKey() {
        return this.clientOptions.apiKey;
    }
    getWebsocketBaseUrl() {
        const baseUrl = this.getBaseUrl();
        const urlParts = new URL(baseUrl);
        urlParts.protocol = urlParts.protocol == 'http:' ? 'ws' : 'wss';
        return urlParts.toString();
    }
    setBaseUrl(url) {
        if (this.clientOptions.httpOptions) this.clientOptions.httpOptions.baseUrl = url;
        else throw new Error('HTTP options are not correctly set.');
    }
    constructUrl(path, httpOptions, prependProjectLocation) {
        const urlElement = [
            this.getRequestUrlInternal(httpOptions)
        ];
        if (prependProjectLocation) urlElement.push(this.getBaseResourcePath());
        if (path !== '') urlElement.push(path);
        const url = new URL(`${urlElement.join('/')}`);
        return url;
    }
    shouldPrependVertexProjectPath(request) {
        if (this.clientOptions.apiKey) return false;
        if (!this.clientOptions.vertexai) return false;
        if (request.path.startsWith('projects/')) // Assume the path already starts with
        // `projects/<project>/location/<location>`.
        return false;
        if (request.httpMethod === 'GET' && request.path.startsWith('publishers/google/models')) // These paths are used by Vertex's models.get and models.list
        // calls. For base models Vertex does not accept a project/location
        // prefix (for tuned model the prefix is required).
        return false;
        return true;
    }
    async request(request) {
        let patchedHttpOptions = this.clientOptions.httpOptions;
        if (request.httpOptions) patchedHttpOptions = this.patchHttpOptions(this.clientOptions.httpOptions, request.httpOptions);
        const prependProjectLocation = this.shouldPrependVertexProjectPath(request);
        const url = this.constructUrl(request.path, patchedHttpOptions, prependProjectLocation);
        if (request.queryParams) for (const [key, value] of Object.entries(request.queryParams))url.searchParams.append(key, String(value));
        let requestInit = {};
        if (request.httpMethod === 'GET') {
            if (request.body && request.body !== '{}') throw new Error('Request body should be empty for GET request, but got non empty request body');
        } else requestInit.body = request.body;
        requestInit = await this.includeExtraHttpOptionsToRequestInit(requestInit, patchedHttpOptions, request.abortSignal);
        return this.unaryApiCall(url, requestInit, request.httpMethod);
    }
    patchHttpOptions(baseHttpOptions, requestHttpOptions) {
        const patchedHttpOptions = JSON.parse(JSON.stringify(baseHttpOptions));
        for (const [key, value] of Object.entries(requestHttpOptions)){
            // Records compile to objects.
            if (typeof value === 'object') // @ts-expect-error TS2345TS7053: Element implicitly has an 'any' type
            // because expression of type 'string' can't be used to index type
            // 'HttpOptions'.
            patchedHttpOptions[key] = Object.assign(Object.assign({}, patchedHttpOptions[key]), value);
            else if (value !== undefined) // @ts-expect-error TS2345TS7053: Element implicitly has an 'any' type
            // because expression of type 'string' can't be used to index type
            // 'HttpOptions'.
            patchedHttpOptions[key] = value;
        }
        return patchedHttpOptions;
    }
    async requestStream(request) {
        let patchedHttpOptions = this.clientOptions.httpOptions;
        if (request.httpOptions) patchedHttpOptions = this.patchHttpOptions(this.clientOptions.httpOptions, request.httpOptions);
        const prependProjectLocation = this.shouldPrependVertexProjectPath(request);
        const url = this.constructUrl(request.path, patchedHttpOptions, prependProjectLocation);
        if (!url.searchParams.has('alt') || url.searchParams.get('alt') !== 'sse') url.searchParams.set('alt', 'sse');
        let requestInit = {};
        requestInit.body = request.body;
        requestInit = await this.includeExtraHttpOptionsToRequestInit(requestInit, patchedHttpOptions, request.abortSignal);
        return this.streamApiCall(url, requestInit, request.httpMethod);
    }
    async includeExtraHttpOptionsToRequestInit(requestInit, httpOptions, abortSignal) {
        if (httpOptions && httpOptions.timeout || abortSignal) {
            const abortController = new AbortController();
            const signal = abortController.signal;
            if (httpOptions.timeout && (httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.timeout) > 0) setTimeout(()=>abortController.abort(), httpOptions.timeout);
            if (abortSignal) abortSignal.addEventListener('abort', ()=>{
                abortController.abort();
            });
            requestInit.signal = signal;
        }
        requestInit.headers = await this.getHeadersInternal(httpOptions);
        return requestInit;
    }
    async unaryApiCall(url, requestInit, httpMethod) {
        return this.apiCall(url.toString(), Object.assign(Object.assign({}, requestInit), {
            method: httpMethod
        })).then(async (response)=>{
            await throwErrorIfNotOK(response);
            return new HttpResponse(response);
        }).catch((e)=>{
            if (e instanceof Error) throw e;
            else throw new Error(JSON.stringify(e));
        });
    }
    async streamApiCall(url, requestInit, httpMethod) {
        return this.apiCall(url.toString(), Object.assign(Object.assign({}, requestInit), {
            method: httpMethod
        })).then(async (response)=>{
            await throwErrorIfNotOK(response);
            return this.processStreamResponse(response);
        }).catch((e)=>{
            if (e instanceof Error) throw e;
            else throw new Error(JSON.stringify(e));
        });
    }
    processStreamResponse(response) {
        var _a;
        return __asyncGenerator(this, arguments, function* processStreamResponse_1() {
            const reader = (_a = response === null || response === void 0 ? void 0 : response.body) === null || _a === void 0 ? void 0 : _a.getReader();
            const decoder = new TextDecoder('utf-8');
            if (!reader) throw new Error('Response body is empty');
            try {
                let buffer = '';
                while(true){
                    const { done, value } = yield __await(reader.read());
                    if (done) {
                        if (buffer.trim().length > 0) throw new Error('Incomplete JSON segment at the end');
                        break;
                    }
                    const chunkString = decoder.decode(value);
                    // Parse and throw an error if the chunk contains an error.
                    try {
                        const chunkJson = JSON.parse(chunkString);
                        if ('error' in chunkJson) {
                            const errorJson = JSON.parse(JSON.stringify(chunkJson['error']));
                            const status = errorJson['status'];
                            const code = errorJson['code'];
                            const errorMessage = `got status: ${status}. ${JSON.stringify(chunkJson)}`;
                            if (code >= 400 && code < 500) {
                                const clientError = new ClientError(errorMessage);
                                throw clientError;
                            } else if (code >= 500 && code < 600) {
                                const serverError = new ServerError(errorMessage);
                                throw serverError;
                            }
                        }
                    } catch (e) {
                        const error = e;
                        if (error.name === 'ClientError' || error.name === 'ServerError') throw e;
                    }
                    buffer += chunkString;
                    let match = buffer.match(responseLineRE);
                    while(match){
                        const processedChunkString = match[1];
                        try {
                            const partialResponse = new Response(processedChunkString, {
                                headers: response === null || response === void 0 ? void 0 : response.headers,
                                status: response === null || response === void 0 ? void 0 : response.status,
                                statusText: response === null || response === void 0 ? void 0 : response.statusText
                            });
                            yield yield __await(new HttpResponse(partialResponse));
                            buffer = buffer.slice(match[0].length);
                            match = buffer.match(responseLineRE);
                        } catch (e) {
                            throw new Error(`exception parsing stream chunk ${processedChunkString}. ${e}`);
                        }
                    }
                }
            } finally{
                reader.releaseLock();
            }
        });
    }
    async apiCall(url, requestInit) {
        return fetch(url, requestInit).catch((e)=>{
            throw new Error(`exception ${e} sending request`);
        });
    }
    getDefaultHeaders() {
        const headers = {};
        const versionHeaderValue = LIBRARY_LABEL + ' ' + this.clientOptions.userAgentExtra;
        headers[USER_AGENT_HEADER] = versionHeaderValue;
        headers[GOOGLE_API_CLIENT_HEADER] = versionHeaderValue;
        headers[CONTENT_TYPE_HEADER] = 'application/json';
        return headers;
    }
    async getHeadersInternal(httpOptions) {
        const headers = new Headers();
        if (httpOptions && httpOptions.headers) {
            for (const [key, value] of Object.entries(httpOptions.headers))headers.append(key, value);
            // Append a timeout header if it is set, note that the timeout option is
            // in milliseconds but the header is in seconds.
            if (httpOptions.timeout && httpOptions.timeout > 0) headers.append(SERVER_TIMEOUT_HEADER, String(Math.ceil(httpOptions.timeout / 1000)));
        }
        await this.clientOptions.auth.addAuthHeaders(headers);
        return headers;
    }
    /**
     * Uploads a file asynchronously using Gemini API only, this is not supported
     * in Vertex AI.
     *
     * @param file The string path to the file to be uploaded or a Blob object.
     * @param config Optional parameters specified in the `UploadFileConfig`
     *     interface. @see {@link UploadFileConfig}
     * @return A promise that resolves to a `File` object.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     */ async uploadFile(file, config) {
        var _a;
        const fileToUpload = {};
        if (config != null) {
            fileToUpload.mimeType = config.mimeType;
            fileToUpload.name = config.name;
            fileToUpload.displayName = config.displayName;
        }
        if (fileToUpload.name && !fileToUpload.name.startsWith('files/')) fileToUpload.name = `files/${fileToUpload.name}`;
        const uploader = this.clientOptions.uploader;
        const fileStat = await uploader.stat(file);
        fileToUpload.sizeBytes = String(fileStat.size);
        const mimeType = (_a = config === null || config === void 0 ? void 0 : config.mimeType) !== null && _a !== void 0 ? _a : fileStat.type;
        if (mimeType === undefined || mimeType === '') throw new Error('Can not determine mimeType. Please provide mimeType in the config.');
        fileToUpload.mimeType = mimeType;
        const uploadUrl = await this.fetchUploadUrl(fileToUpload, config);
        return uploader.upload(file, uploadUrl, this);
    }
    /**
     * Downloads a file asynchronously to the specified path.
     *
     * @params params - The parameters for the download request, see {@link
     * DownloadFileParameters}
     */ async downloadFile(params) {
        const downloader = this.clientOptions.downloader;
        await downloader.download(params, this);
    }
    async fetchUploadUrl(file, config) {
        var _a;
        let httpOptions = {};
        if (config === null || config === void 0 ? void 0 : config.httpOptions) httpOptions = config.httpOptions;
        else httpOptions = {
            apiVersion: '',
            headers: {
                'Content-Type': 'application/json',
                'X-Goog-Upload-Protocol': 'resumable',
                'X-Goog-Upload-Command': 'start',
                'X-Goog-Upload-Header-Content-Length': `${file.sizeBytes}`,
                'X-Goog-Upload-Header-Content-Type': `${file.mimeType}`
            }
        };
        const body = {
            'file': file
        };
        const httpResponse = await this.request({
            path: formatMap('upload/v1beta/files', body['_url']),
            body: JSON.stringify(body),
            httpMethod: 'POST',
            httpOptions
        });
        if (!httpResponse || !(httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.headers)) throw new Error('Server did not return an HttpResponse or the returned HttpResponse did not have headers.');
        const uploadUrl = (_a = httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.headers) === null || _a === void 0 ? void 0 : _a['x-goog-upload-url'];
        if (uploadUrl === undefined) throw new Error('Failed to get upload url. Server did not return the x-google-upload-url in the headers');
        return uploadUrl;
    }
}
async function throwErrorIfNotOK(response) {
    var _a;
    if (response === undefined) throw new ServerError('response is undefined');
    if (!response.ok) {
        const status = response.status;
        const statusText = response.statusText;
        let errorBody;
        if ((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) errorBody = await response.json();
        else errorBody = {
            error: {
                message: await response.text(),
                code: response.status,
                status: response.statusText
            }
        };
        const errorMessage = `got status: ${status} ${statusText}. ${JSON.stringify(errorBody)}`;
        if (status >= 400 && status < 500) {
            const clientError = new ClientError(errorMessage);
            throw clientError;
        } else if (status >= 500 && status < 600) {
            const serverError = new ServerError(errorMessage);
            throw serverError;
        }
        throw new Error(errorMessage);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // TODO: b/416041229 - Determine how to retrieve the MCP package version.
const MCP_LABEL = 'mcp_used/unknown';
// Checks whether the list of tools contains any MCP tools.
function hasMcpToolUsage(tools) {
    for (const tool of tools){
        if (isMcpCallableTool(tool)) return true;
        if (typeof tool === 'object' && 'inputSchema' in tool) return true;
    }
    return false;
}
// Sets the MCP version label in the Google API client header.
function setMcpUsageHeader(headers) {
    var _a;
    const existingHeader = (_a = headers[GOOGLE_API_CLIENT_HEADER]) !== null && _a !== void 0 ? _a : '';
    headers[GOOGLE_API_CLIENT_HEADER] = (existingHeader + ` ${MCP_LABEL}`).trimStart();
}
// Checks whether the list of tools contains any MCP clients. Will return true
// if there is at least one MCP client.
function hasMcpClientTools(params) {
    var _a, _b, _c;
    return (_c = (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools) === null || _b === void 0 ? void 0 : _b.some((tool)=>isMcpCallableTool(tool))) !== null && _c !== void 0 ? _c : false;
}
// Checks whether the list of tools contains any non-MCP tools. Will return true
// if there is at least one non-MCP tool.
function hasNonMcpTools(params) {
    var _a, _b, _c;
    return (_c = (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools) === null || _b === void 0 ? void 0 : _b.some((tool)=>!isMcpCallableTool(tool))) !== null && _c !== void 0 ? _c : false;
}
// Returns true if the object is a MCP CallableTool, otherwise false.
function isMcpCallableTool(object) {
    return object !== null && typeof object === 'object' && object instanceof McpCallableTool;
}
// List all tools from the MCP client.
function listAllTools(mcpClient, maxTools = 100) {
    return __asyncGenerator(this, arguments, function* listAllTools_1() {
        let cursor = undefined;
        let numTools = 0;
        while(numTools < maxTools){
            const t = yield __await(mcpClient.listTools({
                cursor
            }));
            for (const tool of t.tools){
                yield yield __await(tool);
                numTools++;
            }
            if (!t.nextCursor) break;
            cursor = t.nextCursor;
        }
    });
}
/**
 * McpCallableTool can be used for model inference and invoking MCP clients with
 * given function call arguments.
 *
 * @experimental Built-in MCP support is an experimental feature, may change in future
 * versions.
 */ class McpCallableTool {
    constructor(mcpClients = [], config){
        this.mcpTools = [];
        this.functionNameToMcpClient = {};
        this.mcpClients = mcpClients;
        this.config = config;
    }
    /**
     * Creates a McpCallableTool.
     */ static create(mcpClients, config) {
        return new McpCallableTool(mcpClients, config);
    }
    /**
     * Validates the function names are not duplicate and initialize the function
     * name to MCP client mapping.
     *
     * @throws {Error} if the MCP tools from the MCP clients have duplicate tool
     *     names.
     */ async initialize() {
        var _a, e_1, _b, _c;
        if (this.mcpTools.length > 0) return;
        const functionMap = {};
        const mcpTools = [];
        for (const mcpClient of this.mcpClients)try {
            for(var _d = true, _e = (e_1 = void 0, __asyncValues(listAllTools(mcpClient))), _f; _f = await _e.next(), _a = _f.done, !_a; _d = true){
                _c = _f.value;
                _d = false;
                const mcpTool = _c;
                mcpTools.push(mcpTool);
                const mcpToolName = mcpTool.name;
                if (functionMap[mcpToolName]) throw new Error(`Duplicate function name ${mcpToolName} found in MCP tools. Please ensure function names are unique.`);
                functionMap[mcpToolName] = mcpClient;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (!_d && !_a && (_b = _e.return)) await _b.call(_e);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.mcpTools = mcpTools;
        this.functionNameToMcpClient = functionMap;
    }
    async tool() {
        await this.initialize();
        return mcpToolsToGeminiTool(this.mcpTools, this.config);
    }
    async callTool(functionCalls) {
        await this.initialize();
        const functionCallResponseParts = [];
        for (const functionCall of functionCalls)if (functionCall.name in this.functionNameToMcpClient) {
            const mcpClient = this.functionNameToMcpClient[functionCall.name];
            let requestOptions = undefined;
            // TODO: b/424238654 - Add support for finer grained timeout control.
            if (this.config.timeout) requestOptions = {
                timeout: this.config.timeout
            };
            const callToolResponse = await mcpClient.callTool({
                name: functionCall.name,
                arguments: functionCall.args
            }, // Set the result schema to undefined to allow MCP to rely on the
            // default schema.
            undefined, requestOptions);
            functionCallResponseParts.push({
                functionResponse: {
                    name: functionCall.name,
                    response: callToolResponse.isError ? {
                        error: callToolResponse
                    } : callToolResponse
                }
            });
        }
        return functionCallResponseParts;
    }
}
function isMcpClient(client) {
    return client !== null && typeof client === 'object' && 'listTools' in client && typeof client.listTools === 'function';
}
/**
 * Creates a McpCallableTool from MCP clients and an optional config.
 *
 * The callable tool can invoke the MCP clients with given function call
 * arguments. (often for automatic function calling).
 * Use the config to modify tool parameters such as behavior.
 *
 * @experimental Built-in MCP support is an experimental feature, may change in future
 * versions.
 */ function mcpToTool(...args) {
    if (args.length === 0) throw new Error('No MCP clients provided');
    const maybeConfig = args[args.length - 1];
    if (isMcpClient(maybeConfig)) return McpCallableTool.create(args, {});
    return McpCallableTool.create(args.slice(0, args.length - 1), maybeConfig);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Handles incoming messages from the WebSocket.
 *
 * @remarks
 * This function is responsible for parsing incoming messages, transforming them
 * into LiveMusicServerMessage, and then calling the onmessage callback.
 * Note that the first message which is received from the server is a
 * setupComplete message.
 *
 * @param apiClient The ApiClient instance.
 * @param onmessage The user-provided onmessage callback (if any).
 * @param event The MessageEvent from the WebSocket.
 */ async function handleWebSocketMessage$1(apiClient, onmessage, event) {
    const serverMessage = new LiveMusicServerMessage();
    let data;
    if (event.data instanceof Blob) data = JSON.parse(await event.data.text());
    else data = JSON.parse(event.data);
    const response = liveMusicServerMessageFromMldev(apiClient, data);
    Object.assign(serverMessage, response);
    onmessage(serverMessage);
}
/**
   LiveMusic class encapsulates the configuration for live music
   generation via Lyria Live models.

   @experimental
  */ class LiveMusic {
    constructor(apiClient, auth, webSocketFactory){
        this.apiClient = apiClient;
        this.auth = auth;
        this.webSocketFactory = webSocketFactory;
    }
    /**
       Establishes a connection to the specified model and returns a
       LiveMusicSession object representing that connection.
  
       @experimental
  
       @remarks
  
       @param params - The parameters for establishing a connection to the model.
       @return A live session.
  
       @example
       ```ts
       let model = 'models/lyria-realtime-exp';
       const session = await ai.live.music.connect({
         model: model,
         callbacks: {
           onmessage: (e: MessageEvent) => {
             console.log('Received message from the server: %s\n', debug(e.data));
           },
           onerror: (e: ErrorEvent) => {
             console.log('Error occurred: %s\n', debug(e.error));
           },
           onclose: (e: CloseEvent) => {
             console.log('Connection closed.');
           },
         },
       });
       ```
      */ async connect(params) {
        var _a, _b;
        if (this.apiClient.isVertexAI()) throw new Error('Live music is not supported for Vertex AI.');
        console.warn('Live music generation is experimental and may change in future versions.');
        const websocketBaseUrl = this.apiClient.getWebsocketBaseUrl();
        const apiVersion = this.apiClient.getApiVersion();
        const headers = mapToHeaders$1(this.apiClient.getDefaultHeaders());
        const apiKey = this.apiClient.getApiKey();
        const url = `${websocketBaseUrl}/ws/google.ai.generativelanguage.${apiVersion}.GenerativeService.BidiGenerateMusic?key=${apiKey}`;
        let onopenResolve = ()=>{};
        const onopenPromise = new Promise((resolve)=>{
            onopenResolve = resolve;
        });
        const callbacks = params.callbacks;
        const onopenAwaitedCallback = function() {
            onopenResolve({});
        };
        const apiClient = this.apiClient;
        const websocketCallbacks = {
            onopen: onopenAwaitedCallback,
            onmessage: (event)=>{
                handleWebSocketMessage$1(apiClient, callbacks.onmessage, event);
            },
            onerror: (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onerror) !== null && _a !== void 0 ? _a : function(e) {},
            onclose: (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onclose) !== null && _b !== void 0 ? _b : function(e) {}
        };
        const conn = this.webSocketFactory.create(url, headersToMap$1(headers), websocketCallbacks);
        conn.connect();
        // Wait for the websocket to open before sending requests.
        await onopenPromise;
        const model = tModel(this.apiClient, params.model);
        const setup = liveMusicClientSetupToMldev(this.apiClient, {
            model
        });
        const clientMessage = liveMusicClientMessageToMldev(this.apiClient, {
            setup
        });
        conn.send(JSON.stringify(clientMessage));
        return new LiveMusicSession(conn, this.apiClient);
    }
}
/**
   Represents a connection to the API.

   @experimental
  */ class LiveMusicSession {
    constructor(conn, apiClient){
        this.conn = conn;
        this.apiClient = apiClient;
    }
    /**
      Sets inputs to steer music generation. Updates the session's current
      weighted prompts.
  
      @param params - Contains one property, `weightedPrompts`.
  
        - `weightedPrompts` to send to the model; weights are normalized to
          sum to 1.0.
  
      @experimental
     */ async setWeightedPrompts(params) {
        if (!params.weightedPrompts || Object.keys(params.weightedPrompts).length === 0) throw new Error('Weighted prompts must be set and contain at least one entry.');
        const setWeightedPromptsParameters = liveMusicSetWeightedPromptsParametersToMldev(this.apiClient, params);
        const clientContent = liveMusicClientContentToMldev(this.apiClient, setWeightedPromptsParameters);
        this.conn.send(JSON.stringify({
            clientContent
        }));
    }
    /**
      Sets a configuration to the model. Updates the session's current
      music generation config.
  
      @param params - Contains one property, `musicGenerationConfig`.
  
        - `musicGenerationConfig` to set in the model. Passing an empty or
      undefined config to the model will reset the config to defaults.
  
      @experimental
     */ async setMusicGenerationConfig(params) {
        if (!params.musicGenerationConfig) params.musicGenerationConfig = {};
        const setConfigParameters = liveMusicSetConfigParametersToMldev(this.apiClient, params);
        const clientMessage = liveMusicClientMessageToMldev(this.apiClient, setConfigParameters);
        this.conn.send(JSON.stringify(clientMessage));
    }
    sendPlaybackControl(playbackControl) {
        const clientMessage = liveMusicClientMessageToMldev(this.apiClient, {
            playbackControl
        });
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
     * Start the music stream.
     *
     * @experimental
     */ play() {
        this.sendPlaybackControl(LiveMusicPlaybackControl.PLAY);
    }
    /**
     * Temporarily halt the music stream. Use `play` to resume from the current
     * position.
     *
     * @experimental
     */ pause() {
        this.sendPlaybackControl(LiveMusicPlaybackControl.PAUSE);
    }
    /**
     * Stop the music stream and reset the state. Retains the current prompts
     * and config.
     *
     * @experimental
     */ stop() {
        this.sendPlaybackControl(LiveMusicPlaybackControl.STOP);
    }
    /**
     * Resets the context of the music generation without stopping it.
     * Retains the current prompts and config.
     *
     * @experimental
     */ resetContext() {
        this.sendPlaybackControl(LiveMusicPlaybackControl.RESET_CONTEXT);
    }
    /**
       Terminates the WebSocket connection.
  
       @experimental
     */ close() {
        this.conn.close();
    }
}
// Converts an headers object to a "map" object as expected by the WebSocket
// constructor. We use this as the Auth interface works with Headers objects
// while the WebSocket constructor takes a map.
function headersToMap$1(headers) {
    const headerMap = {};
    headers.forEach((value, key)=>{
        headerMap[key] = value;
    });
    return headerMap;
}
// Converts a "map" object to a headers object. We use this as the Auth
// interface works with Headers objects while the API client default headers
// returns a map.
function mapToHeaders$1(map) {
    const headers = new Headers();
    for (const [key, value] of Object.entries(map))headers.append(key, value);
    return headers;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const FUNCTION_RESPONSE_REQUIRES_ID = 'FunctionResponse request must have an `id` field from the response of a ToolCall.FunctionalCalls in Google AI.';
/**
 * Handles incoming messages from the WebSocket.
 *
 * @remarks
 * This function is responsible for parsing incoming messages, transforming them
 * into LiveServerMessages, and then calling the onmessage callback. Note that
 * the first message which is received from the server is a setupComplete
 * message.
 *
 * @param apiClient The ApiClient instance.
 * @param onmessage The user-provided onmessage callback (if any).
 * @param event The MessageEvent from the WebSocket.
 */ async function handleWebSocketMessage(apiClient, onmessage, event) {
    const serverMessage = new LiveServerMessage();
    let data;
    if (event.data instanceof Blob) data = JSON.parse(await event.data.text());
    else data = JSON.parse(event.data);
    if (apiClient.isVertexAI()) {
        const resp = liveServerMessageFromVertex(apiClient, data);
        Object.assign(serverMessage, resp);
    } else {
        const resp = liveServerMessageFromMldev(apiClient, data);
        Object.assign(serverMessage, resp);
    }
    onmessage(serverMessage);
}
/**
   Live class encapsulates the configuration for live interaction with the
   Generative Language API. It embeds ApiClient for general API settings.

   @experimental
  */ class Live {
    constructor(apiClient, auth, webSocketFactory){
        this.apiClient = apiClient;
        this.auth = auth;
        this.webSocketFactory = webSocketFactory;
        this.music = new LiveMusic(this.apiClient, this.auth, this.webSocketFactory);
    }
    /**
       Establishes a connection to the specified model with the given
       configuration and returns a Session object representing that connection.
  
       @experimental Built-in MCP support is an experimental feature, may change in
       future versions.
  
       @remarks
  
       @param params - The parameters for establishing a connection to the model.
       @return A live session.
  
       @example
       ```ts
       let model: string;
       if (GOOGLE_GENAI_USE_VERTEXAI) {
         model = 'gemini-2.0-flash-live-preview-04-09';
       } else {
         model = 'gemini-2.0-flash-live-001';
       }
       const session = await ai.live.connect({
         model: model,
         config: {
           responseModalities: [Modality.AUDIO],
         },
         callbacks: {
           onopen: () => {
             console.log('Connected to the socket.');
           },
           onmessage: (e: MessageEvent) => {
             console.log('Received message from the server: %s\n', debug(e.data));
           },
           onerror: (e: ErrorEvent) => {
             console.log('Error occurred: %s\n', debug(e.error));
           },
           onclose: (e: CloseEvent) => {
             console.log('Connection closed.');
           },
         },
       });
       ```
      */ async connect(params) {
        var _a, _b, _c, _d, _e, _f;
        const websocketBaseUrl = this.apiClient.getWebsocketBaseUrl();
        const apiVersion = this.apiClient.getApiVersion();
        let url;
        const defaultHeaders = this.apiClient.getDefaultHeaders();
        if (params.config && params.config.tools && hasMcpToolUsage(params.config.tools)) setMcpUsageHeader(defaultHeaders);
        const headers = mapToHeaders(defaultHeaders);
        if (this.apiClient.isVertexAI()) {
            url = `${websocketBaseUrl}/ws/google.cloud.aiplatform.${apiVersion}.LlmBidiService/BidiGenerateContent`;
            await this.auth.addAuthHeaders(headers);
        } else {
            const apiKey = this.apiClient.getApiKey();
            let method = 'BidiGenerateContent';
            let keyName = 'key';
            if (apiKey === null || apiKey === void 0 ? void 0 : apiKey.startsWith('auth_tokens/')) {
                console.warn('Warning: Ephemeral token support is experimental and may change in future versions.');
                method = 'BidiGenerateContentConstrained';
                keyName = 'access_token';
            }
            url = `${websocketBaseUrl}/ws/google.ai.generativelanguage.${apiVersion}.GenerativeService.${method}?${keyName}=${apiKey}`;
        }
        let onopenResolve = ()=>{};
        const onopenPromise = new Promise((resolve)=>{
            onopenResolve = resolve;
        });
        const callbacks = params.callbacks;
        const onopenAwaitedCallback = function() {
            var _a;
            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onopen) === null || _a === void 0 || _a.call(callbacks);
            onopenResolve({});
        };
        const apiClient = this.apiClient;
        const websocketCallbacks = {
            onopen: onopenAwaitedCallback,
            onmessage: (event)=>{
                handleWebSocketMessage(apiClient, callbacks.onmessage, event);
            },
            onerror: (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onerror) !== null && _a !== void 0 ? _a : function(e) {},
            onclose: (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onclose) !== null && _b !== void 0 ? _b : function(e) {}
        };
        const conn = this.webSocketFactory.create(url, headersToMap(headers), websocketCallbacks);
        conn.connect();
        // Wait for the websocket to open before sending requests.
        await onopenPromise;
        let transformedModel = tModel(this.apiClient, params.model);
        if (this.apiClient.isVertexAI() && transformedModel.startsWith('publishers/')) {
            const project = this.apiClient.getProject();
            const location = this.apiClient.getLocation();
            transformedModel = `projects/${project}/locations/${location}/` + transformedModel;
        }
        let clientMessage = {};
        if (this.apiClient.isVertexAI() && ((_c = params.config) === null || _c === void 0 ? void 0 : _c.responseModalities) === undefined) {
            // Set default to AUDIO to align with MLDev API.
            if (params.config === undefined) params.config = {
                responseModalities: [
                    Modality.AUDIO
                ]
            };
            else params.config.responseModalities = [
                Modality.AUDIO
            ];
        }
        if ((_d = params.config) === null || _d === void 0 ? void 0 : _d.generationConfig) // Raise deprecation warning for generationConfig.
        console.warn('Setting `LiveConnectConfig.generation_config` is deprecated, please set the fields on `LiveConnectConfig` directly. This will become an error in a future version (not before Q3 2025).');
        const inputTools = (_f = (_e = params.config) === null || _e === void 0 ? void 0 : _e.tools) !== null && _f !== void 0 ? _f : [];
        const convertedTools = [];
        for (const tool of inputTools)if (this.isCallableTool(tool)) {
            const callableTool = tool;
            convertedTools.push(await callableTool.tool());
        } else convertedTools.push(tool);
        if (convertedTools.length > 0) params.config.tools = convertedTools;
        const liveConnectParameters = {
            model: transformedModel,
            config: params.config,
            callbacks: params.callbacks
        };
        if (this.apiClient.isVertexAI()) clientMessage = liveConnectParametersToVertex(this.apiClient, liveConnectParameters);
        else clientMessage = liveConnectParametersToMldev(this.apiClient, liveConnectParameters);
        delete clientMessage['config'];
        conn.send(JSON.stringify(clientMessage));
        return new Session(conn, this.apiClient);
    }
    // TODO: b/416041229 - Abstract this method to a common place.
    isCallableTool(tool) {
        return 'callTool' in tool && typeof tool.callTool === 'function';
    }
}
const defaultLiveSendClientContentParamerters = {
    turnComplete: true
};
/**
   Represents a connection to the API.

   @experimental
  */ class Session {
    constructor(conn, apiClient){
        this.conn = conn;
        this.apiClient = apiClient;
    }
    tLiveClientContent(apiClient, params) {
        if (params.turns !== null && params.turns !== undefined) {
            let contents = [];
            try {
                contents = tContents(apiClient, params.turns);
                if (apiClient.isVertexAI()) contents = contents.map((item)=>contentToVertex(apiClient, item));
                else contents = contents.map((item)=>contentToMldev$1(apiClient, item));
            } catch (_a) {
                throw new Error(`Failed to parse client content "turns", type: '${typeof params.turns}'`);
            }
            return {
                clientContent: {
                    turns: contents,
                    turnComplete: params.turnComplete
                }
            };
        }
        return {
            clientContent: {
                turnComplete: params.turnComplete
            }
        };
    }
    tLiveClienttToolResponse(apiClient, params) {
        let functionResponses = [];
        if (params.functionResponses == null) throw new Error('functionResponses is required.');
        if (!Array.isArray(params.functionResponses)) functionResponses = [
            params.functionResponses
        ];
        else functionResponses = params.functionResponses;
        if (functionResponses.length === 0) throw new Error('functionResponses is required.');
        for (const functionResponse of functionResponses){
            if (typeof functionResponse !== 'object' || functionResponse === null || !('name' in functionResponse) || !('response' in functionResponse)) throw new Error(`Could not parse function response, type '${typeof functionResponse}'.`);
            if (!apiClient.isVertexAI() && !('id' in functionResponse)) throw new Error(FUNCTION_RESPONSE_REQUIRES_ID);
        }
        const clientMessage = {
            toolResponse: {
                functionResponses: functionResponses
            }
        };
        return clientMessage;
    }
    /**
      Send a message over the established connection.
  
      @param params - Contains two **optional** properties, `turns` and
          `turnComplete`.
  
        - `turns` will be converted to a `Content[]`
        - `turnComplete: true` [default] indicates that you are done sending
          content and expect a response. If `turnComplete: false`, the server
          will wait for additional messages before starting generation.
  
      @experimental
  
      @remarks
      There are two ways to send messages to the live API:
      `sendClientContent` and `sendRealtimeInput`.
  
      `sendClientContent` messages are added to the model context **in order**.
      Having a conversation using `sendClientContent` messages is roughly
      equivalent to using the `Chat.sendMessageStream`, except that the state of
      the `chat` history is stored on the API server instead of locally.
  
      Because of `sendClientContent`'s order guarantee, the model cannot respons
      as quickly to `sendClientContent` messages as to `sendRealtimeInput`
      messages. This makes the biggest difference when sending objects that have
      significant preprocessing time (typically images).
  
      The `sendClientContent` message sends a `Content[]`
      which has more options than the `Blob` sent by `sendRealtimeInput`.
  
      So the main use-cases for `sendClientContent` over `sendRealtimeInput` are:
  
      - Sending anything that can't be represented as a `Blob` (text,
      `sendClientContent({turns="Hello?"}`)).
      - Managing turns when not using audio input and voice activity detection.
        (`sendClientContent({turnComplete:true})` or the short form
      `sendClientContent()`)
      - Prefilling a conversation context
        ```
        sendClientContent({
            turns: [
              Content({role:user, parts:...}),
              Content({role:user, parts:...}),
              ...
            ]
        })
        ```
      @experimental
     */ sendClientContent(params) {
        params = Object.assign(Object.assign({}, defaultLiveSendClientContentParamerters), params);
        const clientMessage = this.tLiveClientContent(this.apiClient, params);
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
      Send a realtime message over the established connection.
  
      @param params - Contains one property, `media`.
  
        - `media` will be converted to a `Blob`
  
      @experimental
  
      @remarks
      Use `sendRealtimeInput` for realtime audio chunks and video frames (images).
  
      With `sendRealtimeInput` the api will respond to audio automatically
      based on voice activity detection (VAD).
  
      `sendRealtimeInput` is optimized for responsivness at the expense of
      deterministic ordering guarantees. Audio and video tokens are to the
      context when they become available.
  
      Note: The Call signature expects a `Blob` object, but only a subset
      of audio and image mimetypes are allowed.
     */ sendRealtimeInput(params) {
        let clientMessage = {};
        if (this.apiClient.isVertexAI()) clientMessage = {
            'realtimeInput': liveSendRealtimeInputParametersToVertex(this.apiClient, params)
        };
        else clientMessage = {
            'realtimeInput': liveSendRealtimeInputParametersToMldev(this.apiClient, params)
        };
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
      Send a function response message over the established connection.
  
      @param params - Contains property `functionResponses`.
  
        - `functionResponses` will be converted to a `functionResponses[]`
  
      @remarks
      Use `sendFunctionResponse` to reply to `LiveServerToolCall` from the server.
  
      Use {@link types.LiveConnectConfig#tools} to configure the callable functions.
  
      @experimental
     */ sendToolResponse(params) {
        if (params.functionResponses == null) throw new Error('Tool response parameters are required.');
        const clientMessage = this.tLiveClienttToolResponse(this.apiClient, params);
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
       Terminates the WebSocket connection.
  
       @experimental
  
       @example
       ```ts
       let model: string;
       if (GOOGLE_GENAI_USE_VERTEXAI) {
         model = 'gemini-2.0-flash-live-preview-04-09';
       } else {
         model = 'gemini-2.0-flash-live-001';
       }
       const session = await ai.live.connect({
         model: model,
         config: {
           responseModalities: [Modality.AUDIO],
         }
       });
  
       session.close();
       ```
     */ close() {
        this.conn.close();
    }
}
// Converts an headers object to a "map" object as expected by the WebSocket
// constructor. We use this as the Auth interface works with Headers objects
// while the WebSocket constructor takes a map.
function headersToMap(headers) {
    const headerMap = {};
    headers.forEach((value, key)=>{
        headerMap[key] = value;
    });
    return headerMap;
}
// Converts a "map" object to a headers object. We use this as the Auth
// interface works with Headers objects while the API client default headers
// returns a map.
function mapToHeaders(map) {
    const headers = new Headers();
    for (const [key, value] of Object.entries(map))headers.append(key, value);
    return headers;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const DEFAULT_MAX_REMOTE_CALLS = 10;
/** Returns whether automatic function calling is disabled. */ function shouldDisableAfc(config) {
    var _a, _b, _c;
    if ((_a = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _a === void 0 ? void 0 : _a.disable) return true;
    let callableToolsPresent = false;
    for (const tool of (_b = config === null || config === void 0 ? void 0 : config.tools) !== null && _b !== void 0 ? _b : [])if (isCallableTool(tool)) {
        callableToolsPresent = true;
        break;
    }
    if (!callableToolsPresent) return true;
    const maxCalls = (_c = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _c === void 0 ? void 0 : _c.maximumRemoteCalls;
    if (maxCalls && (maxCalls < 0 || !Number.isInteger(maxCalls)) || maxCalls == 0) {
        console.warn('Invalid maximumRemoteCalls value provided for automatic function calling. Disabled automatic function calling. Please provide a valid integer value greater than 0. maximumRemoteCalls provided:', maxCalls);
        return true;
    }
    return false;
}
function isCallableTool(tool) {
    return 'callTool' in tool && typeof tool.callTool === 'function';
}
/**
 * Returns whether to append automatic function calling history to the
 * response.
 */ function shouldAppendAfcHistory(config) {
    var _a;
    return !((_a = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _a === void 0 ? void 0 : _a.ignoreCallHistory);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class Models extends BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Makes an API request to generate content with a given model.
         *
         * For the `model` parameter, supported formats for Vertex AI API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The full resource name starts with 'projects/', for example:
         *  'projects/my-project-id/locations/us-central1/publishers/google/models/gemini-2.0-flash'
         * - The partial resource name with 'publishers/', for example:
         *  'publishers/google/models/gemini-2.0-flash' or
         *  'publishers/meta/models/llama-3.1-405b-instruct-maas'
         * - `/` separated publisher and model name, for example:
         * 'google/gemini-2.0-flash' or 'meta/llama-3.1-405b-instruct-maas'
         *
         * For the `model` parameter, supported formats for Gemini API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The model name starts with 'models/', for example:
         *  'models/gemini-2.0-flash'
         * - For tuned models, the model name starts with 'tunedModels/',
         * for example:
         * 'tunedModels/1234567890123456789'
         *
         * Some models support multimodal input and output.
         *
         * @param params - The parameters for generating content.
         * @return The response from generating content.
         *
         * @example
         * ```ts
         * const response = await ai.models.generateContent({
         *   model: 'gemini-2.0-flash',
         *   contents: 'why is the sky blue?',
         *   config: {
         *     candidateCount: 2,
         *   }
         * });
         * console.log(response);
         * ```
         */ this.generateContent = async (params)=>{
            var _a, _b, _c, _d, _e;
            const transformedParams = await this.processParamsForMcpUsage(params);
            if (!hasMcpClientTools(params) || shouldDisableAfc(params.config)) return await this.generateContentInternal(transformedParams);
            if (hasNonMcpTools(params)) throw new Error('Automatic function calling with CallableTools and Tools is not yet supported.');
            let response;
            let functionResponseContent;
            const automaticFunctionCallingHistory = tContents(this.apiClient, transformedParams.contents);
            const maxRemoteCalls = (_c = (_b = (_a = transformedParams.config) === null || _a === void 0 ? void 0 : _a.automaticFunctionCalling) === null || _b === void 0 ? void 0 : _b.maximumRemoteCalls) !== null && _c !== void 0 ? _c : DEFAULT_MAX_REMOTE_CALLS;
            let remoteCalls = 0;
            while(remoteCalls < maxRemoteCalls){
                response = await this.generateContentInternal(transformedParams);
                if (!response.functionCalls || response.functionCalls.length === 0) break;
                const responseContent = response.candidates[0].content;
                const functionResponseParts = [];
                for (const tool of (_e = (_d = params.config) === null || _d === void 0 ? void 0 : _d.tools) !== null && _e !== void 0 ? _e : [])if (isCallableTool(tool)) {
                    const callableTool = tool;
                    const parts = await callableTool.callTool(response.functionCalls);
                    functionResponseParts.push(...parts);
                }
                remoteCalls++;
                functionResponseContent = {
                    role: 'user',
                    parts: functionResponseParts
                };
                transformedParams.contents = tContents(this.apiClient, transformedParams.contents);
                transformedParams.contents.push(responseContent);
                transformedParams.contents.push(functionResponseContent);
                if (shouldAppendAfcHistory(transformedParams.config)) {
                    automaticFunctionCallingHistory.push(responseContent);
                    automaticFunctionCallingHistory.push(functionResponseContent);
                }
            }
            if (shouldAppendAfcHistory(transformedParams.config)) response.automaticFunctionCallingHistory = automaticFunctionCallingHistory;
            return response;
        };
        /**
         * Makes an API request to generate content with a given model and yields the
         * response in chunks.
         *
         * For the `model` parameter, supported formats for Vertex AI API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The full resource name starts with 'projects/', for example:
         *  'projects/my-project-id/locations/us-central1/publishers/google/models/gemini-2.0-flash'
         * - The partial resource name with 'publishers/', for example:
         *  'publishers/google/models/gemini-2.0-flash' or
         *  'publishers/meta/models/llama-3.1-405b-instruct-maas'
         * - `/` separated publisher and model name, for example:
         * 'google/gemini-2.0-flash' or 'meta/llama-3.1-405b-instruct-maas'
         *
         * For the `model` parameter, supported formats for Gemini API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The model name starts with 'models/', for example:
         *  'models/gemini-2.0-flash'
         * - For tuned models, the model name starts with 'tunedModels/',
         * for example:
         *  'tunedModels/1234567890123456789'
         *
         * Some models support multimodal input and output.
         *
         * @param params - The parameters for generating content with streaming response.
         * @return The response from generating content.
         *
         * @example
         * ```ts
         * const response = await ai.models.generateContentStream({
         *   model: 'gemini-2.0-flash',
         *   contents: 'why is the sky blue?',
         *   config: {
         *     maxOutputTokens: 200,
         *   }
         * });
         * for await (const chunk of response) {
         *   console.log(chunk);
         * }
         * ```
         */ this.generateContentStream = async (params)=>{
            if (shouldDisableAfc(params.config)) {
                const transformedParams = await this.processParamsForMcpUsage(params);
                return await this.generateContentStreamInternal(transformedParams);
            } else return await this.processAfcStream(params);
        };
        /**
         * Generates an image based on a text description and configuration.
         *
         * @param params - The parameters for generating images.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.generateImages({
         *  model: 'imagen-3.0-generate-002',
         *  prompt: 'Robot holding a red skateboard',
         *  config: {
         *    numberOfImages: 1,
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.generateImages = async (params)=>{
            return await this.generateImagesInternal(params).then((apiResponse)=>{
                var _a;
                let positivePromptSafetyAttributes;
                const generatedImages = [];
                if (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.generatedImages) {
                    for (const generatedImage of apiResponse.generatedImages)if (generatedImage && (generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes) && ((_a = generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes) === null || _a === void 0 ? void 0 : _a.contentType) === 'Positive Prompt') positivePromptSafetyAttributes = generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes;
                    else generatedImages.push(generatedImage);
                }
                let response;
                if (positivePromptSafetyAttributes) response = {
                    generatedImages: generatedImages,
                    positivePromptSafetyAttributes: positivePromptSafetyAttributes
                };
                else response = {
                    generatedImages: generatedImages
                };
                return response;
            });
        };
        this.list = async (params)=>{
            var _a;
            const defaultConfig = {
                queryBase: true
            };
            const actualConfig = Object.assign(Object.assign({}, defaultConfig), params === null || params === void 0 ? void 0 : params.config);
            const actualParams = {
                config: actualConfig
            };
            if (this.apiClient.isVertexAI()) {
                if (!actualParams.config.queryBase) {
                    if ((_a = actualParams.config) === null || _a === void 0 ? void 0 : _a.filter) throw new Error('Filtering tuned models list for Vertex AI is not currently supported');
                    else actualParams.config.filter = 'labels.tune-type:*';
                }
            }
            return new Pager(PagedItem.PAGED_ITEM_MODELS, (x)=>this.listInternal(x), await this.listInternal(actualParams), actualParams);
        };
        /**
         * Edits an image based on a prompt, list of reference images, and configuration.
         *
         * @param params - The parameters for editing an image.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.editImage({
         *  model: 'imagen-3.0-capability-001',
         *  prompt: 'Generate an image containing a mug with the product logo [1] visible on the side of the mug.',
         *  referenceImages: [subjectReferenceImage]
         *  config: {
         *    numberOfImages: 1,
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.editImage = async (params)=>{
            const paramsInternal = {
                model: params.model,
                prompt: params.prompt,
                referenceImages: [],
                config: params.config
            };
            if (params.referenceImages) {
                if (params.referenceImages) paramsInternal.referenceImages = params.referenceImages.map((img)=>img.toReferenceImageAPI());
            }
            return await this.editImageInternal(paramsInternal);
        };
        /**
         * Upscales an image based on an image, upscale factor, and configuration.
         * Only supported in Vertex AI currently.
         *
         * @param params - The parameters for upscaling an image.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.upscaleImage({
         *  model: 'imagen-3.0-generate-002',
         *  image: image,
         *  upscaleFactor: 'x2',
         *  config: {
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.upscaleImage = async (params)=>{
            let apiConfig = {
                numberOfImages: 1,
                mode: 'upscale'
            };
            if (params.config) apiConfig = Object.assign(Object.assign({}, apiConfig), params.config);
            const apiParams = {
                model: params.model,
                image: params.image,
                upscaleFactor: params.upscaleFactor,
                config: apiConfig
            };
            return await this.upscaleImageInternal(apiParams);
        };
    }
    /**
     * Transforms the CallableTools in the parameters to be simply Tools, it
     * copies the params into a new object and replaces the tools, it does not
     * modify the original params. Also sets the MCP usage header if there are
     * MCP tools in the parameters.
     */ async processParamsForMcpUsage(params) {
        var _a, _b, _c;
        const tools = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools;
        if (!tools) return params;
        const transformedTools = await Promise.all(tools.map(async (tool)=>{
            if (isCallableTool(tool)) {
                const callableTool = tool;
                return await callableTool.tool();
            }
            return tool;
        }));
        const newParams = {
            model: params.model,
            contents: params.contents,
            config: Object.assign(Object.assign({}, params.config), {
                tools: transformedTools
            })
        };
        newParams.config.tools = transformedTools;
        if (params.config && params.config.tools && hasMcpToolUsage(params.config.tools)) {
            const headers = (_c = (_b = params.config.httpOptions) === null || _b === void 0 ? void 0 : _b.headers) !== null && _c !== void 0 ? _c : {};
            let newHeaders = Object.assign({}, headers);
            if (Object.keys(newHeaders).length === 0) newHeaders = this.apiClient.getDefaultHeaders();
            setMcpUsageHeader(newHeaders);
            newParams.config.httpOptions = Object.assign(Object.assign({}, params.config.httpOptions), {
                headers: newHeaders
            });
        }
        return newParams;
    }
    async initAfcToolsMap(params) {
        var _a, _b, _c;
        const afcTools = new Map();
        for (const tool of (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools) !== null && _b !== void 0 ? _b : [])if (isCallableTool(tool)) {
            const callableTool = tool;
            const toolDeclaration = await callableTool.tool();
            for (const declaration of (_c = toolDeclaration.functionDeclarations) !== null && _c !== void 0 ? _c : []){
                if (!declaration.name) throw new Error('Function declaration name is required.');
                if (afcTools.has(declaration.name)) throw new Error(`Duplicate tool declaration name: ${declaration.name}`);
                afcTools.set(declaration.name, callableTool);
            }
        }
        return afcTools;
    }
    async processAfcStream(params) {
        var _a, _b, _c;
        const maxRemoteCalls = (_c = (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.automaticFunctionCalling) === null || _b === void 0 ? void 0 : _b.maximumRemoteCalls) !== null && _c !== void 0 ? _c : DEFAULT_MAX_REMOTE_CALLS;
        let wereFunctionsCalled = false;
        let remoteCallCount = 0;
        const afcToolsMap = await this.initAfcToolsMap(params);
        return function(models, afcTools, params) {
            var _a, _b;
            return __asyncGenerator(this, arguments, function*() {
                var _c, e_1, _d, _e;
                while(remoteCallCount < maxRemoteCalls){
                    if (wereFunctionsCalled) {
                        remoteCallCount++;
                        wereFunctionsCalled = false;
                    }
                    const transformedParams = yield __await(models.processParamsForMcpUsage(params));
                    const response = yield __await(models.generateContentStreamInternal(transformedParams));
                    const functionResponses = [];
                    const responseContents = [];
                    try {
                        for(var _f = true, response_1 = (e_1 = void 0, __asyncValues(response)), response_1_1; response_1_1 = yield __await(response_1.next()), _c = response_1_1.done, !_c; _f = true){
                            _e = response_1_1.value;
                            _f = false;
                            const chunk = _e;
                            yield yield __await(chunk);
                            if (chunk.candidates && ((_a = chunk.candidates[0]) === null || _a === void 0 ? void 0 : _a.content)) {
                                responseContents.push(chunk.candidates[0].content);
                                for (const part of (_b = chunk.candidates[0].content.parts) !== null && _b !== void 0 ? _b : [])if (remoteCallCount < maxRemoteCalls && part.functionCall) {
                                    if (!part.functionCall.name) throw new Error('Function call name was not returned by the model.');
                                    if (!afcTools.has(part.functionCall.name)) throw new Error(`Automatic function calling was requested, but not all the tools the model used implement the CallableTool interface. Available tools: ${afcTools.keys()}, mising tool: ${part.functionCall.name}`);
                                    else {
                                        const responseParts = yield __await(afcTools.get(part.functionCall.name).callTool([
                                            part.functionCall
                                        ]));
                                        functionResponses.push(...responseParts);
                                    }
                                }
                            }
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (!_f && !_c && (_d = response_1.return)) yield __await(_d.call(response_1));
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (functionResponses.length > 0) {
                        wereFunctionsCalled = true;
                        const typedResponseChunk = new GenerateContentResponse();
                        typedResponseChunk.candidates = [
                            {
                                content: {
                                    role: 'user',
                                    parts: functionResponses
                                }
                            }
                        ];
                        yield yield __await(typedResponseChunk);
                        const newContents = [];
                        newContents.push(...responseContents);
                        newContents.push({
                            role: 'user',
                            parts: functionResponses
                        });
                        const updatedContents = tContents(models.apiClient, params.contents).concat(newContents);
                        params.contents = updatedContents;
                    } else break;
                }
            });
        }(this, afcToolsMap, params);
    }
    async generateContentInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = generateContentParametersToVertex(this.apiClient, params);
            path = formatMap('{model}:generateContent', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = generateContentResponseFromVertex(this.apiClient, apiResponse);
                const typedResp = new GenerateContentResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = generateContentParametersToMldev(this.apiClient, params);
            path = formatMap('{model}:generateContent', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = generateContentResponseFromMldev(this.apiClient, apiResponse);
                const typedResp = new GenerateContentResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async generateContentStreamInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = generateContentParametersToVertex(this.apiClient, params);
            path = formatMap('{model}:streamGenerateContent?alt=sse', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            const apiClient = this.apiClient;
            response = apiClient.requestStream({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
            return response.then(function(apiResponse) {
                return __asyncGenerator(this, arguments, function*() {
                    var _a, e_2, _b, _c;
                    try {
                        for(var _d = true, apiResponse_1 = __asyncValues(apiResponse), apiResponse_1_1; apiResponse_1_1 = yield __await(apiResponse_1.next()), _a = apiResponse_1_1.done, !_a; _d = true){
                            _c = apiResponse_1_1.value;
                            _d = false;
                            const chunk = _c;
                            const resp = generateContentResponseFromVertex(apiClient, (yield __await(chunk.json())));
                            const typedResp = new GenerateContentResponse();
                            Object.assign(typedResp, resp);
                            yield yield __await(typedResp);
                        }
                    } catch (e_2_1) {
                        e_2 = {
                            error: e_2_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = apiResponse_1.return)) yield __await(_b.call(apiResponse_1));
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                    }
                });
            });
        } else {
            const body = generateContentParametersToMldev(this.apiClient, params);
            path = formatMap('{model}:streamGenerateContent?alt=sse', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            const apiClient = this.apiClient;
            response = apiClient.requestStream({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            });
            return response.then(function(apiResponse) {
                return __asyncGenerator(this, arguments, function*() {
                    var _a, e_3, _b, _c;
                    try {
                        for(var _d = true, apiResponse_2 = __asyncValues(apiResponse), apiResponse_2_1; apiResponse_2_1 = yield __await(apiResponse_2.next()), _a = apiResponse_2_1.done, !_a; _d = true){
                            _c = apiResponse_2_1.value;
                            _d = false;
                            const chunk = _c;
                            const resp = generateContentResponseFromMldev(apiClient, (yield __await(chunk.json())));
                            const typedResp = new GenerateContentResponse();
                            Object.assign(typedResp, resp);
                            yield yield __await(typedResp);
                        }
                    } catch (e_3_1) {
                        e_3 = {
                            error: e_3_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = apiResponse_2.return)) yield __await(_b.call(apiResponse_2));
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                    }
                });
            });
        }
    }
    /**
     * Calculates embeddings for the given contents. Only text is supported.
     *
     * @param params - The parameters for embedding contents.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.embedContent({
     *  model: 'text-embedding-004',
     *  contents: [
     *    'What is your name?',
     *    'What is your favorite color?',
     *  ],
     *  config: {
     *    outputDimensionality: 64,
     *  },
     * });
     * console.log(response);
     * ```
     */ async embedContent(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = embedContentParametersToVertex(this.apiClient, params);
            path = formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = embedContentResponseFromVertex(this.apiClient, apiResponse);
                const typedResp = new EmbedContentResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = embedContentParametersToMldev(this.apiClient, params);
            path = formatMap('{model}:batchEmbedContents', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = embedContentResponseFromMldev(this.apiClient, apiResponse);
                const typedResp = new EmbedContentResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Generates an image based on a text description and configuration.
     *
     * @param params - The parameters for generating images.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateImages({
     *  model: 'imagen-3.0-generate-002',
     *  prompt: 'Robot holding a red skateboard',
     *  config: {
     *    numberOfImages: 1,
     *    includeRaiReason: true,
     *  },
     * });
     * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
     * ```
     */ async generateImagesInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = generateImagesParametersToVertex(this.apiClient, params);
            path = formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = generateImagesResponseFromVertex(this.apiClient, apiResponse);
                const typedResp = new GenerateImagesResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = generateImagesParametersToMldev(this.apiClient, params);
            path = formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = generateImagesResponseFromMldev(this.apiClient, apiResponse);
                const typedResp = new GenerateImagesResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async editImageInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = editImageParametersInternalToVertex(this.apiClient, params);
            path = formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = editImageResponseFromVertex(this.apiClient, apiResponse);
                const typedResp = new EditImageResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    async upscaleImageInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = upscaleImageAPIParametersInternalToVertex(this.apiClient, params);
            path = formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = upscaleImageResponseFromVertex(this.apiClient, apiResponse);
                const typedResp = new UpscaleImageResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Fetches information about a model by name.
     *
     * @example
     * ```ts
     * const modelInfo = await ai.models.get({model: 'gemini-2.0-flash'});
     * ```
     */ async get(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = getModelParametersToVertex(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = modelFromVertex(this.apiClient, apiResponse);
                return resp;
            });
        } else {
            const body = getModelParametersToMldev(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = modelFromMldev(this.apiClient, apiResponse);
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = listModelsParametersToVertex(this.apiClient, params);
            path = formatMap('{models_url}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = listModelsResponseFromVertex(this.apiClient, apiResponse);
                const typedResp = new ListModelsResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = listModelsParametersToMldev(this.apiClient, params);
            path = formatMap('{models_url}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = listModelsResponseFromMldev(this.apiClient, apiResponse);
                const typedResp = new ListModelsResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Updates a tuned model by its name.
     *
     * @param params - The parameters for updating the model.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.update({
     *   model: 'tuned-model-name',
     *   config: {
     *     displayName: 'New display name',
     *     description: 'New description',
     *   },
     * });
     * ```
     */ async update(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = updateModelParametersToVertex(this.apiClient, params);
            path = formatMap('{model}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = modelFromVertex(this.apiClient, apiResponse);
                return resp;
            });
        } else {
            const body = updateModelParametersToMldev(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = modelFromMldev(this.apiClient, apiResponse);
                return resp;
            });
        }
    }
    /**
     * Deletes a tuned model by its name.
     *
     * @param params - The parameters for deleting the model.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.delete({model: 'tuned-model-name'});
     * ```
     */ async delete(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = deleteModelParametersToVertex(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then(()=>{
                const resp = deleteModelResponseFromVertex();
                const typedResp = new DeleteModelResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = deleteModelParametersToMldev(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then(()=>{
                const resp = deleteModelResponseFromMldev();
                const typedResp = new DeleteModelResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Counts the number of tokens in the given contents. Multimodal input is
     * supported for Gemini models.
     *
     * @param params - The parameters for counting tokens.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.countTokens({
     *  model: 'gemini-2.0-flash',
     *  contents: 'The quick brown fox jumps over the lazy dog.'
     * });
     * console.log(response);
     * ```
     */ async countTokens(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = countTokensParametersToVertex(this.apiClient, params);
            path = formatMap('{model}:countTokens', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = countTokensResponseFromVertex(this.apiClient, apiResponse);
                const typedResp = new CountTokensResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = countTokensParametersToMldev(this.apiClient, params);
            path = formatMap('{model}:countTokens', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = countTokensResponseFromMldev(this.apiClient, apiResponse);
                const typedResp = new CountTokensResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Given a list of contents, returns a corresponding TokensInfo containing
     * the list of tokens and list of token ids.
     *
     * This method is not supported by the Gemini Developer API.
     *
     * @param params - The parameters for computing tokens.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.computeTokens({
     *  model: 'gemini-2.0-flash',
     *  contents: 'What is your name?'
     * });
     * console.log(response);
     * ```
     */ async computeTokens(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = computeTokensParametersToVertex(this.apiClient, params);
            path = formatMap('{model}:computeTokens', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = computeTokensResponseFromVertex(this.apiClient, apiResponse);
                const typedResp = new ComputeTokensResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     *  Generates videos based on a text description and configuration.
     *
     * @param params - The parameters for generating videos.
     * @return A Promise<GenerateVideosOperation> which allows you to track the progress and eventually retrieve the generated videos using the operations.get method.
     *
     * @example
     * ```ts
     * const operation = await ai.models.generateVideos({
     *  model: 'veo-2.0-generate-001',
     *  prompt: 'A neon hologram of a cat driving at top speed',
     *  config: {
     *    numberOfVideos: 1
     * });
     *
     * while (!operation.done) {
     *   await new Promise(resolve => setTimeout(resolve, 10000));
     *   operation = await ai.operations.getVideosOperation({operation: operation});
     * }
     *
     * console.log(operation.response?.generatedVideos?.[0]?.video?.uri);
     * ```
     */ async generateVideos(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = generateVideosParametersToVertex(this.apiClient, params);
            path = formatMap('{model}:predictLongRunning', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = generateVideosOperationFromVertex$1(this.apiClient, apiResponse);
                return resp;
            });
        } else {
            const body = generateVideosParametersToMldev(this.apiClient, params);
            path = formatMap('{model}:predictLongRunning', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = generateVideosOperationFromMldev$1(this.apiClient, apiResponse);
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function getOperationParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromOperationName = getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) setValueByPath(toObject, [
        '_url',
        'operationName'
    ], fromOperationName);
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function getOperationParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromOperationName = getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) setValueByPath(toObject, [
        '_url',
        'operationName'
    ], fromOperationName);
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function fetchPredictOperationParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromOperationName = getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) setValueByPath(toObject, [
        'operationName'
    ], fromOperationName);
    const fromResourceName = getValueByPath(fromObject, [
        'resourceName'
    ]);
    if (fromResourceName != null) setValueByPath(toObject, [
        '_url',
        'resourceName'
    ], fromResourceName);
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function videoFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromUri = getValueByPath(fromObject, [
        'video',
        'uri'
    ]);
    if (fromUri != null) setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = getValueByPath(fromObject, [
        'video',
        'encodedVideo'
    ]);
    if (fromVideoBytes != null) setValueByPath(toObject, [
        'videoBytes'
    ], tBytes(apiClient, fromVideoBytes));
    const fromMimeType = getValueByPath(fromObject, [
        'encoding'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function generatedVideoFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromVideo = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) setValueByPath(toObject, [
        'video'
    ], videoFromMldev(apiClient, fromVideo));
    return toObject;
}
function generateVideosResponseFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromGeneratedVideos = getValueByPath(fromObject, [
        'generatedSamples'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return generatedVideoFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function generateVideosOperationFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = getValueByPath(fromObject, [
        'response',
        'generateVideoResponse'
    ]);
    if (fromResponse != null) setValueByPath(toObject, [
        'response'
    ], generateVideosResponseFromMldev(apiClient, fromResponse));
    return toObject;
}
function videoFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromUri = getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromUri != null) setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromVideoBytes != null) setValueByPath(toObject, [
        'videoBytes'
    ], tBytes(apiClient, fromVideoBytes));
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function generatedVideoFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromVideo = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) setValueByPath(toObject, [
        'video'
    ], videoFromVertex(apiClient, fromVideo));
    return toObject;
}
function generateVideosResponseFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromGeneratedVideos = getValueByPath(fromObject, [
        'videos'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return generatedVideoFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function generateVideosOperationFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) setValueByPath(toObject, [
        'response'
    ], generateVideosResponseFromVertex(apiClient, fromResponse));
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class Operations extends BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
    }
    /**
     * Gets the status of a long-running operation.
     *
     * @param parameters The parameters for the get operation request.
     * @return The updated Operation object, with the latest status or result.
     */ async getVideosOperation(parameters) {
        const operation = parameters.operation;
        const config = parameters.config;
        if (operation.name === undefined || operation.name === '') throw new Error('Operation name is required.');
        if (this.apiClient.isVertexAI()) {
            const resourceName = operation.name.split('/operations/')[0];
            let httpOptions = undefined;
            if (config && 'httpOptions' in config) httpOptions = config.httpOptions;
            return this.fetchPredictVideosOperationInternal({
                operationName: operation.name,
                resourceName: resourceName,
                config: {
                    httpOptions: httpOptions
                }
            });
        } else return this.getVideosOperationInternal({
            operationName: operation.name,
            config: config
        });
    }
    async getVideosOperationInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = getOperationParametersToVertex(this.apiClient, params);
            path = formatMap('{operationName}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = generateVideosOperationFromVertex(this.apiClient, apiResponse);
                return resp;
            });
        } else {
            const body = getOperationParametersToMldev(this.apiClient, params);
            path = formatMap('{operationName}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = generateVideosOperationFromMldev(this.apiClient, apiResponse);
                return resp;
            });
        }
    }
    async fetchPredictVideosOperationInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = fetchPredictOperationParametersToVertex(this.apiClient, params);
            path = formatMap('{resourceName}:fetchPredictOperation', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = generateVideosOperationFromVertex(this.apiClient, apiResponse);
                return resp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function prebuiltVoiceConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromVoiceName = getValueByPath(fromObject, [
        'voiceName'
    ]);
    if (fromVoiceName != null) setValueByPath(toObject, [
        'voiceName'
    ], fromVoiceName);
    return toObject;
}
function voiceConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromPrebuiltVoiceConfig = getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], prebuiltVoiceConfigToMldev(apiClient, fromPrebuiltVoiceConfig));
    return toObject;
}
function speakerVoiceConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromSpeaker = getValueByPath(fromObject, [
        'speaker'
    ]);
    if (fromSpeaker != null) setValueByPath(toObject, [
        'speaker'
    ], fromSpeaker);
    const fromVoiceConfig = getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) setValueByPath(toObject, [
        'voiceConfig'
    ], voiceConfigToMldev(apiClient, fromVoiceConfig));
    return toObject;
}
function multiSpeakerVoiceConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromSpeakerVoiceConfigs = getValueByPath(fromObject, [
        'speakerVoiceConfigs'
    ]);
    if (fromSpeakerVoiceConfigs != null) {
        let transformedList = fromSpeakerVoiceConfigs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return speakerVoiceConfigToMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'speakerVoiceConfigs'
        ], transformedList);
    }
    return toObject;
}
function speechConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromVoiceConfig = getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) setValueByPath(toObject, [
        'voiceConfig'
    ], voiceConfigToMldev(apiClient, fromVoiceConfig));
    const fromMultiSpeakerVoiceConfig = getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]);
    if (fromMultiSpeakerVoiceConfig != null) setValueByPath(toObject, [
        'multiSpeakerVoiceConfig'
    ], multiSpeakerVoiceConfigToMldev(apiClient, fromMultiSpeakerVoiceConfig));
    const fromLanguageCode = getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    return toObject;
}
function videoMetadataToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromFps = getValueByPath(fromObject, [
        'fps'
    ]);
    if (fromFps != null) setValueByPath(toObject, [
        'fps'
    ], fromFps);
    const fromEndOffset = getValueByPath(fromObject, [
        'endOffset'
    ]);
    if (fromEndOffset != null) setValueByPath(toObject, [
        'endOffset'
    ], fromEndOffset);
    const fromStartOffset = getValueByPath(fromObject, [
        'startOffset'
    ]);
    if (fromStartOffset != null) setValueByPath(toObject, [
        'startOffset'
    ], fromStartOffset);
    return toObject;
}
function blobToMldev(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromData = getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) setValueByPath(toObject, [
        'data'
    ], fromData);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function fileDataToMldev(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function partToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromVideoMetadata = getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) setValueByPath(toObject, [
        'videoMetadata'
    ], videoMetadataToMldev(apiClient, fromVideoMetadata));
    const fromThought = getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromInlineData = getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) setValueByPath(toObject, [
        'inlineData'
    ], blobToMldev(apiClient, fromInlineData));
    const fromFileData = getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) setValueByPath(toObject, [
        'fileData'
    ], fileDataToMldev(apiClient, fromFileData));
    const fromThoughtSignature = getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromCodeExecutionResult = getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFunctionCall = getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromText = getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) setValueByPath(toObject, [
        'text'
    ], fromText);
    return toObject;
}
function contentToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromParts = getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return partToMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function functionDeclarationToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromBehavior = getValueByPath(fromObject, [
        'behavior'
    ]);
    if (fromBehavior != null) setValueByPath(toObject, [
        'behavior'
    ], fromBehavior);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromResponse = getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) setValueByPath(toObject, [
        'response'
    ], fromResponse);
    return toObject;
}
function intervalToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromStartTime = getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    return toObject;
}
function googleSearchToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromTimeRangeFilter = getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) setValueByPath(toObject, [
        'timeRangeFilter'
    ], intervalToMldev(apiClient, fromTimeRangeFilter));
    return toObject;
}
function dynamicRetrievalConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromMode = getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) setValueByPath(toObject, [
        'mode'
    ], fromMode);
    const fromDynamicThreshold = getValueByPath(fromObject, [
        'dynamicThreshold'
    ]);
    if (fromDynamicThreshold != null) setValueByPath(toObject, [
        'dynamicThreshold'
    ], fromDynamicThreshold);
    return toObject;
}
function googleSearchRetrievalToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromDynamicRetrievalConfig = getValueByPath(fromObject, [
        'dynamicRetrievalConfig'
    ]);
    if (fromDynamicRetrievalConfig != null) setValueByPath(toObject, [
        'dynamicRetrievalConfig'
    ], dynamicRetrievalConfigToMldev(apiClient, fromDynamicRetrievalConfig));
    return toObject;
}
function urlContextToMldev() {
    const toObject = {};
    return toObject;
}
function toolToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromFunctionDeclarations = getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return functionDeclarationToMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    if (getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromGoogleSearch = getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) setValueByPath(toObject, [
        'googleSearch'
    ], googleSearchToMldev(apiClient, fromGoogleSearch));
    const fromGoogleSearchRetrieval = getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], googleSearchRetrievalToMldev(apiClient, fromGoogleSearchRetrieval));
    if (getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'googleMaps'
    ]) !== undefined) throw new Error('googleMaps parameter is not supported in Gemini API.');
    const fromUrlContext = getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) setValueByPath(toObject, [
        'urlContext'
    ], urlContextToMldev());
    const fromCodeExecution = getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    return toObject;
}
function sessionResumptionConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromHandle = getValueByPath(fromObject, [
        'handle'
    ]);
    if (fromHandle != null) setValueByPath(toObject, [
        'handle'
    ], fromHandle);
    if (getValueByPath(fromObject, [
        'transparent'
    ]) !== undefined) throw new Error('transparent parameter is not supported in Gemini API.');
    return toObject;
}
function audioTranscriptionConfigToMldev() {
    const toObject = {};
    return toObject;
}
function automaticActivityDetectionToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromDisabled = getValueByPath(fromObject, [
        'disabled'
    ]);
    if (fromDisabled != null) setValueByPath(toObject, [
        'disabled'
    ], fromDisabled);
    const fromStartOfSpeechSensitivity = getValueByPath(fromObject, [
        'startOfSpeechSensitivity'
    ]);
    if (fromStartOfSpeechSensitivity != null) setValueByPath(toObject, [
        'startOfSpeechSensitivity'
    ], fromStartOfSpeechSensitivity);
    const fromEndOfSpeechSensitivity = getValueByPath(fromObject, [
        'endOfSpeechSensitivity'
    ]);
    if (fromEndOfSpeechSensitivity != null) setValueByPath(toObject, [
        'endOfSpeechSensitivity'
    ], fromEndOfSpeechSensitivity);
    const fromPrefixPaddingMs = getValueByPath(fromObject, [
        'prefixPaddingMs'
    ]);
    if (fromPrefixPaddingMs != null) setValueByPath(toObject, [
        'prefixPaddingMs'
    ], fromPrefixPaddingMs);
    const fromSilenceDurationMs = getValueByPath(fromObject, [
        'silenceDurationMs'
    ]);
    if (fromSilenceDurationMs != null) setValueByPath(toObject, [
        'silenceDurationMs'
    ], fromSilenceDurationMs);
    return toObject;
}
function realtimeInputConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromAutomaticActivityDetection = getValueByPath(fromObject, [
        'automaticActivityDetection'
    ]);
    if (fromAutomaticActivityDetection != null) setValueByPath(toObject, [
        'automaticActivityDetection'
    ], automaticActivityDetectionToMldev(apiClient, fromAutomaticActivityDetection));
    const fromActivityHandling = getValueByPath(fromObject, [
        'activityHandling'
    ]);
    if (fromActivityHandling != null) setValueByPath(toObject, [
        'activityHandling'
    ], fromActivityHandling);
    const fromTurnCoverage = getValueByPath(fromObject, [
        'turnCoverage'
    ]);
    if (fromTurnCoverage != null) setValueByPath(toObject, [
        'turnCoverage'
    ], fromTurnCoverage);
    return toObject;
}
function slidingWindowToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromTargetTokens = getValueByPath(fromObject, [
        'targetTokens'
    ]);
    if (fromTargetTokens != null) setValueByPath(toObject, [
        'targetTokens'
    ], fromTargetTokens);
    return toObject;
}
function contextWindowCompressionConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromTriggerTokens = getValueByPath(fromObject, [
        'triggerTokens'
    ]);
    if (fromTriggerTokens != null) setValueByPath(toObject, [
        'triggerTokens'
    ], fromTriggerTokens);
    const fromSlidingWindow = getValueByPath(fromObject, [
        'slidingWindow'
    ]);
    if (fromSlidingWindow != null) setValueByPath(toObject, [
        'slidingWindow'
    ], slidingWindowToMldev(apiClient, fromSlidingWindow));
    return toObject;
}
function proactivityConfigToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromProactiveAudio = getValueByPath(fromObject, [
        'proactiveAudio'
    ]);
    if (fromProactiveAudio != null) setValueByPath(toObject, [
        'proactiveAudio'
    ], fromProactiveAudio);
    return toObject;
}
function liveConnectConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], fromGenerationConfig);
    const fromResponseModalities = getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], speechConfigToMldev(apiClient, tLiveSpeechConfig(apiClient, fromSpeechConfig)));
    const fromEnableAffectiveDialog = getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], contentToMldev(apiClient, tContent(apiClient, fromSystemInstruction)));
    const fromTools = getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = tTools(apiClient, fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return toolToMldev(apiClient, tTool(apiClient, item));
        });
        setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], sessionResumptionConfigToMldev(apiClient, fromSessionResumption));
    const fromInputAudioTranscription = getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], audioTranscriptionConfigToMldev());
    const fromOutputAudioTranscription = getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], audioTranscriptionConfigToMldev());
    const fromRealtimeInputConfig = getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], realtimeInputConfigToMldev(apiClient, fromRealtimeInputConfig));
    const fromContextWindowCompression = getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], contextWindowCompressionConfigToMldev(apiClient, fromContextWindowCompression));
    const fromProactivity = getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], proactivityConfigToMldev(apiClient, fromProactivity));
    return toObject;
}
function liveConnectConstraintsToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        'setup',
        'model'
    ], tModel(apiClient, fromModel));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], liveConnectConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function createAuthTokenConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromExpireTime = getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromNewSessionExpireTime = getValueByPath(fromObject, [
        'newSessionExpireTime'
    ]);
    if (parentObject !== undefined && fromNewSessionExpireTime != null) setValueByPath(parentObject, [
        'newSessionExpireTime'
    ], fromNewSessionExpireTime);
    const fromUses = getValueByPath(fromObject, [
        'uses'
    ]);
    if (parentObject !== undefined && fromUses != null) setValueByPath(parentObject, [
        'uses'
    ], fromUses);
    const fromLiveConnectConstraints = getValueByPath(fromObject, [
        'liveConnectConstraints'
    ]);
    if (parentObject !== undefined && fromLiveConnectConstraints != null) setValueByPath(parentObject, [
        'bidiGenerateContentSetup'
    ], liveConnectConstraintsToMldev(apiClient, fromLiveConnectConstraints));
    const fromLockAdditionalFields = getValueByPath(fromObject, [
        'lockAdditionalFields'
    ]);
    if (parentObject !== undefined && fromLockAdditionalFields != null) setValueByPath(parentObject, [
        'fieldMask'
    ], fromLockAdditionalFields);
    return toObject;
}
function createAuthTokenParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], createAuthTokenConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function authTokenFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Returns a comma-separated list of field masks from a given object.
 *
 * @param setup The object to extract field masks from.
 * @return A comma-separated list of field masks.
 */ function getFieldMasks(setup) {
    const fields = [];
    for(const key in setup)if (Object.prototype.hasOwnProperty.call(setup, key)) {
        const value = setup[key];
        // 2nd layer, recursively get field masks see TODO(b/418290100)
        if (typeof value === 'object' && value != null && Object.keys(value).length > 0) {
            const field = Object.keys(value).map((kk)=>`${key}.${kk}`);
            fields.push(...field);
        } else fields.push(key); // 1st layer
    }
    return fields.join(',');
}
/**
 * Converts bidiGenerateContentSetup.
 * @param requestDict - The request dictionary.
 * @param config - The configuration object.
 * @return - The modified request dictionary.
 */ function convertBidiSetupToTokenSetup(requestDict, config) {
    // Convert bidiGenerateContentSetup from bidiGenerateContentSetup.setup.
    let setupForMaskGeneration = null;
    const bidiGenerateContentSetupValue = requestDict['bidiGenerateContentSetup'];
    if (typeof bidiGenerateContentSetupValue === 'object' && bidiGenerateContentSetupValue !== null && 'setup' in bidiGenerateContentSetupValue) {
        // Now we know bidiGenerateContentSetupValue is an object and has a 'setup'
        // property.
        const innerSetup = bidiGenerateContentSetupValue.setup;
        if (typeof innerSetup === 'object' && innerSetup !== null) {
            // Valid inner setup found.
            requestDict['bidiGenerateContentSetup'] = innerSetup;
            setupForMaskGeneration = innerSetup;
        } else // `bidiGenerateContentSetupValue.setup` is not a valid object; treat as
        // if bidiGenerateContentSetup is invalid.
        delete requestDict['bidiGenerateContentSetup'];
    } else if (bidiGenerateContentSetupValue !== undefined) // `bidiGenerateContentSetup` exists but not in the expected
    // shape {setup: {...}}; treat as invalid.
    delete requestDict['bidiGenerateContentSetup'];
    const preExistingFieldMask = requestDict['fieldMask'];
    // Handle mask generation setup.
    if (setupForMaskGeneration) {
        const generatedMaskFromBidi = getFieldMasks(setupForMaskGeneration);
        if (Array.isArray(config === null || config === void 0 ? void 0 : config.lockAdditionalFields) && (config === null || config === void 0 ? void 0 : config.lockAdditionalFields.length) === 0) {
            // Case 1: lockAdditionalFields is an empty array. Lock only fields from
            // bidi setup.
            if (generatedMaskFromBidi) // Only assign if mask is not empty
            requestDict['fieldMask'] = generatedMaskFromBidi;
            else delete requestDict['fieldMask']; // If mask is empty, effectively no
        } else if ((config === null || config === void 0 ? void 0 : config.lockAdditionalFields) && config.lockAdditionalFields.length > 0 && preExistingFieldMask !== null && Array.isArray(preExistingFieldMask) && preExistingFieldMask.length > 0) {
            // Case 2: Lock fields from bidi setup + additional fields
            // (preExistingFieldMask).
            const generationConfigFields = [
                'temperature',
                'topK',
                'topP',
                'maxOutputTokens',
                'responseModalities',
                'seed',
                'speechConfig'
            ];
            let mappedFieldsFromPreExisting = [];
            if (preExistingFieldMask.length > 0) mappedFieldsFromPreExisting = preExistingFieldMask.map((field)=>{
                if (generationConfigFields.includes(field)) return `generationConfig.${field}`;
                return field; // Keep original field name if not in
            // generationConfigFields
            });
            const finalMaskParts = [];
            if (generatedMaskFromBidi) finalMaskParts.push(generatedMaskFromBidi);
            if (mappedFieldsFromPreExisting.length > 0) finalMaskParts.push(...mappedFieldsFromPreExisting);
            if (finalMaskParts.length > 0) requestDict['fieldMask'] = finalMaskParts.join(',');
            else // If no fields from bidi and no valid additional fields from
            // pre-existing mask.
            delete requestDict['fieldMask'];
        } else // Case 3: "Lock all fields" (meaning, don't send a field_mask, let server
        // defaults apply or all are mutable). This is hit if:
        //  - `config.lockAdditionalFields` is undefined.
        //  - `config.lockAdditionalFields` is non-empty, BUT
        //  `preExistingFieldMask` is null, not a string, or an empty string.
        delete requestDict['fieldMask'];
    } else // No valid `bidiGenerateContentSetup` was found or extracted.
    // "Lock additional null fields if any".
    if (preExistingFieldMask !== null && Array.isArray(preExistingFieldMask) && preExistingFieldMask.length > 0) // If there's a pre-existing field mask, it's a string, and it's not
    // empty, then we should lock all fields.
    requestDict['fieldMask'] = preExistingFieldMask.join(',');
    else delete requestDict['fieldMask'];
    return requestDict;
}
class Tokens extends BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
    }
    /**
     * Creates an ephemeral auth token resource.
     *
     * @experimental
     *
     * @remarks
     * Ephermeral auth tokens is only supported in the Gemini Developer API.
     * It can be used for the session connection to the Live constrained API.
     *
     * @param params - The parameters for the create request.
     * @return The created auth token.
     *
     * @example
     * ```ts
     * // Case 1: If LiveEphemeralParameters is unset, unlock LiveConnectConfig
     * // when using the token in Live API sessions. Each session connection can
     * // use a different configuration.
     * const config: CreateAuthTokenConfig = {
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 2: If LiveEphemeralParameters is set, lock all fields in
     * // LiveConnectConfig when using the token in Live API sessions. For
     * // example, changing `outputAudioTranscription` in the Live API
     * // connection will be ignored by the API.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     }
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 3: If LiveEphemeralParameters is set and lockAdditionalFields is
     * // set, lock LiveConnectConfig with set and additional fields (e.g.
     * // responseModalities, systemInstruction, temperature in this example) when
     * // using the token in Live API sessions.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     },
     *     lockAdditionalFields: ['temperature'],
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 4: If LiveEphemeralParameters is set and lockAdditionalFields is
     * // empty array, lock LiveConnectConfig with set fields (e.g.
     * // responseModalities, systemInstruction in this example) when using the
     * // token in Live API sessions.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     },
     *     lockAdditionalFields: [],
     * }
     * const token = await ai.tokens.create(config);
     * ```
     */ async create(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('The client.tokens.create method is only supported by the Gemini Developer API.');
        else {
            const body = createAuthTokenParametersToMldev(this.apiClient, params);
            path = formatMap('auth_tokens', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            const transformedBody = convertBidiSetupToTokenSetup(body, params.config);
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(transformedBody),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = authTokenFromMldev(this.apiClient, apiResponse);
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function getTuningJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function listTuningJobsConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    return toObject;
}
function listTuningJobsParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], listTuningJobsConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function tuningExampleToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromTextInput = getValueByPath(fromObject, [
        'textInput'
    ]);
    if (fromTextInput != null) setValueByPath(toObject, [
        'textInput'
    ], fromTextInput);
    const fromOutput = getValueByPath(fromObject, [
        'output'
    ]);
    if (fromOutput != null) setValueByPath(toObject, [
        'output'
    ], fromOutput);
    return toObject;
}
function tuningDatasetToMldev(apiClient, fromObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'gcsUri'
    ]) !== undefined) throw new Error('gcsUri parameter is not supported in Gemini API.');
    const fromExamples = getValueByPath(fromObject, [
        'examples'
    ]);
    if (fromExamples != null) {
        let transformedList = fromExamples;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return tuningExampleToMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'examples',
            'examples'
        ], transformedList);
    }
    return toObject;
}
function createTuningJobConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    if (getValueByPath(fromObject, [
        'validationDataset'
    ]) !== undefined) throw new Error('validationDataset parameter is not supported in Gemini API.');
    const fromTunedModelDisplayName = getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (parentObject !== undefined && fromTunedModelDisplayName != null) setValueByPath(parentObject, [
        'displayName'
    ], fromTunedModelDisplayName);
    if (getValueByPath(fromObject, [
        'description'
    ]) !== undefined) throw new Error('description parameter is not supported in Gemini API.');
    const fromEpochCount = getValueByPath(fromObject, [
        'epochCount'
    ]);
    if (parentObject !== undefined && fromEpochCount != null) setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'epochCount'
    ], fromEpochCount);
    const fromLearningRateMultiplier = getValueByPath(fromObject, [
        'learningRateMultiplier'
    ]);
    if (fromLearningRateMultiplier != null) setValueByPath(toObject, [
        'tuningTask',
        'hyperparameters',
        'learningRateMultiplier'
    ], fromLearningRateMultiplier);
    if (getValueByPath(fromObject, [
        'exportLastCheckpointOnly'
    ]) !== undefined) throw new Error('exportLastCheckpointOnly parameter is not supported in Gemini API.');
    if (getValueByPath(fromObject, [
        'adapterSize'
    ]) !== undefined) throw new Error('adapterSize parameter is not supported in Gemini API.');
    const fromBatchSize = getValueByPath(fromObject, [
        'batchSize'
    ]);
    if (parentObject !== undefined && fromBatchSize != null) setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'batchSize'
    ], fromBatchSize);
    const fromLearningRate = getValueByPath(fromObject, [
        'learningRate'
    ]);
    if (parentObject !== undefined && fromLearningRate != null) setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'learningRate'
    ], fromLearningRate);
    return toObject;
}
function createTuningJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromBaseModel = getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromTrainingDataset = getValueByPath(fromObject, [
        'trainingDataset'
    ]);
    if (fromTrainingDataset != null) setValueByPath(toObject, [
        'tuningTask',
        'trainingData'
    ], tuningDatasetToMldev(apiClient, fromTrainingDataset));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], createTuningJobConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function getTuningJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], fromConfig);
    return toObject;
}
function listTuningJobsConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    return toObject;
}
function listTuningJobsParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], listTuningJobsConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function tuningDatasetToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromGcsUri = getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (parentObject !== undefined && fromGcsUri != null) setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'trainingDatasetUri'
    ], fromGcsUri);
    if (getValueByPath(fromObject, [
        'examples'
    ]) !== undefined) throw new Error('examples parameter is not supported in Vertex AI.');
    return toObject;
}
function tuningValidationDatasetToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromGcsUri = getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) setValueByPath(toObject, [
        'validationDatasetUri'
    ], fromGcsUri);
    return toObject;
}
function createTuningJobConfigToVertex(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromValidationDataset = getValueByPath(fromObject, [
        'validationDataset'
    ]);
    if (parentObject !== undefined && fromValidationDataset != null) setValueByPath(parentObject, [
        'supervisedTuningSpec'
    ], tuningValidationDatasetToVertex(apiClient, fromValidationDataset));
    const fromTunedModelDisplayName = getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (parentObject !== undefined && fromTunedModelDisplayName != null) setValueByPath(parentObject, [
        'tunedModelDisplayName'
    ], fromTunedModelDisplayName);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    const fromEpochCount = getValueByPath(fromObject, [
        'epochCount'
    ]);
    if (parentObject !== undefined && fromEpochCount != null) setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'hyperParameters',
        'epochCount'
    ], fromEpochCount);
    const fromLearningRateMultiplier = getValueByPath(fromObject, [
        'learningRateMultiplier'
    ]);
    if (parentObject !== undefined && fromLearningRateMultiplier != null) setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'hyperParameters',
        'learningRateMultiplier'
    ], fromLearningRateMultiplier);
    const fromExportLastCheckpointOnly = getValueByPath(fromObject, [
        'exportLastCheckpointOnly'
    ]);
    if (parentObject !== undefined && fromExportLastCheckpointOnly != null) setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'exportLastCheckpointOnly'
    ], fromExportLastCheckpointOnly);
    const fromAdapterSize = getValueByPath(fromObject, [
        'adapterSize'
    ]);
    if (parentObject !== undefined && fromAdapterSize != null) setValueByPath(parentObject, [
        'supervisedTuningSpec',
        'hyperParameters',
        'adapterSize'
    ], fromAdapterSize);
    if (getValueByPath(fromObject, [
        'batchSize'
    ]) !== undefined) throw new Error('batchSize parameter is not supported in Vertex AI.');
    if (getValueByPath(fromObject, [
        'learningRate'
    ]) !== undefined) throw new Error('learningRate parameter is not supported in Vertex AI.');
    return toObject;
}
function createTuningJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromBaseModel = getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromTrainingDataset = getValueByPath(fromObject, [
        'trainingDataset'
    ]);
    if (fromTrainingDataset != null) setValueByPath(toObject, [
        'supervisedTuningSpec',
        'trainingDatasetUri'
    ], tuningDatasetToVertex(apiClient, fromTrainingDataset, toObject));
    const fromConfig = getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) setValueByPath(toObject, [
        'config'
    ], createTuningJobConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function tunedModelFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromEndpoint = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromEndpoint != null) setValueByPath(toObject, [
        'endpoint'
    ], fromEndpoint);
    return toObject;
}
function tuningJobFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromState = getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) setValueByPath(toObject, [
        'state'
    ], tTuningJobStatus(apiClient, fromState));
    const fromCreateTime = getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromStartTime = getValueByPath(fromObject, [
        'tuningTask',
        'startTime'
    ]);
    if (fromStartTime != null) setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = getValueByPath(fromObject, [
        'tuningTask',
        'completeTime'
    ]);
    if (fromEndTime != null) setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromBaseModel = getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromTunedModel = getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModel != null) setValueByPath(toObject, [
        'tunedModel'
    ], tunedModelFromMldev(apiClient, fromTunedModel));
    const fromDistillationSpec = getValueByPath(fromObject, [
        'distillationSpec'
    ]);
    if (fromDistillationSpec != null) setValueByPath(toObject, [
        'distillationSpec'
    ], fromDistillationSpec);
    const fromExperiment = getValueByPath(fromObject, [
        'experiment'
    ]);
    if (fromExperiment != null) setValueByPath(toObject, [
        'experiment'
    ], fromExperiment);
    const fromLabels = getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) setValueByPath(toObject, [
        'labels'
    ], fromLabels);
    const fromPipelineJob = getValueByPath(fromObject, [
        'pipelineJob'
    ]);
    if (fromPipelineJob != null) setValueByPath(toObject, [
        'pipelineJob'
    ], fromPipelineJob);
    const fromServiceAccount = getValueByPath(fromObject, [
        'serviceAccount'
    ]);
    if (fromServiceAccount != null) setValueByPath(toObject, [
        'serviceAccount'
    ], fromServiceAccount);
    const fromTunedModelDisplayName = getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (fromTunedModelDisplayName != null) setValueByPath(toObject, [
        'tunedModelDisplayName'
    ], fromTunedModelDisplayName);
    return toObject;
}
function listTuningJobsResponseFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromNextPageToken = getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromTuningJobs = getValueByPath(fromObject, [
        'tunedModels'
    ]);
    if (fromTuningJobs != null) {
        let transformedList = fromTuningJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return tuningJobFromMldev(apiClient, item);
        });
        setValueByPath(toObject, [
            'tuningJobs'
        ], transformedList);
    }
    return toObject;
}
function operationFromMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) setValueByPath(toObject, [
        'error'
    ], fromError);
    return toObject;
}
function tunedModelCheckpointFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromCheckpointId = getValueByPath(fromObject, [
        'checkpointId'
    ]);
    if (fromCheckpointId != null) setValueByPath(toObject, [
        'checkpointId'
    ], fromCheckpointId);
    const fromEpoch = getValueByPath(fromObject, [
        'epoch'
    ]);
    if (fromEpoch != null) setValueByPath(toObject, [
        'epoch'
    ], fromEpoch);
    const fromStep = getValueByPath(fromObject, [
        'step'
    ]);
    if (fromStep != null) setValueByPath(toObject, [
        'step'
    ], fromStep);
    const fromEndpoint = getValueByPath(fromObject, [
        'endpoint'
    ]);
    if (fromEndpoint != null) setValueByPath(toObject, [
        'endpoint'
    ], fromEndpoint);
    return toObject;
}
function tunedModelFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromEndpoint = getValueByPath(fromObject, [
        'endpoint'
    ]);
    if (fromEndpoint != null) setValueByPath(toObject, [
        'endpoint'
    ], fromEndpoint);
    const fromCheckpoints = getValueByPath(fromObject, [
        'checkpoints'
    ]);
    if (fromCheckpoints != null) {
        let transformedList = fromCheckpoints;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return tunedModelCheckpointFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'checkpoints'
        ], transformedList);
    }
    return toObject;
}
function tuningJobFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromState = getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) setValueByPath(toObject, [
        'state'
    ], tTuningJobStatus(apiClient, fromState));
    const fromCreateTime = getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromStartTime = getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromError = getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromDescription = getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromBaseModel = getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromTunedModel = getValueByPath(fromObject, [
        'tunedModel'
    ]);
    if (fromTunedModel != null) setValueByPath(toObject, [
        'tunedModel'
    ], tunedModelFromVertex(apiClient, fromTunedModel));
    const fromSupervisedTuningSpec = getValueByPath(fromObject, [
        'supervisedTuningSpec'
    ]);
    if (fromSupervisedTuningSpec != null) setValueByPath(toObject, [
        'supervisedTuningSpec'
    ], fromSupervisedTuningSpec);
    const fromTuningDataStats = getValueByPath(fromObject, [
        'tuningDataStats'
    ]);
    if (fromTuningDataStats != null) setValueByPath(toObject, [
        'tuningDataStats'
    ], fromTuningDataStats);
    const fromEncryptionSpec = getValueByPath(fromObject, [
        'encryptionSpec'
    ]);
    if (fromEncryptionSpec != null) setValueByPath(toObject, [
        'encryptionSpec'
    ], fromEncryptionSpec);
    const fromPartnerModelTuningSpec = getValueByPath(fromObject, [
        'partnerModelTuningSpec'
    ]);
    if (fromPartnerModelTuningSpec != null) setValueByPath(toObject, [
        'partnerModelTuningSpec'
    ], fromPartnerModelTuningSpec);
    const fromDistillationSpec = getValueByPath(fromObject, [
        'distillationSpec'
    ]);
    if (fromDistillationSpec != null) setValueByPath(toObject, [
        'distillationSpec'
    ], fromDistillationSpec);
    const fromExperiment = getValueByPath(fromObject, [
        'experiment'
    ]);
    if (fromExperiment != null) setValueByPath(toObject, [
        'experiment'
    ], fromExperiment);
    const fromLabels = getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) setValueByPath(toObject, [
        'labels'
    ], fromLabels);
    const fromPipelineJob = getValueByPath(fromObject, [
        'pipelineJob'
    ]);
    if (fromPipelineJob != null) setValueByPath(toObject, [
        'pipelineJob'
    ], fromPipelineJob);
    const fromServiceAccount = getValueByPath(fromObject, [
        'serviceAccount'
    ]);
    if (fromServiceAccount != null) setValueByPath(toObject, [
        'serviceAccount'
    ], fromServiceAccount);
    const fromTunedModelDisplayName = getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (fromTunedModelDisplayName != null) setValueByPath(toObject, [
        'tunedModelDisplayName'
    ], fromTunedModelDisplayName);
    return toObject;
}
function listTuningJobsResponseFromVertex(apiClient, fromObject) {
    const toObject = {};
    const fromNextPageToken = getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromTuningJobs = getValueByPath(fromObject, [
        'tuningJobs'
    ]);
    if (fromTuningJobs != null) {
        let transformedList = fromTuningJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return tuningJobFromVertex(apiClient, item);
        });
        setValueByPath(toObject, [
            'tuningJobs'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class Tunings extends BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Gets a TuningJob.
         *
         * @param name - The resource name of the tuning job.
         * @return - A TuningJob object.
         *
         * @experimental - The SDK's tuning implementation is experimental, and may
         * change in future versions.
         */ this.get = async (params)=>{
            return await this.getInternal(params);
        };
        /**
         * Lists tuning jobs.
         *
         * @param config - The configuration for the list request.
         * @return - A list of tuning jobs.
         *
         * @experimental - The SDK's tuning implementation is experimental, and may
         * change in future versions.
         */ this.list = async (params = {})=>{
            return new Pager(PagedItem.PAGED_ITEM_TUNING_JOBS, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
        /**
         * Creates a supervised fine-tuning job.
         *
         * @param params - The parameters for the tuning job.
         * @return - A TuningJob operation.
         *
         * @experimental - The SDK's tuning implementation is experimental, and may
         * change in future versions.
         */ this.tune = async (params)=>{
            if (this.apiClient.isVertexAI()) return await this.tuneInternal(params);
            else {
                const operation = await this.tuneMldevInternal(params);
                let tunedModelName = '';
                if (operation['metadata'] !== undefined && operation['metadata']['tunedModel'] !== undefined) tunedModelName = operation['metadata']['tunedModel'];
                else if (operation['name'] !== undefined && operation['name'].includes('/operations/')) tunedModelName = operation['name'].split('/operations/')[0];
                const tuningJob = {
                    name: tunedModelName,
                    state: JobState.JOB_STATE_QUEUED
                };
                return tuningJob;
            }
        };
    }
    async getInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = getTuningJobParametersToVertex(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = tuningJobFromVertex(this.apiClient, apiResponse);
                return resp;
            });
        } else {
            const body = getTuningJobParametersToMldev(this.apiClient, params);
            path = formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = tuningJobFromMldev(this.apiClient, apiResponse);
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = listTuningJobsParametersToVertex(this.apiClient, params);
            path = formatMap('tuningJobs', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = listTuningJobsResponseFromVertex(this.apiClient, apiResponse);
                const typedResp = new ListTuningJobsResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = listTuningJobsParametersToMldev(this.apiClient, params);
            path = formatMap('tunedModels', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = listTuningJobsResponseFromMldev(this.apiClient, apiResponse);
                const typedResp = new ListTuningJobsResponse();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async tuneInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = createTuningJobParametersToVertex(this.apiClient, params);
            path = formatMap('tuningJobs', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = tuningJobFromVertex(this.apiClient, apiResponse);
                return resp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    async tuneMldevInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = createTuningJobParametersToMldev(this.apiClient, params);
            path = formatMap('tunedModels', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = operationFromMldev(this.apiClient, apiResponse);
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class BrowserDownloader {
    async download(_params, _apiClient) {
        throw new Error('Download to file is not supported in the browser, please use a browser compliant download like an <a> tag.');
    }
}
const MAX_CHUNK_SIZE = 8388608; // bytes
const MAX_RETRY_COUNT = 3;
const INITIAL_RETRY_DELAY_MS = 1000;
const DELAY_MULTIPLIER = 2;
const X_GOOG_UPLOAD_STATUS_HEADER_FIELD = 'x-goog-upload-status';
async function uploadBlob(file, uploadUrl, apiClient) {
    var _a, _b, _c;
    let fileSize = 0;
    let offset = 0;
    let response = new HttpResponse(new Response());
    let uploadCommand = 'upload';
    fileSize = file.size;
    while(offset < fileSize){
        const chunkSize = Math.min(MAX_CHUNK_SIZE, fileSize - offset);
        const chunk = file.slice(offset, offset + chunkSize);
        if (offset + chunkSize >= fileSize) uploadCommand += ', finalize';
        let retryCount = 0;
        let currentDelayMs = INITIAL_RETRY_DELAY_MS;
        while(retryCount < MAX_RETRY_COUNT){
            response = await apiClient.request({
                path: '',
                body: chunk,
                httpMethod: 'POST',
                httpOptions: {
                    apiVersion: '',
                    baseUrl: uploadUrl,
                    headers: {
                        'X-Goog-Upload-Command': uploadCommand,
                        'X-Goog-Upload-Offset': String(offset),
                        'Content-Length': String(chunkSize)
                    }
                }
            });
            if ((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a[X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) break;
            retryCount++;
            await sleep(currentDelayMs);
            currentDelayMs = currentDelayMs * DELAY_MULTIPLIER;
        }
        offset += chunkSize;
        // The `x-goog-upload-status` header field can be `active`, `final` and
        //`cancelled` in resposne.
        if (((_b = response === null || response === void 0 ? void 0 : response.headers) === null || _b === void 0 ? void 0 : _b[X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) !== 'active') break;
        // TODO(b/401391430) Investigate why the upload status is not finalized
        // even though all content has been uploaded.
        if (fileSize <= offset) throw new Error('All content has been uploaded, but the upload status is not finalized.');
    }
    const responseJson = await (response === null || response === void 0 ? void 0 : response.json());
    if (((_c = response === null || response === void 0 ? void 0 : response.headers) === null || _c === void 0 ? void 0 : _c[X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) !== 'final') throw new Error('Failed to upload file: Upload status is not finalized.');
    return responseJson['file'];
}
async function getBlobStat(file) {
    const fileStat = {
        size: file.size,
        type: file.type
    };
    return fileStat;
}
function sleep(ms) {
    return new Promise((resolvePromise)=>setTimeout(resolvePromise, ms));
}
class BrowserUploader {
    async upload(file, uploadUrl, apiClient) {
        if (typeof file === 'string') throw new Error('File path is not supported in browser uploader.');
        return await uploadBlob(file, uploadUrl, apiClient);
    }
    async stat(file) {
        if (typeof file === 'string') throw new Error('File path is not supported in browser uploader.');
        else return await getBlobStat(file);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class BrowserWebSocketFactory {
    create(url, headers, callbacks) {
        return new BrowserWebSocket(url, headers, callbacks);
    }
}
class BrowserWebSocket {
    constructor(url, headers, callbacks){
        this.url = url;
        this.headers = headers;
        this.callbacks = callbacks;
    }
    connect() {
        this.ws = new WebSocket(this.url);
        this.ws.onopen = this.callbacks.onopen;
        this.ws.onerror = this.callbacks.onerror;
        this.ws.onclose = this.callbacks.onclose;
        this.ws.onmessage = this.callbacks.onmessage;
    }
    send(message) {
        if (this.ws === undefined) throw new Error('WebSocket is not connected');
        this.ws.send(message);
    }
    close() {
        if (this.ws === undefined) throw new Error('WebSocket is not connected');
        this.ws.close();
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const GOOGLE_API_KEY_HEADER = 'x-goog-api-key';
// TODO(b/395122533): We need a secure client side authentication mechanism.
class WebAuth {
    constructor(apiKey){
        this.apiKey = apiKey;
    }
    async addAuthHeaders(headers) {
        if (headers.get(GOOGLE_API_KEY_HEADER) !== null) return;
        if (this.apiKey.startsWith('auth_tokens/')) throw new Error('Ephemeral tokens are only supported by the live API.');
        // Check if API key is empty or null
        if (!this.apiKey) throw new Error('API key is missing. Please provide a valid API key.');
        headers.append(GOOGLE_API_KEY_HEADER, this.apiKey);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const LANGUAGE_LABEL_PREFIX = 'gl-node/';
/**
 * The Google GenAI SDK.
 *
 * @remarks
 * Provides access to the GenAI features through either the {@link
 * https://cloud.google.com/vertex-ai/docs/reference/rest | Gemini API} or
 * the {@link https://cloud.google.com/vertex-ai/docs/reference/rest | Vertex AI
 * API}.
 *
 * The {@link GoogleGenAIOptions.vertexai} value determines which of the API
 * services to use.
 *
 * When using the Gemini API, a {@link GoogleGenAIOptions.apiKey} must also be
 * set. When using Vertex AI, currently only {@link GoogleGenAIOptions.apiKey}
 * is supported via Express mode. {@link GoogleGenAIOptions.project} and {@link
 * GoogleGenAIOptions.location} should not be set.
 *
 * @example
 * Initializing the SDK for using the Gemini API:
 * ```ts
 * import {GoogleGenAI} from '@google/genai';
 * const ai = new GoogleGenAI({apiKey: 'GEMINI_API_KEY'});
 * ```
 *
 * @example
 * Initializing the SDK for using the Vertex AI API:
 * ```ts
 * import {GoogleGenAI} from '@google/genai';
 * const ai = new GoogleGenAI({
 *   vertexai: true,
 *   project: 'PROJECT_ID',
 *   location: 'PROJECT_LOCATION'
 * });
 * ```
 *
 */ class GoogleGenAI {
    constructor(options){
        var _a;
        if (options.apiKey == null) throw new Error('An API Key must be set when running in a browser');
        // Web client only supports API key mode for Vertex AI.
        if (options.project || options.location) throw new Error('Vertex AI project based authentication is not supported on browser runtimes. Please do not provide a project or location.');
        this.vertexai = (_a = options.vertexai) !== null && _a !== void 0 ? _a : false;
        this.apiKey = options.apiKey;
        const baseUrl = getBaseUrl(options, /*vertexBaseUrlFromEnv*/ undefined, /*geminiBaseUrlFromEnv*/ undefined);
        if (baseUrl) {
            if (options.httpOptions) options.httpOptions.baseUrl = baseUrl;
            else options.httpOptions = {
                baseUrl: baseUrl
            };
        }
        this.apiVersion = options.apiVersion;
        const auth = new WebAuth(this.apiKey);
        this.apiClient = new ApiClient({
            auth: auth,
            apiVersion: this.apiVersion,
            apiKey: this.apiKey,
            vertexai: this.vertexai,
            httpOptions: options.httpOptions,
            userAgentExtra: LANGUAGE_LABEL_PREFIX + 'web',
            uploader: new BrowserUploader(),
            downloader: new BrowserDownloader()
        });
        this.models = new Models(this.apiClient);
        this.live = new Live(this.apiClient, auth, new BrowserWebSocketFactory());
        this.chats = new Chats(this.models, this.apiClient);
        this.caches = new Caches(this.apiClient);
        this.files = new Files(this.apiClient);
        this.operations = new Operations(this.apiClient);
        this.authTokens = new Tokens(this.apiClient);
        this.tunings = new Tunings(this.apiClient);
    }
}

},{"zod":"8kVhQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8kVhQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./v3/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
parcelHelpers.exportAll(_indexJs, exports);
exports.default = (0, _indexJsDefault.default);

},{"./v3/index.js":"fbFFW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fbFFW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "z", ()=>_externalJs);
var _externalJs = require("./external.js");
parcelHelpers.exportAll(_externalJs, exports);
exports.default = _externalJs;

},{"./external.js":"ldhqc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ldhqc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errorsJs = require("./errors.js");
parcelHelpers.exportAll(_errorsJs, exports);
var _parseUtilJs = require("./helpers/parseUtil.js");
parcelHelpers.exportAll(_parseUtilJs, exports);
var _typeAliasesJs = require("./helpers/typeAliases.js");
parcelHelpers.exportAll(_typeAliasesJs, exports);
var _utilJs = require("./helpers/util.js");
parcelHelpers.exportAll(_utilJs, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _zodErrorJs = require("./ZodError.js");
parcelHelpers.exportAll(_zodErrorJs, exports);

},{"./errors.js":"j1AAX","./helpers/parseUtil.js":"dEesJ","./helpers/typeAliases.js":"iW8am","./helpers/util.js":"35lyb","./types.js":"hBIlV","./ZodError.js":"lketk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j1AAX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultErrorMap", ()=>(0, _enJsDefault.default));
parcelHelpers.export(exports, "setErrorMap", ()=>setErrorMap);
parcelHelpers.export(exports, "getErrorMap", ()=>getErrorMap);
var _enJs = require("./locales/en.js");
var _enJsDefault = parcelHelpers.interopDefault(_enJs);
let overrideErrorMap = (0, _enJsDefault.default);
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

},{"./locales/en.js":"aCg27","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aCg27":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _zodErrorJs = require("../ZodError.js");
var _utilJs = require("../helpers/util.js");
const errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, _zodErrorJs.ZodIssueCode).invalid_type:
            if (issue.received === (0, _utilJs.ZodParsedType).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, _utilJs.util).jsonStringifyReplacer)}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, _utilJs.util).joinValues(issue.keys, ", ")}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_union:
            message = `Invalid input`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, _utilJs.util).joinValues(issue.options)}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, _utilJs.util).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_date:
            message = `Invalid date`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, _utilJs.util).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, _zodErrorJs.ZodIssueCode).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, _zodErrorJs.ZodIssueCode).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, _zodErrorJs.ZodIssueCode).custom:
            message = `Invalid input`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, _utilJs.util).assertNever(issue);
    }
    return {
        message
    };
};
exports.default = errorMap;

},{"../ZodError.js":"lketk","../helpers/util.js":"35lyb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lketk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZodIssueCode", ()=>ZodIssueCode);
parcelHelpers.export(exports, "quotelessJson", ()=>quotelessJson);
parcelHelpers.export(exports, "ZodError", ()=>ZodError);
var _utilJs = require("./helpers/util.js");
const ZodIssueCode = (0, _utilJs.util).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const quotelessJson = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, _utilJs.util).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors,
            fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues)=>{
    const error = new ZodError(issues);
    return error;
};

},{"./helpers/util.js":"35lyb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"35lyb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "util", ()=>util);
parcelHelpers.export(exports, "objectUtil", ()=>objectUtil);
parcelHelpers.export(exports, "ZodParsedType", ()=>ZodParsedType);
parcelHelpers.export(exports, "getParsedType", ()=>getParsedType);
var util;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return Number.isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return ZodParsedType.array;
            if (data === null) return ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return ZodParsedType.date;
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dEesJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeIssue", ()=>makeIssue);
parcelHelpers.export(exports, "EMPTY_PATH", ()=>EMPTY_PATH);
parcelHelpers.export(exports, "addIssueToContext", ()=>addIssueToContext);
parcelHelpers.export(exports, "ParseStatus", ()=>ParseStatus);
parcelHelpers.export(exports, "INVALID", ()=>INVALID);
parcelHelpers.export(exports, "DIRTY", ()=>DIRTY);
parcelHelpers.export(exports, "OK", ()=>OK);
parcelHelpers.export(exports, "isAborted", ()=>isAborted);
parcelHelpers.export(exports, "isDirty", ()=>isDirty);
parcelHelpers.export(exports, "isValid", ()=>isValid);
parcelHelpers.export(exports, "isAsync", ()=>isAsync);
var _errorsJs = require("../errors.js");
var _enJs = require("../locales/en.js");
var _enJsDefault = parcelHelpers.interopDefault(_enJs);
const makeIssue = (params)=>{
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = (0, _errorsJs.getErrorMap)();
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, _enJsDefault.default) ? undefined : (0, _enJsDefault.default)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return INVALID;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key, value } = pair;
            if (key.status === "aborted") return INVALID;
            if (value.status === "aborted") return INVALID;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const INVALID = Object.freeze({
    status: "aborted"
});
const DIRTY = (value)=>({
        status: "dirty",
        value
    });
const OK = (value)=>({
        status: "valid",
        value
    });
const isAborted = (x)=>x.status === "aborted";
const isDirty = (x)=>x.status === "dirty";
const isValid = (x)=>x.status === "valid";
const isAsync = (x)=>typeof Promise !== "undefined" && x instanceof Promise;

},{"../errors.js":"j1AAX","../locales/en.js":"aCg27","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iW8am":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hBIlV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZodType", ()=>ZodType);
// Adapted from https://stackoverflow.com/a/3143231
parcelHelpers.export(exports, "datetimeRegex", ()=>datetimeRegex);
parcelHelpers.export(exports, "ZodString", ()=>ZodString);
parcelHelpers.export(exports, "ZodNumber", ()=>ZodNumber);
parcelHelpers.export(exports, "ZodBigInt", ()=>ZodBigInt);
parcelHelpers.export(exports, "ZodBoolean", ()=>ZodBoolean);
parcelHelpers.export(exports, "ZodDate", ()=>ZodDate);
parcelHelpers.export(exports, "ZodSymbol", ()=>ZodSymbol);
parcelHelpers.export(exports, "ZodUndefined", ()=>ZodUndefined);
parcelHelpers.export(exports, "ZodNull", ()=>ZodNull);
parcelHelpers.export(exports, "ZodAny", ()=>ZodAny);
parcelHelpers.export(exports, "ZodUnknown", ()=>ZodUnknown);
parcelHelpers.export(exports, "ZodNever", ()=>ZodNever);
parcelHelpers.export(exports, "ZodVoid", ()=>ZodVoid);
parcelHelpers.export(exports, "ZodArray", ()=>ZodArray);
parcelHelpers.export(exports, "ZodObject", ()=>ZodObject);
parcelHelpers.export(exports, "ZodUnion", ()=>ZodUnion);
parcelHelpers.export(exports, "ZodDiscriminatedUnion", ()=>ZodDiscriminatedUnion);
parcelHelpers.export(exports, "ZodIntersection", ()=>ZodIntersection);
// type ZodTupleItems = [ZodTypeAny, ...ZodTypeAny[]];
parcelHelpers.export(exports, "ZodTuple", ()=>ZodTuple);
parcelHelpers.export(exports, "ZodRecord", ()=>ZodRecord);
parcelHelpers.export(exports, "ZodMap", ()=>ZodMap);
parcelHelpers.export(exports, "ZodSet", ()=>ZodSet);
parcelHelpers.export(exports, "ZodFunction", ()=>ZodFunction);
parcelHelpers.export(exports, "ZodLazy", ()=>ZodLazy);
parcelHelpers.export(exports, "ZodLiteral", ()=>ZodLiteral);
parcelHelpers.export(exports, "ZodEnum", ()=>ZodEnum);
parcelHelpers.export(exports, "ZodNativeEnum", ()=>ZodNativeEnum);
parcelHelpers.export(exports, "ZodPromise", ()=>ZodPromise);
parcelHelpers.export(exports, "ZodEffects", ()=>ZodEffects);
parcelHelpers.export(exports, "ZodTransformer", ()=>ZodEffects);
parcelHelpers.export(exports, "ZodOptional", ()=>ZodOptional);
parcelHelpers.export(exports, "ZodNullable", ()=>ZodNullable);
parcelHelpers.export(exports, "ZodDefault", ()=>ZodDefault);
parcelHelpers.export(exports, "ZodCatch", ()=>ZodCatch);
parcelHelpers.export(exports, "ZodNaN", ()=>ZodNaN);
parcelHelpers.export(exports, "BRAND", ()=>BRAND);
parcelHelpers.export(exports, "ZodBranded", ()=>ZodBranded);
parcelHelpers.export(exports, "ZodPipeline", ()=>ZodPipeline);
parcelHelpers.export(exports, "ZodReadonly", ()=>ZodReadonly);
parcelHelpers.export(exports, "custom", ()=>custom);
parcelHelpers.export(exports, "Schema", ()=>ZodType);
parcelHelpers.export(exports, "ZodSchema", ()=>ZodType);
parcelHelpers.export(exports, "late", ()=>late);
parcelHelpers.export(exports, "ZodFirstPartyTypeKind", ()=>ZodFirstPartyTypeKind);
parcelHelpers.export(exports, "coerce", ()=>coerce);
parcelHelpers.export(exports, "any", ()=>anyType);
parcelHelpers.export(exports, "array", ()=>arrayType);
parcelHelpers.export(exports, "bigint", ()=>bigIntType);
parcelHelpers.export(exports, "boolean", ()=>booleanType);
parcelHelpers.export(exports, "date", ()=>dateType);
parcelHelpers.export(exports, "discriminatedUnion", ()=>discriminatedUnionType);
parcelHelpers.export(exports, "effect", ()=>effectsType);
parcelHelpers.export(exports, "enum", ()=>enumType);
parcelHelpers.export(exports, "function", ()=>functionType);
parcelHelpers.export(exports, "instanceof", ()=>instanceOfType);
parcelHelpers.export(exports, "intersection", ()=>intersectionType);
parcelHelpers.export(exports, "lazy", ()=>lazyType);
parcelHelpers.export(exports, "literal", ()=>literalType);
parcelHelpers.export(exports, "map", ()=>mapType);
parcelHelpers.export(exports, "nan", ()=>nanType);
parcelHelpers.export(exports, "nativeEnum", ()=>nativeEnumType);
parcelHelpers.export(exports, "never", ()=>neverType);
parcelHelpers.export(exports, "null", ()=>nullType);
parcelHelpers.export(exports, "nullable", ()=>nullableType);
parcelHelpers.export(exports, "number", ()=>numberType);
parcelHelpers.export(exports, "object", ()=>objectType);
parcelHelpers.export(exports, "oboolean", ()=>oboolean);
parcelHelpers.export(exports, "onumber", ()=>onumber);
parcelHelpers.export(exports, "optional", ()=>optionalType);
parcelHelpers.export(exports, "ostring", ()=>ostring);
parcelHelpers.export(exports, "pipeline", ()=>pipelineType);
parcelHelpers.export(exports, "preprocess", ()=>preprocessType);
parcelHelpers.export(exports, "promise", ()=>promiseType);
parcelHelpers.export(exports, "record", ()=>recordType);
parcelHelpers.export(exports, "set", ()=>setType);
parcelHelpers.export(exports, "strictObject", ()=>strictObjectType);
parcelHelpers.export(exports, "string", ()=>stringType);
parcelHelpers.export(exports, "symbol", ()=>symbolType);
parcelHelpers.export(exports, "transformer", ()=>effectsType);
parcelHelpers.export(exports, "tuple", ()=>tupleType);
parcelHelpers.export(exports, "undefined", ()=>undefinedType);
parcelHelpers.export(exports, "union", ()=>unionType);
parcelHelpers.export(exports, "unknown", ()=>unknownType);
parcelHelpers.export(exports, "void", ()=>voidType);
parcelHelpers.export(exports, "NEVER", ()=>NEVER);
var _zodErrorJs = require("./ZodError.js");
var _errorsJs = require("./errors.js");
var _errorUtilJs = require("./helpers/errorUtil.js");
var _parseUtilJs = require("./helpers/parseUtil.js");
var _utilJs = require("./helpers/util.js");
class ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result)=>{
    if ((0, _parseUtilJs.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, _zodErrorJs.ZodError)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description
    };
    const customMap = (iss, ctx)=>{
        const { message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description
    };
}
class ZodType {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, _utilJs.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, _utilJs.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, _parseUtilJs.ParseStatus)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, _utilJs.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, _parseUtilJs.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, _utilJs.getParsedType)(data)
        };
        const result = this._parseSync({
            data,
            path: ctx.path,
            parent: ctx
        });
        return handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, _utilJs.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data,
                path: [],
                parent: ctx
            });
            return (0, _parseUtilJs.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data,
            path: [],
            parent: ctx
        }).then((result)=>(0, _parseUtilJs.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, _utilJs.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, _parseUtilJs.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, _zodErrorJs.ZodIssueCode).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
function isValidJWT(jwt, alg) {
    if (!jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function isValidCidr(ip, version) {
    if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) return true;
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).string,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const status = new (0, _parseUtilJs.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "email",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    validation: "url",
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation,
            code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, _errorUtilJs.errorUtil).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, _errorUtilJs.errorUtil).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, _errorUtilJs.errorUtil).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, _errorUtilJs.errorUtil).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, _errorUtilJs.errorUtil).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, _errorUtilJs.errorUtil).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, _errorUtilJs.errorUtil).errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params)=>{
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class ZodNumber extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).number,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        let ctx = undefined;
        const status = new (0, _parseUtilJs.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, _utilJs.util).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: (0, _errorUtilJs.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, _utilJs.util).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params)=>{
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodBigInt extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, _parseUtilJs.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, _parseUtilJs.addIssueToContext)(ctx, {
            code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
            expected: (0, _utilJs.ZodParsedType).bigint,
            received: ctx.parsedType
        });
        return 0, _parseUtilJs.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: (0, _errorUtilJs.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params)=>{
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).boolean,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodBoolean.create = (params)=>{
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).date,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_date
            });
            return 0, _parseUtilJs.INVALID;
        }
        const status = new (0, _parseUtilJs.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params)=>{
    return new ZodDate({
        checks: [],
        coerce: params?.coerce || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params)
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).symbol,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodSymbol.create = (params)=>{
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params)
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).undefined,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodUndefined.create = (params)=>{
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params)
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).null,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodNull.create = (params)=>{
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params)
    });
};
class ZodAny extends ZodType {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodAny.create = (params)=>{
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params)
    });
};
class ZodUnknown extends ZodType {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodUnknown.create = (params)=>{
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params)
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, _parseUtilJs.addIssueToContext)(ctx, {
            code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
            expected: (0, _utilJs.ZodParsedType).never,
            received: ctx.parsedType
        });
        return 0, _parseUtilJs.INVALID;
    }
}
ZodNever.create = (params)=>{
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params)
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).void,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodVoid.create = (params)=>{
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params)
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).array) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: tooBig ? (0, _zodErrorJs.ZodIssueCode).too_big : (0, _zodErrorJs.ZodIssueCode).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, _parseUtilJs.ParseStatus).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, _parseUtilJs.ParseStatus).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params)=>{
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params)
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof ZodArray) return new ZodArray({
        ...schema._def,
        type: deepPartialify(schema.element)
    });
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map((item)=>deepPartialify(item)));
    else return schema;
}
class ZodObject extends ZodType {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, _utilJs.util).objectKeys(shape);
        this._cached = {
            shape,
            keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key,
                    value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, _parseUtilJs.ParseStatus).mergeObjectSync(status, syncPairs);
        });
        else return (0, _parseUtilJs.ParseStatus).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, _errorUtilJs.errorUtil).errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, _errorUtilJs.errorUtil).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, _utilJs.util).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, _utilJs.util).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, _utilJs.util).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, _utilJs.util).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof ZodOptional)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return createZodEnum((0, _utilJs.util).objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.strictCreate = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.lazycreate = (shape, params)=>{
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, _zodErrorJs.ZodError)(result.ctx.common.issues));
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_union,
                unionErrors
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, _zodErrorJs.ZodError)(issues));
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_union,
                unionErrors
            });
            return 0, _parseUtilJs.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params)=>{
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type)=>{
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return (0, _utilJs.util).objectValues(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else if (type instanceof ZodOptional) return [
        undefined,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodNullable) return [
        null,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodBranded) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodReadonly) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodCatch) return getDiscriminator(type._def.innerType);
    else return [];
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).object) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params)
        });
    }
}
function mergeValues(a, b) {
    const aType = (0, _utilJs.getParsedType)(a);
    const bType = (0, _utilJs.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, _utilJs.ZodParsedType).object && bType === (0, _utilJs.ZodParsedType).object) {
        const bKeys = (0, _utilJs.util).objectKeys(b);
        const sharedKeys = (0, _utilJs.util).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, _utilJs.ZodParsedType).array && bType === (0, _utilJs.ZodParsedType).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, _utilJs.ZodParsedType).date && bType === (0, _utilJs.ZodParsedType).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, _parseUtilJs.isAborted)(parsedLeft) || (0, _parseUtilJs.isAborted)(parsedRight)) return 0, _parseUtilJs.INVALID;
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_intersection_types
                });
                return 0, _parseUtilJs.INVALID;
            }
            if ((0, _parseUtilJs.isDirty)(parsedLeft) || (0, _parseUtilJs.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
ZodIntersection.create = (left, right, params)=>{
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params)
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).array) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, _parseUtilJs.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, _parseUtilJs.ParseStatus).mergeArray(status, results);
        });
        else return (0, _parseUtilJs.ParseStatus).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest
        });
    }
}
ZodTuple.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params)
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).object) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, _parseUtilJs.ParseStatus).mergeObjectAsync(status, pairs);
        else return (0, _parseUtilJs.ParseStatus).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) return new ZodRecord({
            keyType: first,
            valueType: second,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(third)
        });
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second)
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).map) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).map,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, _parseUtilJs.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
ZodMap.create = (keyType, valueType, params)=>{
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params)
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).set) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).set,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params)=>{
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params)
    });
};
class ZodFunction extends ZodType {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).function) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).function,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, _parseUtilJs.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, _errorsJs.getErrorMap)(),
                    (0, _errorsJs.defaultErrorMap)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, _parseUtilJs.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, _errorsJs.getErrorMap)(),
                    (0, _errorsJs.defaultErrorMap)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, _parseUtilJs.OK)(async function(...args) {
                const error = new (0, _zodErrorJs.ZodError)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, _parseUtilJs.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, _zodErrorJs.ZodError)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, _zodErrorJs.ZodError)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create())
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params)
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
ZodLazy.create = (getter, params)=>{
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params)
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_literal,
                expected: this._def.value
            });
            return 0, _parseUtilJs.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params)=>{
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params)
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params)
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                expected: (0, _utilJs.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = (0, _utilJs.util).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).string && ctx.parsedType !== (0, _utilJs.ZodParsedType).number) {
            const expectedValues = (0, _utilJs.util).objectValues(nativeEnumValues);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                expected: (0, _utilJs.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (!this._cache) this._cache = new Set((0, _utilJs.util).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, _utilJs.util).objectValues(nativeEnumValues);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params)=>{
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params)
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).promise && ctx.common.async === false) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).promise,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const promisified = ctx.parsedType === (0, _utilJs.ZodParsedType).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, _parseUtilJs.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
ZodPromise.create = (schema, params)=>{
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params)
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, _parseUtilJs.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, _parseUtilJs.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (result.status === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                if (status.value === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, _parseUtilJs.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (result.status === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                if (status.value === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, _parseUtilJs.isValid)(base)) return 0, _parseUtilJs.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, _parseUtilJs.isValid)(base)) return 0, _parseUtilJs.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, _utilJs.util).assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params)=>{
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params)
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params)=>{
    return new ZodEffects({
        schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params)
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, _utilJs.ZodParsedType).undefined) return (0, _parseUtilJs.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params)=>{
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params)
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, _utilJs.ZodParsedType).null) return (0, _parseUtilJs.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params)=>{
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params)
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, _utilJs.ZodParsedType).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params)=>{
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...processCreateParams(params)
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, _parseUtilJs.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, _zodErrorJs.ZodError)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, _zodErrorJs.ZodError)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params)=>{
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...processCreateParams(params)
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).nan,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
ZodNaN.create = (params)=>{
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params)
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, _parseUtilJs.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, _parseUtilJs.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, _parseUtilJs.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, _parseUtilJs.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodReadonly.create = (type, params)=>{
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function custom(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return ZodAny.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return ZodAny.create();
}
const late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
// requires TS 4.4+
class Class {
    constructor(..._){}
}
const instanceOfType = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>custom((data)=>data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = ()=>stringType().optional();
const onumber = ()=>numberType().optional();
const oboolean = ()=>booleanType().optional();
const coerce = {
    string: (arg)=>ZodString.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>ZodNumber.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>ZodBoolean.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>ZodBigInt.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>ZodDate.create({
            ...arg,
            coerce: true
        })
};
const NEVER = (0, _parseUtilJs.INVALID);

},{"./ZodError.js":"lketk","./errors.js":"j1AAX","./helpers/errorUtil.js":"kuKox","./helpers/parseUtil.js":"dEesJ","./helpers/util.js":"35lyb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kuKox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorUtil", ()=>errorUtil);
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})(errorUtil || (errorUtil = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"53bH1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Signup);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _header = require("./Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _react = require("react");
var _validate = require("../utils/validate");
var _signin = require("../utils/signin");
var _spinner = require("./helper/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _user = require("../store/slice/user");
var _reactRedux = require("react-redux");
function Signup() {
    const email = (0, _react.useRef)(null);
    const password = (0, _react.useRef)(null);
    const name = (0, _react.useRef)(null);
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [loading, setLoading] = (0, _react.useState)(false);
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatchAction = (0, _reactRedux.useDispatch)();
    const handleSignUpOps = async ()=>{
        let validateRes = (0, _validate.signUpValidate)(email?.current?.["value"], password?.current?.["value"], name?.current?.["value"]);
        if (validateRes) setErrorMessage(validateRes);
        else {
            setErrorMessage("");
            setLoading(true);
            let signUpRes = await (0, _signin.signUpUser)(name?.current?.["value"], email?.current?.["value"], password?.current?.["value"]);
            setLoading(false);
            if (signUpRes?.status == "Error") setErrorMessage("Email already in use");
            else {
                dispatchAction((0, _user.addUser)(signUpRes));
                navigate("/browse");
            }
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bg-[url(https://assets.nflxext.com/ffe/siteui/vlv3/6863f6e8-d419-414d-b5b9-7ef657e67ce4/web/IN-en-20250602-TRIFECTA-perspective_27a3fdfa-126f-4148-b153-55d60b51be6a_small.jpg)]",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex h-screen justify-center items-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "lg:w-3/12 mt-20  absolute opacity-80 bg-black p-10 space-y-10 rounded-md text-lg",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-white text-4xl font-bold ",
                                children: "Sign Up"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                className: "  space-y-4",
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        placeholder: "Full name",
                                        required: true,
                                        ref: name,
                                        className: " py-3 px-4 w-full bg-transparent text-slate-200 placeholder-slate-200 border border-slate-200 rounded-sm  focus:border-2 focus:border-white"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-red-500 -mt-4 text-sm",
                                        children: errorMessage.search("Name") != -1 ? errorMessage : null
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        ref: email,
                                        type: "email",
                                        placeholder: "Email or mobile number",
                                        required: true,
                                        className: " py-3 px-4 w-full bg-transparent text-slate-200 placeholder-slate-200 border border-slate-200 rounded-sm  focus:border-2 focus:border-white"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-red-500 -mt-4 text-sm",
                                        children: errorMessage.search("Email") != -1 ? errorMessage : null
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        ref: password,
                                        type: "password",
                                        placeholder: "Password",
                                        required: true,
                                        className: "  py-3 px-4  w-full bg-transparent text-slate-200 placeholder-slate-200 border border-slate-200 rounded-sm focus:border-2 focus:border-white"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-red-500 -mt-4 text-sm",
                                        children: errorMessage.search("Password") != -1 ? errorMessage : null
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "bg-red-600 px-4 py-2 w-full text-white font-bold rounded-sm  flex items-center justify-center text-center",
                                        onClick: ()=>{
                                            handleSignUpOps();
                                        },
                                        children: !loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "hover:cursor-pointer",
                                            children: "Sign Up"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "text-white text-base",
                                        children: [
                                            "Already a member?",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                to: "/",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "hover:underline font-bold hover:cursor-pointer",
                                                    children: "Sign in."
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-gray-300",
                                        children: "This page is protected by Google reCAPTCHA to ensure you're not a bot."
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-blue-500 underline hover:cursor-pointer",
                                        children: "Learn more."
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","react-router":"6qXj4","./Header":"5keeC","react":"bmhQu","../utils/validate":"36F7x","../utils/signin":"7HPJs","./helper/Spinner":"fDGWh","../store/slice/user":"4kGyY","react-redux":"aRDHF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fQlbO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toolkit = require("@reduxjs/toolkit");
var _user = require("./slice/user");
var _userDefault = parcelHelpers.interopDefault(_user);
var _movies = require("./slice/movies");
var _moviesDefault = parcelHelpers.interopDefault(_movies);
var _feature = require("./slice/feature");
var _featureDefault = parcelHelpers.interopDefault(_feature);
const NetflixGPTStore = (0, _toolkit.configureStore)({
    reducer: {
        user: (0, _userDefault.default),
        movies: (0, _moviesDefault.default),
        feature: (0, _featureDefault.default)
    },
    devTools: false
});
exports.default = NetflixGPTStore;

},{"@reduxjs/toolkit":"7hE98","./slice/user":"4kGyY","./slice/movies":"5TvjQ","./slice/feature":"Io6av","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["5DEId"], "5DEId", "parcelRequiree135", {})

//# sourceMappingURL=netflixGPT.11d7e56f.js.map
